/**
 * This file will export 3 objects which contain static CETa values
 * (q15, mean, q85) for Perennial Trees
 */

export const perennialTreeQ15: Record<string, Record<string, number>> = {
  Almonds: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.4202798152622231,
    "2024-10-03": 2.8405596305244463,
    "2024-10-04": 4.26083944578667,
    "2024-10-05": 5.6811192610488925,
    "2024-10-06": 7.101399076311115,
    "2024-10-07": 8.52167889157334,
    "2024-10-08": 9.941958706835562,
    "2024-10-09": 11.362238522097783,
    "2024-10-10": 12.782518337360008,
    "2024-10-11": 14.20279815262223,
    "2024-10-12": 15.623077967884454,
    "2024-10-13": 17.04335778314668,
    "2024-10-14": 18.4636375984089,
    "2024-10-15": 19.883917413671124,
    "2024-10-16": 21.304197228933347,
    "2024-10-17": 22.72447704419557,
    "2024-10-18": 24.144756859457797,
    "2024-10-19": 25.565036674720016,
    "2024-10-20": 26.98531648998224,
    "2024-10-21": 28.40559630524446,
    "2024-10-22": 29.825876120506685,
    "2024-10-23": 31.246155935768908,
    "2024-10-24": 32.66643575103113,
    "2024-10-25": 34.08671556629336,
    "2024-10-26": 35.506995381555576,
    "2024-10-27": 36.9272751968178,
    "2024-10-28": 38.34755501208002,
    "2024-10-29": 39.76783482734225,
    "2024-10-30": 41.18811464260447,
    "2024-10-31": 42.60839445786669,
    "2024-11-01": 43.19779693958158,
    "2024-11-02": 43.787199421296464,
    "2024-11-03": 44.37660190301135,
    "2024-11-04": 44.96600438472623,
    "2024-11-05": 45.55540686644112,
    "2024-11-06": 46.144809348156,
    "2024-11-07": 46.73421182987089,
    "2024-11-08": 47.32361431158577,
    "2024-11-09": 47.913016793300656,
    "2024-11-10": 48.50241927501554,
    "2024-11-11": 49.091821756730425,
    "2024-11-12": 49.68122423844531,
    "2024-11-13": 50.2706267201602,
    "2024-11-14": 50.86002920187508,
    "2024-11-15": 51.44943168358997,
    "2024-11-16": 52.03883416530485,
    "2024-11-17": 52.62823664701973,
    "2024-11-18": 53.21763912873462,
    "2024-11-19": 53.8070416104495,
    "2024-11-20": 54.39644409216439,
    "2024-11-21": 54.98584657387927,
    "2024-11-22": 55.57524905559415,
    "2024-11-23": 56.16465153730904,
    "2024-11-24": 56.75405401902392,
    "2024-11-25": 57.3434565007388,
    "2024-11-26": 57.93285898245369,
    "2024-11-27": 58.52226146416857,
    "2024-11-28": 59.11166394588346,
    "2024-11-29": 59.70106642759834,
    "2024-11-30": 60.290468909313226,
    "2024-12-01": 60.55351550773466,
    "2024-12-02": 60.81656210615609,
    "2024-12-03": 61.07960870457752,
    "2024-12-04": 61.34265530299896,
    "2024-12-05": 61.60570190142039,
    "2024-12-06": 61.86874849984182,
    "2024-12-07": 62.13179509826325,
    "2024-12-08": 62.39484169668468,
    "2024-12-09": 62.65788829510611,
    "2024-12-10": 62.92093489352754,
    "2024-12-11": 63.18398149194898,
    "2024-12-12": 63.44702809037041,
    "2024-12-13": 63.71007468879184,
    "2024-12-14": 63.97312128721328,
    "2024-12-15": 64.23616788563471,
    "2024-12-16": 64.49921448405614,
    "2024-12-17": 64.76226108247758,
    "2024-12-18": 65.025307680899,
    "2024-12-19": 65.28835427932043,
    "2024-12-20": 65.55140087774187,
    "2024-12-21": 65.8144474761633,
    "2024-12-22": 66.07749407458473,
    "2024-12-23": 66.34054067300616,
    "2024-12-24": 66.6035872714276,
    "2024-12-25": 66.86663386984903,
    "2024-12-26": 67.12968046827046,
    "2024-12-27": 67.39272706669189,
    "2024-12-28": 67.65577366511333,
    "2024-12-29": 67.91882026353476,
    "2024-12-30": 68.1818668619562,
    "2024-12-31": 68.44491346037762,
    "2025-01-01": 68.98880493389697,
    "2025-01-02": 69.53269640741632,
    "2025-01-03": 70.07658788093566,
    "2025-01-04": 70.62047935445501,
    "2025-01-05": 71.16437082797437,
    "2025-01-06": 71.70826230149372,
    "2025-01-07": 72.25215377501307,
    "2025-01-08": 72.79604524853241,
    "2025-01-09": 73.33993672205176,
    "2025-01-10": 73.88382819557111,
    "2025-01-11": 74.42771966909046,
    "2025-01-12": 74.97161114260982,
    "2025-01-13": 75.51550261612915,
    "2025-01-14": 76.0593940896485,
    "2025-01-15": 76.60328556316786,
    "2025-01-16": 77.14717703668721,
    "2025-01-17": 77.69106851020656,
    "2025-01-18": 78.2349599837259,
    "2025-01-19": 78.77885145724525,
    "2025-01-20": 79.3227429307646,
    "2025-01-21": 79.86663440428396,
    "2025-01-22": 80.41052587780331,
    "2025-01-23": 80.95441735132266,
    "2025-01-24": 81.498308824842,
    "2025-01-25": 82.04220029836135,
    "2025-01-26": 82.5860917718807,
    "2025-01-27": 83.12998324540006,
    "2025-01-28": 83.6738747189194,
    "2025-01-29": 84.21776619243875,
    "2025-01-30": 84.7616576659581,
    "2025-01-31": 85.30554913947745,
    "2025-02-01": 86.12572693983415,
    "2025-02-02": 86.94590474019087,
    "2025-02-03": 87.76608254054757,
    "2025-02-04": 88.58626034090427,
    "2025-02-05": 89.40643814126099,
    "2025-02-06": 90.2266159416177,
    "2025-02-07": 91.0467937419744,
    "2025-02-08": 91.86697154233111,
    "2025-02-09": 92.68714934268782,
    "2025-02-10": 93.50732714304452,
    "2025-02-11": 94.32750494340124,
    "2025-02-12": 95.14768274375794,
    "2025-02-13": 95.96786054411466,
    "2025-02-14": 96.78803834447136,
    "2025-02-15": 97.60821614482806,
    "2025-02-16": 98.42839394518478,
    "2025-02-17": 99.24857174554148,
    "2025-02-18": 100.0687495458982,
    "2025-02-19": 100.8889273462549,
    "2025-02-20": 101.7091051466116,
    "2025-02-21": 102.52928294696832,
    "2025-02-22": 103.34946074732504,
    "2025-02-23": 104.16963854768171,
    "2025-02-24": 104.98981634803845,
    "2025-02-25": 105.80999414839516,
    "2025-02-26": 106.63017194875184,
    "2025-02-27": 107.45034974910855,
    "2025-02-28": 108.27052754946529,
    "2025-03-01": 110.11135106952108,
    "2025-03-02": 111.95217458957691,
    "2025-03-03": 113.79299810963276,
    "2025-03-04": 115.63382162968858,
    "2025-03-05": 117.4746451497444,
    "2025-03-06": 119.31546866980024,
    "2025-03-07": 121.15629218985606,
    "2025-03-08": 122.99711570991188,
    "2025-03-09": 124.83793922996772,
    "2025-03-10": 126.67876275002354,
    "2025-03-11": 128.51958627007937,
    "2025-03-12": 130.36040979013518,
    "2025-03-13": 132.201233310191,
    "2025-03-14": 134.04205683024685,
    "2025-03-15": 135.88288035030268,
    "2025-03-16": 137.7237038703585,
    "2025-03-17": 139.56452739041433,
    "2025-03-18": 141.40535091047016,
    "2025-03-19": 143.24617443052597,
    "2025-03-20": 145.0869979505818,
    "2025-03-21": 146.92782147063764,
    "2025-03-22": 148.76864499069347,
    "2025-03-23": 150.60946851074928,
    "2025-03-24": 152.45029203080512,
    "2025-03-25": 154.29111555086095,
    "2025-03-26": 156.13193907091676,
    "2025-03-27": 157.9727625909726,
    "2025-03-28": 159.81358611102843,
    "2025-03-29": 161.65440963108426,
    "2025-03-30": 163.49523315114007,
    "2025-03-31": 165.3360566711959,
    "2025-04-01": 168.49540660546575,
    "2025-04-02": 171.65475653973556,
    "2025-04-03": 174.8141064740054,
    "2025-04-04": 177.97345640827524,
    "2025-04-05": 181.13280634254505,
    "2025-04-06": 184.2921562768149,
    "2025-04-07": 187.45150621108476,
    "2025-04-08": 190.61085614535455,
    "2025-04-09": 193.7702060796244,
    "2025-04-10": 196.92955601389423,
    "2025-04-11": 200.08890594816407,
    "2025-04-12": 203.2482558824339,
    "2025-04-13": 206.4076058167037,
    "2025-04-14": 209.5669557509736,
    "2025-04-15": 212.7263056852434,
    "2025-04-16": 215.8856556195132,
    "2025-04-17": 219.04500555378303,
    "2025-04-18": 222.2043554880529,
    "2025-04-19": 225.3637054223227,
    "2025-04-20": 228.52305535659252,
    "2025-04-21": 231.6824052908624,
    "2025-04-22": 234.8417552251322,
    "2025-04-23": 238.00110515940204,
    "2025-04-24": 241.16045509367189,
    "2025-04-25": 244.3198050279417,
    "2025-04-26": 247.4791549622116,
    "2025-04-27": 250.63850489648135,
    "2025-04-28": 253.7978548307512,
    "2025-04-29": 256.95720476502106,
    "2025-04-30": 260.1165546992909,
    "2025-05-01": 264.0486130597231,
    "2025-05-02": 267.9806714201554,
    "2025-05-03": 271.9127297805876,
    "2025-05-04": 275.8447881410199,
    "2025-05-05": 279.7768465014521,
    "2025-05-06": 283.7089048618844,
    "2025-05-07": 287.6409632223166,
    "2025-05-08": 291.5730215827489,
    "2025-05-09": 295.5050799431811,
    "2025-05-10": 299.4371383036134,
    "2025-05-11": 303.3691966640456,
    "2025-05-12": 307.3012550244779,
    "2025-05-13": 311.2333133849101,
    "2025-05-14": 315.1653717453424,
    "2025-05-15": 319.0974301057746,
    "2025-05-16": 323.0294884662069,
    "2025-05-17": 326.9615468266391,
    "2025-05-18": 330.8936051870714,
    "2025-05-19": 334.8256635475036,
    "2025-05-20": 338.7577219079359,
    "2025-05-21": 342.6897802683681,
    "2025-05-22": 346.6218386288004,
    "2025-05-23": 350.5538969892326,
    "2025-05-24": 354.4859553496649,
    "2025-05-25": 358.4180137100971,
    "2025-05-26": 362.3500720705293,
    "2025-05-27": 366.2821304309616,
    "2025-05-28": 370.2141887913939,
    "2025-05-29": 374.1462471518261,
    "2025-05-30": 378.0783055122584,
    "2025-05-31": 382.0103638726906,
    "2025-06-01": 386.2792742970593,
    "2025-06-02": 390.5481847214281,
    "2025-06-03": 394.8170951457968,
    "2025-06-04": 399.0860055701655,
    "2025-06-05": 403.3549159945342,
    "2025-06-06": 407.6238264189029,
    "2025-06-07": 411.8927368432717,
    "2025-06-08": 416.1616472676404,
    "2025-06-09": 420.43055769200913,
    "2025-06-10": 424.6994681163778,
    "2025-06-11": 428.9683785407466,
    "2025-06-12": 433.2372889651153,
    "2025-06-13": 437.506199389484,
    "2025-06-14": 441.7751098138528,
    "2025-06-15": 446.04402023822144,
    "2025-06-16": 450.3129306625901,
    "2025-06-17": 454.5818410869589,
    "2025-06-18": 458.8507515113276,
    "2025-06-19": 463.11966193569634,
    "2025-06-20": 467.388572360065,
    "2025-06-21": 471.6574827844338,
    "2025-06-22": 475.9263932088025,
    "2025-06-23": 480.1953036331712,
    "2025-06-24": 484.46421405754,
    "2025-06-25": 488.7331244819087,
    "2025-06-26": 493.0020349062773,
    "2025-06-27": 497.2709453306461,
    "2025-06-28": 501.53985575501486,
    "2025-06-29": 505.8087661793836,
    "2025-06-30": 510.07767660375225,
    "2025-07-01": 514.5746161680004,
    "2025-07-02": 519.0715557322484,
    "2025-07-03": 523.5684952964965,
    "2025-07-04": 528.0654348607446,
    "2025-07-05": 532.5623744249928,
    "2025-07-06": 537.0593139892408,
    "2025-07-07": 541.5562535534889,
    "2025-07-08": 546.053193117737,
    "2025-07-09": 550.550132681985,
    "2025-07-10": 555.0470722462331,
    "2025-07-11": 559.5440118104813,
    "2025-07-12": 564.0409513747293,
    "2025-07-13": 568.5378909389774,
    "2025-07-14": 573.0348305032255,
    "2025-07-15": 577.5317700674736,
    "2025-07-16": 582.0287096317217,
    "2025-07-17": 586.5256491959698,
    "2025-07-18": 591.0225887602179,
    "2025-07-19": 595.5195283244659,
    "2025-07-20": 600.016467888714,
    "2025-07-21": 604.5134074529622,
    "2025-07-22": 609.0103470172103,
    "2025-07-23": 613.5072865814583,
    "2025-07-24": 618.0042261457064,
    "2025-07-25": 622.5011657099545,
    "2025-07-26": 626.9981052742025,
    "2025-07-27": 631.4950448384507,
    "2025-07-28": 635.9919844026988,
    "2025-07-29": 640.4889239669469,
    "2025-07-30": 644.9858635311949,
    "2025-07-31": 649.482803095443,
    "2025-08-01": 652.2461904901322,
    "2025-08-02": 655.0095778848214,
    "2025-08-03": 657.7729652795106,
    "2025-08-04": 660.5363526741997,
    "2025-08-05": 663.2997400688889,
    "2025-08-06": 666.0631274635782,
    "2025-08-07": 668.8265148582674,
    "2025-08-08": 671.5899022529566,
    "2025-08-09": 674.3532896476457,
    "2025-08-10": 677.1166770423349,
    "2025-08-11": 679.8800644370241,
    "2025-08-12": 682.6434518317133,
    "2025-08-13": 685.4068392264024,
    "2025-08-14": 688.1702266210916,
    "2025-08-15": 690.9336140157808,
    "2025-08-16": 693.6970014104701,
    "2025-08-17": 696.4603888051593,
    "2025-08-18": 699.2237761998484,
    "2025-08-19": 701.9871635945376,
    "2025-08-20": 704.7505509892268,
    "2025-08-21": 707.513938383916,
    "2025-08-22": 710.2773257786051,
    "2025-08-23": 713.0407131732943,
    "2025-08-24": 715.8041005679835,
    "2025-08-25": 718.5674879626727,
    "2025-08-26": 721.330875357362,
    "2025-08-27": 724.0942627520511,
    "2025-08-28": 726.8576501467403,
    "2025-08-29": 729.6210375414295,
    "2025-08-30": 732.3844249361186,
    "2025-08-31": 735.1478123308078,
    "2025-09-01": 737.1210515594212,
    "2025-09-02": 739.0942907880346,
    "2025-09-03": 741.067530016648,
    "2025-09-04": 743.0407692452615,
    "2025-09-05": 745.0140084738748,
    "2025-09-06": 746.9872477024882,
    "2025-09-07": 748.9604869311016,
    "2025-09-08": 750.933726159715,
    "2025-09-09": 752.9069653883284,
    "2025-09-10": 754.8802046169418,
    "2025-09-11": 756.8534438455551,
    "2025-09-12": 758.8266830741686,
    "2025-09-13": 760.799922302782,
    "2025-09-14": 762.7731615313954,
    "2025-09-15": 764.7464007600088,
    "2025-09-16": 766.7196399886221,
    "2025-09-17": 768.6928792172356,
    "2025-09-18": 770.666118445849,
    "2025-09-19": 772.6393576744624,
    "2025-09-20": 774.6125969030758,
    "2025-09-21": 776.5858361316891,
    "2025-09-22": 778.5590753603026,
    "2025-09-23": 780.5323145889159,
    "2025-09-24": 782.5055538175294,
    "2025-09-25": 784.4787930461428,
    "2025-09-26": 786.4520322747561,
    "2025-09-27": 788.4252715033696,
    "2025-09-28": 790.3985107319829,
    "2025-09-29": 792.3717499605964,
    "2025-09-30": 794.3449891892097,
  },
  Apples: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.8383914862738715,
    "2024-10-03": 3.676782972547743,
    "2024-10-04": 5.515174458821615,
    "2024-10-05": 7.353565945095486,
    "2024-10-06": 9.191957431369357,
    "2024-10-07": 11.030348917643227,
    "2024-10-08": 12.8687404039171,
    "2024-10-09": 14.707131890190972,
    "2024-10-10": 16.545523376464843,
    "2024-10-11": 18.383914862738717,
    "2024-10-12": 20.222306349012587,
    "2024-10-13": 22.060697835286454,
    "2024-10-14": 23.89908932156033,
    "2024-10-15": 25.737480807834203,
    "2024-10-16": 27.575872294108077,
    "2024-10-17": 29.414263780381944,
    "2024-10-18": 31.25265526665581,
    "2024-10-19": 33.091046752929685,
    "2024-10-20": 34.92943823920356,
    "2024-10-21": 36.76782972547743,
    "2024-10-22": 38.6062212117513,
    "2024-10-23": 40.444612698025175,
    "2024-10-24": 42.283004184299045,
    "2024-10-25": 44.12139567057292,
    "2024-10-26": 45.95978715684679,
    "2024-10-27": 47.79817864312066,
    "2024-10-28": 49.63657012939453,
    "2024-10-29": 51.474961615668406,
    "2024-10-30": 53.31335310194228,
    "2024-10-31": 55.15174458821615,
    "2024-11-01": 55.78653306325277,
    "2024-11-02": 56.42132153828939,
    "2024-11-03": 57.05611001332601,
    "2024-11-04": 57.69089848836263,
    "2024-11-05": 58.32568696339925,
    "2024-11-06": 58.96047543843587,
    "2024-11-07": 59.59526391347249,
    "2024-11-08": 60.23005238850912,
    "2024-11-09": 60.86484086354574,
    "2024-11-10": 61.49962933858236,
    "2024-11-11": 62.13441781361898,
    "2024-11-12": 62.7692062886556,
    "2024-11-13": 63.40399476369222,
    "2024-11-14": 64.03878323872884,
    "2024-11-15": 64.67357171376545,
    "2024-11-16": 65.30836018880208,
    "2024-11-17": 65.9431486638387,
    "2024-11-18": 66.57793713887533,
    "2024-11-19": 67.21272561391194,
    "2024-11-20": 67.84751408894857,
    "2024-11-21": 68.48230256398519,
    "2024-11-22": 69.1170910390218,
    "2024-11-23": 69.75187951405843,
    "2024-11-24": 70.38666798909505,
    "2024-11-25": 71.02145646413167,
    "2024-11-26": 71.65624493916829,
    "2024-11-27": 72.29103341420492,
    "2024-11-28": 72.92582188924153,
    "2024-11-29": 73.56061036427815,
    "2024-11-30": 74.19539883931478,
    "2024-12-01": 74.57850845494137,
    "2024-12-02": 74.96161807056798,
    "2024-12-03": 75.34472768619457,
    "2024-12-04": 75.72783730182118,
    "2024-12-05": 76.11094691744778,
    "2024-12-06": 76.49405653307439,
    "2024-12-07": 76.87716614870098,
    "2024-12-08": 77.26027576432759,
    "2024-12-09": 77.64338537995418,
    "2024-12-10": 78.02649499558079,
    "2024-12-11": 78.40960461120739,
    "2024-12-12": 78.792714226834,
    "2024-12-13": 79.17582384246059,
    "2024-12-14": 79.5589334580872,
    "2024-12-15": 79.94204307371379,
    "2024-12-16": 80.3251526893404,
    "2024-12-17": 80.708262304967,
    "2024-12-18": 81.0913719205936,
    "2024-12-19": 81.4744815362202,
    "2024-12-20": 81.8575911518468,
    "2024-12-21": 82.2407007674734,
    "2024-12-22": 82.62381038310001,
    "2024-12-23": 83.0069199987266,
    "2024-12-24": 83.39002961435321,
    "2024-12-25": 83.7731392299798,
    "2024-12-26": 84.15624884560641,
    "2024-12-27": 84.53935846123301,
    "2024-12-28": 84.92246807685962,
    "2024-12-29": 85.30557769248621,
    "2024-12-30": 85.6886873081128,
    "2024-12-31": 86.07179692373941,
    "2025-01-01": 86.61942598416876,
    "2025-01-02": 87.16705504459809,
    "2025-01-03": 87.71468410502743,
    "2025-01-04": 88.26231316545677,
    "2025-01-05": 88.8099422258861,
    "2025-01-06": 89.35757128631545,
    "2025-01-07": 89.90520034674479,
    "2025-01-08": 90.45282940717412,
    "2025-01-09": 91.00045846760348,
    "2025-01-10": 91.5480875280328,
    "2025-01-11": 92.09571658846214,
    "2025-01-12": 92.64334564889148,
    "2025-01-13": 93.1909747093208,
    "2025-01-14": 93.73860376975016,
    "2025-01-15": 94.2862328301795,
    "2025-01-16": 94.83386189060884,
    "2025-01-17": 95.38149095103816,
    "2025-01-18": 95.92912001146752,
    "2025-01-19": 96.47674907189683,
    "2025-01-20": 97.0243781323262,
    "2025-01-21": 97.57200719275554,
    "2025-01-22": 98.11963625318486,
    "2025-01-23": 98.6672653136142,
    "2025-01-24": 99.21489437404357,
    "2025-01-25": 99.76252343447288,
    "2025-01-26": 100.31015249490224,
    "2025-01-27": 100.85778155533156,
    "2025-01-28": 101.4054106157609,
    "2025-01-29": 101.95303967619024,
    "2025-01-30": 102.5006687366196,
    "2025-01-31": 103.04829779704892,
    "2025-02-01": 103.88412312029652,
    "2025-02-02": 104.71994844354408,
    "2025-02-03": 105.55577376679167,
    "2025-02-04": 106.39159909003926,
    "2025-02-05": 107.22742441328684,
    "2025-02-06": 108.06324973653444,
    "2025-02-07": 108.899075059782,
    "2025-02-08": 109.7349003830296,
    "2025-02-09": 110.5707257062772,
    "2025-02-10": 111.40655102952476,
    "2025-02-11": 112.24237635277235,
    "2025-02-12": 113.07820167601994,
    "2025-02-13": 113.91402699926752,
    "2025-02-14": 114.74985232251512,
    "2025-02-15": 115.5856776457627,
    "2025-02-16": 116.42150296901028,
    "2025-02-17": 117.25732829225788,
    "2025-02-18": 118.09315361550546,
    "2025-02-19": 118.92897893875303,
    "2025-02-20": 119.76480426200062,
    "2025-02-21": 120.6006295852482,
    "2025-02-22": 121.4364549084958,
    "2025-02-23": 122.27228023174338,
    "2025-02-24": 123.10810555499096,
    "2025-02-25": 123.94393087823856,
    "2025-02-26": 124.77975620148614,
    "2025-02-27": 125.61558152473371,
    "2025-02-28": 126.4514068479813,
    "2025-03-01": 127.4835003370232,
    "2025-03-02": 128.5155938260651,
    "2025-03-03": 129.54768731510697,
    "2025-03-04": 130.57978080414887,
    "2025-03-05": 131.61187429319077,
    "2025-03-06": 132.64396778223266,
    "2025-03-07": 133.67606127127456,
    "2025-03-08": 134.70815476031643,
    "2025-03-09": 135.74024824935833,
    "2025-03-10": 136.77234173840023,
    "2025-03-11": 137.80443522744213,
    "2025-03-12": 138.83652871648405,
    "2025-03-13": 139.8686222055259,
    "2025-03-14": 140.9007156945678,
    "2025-03-15": 141.9328091836097,
    "2025-03-16": 142.9649026726516,
    "2025-03-17": 143.9969961616935,
    "2025-03-18": 145.0290896507354,
    "2025-03-19": 146.06118313977726,
    "2025-03-20": 147.09327662881915,
    "2025-03-21": 148.12537011786105,
    "2025-03-22": 149.15746360690295,
    "2025-03-23": 150.18955709594485,
    "2025-03-24": 151.22165058498672,
    "2025-03-25": 152.25374407402862,
    "2025-03-26": 153.28583756307052,
    "2025-03-27": 154.3179310521124,
    "2025-03-28": 155.3500245411543,
    "2025-03-29": 156.38211803019618,
    "2025-03-30": 157.41421151923808,
    "2025-03-31": 158.44630500827998,
    "2025-04-01": 160.2751602252382,
    "2025-04-02": 162.10401544219647,
    "2025-04-03": 163.9328706591547,
    "2025-04-04": 165.76172587611296,
    "2025-04-05": 167.5905810930712,
    "2025-04-06": 169.41943631002945,
    "2025-04-07": 171.24829152698769,
    "2025-04-08": 173.07714674394597,
    "2025-04-09": 174.90600196090418,
    "2025-04-10": 176.73485717786244,
    "2025-04-11": 178.56371239482067,
    "2025-04-12": 180.39256761177893,
    "2025-04-13": 182.2214228287372,
    "2025-04-14": 184.0502780456954,
    "2025-04-15": 185.87913326265365,
    "2025-04-16": 187.7079884796119,
    "2025-04-17": 189.53684369657012,
    "2025-04-18": 191.3656989135284,
    "2025-04-19": 193.19455413048664,
    "2025-04-20": 195.0234093474449,
    "2025-04-21": 196.85226456440316,
    "2025-04-22": 198.68111978136136,
    "2025-04-23": 200.5099749983196,
    "2025-04-24": 202.33883021527785,
    "2025-04-25": 204.1676854322361,
    "2025-04-26": 205.99654064919437,
    "2025-04-27": 207.8253958661526,
    "2025-04-28": 209.65425108311084,
    "2025-04-29": 211.4831063000691,
    "2025-04-30": 213.31196151702733,
    "2025-05-01": 215.42749379703076,
    "2025-05-02": 217.54302607703417,
    "2025-05-03": 219.6585583570376,
    "2025-05-04": 221.774090637041,
    "2025-05-05": 223.8896229170444,
    "2025-05-06": 226.00515519704783,
    "2025-05-07": 228.1206874770513,
    "2025-05-08": 230.23621975705467,
    "2025-05-09": 232.3517520370581,
    "2025-05-10": 234.4672843170615,
    "2025-05-11": 236.58281659706492,
    "2025-05-12": 238.6983488770684,
    "2025-05-13": 240.81388115707176,
    "2025-05-14": 242.9294134370752,
    "2025-05-15": 245.0449457170786,
    "2025-05-16": 247.16047799708204,
    "2025-05-17": 249.27601027708545,
    "2025-05-18": 251.39154255708888,
    "2025-05-19": 253.5070748370923,
    "2025-05-20": 255.6226071170957,
    "2025-05-21": 257.73813939709913,
    "2025-05-22": 259.85367167710257,
    "2025-05-23": 261.96920395710595,
    "2025-05-24": 264.0847362371094,
    "2025-05-25": 266.2002685171128,
    "2025-05-26": 268.31580079711625,
    "2025-05-27": 270.43133307711963,
    "2025-05-28": 272.54686535712307,
    "2025-05-29": 274.6623976371265,
    "2025-05-30": 276.7779299171299,
    "2025-05-31": 278.8934621971333,
    "2025-06-01": 280.83011306747323,
    "2025-06-02": 282.76676393781315,
    "2025-06-03": 284.70341480815307,
    "2025-06-04": 286.640065678493,
    "2025-06-05": 288.5767165488329,
    "2025-06-06": 290.5133674191728,
    "2025-06-07": 292.4500182895127,
    "2025-06-08": 294.3866691598526,
    "2025-06-09": 296.3233200301925,
    "2025-06-10": 298.25997090053244,
    "2025-06-11": 300.19662177087235,
    "2025-06-12": 302.1332726412123,
    "2025-06-13": 304.0699235115522,
    "2025-06-14": 306.0065743818921,
    "2025-06-15": 307.943225252232,
    "2025-06-16": 309.8798761225719,
    "2025-06-17": 311.8165269929118,
    "2025-06-18": 313.7531778632517,
    "2025-06-19": 315.68982873359164,
    "2025-06-20": 317.6264796039316,
    "2025-06-21": 319.5631304742715,
    "2025-06-22": 321.4997813446114,
    "2025-06-23": 323.4364322149513,
    "2025-06-24": 325.3730830852912,
    "2025-06-25": 327.30973395563115,
    "2025-06-26": 329.246384825971,
    "2025-06-27": 331.1830356963109,
    "2025-06-28": 333.11968656665084,
    "2025-06-29": 335.0563374369908,
    "2025-06-30": 336.9929883073307,
    "2025-07-01": 339.17210202764005,
    "2025-07-02": 341.35121574794937,
    "2025-07-03": 343.53032946825874,
    "2025-07-04": 345.70944318856806,
    "2025-07-05": 347.88855690887743,
    "2025-07-06": 350.06767062918675,
    "2025-07-07": 352.2467843494961,
    "2025-07-08": 354.4258980698055,
    "2025-07-09": 356.6050117901148,
    "2025-07-10": 358.7841255104242,
    "2025-07-11": 360.9632392307335,
    "2025-07-12": 363.1423529510429,
    "2025-07-13": 365.32146667135225,
    "2025-07-14": 367.5005803916616,
    "2025-07-15": 369.67969411197095,
    "2025-07-16": 371.85880783228026,
    "2025-07-17": 374.0379215525896,
    "2025-07-18": 376.21703527289895,
    "2025-07-19": 378.3961489932083,
    "2025-07-20": 380.5752627135177,
    "2025-07-21": 382.754376433827,
    "2025-07-22": 384.9334901541364,
    "2025-07-23": 387.1126038744457,
    "2025-07-24": 389.2917175947551,
    "2025-07-25": 391.4708313150644,
    "2025-07-26": 393.6499450353738,
    "2025-07-27": 395.8290587556832,
    "2025-07-28": 398.00817247599247,
    "2025-07-29": 400.1872861963018,
    "2025-07-30": 402.3663999166112,
    "2025-07-31": 404.5455136369205,
    "2025-08-01": 406.26635930502766,
    "2025-08-02": 407.9872049731348,
    "2025-08-03": 409.7080506412419,
    "2025-08-04": 411.42889630934906,
    "2025-08-05": 413.1497419774562,
    "2025-08-06": 414.8705876455633,
    "2025-08-07": 416.5914333136705,
    "2025-08-08": 418.3122789817776,
    "2025-08-09": 420.0331246498848,
    "2025-08-10": 421.7539703179919,
    "2025-08-11": 423.47481598609903,
    "2025-08-12": 425.19566165420616,
    "2025-08-13": 426.9165073223133,
    "2025-08-14": 428.6373529904204,
    "2025-08-15": 430.3581986585276,
    "2025-08-16": 432.0790443266347,
    "2025-08-17": 433.7998899947418,
    "2025-08-18": 435.52073566284895,
    "2025-08-19": 437.2415813309561,
    "2025-08-20": 438.9624269990632,
    "2025-08-21": 440.6832726671704,
    "2025-08-22": 442.40411833527753,
    "2025-08-23": 444.1249640033847,
    "2025-08-24": 445.8458096714918,
    "2025-08-25": 447.5666553395989,
    "2025-08-26": 449.28750100770606,
    "2025-08-27": 451.0083466758132,
    "2025-08-28": 452.7291923439203,
    "2025-08-29": 454.45003801202745,
    "2025-08-30": 456.1708836801346,
    "2025-08-31": 457.8917293482417,
    "2025-09-01": 459.4048336162347,
    "2025-09-02": 460.9179378842277,
    "2025-09-03": 462.4310421522207,
    "2025-09-04": 463.9441464202137,
    "2025-09-05": 465.4572506882067,
    "2025-09-06": 466.9703549561997,
    "2025-09-07": 468.4834592241928,
    "2025-09-08": 469.99656349218577,
    "2025-09-09": 471.5096677601788,
    "2025-09-10": 473.0227720281717,
    "2025-09-11": 474.5358762961648,
    "2025-09-12": 476.0489805641578,
    "2025-09-13": 477.5620848321508,
    "2025-09-14": 479.0751891001438,
    "2025-09-15": 480.5882933681368,
    "2025-09-16": 482.1013976361298,
    "2025-09-17": 483.6145019041228,
    "2025-09-18": 485.1276061721158,
    "2025-09-19": 486.6407104401088,
    "2025-09-20": 488.1538147081018,
    "2025-09-21": 489.6669189760949,
    "2025-09-22": 491.1800232440878,
    "2025-09-23": 492.6931275120808,
    "2025-09-24": 494.2062317800738,
    "2025-09-25": 495.7193360480669,
    "2025-09-26": 497.2324403160599,
    "2025-09-27": 498.7455445840528,
    "2025-09-28": 500.2586488520458,
    "2025-09-29": 501.77175312003885,
    "2025-09-30": 503.2848573880319,
  },
  Apricots: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.800348837333813,
    "2024-10-03": 3.600697674667626,
    "2024-10-04": 5.40104651200144,
    "2024-10-05": 7.201395349335252,
    "2024-10-06": 9.001744186669065,
    "2024-10-07": 10.80209302400288,
    "2024-10-08": 12.602441861336692,
    "2024-10-09": 14.402790698670504,
    "2024-10-10": 16.20313953600432,
    "2024-10-11": 18.00348837333813,
    "2024-10-12": 19.803837210671944,
    "2024-10-13": 21.60418604800576,
    "2024-10-14": 23.40453488533957,
    "2024-10-15": 25.204883722673383,
    "2024-10-16": 27.005232560007197,
    "2024-10-17": 28.805581397341008,
    "2024-10-18": 30.605930234674823,
    "2024-10-19": 32.40627907200864,
    "2024-10-20": 34.206627909342444,
    "2024-10-21": 36.00697674667626,
    "2024-10-22": 37.80732558401007,
    "2024-10-23": 39.60767442134389,
    "2024-10-24": 41.4080232586777,
    "2024-10-25": 43.20837209601152,
    "2024-10-26": 45.00872093334532,
    "2024-10-27": 46.80906977067914,
    "2024-10-28": 48.60941860801295,
    "2024-10-29": 50.409767445346766,
    "2024-10-30": 52.21011628268058,
    "2024-10-31": 54.01046512001439,
    "2024-11-01": 54.43975775452424,
    "2024-11-02": 54.86905038903411,
    "2024-11-03": 55.29834302354397,
    "2024-11-04": 55.72763565805382,
    "2024-11-05": 56.15692829256368,
    "2024-11-06": 56.58622092707354,
    "2024-11-07": 57.0155135615834,
    "2024-11-08": 57.44480619609326,
    "2024-11-09": 57.87409883060312,
    "2024-11-10": 58.30339146511297,
    "2024-11-11": 58.73268409962284,
    "2024-11-12": 59.16197673413269,
    "2024-11-13": 59.59126936864255,
    "2024-11-14": 60.02056200315241,
    "2024-11-15": 60.44985463766227,
    "2024-11-16": 60.879147272172126,
    "2024-11-17": 61.30843990668199,
    "2024-11-18": 61.737732541191846,
    "2024-11-19": 62.16702517570171,
    "2024-11-20": 62.596317810211566,
    "2024-11-21": 63.02561044472142,
    "2024-11-22": 63.454903079231286,
    "2024-11-23": 63.88419571374114,
    "2024-11-24": 64.313488348251,
    "2024-11-25": 64.74278098276086,
    "2024-11-26": 65.17207361727071,
    "2024-11-27": 65.60136625178058,
    "2024-11-28": 66.03065888629044,
    "2024-11-29": 66.45995152080029,
    "2024-11-30": 66.88924415531015,
    "2024-12-01": 67.08242891737711,
    "2024-12-02": 67.27561367944408,
    "2024-12-03": 67.46879844151103,
    "2024-12-04": 67.66198320357799,
    "2024-12-05": 67.85516796564495,
    "2024-12-06": 68.04835272771192,
    "2024-12-07": 68.24153748977886,
    "2024-12-08": 68.43472225184583,
    "2024-12-09": 68.62790701391279,
    "2024-12-10": 68.82109177597975,
    "2024-12-11": 69.01427653804672,
    "2024-12-12": 69.20746130011366,
    "2024-12-13": 69.40064606218063,
    "2024-12-14": 69.59383082424759,
    "2024-12-15": 69.78701558631455,
    "2024-12-16": 69.9802003483815,
    "2024-12-17": 70.17338511044846,
    "2024-12-18": 70.36656987251543,
    "2024-12-19": 70.55975463458239,
    "2024-12-20": 70.75293939664934,
    "2024-12-21": 70.9461241587163,
    "2024-12-22": 71.13930892078326,
    "2024-12-23": 71.33249368285023,
    "2024-12-24": 71.52567844491719,
    "2024-12-25": 71.71886320698414,
    "2024-12-26": 71.9120479690511,
    "2024-12-27": 72.10523273111806,
    "2024-12-28": 72.29841749318503,
    "2024-12-29": 72.49160225525198,
    "2024-12-30": 72.68478701731894,
    "2024-12-31": 72.8779717793859,
    "2025-01-01": 73.39394463993023,
    "2025-01-02": 73.90991750047455,
    "2025-01-03": 74.42589036101887,
    "2025-01-04": 74.9418632215632,
    "2025-01-05": 75.45783608210752,
    "2025-01-06": 75.97380894265186,
    "2025-01-07": 76.48978180319618,
    "2025-01-08": 77.0057546637405,
    "2025-01-09": 77.52172752428483,
    "2025-01-10": 78.03770038482915,
    "2025-01-11": 78.55367324537347,
    "2025-01-12": 79.0696461059178,
    "2025-01-13": 79.58561896646212,
    "2025-01-14": 80.10159182700644,
    "2025-01-15": 80.61756468755077,
    "2025-01-16": 81.13353754809509,
    "2025-01-17": 81.64951040863943,
    "2025-01-18": 82.16548326918375,
    "2025-01-19": 82.68145612972808,
    "2025-01-20": 83.1974289902724,
    "2025-01-21": 83.71340185081672,
    "2025-01-22": 84.22937471136105,
    "2025-01-23": 84.74534757190537,
    "2025-01-24": 85.2613204324497,
    "2025-01-25": 85.77729329299402,
    "2025-01-26": 86.29326615353835,
    "2025-01-27": 86.80923901408266,
    "2025-01-28": 87.325211874627,
    "2025-01-29": 87.84118473517132,
    "2025-01-30": 88.35715759571565,
    "2025-01-31": 88.87313045625997,
    "2025-02-01": 89.62384072881135,
    "2025-02-02": 90.37455100136272,
    "2025-02-03": 91.12526127391408,
    "2025-02-04": 91.87597154646546,
    "2025-02-05": 92.62668181901684,
    "2025-02-06": 93.37739209156824,
    "2025-02-07": 94.1281023641196,
    "2025-02-08": 94.87881263667096,
    "2025-02-09": 95.62952290922236,
    "2025-02-10": 96.38023318177372,
    "2025-02-11": 97.13094345432508,
    "2025-02-12": 97.88165372687646,
    "2025-02-13": 98.63236399942784,
    "2025-02-14": 99.3830742719792,
    "2025-02-15": 100.1337845445306,
    "2025-02-16": 100.88449481708196,
    "2025-02-17": 101.63520508963336,
    "2025-02-18": 102.38591536218472,
    "2025-02-19": 103.13662563473608,
    "2025-02-20": 103.88733590728746,
    "2025-02-21": 104.63804617983884,
    "2025-02-22": 105.38875645239024,
    "2025-02-23": 106.1394667249416,
    "2025-02-24": 106.89017699749296,
    "2025-02-25": 107.64088727004436,
    "2025-02-26": 108.39159754259572,
    "2025-02-27": 109.14230781514708,
    "2025-02-28": 109.89301808769848,
    "2025-03-01": 111.24201070047567,
    "2025-03-02": 112.5910033132529,
    "2025-03-03": 113.93999592603012,
    "2025-03-04": 115.28898853880732,
    "2025-03-05": 116.63798115158455,
    "2025-03-06": 117.98697376436178,
    "2025-03-07": 119.335966377139,
    "2025-03-08": 120.6849589899162,
    "2025-03-09": 122.03395160269342,
    "2025-03-10": 123.38294421547064,
    "2025-03-11": 124.73193682824784,
    "2025-03-12": 126.08092944102508,
    "2025-03-13": 127.4299220538023,
    "2025-03-14": 128.7789146665795,
    "2025-03-15": 130.12790727935672,
    "2025-03-16": 131.47689989213396,
    "2025-03-17": 132.82589250491117,
    "2025-03-18": 134.17488511768838,
    "2025-03-19": 135.5238777304656,
    "2025-03-20": 136.87287034324282,
    "2025-03-21": 138.22186295602003,
    "2025-03-22": 139.57085556879724,
    "2025-03-23": 140.91984818157448,
    "2025-03-24": 142.2688407943517,
    "2025-03-25": 143.6178334071289,
    "2025-03-26": 144.96682601990614,
    "2025-03-27": 146.31581863268335,
    "2025-03-28": 147.66481124546056,
    "2025-03-29": 149.0138038582378,
    "2025-03-30": 150.362796471015,
    "2025-03-31": 151.7117890837922,
    "2025-04-01": 154.40714724099553,
    "2025-04-02": 157.10250539819884,
    "2025-04-03": 159.79786355540216,
    "2025-04-04": 162.49322171260545,
    "2025-04-05": 165.18857986980876,
    "2025-04-06": 167.88393802701208,
    "2025-04-07": 170.5792961842154,
    "2025-04-08": 173.2746543414187,
    "2025-04-09": 175.970012498622,
    "2025-04-10": 178.6653706558253,
    "2025-04-11": 181.36072881302863,
    "2025-04-12": 184.05608697023197,
    "2025-04-13": 186.7514451274353,
    "2025-04-14": 189.44680328463855,
    "2025-04-15": 192.1421614418419,
    "2025-04-16": 194.8375195990452,
    "2025-04-17": 197.5328777562485,
    "2025-04-18": 200.2282359134518,
    "2025-04-19": 202.92359407065516,
    "2025-04-20": 205.6189522278584,
    "2025-04-21": 208.31431038506173,
    "2025-04-22": 211.00966854226505,
    "2025-04-23": 213.7050266994684,
    "2025-04-24": 216.40038485667168,
    "2025-04-25": 219.095743013875,
    "2025-04-26": 221.7911011710783,
    "2025-04-27": 224.48645932828163,
    "2025-04-28": 227.1818174854849,
    "2025-04-29": 229.87717564268823,
    "2025-04-30": 232.57253379989157,
    "2025-05-01": 235.5785549836848,
    "2025-05-02": 238.58457616747808,
    "2025-05-03": 241.59059735127133,
    "2025-05-04": 244.5966185350646,
    "2025-05-05": 247.60263971885783,
    "2025-05-06": 250.6086609026511,
    "2025-05-07": 253.6146820864444,
    "2025-05-08": 256.62070327023764,
    "2025-05-09": 259.6267244540309,
    "2025-05-10": 262.63274563782414,
    "2025-05-11": 265.6387668216174,
    "2025-05-12": 268.6447880054107,
    "2025-05-13": 271.650809189204,
    "2025-05-14": 274.6568303729972,
    "2025-05-15": 277.6628515567905,
    "2025-05-16": 280.66887274058377,
    "2025-05-17": 283.674893924377,
    "2025-05-18": 286.68091510817027,
    "2025-05-19": 289.68693629196355,
    "2025-05-20": 292.6929574757568,
    "2025-05-21": 295.69897865955005,
    "2025-05-22": 298.70499984334333,
    "2025-05-23": 301.7110210271365,
    "2025-05-24": 304.71704221092983,
    "2025-05-25": 307.7230633947231,
    "2025-05-26": 310.72908457851634,
    "2025-05-27": 313.7351057623096,
    "2025-05-28": 316.7411269461029,
    "2025-05-29": 319.7471481298962,
    "2025-05-30": 322.7531693136894,
    "2025-05-31": 325.7591904974827,
    "2025-06-01": 329.3143914420098,
    "2025-06-02": 332.8695923865369,
    "2025-06-03": 336.42479333106405,
    "2025-06-04": 339.97999427559114,
    "2025-06-05": 343.5351952201183,
    "2025-06-06": 347.09039616464537,
    "2025-06-07": 350.6455971091725,
    "2025-06-08": 354.2007980536996,
    "2025-06-09": 357.75599899822674,
    "2025-06-10": 361.3111999427538,
    "2025-06-11": 364.866400887281,
    "2025-06-12": 368.42160183180806,
    "2025-06-13": 371.9768027763352,
    "2025-06-14": 375.5320037208624,
    "2025-06-15": 379.08720466538944,
    "2025-06-16": 382.6424056099165,
    "2025-06-17": 386.19760655444367,
    "2025-06-18": 389.7528074989708,
    "2025-06-19": 393.3080084434979,
    "2025-06-20": 396.863209388025,
    "2025-06-21": 400.4184103325521,
    "2025-06-22": 403.97361127707927,
    "2025-06-23": 407.5288122216064,
    "2025-06-24": 411.0840131661335,
    "2025-06-25": 414.6392141106606,
    "2025-06-26": 418.1944150551877,
    "2025-06-27": 421.7496159997148,
    "2025-06-28": 425.304816944242,
    "2025-06-29": 428.8600178887691,
    "2025-06-30": 432.4152188332962,
    "2025-07-01": 436.03619893227255,
    "2025-07-02": 439.65717903124886,
    "2025-07-03": 443.2781591302252,
    "2025-07-04": 446.8991392292015,
    "2025-07-05": 450.5201193281779,
    "2025-07-06": 454.1410994271542,
    "2025-07-07": 457.76207952613055,
    "2025-07-08": 461.38305962510685,
    "2025-07-09": 465.0040397240832,
    "2025-07-10": 468.6250198230596,
    "2025-07-11": 472.2459999220359,
    "2025-07-12": 475.8669800210122,
    "2025-07-13": 479.4879601199885,
    "2025-07-14": 483.1089402189649,
    "2025-07-15": 486.7299203179412,
    "2025-07-16": 490.3509004169176,
    "2025-07-17": 493.9718805158939,
    "2025-07-18": 497.59286061487023,
    "2025-07-19": 501.2138407138466,
    "2025-07-20": 504.8348208128229,
    "2025-07-21": 508.4558009117992,
    "2025-07-22": 512.0767810107756,
    "2025-07-23": 515.6977611097519,
    "2025-07-24": 519.3187412087282,
    "2025-07-25": 522.9397213077045,
    "2025-07-26": 526.5607014066809,
    "2025-07-27": 530.1816815056573,
    "2025-07-28": 533.8026616046336,
    "2025-07-29": 537.4236417036099,
    "2025-07-30": 541.0446218025862,
    "2025-07-31": 544.6656019015626,
    "2025-08-01": 547.6249528531484,
    "2025-08-02": 550.5843038047344,
    "2025-08-03": 553.5436547563203,
    "2025-08-04": 556.5030057079061,
    "2025-08-05": 559.4623566594921,
    "2025-08-06": 562.421707611078,
    "2025-08-07": 565.3810585626638,
    "2025-08-08": 568.3404095142498,
    "2025-08-09": 571.2997604658357,
    "2025-08-10": 574.2591114174217,
    "2025-08-11": 577.2184623690075,
    "2025-08-12": 580.1778133205934,
    "2025-08-13": 583.1371642721793,
    "2025-08-14": 586.0965152237652,
    "2025-08-15": 589.0558661753511,
    "2025-08-16": 592.015217126937,
    "2025-08-17": 594.9745680785229,
    "2025-08-18": 597.9339190301088,
    "2025-08-19": 600.8932699816947,
    "2025-08-20": 603.8526209332806,
    "2025-08-21": 606.8119718848665,
    "2025-08-22": 609.7713228364524,
    "2025-08-23": 612.7306737880383,
    "2025-08-24": 615.6900247396243,
    "2025-08-25": 618.6493756912101,
    "2025-08-26": 621.608726642796,
    "2025-08-27": 624.568077594382,
    "2025-08-28": 627.5274285459678,
    "2025-08-29": 630.4867794975537,
    "2025-08-30": 633.4461304491397,
    "2025-08-31": 636.4054814007255,
    "2025-09-01": 638.2197214113049,
    "2025-09-02": 640.0339614218844,
    "2025-09-03": 641.8482014324638,
    "2025-09-04": 643.6624414430432,
    "2025-09-05": 645.4766814536226,
    "2025-09-06": 647.2909214642021,
    "2025-09-07": 649.1051614747815,
    "2025-09-08": 650.9194014853609,
    "2025-09-09": 652.7336414959403,
    "2025-09-10": 654.5478815065198,
    "2025-09-11": 656.3621215170992,
    "2025-09-12": 658.1763615276786,
    "2025-09-13": 659.990601538258,
    "2025-09-14": 661.8048415488375,
    "2025-09-15": 663.6190815594169,
    "2025-09-16": 665.4333215699963,
    "2025-09-17": 667.2475615805758,
    "2025-09-18": 669.0618015911552,
    "2025-09-19": 670.8760416017346,
    "2025-09-20": 672.690281612314,
    "2025-09-21": 674.5045216228935,
    "2025-09-22": 676.318761633473,
    "2025-09-23": 678.1330016440523,
    "2025-09-24": 679.9472416546317,
    "2025-09-25": 681.7614816652112,
    "2025-09-26": 683.5757216757906,
    "2025-09-27": 685.38996168637,
    "2025-09-28": 687.2042016969494,
    "2025-09-29": 689.018441707529,
    "2025-09-30": 690.8326817181083,
  },
  Cherries: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.8703573173472905,
    "2024-10-03": 3.740714634694581,
    "2024-10-04": 5.611071952041872,
    "2024-10-05": 7.481429269389162,
    "2024-10-06": 9.351786586736452,
    "2024-10-07": 11.222143904083744,
    "2024-10-08": 13.092501221431034,
    "2024-10-09": 14.962858538778324,
    "2024-10-10": 16.833215856125616,
    "2024-10-11": 18.703573173472904,
    "2024-10-12": 20.5739304908202,
    "2024-10-13": 22.444287808167488,
    "2024-10-14": 24.314645125514776,
    "2024-10-15": 26.185002442862068,
    "2024-10-16": 28.05535976020936,
    "2024-10-17": 29.925717077556648,
    "2024-10-18": 31.79607439490394,
    "2024-10-19": 33.66643171225123,
    "2024-10-20": 35.53678902959852,
    "2024-10-21": 37.40714634694581,
    "2024-10-22": 39.2775036642931,
    "2024-10-23": 41.14786098164039,
    "2024-10-24": 43.01821829898768,
    "2024-10-25": 44.888575616334975,
    "2024-10-26": 46.75893293368226,
    "2024-10-27": 48.62929025102955,
    "2024-10-28": 50.49964756837685,
    "2024-10-29": 52.370004885724136,
    "2024-10-30": 54.24036220307143,
    "2024-10-31": 56.11071952041871,
    "2024-11-01": 56.72717074986608,
    "2024-11-02": 57.34362197931346,
    "2024-11-03": 57.96007320876083,
    "2024-11-04": 58.5765244382082,
    "2024-11-05": 59.19297566765557,
    "2024-11-06": 59.80942689710295,
    "2024-11-07": 60.42587812655032,
    "2024-11-08": 61.042329355997694,
    "2024-11-09": 61.658780585445065,
    "2024-11-10": 62.27523181489244,
    "2024-11-11": 62.89168304433981,
    "2024-11-12": 63.50813427378719,
    "2024-11-13": 64.12458550323456,
    "2024-11-14": 64.74103673268193,
    "2024-11-15": 65.35748796212931,
    "2024-11-16": 65.97393919157668,
    "2024-11-17": 66.59039042102405,
    "2024-11-18": 67.20684165047142,
    "2024-11-19": 67.8232928799188,
    "2024-11-20": 68.43974410936617,
    "2024-11-21": 69.05619533881354,
    "2024-11-22": 69.67264656826092,
    "2024-11-23": 70.28909779770828,
    "2024-11-24": 70.90554902715566,
    "2024-11-25": 71.52200025660304,
    "2024-11-26": 72.1384514860504,
    "2024-11-27": 72.75490271549778,
    "2024-11-28": 73.37135394494516,
    "2024-11-29": 73.98780517439252,
    "2024-11-30": 74.6042564038399,
    "2024-12-01": 74.88552156046995,
    "2024-12-02": 75.16678671710002,
    "2024-12-03": 75.44805187373008,
    "2024-12-04": 75.72931703036014,
    "2024-12-05": 76.01058218699019,
    "2024-12-06": 76.29184734362026,
    "2024-12-07": 76.57311250025032,
    "2024-12-08": 76.85437765688037,
    "2024-12-09": 77.13564281351043,
    "2024-12-10": 77.4169079701405,
    "2024-12-11": 77.69817312677056,
    "2024-12-12": 77.97943828340061,
    "2024-12-13": 78.26070344003067,
    "2024-12-14": 78.54196859666074,
    "2024-12-15": 78.8232337532908,
    "2024-12-16": 79.10449890992085,
    "2024-12-17": 79.3857640665509,
    "2024-12-18": 79.66702922318098,
    "2024-12-19": 79.94829437981103,
    "2024-12-20": 80.22955953644109,
    "2024-12-21": 80.51082469307114,
    "2024-12-22": 80.79208984970121,
    "2024-12-23": 81.07335500633127,
    "2024-12-24": 81.35462016296133,
    "2024-12-25": 81.63588531959138,
    "2024-12-26": 81.91715047622145,
    "2024-12-27": 82.1984156328515,
    "2024-12-28": 82.47968078948156,
    "2024-12-29": 82.76094594611163,
    "2024-12-30": 83.04221110274169,
    "2024-12-31": 83.32347625937174,
    "2025-01-01": 83.83120521700738,
    "2025-01-02": 84.33893417464301,
    "2025-01-03": 84.84666313227865,
    "2025-01-04": 85.35439208991427,
    "2025-01-05": 85.8621210475499,
    "2025-01-06": 86.36985000518554,
    "2025-01-07": 86.87757896282118,
    "2025-01-08": 87.38530792045681,
    "2025-01-09": 87.89303687809245,
    "2025-01-10": 88.40076583572808,
    "2025-01-11": 88.90849479336372,
    "2025-01-12": 89.41622375099934,
    "2025-01-13": 89.92395270863497,
    "2025-01-14": 90.4316816662706,
    "2025-01-15": 90.93941062390624,
    "2025-01-16": 91.44713958154188,
    "2025-01-17": 91.95486853917753,
    "2025-01-18": 92.46259749681316,
    "2025-01-19": 92.97032645444878,
    "2025-01-20": 93.4780554120844,
    "2025-01-21": 93.98578436972004,
    "2025-01-22": 94.49351332735569,
    "2025-01-23": 95.0012422849913,
    "2025-01-24": 95.50897124262694,
    "2025-01-25": 96.01670020026258,
    "2025-01-26": 96.5244291578982,
    "2025-01-27": 97.03215811553385,
    "2025-01-28": 97.53988707316948,
    "2025-01-29": 98.0476160308051,
    "2025-01-30": 98.55534498844074,
    "2025-01-31": 99.06307394607636,
    "2025-02-01": 99.8581404156192,
    "2025-02-02": 100.65320688516204,
    "2025-02-03": 101.44827335470488,
    "2025-02-04": 102.24333982424773,
    "2025-02-05": 103.03840629379054,
    "2025-02-06": 103.83347276333338,
    "2025-02-07": 104.6285392328762,
    "2025-02-08": 105.42360570241904,
    "2025-02-09": 106.21867217196188,
    "2025-02-10": 107.01373864150472,
    "2025-02-11": 107.80880511104756,
    "2025-02-12": 108.60387158059038,
    "2025-02-13": 109.3989380501332,
    "2025-02-14": 110.19400451967604,
    "2025-02-15": 110.98907098921887,
    "2025-02-16": 111.78413745876172,
    "2025-02-17": 112.57920392830457,
    "2025-02-18": 113.37427039784738,
    "2025-02-19": 114.1693368673902,
    "2025-02-20": 114.96440333693306,
    "2025-02-21": 115.75946980647588,
    "2025-02-22": 116.55453627601872,
    "2025-02-23": 117.34960274556155,
    "2025-02-24": 118.1446692151044,
    "2025-02-25": 118.93973568464722,
    "2025-02-26": 119.73480215419006,
    "2025-02-27": 120.5298686237329,
    "2025-02-28": 121.32493509327573,
    "2025-03-01": 122.65681574457491,
    "2025-03-02": 123.98869639587409,
    "2025-03-03": 125.32057704717327,
    "2025-03-04": 126.65245769847246,
    "2025-03-05": 127.98433834977163,
    "2025-03-06": 129.31621900107083,
    "2025-03-07": 130.64809965237,
    "2025-03-08": 131.97998030366918,
    "2025-03-09": 133.31186095496838,
    "2025-03-10": 134.64374160626755,
    "2025-03-11": 135.97562225756676,
    "2025-03-12": 137.30750290886593,
    "2025-03-13": 138.6393835601651,
    "2025-03-14": 139.9712642114643,
    "2025-03-15": 141.30314486276347,
    "2025-03-16": 142.63502551406265,
    "2025-03-17": 143.96690616536185,
    "2025-03-18": 145.29878681666102,
    "2025-03-19": 146.63066746796022,
    "2025-03-20": 147.9625481192594,
    "2025-03-21": 149.29442877055857,
    "2025-03-22": 150.62630942185777,
    "2025-03-23": 151.95819007315694,
    "2025-03-24": 153.29007072445611,
    "2025-03-25": 154.62195137575532,
    "2025-03-26": 155.9538320270545,
    "2025-03-27": 157.28571267835366,
    "2025-03-28": 158.61759332965286,
    "2025-03-29": 159.94947398095204,
    "2025-03-30": 161.28135463225124,
    "2025-03-31": 162.6132352835504,
    "2025-04-01": 165.3730120526565,
    "2025-04-02": 168.13278882176257,
    "2025-04-03": 170.89256559086866,
    "2025-04-04": 173.65234235997474,
    "2025-04-05": 176.41211912908082,
    "2025-04-06": 179.1718958981869,
    "2025-04-07": 181.93167266729296,
    "2025-04-08": 184.69144943639907,
    "2025-04-09": 187.45122620550512,
    "2025-04-10": 190.2110029746112,
    "2025-04-11": 192.9707797437173,
    "2025-04-12": 195.73055651282337,
    "2025-04-13": 198.49033328192945,
    "2025-04-14": 201.25011005103556,
    "2025-04-15": 204.0098868201416,
    "2025-04-16": 206.7696635892477,
    "2025-04-17": 209.52944035835375,
    "2025-04-18": 212.28921712745984,
    "2025-04-19": 215.04899389656595,
    "2025-04-20": 217.80877066567203,
    "2025-04-21": 220.5685474347781,
    "2025-04-22": 223.32832420388416,
    "2025-04-23": 226.08810097299028,
    "2025-04-24": 228.84787774209636,
    "2025-04-25": 231.60765451120244,
    "2025-04-26": 234.3674312803085,
    "2025-04-27": 237.1272080494146,
    "2025-04-28": 239.88698481852063,
    "2025-04-29": 242.64676158762677,
    "2025-04-30": 245.4065383567328,
    "2025-05-01": 248.4688064946909,
    "2025-05-02": 251.531074632649,
    "2025-05-03": 254.59334277060708,
    "2025-05-04": 257.6556109085652,
    "2025-05-05": 260.71787904652325,
    "2025-05-06": 263.78014718448134,
    "2025-05-07": 266.8424153224394,
    "2025-05-08": 269.9046834603975,
    "2025-05-09": 272.9669515983556,
    "2025-05-10": 276.0292197363137,
    "2025-05-11": 279.09148787427176,
    "2025-05-12": 282.15375601222985,
    "2025-05-13": 285.21602415018793,
    "2025-05-14": 288.278292288146,
    "2025-05-15": 291.3405604261041,
    "2025-05-16": 294.4028285640622,
    "2025-05-17": 297.4650967020203,
    "2025-05-18": 300.5273648399784,
    "2025-05-19": 303.58963297793645,
    "2025-05-20": 306.65190111589453,
    "2025-05-21": 309.7141692538526,
    "2025-05-22": 312.7764373918107,
    "2025-05-23": 315.8387055297688,
    "2025-05-24": 318.9009736677269,
    "2025-05-25": 321.96324180568496,
    "2025-05-26": 325.02550994364304,
    "2025-05-27": 328.0877780816012,
    "2025-05-28": 331.1500462195592,
    "2025-05-29": 334.2123143575173,
    "2025-05-30": 337.2745824954754,
    "2025-05-31": 340.33685063343347,
    "2025-06-01": 343.7748448574015,
    "2025-06-02": 347.21283908136945,
    "2025-06-03": 350.65083330533747,
    "2025-06-04": 354.08882752930543,
    "2025-06-05": 357.52682175327345,
    "2025-06-06": 360.9648159772415,
    "2025-06-07": 364.40281020120943,
    "2025-06-08": 367.8408044251775,
    "2025-06-09": 371.2787986491454,
    "2025-06-10": 374.71679287311343,
    "2025-06-11": 378.1547870970815,
    "2025-06-12": 381.5927813210494,
    "2025-06-13": 385.03077554501743,
    "2025-06-14": 388.4687697689854,
    "2025-06-15": 391.9067639929534,
    "2025-06-16": 395.34475821692143,
    "2025-06-17": 398.7827524408894,
    "2025-06-18": 402.2207466648574,
    "2025-06-19": 405.6587408888254,
    "2025-06-20": 409.0967351127934,
    "2025-06-21": 412.5347293367614,
    "2025-06-22": 415.9727235607294,
    "2025-06-23": 419.4107177846974,
    "2025-06-24": 422.8487120086654,
    "2025-06-25": 426.2867062326334,
    "2025-06-26": 429.7247004566014,
    "2025-06-27": 433.16269468056936,
    "2025-06-28": 436.6006889045374,
    "2025-06-29": 440.0386831285053,
    "2025-06-30": 443.47667735247336,
    "2025-07-01": 447.1422954410861,
    "2025-07-02": 450.80791352969874,
    "2025-07-03": 454.4735316183114,
    "2025-07-04": 458.1391497069242,
    "2025-07-05": 461.80476779553686,
    "2025-07-06": 465.4703858841496,
    "2025-07-07": 469.13600397276224,
    "2025-07-08": 472.8016220613749,
    "2025-07-09": 476.4672401499876,
    "2025-07-10": 480.1328582386003,
    "2025-07-11": 483.79847632721305,
    "2025-07-12": 487.46409441582574,
    "2025-07-13": 491.1297125044384,
    "2025-07-14": 494.7953305930511,
    "2025-07-15": 498.4609486816638,
    "2025-07-16": 502.1265667702765,
    "2025-07-17": 505.7921848588892,
    "2025-07-18": 509.45780294750193,
    "2025-07-19": 513.1234210361146,
    "2025-07-20": 516.7890391247273,
    "2025-07-21": 520.4546572133399,
    "2025-07-22": 524.1202753019527,
    "2025-07-23": 527.7858933905654,
    "2025-07-24": 531.4515114791781,
    "2025-07-25": 535.1171295677908,
    "2025-07-26": 538.7827476564034,
    "2025-07-27": 542.4483657450162,
    "2025-07-28": 546.1139838336288,
    "2025-07-29": 549.7796019222416,
    "2025-07-30": 553.4452200108542,
    "2025-07-31": 557.110838099467,
    "2025-08-01": 559.9029072102962,
    "2025-08-02": 562.6949763211256,
    "2025-08-03": 565.4870454319549,
    "2025-08-04": 568.2791145427843,
    "2025-08-05": 571.0711836536136,
    "2025-08-06": 573.863252764443,
    "2025-08-07": 576.6553218752723,
    "2025-08-08": 579.4473909861017,
    "2025-08-09": 582.239460096931,
    "2025-08-10": 585.0315292077604,
    "2025-08-11": 587.8235983185897,
    "2025-08-12": 590.6156674294191,
    "2025-08-13": 593.4077365402484,
    "2025-08-14": 596.1998056510778,
    "2025-08-15": 598.9918747619071,
    "2025-08-16": 601.7839438727365,
    "2025-08-17": 604.5760129835658,
    "2025-08-18": 607.3680820943952,
    "2025-08-19": 610.1601512052245,
    "2025-08-20": 612.9522203160539,
    "2025-08-21": 615.7442894268831,
    "2025-08-22": 618.5363585377125,
    "2025-08-23": 621.3284276485418,
    "2025-08-24": 624.1204967593712,
    "2025-08-25": 626.9125658702005,
    "2025-08-26": 629.7046349810299,
    "2025-08-27": 632.4967040918592,
    "2025-08-28": 635.2887732026886,
    "2025-08-29": 638.0808423135179,
    "2025-08-30": 640.8729114243472,
    "2025-08-31": 643.6649805351766,
    "2025-09-01": 645.859196335144,
    "2025-09-02": 648.0534121351114,
    "2025-09-03": 650.247627935079,
    "2025-09-04": 652.4418437350464,
    "2025-09-05": 654.6360595350138,
    "2025-09-06": 656.8302753349813,
    "2025-09-07": 659.0244911349487,
    "2025-09-08": 661.2187069349162,
    "2025-09-09": 663.4129227348836,
    "2025-09-10": 665.6071385348511,
    "2025-09-11": 667.8013543348185,
    "2025-09-12": 669.9955701347859,
    "2025-09-13": 672.1897859347534,
    "2025-09-14": 674.3840017347209,
    "2025-09-15": 676.5782175346883,
    "2025-09-16": 678.7724333346557,
    "2025-09-17": 680.9666491346231,
    "2025-09-18": 683.1608649345907,
    "2025-09-19": 685.3550807345581,
    "2025-09-20": 687.5492965345255,
    "2025-09-21": 689.743512334493,
    "2025-09-22": 691.9377281344604,
    "2025-09-23": 694.1319439344279,
    "2025-09-24": 696.3261597343953,
    "2025-09-25": 698.5203755343628,
    "2025-09-26": 700.7145913343302,
    "2025-09-27": 702.9088071342976,
    "2025-09-28": 705.1030229342651,
    "2025-09-29": 707.2972387342326,
    "2025-09-30": 709.4914545342,
  },
  Citrus: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.5750349030671296,
    "2024-10-03": 3.150069806134259,
    "2024-10-04": 4.725104709201389,
    "2024-10-05": 6.300139612268518,
    "2024-10-06": 7.875174515335647,
    "2024-10-07": 9.450209418402778,
    "2024-10-08": 11.025244321469907,
    "2024-10-09": 12.600279224537037,
    "2024-10-10": 14.175314127604166,
    "2024-10-11": 15.750349030671297,
    "2024-10-12": 17.325383933738426,
    "2024-10-13": 18.90041883680556,
    "2024-10-14": 20.475453739872684,
    "2024-10-15": 22.05048864293981,
    "2024-10-16": 23.625523546006946,
    "2024-10-17": 25.200558449074077,
    "2024-10-18": 26.775593352141204,
    "2024-10-19": 28.35062825520833,
    "2024-10-20": 29.925663158275466,
    "2024-10-21": 31.50069806134259,
    "2024-10-22": 33.075732964409724,
    "2024-10-23": 34.65076786747685,
    "2024-10-24": 36.22580277054398,
    "2024-10-25": 37.80083767361111,
    "2024-10-26": 39.37587257667824,
    "2024-10-27": 40.95090747974537,
    "2024-10-28": 42.525942382812495,
    "2024-10-29": 44.10097728587963,
    "2024-10-30": 45.67601218894676,
    "2024-10-31": 47.25104709201389,
    "2024-11-01": 47.9245608282106,
    "2024-11-02": 48.59807456440733,
    "2024-11-03": 49.27158830060405,
    "2024-11-04": 49.94510203680076,
    "2024-11-05": 50.61861577299749,
    "2024-11-06": 51.29212950919421,
    "2024-11-07": 51.96564324539092,
    "2024-11-08": 52.63915698158765,
    "2024-11-09": 53.31267071778437,
    "2024-11-10": 53.98618445398109,
    "2024-11-11": 54.65969819017781,
    "2024-11-12": 55.33321192637453,
    "2024-11-13": 56.00672566257125,
    "2024-11-14": 56.68023939876797,
    "2024-11-15": 57.35375313496469,
    "2024-11-16": 58.02726687116141,
    "2024-11-17": 58.700780607358126,
    "2024-11-18": 59.37429434355485,
    "2024-11-19": 60.04780807975157,
    "2024-11-20": 60.721321815948286,
    "2024-11-21": 61.39483555214501,
    "2024-11-22": 62.06834928834173,
    "2024-11-23": 62.741863024538446,
    "2024-11-24": 63.41537676073517,
    "2024-11-25": 64.0888904969319,
    "2024-11-26": 64.7624042331286,
    "2024-11-27": 65.43591796932533,
    "2024-11-28": 66.10943170552204,
    "2024-11-29": 66.78294544171877,
    "2024-11-30": 67.45645917791549,
    "2024-12-01": 67.8853907029706,
    "2024-12-02": 68.3143222280257,
    "2024-12-03": 68.74325375308081,
    "2024-12-04": 69.1721852781359,
    "2024-12-05": 69.601116803191,
    "2024-12-06": 70.03004832824611,
    "2024-12-07": 70.45897985330122,
    "2024-12-08": 70.88791137835632,
    "2024-12-09": 71.31684290341143,
    "2024-12-10": 71.74577442846653,
    "2024-12-11": 72.17470595352164,
    "2024-12-12": 72.60363747857673,
    "2024-12-13": 73.03256900363183,
    "2024-12-14": 73.46150052868694,
    "2024-12-15": 73.89043205374205,
    "2024-12-16": 74.31936357879715,
    "2024-12-17": 74.74829510385226,
    "2024-12-18": 75.17722662890736,
    "2024-12-19": 75.60615815396247,
    "2024-12-20": 76.03508967901756,
    "2024-12-21": 76.46402120407267,
    "2024-12-22": 76.89295272912777,
    "2024-12-23": 77.32188425418288,
    "2024-12-24": 77.75081577923798,
    "2024-12-25": 78.17974730429309,
    "2024-12-26": 78.6086788293482,
    "2024-12-27": 79.03761035440328,
    "2024-12-28": 79.46654187945839,
    "2024-12-29": 79.8954734045135,
    "2024-12-30": 80.3244049295686,
    "2024-12-31": 80.7533364546237,
    "2025-01-01": 81.27458976796076,
    "2025-01-02": 81.79584308129782,
    "2025-01-03": 82.31709639463487,
    "2025-01-04": 82.83834970797191,
    "2025-01-05": 83.35960302130897,
    "2025-01-06": 83.88085633464603,
    "2025-01-07": 84.40210964798308,
    "2025-01-08": 84.92336296132014,
    "2025-01-09": 85.44461627465719,
    "2025-01-10": 85.96586958799425,
    "2025-01-11": 86.4871229013313,
    "2025-01-12": 87.00837621466835,
    "2025-01-13": 87.5296295280054,
    "2025-01-14": 88.05088284134246,
    "2025-01-15": 88.57213615467951,
    "2025-01-16": 89.09338946801657,
    "2025-01-17": 89.61464278135362,
    "2025-01-18": 90.13589609469068,
    "2025-01-19": 90.65714940802772,
    "2025-01-20": 91.17840272136478,
    "2025-01-21": 91.69965603470185,
    "2025-01-22": 92.22090934803887,
    "2025-01-23": 92.74216266137594,
    "2025-01-24": 93.263415974713,
    "2025-01-25": 93.78466928805004,
    "2025-01-26": 94.3059226013871,
    "2025-01-27": 94.82717591472417,
    "2025-01-28": 95.3484292280612,
    "2025-01-29": 95.86968254139826,
    "2025-01-30": 96.39093585473532,
    "2025-01-31": 96.91218916807236,
    "2025-02-01": 97.9110055190956,
    "2025-02-02": 98.90982187011883,
    "2025-02-03": 99.90863822114208,
    "2025-02-04": 100.90745457216532,
    "2025-02-05": 101.90627092318856,
    "2025-02-06": 102.9050872742118,
    "2025-02-07": 103.90390362523505,
    "2025-02-08": 104.90271997625828,
    "2025-02-09": 105.9015363272815,
    "2025-02-10": 106.90035267830474,
    "2025-02-11": 107.89916902932798,
    "2025-02-12": 108.89798538035124,
    "2025-02-13": 109.89680173137448,
    "2025-02-14": 110.8956180823977,
    "2025-02-15": 111.89443443342094,
    "2025-02-16": 112.89325078444418,
    "2025-02-17": 113.8920671354674,
    "2025-02-18": 114.89088348649064,
    "2025-02-19": 115.88969983751387,
    "2025-02-20": 116.88851618853712,
    "2025-02-21": 117.88733253956036,
    "2025-02-22": 118.8861488905836,
    "2025-02-23": 119.88496524160684,
    "2025-02-24": 120.88378159263009,
    "2025-02-25": 121.88259794365332,
    "2025-02-26": 122.88141429467656,
    "2025-02-27": 123.88023064569978,
    "2025-02-28": 124.87904699672302,
    "2025-03-01": 126.34081757108083,
    "2025-03-02": 127.80258814543863,
    "2025-03-03": 129.26435871979646,
    "2025-03-04": 130.72612929415428,
    "2025-03-05": 132.1878998685121,
    "2025-03-06": 133.6496704428699,
    "2025-03-07": 135.11144101722772,
    "2025-03-08": 136.57321159158553,
    "2025-03-09": 138.03498216594335,
    "2025-03-10": 139.49675274030116,
    "2025-03-11": 140.95852331465898,
    "2025-03-12": 142.4202938890168,
    "2025-03-13": 143.8820644633746,
    "2025-03-14": 145.34383503773242,
    "2025-03-15": 146.80560561209023,
    "2025-03-16": 148.26737618644805,
    "2025-03-17": 149.72914676080586,
    "2025-03-18": 151.19091733516368,
    "2025-03-19": 152.6526879095215,
    "2025-03-20": 154.1144584838793,
    "2025-03-21": 155.57622905823712,
    "2025-03-22": 157.03799963259493,
    "2025-03-23": 158.49977020695275,
    "2025-03-24": 159.96154078131056,
    "2025-03-25": 161.42331135566835,
    "2025-03-26": 162.8850819300262,
    "2025-03-27": 164.346852504384,
    "2025-03-28": 165.80862307874182,
    "2025-03-29": 167.27039365309963,
    "2025-03-30": 168.73216422745745,
    "2025-03-31": 170.19393480181526,
    "2025-04-01": 172.33670625684562,
    "2025-04-02": 174.47947771187597,
    "2025-04-03": 176.62224916690633,
    "2025-04-04": 178.76502062193669,
    "2025-04-05": 180.90779207696704,
    "2025-04-06": 183.0505635319974,
    "2025-04-07": 185.19333498702773,
    "2025-04-08": 187.3361064420581,
    "2025-04-09": 189.47887789708847,
    "2025-04-10": 191.6216493521188,
    "2025-04-11": 193.76442080714915,
    "2025-04-12": 195.9071922621795,
    "2025-04-13": 198.04996371720983,
    "2025-04-14": 200.19273517224025,
    "2025-04-15": 202.33550662727055,
    "2025-04-16": 204.47827808230093,
    "2025-04-17": 206.6210495373313,
    "2025-04-18": 208.76382099236164,
    "2025-04-19": 210.906592447392,
    "2025-04-20": 213.0493639024224,
    "2025-04-21": 215.1921353574527,
    "2025-04-22": 217.33490681248304,
    "2025-04-23": 219.4776782675134,
    "2025-04-24": 221.62044972254373,
    "2025-04-25": 223.7632211775741,
    "2025-04-26": 225.90599263260447,
    "2025-04-27": 228.0487640876348,
    "2025-04-28": 230.1915355426652,
    "2025-04-29": 232.33430699769556,
    "2025-04-30": 234.4770784527259,
    "2025-05-01": 236.86757287277783,
    "2025-05-02": 239.25806729282985,
    "2025-05-03": 241.6485617128818,
    "2025-05-04": 244.03905613293375,
    "2025-05-05": 246.42955055298572,
    "2025-05-06": 248.8200449730377,
    "2025-05-07": 251.2105393930897,
    "2025-05-08": 253.60103381314167,
    "2025-05-09": 255.9915282331937,
    "2025-05-10": 258.3820226532456,
    "2025-05-11": 260.7725170732976,
    "2025-05-12": 263.1630114933496,
    "2025-05-13": 265.5535059134015,
    "2025-05-14": 267.9440003334535,
    "2025-05-15": 270.3344947535055,
    "2025-05-16": 272.72498917355745,
    "2025-05-17": 275.11548359360944,
    "2025-05-18": 277.50597801366143,
    "2025-05-19": 279.89647243371337,
    "2025-05-20": 282.28696685376536,
    "2025-05-21": 284.67746127381736,
    "2025-05-22": 287.0679556938693,
    "2025-05-23": 289.4584501139213,
    "2025-05-24": 291.8489445339733,
    "2025-05-25": 294.2394389540252,
    "2025-05-26": 296.6299333740772,
    "2025-05-27": 299.0204277941292,
    "2025-05-28": 301.41092221418114,
    "2025-05-29": 303.80141663423314,
    "2025-05-30": 306.1919110542852,
    "2025-05-31": 308.58240547433707,
    "2025-06-01": 311.2591867021425,
    "2025-06-02": 313.9359679299479,
    "2025-06-03": 316.6127491577532,
    "2025-06-04": 319.28953038555863,
    "2025-06-05": 321.96631161336404,
    "2025-06-06": 324.64309284116945,
    "2025-06-07": 327.31987406897485,
    "2025-06-08": 329.99665529678026,
    "2025-06-09": 332.67343652458567,
    "2025-06-10": 335.350217752391,
    "2025-06-11": 338.0269989801964,
    "2025-06-12": 340.70378020800183,
    "2025-06-13": 343.38056143580724,
    "2025-06-14": 346.05734266361264,
    "2025-06-15": 348.734123891418,
    "2025-06-16": 351.4109051192234,
    "2025-06-17": 354.0876863470288,
    "2025-06-18": 356.7644675748342,
    "2025-06-19": 359.4412488026396,
    "2025-06-20": 362.118030030445,
    "2025-06-21": 364.7948112582504,
    "2025-06-22": 367.4715924860558,
    "2025-06-23": 370.1483737138612,
    "2025-06-24": 372.8251549416666,
    "2025-06-25": 375.501936169472,
    "2025-06-26": 378.1787173972774,
    "2025-06-27": 380.8554986250828,
    "2025-06-28": 383.5322798528882,
    "2025-06-29": 386.2090610806936,
    "2025-06-30": 388.885842308499,
    "2025-07-01": 391.7603475329872,
    "2025-07-02": 394.6348527574754,
    "2025-07-03": 397.5093579819636,
    "2025-07-04": 400.3838632064519,
    "2025-07-05": 403.25836843094,
    "2025-07-06": 406.1328736554283,
    "2025-07-07": 409.0073788799165,
    "2025-07-08": 411.8818841044047,
    "2025-07-09": 414.7563893288929,
    "2025-07-10": 417.6308945533811,
    "2025-07-11": 420.5053997778693,
    "2025-07-12": 423.37990500235753,
    "2025-07-13": 426.2544102268457,
    "2025-07-14": 429.128915451334,
    "2025-07-15": 432.00342067582216,
    "2025-07-16": 434.8779259003104,
    "2025-07-17": 437.7524311247986,
    "2025-07-18": 440.6269363492869,
    "2025-07-19": 443.501441573775,
    "2025-07-20": 446.37594679826327,
    "2025-07-21": 449.25045202275146,
    "2025-07-22": 452.1249572472397,
    "2025-07-23": 454.9994624717279,
    "2025-07-24": 457.8739676962161,
    "2025-07-25": 460.74847292070433,
    "2025-07-26": 463.6229781451925,
    "2025-07-27": 466.4974833696807,
    "2025-07-28": 469.37198859416895,
    "2025-07-29": 472.24649381865714,
    "2025-07-30": 475.1209990431454,
    "2025-07-31": 477.9955042676336,
    "2025-08-01": 480.163393372953,
    "2025-08-02": 482.3312824782724,
    "2025-08-03": 484.4991715835918,
    "2025-08-04": 486.6670606889112,
    "2025-08-05": 488.8349497942306,
    "2025-08-06": 491.00283889955,
    "2025-08-07": 493.17072800486943,
    "2025-08-08": 495.3386171101888,
    "2025-08-09": 497.5065062155082,
    "2025-08-10": 499.67439532082767,
    "2025-08-11": 501.8422844261471,
    "2025-08-12": 504.0101735314665,
    "2025-08-13": 506.17806263678585,
    "2025-08-14": 508.3459517421053,
    "2025-08-15": 510.5138408474247,
    "2025-08-16": 512.681729952744,
    "2025-08-17": 514.8496190580635,
    "2025-08-18": 517.0175081633829,
    "2025-08-19": 519.1853972687023,
    "2025-08-20": 521.3532863740218,
    "2025-08-21": 523.5211754793411,
    "2025-08-22": 525.6890645846605,
    "2025-08-23": 527.85695368998,
    "2025-08-24": 530.0248427952994,
    "2025-08-25": 532.1927319006187,
    "2025-08-26": 534.3606210059381,
    "2025-08-27": 536.5285101112576,
    "2025-08-28": 538.696399216577,
    "2025-08-29": 540.8642883218963,
    "2025-08-30": 543.0321774272157,
    "2025-08-31": 545.2000665325352,
    "2025-09-01": 546.7120440860652,
    "2025-09-02": 548.2240216395953,
    "2025-09-03": 549.7359991931255,
    "2025-09-04": 551.2479767466556,
    "2025-09-05": 552.7599543001857,
    "2025-09-06": 554.2719318537157,
    "2025-09-07": 555.7839094072458,
    "2025-09-08": 557.2958869607759,
    "2025-09-09": 558.807864514306,
    "2025-09-10": 560.3198420678361,
    "2025-09-11": 561.8318196213662,
    "2025-09-12": 563.3437971748963,
    "2025-09-13": 564.8557747284264,
    "2025-09-14": 566.3677522819564,
    "2025-09-15": 567.8797298354866,
    "2025-09-16": 569.3917073890167,
    "2025-09-17": 570.9036849425468,
    "2025-09-18": 572.4156624960768,
    "2025-09-19": 573.9276400496069,
    "2025-09-20": 575.439617603137,
    "2025-09-21": 576.951595156667,
    "2025-09-22": 578.4635727101972,
    "2025-09-23": 579.9755502637273,
    "2025-09-24": 581.4875278172574,
    "2025-09-25": 582.9995053707875,
    "2025-09-26": 584.5114829243175,
    "2025-09-27": 586.0234604778477,
    "2025-09-28": 587.5354380313778,
    "2025-09-29": 589.0474155849079,
    "2025-09-30": 590.5593931384379,
  },
  Grapes: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.6711398475387602,
    "2024-10-03": 3.3422796950775204,
    "2024-10-04": 5.013419542616281,
    "2024-10-05": 6.684559390155041,
    "2024-10-06": 8.355699237693802,
    "2024-10-07": 10.02683908523256,
    "2024-10-08": 11.69797893277132,
    "2024-10-09": 13.369118780310082,
    "2024-10-10": 15.040258627848845,
    "2024-10-11": 16.711398475387604,
    "2024-10-12": 18.38253832292636,
    "2024-10-13": 20.053678170465123,
    "2024-10-14": 21.724818018003884,
    "2024-10-15": 23.39595786554264,
    "2024-10-16": 25.0670977130814,
    "2024-10-17": 26.738237560620163,
    "2024-10-18": 28.409377408158925,
    "2024-10-19": 30.08051725569769,
    "2024-10-20": 31.751657103236443,
    "2024-10-21": 33.42279695077521,
    "2024-10-22": 35.09393679831396,
    "2024-10-23": 36.76507664585272,
    "2024-10-24": 38.43621649339149,
    "2024-10-25": 40.107356340930245,
    "2024-10-26": 41.778496188469006,
    "2024-10-27": 43.44963603600777,
    "2024-10-28": 45.12077588354653,
    "2024-10-29": 46.79191573108528,
    "2024-10-30": 48.46305557862405,
    "2024-10-31": 50.134195426162805,
    "2024-11-01": 50.5756613799674,
    "2024-11-02": 51.017127333772,
    "2024-11-03": 51.45859328757659,
    "2024-11-04": 51.90005924138119,
    "2024-11-05": 52.34152519518578,
    "2024-11-06": 52.782991148990384,
    "2024-11-07": 53.22445710279498,
    "2024-11-08": 53.66592305659957,
    "2024-11-09": 54.10738901040417,
    "2024-11-10": 54.548854964208765,
    "2024-11-11": 54.99032091801336,
    "2024-11-12": 55.43178687181796,
    "2024-11-13": 55.87325282562255,
    "2024-11-14": 56.314718779427146,
    "2024-11-15": 56.75618473323175,
    "2024-11-16": 57.19765068703634,
    "2024-11-17": 57.63911664084094,
    "2024-11-18": 58.080582594645534,
    "2024-11-19": 58.52204854845013,
    "2024-11-20": 58.963514502254725,
    "2024-11-21": 59.40498045605932,
    "2024-11-22": 59.84644640986392,
    "2024-11-23": 60.28791236366851,
    "2024-11-24": 60.72937831747311,
    "2024-11-25": 61.1708442712777,
    "2024-11-26": 61.612310225082304,
    "2024-11-27": 62.0537761788869,
    "2024-11-28": 62.49524213269149,
    "2024-11-29": 62.93670808649609,
    "2024-11-30": 63.378174040300685,
    "2024-12-01": 63.61684959790245,
    "2024-12-02": 63.8555251555042,
    "2024-12-03": 64.09420071310596,
    "2024-12-04": 64.33287627070771,
    "2024-12-05": 64.57155182830948,
    "2024-12-06": 64.81022738591123,
    "2024-12-07": 65.04890294351299,
    "2024-12-08": 65.28757850111475,
    "2024-12-09": 65.5262540587165,
    "2024-12-10": 65.76492961631827,
    "2024-12-11": 66.00360517392002,
    "2024-12-12": 66.24228073152177,
    "2024-12-13": 66.48095628912354,
    "2024-12-14": 66.71963184672529,
    "2024-12-15": 66.95830740432706,
    "2024-12-16": 67.19698296192881,
    "2024-12-17": 67.43565851953056,
    "2024-12-18": 67.67433407713233,
    "2024-12-19": 67.91300963473408,
    "2024-12-20": 68.15168519233585,
    "2024-12-21": 68.3903607499376,
    "2024-12-22": 68.62903630753935,
    "2024-12-23": 68.86771186514112,
    "2024-12-24": 69.10638742274287,
    "2024-12-25": 69.34506298034464,
    "2024-12-26": 69.58373853794639,
    "2024-12-27": 69.82241409554814,
    "2024-12-28": 70.0610896531499,
    "2024-12-29": 70.29976521075166,
    "2024-12-30": 70.53844076835342,
    "2024-12-31": 70.77711632595518,
    "2025-01-01": 71.2776609654517,
    "2025-01-02": 71.77820560494821,
    "2025-01-03": 72.27875024444474,
    "2025-01-04": 72.77929488394126,
    "2025-01-05": 73.27983952343779,
    "2025-01-06": 73.7803841629343,
    "2025-01-07": 74.28092880243082,
    "2025-01-08": 74.78147344192735,
    "2025-01-09": 75.28201808142387,
    "2025-01-10": 75.78256272092038,
    "2025-01-11": 76.2831073604169,
    "2025-01-12": 76.78365199991343,
    "2025-01-13": 77.28419663940996,
    "2025-01-14": 77.78474127890647,
    "2025-01-15": 78.28528591840299,
    "2025-01-16": 78.78583055789952,
    "2025-01-17": 79.28637519739604,
    "2025-01-18": 79.78691983689255,
    "2025-01-19": 80.28746447638908,
    "2025-01-20": 80.7880091158856,
    "2025-01-21": 81.28855375538213,
    "2025-01-22": 81.78909839487864,
    "2025-01-23": 82.28964303437516,
    "2025-01-24": 82.79018767387169,
    "2025-01-25": 83.29073231336821,
    "2025-01-26": 83.79127695286472,
    "2025-01-27": 84.29182159236125,
    "2025-01-28": 84.79236623185777,
    "2025-01-29": 85.29291087135428,
    "2025-01-30": 85.7934555108508,
    "2025-01-31": 86.29400015034733,
    "2025-02-01": 87.5567090542364,
    "2025-02-02": 88.81941795812548,
    "2025-02-03": 90.08212686201458,
    "2025-02-04": 91.34483576590364,
    "2025-02-05": 92.60754466979272,
    "2025-02-06": 93.8702535736818,
    "2025-02-07": 95.13296247757089,
    "2025-02-08": 96.39567138145996,
    "2025-02-09": 97.65838028534904,
    "2025-02-10": 98.92108918923812,
    "2025-02-11": 100.1837980931272,
    "2025-02-12": 101.44650699701629,
    "2025-02-13": 102.70921590090536,
    "2025-02-14": 103.97192480479444,
    "2025-02-15": 105.23463370868352,
    "2025-02-16": 106.4973426125726,
    "2025-02-17": 107.76005151646169,
    "2025-02-18": 109.02276042035076,
    "2025-02-19": 110.28546932423984,
    "2025-02-20": 111.54817822812892,
    "2025-02-21": 112.810887132018,
    "2025-02-22": 114.07359603590707,
    "2025-02-23": 115.33630493979616,
    "2025-02-24": 116.59901384368524,
    "2025-02-25": 117.86172274757432,
    "2025-02-26": 119.1244316514634,
    "2025-02-27": 120.38714055535247,
    "2025-02-28": 121.64984945924157,
    "2025-03-01": 122.58780449794736,
    "2025-03-02": 123.52575953665318,
    "2025-03-03": 124.463714575359,
    "2025-03-04": 125.4016696140648,
    "2025-03-05": 126.33962465277062,
    "2025-03-06": 127.27757969147645,
    "2025-03-07": 128.21553473018224,
    "2025-03-08": 129.15348976888805,
    "2025-03-09": 130.09144480759386,
    "2025-03-10": 131.02939984629967,
    "2025-03-11": 131.96735488500548,
    "2025-03-12": 132.9053099237113,
    "2025-03-13": 133.8432649624171,
    "2025-03-14": 134.7812200011229,
    "2025-03-15": 135.7191750398287,
    "2025-03-16": 136.65713007853452,
    "2025-03-17": 137.59508511724033,
    "2025-03-18": 138.53304015594614,
    "2025-03-19": 139.47099519465195,
    "2025-03-20": 140.40895023335776,
    "2025-03-21": 141.34690527206357,
    "2025-03-22": 142.28486031076935,
    "2025-03-23": 143.2228153494752,
    "2025-03-24": 144.16077038818102,
    "2025-03-25": 145.09872542688683,
    "2025-03-26": 146.03668046559264,
    "2025-03-27": 146.97463550429845,
    "2025-03-28": 147.91259054300426,
    "2025-03-29": 148.8505455817101,
    "2025-03-30": 149.78850062041587,
    "2025-03-31": 150.72645565912168,
    "2025-04-01": 152.65502078945372,
    "2025-04-02": 154.58358591978572,
    "2025-04-03": 156.51215105011775,
    "2025-04-04": 158.44071618044978,
    "2025-04-05": 160.3692813107818,
    "2025-04-06": 162.29784644111382,
    "2025-04-07": 164.22641157144585,
    "2025-04-08": 166.15497670177788,
    "2025-04-09": 168.0835418321099,
    "2025-04-10": 170.01210696244192,
    "2025-04-11": 171.94067209277395,
    "2025-04-12": 173.86923722310598,
    "2025-04-13": 175.797802353438,
    "2025-04-14": 177.72636748377002,
    "2025-04-15": 179.65493261410205,
    "2025-04-16": 181.58349774443408,
    "2025-04-17": 183.5120628747661,
    "2025-04-18": 185.4406280050981,
    "2025-04-19": 187.36919313543007,
    "2025-04-20": 189.29775826576216,
    "2025-04-21": 191.2263233960942,
    "2025-04-22": 193.1548885264262,
    "2025-04-23": 195.08345365675825,
    "2025-04-24": 197.01201878709023,
    "2025-04-25": 198.94058391742223,
    "2025-04-26": 200.8691490477543,
    "2025-04-27": 202.79771417808632,
    "2025-04-28": 204.7262793084184,
    "2025-04-29": 206.6548444387504,
    "2025-04-30": 208.5834095690824,
    "2025-05-01": 211.4147463833885,
    "2025-05-02": 214.24608319769465,
    "2025-05-03": 217.07742001200077,
    "2025-05-04": 219.90875682630684,
    "2025-05-05": 222.74009364061297,
    "2025-05-06": 225.5714304549191,
    "2025-05-07": 228.4027672692252,
    "2025-05-08": 231.2341040835313,
    "2025-05-09": 234.06544089783745,
    "2025-05-10": 236.89677771214355,
    "2025-05-11": 239.72811452644964,
    "2025-05-12": 242.55945134075577,
    "2025-05-13": 245.3907881550619,
    "2025-05-14": 248.222124969368,
    "2025-05-15": 251.05346178367407,
    "2025-05-16": 253.88479859798025,
    "2025-05-17": 256.71613541228635,
    "2025-05-18": 259.54747222659245,
    "2025-05-19": 262.37880904089855,
    "2025-05-20": 265.2101458552047,
    "2025-05-21": 268.0414826695108,
    "2025-05-22": 270.8728194838169,
    "2025-05-23": 273.70415629812305,
    "2025-05-24": 276.53549311242915,
    "2025-05-25": 279.36682992673525,
    "2025-05-26": 282.1981667410414,
    "2025-05-27": 285.0295035553475,
    "2025-05-28": 287.8608403696536,
    "2025-05-29": 290.69217718395976,
    "2025-05-30": 293.52351399826586,
    "2025-05-31": 296.35485081257195,
    "2025-06-01": 299.7182245744302,
    "2025-06-02": 303.0815983362885,
    "2025-06-03": 306.4449720981467,
    "2025-06-04": 309.808345860005,
    "2025-06-05": 313.17171962186325,
    "2025-06-06": 316.5350933837215,
    "2025-06-07": 319.8984671455798,
    "2025-06-08": 323.261840907438,
    "2025-06-09": 326.62521466929627,
    "2025-06-10": 329.98858843115454,
    "2025-06-11": 333.3519621930128,
    "2025-06-12": 336.7153359548711,
    "2025-06-13": 340.0787097167293,
    "2025-06-14": 343.4420834785876,
    "2025-06-15": 346.80545724044583,
    "2025-06-16": 350.1688310023041,
    "2025-06-17": 353.5322047641623,
    "2025-06-18": 356.8955785260206,
    "2025-06-19": 360.25895228787886,
    "2025-06-20": 363.6223260497371,
    "2025-06-21": 366.9856998115954,
    "2025-06-22": 370.34907357345367,
    "2025-06-23": 373.7124473353119,
    "2025-06-24": 377.07582109717015,
    "2025-06-25": 380.4391948590284,
    "2025-06-26": 383.8025686208867,
    "2025-06-27": 387.1659423827449,
    "2025-06-28": 390.5293161446032,
    "2025-06-29": 393.89268990646144,
    "2025-06-30": 397.2560636683197,
    "2025-07-01": 400.9587537304837,
    "2025-07-02": 404.6614437926477,
    "2025-07-03": 408.36413385481166,
    "2025-07-04": 412.0668239169757,
    "2025-07-05": 415.7695139791396,
    "2025-07-06": 419.4722040413036,
    "2025-07-07": 423.1748941034676,
    "2025-07-08": 426.8775841656316,
    "2025-07-09": 430.58027422779554,
    "2025-07-10": 434.2829642899595,
    "2025-07-11": 437.9856543521235,
    "2025-07-12": 441.6883444142875,
    "2025-07-13": 445.39103447645147,
    "2025-07-14": 449.09372453861545,
    "2025-07-15": 452.79641460077937,
    "2025-07-16": 456.4991046629434,
    "2025-07-17": 460.2017947251073,
    "2025-07-18": 463.9044847872714,
    "2025-07-19": 467.6071748494353,
    "2025-07-20": 471.3098649115993,
    "2025-07-21": 475.01255497376326,
    "2025-07-22": 478.7152450359272,
    "2025-07-23": 482.4179350980912,
    "2025-07-24": 486.1206251602552,
    "2025-07-25": 489.8233152224192,
    "2025-07-26": 493.5260052845832,
    "2025-07-27": 497.2286953467472,
    "2025-07-28": 500.9313854089111,
    "2025-07-29": 504.6340754710751,
    "2025-07-30": 508.3367655332391,
    "2025-07-31": 512.0394555954031,
    "2025-08-01": 514.9866625693767,
    "2025-08-02": 517.9338695433503,
    "2025-08-03": 520.8810765173239,
    "2025-08-04": 523.8282834912975,
    "2025-08-05": 526.7754904652711,
    "2025-08-06": 529.7226974392447,
    "2025-08-07": 532.6699044132183,
    "2025-08-08": 535.6171113871919,
    "2025-08-09": 538.5643183611655,
    "2025-08-10": 541.5115253351391,
    "2025-08-11": 544.4587323091127,
    "2025-08-12": 547.4059392830864,
    "2025-08-13": 550.35314625706,
    "2025-08-14": 553.3003532310336,
    "2025-08-15": 556.2475602050072,
    "2025-08-16": 559.1947671789808,
    "2025-08-17": 562.1419741529544,
    "2025-08-18": 565.089181126928,
    "2025-08-19": 568.0363881009016,
    "2025-08-20": 570.9835950748752,
    "2025-08-21": 573.9308020488488,
    "2025-08-22": 576.8780090228224,
    "2025-08-23": 579.825215996796,
    "2025-08-24": 582.7724229707696,
    "2025-08-25": 585.7196299447432,
    "2025-08-26": 588.6668369187169,
    "2025-08-27": 591.6140438926905,
    "2025-08-28": 594.5612508666641,
    "2025-08-29": 597.5084578406377,
    "2025-08-30": 600.4556648146113,
    "2025-08-31": 603.4028717885849,
    "2025-09-01": 605.5644837762264,
    "2025-09-02": 607.7260957638679,
    "2025-09-03": 609.8877077515094,
    "2025-09-04": 612.049319739151,
    "2025-09-05": 614.2109317267924,
    "2025-09-06": 616.372543714434,
    "2025-09-07": 618.5341557020754,
    "2025-09-08": 620.695767689717,
    "2025-09-09": 622.8573796773585,
    "2025-09-10": 625.0189916649999,
    "2025-09-11": 627.1806036526415,
    "2025-09-12": 629.342215640283,
    "2025-09-13": 631.5038276279245,
    "2025-09-14": 633.665439615566,
    "2025-09-15": 635.8270516032076,
    "2025-09-16": 637.988663590849,
    "2025-09-17": 640.1502755784906,
    "2025-09-18": 642.311887566132,
    "2025-09-19": 644.4734995537735,
    "2025-09-20": 646.6351115414151,
    "2025-09-21": 648.7967235290565,
    "2025-09-22": 650.9583355166981,
    "2025-09-23": 653.1199475043396,
    "2025-09-24": 655.281559491981,
    "2025-09-25": 657.4431714796226,
    "2025-09-26": 659.604783467264,
    "2025-09-27": 661.7663954549056,
    "2025-09-28": 663.9280074425471,
    "2025-09-29": 666.0896194301886,
    "2025-09-30": 668.2512314178301,
  },
  Kiwi: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.752005896189856,
    "2024-10-03": 3.5040117923797123,
    "2024-10-04": 5.256017688569568,
    "2024-10-05": 7.0080235847594246,
    "2024-10-06": 8.760029480949282,
    "2024-10-07": 10.512035377139137,
    "2024-10-08": 12.264041273328992,
    "2024-10-09": 14.016047169518847,
    "2024-10-10": 15.768053065708706,
    "2024-10-11": 17.520058961898563,
    "2024-10-12": 19.272064858088417,
    "2024-10-13": 21.024070754278277,
    "2024-10-14": 22.77607665046813,
    "2024-10-15": 24.528082546657984,
    "2024-10-16": 26.28008844284784,
    "2024-10-17": 28.032094339037695,
    "2024-10-18": 29.784100235227555,
    "2024-10-19": 31.53610613141741,
    "2024-10-20": 33.28811202760727,
    "2024-10-21": 35.040117923797126,
    "2024-10-22": 36.792123819986976,
    "2024-10-23": 38.54412971617683,
    "2024-10-24": 40.29613561236669,
    "2024-10-25": 42.04814150855655,
    "2024-10-26": 43.8001474047464,
    "2024-10-27": 45.55215330093626,
    "2024-10-28": 47.30415919712612,
    "2024-10-29": 49.05616509331597,
    "2024-10-30": 50.80817098950583,
    "2024-10-31": 52.56017688569568,
    "2024-11-01": 53.18635303248848,
    "2024-11-02": 53.81252917928126,
    "2024-11-03": 54.43870532607406,
    "2024-11-04": 55.06488147286685,
    "2024-11-05": 55.69105761965964,
    "2024-11-06": 56.31723376645243,
    "2024-11-07": 56.94340991324522,
    "2024-11-08": 57.56958606003801,
    "2024-11-09": 58.1957622068308,
    "2024-11-10": 58.8219383536236,
    "2024-11-11": 59.44811450041638,
    "2024-11-12": 60.074290647209175,
    "2024-11-13": 60.70046679400197,
    "2024-11-14": 61.32664294079476,
    "2024-11-15": 61.95281908758755,
    "2024-11-16": 62.57899523438034,
    "2024-11-17": 63.20517138117313,
    "2024-11-18": 63.83134752796592,
    "2024-11-19": 64.45752367475872,
    "2024-11-20": 65.0836998215515,
    "2024-11-21": 65.70987596834429,
    "2024-11-22": 66.33605211513708,
    "2024-11-23": 66.96222826192988,
    "2024-11-24": 67.58840440872267,
    "2024-11-25": 68.21458055551545,
    "2024-11-26": 68.84075670230825,
    "2024-11-27": 69.46693284910104,
    "2024-11-28": 70.09310899589383,
    "2024-11-29": 70.71928514268663,
    "2024-11-30": 71.34546128947942,
    "2024-12-01": 71.59907102151622,
    "2024-12-02": 71.85268075355305,
    "2024-12-03": 72.10629048558985,
    "2024-12-04": 72.35990021762667,
    "2024-12-05": 72.61350994966348,
    "2024-12-06": 72.8671196817003,
    "2024-12-07": 73.12072941373711,
    "2024-12-08": 73.37433914577392,
    "2024-12-09": 73.62794887781074,
    "2024-12-10": 73.88155860984754,
    "2024-12-11": 74.13516834188437,
    "2024-12-12": 74.38877807392117,
    "2024-12-13": 74.64238780595798,
    "2024-12-14": 74.8959975379948,
    "2024-12-15": 75.14960727003161,
    "2024-12-16": 75.40321700206843,
    "2024-12-17": 75.65682673410524,
    "2024-12-18": 75.91043646614204,
    "2024-12-19": 76.16404619817887,
    "2024-12-20": 76.41765593021567,
    "2024-12-21": 76.6712656622525,
    "2024-12-22": 76.9248753942893,
    "2024-12-23": 77.17848512632612,
    "2024-12-24": 77.43209485836293,
    "2024-12-25": 77.68570459039974,
    "2024-12-26": 77.93931432243656,
    "2024-12-27": 78.19292405447337,
    "2024-12-28": 78.44653378651019,
    "2024-12-29": 78.700143518547,
    "2024-12-30": 78.95375325058382,
    "2024-12-31": 79.20736298262062,
    "2025-01-01": 79.76236369797891,
    "2025-01-02": 80.31736441333719,
    "2025-01-03": 80.87236512869548,
    "2025-01-04": 81.42736584405375,
    "2025-01-05": 81.98236655941204,
    "2025-01-06": 82.53736727477032,
    "2025-01-07": 83.09236799012861,
    "2025-01-08": 83.64736870548688,
    "2025-01-09": 84.20236942084517,
    "2025-01-10": 84.75737013620345,
    "2025-01-11": 85.31237085156174,
    "2025-01-12": 85.86737156692001,
    "2025-01-13": 86.4223722822783,
    "2025-01-14": 86.97737299763658,
    "2025-01-15": 87.53237371299487,
    "2025-01-16": 88.08737442835314,
    "2025-01-17": 88.64237514371143,
    "2025-01-18": 89.19737585906971,
    "2025-01-19": 89.752376574428,
    "2025-01-20": 90.30737728978627,
    "2025-01-21": 90.86237800514456,
    "2025-01-22": 91.41737872050284,
    "2025-01-23": 91.97237943586111,
    "2025-01-24": 92.5273801512194,
    "2025-01-25": 93.0823808665777,
    "2025-01-26": 93.63738158193595,
    "2025-01-27": 94.19238229729426,
    "2025-01-28": 94.74738301265252,
    "2025-01-29": 95.30238372801082,
    "2025-01-30": 95.85738444336911,
    "2025-01-31": 96.4123851587274,
    "2025-02-01": 97.16986487416511,
    "2025-02-02": 97.92734458960282,
    "2025-02-03": 98.68482430504056,
    "2025-02-04": 99.44230402047828,
    "2025-02-05": 100.199783735916,
    "2025-02-06": 100.95726345135373,
    "2025-02-07": 101.71474316679144,
    "2025-02-08": 102.47222288222916,
    "2025-02-09": 103.22970259766689,
    "2025-02-10": 103.9871823131046,
    "2025-02-11": 104.74466202854232,
    "2025-02-12": 105.50214174398003,
    "2025-02-13": 106.25962145941776,
    "2025-02-14": 107.01710117485548,
    "2025-02-15": 107.7745808902932,
    "2025-02-16": 108.53206060573092,
    "2025-02-17": 109.28954032116864,
    "2025-02-18": 110.04702003660636,
    "2025-02-19": 110.80449975204408,
    "2025-02-20": 111.5619794674818,
    "2025-02-21": 112.31945918291952,
    "2025-02-22": 113.07693889835724,
    "2025-02-23": 113.83441861379497,
    "2025-02-24": 114.59189832923268,
    "2025-02-25": 115.3493780446704,
    "2025-02-26": 116.10685776010811,
    "2025-02-27": 116.86433747554584,
    "2025-02-28": 117.62181719098356,
    "2025-03-01": 118.72740176714645,
    "2025-03-02": 119.83298634330932,
    "2025-03-03": 120.93857091947218,
    "2025-03-04": 122.04415549563508,
    "2025-03-05": 123.14974007179794,
    "2025-03-06": 124.2553246479608,
    "2025-03-07": 125.36090922412367,
    "2025-03-08": 126.46649380028656,
    "2025-03-09": 127.57207837644944,
    "2025-03-10": 128.6776629526123,
    "2025-03-11": 129.78324752877518,
    "2025-03-12": 130.88883210493805,
    "2025-03-13": 131.99441668110094,
    "2025-03-14": 133.1000012572638,
    "2025-03-15": 134.20558583342668,
    "2025-03-16": 135.31117040958955,
    "2025-03-17": 136.41675498575242,
    "2025-03-18": 137.52233956191532,
    "2025-03-19": 138.6279241380782,
    "2025-03-20": 139.73350871424103,
    "2025-03-21": 140.83909329040392,
    "2025-03-22": 141.9446778665668,
    "2025-03-23": 143.05026244272966,
    "2025-03-24": 144.15584701889256,
    "2025-03-25": 145.26143159505543,
    "2025-03-26": 146.3670161712183,
    "2025-03-27": 147.47260074738116,
    "2025-03-28": 148.57818532354406,
    "2025-03-29": 149.68376989970693,
    "2025-03-30": 150.7893544758698,
    "2025-03-31": 151.89493905203267,
    "2025-04-01": 154.63103406462267,
    "2025-04-02": 157.36712907721267,
    "2025-04-03": 160.1032240898027,
    "2025-04-04": 162.83931910239266,
    "2025-04-05": 165.57541411498266,
    "2025-04-06": 168.31150912757266,
    "2025-04-07": 171.04760414016266,
    "2025-04-08": 173.78369915275266,
    "2025-04-09": 176.51979416534266,
    "2025-04-10": 179.25588917793263,
    "2025-04-11": 181.99198419052263,
    "2025-04-12": 184.72807920311263,
    "2025-04-13": 187.46417421570263,
    "2025-04-14": 190.20026922829263,
    "2025-04-15": 192.93636424088265,
    "2025-04-16": 195.67245925347265,
    "2025-04-17": 198.40855426606265,
    "2025-04-18": 201.14464927865265,
    "2025-04-19": 203.88074429124265,
    "2025-04-20": 206.61683930383265,
    "2025-04-21": 209.35293431642265,
    "2025-04-22": 212.0890293290126,
    "2025-04-23": 214.8251243416026,
    "2025-04-24": 217.5612193541926,
    "2025-04-25": 220.2973143667826,
    "2025-04-26": 223.03340937937256,
    "2025-04-27": 225.76950439196256,
    "2025-04-28": 228.50559940455256,
    "2025-04-29": 231.24169441714255,
    "2025-04-30": 233.97778942973255,
    "2025-05-01": 237.6650335072837,
    "2025-05-02": 241.3522775848348,
    "2025-05-03": 245.03952166238597,
    "2025-05-04": 248.72676573993704,
    "2025-05-05": 252.4140098174882,
    "2025-05-06": 256.1012538950393,
    "2025-05-07": 259.7884979725904,
    "2025-05-08": 263.47574205014155,
    "2025-05-09": 267.16298612769265,
    "2025-05-10": 270.85023020524375,
    "2025-05-11": 274.5374742827949,
    "2025-05-12": 278.224718360346,
    "2025-05-13": 281.9119624378972,
    "2025-05-14": 285.59920651544826,
    "2025-05-15": 289.28645059299936,
    "2025-05-16": 292.9736946705505,
    "2025-05-17": 296.6609387481016,
    "2025-05-18": 300.3481828256527,
    "2025-05-19": 304.03542690320387,
    "2025-05-20": 307.72267098075497,
    "2025-05-21": 311.40991505830607,
    "2025-05-22": 315.0971591358572,
    "2025-05-23": 318.7844032134083,
    "2025-05-24": 322.4716472909595,
    "2025-05-25": 326.1588913685106,
    "2025-05-26": 329.8461354460617,
    "2025-05-27": 333.5333795236128,
    "2025-05-28": 337.22062360116394,
    "2025-05-29": 340.90786767871504,
    "2025-05-30": 344.5951117562662,
    "2025-05-31": 348.2823558338173,
    "2025-06-01": 352.6820455286657,
    "2025-06-02": 357.0817352235141,
    "2025-06-03": 361.4814249183625,
    "2025-06-04": 365.88111461321085,
    "2025-06-05": 370.28080430805926,
    "2025-06-06": 374.68049400290766,
    "2025-06-07": 379.080183697756,
    "2025-06-08": 383.4798733926044,
    "2025-06-09": 387.8795630874528,
    "2025-06-10": 392.2792527823012,
    "2025-06-11": 396.6789424771496,
    "2025-06-12": 401.078632171998,
    "2025-06-13": 405.4783218668464,
    "2025-06-14": 409.8780115616948,
    "2025-06-15": 414.2777012565432,
    "2025-06-16": 418.67739095139154,
    "2025-06-17": 423.07708064624,
    "2025-06-18": 427.4767703410884,
    "2025-06-19": 431.8764600359367,
    "2025-06-20": 436.2761497307851,
    "2025-06-21": 440.6758394256335,
    "2025-06-22": 445.0755291204819,
    "2025-06-23": 449.4752188153303,
    "2025-06-24": 453.8749085101786,
    "2025-06-25": 458.2745982050271,
    "2025-06-26": 462.6742878998755,
    "2025-06-27": 467.0739775947239,
    "2025-06-28": 471.4736672895723,
    "2025-06-29": 475.87335698442064,
    "2025-06-30": 480.273046679269,
    "2025-07-01": 484.38836424922766,
    "2025-07-02": 488.5036818191863,
    "2025-07-03": 492.6189993891449,
    "2025-07-04": 496.7343169591035,
    "2025-07-05": 500.8496345290622,
    "2025-07-06": 504.9649520990208,
    "2025-07-07": 509.0802696689794,
    "2025-07-08": 513.1955872389381,
    "2025-07-09": 517.3109048088967,
    "2025-07-10": 521.4262223788553,
    "2025-07-11": 525.5415399488139,
    "2025-07-12": 529.6568575187725,
    "2025-07-13": 533.7721750887312,
    "2025-07-14": 537.8874926586898,
    "2025-07-15": 542.0028102286484,
    "2025-07-16": 546.118127798607,
    "2025-07-17": 550.2334453685656,
    "2025-07-18": 554.3487629385243,
    "2025-07-19": 558.4640805084829,
    "2025-07-20": 562.5793980784415,
    "2025-07-21": 566.6947156484002,
    "2025-07-22": 570.8100332183587,
    "2025-07-23": 574.9253507883175,
    "2025-07-24": 579.0406683582761,
    "2025-07-25": 583.1559859282347,
    "2025-07-26": 587.2713034981933,
    "2025-07-27": 591.386621068152,
    "2025-07-28": 595.5019386381106,
    "2025-07-29": 599.6172562080692,
    "2025-07-30": 603.7325737780278,
    "2025-07-31": 607.8478913479864,
    "2025-08-01": 611.3644313765483,
    "2025-08-02": 614.8809714051101,
    "2025-08-03": 618.3975114336719,
    "2025-08-04": 621.9140514622337,
    "2025-08-05": 625.4305914907956,
    "2025-08-06": 628.9471315193574,
    "2025-08-07": 632.4636715479193,
    "2025-08-08": 635.980211576481,
    "2025-08-09": 639.4967516050428,
    "2025-08-10": 643.0132916336047,
    "2025-08-11": 646.5298316621665,
    "2025-08-12": 650.0463716907284,
    "2025-08-13": 653.5629117192901,
    "2025-08-14": 657.079451747852,
    "2025-08-15": 660.5959917764138,
    "2025-08-16": 664.1125318049757,
    "2025-08-17": 667.6290718335375,
    "2025-08-18": 671.1456118620993,
    "2025-08-19": 674.6621518906611,
    "2025-08-20": 678.178691919223,
    "2025-08-21": 681.6952319477848,
    "2025-08-22": 685.2117719763467,
    "2025-08-23": 688.7283120049085,
    "2025-08-24": 692.2448520334702,
    "2025-08-25": 695.7613920620321,
    "2025-08-26": 699.2779320905939,
    "2025-08-27": 702.7944721191558,
    "2025-08-28": 706.3110121477175,
    "2025-08-29": 709.8275521762794,
    "2025-08-30": 713.3440922048412,
    "2025-08-31": 716.8606322334031,
    "2025-09-01": 719.4195661139214,
    "2025-09-02": 721.9784999944397,
    "2025-09-03": 724.5374338749581,
    "2025-09-04": 727.0963677554765,
    "2025-09-05": 729.6553016359949,
    "2025-09-06": 732.2142355165132,
    "2025-09-07": 734.7731693970316,
    "2025-09-08": 737.3321032775499,
    "2025-09-09": 739.8910371580682,
    "2025-09-10": 742.4499710385866,
    "2025-09-11": 745.0089049191049,
    "2025-09-12": 747.5678387996234,
    "2025-09-13": 750.1267726801417,
    "2025-09-14": 752.68570656066,
    "2025-09-15": 755.2446404411784,
    "2025-09-16": 757.8035743216967,
    "2025-09-17": 760.362508202215,
    "2025-09-18": 762.9214420827334,
    "2025-09-19": 765.4803759632518,
    "2025-09-20": 768.0393098437702,
    "2025-09-21": 770.5982437242885,
    "2025-09-22": 773.1571776048069,
    "2025-09-23": 775.7161114853252,
    "2025-09-24": 778.2750453658435,
    "2025-09-25": 780.8339792463619,
    "2025-09-26": 783.3929131268803,
    "2025-09-27": 785.9518470073987,
    "2025-09-28": 788.510780887917,
    "2025-09-29": 791.0697147684353,
    "2025-09-30": 793.6286486489537,
  },
  "Miscellaneous Deciduous": {
    "2024-10-01": 0.0,
    "2024-10-02": 1.5825491270085985,
    "2024-10-03": 3.165098254017197,
    "2024-10-04": 4.747647381025795,
    "2024-10-05": 6.330196508034393,
    "2024-10-06": 7.912745635042992,
    "2024-10-07": 9.49529476205159,
    "2024-10-08": 11.077843889060189,
    "2024-10-09": 12.660393016068786,
    "2024-10-10": 14.242942143077384,
    "2024-10-11": 15.825491270085983,
    "2024-10-12": 17.40804039709458,
    "2024-10-13": 18.99058952410318,
    "2024-10-14": 20.573138651111776,
    "2024-10-15": 22.155687778120377,
    "2024-10-16": 23.73823690512897,
    "2024-10-17": 25.320786032137573,
    "2024-10-18": 26.90333515914617,
    "2024-10-19": 28.485884286154768,
    "2024-10-20": 30.06843341316337,
    "2024-10-21": 31.650982540171967,
    "2024-10-22": 33.233531667180564,
    "2024-10-23": 34.81608079418916,
    "2024-10-24": 36.39862992119776,
    "2024-10-25": 37.98117904820636,
    "2024-10-26": 39.56372817521496,
    "2024-10-27": 41.14627730222355,
    "2024-10-28": 42.72882642923216,
    "2024-10-29": 44.31137555624076,
    "2024-10-30": 45.89392468324935,
    "2024-10-31": 47.47647381025795,
    "2024-11-01": 47.85201546336125,
    "2024-11-02": 48.22755711646455,
    "2024-11-03": 48.60309876956784,
    "2024-11-04": 48.97864042267114,
    "2024-11-05": 49.354182075774446,
    "2024-11-06": 49.729723728877744,
    "2024-11-07": 50.10526538198104,
    "2024-11-08": 50.48080703508434,
    "2024-11-09": 50.85634868818764,
    "2024-11-10": 51.231890341290935,
    "2024-11-11": 51.60743199439423,
    "2024-11-12": 51.98297364749753,
    "2024-11-13": 52.35851530060083,
    "2024-11-14": 52.734056953704126,
    "2024-11-15": 53.109598606807424,
    "2024-11-16": 53.48514025991073,
    "2024-11-17": 53.86068191301403,
    "2024-11-18": 54.23622356611733,
    "2024-11-19": 54.61176521922062,
    "2024-11-20": 54.98730687232392,
    "2024-11-21": 55.36284852542722,
    "2024-11-22": 55.73839017853052,
    "2024-11-23": 56.11393183163381,
    "2024-11-24": 56.48947348473712,
    "2024-11-25": 56.865015137840416,
    "2024-11-26": 57.240556790943714,
    "2024-11-27": 57.61609844404701,
    "2024-11-28": 57.99164009715031,
    "2024-11-29": 58.36718175025361,
    "2024-11-30": 58.742723403356905,
    "2024-12-01": 58.9899211544329,
    "2024-12-02": 59.237118905508886,
    "2024-12-03": 59.48431665658488,
    "2024-12-04": 59.73151440766087,
    "2024-12-05": 59.97871215873686,
    "2024-12-06": 60.22590990981285,
    "2024-12-07": 60.47310766088884,
    "2024-12-08": 60.72030541196483,
    "2024-12-09": 60.96750316304082,
    "2024-12-10": 61.21470091411681,
    "2024-12-11": 61.461898665192805,
    "2024-12-12": 61.70909641626879,
    "2024-12-13": 61.95629416734479,
    "2024-12-14": 62.20349191842077,
    "2024-12-15": 62.45068966949677,
    "2024-12-16": 62.69788742057276,
    "2024-12-17": 62.94508517164875,
    "2024-12-18": 63.192282922724736,
    "2024-12-19": 63.43948067380073,
    "2024-12-20": 63.68667842487672,
    "2024-12-21": 63.93387617595271,
    "2024-12-22": 64.1810739270287,
    "2024-12-23": 64.4282716781047,
    "2024-12-24": 64.67546942918068,
    "2024-12-25": 64.92266718025667,
    "2024-12-26": 65.16986493133267,
    "2024-12-27": 65.41706268240866,
    "2024-12-28": 65.66426043348464,
    "2024-12-29": 65.91145818456064,
    "2024-12-30": 66.15865593563663,
    "2024-12-31": 66.40585368671262,
    "2025-01-01": 66.95264982380303,
    "2025-01-02": 67.49944596089342,
    "2025-01-03": 68.04624209798384,
    "2025-01-04": 68.59303823507425,
    "2025-01-05": 69.13983437216466,
    "2025-01-06": 69.68663050925505,
    "2025-01-07": 70.23342664634546,
    "2025-01-08": 70.78022278343587,
    "2025-01-09": 71.32701892052629,
    "2025-01-10": 71.87381505761668,
    "2025-01-11": 72.42061119470709,
    "2025-01-12": 72.9674073317975,
    "2025-01-13": 73.51420346888791,
    "2025-01-14": 74.06099960597831,
    "2025-01-15": 74.60779574306872,
    "2025-01-16": 75.15459188015913,
    "2025-01-17": 75.70138801724954,
    "2025-01-18": 76.24818415433994,
    "2025-01-19": 76.79498029143035,
    "2025-01-20": 77.34177642852076,
    "2025-01-21": 77.88857256561117,
    "2025-01-22": 78.43536870270157,
    "2025-01-23": 78.98216483979198,
    "2025-01-24": 79.52896097688239,
    "2025-01-25": 80.0757571139728,
    "2025-01-26": 80.6225532510632,
    "2025-01-27": 81.1693493881536,
    "2025-01-28": 81.71614552524402,
    "2025-01-29": 82.26294166233441,
    "2025-01-30": 82.80973779942482,
    "2025-01-31": 83.35653393651523,
    "2025-02-01": 84.21297975960535,
    "2025-02-02": 85.06942558269546,
    "2025-02-03": 85.92587140578557,
    "2025-02-04": 86.78231722887567,
    "2025-02-05": 87.63876305196578,
    "2025-02-06": 88.4952088750559,
    "2025-02-07": 89.351654698146,
    "2025-02-08": 90.20810052123612,
    "2025-02-09": 91.06454634432625,
    "2025-02-10": 91.92099216741634,
    "2025-02-11": 92.77743799050646,
    "2025-02-12": 93.63388381359655,
    "2025-02-13": 94.49032963668668,
    "2025-02-14": 95.34677545977678,
    "2025-02-15": 96.20322128286688,
    "2025-02-16": 97.059667105957,
    "2025-02-17": 97.91611292904712,
    "2025-02-18": 98.77255875213724,
    "2025-02-19": 99.62900457522731,
    "2025-02-20": 100.48545039831744,
    "2025-02-21": 101.34189622140757,
    "2025-02-22": 102.19834204449766,
    "2025-02-23": 103.05478786758778,
    "2025-02-24": 103.91123369067788,
    "2025-02-25": 104.767679513768,
    "2025-02-26": 105.6241253368581,
    "2025-02-27": 106.4805711599482,
    "2025-02-28": 107.33701698303832,
    "2025-03-01": 108.59947659646922,
    "2025-03-02": 109.8619362099001,
    "2025-03-03": 111.124395823331,
    "2025-03-04": 112.38685543676186,
    "2025-03-05": 113.64931505019275,
    "2025-03-06": 114.91177466362365,
    "2025-03-07": 116.17423427705452,
    "2025-03-08": 117.4366938904854,
    "2025-03-09": 118.69915350391628,
    "2025-03-10": 119.96161311734716,
    "2025-03-11": 121.22407273077806,
    "2025-03-12": 122.48653234420894,
    "2025-03-13": 123.74899195763984,
    "2025-03-14": 125.01145157107072,
    "2025-03-15": 126.2739111845016,
    "2025-03-16": 127.53637079793248,
    "2025-03-17": 128.79883041136335,
    "2025-03-18": 130.06129002479426,
    "2025-03-19": 131.32374963822514,
    "2025-03-20": 132.58620925165602,
    "2025-03-21": 133.8486688650869,
    "2025-03-22": 135.1111284785178,
    "2025-03-23": 136.37358809194868,
    "2025-03-24": 137.63604770537955,
    "2025-03-25": 138.89850731881046,
    "2025-03-26": 140.16096693224134,
    "2025-03-27": 141.4234265456722,
    "2025-03-28": 142.6858861591031,
    "2025-03-29": 143.94834577253397,
    "2025-03-30": 145.21080538596487,
    "2025-03-31": 146.47326499939575,
    "2025-04-01": 148.6911005937792,
    "2025-04-02": 150.90893618816264,
    "2025-04-03": 153.1267717825461,
    "2025-04-04": 155.34460737692953,
    "2025-04-05": 157.56244297131298,
    "2025-04-06": 159.78027856569642,
    "2025-04-07": 161.9981141600799,
    "2025-04-08": 164.2159497544633,
    "2025-04-09": 166.43378534884675,
    "2025-04-10": 168.6516209432302,
    "2025-04-11": 170.86945653761364,
    "2025-04-12": 173.0872921319971,
    "2025-04-13": 175.30512772638053,
    "2025-04-14": 177.522963320764,
    "2025-04-15": 179.74079891514742,
    "2025-04-16": 181.9586345095309,
    "2025-04-17": 184.1764701039143,
    "2025-04-18": 186.39430569829776,
    "2025-04-19": 188.6121412926812,
    "2025-04-20": 190.82997688706467,
    "2025-04-21": 193.0478124814481,
    "2025-04-22": 195.2656480758316,
    "2025-04-23": 197.483483670215,
    "2025-04-24": 199.70131926459845,
    "2025-04-25": 201.9191548589819,
    "2025-04-26": 204.1369904533653,
    "2025-04-27": 206.3548260477488,
    "2025-04-28": 208.57266164213223,
    "2025-04-29": 210.79049723651568,
    "2025-04-30": 213.00833283089912,
    "2025-05-01": 215.2909237526651,
    "2025-05-02": 217.57351467443104,
    "2025-05-03": 219.856105596197,
    "2025-05-04": 222.13869651796296,
    "2025-05-05": 224.42128743972893,
    "2025-05-06": 226.7038783614949,
    "2025-05-07": 228.98646928326085,
    "2025-05-08": 231.2690602050268,
    "2025-05-09": 233.5516511267928,
    "2025-05-10": 235.83424204855876,
    "2025-05-11": 238.1168329703247,
    "2025-05-12": 240.39942389209065,
    "2025-05-13": 242.68201481385665,
    "2025-05-14": 244.96460573562257,
    "2025-05-15": 247.2471966573885,
    "2025-05-16": 249.5297875791545,
    "2025-05-17": 251.8123785009205,
    "2025-05-18": 254.09496942268643,
    "2025-05-19": 256.3775603444524,
    "2025-05-20": 258.66015126621835,
    "2025-05-21": 260.9427421879843,
    "2025-05-22": 263.2253331097503,
    "2025-05-23": 265.50792403151627,
    "2025-05-24": 267.7905149532822,
    "2025-05-25": 270.07310587504816,
    "2025-05-26": 272.35569679681413,
    "2025-05-27": 274.6382877185801,
    "2025-05-28": 276.920878640346,
    "2025-05-29": 279.203469562112,
    "2025-05-30": 281.486060483878,
    "2025-05-31": 283.76865140564394,
    "2025-06-01": 285.98960752136657,
    "2025-06-02": 288.21056363708925,
    "2025-06-03": 290.4315197528119,
    "2025-06-04": 292.65247586853457,
    "2025-06-05": 294.8734319842572,
    "2025-06-06": 297.0943880999799,
    "2025-06-07": 299.3153442157025,
    "2025-06-08": 301.5363003314252,
    "2025-06-09": 303.7572564471478,
    "2025-06-10": 305.9782125628705,
    "2025-06-11": 308.19916867859314,
    "2025-06-12": 310.4201247943158,
    "2025-06-13": 312.64108091003845,
    "2025-06-14": 314.86203702576114,
    "2025-06-15": 317.08299314148377,
    "2025-06-16": 319.30394925720645,
    "2025-06-17": 321.5249053729291,
    "2025-06-18": 323.7458614886517,
    "2025-06-19": 325.9668176043744,
    "2025-06-20": 328.187773720097,
    "2025-06-21": 330.4087298358197,
    "2025-06-22": 332.62968595154234,
    "2025-06-23": 334.850642067265,
    "2025-06-24": 337.07159818298766,
    "2025-06-25": 339.29255429871034,
    "2025-06-26": 341.513510414433,
    "2025-06-27": 343.73446653015566,
    "2025-06-28": 345.9554226458783,
    "2025-06-29": 348.176378761601,
    "2025-06-30": 350.3973348773236,
    "2025-07-01": 352.6847637024559,
    "2025-07-02": 354.9721925275882,
    "2025-07-03": 357.2596213527205,
    "2025-07-04": 359.54705017785284,
    "2025-07-05": 361.8344790029851,
    "2025-07-06": 364.1219078281175,
    "2025-07-07": 366.40933665324974,
    "2025-07-08": 368.6967654783821,
    "2025-07-09": 370.9841943035144,
    "2025-07-10": 373.2716231286467,
    "2025-07-11": 375.559051953779,
    "2025-07-12": 377.8464807789113,
    "2025-07-13": 380.1339096040436,
    "2025-07-14": 382.42133842917593,
    "2025-07-15": 384.7087672543082,
    "2025-07-16": 386.99619607944055,
    "2025-07-17": 389.2836249045728,
    "2025-07-18": 391.5710537297052,
    "2025-07-19": 393.8584825548375,
    "2025-07-20": 396.1459113799698,
    "2025-07-21": 398.43334020510207,
    "2025-07-22": 400.7207690302344,
    "2025-07-23": 403.0081978553667,
    "2025-07-24": 405.295626680499,
    "2025-07-25": 407.5830555056313,
    "2025-07-26": 409.8704843307637,
    "2025-07-27": 412.1579131558959,
    "2025-07-28": 414.44534198102826,
    "2025-07-29": 416.7327708061605,
    "2025-07-30": 419.0201996312928,
    "2025-07-31": 421.3076284564252,
    "2025-08-01": 423.106512748088,
    "2025-08-02": 424.9053970397509,
    "2025-08-03": 426.7042813314137,
    "2025-08-04": 428.5031656230765,
    "2025-08-05": 430.3020499147394,
    "2025-08-06": 432.1009342064023,
    "2025-08-07": 433.8998184980651,
    "2025-08-08": 435.698702789728,
    "2025-08-09": 437.4975870813908,
    "2025-08-10": 439.2964713730536,
    "2025-08-11": 441.0953556647165,
    "2025-08-12": 442.89423995637935,
    "2025-08-13": 444.6931242480422,
    "2025-08-14": 446.49200853970507,
    "2025-08-15": 448.2908928313679,
    "2025-08-16": 450.08977712303073,
    "2025-08-17": 451.8886614146936,
    "2025-08-18": 453.6875457063565,
    "2025-08-19": 455.4864299980193,
    "2025-08-20": 457.2853142896821,
    "2025-08-21": 459.084198581345,
    "2025-08-22": 460.8830828730078,
    "2025-08-23": 462.6819671646707,
    "2025-08-24": 464.4808514563336,
    "2025-08-25": 466.2797357479964,
    "2025-08-26": 468.0786200396592,
    "2025-08-27": 469.8775043313221,
    "2025-08-28": 471.6763886229849,
    "2025-08-29": 473.47527291464775,
    "2025-08-30": 475.2741572063106,
    "2025-08-31": 477.0730414979735,
    "2025-09-01": 478.4141917706197,
    "2025-09-02": 479.755342043266,
    "2025-09-03": 481.09649231591226,
    "2025-09-04": 482.4376425885585,
    "2025-09-05": 483.7787928612048,
    "2025-09-06": 485.1199431338511,
    "2025-09-07": 486.4610934064973,
    "2025-09-08": 487.8022436791436,
    "2025-09-09": 489.14339395178985,
    "2025-09-10": 490.4845442244361,
    "2025-09-11": 491.8256944970824,
    "2025-09-12": 493.16684476972864,
    "2025-09-13": 494.5079950423749,
    "2025-09-14": 495.8491453150212,
    "2025-09-15": 497.1902955876674,
    "2025-09-16": 498.5314458603137,
    "2025-09-17": 499.87259613296,
    "2025-09-18": 501.21374640560623,
    "2025-09-19": 502.5548966782525,
    "2025-09-20": 503.8960469508988,
    "2025-09-21": 505.237197223545,
    "2025-09-22": 506.57834749619127,
    "2025-09-23": 507.9194977688376,
    "2025-09-24": 509.2606480414838,
    "2025-09-25": 510.60179831413006,
    "2025-09-26": 511.9429485867764,
    "2025-09-27": 513.2840988594226,
    "2025-09-28": 514.6252491320689,
    "2025-09-29": 515.9663994047152,
    "2025-09-30": 517.3075496773614,
  },
  "Miscellaneous Subtropical Fruits": {
    "2024-10-01": 0.0,
    "2024-10-02": 1.6550535450470751,
    "2024-10-03": 3.3101070900941503,
    "2024-10-04": 4.965160635141226,
    "2024-10-05": 6.6202141801883005,
    "2024-10-06": 8.275267725235375,
    "2024-10-07": 9.930321270282452,
    "2024-10-08": 11.585374815329526,
    "2024-10-09": 13.2404283603766,
    "2024-10-10": 14.895481905423676,
    "2024-10-11": 16.55053545047075,
    "2024-10-12": 18.205588995517825,
    "2024-10-13": 19.860642540564903,
    "2024-10-14": 21.515696085611975,
    "2024-10-15": 23.170749630659053,
    "2024-10-16": 24.825803175706127,
    "2024-10-17": 26.4808567207532,
    "2024-10-18": 28.13591026580028,
    "2024-10-19": 29.79096381084735,
    "2024-10-20": 31.446017355894423,
    "2024-10-21": 33.1010709009415,
    "2024-10-22": 34.756124445988576,
    "2024-10-23": 36.41117799103565,
    "2024-10-24": 38.066231536082725,
    "2024-10-25": 39.72128508112981,
    "2024-10-26": 41.37633862617688,
    "2024-10-27": 43.03139217122396,
    "2024-10-28": 44.68644571627103,
    "2024-10-29": 46.341499261318106,
    "2024-10-30": 47.99655280636518,
    "2024-10-31": 49.651606351412255,
    "2024-11-01": 50.14125363178741,
    "2024-11-02": 50.63090091216258,
    "2024-11-03": 51.12054819253774,
    "2024-11-04": 51.610195472912906,
    "2024-11-05": 52.09984275328807,
    "2024-11-06": 52.58949003366323,
    "2024-11-07": 53.07913731403839,
    "2024-11-08": 53.56878459441356,
    "2024-11-09": 54.05843187478872,
    "2024-11-10": 54.54807915516388,
    "2024-11-11": 55.03772643553904,
    "2024-11-12": 55.52737371591421,
    "2024-11-13": 56.01702099628937,
    "2024-11-14": 56.50666827666453,
    "2024-11-15": 56.99631555703969,
    "2024-11-16": 57.48596283741486,
    "2024-11-17": 57.97561011779002,
    "2024-11-18": 58.46525739816518,
    "2024-11-19": 58.954904678540345,
    "2024-11-20": 59.44455195891551,
    "2024-11-21": 59.93419923929067,
    "2024-11-22": 60.42384651966583,
    "2024-11-23": 60.913493800041,
    "2024-11-24": 61.40314108041616,
    "2024-11-25": 61.89278836079132,
    "2024-11-26": 62.38243564116648,
    "2024-11-27": 62.87208292154165,
    "2024-11-28": 63.36173020191681,
    "2024-11-29": 63.851377482291966,
    "2024-11-30": 64.34102476266713,
    "2024-12-01": 64.6456791730494,
    "2024-12-02": 64.95033358343166,
    "2024-12-03": 65.25498799381393,
    "2024-12-04": 65.5596424041962,
    "2024-12-05": 65.86429681457845,
    "2024-12-06": 66.16895122496072,
    "2024-12-07": 66.47360563534298,
    "2024-12-08": 66.77826004572525,
    "2024-12-09": 67.08291445610752,
    "2024-12-10": 67.38756886648977,
    "2024-12-11": 67.69222327687204,
    "2024-12-12": 67.99687768725431,
    "2024-12-13": 68.30153209763657,
    "2024-12-14": 68.60618650801884,
    "2024-12-15": 68.9108409184011,
    "2024-12-16": 69.21549532878336,
    "2024-12-17": 69.52014973916563,
    "2024-12-18": 69.8248041495479,
    "2024-12-19": 70.12945855993016,
    "2024-12-20": 70.43411297031243,
    "2024-12-21": 70.7387673806947,
    "2024-12-22": 71.04342179107695,
    "2024-12-23": 71.34807620145922,
    "2024-12-24": 71.65273061184149,
    "2024-12-25": 71.95738502222375,
    "2024-12-26": 72.26203943260602,
    "2024-12-27": 72.56669384298827,
    "2024-12-28": 72.87134825337054,
    "2024-12-29": 73.17600266375281,
    "2024-12-30": 73.48065707413507,
    "2024-12-31": 73.78531148451734,
    "2025-01-01": 74.42692559801591,
    "2025-01-02": 75.06853971151449,
    "2025-01-03": 75.71015382501307,
    "2025-01-04": 76.35176793851164,
    "2025-01-05": 76.99338205201022,
    "2025-01-06": 77.6349961655088,
    "2025-01-07": 78.27661027900737,
    "2025-01-08": 78.91822439250595,
    "2025-01-09": 79.55983850600452,
    "2025-01-10": 80.2014526195031,
    "2025-01-11": 80.84306673300168,
    "2025-01-12": 81.48468084650025,
    "2025-01-13": 82.12629495999883,
    "2025-01-14": 82.7679090734974,
    "2025-01-15": 83.40952318699598,
    "2025-01-16": 84.05113730049456,
    "2025-01-17": 84.69275141399314,
    "2025-01-18": 85.33436552749171,
    "2025-01-19": 85.97597964099029,
    "2025-01-20": 86.61759375448887,
    "2025-01-21": 87.25920786798744,
    "2025-01-22": 87.90082198148602,
    "2025-01-23": 88.5424360949846,
    "2025-01-24": 89.18405020848317,
    "2025-01-25": 89.82566432198175,
    "2025-01-26": 90.46727843548032,
    "2025-01-27": 91.1088925489789,
    "2025-01-28": 91.75050666247748,
    "2025-01-29": 92.39212077597604,
    "2025-01-30": 93.03373488947464,
    "2025-01-31": 93.6753490029732,
    "2025-02-01": 94.6808454140697,
    "2025-02-02": 95.68634182516617,
    "2025-02-03": 96.69183823626264,
    "2025-02-04": 97.69733464735914,
    "2025-02-05": 98.70283105845562,
    "2025-02-06": 99.7083274695521,
    "2025-02-07": 100.7138238806486,
    "2025-02-08": 101.71932029174506,
    "2025-02-09": 102.72481670284157,
    "2025-02-10": 103.73031311393802,
    "2025-02-11": 104.73580952503453,
    "2025-02-12": 105.741305936131,
    "2025-02-13": 106.74680234722749,
    "2025-02-14": 107.75229875832396,
    "2025-02-15": 108.75779516942043,
    "2025-02-16": 109.76329158051692,
    "2025-02-17": 110.7687879916134,
    "2025-02-18": 111.7742844027099,
    "2025-02-19": 112.77978081380635,
    "2025-02-20": 113.78527722490286,
    "2025-02-21": 114.79077363599932,
    "2025-02-22": 115.79627004709582,
    "2025-02-23": 116.8017664581923,
    "2025-02-24": 117.8072628692888,
    "2025-02-25": 118.81275928038528,
    "2025-02-26": 119.81825569148177,
    "2025-02-27": 120.82375210257824,
    "2025-02-28": 121.82924851367471,
    "2025-03-01": 122.97809535229426,
    "2025-03-02": 124.1269421909138,
    "2025-03-03": 125.27578902953336,
    "2025-03-04": 126.4246358681529,
    "2025-03-05": 127.57348270677244,
    "2025-03-06": 128.722329545392,
    "2025-03-07": 129.87117638401153,
    "2025-03-08": 131.0200232226311,
    "2025-03-09": 132.16887006125063,
    "2025-03-10": 133.31771689987016,
    "2025-03-11": 134.46656373848973,
    "2025-03-12": 135.61541057710926,
    "2025-03-13": 136.76425741572882,
    "2025-03-14": 137.91310425434835,
    "2025-03-15": 139.06195109296792,
    "2025-03-16": 140.21079793158745,
    "2025-03-17": 141.359644770207,
    "2025-03-18": 142.50849160882655,
    "2025-03-19": 143.6573384474461,
    "2025-03-20": 144.80618528606564,
    "2025-03-21": 145.9550321246852,
    "2025-03-22": 147.10387896330474,
    "2025-03-23": 148.25272580192427,
    "2025-03-24": 149.40157264054383,
    "2025-03-25": 150.55041947916337,
    "2025-03-26": 151.69926631778293,
    "2025-03-27": 152.84811315640246,
    "2025-03-28": 153.99695999502202,
    "2025-03-29": 155.14580683364156,
    "2025-03-30": 156.29465367226112,
    "2025-03-31": 157.44350051088065,
    "2025-04-01": 159.87175067918972,
    "2025-04-02": 162.30000084749878,
    "2025-04-03": 164.72825101580784,
    "2025-04-04": 167.15650118411693,
    "2025-04-05": 169.584751352426,
    "2025-04-06": 172.01300152073506,
    "2025-04-07": 174.44125168904412,
    "2025-04-08": 176.8695018573532,
    "2025-04-09": 179.29775202566225,
    "2025-04-10": 181.7260021939713,
    "2025-04-11": 184.1542523622804,
    "2025-04-12": 186.5825025305895,
    "2025-04-13": 189.01075269889853,
    "2025-04-14": 191.4390028672076,
    "2025-04-15": 193.86725303551663,
    "2025-04-16": 196.2955032038257,
    "2025-04-17": 198.7237533721348,
    "2025-04-18": 201.15200354044384,
    "2025-04-19": 203.5802537087529,
    "2025-04-20": 206.008503877062,
    "2025-04-21": 208.43675404537103,
    "2025-04-22": 210.86500421368007,
    "2025-04-23": 213.2932543819892,
    "2025-04-24": 215.72150455029828,
    "2025-04-25": 218.1497547186073,
    "2025-04-26": 220.5780048869164,
    "2025-04-27": 223.00625505522547,
    "2025-04-28": 225.43450522353453,
    "2025-04-29": 227.8627553918436,
    "2025-04-30": 230.29100556015263,
    "2025-05-01": 232.37867652144277,
    "2025-05-02": 234.4663474827328,
    "2025-05-03": 236.5540184440229,
    "2025-05-04": 238.64168940531297,
    "2025-05-05": 240.72936036660303,
    "2025-05-06": 242.81703132789312,
    "2025-05-07": 244.9047022891832,
    "2025-05-08": 246.9923732504733,
    "2025-05-09": 249.08004421176335,
    "2025-05-10": 251.16771517305344,
    "2025-05-11": 253.25538613434352,
    "2025-05-12": 255.3430570956336,
    "2025-05-13": 257.43072805692367,
    "2025-05-14": 259.51839901821376,
    "2025-05-15": 261.60606997950384,
    "2025-05-16": 263.693740940794,
    "2025-05-17": 265.781411902084,
    "2025-05-18": 267.8690828633741,
    "2025-05-19": 269.95675382466413,
    "2025-05-20": 272.0444247859542,
    "2025-05-21": 274.1320957472443,
    "2025-05-22": 276.2197667085344,
    "2025-05-23": 278.3074376698245,
    "2025-05-24": 280.39510863111457,
    "2025-05-25": 282.48277959240465,
    "2025-05-26": 284.57045055369474,
    "2025-05-27": 286.6581215149848,
    "2025-05-28": 288.74579247627486,
    "2025-05-29": 290.83346343756494,
    "2025-05-30": 292.92113439885503,
    "2025-05-31": 295.0088053601451,
    "2025-06-01": 296.9805381393627,
    "2025-06-02": 298.95227091858027,
    "2025-06-03": 300.92400369779784,
    "2025-06-04": 302.8957364770154,
    "2025-06-05": 304.867469256233,
    "2025-06-06": 306.8392020354506,
    "2025-06-07": 308.8109348146682,
    "2025-06-08": 310.7826675938858,
    "2025-06-09": 312.7544003731033,
    "2025-06-10": 314.7261331523209,
    "2025-06-11": 316.6978659315385,
    "2025-06-12": 318.6695987107561,
    "2025-06-13": 320.64133148997365,
    "2025-06-14": 322.6130642691912,
    "2025-06-15": 324.58479704840886,
    "2025-06-16": 326.55652982762643,
    "2025-06-17": 328.528262606844,
    "2025-06-18": 330.4999953860616,
    "2025-06-19": 332.4717281652792,
    "2025-06-20": 334.44346094449674,
    "2025-06-21": 336.4151937237143,
    "2025-06-22": 338.3869265029319,
    "2025-06-23": 340.35865928214946,
    "2025-06-24": 342.3303920613671,
    "2025-06-25": 344.3021248405846,
    "2025-06-26": 346.27385761980224,
    "2025-06-27": 348.2455903990198,
    "2025-06-28": 350.2173231782374,
    "2025-06-29": 352.18905595745497,
    "2025-06-30": 354.16078873667254,
    "2025-07-01": 356.1734309405321,
    "2025-07-02": 358.1860731443917,
    "2025-07-03": 360.19871534825126,
    "2025-07-04": 362.2113575521108,
    "2025-07-05": 364.2239997559704,
    "2025-07-06": 366.23664195983,
    "2025-07-07": 368.2492841636896,
    "2025-07-08": 370.2619263675491,
    "2025-07-09": 372.2745685714087,
    "2025-07-10": 374.28721077526825,
    "2025-07-11": 376.2998529791278,
    "2025-07-12": 378.3124951829874,
    "2025-07-13": 380.32513738684696,
    "2025-07-14": 382.3377795907065,
    "2025-07-15": 384.3504217945661,
    "2025-07-16": 386.3630639984257,
    "2025-07-17": 388.3757062022852,
    "2025-07-18": 390.3883484061448,
    "2025-07-19": 392.4009906100043,
    "2025-07-20": 394.4136328138639,
    "2025-07-21": 396.4262750177234,
    "2025-07-22": 398.43891722158304,
    "2025-07-23": 400.4515594254426,
    "2025-07-24": 402.4642016293022,
    "2025-07-25": 404.47684383316175,
    "2025-07-26": 406.4894860370213,
    "2025-07-27": 408.5021282408809,
    "2025-07-28": 410.51477044474046,
    "2025-07-29": 412.5274126486,
    "2025-07-30": 414.5400548524596,
    "2025-07-31": 416.5526970563192,
    "2025-08-01": 418.2417896637148,
    "2025-08-02": 419.9308822711104,
    "2025-08-03": 421.61997487850607,
    "2025-08-04": 423.30906748590166,
    "2025-08-05": 424.9981600932973,
    "2025-08-06": 426.6872527006929,
    "2025-08-07": 428.37634530808856,
    "2025-08-08": 430.06543791548415,
    "2025-08-09": 431.7545305228798,
    "2025-08-10": 433.4436231302754,
    "2025-08-11": 435.1327157376711,
    "2025-08-12": 436.8218083450666,
    "2025-08-13": 438.5109009524623,
    "2025-08-14": 440.1999935598579,
    "2025-08-15": 441.8890861672536,
    "2025-08-16": 443.57817877464913,
    "2025-08-17": 445.2672713820448,
    "2025-08-18": 446.9563639894404,
    "2025-08-19": 448.645456596836,
    "2025-08-20": 450.3345492042316,
    "2025-08-21": 452.0236418116273,
    "2025-08-22": 453.71273441902287,
    "2025-08-23": 455.4018270264185,
    "2025-08-24": 457.0909196338141,
    "2025-08-25": 458.78001224120976,
    "2025-08-26": 460.46910484860535,
    "2025-08-27": 462.158197456001,
    "2025-08-28": 463.8472900633966,
    "2025-08-29": 465.53638267079225,
    "2025-08-30": 467.2254752781879,
    "2025-08-31": 468.9145678855835,
    "2025-09-01": 470.32776739198994,
    "2025-09-02": 471.7409668983964,
    "2025-09-03": 473.1541664048028,
    "2025-09-04": 474.5673659112092,
    "2025-09-05": 475.9805654176157,
    "2025-09-06": 477.3937649240221,
    "2025-09-07": 478.8069644304285,
    "2025-09-08": 480.2201639368349,
    "2025-09-09": 481.63336344324136,
    "2025-09-10": 483.0465629496478,
    "2025-09-11": 484.4597624560543,
    "2025-09-12": 485.8729619624607,
    "2025-09-13": 487.2861614688671,
    "2025-09-14": 488.6993609752735,
    "2025-09-15": 490.11256048168,
    "2025-09-16": 491.5257599880864,
    "2025-09-17": 492.9389594944929,
    "2025-09-18": 494.3521590008992,
    "2025-09-19": 495.7653585073057,
    "2025-09-20": 497.1785580137121,
    "2025-09-21": 498.59175752011856,
    "2025-09-22": 500.004957026525,
    "2025-09-23": 501.4181565329314,
    "2025-09-24": 502.8313560393378,
    "2025-09-25": 504.2445555457443,
    "2025-09-26": 505.6577550521507,
    "2025-09-27": 507.0709545585572,
    "2025-09-28": 508.4841540649636,
    "2025-09-29": 509.89735357137,
    "2025-09-30": 511.3105530777764,
  },
  Olives: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.624598038939881,
    "2024-10-03": 3.249196077879762,
    "2024-10-04": 4.873794116819643,
    "2024-10-05": 6.498392155759524,
    "2024-10-06": 8.122990194699405,
    "2024-10-07": 9.747588233639286,
    "2024-10-08": 11.372186272579167,
    "2024-10-09": 12.996784311519049,
    "2024-10-10": 14.62138235045893,
    "2024-10-11": 16.24598038939881,
    "2024-10-12": 17.870578428338693,
    "2024-10-13": 19.49517646727857,
    "2024-10-14": 21.11977450621845,
    "2024-10-15": 22.74437254515833,
    "2024-10-16": 24.368970584098214,
    "2024-10-17": 25.993568623038097,
    "2024-10-18": 27.618166661977977,
    "2024-10-19": 29.24276470091786,
    "2024-10-20": 30.86736273985774,
    "2024-10-21": 32.49196077879762,
    "2024-10-22": 34.116558817737506,
    "2024-10-23": 35.741156856677385,
    "2024-10-24": 37.36575489561727,
    "2024-10-25": 38.99035293455714,
    "2024-10-26": 40.614950973497024,
    "2024-10-27": 42.23954901243691,
    "2024-10-28": 43.86414705137679,
    "2024-10-29": 45.48874509031667,
    "2024-10-30": 47.11334312925655,
    "2024-10-31": 48.73794116819644,
    "2024-11-01": 49.34923416793817,
    "2024-11-02": 49.96052716767991,
    "2024-11-03": 50.57182016742165,
    "2024-11-04": 51.18311316716339,
    "2024-11-05": 51.79440616690513,
    "2024-11-06": 52.40569916664687,
    "2024-11-07": 53.01699216638861,
    "2024-11-08": 53.62828516613034,
    "2024-11-09": 54.23957816587208,
    "2024-11-10": 54.85087116561382,
    "2024-11-11": 55.46216416535556,
    "2024-11-12": 56.073457165097295,
    "2024-11-13": 56.68475016483904,
    "2024-11-14": 57.29604316458077,
    "2024-11-15": 57.90733616432252,
    "2024-11-16": 58.51862916406425,
    "2024-11-17": 59.12992216380599,
    "2024-11-18": 59.74121516354773,
    "2024-11-19": 60.35250816328946,
    "2024-11-20": 60.963801163031206,
    "2024-11-21": 61.57509416277294,
    "2024-11-22": 62.18638716251468,
    "2024-11-23": 62.79768016225642,
    "2024-11-24": 63.40897316199816,
    "2024-11-25": 64.0202661617399,
    "2024-11-26": 64.63155916148163,
    "2024-11-27": 65.24285216122337,
    "2024-11-28": 65.85414516096512,
    "2024-11-29": 66.46543816070685,
    "2024-11-30": 67.07673116044859,
    "2024-12-01": 67.44754801850875,
    "2024-12-02": 67.81836487656892,
    "2024-12-03": 68.18918173462909,
    "2024-12-04": 68.55999859268925,
    "2024-12-05": 68.93081545074942,
    "2024-12-06": 69.30163230880959,
    "2024-12-07": 69.67244916686975,
    "2024-12-08": 70.04326602492992,
    "2024-12-09": 70.41408288299009,
    "2024-12-10": 70.78489974105025,
    "2024-12-11": 71.15571659911042,
    "2024-12-12": 71.52653345717059,
    "2024-12-13": 71.89735031523075,
    "2024-12-14": 72.26816717329092,
    "2024-12-15": 72.63898403135107,
    "2024-12-16": 73.00980088941125,
    "2024-12-17": 73.3806177474714,
    "2024-12-18": 73.75143460553157,
    "2024-12-19": 74.12225146359174,
    "2024-12-20": 74.4930683216519,
    "2024-12-21": 74.86388517971207,
    "2024-12-22": 75.23470203777224,
    "2024-12-23": 75.6055188958324,
    "2024-12-24": 75.97633575389257,
    "2024-12-25": 76.34715261195274,
    "2024-12-26": 76.7179694700129,
    "2024-12-27": 77.08878632807307,
    "2024-12-28": 77.45960318613324,
    "2024-12-29": 77.8304200441934,
    "2024-12-30": 78.20123690225357,
    "2024-12-31": 78.57205376031374,
    "2025-01-01": 79.13400068206516,
    "2025-01-02": 79.69594760381659,
    "2025-01-03": 80.25789452556802,
    "2025-01-04": 80.81984144731946,
    "2025-01-05": 81.38178836907089,
    "2025-01-06": 81.94373529082232,
    "2025-01-07": 82.50568221257375,
    "2025-01-08": 83.06762913432517,
    "2025-01-09": 83.6295760560766,
    "2025-01-10": 84.19152297782803,
    "2025-01-11": 84.75346989957946,
    "2025-01-12": 85.3154168213309,
    "2025-01-13": 85.87736374308233,
    "2025-01-14": 86.43931066483376,
    "2025-01-15": 87.00125758658518,
    "2025-01-16": 87.56320450833661,
    "2025-01-17": 88.12515143008804,
    "2025-01-18": 88.68709835183947,
    "2025-01-19": 89.2490452735909,
    "2025-01-20": 89.81099219534234,
    "2025-01-21": 90.37293911709376,
    "2025-01-22": 90.9348860388452,
    "2025-01-23": 91.49683296059662,
    "2025-01-24": 92.05877988234803,
    "2025-01-25": 92.62072680409948,
    "2025-01-26": 93.18267372585092,
    "2025-01-27": 93.74462064760236,
    "2025-01-28": 94.30656756935376,
    "2025-01-29": 94.8685144911052,
    "2025-01-30": 95.43046141285664,
    "2025-01-31": 95.99240833460806,
    "2025-02-01": 97.00839380465682,
    "2025-02-02": 98.02437927470558,
    "2025-02-03": 99.04036474475436,
    "2025-02-04": 100.05635021480312,
    "2025-02-05": 101.07233568485188,
    "2025-02-06": 102.08832115490064,
    "2025-02-07": 103.1043066249494,
    "2025-02-08": 104.12029209499816,
    "2025-02-09": 105.13627756504692,
    "2025-02-10": 106.1522630350957,
    "2025-02-11": 107.16824850514446,
    "2025-02-12": 108.18423397519322,
    "2025-02-13": 109.20021944524198,
    "2025-02-14": 110.21620491529076,
    "2025-02-15": 111.23219038533952,
    "2025-02-16": 112.24817585538828,
    "2025-02-17": 113.26416132543704,
    "2025-02-18": 114.2801467954858,
    "2025-02-19": 115.29613226553457,
    "2025-02-20": 116.31211773558334,
    "2025-02-21": 117.32810320563208,
    "2025-02-22": 118.34408867568088,
    "2025-02-23": 119.36007414572964,
    "2025-02-24": 120.3760596157784,
    "2025-02-25": 121.39204508582716,
    "2025-02-26": 122.40803055587592,
    "2025-02-27": 123.42401602592469,
    "2025-02-28": 124.44000149597343,
    "2025-03-01": 125.9928400616856,
    "2025-03-02": 127.54567862739778,
    "2025-03-03": 129.09851719310996,
    "2025-03-04": 130.65135575882212,
    "2025-03-05": 132.20419432453428,
    "2025-03-06": 133.75703289024645,
    "2025-03-07": 135.3098714559586,
    "2025-03-08": 136.86271002167078,
    "2025-03-09": 138.41554858738294,
    "2025-03-10": 139.9683871530951,
    "2025-03-11": 141.52122571880727,
    "2025-03-12": 143.0740642845195,
    "2025-03-13": 144.6269028502316,
    "2025-03-14": 146.1797414159438,
    "2025-03-15": 147.73257998165596,
    "2025-03-16": 149.28541854736812,
    "2025-03-17": 150.8382571130803,
    "2025-03-18": 152.39109567879245,
    "2025-03-19": 153.94393424450462,
    "2025-03-20": 155.49677281021678,
    "2025-03-21": 157.04961137592895,
    "2025-03-22": 158.6024499416411,
    "2025-03-23": 160.15528850735328,
    "2025-03-24": 161.70812707306544,
    "2025-03-25": 163.26096563877763,
    "2025-03-26": 164.81380420448977,
    "2025-03-27": 166.36664277020196,
    "2025-03-28": 167.91948133591413,
    "2025-03-29": 169.4723199016263,
    "2025-03-30": 171.02515846733846,
    "2025-03-31": 172.57799703305062,
    "2025-04-01": 174.74158736048005,
    "2025-04-02": 176.9051776879094,
    "2025-04-03": 179.0687680153388,
    "2025-04-04": 181.2323583427682,
    "2025-04-05": 183.3959486701976,
    "2025-04-06": 185.559538997627,
    "2025-04-07": 187.7231293250564,
    "2025-04-08": 189.88671965248577,
    "2025-04-09": 192.0503099799152,
    "2025-04-10": 194.21390030734452,
    "2025-04-11": 196.37749063477395,
    "2025-04-12": 198.54108096220332,
    "2025-04-13": 200.70467128963276,
    "2025-04-14": 202.86826161706213,
    "2025-04-15": 205.0318519444915,
    "2025-04-16": 207.1954422719209,
    "2025-04-17": 209.35903259935031,
    "2025-04-18": 211.5226229267797,
    "2025-04-19": 213.6862132542091,
    "2025-04-20": 215.8498035816385,
    "2025-04-21": 218.01339390906787,
    "2025-04-22": 220.17698423649728,
    "2025-04-23": 222.34057456392668,
    "2025-04-24": 224.50416489135608,
    "2025-04-25": 226.66775521878543,
    "2025-04-26": 228.8313455462149,
    "2025-04-27": 230.99493587364424,
    "2025-04-28": 233.15852620107364,
    "2025-04-29": 235.32211652850305,
    "2025-04-30": 237.4857068559324,
    "2025-05-01": 239.85651697197105,
    "2025-05-02": 242.2273270880096,
    "2025-05-03": 244.59813720404824,
    "2025-05-04": 246.96894732008684,
    "2025-05-05": 249.33975743612544,
    "2025-05-06": 251.71056755216404,
    "2025-05-07": 254.08137766820263,
    "2025-05-08": 256.45218778424123,
    "2025-05-09": 258.82299790027986,
    "2025-05-10": 261.1938080163184,
    "2025-05-11": 263.56461813235705,
    "2025-05-12": 265.9354282483957,
    "2025-05-13": 268.30623836443425,
    "2025-05-14": 270.6770484804729,
    "2025-05-15": 273.04785859651145,
    "2025-05-16": 275.4186687125501,
    "2025-05-17": 277.7894788285887,
    "2025-05-18": 280.16028894462727,
    "2025-05-19": 282.5310990606659,
    "2025-05-20": 284.90190917670446,
    "2025-05-21": 287.2727192927431,
    "2025-05-22": 289.64352940878166,
    "2025-05-23": 292.0143395248203,
    "2025-05-24": 294.3851496408589,
    "2025-05-25": 296.7559597568975,
    "2025-05-26": 299.1267698729361,
    "2025-05-27": 301.49757998897473,
    "2025-05-28": 303.8683901050133,
    "2025-05-29": 306.239200221052,
    "2025-05-30": 308.6100103370905,
    "2025-05-31": 310.9808204531291,
    "2025-06-01": 313.41578135146693,
    "2025-06-02": 315.8507422498047,
    "2025-06-03": 318.2857031481425,
    "2025-06-04": 320.7206640464803,
    "2025-06-05": 323.15562494481804,
    "2025-06-06": 325.59058584315585,
    "2025-06-07": 328.0255467414936,
    "2025-06-08": 330.4605076398314,
    "2025-06-09": 332.8954685381692,
    "2025-06-10": 335.33042943650696,
    "2025-06-11": 337.7653903348448,
    "2025-06-12": 340.2003512331826,
    "2025-06-13": 342.6353121315203,
    "2025-06-14": 345.07027302985813,
    "2025-06-15": 347.50523392819593,
    "2025-06-16": 349.9401948265337,
    "2025-06-17": 352.3751557248715,
    "2025-06-18": 354.81011662320924,
    "2025-06-19": 357.24507752154705,
    "2025-06-20": 359.68003841988485,
    "2025-06-21": 362.1149993182226,
    "2025-06-22": 364.5499602165604,
    "2025-06-23": 366.98492111489816,
    "2025-06-24": 369.419882013236,
    "2025-06-25": 371.85484291157377,
    "2025-06-26": 374.2898038099115,
    "2025-06-27": 376.7247647082493,
    "2025-06-28": 379.15972560658713,
    "2025-06-29": 381.5946865049249,
    "2025-06-30": 384.0296474032627,
    "2025-07-01": 386.60907867910055,
    "2025-07-02": 389.1885099549384,
    "2025-07-03": 391.7679412307763,
    "2025-07-04": 394.3473725066141,
    "2025-07-05": 396.926803782452,
    "2025-07-06": 399.50623505828986,
    "2025-07-07": 402.0856663341277,
    "2025-07-08": 404.6650976099656,
    "2025-07-09": 407.24452888580345,
    "2025-07-10": 409.8239601616413,
    "2025-07-11": 412.4033914374792,
    "2025-07-12": 414.982822713317,
    "2025-07-13": 417.5622539891549,
    "2025-07-14": 420.1416852649928,
    "2025-07-15": 422.7211165408306,
    "2025-07-16": 425.3005478166685,
    "2025-07-17": 427.8799790925064,
    "2025-07-18": 430.45941036834427,
    "2025-07-19": 433.0388416441821,
    "2025-07-20": 435.61827292002,
    "2025-07-21": 438.19770419585785,
    "2025-07-22": 440.7771354716957,
    "2025-07-23": 443.3565667475336,
    "2025-07-24": 445.9359980233714,
    "2025-07-25": 448.5154292992093,
    "2025-07-26": 451.0948605750472,
    "2025-07-27": 453.674291850885,
    "2025-07-28": 456.2537231267229,
    "2025-07-29": 458.8331544025608,
    "2025-07-30": 461.4125856783986,
    "2025-07-31": 463.9920169542365,
    "2025-08-01": 466.1604916317629,
    "2025-08-02": 468.3289663092893,
    "2025-08-03": 470.4974409868157,
    "2025-08-04": 472.66591566434215,
    "2025-08-05": 474.8343903418686,
    "2025-08-06": 477.002865019395,
    "2025-08-07": 479.1713396969214,
    "2025-08-08": 481.3398143744478,
    "2025-08-09": 483.5082890519743,
    "2025-08-10": 485.6767637295007,
    "2025-08-11": 487.8452384070271,
    "2025-08-12": 490.0137130845535,
    "2025-08-13": 492.18218776207993,
    "2025-08-14": 494.3506624396064,
    "2025-08-15": 496.5191371171328,
    "2025-08-16": 498.6876117946592,
    "2025-08-17": 500.8560864721856,
    "2025-08-18": 503.024561149712,
    "2025-08-19": 505.1930358272385,
    "2025-08-20": 507.3615105047649,
    "2025-08-21": 509.5299851822913,
    "2025-08-22": 511.6984598598177,
    "2025-08-23": 513.8669345373442,
    "2025-08-24": 516.0354092148706,
    "2025-08-25": 518.203883892397,
    "2025-08-26": 520.3723585699234,
    "2025-08-27": 522.5408332474498,
    "2025-08-28": 524.7093079249762,
    "2025-08-29": 526.8777826025026,
    "2025-08-30": 529.0462572800291,
    "2025-08-31": 531.2147319575555,
    "2025-09-01": 532.5500133104058,
    "2025-09-02": 533.8852946632562,
    "2025-09-03": 535.2205760161065,
    "2025-09-04": 536.5558573689568,
    "2025-09-05": 537.8911387218071,
    "2025-09-06": 539.2264200746575,
    "2025-09-07": 540.5617014275078,
    "2025-09-08": 541.8969827803581,
    "2025-09-09": 543.2322641332084,
    "2025-09-10": 544.5675454860589,
    "2025-09-11": 545.9028268389092,
    "2025-09-12": 547.2381081917595,
    "2025-09-13": 548.5733895446098,
    "2025-09-14": 549.9086708974602,
    "2025-09-15": 551.2439522503105,
    "2025-09-16": 552.5792336031608,
    "2025-09-17": 553.9145149560112,
    "2025-09-18": 555.2497963088615,
    "2025-09-19": 556.5850776617118,
    "2025-09-20": 557.9203590145621,
    "2025-09-21": 559.2556403674125,
    "2025-09-22": 560.5909217202628,
    "2025-09-23": 561.9262030731131,
    "2025-09-24": 563.2614844259634,
    "2025-09-25": 564.5967657788138,
    "2025-09-26": 565.9320471316641,
    "2025-09-27": 567.2673284845145,
    "2025-09-28": 568.6026098373648,
    "2025-09-29": 569.9378911902152,
    "2025-09-30": 571.2731725430655,
  },
  "Peaches/Nectarines": {
    "2024-10-01": 0.0,
    "2024-10-02": 1.9363682338169643,
    "2024-10-03": 3.8727364676339286,
    "2024-10-04": 5.809104701450893,
    "2024-10-05": 7.745472935267857,
    "2024-10-06": 9.68184116908482,
    "2024-10-07": 11.618209402901789,
    "2024-10-08": 13.55457763671875,
    "2024-10-09": 15.490945870535716,
    "2024-10-10": 17.42731410435268,
    "2024-10-11": 19.36368233816964,
    "2024-10-12": 21.300050571986606,
    "2024-10-13": 23.236418805803574,
    "2024-10-14": 25.172787039620538,
    "2024-10-15": 27.1091552734375,
    "2024-10-16": 29.045523507254465,
    "2024-10-17": 30.98189174107143,
    "2024-10-18": 32.91825997488839,
    "2024-10-19": 34.85462820870536,
    "2024-10-20": 36.79099644252232,
    "2024-10-21": 38.727364676339285,
    "2024-10-22": 40.66373291015625,
    "2024-10-23": 42.60010114397321,
    "2024-10-24": 44.536469377790176,
    "2024-10-25": 46.47283761160715,
    "2024-10-26": 48.40920584542411,
    "2024-10-27": 50.34557407924108,
    "2024-10-28": 52.28194231305804,
    "2024-10-29": 54.218310546875,
    "2024-10-30": 56.15467878069197,
    "2024-10-31": 58.09104701450893,
    "2024-11-01": 58.60888681317032,
    "2024-11-02": 59.1267266118317,
    "2024-11-03": 59.64456641049309,
    "2024-11-04": 60.16240620915448,
    "2024-11-05": 60.68024600781586,
    "2024-11-06": 61.198085806477245,
    "2024-11-07": 61.71592560513863,
    "2024-11-08": 62.23376540380002,
    "2024-11-09": 62.751605202461405,
    "2024-11-10": 63.26944500112279,
    "2024-11-11": 63.787284799784175,
    "2024-11-12": 64.30512459844556,
    "2024-11-13": 64.82296439710694,
    "2024-11-14": 65.34080419576833,
    "2024-11-15": 65.85864399442971,
    "2024-11-16": 66.37648379309111,
    "2024-11-17": 66.8943235917525,
    "2024-11-18": 67.41216339041388,
    "2024-11-19": 67.93000318907526,
    "2024-11-20": 68.44784298773665,
    "2024-11-21": 68.96568278639803,
    "2024-11-22": 69.48352258505942,
    "2024-11-23": 70.0013623837208,
    "2024-11-24": 70.5192021823822,
    "2024-11-25": 71.03704198104359,
    "2024-11-26": 71.55488177970497,
    "2024-11-27": 72.07272157836636,
    "2024-11-28": 72.59056137702774,
    "2024-11-29": 73.10840117568912,
    "2024-11-30": 73.62624097435051,
    "2024-12-01": 73.91589864195454,
    "2024-12-02": 74.20555630955856,
    "2024-12-03": 74.49521397716259,
    "2024-12-04": 74.78487164476662,
    "2024-12-05": 75.07452931237066,
    "2024-12-06": 75.36418697997468,
    "2024-12-07": 75.65384464757871,
    "2024-12-08": 75.94350231518274,
    "2024-12-09": 76.23315998278677,
    "2024-12-10": 76.52281765039079,
    "2024-12-11": 76.81247531799482,
    "2024-12-12": 77.10213298559886,
    "2024-12-13": 77.39179065320289,
    "2024-12-14": 77.68144832080691,
    "2024-12-15": 77.97110598841094,
    "2024-12-16": 78.26076365601497,
    "2024-12-17": 78.550421323619,
    "2024-12-18": 78.84007899122302,
    "2024-12-19": 79.12973665882706,
    "2024-12-20": 79.41939432643109,
    "2024-12-21": 79.70905199403512,
    "2024-12-22": 79.99870966163914,
    "2024-12-23": 80.28836732924317,
    "2024-12-24": 80.5780249968472,
    "2024-12-25": 80.86768266445124,
    "2024-12-26": 81.15734033205526,
    "2024-12-27": 81.44699799965929,
    "2024-12-28": 81.73665566726332,
    "2024-12-29": 82.02631333486735,
    "2024-12-30": 82.31597100247137,
    "2024-12-31": 82.6056286700754,
    "2025-01-01": 83.11159545994175,
    "2025-01-02": 83.61756224980812,
    "2025-01-03": 84.12352903967447,
    "2025-01-04": 84.62949582954083,
    "2025-01-05": 85.13546261940718,
    "2025-01-06": 85.64142940927353,
    "2025-01-07": 86.14739619913989,
    "2025-01-08": 86.65336298900624,
    "2025-01-09": 87.1593297788726,
    "2025-01-10": 87.66529656873895,
    "2025-01-11": 88.1712633586053,
    "2025-01-12": 88.67723014847166,
    "2025-01-13": 89.18319693833801,
    "2025-01-14": 89.68916372820436,
    "2025-01-15": 90.19513051807073,
    "2025-01-16": 90.70109730793708,
    "2025-01-17": 91.20706409780344,
    "2025-01-18": 91.7130308876698,
    "2025-01-19": 92.21899767753614,
    "2025-01-20": 92.7249644674025,
    "2025-01-21": 93.23093125726884,
    "2025-01-22": 93.7368980471352,
    "2025-01-23": 94.24286483700156,
    "2025-01-24": 94.74883162686793,
    "2025-01-25": 95.25479841673427,
    "2025-01-26": 95.76076520660062,
    "2025-01-27": 96.26673199646696,
    "2025-01-28": 96.77269878633334,
    "2025-01-29": 97.27866557619969,
    "2025-01-30": 97.78463236606603,
    "2025-01-31": 98.2905991559324,
    "2025-02-01": 99.04658577348673,
    "2025-02-02": 99.80257239104104,
    "2025-02-03": 100.55855900859537,
    "2025-02-04": 101.31454562614968,
    "2025-02-05": 102.070532243704,
    "2025-02-06": 102.82651886125834,
    "2025-02-07": 103.58250547881264,
    "2025-02-08": 104.33849209636698,
    "2025-02-09": 105.09447871392128,
    "2025-02-10": 105.85046533147562,
    "2025-02-11": 106.60645194902996,
    "2025-02-12": 107.36243856658426,
    "2025-02-13": 108.1184251841386,
    "2025-02-14": 108.8744118016929,
    "2025-02-15": 109.63039841924724,
    "2025-02-16": 110.38638503680156,
    "2025-02-17": 111.14237165435588,
    "2025-02-18": 111.8983582719102,
    "2025-02-19": 112.65434488946453,
    "2025-02-20": 113.41033150701884,
    "2025-02-21": 114.16631812457317,
    "2025-02-22": 114.9223047421275,
    "2025-02-23": 115.6782913596818,
    "2025-02-24": 116.43427797723612,
    "2025-02-25": 117.19026459479043,
    "2025-02-26": 117.94625121234478,
    "2025-02-27": 118.7022378298991,
    "2025-02-28": 119.45822444745342,
    "2025-03-01": 120.84619513472026,
    "2025-03-02": 122.2341658219871,
    "2025-03-03": 123.62213650925396,
    "2025-03-04": 125.01010719652078,
    "2025-03-05": 126.39807788378762,
    "2025-03-06": 127.78604857105448,
    "2025-03-07": 129.17401925832132,
    "2025-03-08": 130.56198994558815,
    "2025-03-09": 131.94996063285498,
    "2025-03-10": 133.33793132012184,
    "2025-03-11": 134.72590200738867,
    "2025-03-12": 136.11387269465553,
    "2025-03-13": 137.50184338192236,
    "2025-03-14": 138.8898140691892,
    "2025-03-15": 140.27778475645604,
    "2025-03-16": 141.6657554437229,
    "2025-03-17": 143.05372613098973,
    "2025-03-18": 144.44169681825656,
    "2025-03-19": 145.82966750552342,
    "2025-03-20": 147.21763819279025,
    "2025-03-21": 148.6056088800571,
    "2025-03-22": 149.99357956732393,
    "2025-03-23": 151.38155025459076,
    "2025-03-24": 152.76952094185762,
    "2025-03-25": 154.15749162912448,
    "2025-03-26": 155.5454623163913,
    "2025-03-27": 156.93343300365814,
    "2025-03-28": 158.321403690925,
    "2025-03-29": 159.70937437819182,
    "2025-03-30": 161.09734506545868,
    "2025-03-31": 162.4853157527255,
    "2025-04-01": 165.17061857957802,
    "2025-04-02": 167.85592140643053,
    "2025-04-03": 170.54122423328303,
    "2025-04-04": 173.22652706013554,
    "2025-04-05": 175.91182988698807,
    "2025-04-06": 178.59713271384055,
    "2025-04-07": 181.2824355406931,
    "2025-04-08": 183.9677383675456,
    "2025-04-09": 186.6530411943981,
    "2025-04-10": 189.3383440212506,
    "2025-04-11": 192.0236468481031,
    "2025-04-12": 194.7089496749556,
    "2025-04-13": 197.39425250180813,
    "2025-04-14": 200.07955532866063,
    "2025-04-15": 202.76485815551317,
    "2025-04-16": 205.45016098236567,
    "2025-04-17": 208.13546380921812,
    "2025-04-18": 210.8207666360707,
    "2025-04-19": 213.5060694629232,
    "2025-04-20": 216.1913722897757,
    "2025-04-21": 218.8766751166282,
    "2025-04-22": 221.5619779434807,
    "2025-04-23": 224.2472807703332,
    "2025-04-24": 226.93258359718573,
    "2025-04-25": 229.61788642403823,
    "2025-04-26": 232.30318925089077,
    "2025-04-27": 234.98849207774327,
    "2025-04-28": 237.67379490459572,
    "2025-04-29": 240.3590977314483,
    "2025-04-30": 243.0444005583008,
    "2025-05-01": 246.3531835079096,
    "2025-05-02": 249.66196645751836,
    "2025-05-03": 252.97074940712716,
    "2025-05-04": 256.2795323567359,
    "2025-05-05": 259.58831530634467,
    "2025-05-06": 262.89709825595344,
    "2025-05-07": 266.2058812055622,
    "2025-05-08": 269.514664155171,
    "2025-05-09": 272.8234471047798,
    "2025-05-10": 276.1322300543886,
    "2025-05-11": 279.44101300399734,
    "2025-05-12": 282.7497959536061,
    "2025-05-13": 286.0585789032149,
    "2025-05-14": 289.36736185282365,
    "2025-05-15": 292.6761448024324,
    "2025-05-16": 295.9849277520412,
    "2025-05-17": 299.29371070165,
    "2025-05-18": 302.6024936512588,
    "2025-05-19": 305.91127660086755,
    "2025-05-20": 309.2200595504763,
    "2025-05-21": 312.5288425000851,
    "2025-05-22": 315.83762544969386,
    "2025-05-23": 319.14640839930263,
    "2025-05-24": 322.4551913489114,
    "2025-05-25": 325.76397429852017,
    "2025-05-26": 329.07275724812894,
    "2025-05-27": 332.38154019773776,
    "2025-05-28": 335.6903231473465,
    "2025-05-29": 338.9991060969553,
    "2025-05-30": 342.30788904656407,
    "2025-05-31": 345.61667199617284,
    "2025-06-01": 349.67284869687643,
    "2025-06-02": 353.72902539758,
    "2025-06-03": 357.7852020982836,
    "2025-06-04": 361.8413787989872,
    "2025-06-05": 365.8975554996907,
    "2025-06-06": 369.9537322003943,
    "2025-06-07": 374.0099089010979,
    "2025-06-08": 378.0660856018015,
    "2025-06-09": 382.1222623025051,
    "2025-06-10": 386.1784390032087,
    "2025-06-11": 390.23461570391225,
    "2025-06-12": 394.29079240461584,
    "2025-06-13": 398.3469691053194,
    "2025-06-14": 402.403145806023,
    "2025-06-15": 406.4593225067266,
    "2025-06-16": 410.5154992074301,
    "2025-06-17": 414.5716759081338,
    "2025-06-18": 418.6278526088373,
    "2025-06-19": 422.6840293095409,
    "2025-06-20": 426.7402060102445,
    "2025-06-21": 430.7963827109481,
    "2025-06-22": 434.85255941165167,
    "2025-06-23": 438.90873611235526,
    "2025-06-24": 442.9649128130589,
    "2025-06-25": 447.0210895137624,
    "2025-06-26": 451.077266214466,
    "2025-06-27": 455.1334429151696,
    "2025-06-28": 459.1896196158732,
    "2025-06-29": 463.24579631657673,
    "2025-06-30": 467.3019730172803,
    "2025-07-01": 471.8372478334623,
    "2025-07-02": 476.3725226496443,
    "2025-07-03": 480.9077974658263,
    "2025-07-04": 485.44307228200825,
    "2025-07-05": 489.9783470981903,
    "2025-07-06": 494.51362191437227,
    "2025-07-07": 499.0488967305543,
    "2025-07-08": 503.5841715467362,
    "2025-07-09": 508.1194463629182,
    "2025-07-10": 512.6547211791002,
    "2025-07-11": 517.1899959952822,
    "2025-07-12": 521.7252708114642,
    "2025-07-13": 526.2605456276461,
    "2025-07-14": 530.7958204438281,
    "2025-07-15": 535.3310952600101,
    "2025-07-16": 539.8663700761921,
    "2025-07-17": 544.4016448923741,
    "2025-07-18": 548.936919708556,
    "2025-07-19": 553.472194524738,
    "2025-07-20": 558.0074693409201,
    "2025-07-21": 562.5427441571021,
    "2025-07-22": 567.0780189732841,
    "2025-07-23": 571.6132937894661,
    "2025-07-24": 576.148568605648,
    "2025-07-25": 580.68384342183,
    "2025-07-26": 585.219118238012,
    "2025-07-27": 589.754393054194,
    "2025-07-28": 594.289667870376,
    "2025-07-29": 598.824942686558,
    "2025-07-30": 603.3602175027399,
    "2025-07-31": 607.8954923189219,
    "2025-08-01": 611.6224933426216,
    "2025-08-02": 615.3494943663213,
    "2025-08-03": 619.076495390021,
    "2025-08-04": 622.8034964137207,
    "2025-08-05": 626.5304974374204,
    "2025-08-06": 630.2574984611201,
    "2025-08-07": 633.9844994848198,
    "2025-08-08": 637.7115005085196,
    "2025-08-09": 641.4385015322193,
    "2025-08-10": 645.165502555919,
    "2025-08-11": 648.8925035796187,
    "2025-08-12": 652.6195046033184,
    "2025-08-13": 656.3465056270181,
    "2025-08-14": 660.0735066507178,
    "2025-08-15": 663.8005076744175,
    "2025-08-16": 667.5275086981172,
    "2025-08-17": 671.2545097218169,
    "2025-08-18": 674.9815107455166,
    "2025-08-19": 678.7085117692163,
    "2025-08-20": 682.435512792916,
    "2025-08-21": 686.1625138166157,
    "2025-08-22": 689.8895148403155,
    "2025-08-23": 693.6165158640151,
    "2025-08-24": 697.3435168877149,
    "2025-08-25": 701.0705179114146,
    "2025-08-26": 704.7975189351143,
    "2025-08-27": 708.524519958814,
    "2025-08-28": 712.2515209825137,
    "2025-08-29": 715.9785220062134,
    "2025-08-30": 719.7055230299131,
    "2025-08-31": 723.4325240536128,
    "2025-09-01": 726.161140781554,
    "2025-09-02": 728.8897575094952,
    "2025-09-03": 731.6183742374363,
    "2025-09-04": 734.3469909653776,
    "2025-09-05": 737.0756076933187,
    "2025-09-06": 739.8042244212598,
    "2025-09-07": 742.5328411492011,
    "2025-09-08": 745.2614578771422,
    "2025-09-09": 747.9900746050835,
    "2025-09-10": 750.7186913330246,
    "2025-09-11": 753.4473080609657,
    "2025-09-12": 756.175924788907,
    "2025-09-13": 758.9045415168481,
    "2025-09-14": 761.6331582447893,
    "2025-09-15": 764.3617749727305,
    "2025-09-16": 767.0903917006716,
    "2025-09-17": 769.8190084286128,
    "2025-09-18": 772.547625156554,
    "2025-09-19": 775.2762418844952,
    "2025-09-20": 778.0048586124364,
    "2025-09-21": 780.7334753403775,
    "2025-09-22": 783.4620920683187,
    "2025-09-23": 786.1907087962599,
    "2025-09-24": 788.919325524201,
    "2025-09-25": 791.6479422521422,
    "2025-09-26": 794.3765589800834,
    "2025-09-27": 797.1051757080246,
    "2025-09-28": 799.8337924359657,
    "2025-09-29": 802.562409163907,
    "2025-09-30": 805.2910258918481,
  },
  Pears: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.031210441541372,
    "2024-10-03": 4.062420883082743,
    "2024-10-04": 6.0936313246241145,
    "2024-10-05": 8.124841766165487,
    "2024-10-06": 10.15605220770686,
    "2024-10-07": 12.187262649248227,
    "2024-10-08": 14.2184730907896,
    "2024-10-09": 16.249683532330973,
    "2024-10-10": 18.280893973872345,
    "2024-10-11": 20.31210441541372,
    "2024-10-12": 22.34331485695509,
    "2024-10-13": 24.374525298496454,
    "2024-10-14": 26.40573574003783,
    "2024-10-15": 28.4369461815792,
    "2024-10-16": 30.46815662312057,
    "2024-10-17": 32.499367064661946,
    "2024-10-18": 34.530577506203315,
    "2024-10-19": 36.56178794774469,
    "2024-10-20": 38.59299838928606,
    "2024-10-21": 40.62420883082744,
    "2024-10-22": 42.6554192723688,
    "2024-10-23": 44.68662971391018,
    "2024-10-24": 46.71784015545155,
    "2024-10-25": 48.74905059699292,
    "2024-10-26": 50.78026103853429,
    "2024-10-27": 52.81147148007566,
    "2024-10-28": 54.84268192161704,
    "2024-10-29": 56.8738923631584,
    "2024-10-30": 58.90510280469978,
    "2024-10-31": 60.93631324624116,
    "2024-11-01": 61.53054724113401,
    "2024-11-02": 62.124781236026855,
    "2024-11-03": 62.71901523091971,
    "2024-11-04": 63.31324922581256,
    "2024-11-05": 63.90748322070541,
    "2024-11-06": 64.50171721559826,
    "2024-11-07": 65.09595121049111,
    "2024-11-08": 65.69018520538397,
    "2024-11-09": 66.28441920027682,
    "2024-11-10": 66.87865319516966,
    "2024-11-11": 67.47288719006252,
    "2024-11-12": 68.06712118495537,
    "2024-11-13": 68.66135517984821,
    "2024-11-14": 69.25558917474108,
    "2024-11-15": 69.84982316963392,
    "2024-11-16": 70.44405716452677,
    "2024-11-17": 71.03829115941963,
    "2024-11-18": 71.63252515431248,
    "2024-11-19": 72.22675914920532,
    "2024-11-20": 72.82099314409818,
    "2024-11-21": 73.41522713899103,
    "2024-11-22": 74.00946113388387,
    "2024-11-23": 74.60369512877674,
    "2024-11-24": 75.19792912366958,
    "2024-11-25": 75.79216311856243,
    "2024-11-26": 76.38639711345529,
    "2024-11-27": 76.98063110834813,
    "2024-11-28": 77.574865103241,
    "2024-11-29": 78.16909909813384,
    "2024-11-30": 78.76333309302669,
    "2024-12-01": 79.0666613040561,
    "2024-12-02": 79.36998951508549,
    "2024-12-03": 79.6733177261149,
    "2024-12-04": 79.9766459371443,
    "2024-12-05": 80.27997414817371,
    "2024-12-06": 80.5833023592031,
    "2024-12-07": 80.88663057023251,
    "2024-12-08": 81.18995878126191,
    "2024-12-09": 81.49328699229132,
    "2024-12-10": 81.79661520332071,
    "2024-12-11": 82.09994341435012,
    "2024-12-12": 82.40327162537953,
    "2024-12-13": 82.70659983640893,
    "2024-12-14": 83.00992804743834,
    "2024-12-15": 83.31325625846773,
    "2024-12-16": 83.61658446949714,
    "2024-12-17": 83.91991268052654,
    "2024-12-18": 84.22324089155595,
    "2024-12-19": 84.52656910258534,
    "2024-12-20": 84.82989731361475,
    "2024-12-21": 85.13322552464416,
    "2024-12-22": 85.43655373567356,
    "2024-12-23": 85.73988194670297,
    "2024-12-24": 86.04321015773236,
    "2024-12-25": 86.34653836876177,
    "2024-12-26": 86.64986657979117,
    "2024-12-27": 86.95319479082058,
    "2024-12-28": 87.25652300184997,
    "2024-12-29": 87.55985121287938,
    "2024-12-30": 87.86317942390878,
    "2024-12-31": 88.16650763493818,
    "2025-01-01": 88.63107521603109,
    "2025-01-02": 89.095642797124,
    "2025-01-03": 89.56021037821691,
    "2025-01-04": 90.02477795930982,
    "2025-01-05": 90.48934554040272,
    "2025-01-06": 90.95391312149565,
    "2025-01-07": 91.41848070258854,
    "2025-01-08": 91.88304828368145,
    "2025-01-09": 92.34761586477434,
    "2025-01-10": 92.81218344586723,
    "2025-01-11": 93.27675102696016,
    "2025-01-12": 93.74131860805306,
    "2025-01-13": 94.20588618914596,
    "2025-01-14": 94.67045377023888,
    "2025-01-15": 95.1350213513318,
    "2025-01-16": 95.5995889324247,
    "2025-01-17": 96.0641565135176,
    "2025-01-18": 96.52872409461052,
    "2025-01-19": 96.99329167570342,
    "2025-01-20": 97.45785925679633,
    "2025-01-21": 97.92242683788923,
    "2025-01-22": 98.38699441898214,
    "2025-01-23": 98.85156200007503,
    "2025-01-24": 99.31612958116794,
    "2025-01-25": 99.78069716226084,
    "2025-01-26": 100.24526474335376,
    "2025-01-27": 100.70983232444668,
    "2025-01-28": 101.17439990553956,
    "2025-01-29": 101.63896748663248,
    "2025-01-30": 102.1035350677254,
    "2025-01-31": 102.5681026488183,
    "2025-02-01": 103.2699873926562,
    "2025-02-02": 103.97187213649408,
    "2025-02-03": 104.67375688033196,
    "2025-02-04": 105.37564162416986,
    "2025-02-05": 106.07752636800775,
    "2025-02-06": 106.77941111184565,
    "2025-02-07": 107.48129585568353,
    "2025-02-08": 108.18318059952142,
    "2025-02-09": 108.88506534335932,
    "2025-02-10": 109.5869500871972,
    "2025-02-11": 110.2888348310351,
    "2025-02-12": 110.990719574873,
    "2025-02-13": 111.69260431871088,
    "2025-02-14": 112.39448906254876,
    "2025-02-15": 113.09637380638668,
    "2025-02-16": 113.79825855022456,
    "2025-02-17": 114.50014329406244,
    "2025-02-18": 115.20202803790032,
    "2025-02-19": 115.90391278173824,
    "2025-02-20": 116.60579752557612,
    "2025-02-21": 117.30768226941402,
    "2025-02-22": 118.0095670132519,
    "2025-02-23": 118.7114517570898,
    "2025-02-24": 119.41333650092768,
    "2025-02-25": 120.11522124476558,
    "2025-02-26": 120.81710598860346,
    "2025-02-27": 121.51899073244137,
    "2025-02-28": 122.22087547627925,
    "2025-03-01": 123.45141108993352,
    "2025-03-02": 124.6819467035878,
    "2025-03-03": 125.91248231724208,
    "2025-03-04": 127.14301793089636,
    "2025-03-05": 128.37355354455062,
    "2025-03-06": 129.60408915820489,
    "2025-03-07": 130.83462477185915,
    "2025-03-08": 132.06516038551345,
    "2025-03-09": 133.29569599916772,
    "2025-03-10": 134.526231612822,
    "2025-03-11": 135.75676722647626,
    "2025-03-12": 136.98730284013052,
    "2025-03-13": 138.21783845378482,
    "2025-03-14": 139.4483740674391,
    "2025-03-15": 140.67890968109336,
    "2025-03-16": 141.90944529474763,
    "2025-03-17": 143.1399809084019,
    "2025-03-18": 144.37051652205616,
    "2025-03-19": 145.60105213571046,
    "2025-03-20": 146.83158774936473,
    "2025-03-21": 148.062123363019,
    "2025-03-22": 149.29265897667327,
    "2025-03-23": 150.5231945903275,
    "2025-03-24": 151.75373020398183,
    "2025-03-25": 152.9842658176361,
    "2025-03-26": 154.21480143129037,
    "2025-03-27": 155.44533704494464,
    "2025-03-28": 156.6758726585989,
    "2025-03-29": 157.9064082722532,
    "2025-03-30": 159.13694388590747,
    "2025-03-31": 160.36747949956174,
    "2025-04-01": 162.83318705906922,
    "2025-04-02": 165.29889461857672,
    "2025-04-03": 167.7646021780842,
    "2025-04-04": 170.2303097375917,
    "2025-04-05": 172.6960172970992,
    "2025-04-06": 175.1617248566067,
    "2025-04-07": 177.62743241611415,
    "2025-04-08": 180.09313997562168,
    "2025-04-09": 182.5588475351292,
    "2025-04-10": 185.02455509463667,
    "2025-04-11": 187.49026265414412,
    "2025-04-12": 189.95597021365165,
    "2025-04-13": 192.42167777315916,
    "2025-04-14": 194.8873853326666,
    "2025-04-15": 197.3530928921741,
    "2025-04-16": 199.8188004516816,
    "2025-04-17": 202.2845080111891,
    "2025-04-18": 204.75021557069655,
    "2025-04-19": 207.2159231302041,
    "2025-04-20": 209.6816306897116,
    "2025-04-21": 212.14733824921908,
    "2025-04-22": 214.61304580872653,
    "2025-04-23": 217.0787533682341,
    "2025-04-24": 219.54446092774157,
    "2025-04-25": 222.01016848724905,
    "2025-04-26": 224.47587604675653,
    "2025-04-27": 226.94158360626403,
    "2025-04-28": 229.4072911657715,
    "2025-04-29": 231.872998725279,
    "2025-04-30": 234.3387062847865,
    "2025-05-01": 237.20412782062843,
    "2025-05-02": 240.0695493564704,
    "2025-05-03": 242.9349708923123,
    "2025-05-04": 245.80039242815425,
    "2025-05-05": 248.66581396399613,
    "2025-05-06": 251.5312354998381,
    "2025-05-07": 254.39665703568,
    "2025-05-08": 257.26207857152195,
    "2025-05-09": 260.12750010736386,
    "2025-05-10": 262.9929216432058,
    "2025-05-11": 265.8583431790477,
    "2025-05-12": 268.7237647148896,
    "2025-05-13": 271.5891862507316,
    "2025-05-14": 274.4546077865735,
    "2025-05-15": 277.32002932241545,
    "2025-05-16": 280.1854508582573,
    "2025-05-17": 283.0508723940993,
    "2025-05-18": 285.9162939299412,
    "2025-05-19": 288.7817154657832,
    "2025-05-20": 291.6471370016251,
    "2025-05-21": 294.51255853746704,
    "2025-05-22": 297.37798007330895,
    "2025-05-23": 300.24340160915085,
    "2025-05-24": 303.1088231449928,
    "2025-05-25": 305.9742446808347,
    "2025-05-26": 308.8396662166767,
    "2025-05-27": 311.7050877525186,
    "2025-05-28": 314.57050928836054,
    "2025-05-29": 317.43593082420244,
    "2025-05-30": 320.30135236004435,
    "2025-05-31": 323.1667738958863,
    "2025-06-01": 326.47374811791263,
    "2025-06-02": 329.780722339939,
    "2025-06-03": 333.08769656196534,
    "2025-06-04": 336.39467078399167,
    "2025-06-05": 339.70164500601805,
    "2025-06-06": 343.0086192280444,
    "2025-06-07": 346.3155934500707,
    "2025-06-08": 349.6225676720971,
    "2025-06-09": 352.9295418941234,
    "2025-06-10": 356.23651611614974,
    "2025-06-11": 359.5434903381761,
    "2025-06-12": 362.85046456020245,
    "2025-06-13": 366.1574387822288,
    "2025-06-14": 369.4644130042552,
    "2025-06-15": 372.7713872262815,
    "2025-06-16": 376.0783614483078,
    "2025-06-17": 379.3853356703342,
    "2025-06-18": 382.6923098923605,
    "2025-06-19": 385.99928411438685,
    "2025-06-20": 389.3062583364133,
    "2025-06-21": 392.6132325584396,
    "2025-06-22": 395.920206780466,
    "2025-06-23": 399.2271810024923,
    "2025-06-24": 402.5341552245186,
    "2025-06-25": 405.841129446545,
    "2025-06-26": 409.1481036685713,
    "2025-06-27": 412.4550778905976,
    "2025-06-28": 415.762052112624,
    "2025-06-29": 419.0690263346504,
    "2025-06-30": 422.3760005566767,
    "2025-07-01": 426.0269882526524,
    "2025-07-02": 429.6779759486281,
    "2025-07-03": 433.3289636446038,
    "2025-07-04": 436.9799513405795,
    "2025-07-05": 440.6309390365552,
    "2025-07-06": 444.2819267325309,
    "2025-07-07": 447.9329144285066,
    "2025-07-08": 451.5839021244823,
    "2025-07-09": 455.234889820458,
    "2025-07-10": 458.8858775164337,
    "2025-07-11": 462.5368652124094,
    "2025-07-12": 466.1878529083851,
    "2025-07-13": 469.8388406043608,
    "2025-07-14": 473.4898283003365,
    "2025-07-15": 477.1408159963122,
    "2025-07-16": 480.7918036922879,
    "2025-07-17": 484.4427913882636,
    "2025-07-18": 488.0937790842393,
    "2025-07-19": 491.744766780215,
    "2025-07-20": 495.3957544761907,
    "2025-07-21": 499.0467421721664,
    "2025-07-22": 502.6977298681421,
    "2025-07-23": 506.3487175641178,
    "2025-07-24": 509.9997052600935,
    "2025-07-25": 513.6506929560692,
    "2025-07-26": 517.3016806520449,
    "2025-07-27": 520.9526683480206,
    "2025-07-28": 524.6036560439964,
    "2025-07-29": 528.254643739972,
    "2025-07-30": 531.9056314359477,
    "2025-07-31": 535.5566191319234,
    "2025-08-01": 539.0240403375055,
    "2025-08-02": 542.4914615430878,
    "2025-08-03": 545.9588827486699,
    "2025-08-04": 549.426303954252,
    "2025-08-05": 552.8937251598342,
    "2025-08-06": 556.3611463654164,
    "2025-08-07": 559.8285675709985,
    "2025-08-08": 563.2959887765807,
    "2025-08-09": 566.7634099821628,
    "2025-08-10": 570.230831187745,
    "2025-08-11": 573.6982523933272,
    "2025-08-12": 577.1656735989093,
    "2025-08-13": 580.6330948044914,
    "2025-08-14": 584.1005160100736,
    "2025-08-15": 587.5679372156558,
    "2025-08-16": 591.0353584212379,
    "2025-08-17": 594.50277962682,
    "2025-08-18": 597.9702008324023,
    "2025-08-19": 601.4376220379844,
    "2025-08-20": 604.9050432435665,
    "2025-08-21": 608.3724644491487,
    "2025-08-22": 611.8398856547309,
    "2025-08-23": 615.307306860313,
    "2025-08-24": 618.7747280658951,
    "2025-08-25": 622.2421492714773,
    "2025-08-26": 625.7095704770595,
    "2025-08-27": 629.1769916826416,
    "2025-08-28": 632.6444128882238,
    "2025-08-29": 636.111834093806,
    "2025-08-30": 639.5792552993881,
    "2025-08-31": 643.0466765049703,
    "2025-09-01": 645.5366710321513,
    "2025-09-02": 648.0266655593323,
    "2025-09-03": 650.5166600865132,
    "2025-09-04": 653.0066546136942,
    "2025-09-05": 655.4966491408752,
    "2025-09-06": 657.9866436680562,
    "2025-09-07": 660.4766381952372,
    "2025-09-08": 662.9666327224181,
    "2025-09-09": 665.4566272495991,
    "2025-09-10": 667.9466217767801,
    "2025-09-11": 670.4366163039612,
    "2025-09-12": 672.9266108311422,
    "2025-09-13": 675.4166053583231,
    "2025-09-14": 677.9065998855041,
    "2025-09-15": 680.3965944126851,
    "2025-09-16": 682.8865889398661,
    "2025-09-17": 685.3765834670471,
    "2025-09-18": 687.866577994228,
    "2025-09-19": 690.356572521409,
    "2025-09-20": 692.84656704859,
    "2025-09-21": 695.336561575771,
    "2025-09-22": 697.826556102952,
    "2025-09-23": 700.316550630133,
    "2025-09-24": 702.806545157314,
    "2025-09-25": 705.296539684495,
    "2025-09-26": 707.786534211676,
    "2025-09-27": 710.276528738857,
    "2025-09-28": 712.7665232660379,
    "2025-09-29": 715.2565177932189,
    "2025-09-30": 717.7465123203999,
  },
  Pecans: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.796785292282603,
    "2024-10-03": 3.593570584565206,
    "2024-10-04": 5.390355876847809,
    "2024-10-05": 7.187141169130412,
    "2024-10-06": 8.983926461413015,
    "2024-10-07": 10.780711753695618,
    "2024-10-08": 12.57749704597822,
    "2024-10-09": 14.374282338260825,
    "2024-10-10": 16.171067630543426,
    "2024-10-11": 17.96785292282603,
    "2024-10-12": 19.764638215108636,
    "2024-10-13": 21.56142350739124,
    "2024-10-14": 23.35820879967384,
    "2024-10-15": 25.154994091956443,
    "2024-10-16": 26.95177938423905,
    "2024-10-17": 28.74856467652165,
    "2024-10-18": 30.545349968804253,
    "2024-10-19": 32.34213526108685,
    "2024-10-20": 34.13892055336946,
    "2024-10-21": 35.93570584565206,
    "2024-10-22": 37.732491137934666,
    "2024-10-23": 39.52927643021727,
    "2024-10-24": 41.32606172249987,
    "2024-10-25": 43.12284701478247,
    "2024-10-26": 44.91963230706508,
    "2024-10-27": 46.71641759934768,
    "2024-10-28": 48.513202891630286,
    "2024-10-29": 50.309988183912886,
    "2024-10-30": 52.10677347619549,
    "2024-10-31": 53.90355876847809,
    "2024-11-01": 54.51202742240424,
    "2024-11-02": 55.120496076330376,
    "2024-11-03": 55.72896473025652,
    "2024-11-04": 56.33743338418267,
    "2024-11-05": 56.945902038108805,
    "2024-11-06": 57.55437069203495,
    "2024-11-07": 58.162839345961096,
    "2024-11-08": 58.77130799988724,
    "2024-11-09": 59.37977665381338,
    "2024-11-10": 59.988245307739525,
    "2024-11-11": 60.596713961665664,
    "2024-11-12": 61.20518261559181,
    "2024-11-13": 61.81365126951796,
    "2024-11-14": 62.4221199234441,
    "2024-11-15": 63.03058857737024,
    "2024-11-16": 63.639057231296384,
    "2024-11-17": 64.24752588522253,
    "2024-11-18": 64.85599453914867,
    "2024-11-19": 65.4644631930748,
    "2024-11-20": 66.07293184700096,
    "2024-11-21": 66.6814005009271,
    "2024-11-22": 67.28986915485324,
    "2024-11-23": 67.89833780877939,
    "2024-11-24": 68.50680646270553,
    "2024-11-25": 69.11527511663166,
    "2024-11-26": 69.72374377055782,
    "2024-11-27": 70.33221242448396,
    "2024-11-28": 70.94068107841011,
    "2024-11-29": 71.54914973233625,
    "2024-11-30": 72.15761838626239,
    "2024-12-01": 72.46089056747886,
    "2024-12-02": 72.76416274869533,
    "2024-12-03": 73.0674349299118,
    "2024-12-04": 73.37070711112828,
    "2024-12-05": 73.67397929234475,
    "2024-12-06": 73.97725147356122,
    "2024-12-07": 74.2805236547777,
    "2024-12-08": 74.58379583599417,
    "2024-12-09": 74.88706801721064,
    "2024-12-10": 75.19034019842711,
    "2024-12-11": 75.49361237964358,
    "2024-12-12": 75.79688456086006,
    "2024-12-13": 76.10015674207654,
    "2024-12-14": 76.403428923293,
    "2024-12-15": 76.70670110450948,
    "2024-12-16": 77.00997328572595,
    "2024-12-17": 77.31324546694242,
    "2024-12-18": 77.61651764815889,
    "2024-12-19": 77.91978982937536,
    "2024-12-20": 78.22306201059185,
    "2024-12-21": 78.52633419180832,
    "2024-12-22": 78.82960637302479,
    "2024-12-23": 79.13287855424126,
    "2024-12-24": 79.43615073545773,
    "2024-12-25": 79.7394229166742,
    "2024-12-26": 80.04269509789067,
    "2024-12-27": 80.34596727910716,
    "2024-12-28": 80.64923946032363,
    "2024-12-29": 80.9525116415401,
    "2024-12-30": 81.25578382275657,
    "2024-12-31": 81.55905600397304,
    "2025-01-01": 82.02421935226825,
    "2025-01-02": 82.48938270056344,
    "2025-01-03": 82.95454604885865,
    "2025-01-04": 83.41970939715384,
    "2025-01-05": 83.88487274544904,
    "2025-01-06": 84.35003609374424,
    "2025-01-07": 84.81519944203944,
    "2025-01-08": 85.28036279033464,
    "2025-01-09": 85.74552613862984,
    "2025-01-10": 86.21068948692505,
    "2025-01-11": 86.67585283522024,
    "2025-01-12": 87.14101618351545,
    "2025-01-13": 87.60617953181064,
    "2025-01-14": 88.07134288010585,
    "2025-01-15": 88.53650622840104,
    "2025-01-16": 89.00166957669624,
    "2025-01-17": 89.46683292499144,
    "2025-01-18": 89.93199627328664,
    "2025-01-19": 90.39715962158184,
    "2025-01-20": 90.86232296987704,
    "2025-01-21": 91.32748631817223,
    "2025-01-22": 91.79264966646744,
    "2025-01-23": 92.25781301476265,
    "2025-01-24": 92.72297636305784,
    "2025-01-25": 93.18813971135305,
    "2025-01-26": 93.65330305964824,
    "2025-01-27": 94.11846640794344,
    "2025-01-28": 94.58362975623864,
    "2025-01-29": 95.04879310453384,
    "2025-01-30": 95.51395645282904,
    "2025-01-31": 95.97911980112424,
    "2025-02-01": 96.84465559555711,
    "2025-02-02": 97.71019138999002,
    "2025-02-03": 98.57572718442292,
    "2025-02-04": 99.4412629788558,
    "2025-02-05": 100.30679877328868,
    "2025-02-06": 101.17233456772158,
    "2025-02-07": 102.03787036215446,
    "2025-02-08": 102.90340615658737,
    "2025-02-09": 103.76894195102024,
    "2025-02-10": 104.63447774545314,
    "2025-02-11": 105.50001353988604,
    "2025-02-12": 106.36554933431891,
    "2025-02-13": 107.2310851287518,
    "2025-02-14": 108.0966209231847,
    "2025-02-15": 108.9621567176176,
    "2025-02-16": 109.82769251205048,
    "2025-02-17": 110.69322830648336,
    "2025-02-18": 111.55876410091624,
    "2025-02-19": 112.42429989534917,
    "2025-02-20": 113.28983568978202,
    "2025-02-21": 114.15537148421492,
    "2025-02-22": 115.0209072786478,
    "2025-02-23": 115.8864430730807,
    "2025-02-24": 116.7519788675136,
    "2025-02-25": 117.61751466194649,
    "2025-02-26": 118.48305045637936,
    "2025-02-27": 119.34858625081226,
    "2025-02-28": 120.21412204524516,
    "2025-03-01": 121.52891507194538,
    "2025-03-02": 122.8437080986456,
    "2025-03-03": 124.15850112534584,
    "2025-03-04": 125.47329415204608,
    "2025-03-05": 126.78808717874632,
    "2025-03-06": 128.10288020544655,
    "2025-03-07": 129.41767323214677,
    "2025-03-08": 130.732466258847,
    "2025-03-09": 132.04725928554723,
    "2025-03-10": 133.36205231224747,
    "2025-03-11": 134.67684533894771,
    "2025-03-12": 135.99163836564793,
    "2025-03-13": 137.30643139234817,
    "2025-03-14": 138.62122441904842,
    "2025-03-15": 139.93601744574863,
    "2025-03-16": 141.25081047244888,
    "2025-03-17": 142.5656034991491,
    "2025-03-18": 143.8803965258493,
    "2025-03-19": 145.19518955254958,
    "2025-03-20": 146.5099825792498,
    "2025-03-21": 147.82477560595004,
    "2025-03-22": 149.13956863265025,
    "2025-03-23": 150.4543616593505,
    "2025-03-24": 151.76915468605074,
    "2025-03-25": 153.08394771275096,
    "2025-03-26": 154.3987407394512,
    "2025-03-27": 155.71353376615144,
    "2025-03-28": 157.02832679285166,
    "2025-03-29": 158.3431198195519,
    "2025-03-30": 159.65791284625212,
    "2025-03-31": 160.97270587295236,
    "2025-04-01": 163.4082995616495,
    "2025-04-02": 165.84389325034664,
    "2025-04-03": 168.2794869390438,
    "2025-04-04": 170.71508062774095,
    "2025-04-05": 173.15067431643809,
    "2025-04-06": 175.58626800513522,
    "2025-04-07": 178.0218616938324,
    "2025-04-08": 180.45745538252956,
    "2025-04-09": 182.89304907122667,
    "2025-04-10": 185.3286427599238,
    "2025-04-11": 187.76423644862095,
    "2025-04-12": 190.1998301373181,
    "2025-04-13": 192.63542382601528,
    "2025-04-14": 195.0710175147124,
    "2025-04-15": 197.50661120340956,
    "2025-04-16": 199.9422048921067,
    "2025-04-17": 202.37779858080384,
    "2025-04-18": 204.81339226950095,
    "2025-04-19": 207.24898595819812,
    "2025-04-20": 209.6845796468953,
    "2025-04-21": 212.12017333559243,
    "2025-04-22": 214.5557670242896,
    "2025-04-23": 216.9913607129867,
    "2025-04-24": 219.42695440168387,
    "2025-04-25": 221.862548090381,
    "2025-04-26": 224.29814177907812,
    "2025-04-27": 226.7337354677753,
    "2025-04-28": 229.16932915647243,
    "2025-04-29": 231.6049228451696,
    "2025-04-30": 234.04051653386676,
    "2025-05-01": 236.85897856953184,
    "2025-05-02": 239.67744060519692,
    "2025-05-03": 242.49590264086208,
    "2025-05-04": 245.3143646765272,
    "2025-05-05": 248.1328267121923,
    "2025-05-06": 250.9512887478574,
    "2025-05-07": 253.7697507835225,
    "2025-05-08": 256.5882128191876,
    "2025-05-09": 259.4066748548527,
    "2025-05-10": 262.22513689051783,
    "2025-05-11": 265.04359892618294,
    "2025-05-12": 267.86206096184804,
    "2025-05-13": 270.68052299751315,
    "2025-05-14": 273.49898503317826,
    "2025-05-15": 276.31744706884336,
    "2025-05-16": 279.13590910450847,
    "2025-05-17": 281.9543711401736,
    "2025-05-18": 284.7728331758387,
    "2025-05-19": 287.5912952115038,
    "2025-05-20": 290.4097572471689,
    "2025-05-21": 293.22821928283406,
    "2025-05-22": 296.0466813184992,
    "2025-05-23": 298.8651433541643,
    "2025-05-24": 301.6836053898294,
    "2025-05-25": 304.5020674254945,
    "2025-05-26": 307.3205294611596,
    "2025-05-27": 310.1389914968247,
    "2025-05-28": 312.9574535324898,
    "2025-05-29": 315.7759155681549,
    "2025-05-30": 318.59437760382,
    "2025-05-31": 321.4128396394851,
    "2025-06-01": 324.30667361544147,
    "2025-06-02": 327.20050759139787,
    "2025-06-03": 330.0943415673542,
    "2025-06-04": 332.98817554331055,
    "2025-06-05": 335.88200951926694,
    "2025-06-06": 338.7758434952233,
    "2025-06-07": 341.6696774711796,
    "2025-06-08": 344.563511447136,
    "2025-06-09": 347.4573454230924,
    "2025-06-10": 350.3511793990487,
    "2025-06-11": 353.24501337500504,
    "2025-06-12": 356.13884735096144,
    "2025-06-13": 359.0326813269178,
    "2025-06-14": 361.9265153028741,
    "2025-06-15": 364.82034927883046,
    "2025-06-16": 367.71418325478686,
    "2025-06-17": 370.6080172307432,
    "2025-06-18": 373.50185120669954,
    "2025-06-19": 376.395685182656,
    "2025-06-20": 379.2895191586123,
    "2025-06-21": 382.1833531345686,
    "2025-06-22": 385.07718711052496,
    "2025-06-23": 387.97102108648136,
    "2025-06-24": 390.8648550624377,
    "2025-06-25": 393.7586890383941,
    "2025-06-26": 396.6525230143504,
    "2025-06-27": 399.5463569903068,
    "2025-06-28": 402.4401909662631,
    "2025-06-29": 405.33402494221946,
    "2025-06-30": 408.2278589181759,
    "2025-07-01": 411.77847305150215,
    "2025-07-02": 415.3290871848284,
    "2025-07-03": 418.8797013181547,
    "2025-07-04": 422.43031545148096,
    "2025-07-05": 425.9809295848072,
    "2025-07-06": 429.5315437181335,
    "2025-07-07": 433.0821578514598,
    "2025-07-08": 436.632771984786,
    "2025-07-09": 440.1833861181123,
    "2025-07-10": 443.7340002514386,
    "2025-07-11": 447.2846143847648,
    "2025-07-12": 450.8352285180911,
    "2025-07-13": 454.3858426514174,
    "2025-07-14": 457.93645678474365,
    "2025-07-15": 461.48707091807,
    "2025-07-16": 465.0376850513962,
    "2025-07-17": 468.5882991847225,
    "2025-07-18": 472.1389133180488,
    "2025-07-19": 475.6895274513751,
    "2025-07-20": 479.2401415847013,
    "2025-07-21": 482.7907557180276,
    "2025-07-22": 486.3413698513539,
    "2025-07-23": 489.89198398468017,
    "2025-07-24": 493.4425981180064,
    "2025-07-25": 496.9932122513327,
    "2025-07-26": 500.543826384659,
    "2025-07-27": 504.0944405179852,
    "2025-07-28": 507.6450546513115,
    "2025-07-29": 511.1956687846378,
    "2025-07-30": 514.7462829179641,
    "2025-07-31": 518.2968970512903,
    "2025-08-01": 521.1067212002009,
    "2025-08-02": 523.9165453491116,
    "2025-08-03": 526.7263694980222,
    "2025-08-04": 529.5361936469328,
    "2025-08-05": 532.3460177958434,
    "2025-08-06": 535.1558419447541,
    "2025-08-07": 537.9656660936647,
    "2025-08-08": 540.7754902425753,
    "2025-08-09": 543.585314391486,
    "2025-08-10": 546.3951385403966,
    "2025-08-11": 549.2049626893072,
    "2025-08-12": 552.0147868382178,
    "2025-08-13": 554.8246109871285,
    "2025-08-14": 557.6344351360391,
    "2025-08-15": 560.4442592849497,
    "2025-08-16": 563.2540834338604,
    "2025-08-17": 566.063907582771,
    "2025-08-18": 568.8737317316816,
    "2025-08-19": 571.6835558805922,
    "2025-08-20": 574.4933800295029,
    "2025-08-21": 577.3032041784135,
    "2025-08-22": 580.1130283273241,
    "2025-08-23": 582.9228524762348,
    "2025-08-24": 585.7326766251454,
    "2025-08-25": 588.542500774056,
    "2025-08-26": 591.3523249229665,
    "2025-08-27": 594.1621490718773,
    "2025-08-28": 596.9719732207878,
    "2025-08-29": 599.7817973696984,
    "2025-08-30": 602.5916215186091,
    "2025-08-31": 605.4014456675197,
    "2025-09-01": 607.5223175190409,
    "2025-09-02": 609.643189370562,
    "2025-09-03": 611.7640612220832,
    "2025-09-04": 613.8849330736043,
    "2025-09-05": 616.0058049251255,
    "2025-09-06": 618.1266767766466,
    "2025-09-07": 620.2475486281678,
    "2025-09-08": 622.368420479689,
    "2025-09-09": 624.4892923312101,
    "2025-09-10": 626.6101641827313,
    "2025-09-11": 628.7310360342524,
    "2025-09-12": 630.8519078857736,
    "2025-09-13": 632.9727797372947,
    "2025-09-14": 635.0936515888159,
    "2025-09-15": 637.214523440337,
    "2025-09-16": 639.3353952918582,
    "2025-09-17": 641.4562671433794,
    "2025-09-18": 643.5771389949005,
    "2025-09-19": 645.6980108464217,
    "2025-09-20": 647.8188826979427,
    "2025-09-21": 649.9397545494639,
    "2025-09-22": 652.060626400985,
    "2025-09-23": 654.1814982525062,
    "2025-09-24": 656.3023701040274,
    "2025-09-25": 658.4232419555485,
    "2025-09-26": 660.5441138070697,
    "2025-09-27": 662.6649856585908,
    "2025-09-28": 664.785857510112,
    "2025-09-29": 666.9067293616331,
    "2025-09-30": 669.0276012131543,
  },
  Pistachios: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.34914564984464,
    "2024-10-03": 2.6982912996892803,
    "2024-10-04": 4.04743694953392,
    "2024-10-05": 5.3965825993785606,
    "2024-10-06": 6.745728249223201,
    "2024-10-07": 8.09487389906784,
    "2024-10-08": 9.44401954891248,
    "2024-10-09": 10.79316519875712,
    "2024-10-10": 12.14231084860176,
    "2024-10-11": 13.491456498446402,
    "2024-10-12": 14.840602148291042,
    "2024-10-13": 16.18974779813568,
    "2024-10-14": 17.53889344798032,
    "2024-10-15": 18.88803909782496,
    "2024-10-16": 20.2371847476696,
    "2024-10-17": 21.58633039751424,
    "2024-10-18": 22.935476047358883,
    "2024-10-19": 24.284621697203523,
    "2024-10-20": 25.633767347048163,
    "2024-10-21": 26.982912996892804,
    "2024-10-22": 28.332058646737444,
    "2024-10-23": 29.681204296582084,
    "2024-10-24": 31.030349946426725,
    "2024-10-25": 32.37949559627136,
    "2024-10-26": 33.728641246116005,
    "2024-10-27": 35.07778689596064,
    "2024-10-28": 36.426932545805286,
    "2024-10-29": 37.77607819564992,
    "2024-10-30": 39.12522384549457,
    "2024-10-31": 40.4743694953392,
    "2024-11-01": 40.847023972107294,
    "2024-11-02": 41.219678448875385,
    "2024-11-03": 41.59233292564348,
    "2024-11-04": 41.96498740241157,
    "2024-11-05": 42.337641879179664,
    "2024-11-06": 42.71029635594776,
    "2024-11-07": 43.082950832715845,
    "2024-11-08": 43.45560530948394,
    "2024-11-09": 43.82825978625203,
    "2024-11-10": 44.20091426302013,
    "2024-11-11": 44.573568739788215,
    "2024-11-12": 44.94622321655631,
    "2024-11-13": 45.3188776933244,
    "2024-11-14": 45.69153217009249,
    "2024-11-15": 46.06418664686058,
    "2024-11-16": 46.43684112362868,
    "2024-11-17": 46.80949560039677,
    "2024-11-18": 47.18215007716486,
    "2024-11-19": 47.55480455393296,
    "2024-11-20": 47.92745903070104,
    "2024-11-21": 48.300113507469135,
    "2024-11-22": 48.672767984237225,
    "2024-11-23": 49.04542246100532,
    "2024-11-24": 49.41807693777341,
    "2024-11-25": 49.790731414541504,
    "2024-11-26": 50.1633858913096,
    "2024-11-27": 50.53604036807769,
    "2024-11-28": 50.90869484484578,
    "2024-11-29": 51.281349321613874,
    "2024-11-30": 51.65400379838197,
    "2024-12-01": 51.7155948476671,
    "2024-12-02": 51.77718589695223,
    "2024-12-03": 51.83877694623737,
    "2024-12-04": 51.9003679955225,
    "2024-12-05": 51.96195904480764,
    "2024-12-06": 52.02355009409277,
    "2024-12-07": 52.0851411433779,
    "2024-12-08": 52.14673219266303,
    "2024-12-09": 52.208323241948165,
    "2024-12-10": 52.2699142912333,
    "2024-12-11": 52.33150534051843,
    "2024-12-12": 52.39309638980357,
    "2024-12-13": 52.4546874390887,
    "2024-12-14": 52.51627848837384,
    "2024-12-15": 52.57786953765897,
    "2024-12-16": 52.6394605869441,
    "2024-12-17": 52.70105163622924,
    "2024-12-18": 52.76264268551437,
    "2024-12-19": 52.82423373479951,
    "2024-12-20": 52.88582478408464,
    "2024-12-21": 52.947415833369774,
    "2024-12-22": 53.00900688265491,
    "2024-12-23": 53.07059793194004,
    "2024-12-24": 53.13218898122517,
    "2024-12-25": 53.193780030510304,
    "2024-12-26": 53.25537107979544,
    "2024-12-27": 53.31696212908057,
    "2024-12-28": 53.378553178365706,
    "2024-12-29": 53.44014422765084,
    "2024-12-30": 53.501735276935975,
    "2024-12-31": 53.56332632622111,
    "2025-01-01": 53.98522754553709,
    "2025-01-02": 54.40712876485307,
    "2025-01-03": 54.829029984169054,
    "2025-01-04": 55.25093120348503,
    "2025-01-05": 55.672832422801015,
    "2025-01-06": 56.09473364211699,
    "2025-01-07": 56.516634861432976,
    "2025-01-08": 56.93853608074896,
    "2025-01-09": 57.36043730006494,
    "2025-01-10": 57.78233851938092,
    "2025-01-11": 58.2042397386969,
    "2025-01-12": 58.62614095801288,
    "2025-01-13": 59.04804217732887,
    "2025-01-14": 59.46994339664485,
    "2025-01-15": 59.89184461596083,
    "2025-01-16": 60.313745835276805,
    "2025-01-17": 60.73564705459279,
    "2025-01-18": 61.157548273908766,
    "2025-01-19": 61.57944949322475,
    "2025-01-20": 62.00135071254073,
    "2025-01-21": 62.42325193185671,
    "2025-01-22": 62.845153151172696,
    "2025-01-23": 63.26705437048867,
    "2025-01-24": 63.68895558980466,
    "2025-01-25": 64.11085680912063,
    "2025-01-26": 64.53275802843662,
    "2025-01-27": 64.9546592477526,
    "2025-01-28": 65.37656046706859,
    "2025-01-29": 65.79846168638456,
    "2025-01-30": 66.22036290570054,
    "2025-01-31": 66.64226412501652,
    "2025-02-01": 67.62051712719324,
    "2025-02-02": 68.59877012936994,
    "2025-02-03": 69.57702313154665,
    "2025-02-04": 70.55527613372337,
    "2025-02-05": 71.53352913590008,
    "2025-02-06": 72.51178213807678,
    "2025-02-07": 73.4900351402535,
    "2025-02-08": 74.46828814243021,
    "2025-02-09": 75.44654114460691,
    "2025-02-10": 76.42479414678363,
    "2025-02-11": 77.40304714896034,
    "2025-02-12": 78.38130015113705,
    "2025-02-13": 79.35955315331375,
    "2025-02-14": 80.33780615549047,
    "2025-02-15": 81.31605915766718,
    "2025-02-16": 82.29431215984388,
    "2025-02-17": 83.2725651620206,
    "2025-02-18": 84.25081816419731,
    "2025-02-19": 85.22907116637401,
    "2025-02-20": 86.20732416855073,
    "2025-02-21": 87.18557717072744,
    "2025-02-22": 88.16383017290416,
    "2025-02-23": 89.14208317508086,
    "2025-02-24": 90.12033617725756,
    "2025-02-25": 91.09858917943428,
    "2025-02-26": 92.076842181611,
    "2025-02-27": 93.0550951837877,
    "2025-02-28": 94.0333481859644,
    "2025-03-01": 95.08665715065855,
    "2025-03-02": 96.13996611535268,
    "2025-03-03": 97.19327508004682,
    "2025-03-04": 98.24658404474096,
    "2025-03-05": 99.2998930094351,
    "2025-03-06": 100.35320197412923,
    "2025-03-07": 101.40651093882336,
    "2025-03-08": 102.4598199035175,
    "2025-03-09": 103.51312886821164,
    "2025-03-10": 104.56643783290578,
    "2025-03-11": 105.61974679759992,
    "2025-03-12": 106.67305576229404,
    "2025-03-13": 107.72636472698818,
    "2025-03-14": 108.77967369168232,
    "2025-03-15": 109.83298265637646,
    "2025-03-16": 110.8862916210706,
    "2025-03-17": 111.93960058576472,
    "2025-03-18": 112.99290955045886,
    "2025-03-19": 114.046218515153,
    "2025-03-20": 115.09952747984713,
    "2025-03-21": 116.15283644454126,
    "2025-03-22": 117.2061454092354,
    "2025-03-23": 118.25945437392954,
    "2025-03-24": 119.31276333862368,
    "2025-03-25": 120.36607230331782,
    "2025-03-26": 121.41938126801196,
    "2025-03-27": 122.47269023270609,
    "2025-03-28": 123.52599919740022,
    "2025-03-29": 124.57930816209436,
    "2025-03-30": 125.63261712678847,
    "2025-03-31": 126.68592609148264,
    "2025-04-01": 128.52212959908837,
    "2025-04-02": 130.35833310669412,
    "2025-04-03": 132.19453661429986,
    "2025-04-04": 134.03074012190564,
    "2025-04-05": 135.86694362951138,
    "2025-04-06": 137.70314713711713,
    "2025-04-07": 139.53935064472287,
    "2025-04-08": 141.37555415232862,
    "2025-04-09": 143.21175765993436,
    "2025-04-10": 145.0479611675401,
    "2025-04-11": 146.88416467514588,
    "2025-04-12": 148.72036818275163,
    "2025-04-13": 150.55657169035737,
    "2025-04-14": 152.39277519796312,
    "2025-04-15": 154.22897870556886,
    "2025-04-16": 156.0651822131746,
    "2025-04-17": 157.90138572078035,
    "2025-04-18": 159.73758922838613,
    "2025-04-19": 161.57379273599184,
    "2025-04-20": 163.40999624359762,
    "2025-04-21": 165.24619975120336,
    "2025-04-22": 167.0824032588091,
    "2025-04-23": 168.91860676641485,
    "2025-04-24": 170.7548102740206,
    "2025-04-25": 172.59101378162634,
    "2025-04-26": 174.4272172892321,
    "2025-04-27": 176.26342079683786,
    "2025-04-28": 178.0996243044436,
    "2025-04-29": 179.93582781204935,
    "2025-04-30": 181.7720313196551,
    "2025-05-01": 183.72409995817776,
    "2025-05-02": 185.67616859670045,
    "2025-05-03": 187.6282372352231,
    "2025-05-04": 189.5803058737458,
    "2025-05-05": 191.5323745122685,
    "2025-05-06": 193.48444315079115,
    "2025-05-07": 195.4365117893138,
    "2025-05-08": 197.38858042783647,
    "2025-05-09": 199.3406490663592,
    "2025-05-10": 201.29271770488185,
    "2025-05-11": 203.2447863434045,
    "2025-05-12": 205.1968549819272,
    "2025-05-13": 207.14892362044984,
    "2025-05-14": 209.10099225897247,
    "2025-05-15": 211.0530608974952,
    "2025-05-16": 213.00512953601788,
    "2025-05-17": 214.9571981745405,
    "2025-05-18": 216.9092668130632,
    "2025-05-19": 218.8613354515859,
    "2025-05-20": 220.81340409010855,
    "2025-05-21": 222.76547272863124,
    "2025-05-22": 224.7175413671539,
    "2025-05-23": 226.6696100056766,
    "2025-05-24": 228.62167864419925,
    "2025-05-25": 230.5737472827219,
    "2025-05-26": 232.5258159212446,
    "2025-05-27": 234.4778845597673,
    "2025-05-28": 236.42995319828995,
    "2025-05-29": 238.3820218368126,
    "2025-05-30": 240.3340904753353,
    "2025-05-31": 242.286159113858,
    "2025-06-01": 244.3967505861086,
    "2025-06-02": 246.50734205835928,
    "2025-06-03": 248.6179335306099,
    "2025-06-04": 250.7285250028605,
    "2025-06-05": 252.8391164751112,
    "2025-06-06": 254.94970794736184,
    "2025-06-07": 257.0602994196125,
    "2025-06-08": 259.1708908918631,
    "2025-06-09": 261.28148236411374,
    "2025-06-10": 263.3920738363644,
    "2025-06-11": 265.50266530861506,
    "2025-06-12": 267.6132567808657,
    "2025-06-13": 269.7238482531164,
    "2025-06-14": 271.83443972536696,
    "2025-06-15": 273.9450311976176,
    "2025-06-16": 276.0556226698682,
    "2025-06-17": 278.16621414211886,
    "2025-06-18": 280.27680561436955,
    "2025-06-19": 282.3873970866202,
    "2025-06-20": 284.4979885588708,
    "2025-06-21": 286.60858003112145,
    "2025-06-22": 288.7191715033721,
    "2025-06-23": 290.8297629756228,
    "2025-06-24": 292.9403544478734,
    "2025-06-25": 295.05094592012404,
    "2025-06-26": 297.16153739237467,
    "2025-06-27": 299.2721288646253,
    "2025-06-28": 301.382720336876,
    "2025-06-29": 303.4933118091266,
    "2025-06-30": 305.60390328137726,
    "2025-07-01": 308.35304156997773,
    "2025-07-02": 311.1021798585782,
    "2025-07-03": 313.8513181471787,
    "2025-07-04": 316.6004564357792,
    "2025-07-05": 319.34959472437964,
    "2025-07-06": 322.09873301298006,
    "2025-07-07": 324.84787130158054,
    "2025-07-08": 327.597009590181,
    "2025-07-09": 330.3461478787815,
    "2025-07-10": 333.095286167382,
    "2025-07-11": 335.84442445598245,
    "2025-07-12": 338.5935627445829,
    "2025-07-13": 341.3427010331834,
    "2025-07-14": 344.0918393217839,
    "2025-07-15": 346.8409776103844,
    "2025-07-16": 349.5901158989848,
    "2025-07-17": 352.33925418758525,
    "2025-07-18": 355.08839247618573,
    "2025-07-19": 357.8375307647862,
    "2025-07-20": 360.5866690533867,
    "2025-07-21": 363.3358073419872,
    "2025-07-22": 366.0849456305877,
    "2025-07-23": 368.8340839191881,
    "2025-07-24": 371.5832222077886,
    "2025-07-25": 374.3323604963891,
    "2025-07-26": 377.0814987849896,
    "2025-07-27": 379.83063707359,
    "2025-07-28": 382.5797753621905,
    "2025-07-29": 385.3289136507909,
    "2025-07-30": 388.0780519393914,
    "2025-07-31": 390.8271902279919,
    "2025-08-01": 393.5318892858945,
    "2025-08-02": 396.2365883437971,
    "2025-08-03": 398.94128740169975,
    "2025-08-04": 401.6459864596024,
    "2025-08-05": 404.350685517505,
    "2025-08-06": 407.0553845754076,
    "2025-08-07": 409.7600836333103,
    "2025-08-08": 412.4647826912129,
    "2025-08-09": 415.1694817491155,
    "2025-08-10": 417.87418080701815,
    "2025-08-11": 420.5788798649208,
    "2025-08-12": 423.2835789228234,
    "2025-08-13": 425.988277980726,
    "2025-08-14": 428.6929770386287,
    "2025-08-15": 431.3976760965313,
    "2025-08-16": 434.1023751544339,
    "2025-08-17": 436.8070742123365,
    "2025-08-18": 439.5117732702392,
    "2025-08-19": 442.2164723281418,
    "2025-08-20": 444.9211713860444,
    "2025-08-21": 447.6258704439471,
    "2025-08-22": 450.3305695018497,
    "2025-08-23": 453.0352685597523,
    "2025-08-24": 455.7399676176549,
    "2025-08-25": 458.4446666755576,
    "2025-08-26": 461.1493657334602,
    "2025-08-27": 463.8540647913628,
    "2025-08-28": 466.5587638492655,
    "2025-08-29": 469.2634629071681,
    "2025-08-30": 471.9681619650707,
    "2025-08-31": 474.6728610229733,
    "2025-09-01": 476.66025281922185,
    "2025-09-02": 478.6476446154704,
    "2025-09-03": 480.6350364117189,
    "2025-09-04": 482.62242820796746,
    "2025-09-05": 484.609820004216,
    "2025-09-06": 486.59721180046455,
    "2025-09-07": 488.58460359671307,
    "2025-09-08": 490.5719953929616,
    "2025-09-09": 492.55938718921016,
    "2025-09-10": 494.5467789854587,
    "2025-09-11": 496.5341707817072,
    "2025-09-12": 498.52156257795576,
    "2025-09-13": 500.5089543742043,
    "2025-09-14": 502.4963461704528,
    "2025-09-15": 504.48373796670137,
    "2025-09-16": 506.4711297629499,
    "2025-09-17": 508.4585215591984,
    "2025-09-18": 510.4459133554469,
    "2025-09-19": 512.4333051516954,
    "2025-09-20": 514.420696947944,
    "2025-09-21": 516.4080887441926,
    "2025-09-22": 518.3954805404411,
    "2025-09-23": 520.3828723366896,
    "2025-09-24": 522.3702641329381,
    "2025-09-25": 524.3576559291866,
    "2025-09-26": 526.3450477254352,
    "2025-09-27": 528.3324395216838,
    "2025-09-28": 530.3198313179323,
    "2025-09-29": 532.3072231141808,
    "2025-09-30": 534.2946149104293,
  },
  Plums: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.851335577713816,
    "2024-10-03": 3.702671155427632,
    "2024-10-04": 5.554006733141447,
    "2024-10-05": 7.405342310855263,
    "2024-10-06": 9.25667788856908,
    "2024-10-07": 11.108013466282896,
    "2024-10-08": 12.959349043996712,
    "2024-10-09": 14.810684621710529,
    "2024-10-10": 16.662020199424344,
    "2024-10-11": 18.51335577713816,
    "2024-10-12": 20.36469135485197,
    "2024-10-13": 22.21602693256579,
    "2024-10-14": 24.067362510279604,
    "2024-10-15": 25.918698087993423,
    "2024-10-16": 27.77003366570724,
    "2024-10-17": 29.621369243421054,
    "2024-10-18": 31.47270482113487,
    "2024-10-19": 33.32404039884869,
    "2024-10-20": 35.1753759765625,
    "2024-10-21": 37.02671155427632,
    "2024-10-22": 38.87804713199013,
    "2024-10-23": 40.72938270970395,
    "2024-10-24": 42.58071828741777,
    "2024-10-25": 44.43205386513158,
    "2024-10-26": 46.2833894428454,
    "2024-10-27": 48.13472502055921,
    "2024-10-28": 49.98606059827303,
    "2024-10-29": 51.83739617598685,
    "2024-10-30": 53.68873175370066,
    "2024-10-31": 55.54006733141448,
    "2024-11-01": 56.04878431691251,
    "2024-11-02": 56.55750130241054,
    "2024-11-03": 57.06621828790858,
    "2024-11-04": 57.574935273406616,
    "2024-11-05": 58.08365225890465,
    "2024-11-06": 58.59236924440268,
    "2024-11-07": 59.10108622990072,
    "2024-11-08": 59.60980321539876,
    "2024-11-09": 60.11852020089679,
    "2024-11-10": 60.62723718639482,
    "2024-11-11": 61.135954171892855,
    "2024-11-12": 61.64467115739089,
    "2024-11-13": 62.15338814288893,
    "2024-11-14": 62.66210512838696,
    "2024-11-15": 63.170822113885,
    "2024-11-16": 63.67953909938303,
    "2024-11-17": 64.18825608488106,
    "2024-11-18": 64.6969730703791,
    "2024-11-19": 65.20569005587713,
    "2024-11-20": 65.71440704137517,
    "2024-11-21": 66.22312402687321,
    "2024-11-22": 66.73184101237123,
    "2024-11-23": 67.24055799786927,
    "2024-11-24": 67.74927498336731,
    "2024-11-25": 68.25799196886534,
    "2024-11-26": 68.76670895436338,
    "2024-11-27": 69.2754259398614,
    "2024-11-28": 69.78414292535945,
    "2024-11-29": 70.29285991085749,
    "2024-11-30": 70.80157689635551,
    "2024-12-01": 71.07302386946179,
    "2024-12-02": 71.34447084256807,
    "2024-12-03": 71.61591781567435,
    "2024-12-04": 71.88736478878063,
    "2024-12-05": 72.15881176188691,
    "2024-12-06": 72.43025873499319,
    "2024-12-07": 72.70170570809947,
    "2024-12-08": 72.97315268120575,
    "2024-12-09": 73.24459965431203,
    "2024-12-10": 73.5160466274183,
    "2024-12-11": 73.78749360052458,
    "2024-12-12": 74.05894057363086,
    "2024-12-13": 74.33038754673714,
    "2024-12-14": 74.60183451984342,
    "2024-12-15": 74.8732814929497,
    "2024-12-16": 75.14472846605597,
    "2024-12-17": 75.41617543916226,
    "2024-12-18": 75.68762241226852,
    "2024-12-19": 75.9590693853748,
    "2024-12-20": 76.23051635848108,
    "2024-12-21": 76.50196333158736,
    "2024-12-22": 76.77341030469364,
    "2024-12-23": 77.04485727779992,
    "2024-12-24": 77.3163042509062,
    "2024-12-25": 77.58775122401248,
    "2024-12-26": 77.85919819711876,
    "2024-12-27": 78.13064517022504,
    "2024-12-28": 78.40209214333132,
    "2024-12-29": 78.6735391164376,
    "2024-12-30": 78.94498608954387,
    "2024-12-31": 79.21643306265015,
    "2025-01-01": 79.72243356028494,
    "2025-01-02": 80.22843405791973,
    "2025-01-03": 80.73443455555453,
    "2025-01-04": 81.24043505318932,
    "2025-01-05": 81.7464355508241,
    "2025-01-06": 82.25243604845889,
    "2025-01-07": 82.75843654609368,
    "2025-01-08": 83.26443704372848,
    "2025-01-09": 83.77043754136326,
    "2025-01-10": 84.27643803899805,
    "2025-01-11": 84.78243853663284,
    "2025-01-12": 85.28843903426763,
    "2025-01-13": 85.79443953190243,
    "2025-01-14": 86.30044002953721,
    "2025-01-15": 86.806440527172,
    "2025-01-16": 87.31244102480679,
    "2025-01-17": 87.81844152244157,
    "2025-01-18": 88.32444202007636,
    "2025-01-19": 88.83044251771116,
    "2025-01-20": 89.33644301534595,
    "2025-01-21": 89.84244351298074,
    "2025-01-22": 90.34844401061552,
    "2025-01-23": 90.85444450825032,
    "2025-01-24": 91.36044500588513,
    "2025-01-25": 91.8664455035199,
    "2025-01-26": 92.37244600115469,
    "2025-01-27": 92.87844649878949,
    "2025-01-28": 93.38444699642426,
    "2025-01-29": 93.89044749405906,
    "2025-01-30": 94.39644799169383,
    "2025-01-31": 94.90244848932863,
    "2025-02-01": 95.67666614422508,
    "2025-02-02": 96.4508837991215,
    "2025-02-03": 97.22510145401792,
    "2025-02-04": 97.99931910891436,
    "2025-02-05": 98.7735367638108,
    "2025-02-06": 99.54775441870724,
    "2025-02-07": 100.32197207360366,
    "2025-02-08": 101.09618972850008,
    "2025-02-09": 101.87040738339653,
    "2025-02-10": 102.64462503829294,
    "2025-02-11": 103.41884269318938,
    "2025-02-12": 104.1930603480858,
    "2025-02-13": 104.96727800298224,
    "2025-02-14": 105.74149565787869,
    "2025-02-15": 106.5157133127751,
    "2025-02-16": 107.28993096767154,
    "2025-02-17": 108.06414862256796,
    "2025-02-18": 108.8383662774644,
    "2025-02-19": 109.61258393236083,
    "2025-02-20": 110.38680158725728,
    "2025-02-21": 111.16101924215369,
    "2025-02-22": 111.93523689705012,
    "2025-02-23": 112.70945455194656,
    "2025-02-24": 113.48367220684298,
    "2025-02-25": 114.2578898617394,
    "2025-02-26": 115.03210751663585,
    "2025-02-27": 115.80632517153228,
    "2025-02-28": 116.58054282642873,
    "2025-03-01": 117.9894583807742,
    "2025-03-02": 119.39837393511966,
    "2025-03-03": 120.80728948946516,
    "2025-03-04": 122.21620504381065,
    "2025-03-05": 123.6251205981561,
    "2025-03-06": 125.0340361525016,
    "2025-03-07": 126.44295170684704,
    "2025-03-08": 127.85186726119254,
    "2025-03-09": 129.26078281553802,
    "2025-03-10": 130.6696983698835,
    "2025-03-11": 132.078613924229,
    "2025-03-12": 133.48752947857446,
    "2025-03-13": 134.89644503291993,
    "2025-03-14": 136.3053605872654,
    "2025-03-15": 137.7142761416109,
    "2025-03-16": 139.12319169595636,
    "2025-03-17": 140.53210725030186,
    "2025-03-18": 141.94102280464733,
    "2025-03-19": 143.3499383589928,
    "2025-03-20": 144.75885391333827,
    "2025-03-21": 146.16776946768377,
    "2025-03-22": 147.57668502202924,
    "2025-03-23": 148.9856005763747,
    "2025-03-24": 150.3945161307202,
    "2025-03-25": 151.80343168506568,
    "2025-03-26": 153.21234723941114,
    "2025-03-27": 154.62126279375664,
    "2025-03-28": 156.0301783481021,
    "2025-03-29": 157.43909390244758,
    "2025-03-30": 158.84800945679308,
    "2025-03-31": 160.25692501113855,
    "2025-04-01": 162.88048233768245,
    "2025-04-02": 165.50403966422635,
    "2025-04-03": 168.12759699077026,
    "2025-04-04": 170.75115431731413,
    "2025-04-05": 173.37471164385803,
    "2025-04-06": 175.99826897040194,
    "2025-04-07": 178.62182629694584,
    "2025-04-08": 181.24538362348972,
    "2025-04-09": 183.86894095003365,
    "2025-04-10": 186.49249827657755,
    "2025-04-11": 189.11605560312145,
    "2025-04-12": 191.73961292966533,
    "2025-04-13": 194.36317025620923,
    "2025-04-14": 196.98672758275316,
    "2025-04-15": 199.61028490929704,
    "2025-04-16": 202.2338422358409,
    "2025-04-17": 204.85739956238484,
    "2025-04-18": 207.48095688892877,
    "2025-04-19": 210.10451421547265,
    "2025-04-20": 212.7280715420165,
    "2025-04-21": 215.35162886856045,
    "2025-04-22": 217.97518619510436,
    "2025-04-23": 220.59874352164823,
    "2025-04-24": 223.2223008481921,
    "2025-04-25": 225.845858174736,
    "2025-04-26": 228.4694155012799,
    "2025-04-27": 231.0929728278238,
    "2025-04-28": 233.7165301543677,
    "2025-04-29": 236.3400874809116,
    "2025-04-30": 238.96364480745552,
    "2025-05-01": 241.773245283434,
    "2025-05-02": 244.5828457594125,
    "2025-05-03": 247.39244623539096,
    "2025-05-04": 250.20204671136943,
    "2025-05-05": 253.0116471873479,
    "2025-05-06": 255.8212476633264,
    "2025-05-07": 258.6308481393049,
    "2025-05-08": 261.44044861528334,
    "2025-05-09": 264.2500490912618,
    "2025-05-10": 267.0596495672403,
    "2025-05-11": 269.8692500432188,
    "2025-05-12": 272.6788505191972,
    "2025-05-13": 275.4884509951757,
    "2025-05-14": 278.29805147115417,
    "2025-05-15": 281.10765194713264,
    "2025-05-16": 283.9172524231111,
    "2025-05-17": 286.72685289908964,
    "2025-05-18": 289.5364533750681,
    "2025-05-19": 292.3460538510466,
    "2025-05-20": 295.15565432702505,
    "2025-05-21": 297.9652548030035,
    "2025-05-22": 300.774855278982,
    "2025-05-23": 303.58445575496046,
    "2025-05-24": 306.39405623093893,
    "2025-05-25": 309.2036567069174,
    "2025-05-26": 312.0132571828959,
    "2025-05-27": 314.82285765887434,
    "2025-05-28": 317.63245813485287,
    "2025-05-29": 320.44205861083134,
    "2025-05-30": 323.2516590868098,
    "2025-05-31": 326.0612595627883,
    "2025-06-01": 329.26169531814594,
    "2025-06-02": 332.46213107350354,
    "2025-06-03": 335.66256682886115,
    "2025-06-04": 338.8630025842188,
    "2025-06-05": 342.06343833957646,
    "2025-06-06": 345.26387409493407,
    "2025-06-07": 348.46430985029167,
    "2025-06-08": 351.66474560564933,
    "2025-06-09": 354.865181361007,
    "2025-06-10": 358.0656171163646,
    "2025-06-11": 361.2660528717222,
    "2025-06-12": 364.4664886270799,
    "2025-06-13": 367.6669243824375,
    "2025-06-14": 370.8673601377951,
    "2025-06-15": 374.0677958931527,
    "2025-06-16": 377.2682316485104,
    "2025-06-17": 380.468667403868,
    "2025-06-18": 383.6691031592256,
    "2025-06-19": 386.8695389145833,
    "2025-06-20": 390.0699746699409,
    "2025-06-21": 393.27041042529856,
    "2025-06-22": 396.47084618065617,
    "2025-06-23": 399.67128193601377,
    "2025-06-24": 402.8717176913714,
    "2025-06-25": 406.0721534467291,
    "2025-06-26": 409.2725892020867,
    "2025-06-27": 412.4730249574443,
    "2025-06-28": 415.673460712802,
    "2025-06-29": 418.8738964681596,
    "2025-06-30": 422.0743322235172,
    "2025-07-01": 425.8066403858825,
    "2025-07-02": 429.5389485482477,
    "2025-07-03": 433.271256710613,
    "2025-07-04": 437.0035648729782,
    "2025-07-05": 440.73587303534345,
    "2025-07-06": 444.4681811977087,
    "2025-07-07": 448.200489360074,
    "2025-07-08": 451.9327975224392,
    "2025-07-09": 455.6651056848045,
    "2025-07-10": 459.3974138471697,
    "2025-07-11": 463.1297220095349,
    "2025-07-12": 466.8620301719002,
    "2025-07-13": 470.59433833426544,
    "2025-07-14": 474.3266464966307,
    "2025-07-15": 478.058954658996,
    "2025-07-16": 481.7912628213612,
    "2025-07-17": 485.5235709837265,
    "2025-07-18": 489.2558791460917,
    "2025-07-19": 492.988187308457,
    "2025-07-20": 496.7204954708222,
    "2025-07-21": 500.4528036331874,
    "2025-07-22": 504.1851117955527,
    "2025-07-23": 507.917419957918,
    "2025-07-24": 511.6497281202832,
    "2025-07-25": 515.3820362826484,
    "2025-07-26": 519.1143444450137,
    "2025-07-27": 522.8466526073789,
    "2025-07-28": 526.5789607697442,
    "2025-07-29": 530.3112689321094,
    "2025-07-30": 534.0435770944747,
    "2025-07-31": 537.77588525684,
    "2025-08-01": 540.8952202692808,
    "2025-08-02": 544.0145552817215,
    "2025-08-03": 547.1338902941624,
    "2025-08-04": 550.2532253066031,
    "2025-08-05": 553.3725603190439,
    "2025-08-06": 556.4918953314848,
    "2025-08-07": 559.6112303439255,
    "2025-08-08": 562.7305653563664,
    "2025-08-09": 565.8499003688071,
    "2025-08-10": 568.9692353812479,
    "2025-08-11": 572.0885703936887,
    "2025-08-12": 575.2079054061295,
    "2025-08-13": 578.3272404185703,
    "2025-08-14": 581.4465754310111,
    "2025-08-15": 584.5659104434519,
    "2025-08-16": 587.6852454558926,
    "2025-08-17": 590.8045804683335,
    "2025-08-18": 593.9239154807742,
    "2025-08-19": 597.043250493215,
    "2025-08-20": 600.1625855056559,
    "2025-08-21": 603.2819205180966,
    "2025-08-22": 606.4012555305375,
    "2025-08-23": 609.5205905429782,
    "2025-08-24": 612.639925555419,
    "2025-08-25": 615.7592605678599,
    "2025-08-26": 618.8785955803006,
    "2025-08-27": 621.9979305927415,
    "2025-08-28": 625.1172656051822,
    "2025-08-29": 628.236600617623,
    "2025-08-30": 631.3559356300639,
    "2025-08-31": 634.4752706425046,
    "2025-09-01": 636.7479959721086,
    "2025-09-02": 639.0207213017127,
    "2025-09-03": 641.2934466313167,
    "2025-09-04": 643.5661719609207,
    "2025-09-05": 645.8388972905248,
    "2025-09-06": 648.1116226201287,
    "2025-09-07": 650.3843479497327,
    "2025-09-08": 652.6570732793367,
    "2025-09-09": 654.9297986089408,
    "2025-09-10": 657.2025239385448,
    "2025-09-11": 659.4752492681488,
    "2025-09-12": 661.7479745977529,
    "2025-09-13": 664.0206999273569,
    "2025-09-14": 666.2934252569609,
    "2025-09-15": 668.5661505865648,
    "2025-09-16": 670.838875916169,
    "2025-09-17": 673.1116012457729,
    "2025-09-18": 675.3843265753769,
    "2025-09-19": 677.657051904981,
    "2025-09-20": 679.929777234585,
    "2025-09-21": 682.202502564189,
    "2025-09-22": 684.4752278937931,
    "2025-09-23": 686.7479532233971,
    "2025-09-24": 689.0206785530011,
    "2025-09-25": 691.2934038826052,
    "2025-09-26": 693.5661292122091,
    "2025-09-27": 695.8388545418131,
    "2025-09-28": 698.1115798714171,
    "2025-09-29": 700.3843052010212,
    "2025-09-30": 702.6570305306252,
  },
  Pomegranates: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.7737037237258186,
    "2024-10-03": 3.5474074474516373,
    "2024-10-04": 5.321111171177456,
    "2024-10-05": 7.0948148949032745,
    "2024-10-06": 8.868518618629093,
    "2024-10-07": 10.642222342354913,
    "2024-10-08": 12.415926066080733,
    "2024-10-09": 14.189629789806547,
    "2024-10-10": 15.963333513532367,
    "2024-10-11": 17.737037237258185,
    "2024-10-12": 19.510740960984005,
    "2024-10-13": 21.284444684709825,
    "2024-10-14": 23.05814840843564,
    "2024-10-15": 24.831852132161465,
    "2024-10-16": 26.60555585588728,
    "2024-10-17": 28.379259579613095,
    "2024-10-18": 30.15296330333892,
    "2024-10-19": 31.92666702706473,
    "2024-10-20": 33.700370750790555,
    "2024-10-21": 35.47407447451637,
    "2024-10-22": 37.247778198242194,
    "2024-10-23": 39.02148192196801,
    "2024-10-24": 40.79518564569383,
    "2024-10-25": 42.56888936941965,
    "2024-10-26": 44.34259309314547,
    "2024-10-27": 46.11629681687128,
    "2024-10-28": 47.8900005405971,
    "2024-10-29": 49.66370426432293,
    "2024-10-30": 51.43740798804874,
    "2024-10-31": 53.21111171177456,
    "2024-11-01": 53.59296304420524,
    "2024-11-02": 53.97481437663593,
    "2024-11-03": 54.35666570906662,
    "2024-11-04": 54.73851704149731,
    "2024-11-05": 55.120368373928,
    "2024-11-06": 55.50221970635869,
    "2024-11-07": 55.88407103878937,
    "2024-11-08": 56.26592237122006,
    "2024-11-09": 56.64777370365075,
    "2024-11-10": 57.02962503608144,
    "2024-11-11": 57.411476368512126,
    "2024-11-12": 57.79332770094281,
    "2024-11-13": 58.1751790333735,
    "2024-11-14": 58.55703036580419,
    "2024-11-15": 58.93888169823488,
    "2024-11-16": 59.320733030665565,
    "2024-11-17": 59.70258436309625,
    "2024-11-18": 60.08443569552694,
    "2024-11-19": 60.46628702795763,
    "2024-11-20": 60.84813836038832,
    "2024-11-21": 61.22998969281901,
    "2024-11-22": 61.61184102524969,
    "2024-11-23": 61.99369235768038,
    "2024-11-24": 62.375543690111066,
    "2024-11-25": 62.75739502254176,
    "2024-11-26": 63.13924635497244,
    "2024-11-27": 63.52109768740313,
    "2024-11-28": 63.90294901983382,
    "2024-11-29": 64.28480035226451,
    "2024-11-30": 64.6666516846952,
    "2024-12-01": 64.91049866750011,
    "2024-12-02": 65.15434565030502,
    "2024-12-03": 65.39819263310993,
    "2024-12-04": 65.64203961591484,
    "2024-12-05": 65.88588659871975,
    "2024-12-06": 66.12973358152466,
    "2024-12-07": 66.37358056432957,
    "2024-12-08": 66.61742754713448,
    "2024-12-09": 66.8612745299394,
    "2024-12-10": 67.1051215127443,
    "2024-12-11": 67.34896849554922,
    "2024-12-12": 67.59281547835413,
    "2024-12-13": 67.83666246115904,
    "2024-12-14": 68.08050944396395,
    "2024-12-15": 68.32435642676886,
    "2024-12-16": 68.56820340957377,
    "2024-12-17": 68.81205039237868,
    "2024-12-18": 69.05589737518359,
    "2024-12-19": 69.2997443579885,
    "2024-12-20": 69.54359134079341,
    "2024-12-21": 69.78743832359832,
    "2024-12-22": 70.03128530640323,
    "2024-12-23": 70.27513228920814,
    "2024-12-24": 70.51897927201306,
    "2024-12-25": 70.76282625481797,
    "2024-12-26": 71.00667323762288,
    "2024-12-27": 71.25052022042779,
    "2024-12-28": 71.4943672032327,
    "2024-12-29": 71.73821418603761,
    "2024-12-30": 71.98206116884252,
    "2024-12-31": 72.22590815164743,
    "2025-01-01": 72.75764444085817,
    "2025-01-02": 73.28938073006893,
    "2025-01-03": 73.82111701927967,
    "2025-01-04": 74.35285330849041,
    "2025-01-05": 74.88458959770115,
    "2025-01-06": 75.4163258869119,
    "2025-01-07": 75.94806217612265,
    "2025-01-08": 76.47979846533339,
    "2025-01-09": 77.01153475454413,
    "2025-01-10": 77.54327104375488,
    "2025-01-11": 78.07500733296563,
    "2025-01-12": 78.60674362217637,
    "2025-01-13": 79.13847991138711,
    "2025-01-14": 79.67021620059786,
    "2025-01-15": 80.2019524898086,
    "2025-01-16": 80.73368877901935,
    "2025-01-17": 81.26542506823009,
    "2025-01-18": 81.79716135744084,
    "2025-01-19": 82.32889764665158,
    "2025-01-20": 82.86063393586232,
    "2025-01-21": 83.39237022507307,
    "2025-01-22": 83.92410651428382,
    "2025-01-23": 84.45584280349456,
    "2025-01-24": 84.9875790927053,
    "2025-01-25": 85.51931538191604,
    "2025-01-26": 86.0510516711268,
    "2025-01-27": 86.58278796033754,
    "2025-01-28": 87.11452424954828,
    "2025-01-29": 87.64626053875904,
    "2025-01-30": 88.17799682796978,
    "2025-01-31": 88.70973311718052,
    "2025-02-01": 89.49920012629497,
    "2025-02-02": 90.28866713540944,
    "2025-02-03": 91.07813414452389,
    "2025-02-04": 91.86760115363832,
    "2025-02-05": 92.65706816275278,
    "2025-02-06": 93.44653517186724,
    "2025-02-07": 94.2360021809817,
    "2025-02-08": 95.02546919009616,
    "2025-02-09": 95.8149361992106,
    "2025-02-10": 96.60440320832504,
    "2025-02-11": 97.39387021743951,
    "2025-02-12": 98.18333722655396,
    "2025-02-13": 98.9728042356684,
    "2025-02-14": 99.76227124478288,
    "2025-02-15": 100.55173825389733,
    "2025-02-16": 101.34120526301176,
    "2025-02-17": 102.13067227212622,
    "2025-02-18": 102.92013928124068,
    "2025-02-19": 103.70960629035514,
    "2025-02-20": 104.4990732994696,
    "2025-02-21": 105.28854030858405,
    "2025-02-22": 106.07800731769848,
    "2025-02-23": 106.86747432681295,
    "2025-02-24": 107.6569413359274,
    "2025-02-25": 108.44640834504185,
    "2025-02-26": 109.2358753541563,
    "2025-02-27": 110.02534236327077,
    "2025-02-28": 110.8148093723852,
    "2025-03-01": 112.16073575148116,
    "2025-03-02": 113.50666213057713,
    "2025-03-03": 114.85258850967308,
    "2025-03-04": 116.19851488876904,
    "2025-03-05": 117.54444126786498,
    "2025-03-06": 118.89036764696094,
    "2025-03-07": 120.2362940260569,
    "2025-03-08": 121.58222040515284,
    "2025-03-09": 122.9281467842488,
    "2025-03-10": 124.27407316334477,
    "2025-03-11": 125.61999954244072,
    "2025-03-12": 126.96592592153668,
    "2025-03-13": 128.3118523006326,
    "2025-03-14": 129.65777867972858,
    "2025-03-15": 131.00370505882452,
    "2025-03-16": 132.3496314379205,
    "2025-03-17": 133.69555781701644,
    "2025-03-18": 135.0414841961124,
    "2025-03-19": 136.38741057520835,
    "2025-03-20": 137.73333695430432,
    "2025-03-21": 139.07926333340026,
    "2025-03-22": 140.4251897124962,
    "2025-03-23": 141.77111609159218,
    "2025-03-24": 143.11704247068812,
    "2025-03-25": 144.4629688497841,
    "2025-03-26": 145.80889522888003,
    "2025-03-27": 147.15482160797598,
    "2025-03-28": 148.50074798707195,
    "2025-03-29": 149.8466743661679,
    "2025-03-30": 151.19260074526386,
    "2025-03-31": 152.5385271243598,
    "2025-04-01": 154.79006322194522,
    "2025-04-02": 157.04159931953063,
    "2025-04-03": 159.29313541711605,
    "2025-04-04": 161.5446715147015,
    "2025-04-05": 163.7962076122869,
    "2025-04-06": 166.04774370987232,
    "2025-04-07": 168.29927980745774,
    "2025-04-08": 170.55081590504315,
    "2025-04-09": 172.80235200262857,
    "2025-04-10": 175.05388810021398,
    "2025-04-11": 177.30542419779945,
    "2025-04-12": 179.55696029538484,
    "2025-04-13": 181.80849639297023,
    "2025-04-14": 184.06003249055567,
    "2025-04-15": 186.31156858814109,
    "2025-04-16": 188.5631046857265,
    "2025-04-17": 190.81464078331192,
    "2025-04-18": 193.06617688089733,
    "2025-04-19": 195.3177129784828,
    "2025-04-20": 197.5692490760682,
    "2025-04-21": 199.8207851736536,
    "2025-04-22": 202.07232127123905,
    "2025-04-23": 204.32385736882443,
    "2025-04-24": 206.57539346640988,
    "2025-04-25": 208.8269295639953,
    "2025-04-26": 211.0784656615807,
    "2025-04-27": 213.33000175916607,
    "2025-04-28": 215.58153785675157,
    "2025-04-29": 217.83307395433692,
    "2025-04-30": 220.0846100519224,
    "2025-05-01": 222.38057447489544,
    "2025-05-02": 224.6765388978685,
    "2025-05-03": 226.9725033208416,
    "2025-05-04": 229.26846774381465,
    "2025-05-05": 231.56443216678773,
    "2025-05-06": 233.8603965897608,
    "2025-05-07": 236.15636101273387,
    "2025-05-08": 238.4523254357069,
    "2025-05-09": 240.74828985868,
    "2025-05-10": 243.04425428165308,
    "2025-05-11": 245.34021870462612,
    "2025-05-12": 247.6361831275992,
    "2025-05-13": 249.9321475505723,
    "2025-05-14": 252.22811197354537,
    "2025-05-15": 254.5240763965184,
    "2025-05-16": 256.8200408194915,
    "2025-05-17": 259.1160052424645,
    "2025-05-18": 261.41196966543765,
    "2025-05-19": 263.7079340884107,
    "2025-05-20": 266.0038985113838,
    "2025-05-21": 268.29986293435684,
    "2025-05-22": 270.59582735732994,
    "2025-05-23": 272.891791780303,
    "2025-05-24": 275.1877562032761,
    "2025-05-25": 277.4837206262491,
    "2025-05-26": 279.7796850492222,
    "2025-05-27": 282.07564947219527,
    "2025-05-28": 284.3716138951684,
    "2025-05-29": 286.6675783181414,
    "2025-05-30": 288.96354274111445,
    "2025-05-31": 291.25950716408755,
    "2025-06-01": 293.41525714551307,
    "2025-06-02": 295.57100712693864,
    "2025-06-03": 297.7267571083641,
    "2025-06-04": 299.88250708978967,
    "2025-06-05": 302.03825707121524,
    "2025-06-06": 304.1940070526408,
    "2025-06-07": 306.3497570340664,
    "2025-06-08": 308.50550701549184,
    "2025-06-09": 310.66125699691736,
    "2025-06-10": 312.81700697834293,
    "2025-06-11": 314.97275695976845,
    "2025-06-12": 317.128506941194,
    "2025-06-13": 319.28425692261953,
    "2025-06-14": 321.44000690404505,
    "2025-06-15": 323.59575688547056,
    "2025-06-16": 325.75150686689614,
    "2025-06-17": 327.90725684832165,
    "2025-06-18": 330.0630068297472,
    "2025-06-19": 332.21875681117274,
    "2025-06-20": 334.37450679259825,
    "2025-06-21": 336.5302567740238,
    "2025-06-22": 338.68600675544934,
    "2025-06-23": 340.8417567368749,
    "2025-06-24": 342.99750671830043,
    "2025-06-25": 345.15325669972594,
    "2025-06-26": 347.30900668115146,
    "2025-06-27": 349.46475666257703,
    "2025-06-28": 351.62050664400255,
    "2025-06-29": 353.7762566254281,
    "2025-06-30": 355.93200660685363,
    "2025-07-01": 357.7834628578662,
    "2025-07-02": 359.6349191088788,
    "2025-07-03": 361.4863753598913,
    "2025-07-04": 363.3378316109039,
    "2025-07-05": 365.18928786191645,
    "2025-07-06": 367.040744112929,
    "2025-07-07": 368.8922003639416,
    "2025-07-08": 370.74365661495415,
    "2025-07-09": 372.5951128659667,
    "2025-07-10": 374.4465691169793,
    "2025-07-11": 376.29802536799184,
    "2025-07-12": 378.1494816190044,
    "2025-07-13": 380.00093787001697,
    "2025-07-14": 381.85239412102953,
    "2025-07-15": 383.7038503720421,
    "2025-07-16": 385.55530662305466,
    "2025-07-17": 387.4067628740672,
    "2025-07-18": 389.2582191250798,
    "2025-07-19": 391.1096753760924,
    "2025-07-20": 392.9611316271049,
    "2025-07-21": 394.8125878781175,
    "2025-07-22": 396.6640441291301,
    "2025-07-23": 398.5155003801426,
    "2025-07-24": 400.3669566311552,
    "2025-07-25": 402.2184128821677,
    "2025-07-26": 404.0698691331803,
    "2025-07-27": 405.92132538419287,
    "2025-07-28": 407.77278163520543,
    "2025-07-29": 409.624237886218,
    "2025-07-30": 411.47569413723056,
    "2025-07-31": 413.3271503882431,
    "2025-08-01": 415.3671818421429,
    "2025-08-02": 417.4072132960426,
    "2025-08-03": 419.4472447499424,
    "2025-08-04": 421.4872762038421,
    "2025-08-05": 423.52730765774186,
    "2025-08-06": 425.5673391116416,
    "2025-08-07": 427.6073705655414,
    "2025-08-08": 429.6474020194411,
    "2025-08-09": 431.6874334733408,
    "2025-08-10": 433.7274649272406,
    "2025-08-11": 435.7674963811404,
    "2025-08-12": 437.8075278350401,
    "2025-08-13": 439.8475592889398,
    "2025-08-14": 441.8875907428396,
    "2025-08-15": 443.9276221967393,
    "2025-08-16": 445.9676536506391,
    "2025-08-17": 448.0076851045389,
    "2025-08-18": 450.04771655843854,
    "2025-08-19": 452.0877480123383,
    "2025-08-20": 454.12777946623805,
    "2025-08-21": 456.1678109201378,
    "2025-08-22": 458.2078423740376,
    "2025-08-23": 460.24787382793727,
    "2025-08-24": 462.287905281837,
    "2025-08-25": 464.3279367357368,
    "2025-08-26": 466.3679681896365,
    "2025-08-27": 468.4079996435363,
    "2025-08-28": 470.448031097436,
    "2025-08-29": 472.48806255133576,
    "2025-08-30": 474.5280940052355,
    "2025-08-31": 476.5681254591353,
    "2025-09-01": 478.2084590341432,
    "2025-09-02": 479.8487926091511,
    "2025-09-03": 481.489126184159,
    "2025-09-04": 483.1294597591668,
    "2025-09-05": 484.7697933341747,
    "2025-09-06": 486.4101269091826,
    "2025-09-07": 488.0504604841905,
    "2025-09-08": 489.6907940591984,
    "2025-09-09": 491.3311276342063,
    "2025-09-10": 492.97146120921417,
    "2025-09-11": 494.61179478422207,
    "2025-09-12": 496.25212835923,
    "2025-09-13": 497.8924619342379,
    "2025-09-14": 499.5327955092458,
    "2025-09-15": 501.1731290842537,
    "2025-09-16": 502.8134626592615,
    "2025-09-17": 504.4537962342694,
    "2025-09-18": 506.0941298092773,
    "2025-09-19": 507.7344633842852,
    "2025-09-20": 509.3747969592931,
    "2025-09-21": 511.01513053430097,
    "2025-09-22": 512.6554641093089,
    "2025-09-23": 514.2957976843168,
    "2025-09-24": 515.9361312593246,
    "2025-09-25": 517.5764648343326,
    "2025-09-26": 519.2167984093404,
    "2025-09-27": 520.8571319843484,
    "2025-09-28": 522.4974655593562,
    "2025-09-29": 524.1377991343642,
    "2025-09-30": 525.778132709372,
  },
  Prunes: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.9187136889260912,
    "2024-10-03": 3.8374273778521824,
    "2024-10-04": 5.756141066778273,
    "2024-10-05": 7.674854755704365,
    "2024-10-06": 9.593568444630456,
    "2024-10-07": 11.512282133556546,
    "2024-10-08": 13.430995822482638,
    "2024-10-09": 15.34970951140873,
    "2024-10-10": 17.26842320033482,
    "2024-10-11": 19.187136889260916,
    "2024-10-12": 21.105850578187,
    "2024-10-13": 23.02456426711309,
    "2024-10-14": 24.943277956039186,
    "2024-10-15": 26.86199164496528,
    "2024-10-16": 28.78070533389137,
    "2024-10-17": 30.69941902281746,
    "2024-10-18": 32.61813271174355,
    "2024-10-19": 34.53684640066964,
    "2024-10-20": 36.455560089595735,
    "2024-10-21": 38.37427377852183,
    "2024-10-22": 40.29298746744792,
    "2024-10-23": 42.211701156374005,
    "2024-10-24": 44.130414845300095,
    "2024-10-25": 46.049128534226185,
    "2024-10-26": 47.96784222315228,
    "2024-10-27": 49.88655591207837,
    "2024-10-28": 51.80526960100446,
    "2024-10-29": 53.72398328993055,
    "2024-10-30": 55.64269697885664,
    "2024-10-31": 57.56141066778274,
    "2024-11-01": 58.08528137235337,
    "2024-11-02": 58.609152076924005,
    "2024-11-03": 59.13302278149463,
    "2024-11-04": 59.65689348606527,
    "2024-11-05": 60.1807641906359,
    "2024-11-06": 60.70463489520653,
    "2024-11-07": 61.228505599777165,
    "2024-11-08": 61.75237630434779,
    "2024-11-09": 62.276247008918425,
    "2024-11-10": 62.80011771348906,
    "2024-11-11": 63.32398841805969,
    "2024-11-12": 63.847859122630325,
    "2024-11-13": 64.37172982720095,
    "2024-11-14": 64.89560053177159,
    "2024-11-15": 65.41947123634222,
    "2024-11-16": 65.94334194091284,
    "2024-11-17": 66.46721264548349,
    "2024-11-18": 66.99108335005411,
    "2024-11-19": 67.51495405462475,
    "2024-11-20": 68.03882475919538,
    "2024-11-21": 68.562695463766,
    "2024-11-22": 69.08656616833665,
    "2024-11-23": 69.61043687290727,
    "2024-11-24": 70.1343075774779,
    "2024-11-25": 70.65817828204854,
    "2024-11-26": 71.18204898661917,
    "2024-11-27": 71.7059196911898,
    "2024-11-28": 72.22979039576043,
    "2024-11-29": 72.75366110033107,
    "2024-11-30": 73.2775318049017,
    "2024-12-01": 73.55370028628668,
    "2024-12-02": 73.82986876767166,
    "2024-12-03": 74.10603724905664,
    "2024-12-04": 74.38220573044161,
    "2024-12-05": 74.6583742118266,
    "2024-12-06": 74.93454269321157,
    "2024-12-07": 75.21071117459655,
    "2024-12-08": 75.48687965598153,
    "2024-12-09": 75.76304813736651,
    "2024-12-10": 76.03921661875148,
    "2024-12-11": 76.31538510013647,
    "2024-12-12": 76.59155358152144,
    "2024-12-13": 76.86772206290642,
    "2024-12-14": 77.1438905442914,
    "2024-12-15": 77.42005902567638,
    "2024-12-16": 77.69622750706135,
    "2024-12-17": 77.97239598844634,
    "2024-12-18": 78.24856446983131,
    "2024-12-19": 78.5247329512163,
    "2024-12-20": 78.80090143260126,
    "2024-12-21": 79.07706991398625,
    "2024-12-22": 79.35323839537122,
    "2024-12-23": 79.6294068767562,
    "2024-12-24": 79.90557535814118,
    "2024-12-25": 80.18174383952616,
    "2024-12-26": 80.45791232091113,
    "2024-12-27": 80.73408080229612,
    "2024-12-28": 81.01024928368109,
    "2024-12-29": 81.28641776506608,
    "2024-12-30": 81.56258624645105,
    "2024-12-31": 81.83875472783603,
    "2025-01-01": 82.37573652303631,
    "2025-01-02": 82.91271831823659,
    "2025-01-03": 83.44970011343686,
    "2025-01-04": 83.98668190863714,
    "2025-01-05": 84.52366370383741,
    "2025-01-06": 85.0606454990377,
    "2025-01-07": 85.59762729423798,
    "2025-01-08": 86.13460908943826,
    "2025-01-09": 86.67159088463853,
    "2025-01-10": 87.20857267983881,
    "2025-01-11": 87.74555447503909,
    "2025-01-12": 88.28253627023936,
    "2025-01-13": 88.81951806543964,
    "2025-01-14": 89.35649986063991,
    "2025-01-15": 89.89348165584019,
    "2025-01-16": 90.43046345104048,
    "2025-01-17": 90.96744524624076,
    "2025-01-18": 91.50442704144103,
    "2025-01-19": 92.04140883664132,
    "2025-01-20": 92.5783906318416,
    "2025-01-21": 93.11537242704186,
    "2025-01-22": 93.65235422224214,
    "2025-01-23": 94.1893360174424,
    "2025-01-24": 94.72631781264268,
    "2025-01-25": 95.26329960784297,
    "2025-01-26": 95.80028140304324,
    "2025-01-27": 96.33726319824352,
    "2025-01-28": 96.8742449934438,
    "2025-01-29": 97.41122678864409,
    "2025-01-30": 97.94820858384436,
    "2025-01-31": 98.48519037904464,
    "2025-02-01": 99.44022070249714,
    "2025-02-02": 100.39525102594963,
    "2025-02-03": 101.35028134940217,
    "2025-02-04": 102.30531167285469,
    "2025-02-05": 103.26034199630718,
    "2025-02-06": 104.21537231975968,
    "2025-02-07": 105.1704026432122,
    "2025-02-08": 106.12543296666468,
    "2025-02-09": 107.0804632901172,
    "2025-02-10": 108.03549361356971,
    "2025-02-11": 108.99052393702222,
    "2025-02-12": 109.94555426047472,
    "2025-02-13": 110.90058458392724,
    "2025-02-14": 111.85561490737972,
    "2025-02-15": 112.81064523083224,
    "2025-02-16": 113.76567555428475,
    "2025-02-17": 114.72070587773726,
    "2025-02-18": 115.67573620118976,
    "2025-02-19": 116.63076652464228,
    "2025-02-20": 117.5857968480948,
    "2025-02-21": 118.54082717154728,
    "2025-02-22": 119.4958574949998,
    "2025-02-23": 120.4508878184523,
    "2025-02-24": 121.4059181419048,
    "2025-02-25": 122.36094846535732,
    "2025-02-26": 123.31597878880984,
    "2025-02-27": 124.27100911226232,
    "2025-02-28": 125.22603943571484,
    "2025-03-01": 126.74534596361204,
    "2025-03-02": 128.26465249150922,
    "2025-03-03": 129.78395901940644,
    "2025-03-04": 131.30326554730362,
    "2025-03-05": 132.82257207520084,
    "2025-03-06": 134.34187860309802,
    "2025-03-07": 135.8611851309952,
    "2025-03-08": 137.38049165889242,
    "2025-03-09": 138.8997981867896,
    "2025-03-10": 140.41910471468682,
    "2025-03-11": 141.938411242584,
    "2025-03-12": 143.4577177704812,
    "2025-03-13": 144.9770242983784,
    "2025-03-14": 146.4963308262756,
    "2025-03-15": 148.0156373541728,
    "2025-03-16": 149.53494388207,
    "2025-03-17": 151.05425040996718,
    "2025-03-18": 152.5735569378644,
    "2025-03-19": 154.09286346576158,
    "2025-03-20": 155.6121699936588,
    "2025-03-21": 157.13147652155598,
    "2025-03-22": 158.6507830494532,
    "2025-03-23": 160.17008957735038,
    "2025-03-24": 161.68939610524757,
    "2025-03-25": 163.20870263314478,
    "2025-03-26": 164.72800916104197,
    "2025-03-27": 166.24731568893918,
    "2025-03-28": 167.76662221683637,
    "2025-03-29": 169.28592874473355,
    "2025-03-30": 170.80523527263077,
    "2025-03-31": 172.32454180052795,
    "2025-04-01": 175.2221284344699,
    "2025-04-02": 178.11971506841184,
    "2025-04-03": 181.0173017023538,
    "2025-04-04": 183.9148883362957,
    "2025-04-05": 186.81247497023767,
    "2025-04-06": 189.7100616041796,
    "2025-04-07": 192.6076482381216,
    "2025-04-08": 195.5052348720635,
    "2025-04-09": 198.40282150600544,
    "2025-04-10": 201.3004081399474,
    "2025-04-11": 204.1979947738893,
    "2025-04-12": 207.09558140783128,
    "2025-04-13": 209.9931680417732,
    "2025-04-14": 212.8907546757152,
    "2025-04-15": 215.78834130965708,
    "2025-04-16": 218.68592794359904,
    "2025-04-17": 221.583514577541,
    "2025-04-18": 224.4811012114829,
    "2025-04-19": 227.37868784542488,
    "2025-04-20": 230.2762744793668,
    "2025-04-21": 233.1738611133088,
    "2025-04-22": 236.07144774725072,
    "2025-04-23": 238.96903438119264,
    "2025-04-24": 241.86662101513457,
    "2025-04-25": 244.76420764907647,
    "2025-04-26": 247.66179428301848,
    "2025-04-27": 250.5593809169604,
    "2025-04-28": 253.4569675509024,
    "2025-04-29": 256.3545541848443,
    "2025-04-30": 259.25214081878624,
    "2025-05-01": 262.3316834392934,
    "2025-05-02": 265.41122605980047,
    "2025-05-03": 268.4907686803076,
    "2025-05-04": 271.57031130081475,
    "2025-05-05": 274.6498539213219,
    "2025-05-06": 277.729396541829,
    "2025-05-07": 280.8089391623361,
    "2025-05-08": 283.88848178284326,
    "2025-05-09": 286.96802440335034,
    "2025-05-10": 290.0475670238575,
    "2025-05-11": 293.1271096443646,
    "2025-05-12": 296.20665226487176,
    "2025-05-13": 299.28619488537885,
    "2025-05-14": 302.365737505886,
    "2025-05-15": 305.4452801263932,
    "2025-05-16": 308.5248227469002,
    "2025-05-17": 311.6043653674073,
    "2025-05-18": 314.6839079879145,
    "2025-05-19": 317.76345060842164,
    "2025-05-20": 320.8429932289287,
    "2025-05-21": 323.92253584943586,
    "2025-05-22": 327.002078469943,
    "2025-05-23": 330.0816210904501,
    "2025-05-24": 333.1611637109572,
    "2025-05-25": 336.2407063314644,
    "2025-05-26": 339.3202489519715,
    "2025-05-27": 342.3997915724786,
    "2025-05-28": 345.47933419298573,
    "2025-05-29": 348.5588768134928,
    "2025-05-30": 351.638419434,
    "2025-05-31": 354.7179620545071,
    "2025-06-01": 358.0431130095091,
    "2025-06-02": 361.36826396451113,
    "2025-06-03": 364.6934149195132,
    "2025-06-04": 368.0185658745152,
    "2025-06-05": 371.3437168295172,
    "2025-06-06": 374.6688677845193,
    "2025-06-07": 377.9940187395213,
    "2025-06-08": 381.31916969452334,
    "2025-06-09": 384.64432064952535,
    "2025-06-10": 387.96947160452737,
    "2025-06-11": 391.29462255952944,
    "2025-06-12": 394.61977351453146,
    "2025-06-13": 397.9449244695335,
    "2025-06-14": 401.2700754245355,
    "2025-06-15": 404.5952263795375,
    "2025-06-16": 407.9203773345396,
    "2025-06-17": 411.2455282895416,
    "2025-06-18": 414.5706792445436,
    "2025-06-19": 417.8958301995457,
    "2025-06-20": 421.2209811545477,
    "2025-06-21": 424.5461321095497,
    "2025-06-22": 427.8712830645517,
    "2025-06-23": 431.19643401955375,
    "2025-06-24": 434.5215849745558,
    "2025-06-25": 437.8467359295578,
    "2025-06-26": 441.1718868845599,
    "2025-06-27": 444.4970378395618,
    "2025-06-28": 447.8221887945639,
    "2025-06-29": 451.147339749566,
    "2025-06-30": 454.472490704568,
    "2025-07-01": 458.4737900266135,
    "2025-07-02": 462.47508934865897,
    "2025-07-03": 466.47638867070447,
    "2025-07-04": 470.47768799275,
    "2025-07-05": 474.47898731479546,
    "2025-07-06": 478.48028663684096,
    "2025-07-07": 482.48158595888646,
    "2025-07-08": 486.482885280932,
    "2025-07-09": 490.4841846029775,
    "2025-07-10": 494.48548392502295,
    "2025-07-11": 498.4867832470685,
    "2025-07-12": 502.48808256911394,
    "2025-07-13": 506.4893818911594,
    "2025-07-14": 510.490681213205,
    "2025-07-15": 514.4919805352505,
    "2025-07-16": 518.493279857296,
    "2025-07-17": 522.4945791793415,
    "2025-07-18": 526.495878501387,
    "2025-07-19": 530.4971778234325,
    "2025-07-20": 534.498477145478,
    "2025-07-21": 538.4997764675235,
    "2025-07-22": 542.501075789569,
    "2025-07-23": 546.5023751116145,
    "2025-07-24": 550.50367443366,
    "2025-07-25": 554.5049737557055,
    "2025-07-26": 558.506273077751,
    "2025-07-27": 562.5075723997965,
    "2025-07-28": 566.508871721842,
    "2025-07-29": 570.5101710438875,
    "2025-07-30": 574.511470365933,
    "2025-07-31": 578.5127696879784,
    "2025-08-01": 581.6570104595876,
    "2025-08-02": 584.8012512311967,
    "2025-08-03": 587.9454920028058,
    "2025-08-04": 591.089732774415,
    "2025-08-05": 594.2339735460241,
    "2025-08-06": 597.3782143176333,
    "2025-08-07": 600.5224550892424,
    "2025-08-08": 603.6666958608515,
    "2025-08-09": 606.8109366324607,
    "2025-08-10": 609.9551774040698,
    "2025-08-11": 613.0994181756789,
    "2025-08-12": 616.243658947288,
    "2025-08-13": 619.3878997188972,
    "2025-08-14": 622.5321404905063,
    "2025-08-15": 625.6763812621155,
    "2025-08-16": 628.8206220337246,
    "2025-08-17": 631.9648628053337,
    "2025-08-18": 635.1091035769429,
    "2025-08-19": 638.253344348552,
    "2025-08-20": 641.3975851201611,
    "2025-08-21": 644.5418258917703,
    "2025-08-22": 647.6860666633794,
    "2025-08-23": 650.8303074349885,
    "2025-08-24": 653.9745482065977,
    "2025-08-25": 657.1187889782068,
    "2025-08-26": 660.2630297498159,
    "2025-08-27": 663.4072705214251,
    "2025-08-28": 666.5515112930342,
    "2025-08-29": 669.6957520646433,
    "2025-08-30": 672.8399928362525,
    "2025-08-31": 675.9842336078616,
    "2025-09-01": 678.2527057809973,
    "2025-09-02": 680.5211779541331,
    "2025-09-03": 682.7896501272688,
    "2025-09-04": 685.0581223004045,
    "2025-09-05": 687.3265944735404,
    "2025-09-06": 689.5950666466761,
    "2025-09-07": 691.8635388198119,
    "2025-09-08": 694.1320109929476,
    "2025-09-09": 696.4004831660833,
    "2025-09-10": 698.6689553392191,
    "2025-09-11": 700.9374275123548,
    "2025-09-12": 703.2058996854905,
    "2025-09-13": 705.4743718586263,
    "2025-09-14": 707.742844031762,
    "2025-09-15": 710.0113162048979,
    "2025-09-16": 712.2797883780336,
    "2025-09-17": 714.5482605511693,
    "2025-09-18": 716.8167327243051,
    "2025-09-19": 719.0852048974408,
    "2025-09-20": 721.3536770705765,
    "2025-09-21": 723.6221492437123,
    "2025-09-22": 725.890621416848,
    "2025-09-23": 728.1590935899837,
    "2025-09-24": 730.4275657631196,
    "2025-09-25": 732.6960379362553,
    "2025-09-26": 734.9645101093911,
    "2025-09-27": 737.2329822825268,
    "2025-09-28": 739.5014544556625,
    "2025-09-29": 741.7699266287983,
    "2025-09-30": 744.038398801934,
  },
  Walnuts: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.0664585119621237,
    "2024-10-03": 4.132917023924247,
    "2024-10-04": 6.19937553588637,
    "2024-10-05": 8.265834047848493,
    "2024-10-06": 10.332292559810616,
    "2024-10-07": 12.39875107177274,
    "2024-10-08": 14.465209583734865,
    "2024-10-09": 16.531668095696986,
    "2024-10-10": 18.59812660765911,
    "2024-10-11": 20.664585119621236,
    "2024-10-12": 22.731043631583358,
    "2024-10-13": 24.79750214354548,
    "2024-10-14": 26.863960655507604,
    "2024-10-15": 28.93041916746973,
    "2024-10-16": 30.996877679431847,
    "2024-10-17": 33.06333619139397,
    "2024-10-18": 35.1297947033561,
    "2024-10-19": 37.19625321531822,
    "2024-10-20": 39.26271172728034,
    "2024-10-21": 41.32917023924247,
    "2024-10-22": 43.39562875120459,
    "2024-10-23": 45.46208726316671,
    "2024-10-24": 47.52854577512883,
    "2024-10-25": 49.59500428709096,
    "2024-10-26": 51.66146279905308,
    "2024-10-27": 53.72792131101521,
    "2024-10-28": 55.79437982297733,
    "2024-10-29": 57.86083833493945,
    "2024-10-30": 59.92729684690158,
    "2024-10-31": 61.9937553588637,
    "2024-11-01": 62.69246378336062,
    "2024-11-02": 63.39117220785754,
    "2024-11-03": 64.08988063235446,
    "2024-11-04": 64.7885890568514,
    "2024-11-05": 65.4872974813483,
    "2024-11-06": 66.18600590584524,
    "2024-11-07": 66.88471433034215,
    "2024-11-08": 67.58342275483908,
    "2024-11-09": 68.28213117933599,
    "2024-11-10": 68.98083960383292,
    "2024-11-11": 69.67954802832983,
    "2024-11-12": 70.37825645282676,
    "2024-11-13": 71.07696487732368,
    "2024-11-14": 71.7756733018206,
    "2024-11-15": 72.47438172631752,
    "2024-11-16": 73.17309015081445,
    "2024-11-17": 73.87179857531136,
    "2024-11-18": 74.57050699980829,
    "2024-11-19": 75.2692154243052,
    "2024-11-20": 75.96792384880213,
    "2024-11-21": 76.66663227329904,
    "2024-11-22": 77.36534069779597,
    "2024-11-23": 78.06404912229289,
    "2024-11-24": 78.76275754678981,
    "2024-11-25": 79.46146597128674,
    "2024-11-26": 80.16017439578366,
    "2024-11-27": 80.85888282028057,
    "2024-11-28": 81.5575912447775,
    "2024-11-29": 82.25629966927443,
    "2024-11-30": 82.95500809377134,
    "2024-12-01": 83.2460534112237,
    "2024-12-02": 83.53709872867607,
    "2024-12-03": 83.82814404612843,
    "2024-12-04": 84.1191893635808,
    "2024-12-05": 84.41023468103316,
    "2024-12-06": 84.70127999848553,
    "2024-12-07": 84.99232531593789,
    "2024-12-08": 85.28337063339026,
    "2024-12-09": 85.57441595084262,
    "2024-12-10": 85.865461268295,
    "2024-12-11": 86.15650658574735,
    "2024-12-12": 86.44755190319971,
    "2024-12-13": 86.73859722065208,
    "2024-12-14": 87.02964253810444,
    "2024-12-15": 87.32068785555681,
    "2024-12-16": 87.61173317300917,
    "2024-12-17": 87.90277849046154,
    "2024-12-18": 88.1938238079139,
    "2024-12-19": 88.48486912536627,
    "2024-12-20": 88.77591444281863,
    "2024-12-21": 89.066959760271,
    "2024-12-22": 89.35800507772336,
    "2024-12-23": 89.64905039517572,
    "2024-12-24": 89.94009571262809,
    "2024-12-25": 90.23114103008044,
    "2024-12-26": 90.52218634753282,
    "2024-12-27": 90.81323166498518,
    "2024-12-28": 91.10427698243755,
    "2024-12-29": 91.39532229988993,
    "2024-12-30": 91.68636761734228,
    "2024-12-31": 91.97741293479464,
    "2025-01-01": 92.4892256728728,
    "2025-01-02": 93.00103841095095,
    "2025-01-03": 93.51285114902912,
    "2025-01-04": 94.02466388710728,
    "2025-01-05": 94.53647662518544,
    "2025-01-06": 95.0482893632636,
    "2025-01-07": 95.56010210134176,
    "2025-01-08": 96.07191483941992,
    "2025-01-09": 96.58372757749808,
    "2025-01-10": 97.09554031557624,
    "2025-01-11": 97.6073530536544,
    "2025-01-12": 98.11916579173256,
    "2025-01-13": 98.63097852981072,
    "2025-01-14": 99.14279126788888,
    "2025-01-15": 99.65460400596704,
    "2025-01-16": 100.1664167440452,
    "2025-01-17": 100.67822948212336,
    "2025-01-18": 101.1900422202015,
    "2025-01-19": 101.70185495827968,
    "2025-01-20": 102.21366769635785,
    "2025-01-21": 102.725480434436,
    "2025-01-22": 103.23729317251414,
    "2025-01-23": 103.7491059105923,
    "2025-01-24": 104.26091864867048,
    "2025-01-25": 104.77273138674865,
    "2025-01-26": 105.28454412482678,
    "2025-01-27": 105.79635686290494,
    "2025-01-28": 106.3081696009831,
    "2025-01-29": 106.81998233906126,
    "2025-01-30": 107.33179507713942,
    "2025-01-31": 107.84360781521758,
    "2025-02-01": 108.70345103701852,
    "2025-02-02": 109.56329425881948,
    "2025-02-03": 110.4231374806204,
    "2025-02-04": 111.28298070242136,
    "2025-02-05": 112.1428239242223,
    "2025-02-06": 113.00266714602324,
    "2025-02-07": 113.8625103678242,
    "2025-02-08": 114.72235358962514,
    "2025-02-09": 115.58219681142609,
    "2025-02-10": 116.44204003322704,
    "2025-02-11": 117.30188325502796,
    "2025-02-12": 118.16172647682892,
    "2025-02-13": 119.02156969862986,
    "2025-02-14": 119.8814129204308,
    "2025-02-15": 120.74125614223176,
    "2025-02-16": 121.60109936403268,
    "2025-02-17": 122.46094258583364,
    "2025-02-18": 123.32078580763458,
    "2025-02-19": 124.18062902943552,
    "2025-02-20": 125.04047225123648,
    "2025-02-21": 125.9003154730374,
    "2025-02-22": 126.76015869483837,
    "2025-02-23": 127.6200019166393,
    "2025-02-24": 128.47984513844025,
    "2025-02-25": 129.33968836024118,
    "2025-02-26": 130.19953158204214,
    "2025-02-27": 131.05937480384307,
    "2025-02-28": 131.91921802564403,
    "2025-03-01": 133.30338145127232,
    "2025-03-02": 134.68754487690055,
    "2025-03-03": 136.07170830252886,
    "2025-03-04": 137.45587172815712,
    "2025-03-05": 138.8400351537854,
    "2025-03-06": 140.22419857941367,
    "2025-03-07": 141.60836200504195,
    "2025-03-08": 142.9925254306702,
    "2025-03-09": 144.3766888562985,
    "2025-03-10": 145.76085228192676,
    "2025-03-11": 147.14501570755505,
    "2025-03-12": 148.52917913318333,
    "2025-03-13": 149.9133425588116,
    "2025-03-14": 151.29750598443988,
    "2025-03-15": 152.68166941006814,
    "2025-03-16": 154.06583283569643,
    "2025-03-17": 155.44999626132469,
    "2025-03-18": 156.83415968695297,
    "2025-03-19": 158.21832311258123,
    "2025-03-20": 159.60248653820952,
    "2025-03-21": 160.9866499638378,
    "2025-03-22": 162.37081338946606,
    "2025-03-23": 163.75497681509435,
    "2025-03-24": 165.1391402407226,
    "2025-03-25": 166.5233036663509,
    "2025-03-26": 167.90746709197916,
    "2025-03-27": 169.29163051760744,
    "2025-03-28": 170.6757939432357,
    "2025-03-29": 172.059957368864,
    "2025-03-30": 173.44412079449228,
    "2025-03-31": 174.82828422012054,
    "2025-04-01": 177.27428909432916,
    "2025-04-02": 179.72029396853782,
    "2025-04-03": 182.16629884274644,
    "2025-04-04": 184.61230371695507,
    "2025-04-05": 187.05830859116367,
    "2025-04-06": 189.50431346537235,
    "2025-04-07": 191.95031833958095,
    "2025-04-08": 194.3963232137896,
    "2025-04-09": 196.84232808799825,
    "2025-04-10": 199.28833296220688,
    "2025-04-11": 201.7343378364155,
    "2025-04-12": 204.18034271062413,
    "2025-04-13": 206.6263475848328,
    "2025-04-14": 209.0723524590414,
    "2025-04-15": 211.51835733325004,
    "2025-04-16": 213.9643622074587,
    "2025-04-17": 216.4103670816673,
    "2025-04-18": 218.85637195587597,
    "2025-04-19": 221.3023768300846,
    "2025-04-20": 223.7483817042932,
    "2025-04-21": 226.19438657850185,
    "2025-04-22": 228.6403914527105,
    "2025-04-23": 231.08639632691916,
    "2025-04-24": 233.53240120112773,
    "2025-04-25": 235.9784060753364,
    "2025-04-26": 238.42441094954503,
    "2025-04-27": 240.8704158237537,
    "2025-04-28": 243.31642069796231,
    "2025-04-29": 245.7624255721709,
    "2025-04-30": 248.2084304463796,
    "2025-05-01": 251.1603399959345,
    "2025-05-02": 254.11224954548945,
    "2025-05-03": 257.0641590950443,
    "2025-05-04": 260.0160686445993,
    "2025-05-05": 262.96797819415417,
    "2025-05-06": 265.91988774370907,
    "2025-05-07": 268.871797293264,
    "2025-05-08": 271.8237068428189,
    "2025-05-09": 274.7756163923739,
    "2025-05-10": 277.7275259419288,
    "2025-05-11": 280.67943549148373,
    "2025-05-12": 283.6313450410386,
    "2025-05-13": 286.5832545905936,
    "2025-05-14": 289.5351641401485,
    "2025-05-15": 292.4870736897034,
    "2025-05-16": 295.43898323925833,
    "2025-05-17": 298.39089278881323,
    "2025-05-18": 301.3428023383682,
    "2025-05-19": 304.2947118879231,
    "2025-05-20": 307.246621437478,
    "2025-05-21": 310.19853098703294,
    "2025-05-22": 313.15044053658784,
    "2025-05-23": 316.1023500861428,
    "2025-05-24": 319.0542596356977,
    "2025-05-25": 322.0061691852526,
    "2025-05-26": 324.95807873480754,
    "2025-05-27": 327.9099882843625,
    "2025-05-28": 330.8618978339174,
    "2025-05-29": 333.8138073834723,
    "2025-05-30": 336.76571693302725,
    "2025-05-31": 339.71762648258215,
    "2025-06-01": 343.04611127820425,
    "2025-06-02": 346.3745960738264,
    "2025-06-03": 349.7030808694485,
    "2025-06-04": 353.0315656650706,
    "2025-06-05": 356.3600504606928,
    "2025-06-06": 359.6885352563149,
    "2025-06-07": 363.017020051937,
    "2025-06-08": 366.3455048475592,
    "2025-06-09": 369.6739896431813,
    "2025-06-10": 373.0024744388034,
    "2025-06-11": 376.3309592344255,
    "2025-06-12": 379.6594440300476,
    "2025-06-13": 382.98792882566977,
    "2025-06-14": 386.3164136212919,
    "2025-06-15": 389.644898416914,
    "2025-06-16": 392.9733832125361,
    "2025-06-17": 396.30186800815824,
    "2025-06-18": 399.6303528037804,
    "2025-06-19": 402.9588375994025,
    "2025-06-20": 406.2873223950246,
    "2025-06-21": 409.6158071906468,
    "2025-06-22": 412.94429198626887,
    "2025-06-23": 416.272776781891,
    "2025-06-24": 419.6012615775131,
    "2025-06-25": 422.9297463731352,
    "2025-06-26": 426.2582311687573,
    "2025-06-27": 429.5867159643795,
    "2025-06-28": 432.9152007600016,
    "2025-06-29": 436.24368555562376,
    "2025-06-30": 439.57217035124586,
    "2025-07-01": 443.4565464977936,
    "2025-07-02": 447.3409226443413,
    "2025-07-03": 451.225298790889,
    "2025-07-04": 455.1096749374368,
    "2025-07-05": 458.9940510839845,
    "2025-07-06": 462.8784272305323,
    "2025-07-07": 466.76280337708,
    "2025-07-08": 470.64717952362776,
    "2025-07-09": 474.53155567017546,
    "2025-07-10": 478.4159318167232,
    "2025-07-11": 482.3003079632709,
    "2025-07-12": 486.1846841098187,
    "2025-07-13": 490.0690602563664,
    "2025-07-14": 493.9534364029142,
    "2025-07-15": 497.8378125494619,
    "2025-07-16": 501.72218869600965,
    "2025-07-17": 505.60656484255736,
    "2025-07-18": 509.4909409891051,
    "2025-07-19": 513.3753171356528,
    "2025-07-20": 517.2596932822006,
    "2025-07-21": 521.1440694287484,
    "2025-07-22": 525.028445575296,
    "2025-07-23": 528.9128217218438,
    "2025-07-24": 532.7971978683915,
    "2025-07-25": 536.6815740149393,
    "2025-07-26": 540.565950161487,
    "2025-07-27": 544.4503263080347,
    "2025-07-28": 548.3347024545825,
    "2025-07-29": 552.2190786011301,
    "2025-07-30": 556.1034547476779,
    "2025-07-31": 559.9878308942257,
    "2025-08-01": 563.0644899932006,
    "2025-08-02": 566.1411490921756,
    "2025-08-03": 569.2178081911505,
    "2025-08-04": 572.2944672901256,
    "2025-08-05": 575.3711263891005,
    "2025-08-06": 578.4477854880755,
    "2025-08-07": 581.5244445870504,
    "2025-08-08": 584.6011036860255,
    "2025-08-09": 587.6777627850004,
    "2025-08-10": 590.7544218839754,
    "2025-08-11": 593.8310809829503,
    "2025-08-12": 596.9077400819252,
    "2025-08-13": 599.9843991809003,
    "2025-08-14": 603.0610582798752,
    "2025-08-15": 606.1377173788502,
    "2025-08-16": 609.2143764778251,
    "2025-08-17": 612.2910355768001,
    "2025-08-18": 615.367694675775,
    "2025-08-19": 618.4443537747501,
    "2025-08-20": 621.521012873725,
    "2025-08-21": 624.5976719727,
    "2025-08-22": 627.6743310716749,
    "2025-08-23": 630.7509901706499,
    "2025-08-24": 633.8276492696249,
    "2025-08-25": 636.9043083685998,
    "2025-08-26": 639.9809674675748,
    "2025-08-27": 643.0576265665497,
    "2025-08-28": 646.1342856655248,
    "2025-08-29": 649.2109447644997,
    "2025-08-30": 652.2876038634747,
    "2025-08-31": 655.3642629624496,
    "2025-09-01": 657.5906041179711,
    "2025-09-02": 659.8169452734926,
    "2025-09-03": 662.043286429014,
    "2025-09-04": 664.2696275845354,
    "2025-09-05": 666.4959687400569,
    "2025-09-06": 668.7223098955784,
    "2025-09-07": 670.9486510510998,
    "2025-09-08": 673.1749922066213,
    "2025-09-09": 675.4013333621427,
    "2025-09-10": 677.6276745176642,
    "2025-09-11": 679.8540156731856,
    "2025-09-12": 682.0803568287071,
    "2025-09-13": 684.3066979842285,
    "2025-09-14": 686.53303913975,
    "2025-09-15": 688.7593802952715,
    "2025-09-16": 690.9857214507929,
    "2025-09-17": 693.2120626063144,
    "2025-09-18": 695.4384037618358,
    "2025-09-19": 697.6647449173573,
    "2025-09-20": 699.8910860728787,
    "2025-09-21": 702.1174272284002,
    "2025-09-22": 704.3437683839217,
    "2025-09-23": 706.5701095394431,
    "2025-09-24": 708.7964506949645,
    "2025-09-25": 711.022791850486,
    "2025-09-26": 713.2491330060075,
    "2025-09-27": 715.475474161529,
    "2025-09-28": 717.7018153170503,
    "2025-09-29": 719.9281564725718,
    "2025-09-30": 722.1544976280933,
  },
};

export const perennialTreeMean: Record<string, Record<string, number>> = {
  Almonds: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.6920369957703296,
    "2024-10-03": 3.3840739915406592,
    "2024-10-04": 5.076110987310988,
    "2024-10-05": 6.768147983081319,
    "2024-10-06": 8.460184978851649,
    "2024-10-07": 10.152221974621977,
    "2024-10-08": 11.844258970392309,
    "2024-10-09": 13.536295966162635,
    "2024-10-10": 15.228332961932969,
    "2024-10-11": 16.920369957703297,
    "2024-10-12": 18.612406953473627,
    "2024-10-13": 20.304443949243957,
    "2024-10-14": 21.996480945014284,
    "2024-10-15": 23.68851794078461,
    "2024-10-16": 25.380554936554944,
    "2024-10-17": 27.072591932325277,
    "2024-10-18": 28.764628928095604,
    "2024-10-19": 30.45666592386593,
    "2024-10-20": 32.148702919636264,
    "2024-10-21": 33.840739915406594,
    "2024-10-22": 35.532776911176924,
    "2024-10-23": 37.22481390694725,
    "2024-10-24": 38.916850902717584,
    "2024-10-25": 40.60888789848791,
    "2024-10-26": 42.30092489425824,
    "2024-10-27": 43.99296189002857,
    "2024-10-28": 45.6849988857989,
    "2024-10-29": 47.37703588156923,
    "2024-10-30": 49.06907287733956,
    "2024-10-31": 50.76110987310989,
    "2024-11-01": 51.501848608296136,
    "2024-11-02": 52.24258734348238,
    "2024-11-03": 52.98332607866863,
    "2024-11-04": 53.72406481385487,
    "2024-11-05": 54.46480354904112,
    "2024-11-06": 55.20554228422736,
    "2024-11-07": 55.94628101941361,
    "2024-11-08": 56.68701975459985,
    "2024-11-09": 57.4277584897861,
    "2024-11-10": 58.16849722497235,
    "2024-11-11": 58.9092359601586,
    "2024-11-12": 59.64997469534484,
    "2024-11-13": 60.390713430531086,
    "2024-11-14": 61.13145216571733,
    "2024-11-15": 61.872190900903576,
    "2024-11-16": 62.612929636089824,
    "2024-11-17": 63.35366837127607,
    "2024-11-18": 64.09440710646231,
    "2024-11-19": 64.83514584164855,
    "2024-11-20": 65.57588457683481,
    "2024-11-21": 66.31662331202105,
    "2024-11-22": 67.0573620472073,
    "2024-11-23": 67.79810078239355,
    "2024-11-24": 68.53883951757979,
    "2024-11-25": 69.27957825276604,
    "2024-11-26": 70.02031698795228,
    "2024-11-27": 70.76105572313853,
    "2024-11-28": 71.50179445832478,
    "2024-11-29": 72.24253319351102,
    "2024-11-30": 72.98327192869726,
    "2024-12-01": 73.31777896727684,
    "2024-12-02": 73.65228600585641,
    "2024-12-03": 73.986793044436,
    "2024-12-04": 74.32130008301557,
    "2024-12-05": 74.65580712159515,
    "2024-12-06": 74.99031416017472,
    "2024-12-07": 75.3248211987543,
    "2024-12-08": 75.65932823733388,
    "2024-12-09": 75.99383527591345,
    "2024-12-10": 76.32834231449303,
    "2024-12-11": 76.6628493530726,
    "2024-12-12": 76.99735639165218,
    "2024-12-13": 77.33186343023176,
    "2024-12-14": 77.66637046881134,
    "2024-12-15": 78.00087750739091,
    "2024-12-16": 78.33538454597048,
    "2024-12-17": 78.66989158455006,
    "2024-12-18": 79.00439862312965,
    "2024-12-19": 79.33890566170922,
    "2024-12-20": 79.6734127002888,
    "2024-12-21": 80.00791973886837,
    "2024-12-22": 80.34242677744794,
    "2024-12-23": 80.67693381602751,
    "2024-12-24": 81.0114408546071,
    "2024-12-25": 81.34594789318668,
    "2024-12-26": 81.68045493176625,
    "2024-12-27": 82.01496197034582,
    "2024-12-28": 82.34946900892541,
    "2024-12-29": 82.68397604750498,
    "2024-12-30": 83.01848308608456,
    "2024-12-31": 83.35299012466413,
    "2025-01-01": 83.96744707111121,
    "2025-01-02": 84.58190401755827,
    "2025-01-03": 85.19636096400535,
    "2025-01-04": 85.81081791045241,
    "2025-01-05": 86.42527485689949,
    "2025-01-06": 87.03973180334656,
    "2025-01-07": 87.65418874979363,
    "2025-01-08": 88.2686456962407,
    "2025-01-09": 88.88310264268777,
    "2025-01-10": 89.49755958913484,
    "2025-01-11": 90.11201653558192,
    "2025-01-12": 90.72647348202898,
    "2025-01-13": 91.34093042847606,
    "2025-01-14": 91.95538737492312,
    "2025-01-15": 92.5698443213702,
    "2025-01-16": 93.18430126781726,
    "2025-01-17": 93.79875821426434,
    "2025-01-18": 94.4132151607114,
    "2025-01-19": 95.02767210715848,
    "2025-01-20": 95.64212905360554,
    "2025-01-21": 96.25658600005262,
    "2025-01-22": 96.87104294649968,
    "2025-01-23": 97.48549989294676,
    "2025-01-24": 98.09995683939384,
    "2025-01-25": 98.7144137858409,
    "2025-01-26": 99.32887073228795,
    "2025-01-27": 99.94332767873505,
    "2025-01-28": 100.55778462518212,
    "2025-01-29": 101.1722415716292,
    "2025-01-30": 101.78669851807626,
    "2025-01-31": 102.40115546452331,
    "2025-02-01": 103.442999466578,
    "2025-02-02": 104.48484346863268,
    "2025-02-03": 105.52668747068736,
    "2025-02-04": 106.56853147274202,
    "2025-02-05": 107.6103754747967,
    "2025-02-06": 108.65221947685136,
    "2025-02-07": 109.69406347890606,
    "2025-02-08": 110.73590748096072,
    "2025-02-09": 111.7777514830154,
    "2025-02-10": 112.81959548507008,
    "2025-02-11": 113.86143948712476,
    "2025-02-12": 114.90328348917944,
    "2025-02-13": 115.9451274912341,
    "2025-02-14": 116.98697149328878,
    "2025-02-15": 118.02881549534344,
    "2025-02-16": 119.07065949739813,
    "2025-02-17": 120.1125034994528,
    "2025-02-18": 121.15434750150747,
    "2025-02-19": 122.19619150356216,
    "2025-02-20": 123.23803550561684,
    "2025-02-21": 124.27987950767152,
    "2025-02-22": 125.32172350972618,
    "2025-02-23": 126.36356751178086,
    "2025-02-24": 127.40541151383552,
    "2025-02-25": 128.44725551589022,
    "2025-02-26": 129.48909951794488,
    "2025-02-27": 130.53094351999954,
    "2025-02-28": 131.57278752205423,
    "2025-03-01": 133.6935563350486,
    "2025-03-02": 135.814325148043,
    "2025-03-03": 137.93509396103738,
    "2025-03-04": 140.05586277403177,
    "2025-03-05": 142.17663158702615,
    "2025-03-06": 144.29740040002054,
    "2025-03-07": 146.41816921301492,
    "2025-03-08": 148.5389380260093,
    "2025-03-09": 150.6597068390037,
    "2025-03-10": 152.78047565199807,
    "2025-03-11": 154.90124446499246,
    "2025-03-12": 157.02201327798684,
    "2025-03-13": 159.14278209098123,
    "2025-03-14": 161.2635509039756,
    "2025-03-15": 163.38431971697003,
    "2025-03-16": 165.50508852996438,
    "2025-03-17": 167.6258573429588,
    "2025-03-18": 169.74662615595315,
    "2025-03-19": 171.86739496894756,
    "2025-03-20": 173.98816378194192,
    "2025-03-21": 176.1089325949363,
    "2025-03-22": 178.22970140793072,
    "2025-03-23": 180.3504702209251,
    "2025-03-24": 182.4712390339195,
    "2025-03-25": 184.59200784691387,
    "2025-03-26": 186.71277665990823,
    "2025-03-27": 188.83354547290264,
    "2025-03-28": 190.95431428589703,
    "2025-03-29": 193.0750830988914,
    "2025-03-30": 195.1958519118858,
    "2025-03-31": 197.31662072488015,
    "2025-04-01": 200.981635146744,
    "2025-04-02": 204.6466495686078,
    "2025-04-03": 208.3116639904716,
    "2025-04-04": 211.97667841233545,
    "2025-04-05": 215.64169283419923,
    "2025-04-06": 219.30670725606305,
    "2025-04-07": 222.9717216779269,
    "2025-04-08": 226.63673609979065,
    "2025-04-09": 230.30175052165447,
    "2025-04-10": 233.96676494351829,
    "2025-04-11": 237.6317793653821,
    "2025-04-12": 241.29679378724592,
    "2025-04-13": 244.9618082091097,
    "2025-04-14": 248.62682263097352,
    "2025-04-15": 252.2918370528373,
    "2025-04-16": 255.95685147470115,
    "2025-04-17": 259.62186589656494,
    "2025-04-18": 263.2868803184288,
    "2025-04-19": 266.9518947402926,
    "2025-04-20": 270.6169091621564,
    "2025-04-21": 274.2819235840202,
    "2025-04-22": 277.946938005884,
    "2025-04-23": 281.61195242774784,
    "2025-04-24": 285.27696684961165,
    "2025-04-25": 288.94198127147547,
    "2025-04-26": 292.60699569333923,
    "2025-04-27": 296.27201011520305,
    "2025-04-28": 299.93702453706686,
    "2025-04-29": 303.6020389589307,
    "2025-04-30": 307.2670533807945,
    "2025-05-01": 312.1132109938083,
    "2025-05-02": 316.9593686068222,
    "2025-05-03": 321.805526219836,
    "2025-05-04": 326.65168383284987,
    "2025-05-05": 331.4978414458637,
    "2025-05-06": 336.3439990588776,
    "2025-05-07": 341.1901566718914,
    "2025-05-08": 346.03631428490525,
    "2025-05-09": 350.88247189791906,
    "2025-05-10": 355.72862951093293,
    "2025-05-11": 360.5747871239468,
    "2025-05-12": 365.4209447369606,
    "2025-05-13": 370.2671023499744,
    "2025-05-14": 375.1132599629883,
    "2025-05-15": 379.9594175760021,
    "2025-05-16": 384.805575189016,
    "2025-05-17": 389.6517328020298,
    "2025-05-18": 394.4978904150437,
    "2025-05-19": 399.3440480280575,
    "2025-05-20": 404.1902056410714,
    "2025-05-21": 409.0363632540852,
    "2025-05-22": 413.8825208670991,
    "2025-05-23": 418.7286784801129,
    "2025-05-24": 423.5748360931267,
    "2025-05-25": 428.42099370614056,
    "2025-05-26": 433.2671513191544,
    "2025-05-27": 438.11330893216825,
    "2025-05-28": 442.95946654518207,
    "2025-05-29": 447.805624158196,
    "2025-05-30": 452.6517817712098,
    "2025-05-31": 457.4979393842236,
    "2025-06-01": 463.12649064264383,
    "2025-06-02": 468.755041901064,
    "2025-06-03": 474.3835931594842,
    "2025-06-04": 480.0121444179044,
    "2025-06-05": 485.6406956763246,
    "2025-06-06": 491.2692469347448,
    "2025-06-07": 496.897798193165,
    "2025-06-08": 502.5263494515852,
    "2025-06-09": 508.1549007100054,
    "2025-06-10": 513.7834519684255,
    "2025-06-11": 519.4120032268457,
    "2025-06-12": 525.040554485266,
    "2025-06-13": 530.6691057436861,
    "2025-06-14": 536.2976570021063,
    "2025-06-15": 541.9262082605266,
    "2025-06-16": 547.5547595189468,
    "2025-06-17": 553.183310777367,
    "2025-06-18": 558.8118620357872,
    "2025-06-19": 564.4404132942074,
    "2025-06-20": 570.0689645526276,
    "2025-06-21": 575.6975158110477,
    "2025-06-22": 581.3260670694679,
    "2025-06-23": 586.954618327888,
    "2025-06-24": 592.5831695863083,
    "2025-06-25": 598.2117208447285,
    "2025-06-26": 603.8402721031487,
    "2025-06-27": 609.4688233615689,
    "2025-06-28": 615.0973746199891,
    "2025-06-29": 620.7259258784093,
    "2025-06-30": 626.3544771368295,
    "2025-07-01": 631.9131020773791,
    "2025-07-02": 637.4717270179287,
    "2025-07-03": 643.0303519584785,
    "2025-07-04": 648.5889768990281,
    "2025-07-05": 654.1476018395778,
    "2025-07-06": 659.7062267801274,
    "2025-07-07": 665.2648517206771,
    "2025-07-08": 670.8234766612268,
    "2025-07-09": 676.3821016017764,
    "2025-07-10": 681.940726542326,
    "2025-07-11": 687.4993514828757,
    "2025-07-12": 693.0579764234254,
    "2025-07-13": 698.6166013639751,
    "2025-07-14": 704.1752263045247,
    "2025-07-15": 709.7338512450743,
    "2025-07-16": 715.2924761856241,
    "2025-07-17": 720.8511011261737,
    "2025-07-18": 726.4097260667234,
    "2025-07-19": 731.968351007273,
    "2025-07-20": 737.5269759478226,
    "2025-07-21": 743.0856008883724,
    "2025-07-22": 748.644225828922,
    "2025-07-23": 754.2028507694716,
    "2025-07-24": 759.7614757100214,
    "2025-07-25": 765.320100650571,
    "2025-07-26": 770.8787255911207,
    "2025-07-27": 776.4373505316703,
    "2025-07-28": 781.9959754722199,
    "2025-07-29": 787.5546004127696,
    "2025-07-30": 793.1132253533193,
    "2025-07-31": 798.6718502938689,
    "2025-08-01": 802.3766503955046,
    "2025-08-02": 806.0814504971403,
    "2025-08-03": 809.7862505987758,
    "2025-08-04": 813.4910507004115,
    "2025-08-05": 817.1958508020472,
    "2025-08-06": 820.9006509036828,
    "2025-08-07": 824.6054510053184,
    "2025-08-08": 828.3102511069541,
    "2025-08-09": 832.0150512085897,
    "2025-08-10": 835.7198513102254,
    "2025-08-11": 839.4246514118611,
    "2025-08-12": 843.1294515134966,
    "2025-08-13": 846.8342516151323,
    "2025-08-14": 850.539051716768,
    "2025-08-15": 854.2438518184036,
    "2025-08-16": 857.9486519200392,
    "2025-08-17": 861.6534520216749,
    "2025-08-18": 865.3582521233105,
    "2025-08-19": 869.0630522249462,
    "2025-08-20": 872.7678523265818,
    "2025-08-21": 876.4726524282174,
    "2025-08-22": 880.1774525298531,
    "2025-08-23": 883.8822526314888,
    "2025-08-24": 887.5870527331244,
    "2025-08-25": 891.29185283476,
    "2025-08-26": 894.9966529363957,
    "2025-08-27": 898.7014530380313,
    "2025-08-28": 902.406253139667,
    "2025-08-29": 906.1110532413026,
    "2025-08-30": 909.8158533429382,
    "2025-08-31": 913.520653444574,
    "2025-09-01": 916.1656591001424,
    "2025-09-02": 918.8106647557108,
    "2025-09-03": 921.4556704112792,
    "2025-09-04": 924.1006760668477,
    "2025-09-05": 926.745681722416,
    "2025-09-06": 929.3906873779844,
    "2025-09-07": 932.0356930335528,
    "2025-09-08": 934.6806986891212,
    "2025-09-09": 937.3257043446896,
    "2025-09-10": 939.970710000258,
    "2025-09-11": 942.6157156558264,
    "2025-09-12": 945.2607213113948,
    "2025-09-13": 947.9057269669632,
    "2025-09-14": 950.5507326225317,
    "2025-09-15": 953.1957382781,
    "2025-09-16": 955.8407439336684,
    "2025-09-17": 958.4857495892368,
    "2025-09-18": 961.1307552448052,
    "2025-09-19": 963.7757609003736,
    "2025-09-20": 966.420766555942,
    "2025-09-21": 969.0657722115104,
    "2025-09-22": 971.710777867079,
    "2025-09-23": 974.3557835226474,
    "2025-09-24": 977.0007891782158,
    "2025-09-25": 979.6457948337842,
    "2025-09-26": 982.2908004893526,
    "2025-09-27": 984.935806144921,
    "2025-09-28": 987.5808118004894,
    "2025-09-29": 990.2258174560578,
    "2025-09-30": 992.8708231116262,
  },
  Apples: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.208171654474986,
    "2024-10-03": 4.416343308949972,
    "2024-10-04": 6.624514963424957,
    "2024-10-05": 8.832686617899943,
    "2024-10-06": 11.04085827237493,
    "2024-10-07": 13.249029926849914,
    "2024-10-08": 15.4572015813249,
    "2024-10-09": 17.665373235799887,
    "2024-10-10": 19.87354489027487,
    "2024-10-11": 22.08171654474986,
    "2024-10-12": 24.289888199224844,
    "2024-10-13": 26.49805985369983,
    "2024-10-14": 28.706231508174817,
    "2024-10-15": 30.9144031626498,
    "2024-10-16": 33.122574817124786,
    "2024-10-17": 35.330746471599774,
    "2024-10-18": 37.53891812607476,
    "2024-10-19": 39.74708978054974,
    "2024-10-20": 41.95526143502473,
    "2024-10-21": 44.16343308949972,
    "2024-10-22": 46.3716047439747,
    "2024-10-23": 48.57977639844969,
    "2024-10-24": 50.78794805292468,
    "2024-10-25": 52.99611970739966,
    "2024-10-26": 55.204291361874645,
    "2024-10-27": 57.41246301634963,
    "2024-10-28": 59.62063467082462,
    "2024-10-29": 61.8288063252996,
    "2024-10-30": 64.03697797977459,
    "2024-10-31": 66.24514963424957,
    "2024-11-01": 67.01853019875863,
    "2024-11-02": 67.79191076326767,
    "2024-11-03": 68.56529132777672,
    "2024-11-04": 69.33867189228577,
    "2024-11-05": 70.11205245679483,
    "2024-11-06": 70.88543302130387,
    "2024-11-07": 71.65881358581292,
    "2024-11-08": 72.43219415032198,
    "2024-11-09": 73.20557471483102,
    "2024-11-10": 73.97895527934007,
    "2024-11-11": 74.75233584384912,
    "2024-11-12": 75.52571640835816,
    "2024-11-13": 76.29909697286722,
    "2024-11-14": 77.07247753737627,
    "2024-11-15": 77.84585810188531,
    "2024-11-16": 78.61923866639437,
    "2024-11-17": 79.39261923090342,
    "2024-11-18": 80.16599979541247,
    "2024-11-19": 80.93938035992151,
    "2024-11-20": 81.71276092443057,
    "2024-11-21": 82.48614148893962,
    "2024-11-22": 83.25952205344868,
    "2024-11-23": 84.03290261795772,
    "2024-11-24": 84.80628318246677,
    "2024-11-25": 85.57966374697583,
    "2024-11-26": 86.35304431148487,
    "2024-11-27": 87.12642487599392,
    "2024-11-28": 87.89980544050297,
    "2024-11-29": 88.67318600501201,
    "2024-11-30": 89.44656656952107,
    "2024-12-01": 89.8960310766264,
    "2024-12-02": 90.34549558373172,
    "2024-12-03": 90.79496009083708,
    "2024-12-04": 91.2444245979424,
    "2024-12-05": 91.69388910504776,
    "2024-12-06": 92.14335361215308,
    "2024-12-07": 92.59281811925842,
    "2024-12-08": 93.04228262636376,
    "2024-12-09": 93.49174713346908,
    "2024-12-10": 93.94121164057442,
    "2024-12-11": 94.39067614767976,
    "2024-12-12": 94.8401406547851,
    "2024-12-13": 95.28960516189044,
    "2024-12-14": 95.73906966899575,
    "2024-12-15": 96.1885341761011,
    "2024-12-16": 96.63799868320643,
    "2024-12-17": 97.08746319031178,
    "2024-12-18": 97.53692769741713,
    "2024-12-19": 97.98639220452245,
    "2024-12-20": 98.4358567116278,
    "2024-12-21": 98.88532121873313,
    "2024-12-22": 99.33478572583846,
    "2024-12-23": 99.7842502329438,
    "2024-12-24": 100.23371474004912,
    "2024-12-25": 100.68317924715448,
    "2024-12-26": 101.1326437542598,
    "2024-12-27": 101.58210826136514,
    "2024-12-28": 102.03157276847048,
    "2024-12-29": 102.48103727557582,
    "2024-12-30": 102.93050178268116,
    "2024-12-31": 103.37996628978648,
    "2025-01-01": 104.15905987159223,
    "2025-01-02": 104.938153453398,
    "2025-01-03": 105.71724703520375,
    "2025-01-04": 106.49634061700952,
    "2025-01-05": 107.27543419881526,
    "2025-01-06": 108.05452778062104,
    "2025-01-07": 108.83362136242678,
    "2025-01-08": 109.61271494423254,
    "2025-01-09": 110.3918085260383,
    "2025-01-10": 111.17090210784406,
    "2025-01-11": 111.9499956896498,
    "2025-01-12": 112.72908927145556,
    "2025-01-13": 113.50818285326132,
    "2025-01-14": 114.28727643506708,
    "2025-01-15": 115.06637001687284,
    "2025-01-16": 115.8454635986786,
    "2025-01-17": 116.62455718048436,
    "2025-01-18": 117.40365076229013,
    "2025-01-19": 118.18274434409588,
    "2025-01-20": 118.96183792590163,
    "2025-01-21": 119.7409315077074,
    "2025-01-22": 120.52002508951314,
    "2025-01-23": 121.29911867131892,
    "2025-01-24": 122.07821225312466,
    "2025-01-25": 122.8573058349304,
    "2025-01-26": 123.63639941673615,
    "2025-01-27": 124.41549299854194,
    "2025-01-28": 125.19458658034767,
    "2025-01-29": 125.97368016215344,
    "2025-01-30": 126.7527737439592,
    "2025-01-31": 127.53186732576496,
    "2025-02-01": 128.68219414327197,
    "2025-02-02": 129.83252096077896,
    "2025-02-03": 130.98284777828596,
    "2025-02-04": 132.13317459579298,
    "2025-02-05": 133.28350141329997,
    "2025-02-06": 134.43382823080697,
    "2025-02-07": 135.58415504831396,
    "2025-02-08": 136.73448186582098,
    "2025-02-09": 137.88480868332798,
    "2025-02-10": 139.03513550083497,
    "2025-02-11": 140.18546231834196,
    "2025-02-12": 141.33578913584898,
    "2025-02-13": 142.48611595335598,
    "2025-02-14": 143.63644277086297,
    "2025-02-15": 144.78676958836996,
    "2025-02-16": 145.937096405877,
    "2025-02-17": 147.08742322338398,
    "2025-02-18": 148.23775004089097,
    "2025-02-19": 149.388076858398,
    "2025-02-20": 150.538403675905,
    "2025-02-21": 151.68873049341198,
    "2025-02-22": 152.83905731091895,
    "2025-02-23": 153.989384128426,
    "2025-02-24": 155.139710945933,
    "2025-02-25": 156.29003776343998,
    "2025-02-26": 157.44036458094698,
    "2025-02-27": 158.590691398454,
    "2025-02-28": 159.741018215961,
    "2025-03-01": 161.30982793452503,
    "2025-03-02": 162.87863765308907,
    "2025-03-03": 164.4474473716531,
    "2025-03-04": 166.01625709021715,
    "2025-03-05": 167.5850668087812,
    "2025-03-06": 169.15387652734526,
    "2025-03-07": 170.7226862459093,
    "2025-03-08": 172.29149596447334,
    "2025-03-09": 173.86030568303738,
    "2025-03-10": 175.42911540160142,
    "2025-03-11": 176.99792512016546,
    "2025-03-12": 178.5667348387295,
    "2025-03-13": 180.13554455729354,
    "2025-03-14": 181.7043542758576,
    "2025-03-15": 183.2731639944216,
    "2025-03-16": 184.8419737129857,
    "2025-03-17": 186.41078343154973,
    "2025-03-18": 187.97959315011377,
    "2025-03-19": 189.5484028686778,
    "2025-03-20": 191.11721258724185,
    "2025-03-21": 192.6860223058059,
    "2025-03-22": 194.25483202436996,
    "2025-03-23": 195.823641742934,
    "2025-03-24": 197.392451461498,
    "2025-03-25": 198.96126118006205,
    "2025-03-26": 200.5300708986261,
    "2025-03-27": 202.09888061719016,
    "2025-03-28": 203.66769033575417,
    "2025-03-29": 205.23650005431824,
    "2025-03-30": 206.80530977288228,
    "2025-03-31": 208.37411949144632,
    "2025-04-01": 211.1246877605141,
    "2025-04-02": 213.87525602958195,
    "2025-04-03": 216.62582429864972,
    "2025-04-04": 219.3763925677176,
    "2025-04-05": 222.12696083678537,
    "2025-04-06": 224.8775291058532,
    "2025-04-07": 227.628097374921,
    "2025-04-08": 230.3786656439888,
    "2025-04-09": 233.12923391305665,
    "2025-04-10": 235.87980218212445,
    "2025-04-11": 238.63037045119225,
    "2025-04-12": 241.38093872026008,
    "2025-04-13": 244.13150698932787,
    "2025-04-14": 246.88207525839567,
    "2025-04-15": 249.6326435274635,
    "2025-04-16": 252.38321179653133,
    "2025-04-17": 255.13378006559915,
    "2025-04-18": 257.8843483346669,
    "2025-04-19": 260.6349166037347,
    "2025-04-20": 263.3854848728026,
    "2025-04-21": 266.1360531418704,
    "2025-04-22": 268.8866214109382,
    "2025-04-23": 271.637189680006,
    "2025-04-24": 274.38775794907383,
    "2025-04-25": 277.13832621814163,
    "2025-04-26": 279.8888944872094,
    "2025-04-27": 282.6394627562772,
    "2025-04-28": 285.390031025345,
    "2025-04-29": 288.1405992944129,
    "2025-04-30": 290.8911675634807,
    "2025-05-01": 294.05992367798854,
    "2025-05-02": 297.22867979249634,
    "2025-05-03": 300.3974359070042,
    "2025-05-04": 303.56619202151205,
    "2025-05-05": 306.73494813601985,
    "2025-05-06": 309.9037042505277,
    "2025-05-07": 313.0724603650356,
    "2025-05-08": 316.24121647954337,
    "2025-05-09": 319.4099725940512,
    "2025-05-10": 322.5787287085591,
    "2025-05-11": 325.7474848230669,
    "2025-05-12": 328.91624093757474,
    "2025-05-13": 332.0849970520826,
    "2025-05-14": 335.2537531665904,
    "2025-05-15": 338.42250928109826,
    "2025-05-16": 341.5912653956061,
    "2025-05-17": 344.7600215101139,
    "2025-05-18": 347.9287776246218,
    "2025-05-19": 351.09753373912963,
    "2025-05-20": 354.2662898536375,
    "2025-05-21": 357.4350459681453,
    "2025-05-22": 360.6038020826532,
    "2025-05-23": 363.772558197161,
    "2025-05-24": 366.9413143116688,
    "2025-05-25": 370.1100704261767,
    "2025-05-26": 373.2788265406845,
    "2025-05-27": 376.4475826551923,
    "2025-05-28": 379.6163387697002,
    "2025-05-29": 382.785094884208,
    "2025-05-30": 385.9538509987159,
    "2025-05-31": 389.1226071132237,
    "2025-06-01": 392.4382495517215,
    "2025-06-02": 395.7538919902192,
    "2025-06-03": 399.069534428717,
    "2025-06-04": 402.3851768672148,
    "2025-06-05": 405.70081930571257,
    "2025-06-06": 409.0164617442104,
    "2025-06-07": 412.3321041827081,
    "2025-06-08": 415.647746621206,
    "2025-06-09": 418.9633890597037,
    "2025-06-10": 422.2790314982015,
    "2025-06-11": 425.5946739366993,
    "2025-06-12": 428.91031637519706,
    "2025-06-13": 432.2259588136948,
    "2025-06-14": 435.5416012521926,
    "2025-06-15": 438.8572436906904,
    "2025-06-16": 442.17288612918816,
    "2025-06-17": 445.48852856768593,
    "2025-06-18": 448.8041710061837,
    "2025-06-19": 452.1198134446815,
    "2025-06-20": 455.4354558831793,
    "2025-06-21": 458.7510983216771,
    "2025-06-22": 462.06674076017487,
    "2025-06-23": 465.38238319867264,
    "2025-06-24": 468.6980256371704,
    "2025-06-25": 472.0136680756682,
    "2025-06-26": 475.329310514166,
    "2025-06-27": 478.6449529526637,
    "2025-06-28": 481.9605953911615,
    "2025-06-29": 485.2762378296593,
    "2025-06-30": 488.591880268157,
    "2025-07-01": 492.3183636604873,
    "2025-07-02": 496.04484705281743,
    "2025-07-03": 499.7713304451476,
    "2025-07-04": 503.49781383747774,
    "2025-07-05": 507.2242972298079,
    "2025-07-06": 510.9507806221381,
    "2025-07-07": 514.6772640144683,
    "2025-07-08": 518.4037474067984,
    "2025-07-09": 522.1302307991286,
    "2025-07-10": 525.8567141914588,
    "2025-07-11": 529.5831975837889,
    "2025-07-12": 533.3096809761191,
    "2025-07-13": 537.0361643684492,
    "2025-07-14": 540.7626477607794,
    "2025-07-15": 544.4891311531096,
    "2025-07-16": 548.2156145454397,
    "2025-07-17": 551.94209793777,
    "2025-07-18": 555.6685813301001,
    "2025-07-19": 559.3950647224302,
    "2025-07-20": 563.1215481147605,
    "2025-07-21": 566.8480315070906,
    "2025-07-22": 570.5745148994208,
    "2025-07-23": 574.300998291751,
    "2025-07-24": 578.0274816840811,
    "2025-07-25": 581.7539650764113,
    "2025-07-26": 585.4804484687414,
    "2025-07-27": 589.2069318610716,
    "2025-07-28": 592.9334152534018,
    "2025-07-29": 596.6598986457319,
    "2025-07-30": 600.3863820380622,
    "2025-07-31": 604.1128654303923,
    "2025-08-01": 607.2995345728879,
    "2025-08-02": 610.4862037153833,
    "2025-08-03": 613.6728728578789,
    "2025-08-04": 616.8595420003745,
    "2025-08-05": 620.0462111428701,
    "2025-08-06": 623.2328802853656,
    "2025-08-07": 626.4195494278612,
    "2025-08-08": 629.6062185703568,
    "2025-08-09": 632.7928877128523,
    "2025-08-10": 635.9795568553478,
    "2025-08-11": 639.1662259978434,
    "2025-08-12": 642.352895140339,
    "2025-08-13": 645.5395642828346,
    "2025-08-14": 648.7262334253301,
    "2025-08-15": 651.9129025678257,
    "2025-08-16": 655.0995717103212,
    "2025-08-17": 658.2862408528168,
    "2025-08-18": 661.4729099953123,
    "2025-08-19": 664.6595791378079,
    "2025-08-20": 667.8462482803035,
    "2025-08-21": 671.0329174227991,
    "2025-08-22": 674.2195865652945,
    "2025-08-23": 677.4062557077901,
    "2025-08-24": 680.5929248502857,
    "2025-08-25": 683.7795939927812,
    "2025-08-26": 686.9662631352768,
    "2025-08-27": 690.1529322777724,
    "2025-08-28": 693.339601420268,
    "2025-08-29": 696.5262705627636,
    "2025-08-30": 699.712939705259,
    "2025-08-31": 702.8996088477546,
    "2025-09-01": 705.3325035953268,
    "2025-09-02": 707.7653983428988,
    "2025-09-03": 710.198293090471,
    "2025-09-04": 712.631187838043,
    "2025-09-05": 715.0640825856152,
    "2025-09-06": 717.4969773331874,
    "2025-09-07": 719.9298720807594,
    "2025-09-08": 722.3627668283316,
    "2025-09-09": 724.7956615759036,
    "2025-09-10": 727.2285563234758,
    "2025-09-11": 729.661451071048,
    "2025-09-12": 732.09434581862,
    "2025-09-13": 734.5272405661922,
    "2025-09-14": 736.9601353137642,
    "2025-09-15": 739.3930300613364,
    "2025-09-16": 741.8259248089086,
    "2025-09-17": 744.2588195564806,
    "2025-09-18": 746.6917143040528,
    "2025-09-19": 749.1246090516248,
    "2025-09-20": 751.557503799197,
    "2025-09-21": 753.9903985467691,
    "2025-09-22": 756.4232932943412,
    "2025-09-23": 758.8561880419134,
    "2025-09-24": 761.2890827894854,
    "2025-09-25": 763.7219775370576,
    "2025-09-26": 766.1548722846297,
    "2025-09-27": 768.5877670322018,
    "2025-09-28": 771.020661779774,
    "2025-09-29": 773.4535565273461,
    "2025-09-30": 775.8864512749182,
  },
  Apricots: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.051653803040964,
    "2024-10-03": 4.103307606081928,
    "2024-10-04": 6.154961409122892,
    "2024-10-05": 8.206615212163856,
    "2024-10-06": 10.25826901520482,
    "2024-10-07": 12.309922818245784,
    "2024-10-08": 14.361576621286748,
    "2024-10-09": 16.41323042432771,
    "2024-10-10": 18.464884227368675,
    "2024-10-11": 20.51653803040964,
    "2024-10-12": 22.5681918334506,
    "2024-10-13": 24.61984563649157,
    "2024-10-14": 26.67149943953253,
    "2024-10-15": 28.723153242573492,
    "2024-10-16": 30.77480704561446,
    "2024-10-17": 32.82646084865542,
    "2024-10-18": 34.878114651696386,
    "2024-10-19": 36.92976845473735,
    "2024-10-20": 38.98142225777831,
    "2024-10-21": 41.03307606081928,
    "2024-10-22": 43.08472986386024,
    "2024-10-23": 45.1363836669012,
    "2024-10-24": 47.18803746994217,
    "2024-10-25": 49.23969127298314,
    "2024-10-26": 51.2913450760241,
    "2024-10-27": 53.34299887906506,
    "2024-10-28": 55.39465268210603,
    "2024-10-29": 57.44630648514699,
    "2024-10-30": 59.497960288187954,
    "2024-10-31": 61.54961409122891,
    "2024-11-01": 62.13116537652046,
    "2024-11-02": 62.71271666181201,
    "2024-11-03": 63.29426794710356,
    "2024-11-04": 63.87581923239511,
    "2024-11-05": 64.45737051768666,
    "2024-11-06": 65.03892180297821,
    "2024-11-07": 65.62047308826976,
    "2024-11-08": 66.2020243735613,
    "2024-11-09": 66.78357565885285,
    "2024-11-10": 67.36512694414441,
    "2024-11-11": 67.94667822943595,
    "2024-11-12": 68.5282295147275,
    "2024-11-13": 69.10978080001905,
    "2024-11-14": 69.69133208531059,
    "2024-11-15": 70.27288337060214,
    "2024-11-16": 70.8544346558937,
    "2024-11-17": 71.43598594118525,
    "2024-11-18": 72.0175372264768,
    "2024-11-19": 72.59908851176834,
    "2024-11-20": 73.1806397970599,
    "2024-11-21": 73.76219108235145,
    "2024-11-22": 74.34374236764299,
    "2024-11-23": 74.92529365293454,
    "2024-11-24": 75.5068449382261,
    "2024-11-25": 76.08839622351763,
    "2024-11-26": 76.66994750880919,
    "2024-11-27": 77.25149879410074,
    "2024-11-28": 77.83305007939228,
    "2024-11-29": 78.41460136468383,
    "2024-11-30": 78.99615264997539,
    "2024-12-01": 79.2821015208014,
    "2024-12-02": 79.56805039162742,
    "2024-12-03": 79.85399926245344,
    "2024-12-04": 80.13994813327946,
    "2024-12-05": 80.42589700410548,
    "2024-12-06": 80.7118458749315,
    "2024-12-07": 80.99779474575752,
    "2024-12-08": 81.28374361658352,
    "2024-12-09": 81.56969248740954,
    "2024-12-10": 81.85564135823556,
    "2024-12-11": 82.14159022906158,
    "2024-12-12": 82.4275390998876,
    "2024-12-13": 82.71348797071362,
    "2024-12-14": 82.99943684153963,
    "2024-12-15": 83.28538571236565,
    "2024-12-16": 83.57133458319167,
    "2024-12-17": 83.85728345401769,
    "2024-12-18": 84.14323232484371,
    "2024-12-19": 84.42918119566973,
    "2024-12-20": 84.71513006649575,
    "2024-12-21": 85.00107893732176,
    "2024-12-22": 85.28702780814778,
    "2024-12-23": 85.57297667897379,
    "2024-12-24": 85.8589255497998,
    "2024-12-25": 86.14487442062583,
    "2024-12-26": 86.43082329145184,
    "2024-12-27": 86.71677216227786,
    "2024-12-28": 87.00272103310388,
    "2024-12-29": 87.2886699039299,
    "2024-12-30": 87.57461877475592,
    "2024-12-31": 87.86056764558194,
    "2025-01-01": 88.4288495777046,
    "2025-01-02": 88.99713150982727,
    "2025-01-03": 89.56541344194993,
    "2025-01-04": 90.1336953740726,
    "2025-01-05": 90.70197730619526,
    "2025-01-06": 91.27025923831792,
    "2025-01-07": 91.8385411704406,
    "2025-01-08": 92.40682310256328,
    "2025-01-09": 92.97510503468592,
    "2025-01-10": 93.54338696680858,
    "2025-01-11": 94.11166889893126,
    "2025-01-12": 94.67995083105392,
    "2025-01-13": 95.2482327631766,
    "2025-01-14": 95.81651469529923,
    "2025-01-15": 96.38479662742192,
    "2025-01-16": 96.95307855954458,
    "2025-01-17": 97.52136049166724,
    "2025-01-18": 98.08964242378993,
    "2025-01-19": 98.65792435591258,
    "2025-01-20": 99.22620628803524,
    "2025-01-21": 99.79448822015792,
    "2025-01-22": 100.36277015228058,
    "2025-01-23": 100.93105208440323,
    "2025-01-24": 101.4993340165259,
    "2025-01-25": 102.06761594864857,
    "2025-01-26": 102.63589788077124,
    "2025-01-27": 103.2041798128939,
    "2025-01-28": 103.77246174501656,
    "2025-01-29": 104.34074367713924,
    "2025-01-30": 104.9090256092619,
    "2025-01-31": 105.47730754138456,
    "2025-02-01": 106.37969530709326,
    "2025-02-02": 107.28208307280195,
    "2025-02-03": 108.18447083851063,
    "2025-02-04": 109.08685860421934,
    "2025-02-05": 109.98924636992804,
    "2025-02-06": 110.89163413563674,
    "2025-02-07": 111.79402190134542,
    "2025-02-08": 112.69640966705413,
    "2025-02-09": 113.5987974327628,
    "2025-02-10": 114.5011851984715,
    "2025-02-11": 115.4035729641802,
    "2025-02-12": 116.3059607298889,
    "2025-02-13": 117.2083484955976,
    "2025-02-14": 118.11073626130629,
    "2025-02-15": 119.01312402701498,
    "2025-02-16": 119.91551179272368,
    "2025-02-17": 120.81789955843236,
    "2025-02-18": 121.72028732414108,
    "2025-02-19": 122.62267508984976,
    "2025-02-20": 123.52506285555845,
    "2025-02-21": 124.42745062126716,
    "2025-02-22": 125.32983838697584,
    "2025-02-23": 126.23222615268456,
    "2025-02-24": 127.13461391839324,
    "2025-02-25": 128.03700168410194,
    "2025-02-26": 128.93938944981062,
    "2025-02-27": 129.8417772155193,
    "2025-02-28": 130.744164981228,
    "2025-03-01": 132.3972720634563,
    "2025-03-02": 134.05037914568462,
    "2025-03-03": 135.70348622791292,
    "2025-03-04": 137.35659331014122,
    "2025-03-05": 139.00970039236952,
    "2025-03-06": 140.66280747459783,
    "2025-03-07": 142.31591455682613,
    "2025-03-08": 143.96902163905443,
    "2025-03-09": 145.6221287212827,
    "2025-03-10": 147.27523580351104,
    "2025-03-11": 148.92834288573934,
    "2025-03-12": 150.58144996796764,
    "2025-03-13": 152.23455705019597,
    "2025-03-14": 153.88766413242422,
    "2025-03-15": 155.54077121465252,
    "2025-03-16": 157.19387829688085,
    "2025-03-17": 158.84698537910913,
    "2025-03-18": 160.50009246133743,
    "2025-03-19": 162.15319954356573,
    "2025-03-20": 163.80630662579404,
    "2025-03-21": 165.45941370802234,
    "2025-03-22": 167.11252079025064,
    "2025-03-23": 168.76562787247894,
    "2025-03-24": 170.41873495470725,
    "2025-03-25": 172.07184203693555,
    "2025-03-26": 173.72494911916385,
    "2025-03-27": 175.37805620139216,
    "2025-03-28": 177.03116328362046,
    "2025-03-29": 178.68427036584876,
    "2025-03-30": 180.33737744807704,
    "2025-03-31": 181.99048453030537,
    "2025-04-01": 185.1999367766084,
    "2025-04-02": 188.40938902291148,
    "2025-04-03": 191.61884126921453,
    "2025-04-04": 194.8282935155176,
    "2025-04-05": 198.03774576182064,
    "2025-04-06": 201.2471980081237,
    "2025-04-07": 204.45665025442676,
    "2025-04-08": 207.66610250072975,
    "2025-04-09": 210.8755547470328,
    "2025-04-10": 214.0850069933359,
    "2025-04-11": 217.2944592396389,
    "2025-04-12": 220.503911485942,
    "2025-04-13": 223.71336373224503,
    "2025-04-14": 226.9228159785481,
    "2025-04-15": 230.13226822485117,
    "2025-04-16": 233.3417204711542,
    "2025-04-17": 236.55117271745723,
    "2025-04-18": 239.7606249637603,
    "2025-04-19": 242.97007721006332,
    "2025-04-20": 246.1795294563664,
    "2025-04-21": 249.38898170266947,
    "2025-04-22": 252.5984339489725,
    "2025-04-23": 255.8078861952756,
    "2025-04-24": 259.0173384415786,
    "2025-04-25": 262.22679068788165,
    "2025-04-26": 265.43624293418475,
    "2025-04-27": 268.6456951804878,
    "2025-04-28": 271.85514742679084,
    "2025-04-29": 275.0645996730939,
    "2025-04-30": 278.2740519193969,
    "2025-05-01": 282.26376103464486,
    "2025-05-02": 286.2534701498928,
    "2025-05-03": 290.24317926514067,
    "2025-05-04": 294.2328883803886,
    "2025-05-05": 298.22259749563653,
    "2025-05-06": 302.21230661088447,
    "2025-05-07": 306.2020157261324,
    "2025-05-08": 310.1917248413803,
    "2025-05-09": 314.1814339566282,
    "2025-05-10": 318.17114307187614,
    "2025-05-11": 322.1608521871241,
    "2025-05-12": 326.150561302372,
    "2025-05-13": 330.14027041761994,
    "2025-05-14": 334.1299795328678,
    "2025-05-15": 338.1196886481157,
    "2025-05-16": 342.1093977633637,
    "2025-05-17": 346.0991068786116,
    "2025-05-18": 350.0888159938595,
    "2025-05-19": 354.07852510910743,
    "2025-05-20": 358.06823422435536,
    "2025-05-21": 362.0579433396033,
    "2025-05-22": 366.0476524548512,
    "2025-05-23": 370.0373615700992,
    "2025-05-24": 374.02707068534704,
    "2025-05-25": 378.016779800595,
    "2025-05-26": 382.0064889158429,
    "2025-05-27": 385.9961980310909,
    "2025-05-28": 389.9859071463387,
    "2025-05-29": 393.97561626158665,
    "2025-05-30": 397.9653253768346,
    "2025-05-31": 401.9550344920825,
    "2025-06-01": 406.755510083842,
    "2025-06-02": 411.5559856756015,
    "2025-06-03": 416.35646126736094,
    "2025-06-04": 421.1569368591205,
    "2025-06-05": 425.95741245087993,
    "2025-06-06": 430.75788804263937,
    "2025-06-07": 435.55836363439886,
    "2025-06-08": 440.3588392261584,
    "2025-06-09": 445.15931481791785,
    "2025-06-10": 449.9597904096773,
    "2025-06-11": 454.7602660014368,
    "2025-06-12": 459.5607415931962,
    "2025-06-13": 464.36121718495576,
    "2025-06-14": 469.1616927767152,
    "2025-06-15": 473.9621683684747,
    "2025-06-16": 478.7626439602342,
    "2025-06-17": 483.5631195519936,
    "2025-06-18": 488.3635951437531,
    "2025-06-19": 493.1640707355126,
    "2025-06-20": 497.9645463272721,
    "2025-06-21": 502.7650219190316,
    "2025-06-22": 507.56549751079103,
    "2025-06-23": 512.3659731025505,
    "2025-06-24": 517.16644869431,
    "2025-06-25": 521.9669242860695,
    "2025-06-26": 526.7673998778289,
    "2025-06-27": 531.5678754695884,
    "2025-06-28": 536.3683510613479,
    "2025-06-29": 541.1688266531074,
    "2025-06-30": 545.9693022448669,
    "2025-07-01": 550.8202105210645,
    "2025-07-02": 555.6711187972621,
    "2025-07-03": 560.5220270734599,
    "2025-07-04": 565.3729353496575,
    "2025-07-05": 570.2238436258551,
    "2025-07-06": 575.0747519020528,
    "2025-07-07": 579.9256601782504,
    "2025-07-08": 584.776568454448,
    "2025-07-09": 589.6274767306456,
    "2025-07-10": 594.4783850068434,
    "2025-07-11": 599.329293283041,
    "2025-07-12": 604.1802015592386,
    "2025-07-13": 609.0311098354363,
    "2025-07-14": 613.8820181116339,
    "2025-07-15": 618.7329263878316,
    "2025-07-16": 623.5838346640293,
    "2025-07-17": 628.4347429402269,
    "2025-07-18": 633.2856512164245,
    "2025-07-19": 638.1365594926222,
    "2025-07-20": 642.9874677688198,
    "2025-07-21": 647.8383760450174,
    "2025-07-22": 652.6892843212152,
    "2025-07-23": 657.5401925974128,
    "2025-07-24": 662.3911008736104,
    "2025-07-25": 667.242009149808,
    "2025-07-26": 672.0929174260057,
    "2025-07-27": 676.9438257022034,
    "2025-07-28": 681.7947339784009,
    "2025-07-29": 686.6456422545987,
    "2025-07-30": 691.4965505307963,
    "2025-07-31": 696.3474588069939,
    "2025-08-01": 700.1981887316321,
    "2025-08-02": 704.0489186562702,
    "2025-08-03": 707.8996485809083,
    "2025-08-04": 711.7503785055465,
    "2025-08-05": 715.6011084301845,
    "2025-08-06": 719.4518383548226,
    "2025-08-07": 723.3025682794607,
    "2025-08-08": 727.1532982040989,
    "2025-08-09": 731.004028128737,
    "2025-08-10": 734.8547580533751,
    "2025-08-11": 738.7054879780133,
    "2025-08-12": 742.5562179026514,
    "2025-08-13": 746.4069478272895,
    "2025-08-14": 750.2576777519276,
    "2025-08-15": 754.1084076765658,
    "2025-08-16": 757.9591376012038,
    "2025-08-17": 761.8098675258419,
    "2025-08-18": 765.66059745048,
    "2025-08-19": 769.5113273751182,
    "2025-08-20": 773.3620572997563,
    "2025-08-21": 777.2127872243944,
    "2025-08-22": 781.0635171490326,
    "2025-08-23": 784.9142470736707,
    "2025-08-24": 788.7649769983088,
    "2025-08-25": 792.6157069229469,
    "2025-08-26": 796.4664368475851,
    "2025-08-27": 800.3171667722231,
    "2025-08-28": 804.1678966968612,
    "2025-08-29": 808.0186266214994,
    "2025-08-30": 811.8693565461375,
    "2025-08-31": 815.7200864707756,
    "2025-09-01": 818.5685866500829,
    "2025-09-02": 821.4170868293902,
    "2025-09-03": 824.2655870086975,
    "2025-09-04": 827.1140871880048,
    "2025-09-05": 829.9625873673119,
    "2025-09-06": 832.8110875466192,
    "2025-09-07": 835.6595877259265,
    "2025-09-08": 838.5080879052338,
    "2025-09-09": 841.356588084541,
    "2025-09-10": 844.2050882638483,
    "2025-09-11": 847.0535884431556,
    "2025-09-12": 849.9020886224629,
    "2025-09-13": 852.7505888017702,
    "2025-09-14": 855.5990889810774,
    "2025-09-15": 858.4475891603847,
    "2025-09-16": 861.2960893396919,
    "2025-09-17": 864.1445895189992,
    "2025-09-18": 866.9930896983064,
    "2025-09-19": 869.8415898776137,
    "2025-09-20": 872.690090056921,
    "2025-09-21": 875.5385902362283,
    "2025-09-22": 878.3870904155356,
    "2025-09-23": 881.2355905948428,
    "2025-09-24": 884.0840907741501,
    "2025-09-25": 886.9325909534573,
    "2025-09-26": 889.7810911327646,
    "2025-09-27": 892.6295913120719,
    "2025-09-28": 895.4780914913791,
    "2025-09-29": 898.3265916706864,
    "2025-09-30": 901.1750918499936,
  },
  Cherries: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.147862608383272,
    "2024-10-03": 4.295725216766544,
    "2024-10-04": 6.443587825149816,
    "2024-10-05": 8.591450433533089,
    "2024-10-06": 10.73931304191636,
    "2024-10-07": 12.887175650299632,
    "2024-10-08": 15.035038258682905,
    "2024-10-09": 17.182900867066177,
    "2024-10-10": 19.330763475449448,
    "2024-10-11": 21.47862608383272,
    "2024-10-12": 23.626488692215997,
    "2024-10-13": 25.774351300599264,
    "2024-10-14": 27.92221390898254,
    "2024-10-15": 30.07007651736581,
    "2024-10-16": 32.21793912574908,
    "2024-10-17": 34.365801734132354,
    "2024-10-18": 36.513664342515625,
    "2024-10-19": 38.661526950898896,
    "2024-10-20": 40.809389559282174,
    "2024-10-21": 42.957252167665445,
    "2024-10-22": 45.10511477604872,
    "2024-10-23": 47.25297738443199,
    "2024-10-24": 49.40083999281526,
    "2024-10-25": 51.54870260119853,
    "2024-10-26": 53.696565209581806,
    "2024-10-27": 55.84442781796508,
    "2024-10-28": 57.99229042634835,
    "2024-10-29": 60.14015303473162,
    "2024-10-30": 62.28801564311489,
    "2024-10-31": 64.43587825149817,
    "2024-11-01": 65.18607246493274,
    "2024-11-02": 65.9362666783673,
    "2024-11-03": 66.68646089180187,
    "2024-11-04": 67.43665510523644,
    "2024-11-05": 68.18684931867101,
    "2024-11-06": 68.93704353210558,
    "2024-11-07": 69.68723774554014,
    "2024-11-08": 70.43743195897471,
    "2024-11-09": 71.18762617240928,
    "2024-11-10": 71.93782038584385,
    "2024-11-11": 72.68801459927842,
    "2024-11-12": 73.43820881271299,
    "2024-11-13": 74.18840302614755,
    "2024-11-14": 74.93859723958212,
    "2024-11-15": 75.68879145301669,
    "2024-11-16": 76.43898566645126,
    "2024-11-17": 77.18917987988583,
    "2024-11-18": 77.9393740933204,
    "2024-11-19": 78.68956830675496,
    "2024-11-20": 79.43976252018953,
    "2024-11-21": 80.1899567336241,
    "2024-11-22": 80.94015094705867,
    "2024-11-23": 81.69034516049324,
    "2024-11-24": 82.4405393739278,
    "2024-11-25": 83.19073358736237,
    "2024-11-26": 83.94092780079694,
    "2024-11-27": 84.69112201423151,
    "2024-11-28": 85.44131622766608,
    "2024-11-29": 86.19151044110065,
    "2024-11-30": 86.94170465453522,
    "2024-12-01": 87.30094394021783,
    "2024-12-02": 87.66018322590047,
    "2024-12-03": 88.01942251158309,
    "2024-12-04": 88.37866179726572,
    "2024-12-05": 88.73790108294834,
    "2024-12-06": 89.09714036863096,
    "2024-12-07": 89.4563796543136,
    "2024-12-08": 89.81561893999621,
    "2024-12-09": 90.17485822567885,
    "2024-12-10": 90.53409751136148,
    "2024-12-11": 90.8933367970441,
    "2024-12-12": 91.25257608272672,
    "2024-12-13": 91.61181536840934,
    "2024-12-14": 91.97105465409196,
    "2024-12-15": 92.3302939397746,
    "2024-12-16": 92.68953322545724,
    "2024-12-17": 93.04877251113984,
    "2024-12-18": 93.40801179682248,
    "2024-12-19": 93.7672510825051,
    "2024-12-20": 94.12649036818772,
    "2024-12-21": 94.48572965387037,
    "2024-12-22": 94.84496893955296,
    "2024-12-23": 95.2042082252356,
    "2024-12-24": 95.56344751091822,
    "2024-12-25": 95.92268679660086,
    "2024-12-26": 96.28192608228348,
    "2024-12-27": 96.6411653679661,
    "2024-12-28": 97.00040465364872,
    "2024-12-29": 97.35964393933136,
    "2024-12-30": 97.71888322501395,
    "2024-12-31": 98.0781225106966,
    "2025-01-01": 98.69534270894825,
    "2025-01-02": 99.31256290719986,
    "2025-01-03": 99.9297831054515,
    "2025-01-04": 100.54700330370314,
    "2025-01-05": 101.16422350195477,
    "2025-01-06": 101.7814437002064,
    "2025-01-07": 102.39866389845804,
    "2025-01-08": 103.01588409670968,
    "2025-01-09": 103.6331042949613,
    "2025-01-10": 104.25032449321291,
    "2025-01-11": 104.86754469146456,
    "2025-01-12": 105.4847648897162,
    "2025-01-13": 106.10198508796782,
    "2025-01-14": 106.71920528621946,
    "2025-01-15": 107.33642548447108,
    "2025-01-16": 107.95364568272272,
    "2025-01-17": 108.57086588097437,
    "2025-01-18": 109.188086079226,
    "2025-01-19": 109.80530627747764,
    "2025-01-20": 110.42252647572926,
    "2025-01-21": 111.03974667398089,
    "2025-01-22": 111.65696687223252,
    "2025-01-23": 112.27418707048416,
    "2025-01-24": 112.8914072687358,
    "2025-01-25": 113.50862746698742,
    "2025-01-26": 114.12584766523904,
    "2025-01-27": 114.74306786349068,
    "2025-01-28": 115.36028806174232,
    "2025-01-29": 115.97750825999395,
    "2025-01-30": 116.59472845824558,
    "2025-01-31": 117.2119486564972,
    "2025-02-01": 118.21268042490998,
    "2025-02-02": 119.21341219332274,
    "2025-02-03": 120.2141439617355,
    "2025-02-04": 121.21487573014828,
    "2025-02-05": 122.21560749856104,
    "2025-02-06": 123.2163392669738,
    "2025-02-07": 124.21707103538655,
    "2025-02-08": 125.21780280379932,
    "2025-02-09": 126.21853457221208,
    "2025-02-10": 127.21926634062486,
    "2025-02-11": 128.21999810903762,
    "2025-02-12": 129.2207298774504,
    "2025-02-13": 130.22146164586314,
    "2025-02-14": 131.22219341427592,
    "2025-02-15": 132.2229251826887,
    "2025-02-16": 133.22365695110145,
    "2025-02-17": 134.22438871951422,
    "2025-02-18": 135.22512048792697,
    "2025-02-19": 136.22585225633975,
    "2025-02-20": 137.2265840247525,
    "2025-02-21": 138.22731579316527,
    "2025-02-22": 139.22804756157802,
    "2025-02-23": 140.2287793299908,
    "2025-02-24": 141.22951109840358,
    "2025-02-25": 142.23024286681633,
    "2025-02-26": 143.2309746352291,
    "2025-02-27": 144.23170640364185,
    "2025-02-28": 145.23243817205463,
    "2025-03-01": 146.90233789514477,
    "2025-03-02": 148.5722376182349,
    "2025-03-03": 150.24213734132505,
    "2025-03-04": 151.91203706441522,
    "2025-03-05": 153.58193678750536,
    "2025-03-06": 155.2518365105955,
    "2025-03-07": 156.92173623368564,
    "2025-03-08": 158.59163595677578,
    "2025-03-09": 160.26153567986591,
    "2025-03-10": 161.93143540295603,
    "2025-03-11": 163.6013351260462,
    "2025-03-12": 165.27123484913636,
    "2025-03-13": 166.9411345722265,
    "2025-03-14": 168.61103429531664,
    "2025-03-15": 170.28093401840678,
    "2025-03-16": 171.95083374149692,
    "2025-03-17": 173.62073346458706,
    "2025-03-18": 175.2906331876772,
    "2025-03-19": 176.96053291076737,
    "2025-03-20": 178.6304326338575,
    "2025-03-21": 180.30033235694765,
    "2025-03-22": 181.9702320800378,
    "2025-03-23": 183.64013180312796,
    "2025-03-24": 185.31003152621807,
    "2025-03-25": 186.9799312493082,
    "2025-03-26": 188.6498309723984,
    "2025-03-27": 190.3197306954885,
    "2025-03-28": 191.98963041857863,
    "2025-03-29": 193.6595301416688,
    "2025-03-30": 195.3294298647589,
    "2025-03-31": 196.99932958784908,
    "2025-04-01": 200.3985965305872,
    "2025-04-02": 203.79786347332524,
    "2025-04-03": 207.1971304160633,
    "2025-04-04": 210.59639735880137,
    "2025-04-05": 213.99566430153945,
    "2025-04-06": 217.39493124427756,
    "2025-04-07": 220.7941981870156,
    "2025-04-08": 224.1934651297537,
    "2025-04-09": 227.5927320724917,
    "2025-04-10": 230.99199901522985,
    "2025-04-11": 234.3912659579679,
    "2025-04-12": 237.79053290070595,
    "2025-04-13": 241.18979984344404,
    "2025-04-14": 244.5890667861821,
    "2025-04-15": 247.98833372892017,
    "2025-04-16": 251.38760067165825,
    "2025-04-17": 254.78686761439636,
    "2025-04-18": 258.1861345571344,
    "2025-04-19": 261.5854014998725,
    "2025-04-20": 264.98466844261054,
    "2025-04-21": 268.38393538534865,
    "2025-04-22": 271.7832023280867,
    "2025-04-23": 275.18246927082475,
    "2025-04-24": 278.58173621356286,
    "2025-04-25": 281.9810031563009,
    "2025-04-26": 285.38027009903897,
    "2025-04-27": 288.7795370417771,
    "2025-04-28": 292.1788039845151,
    "2025-04-29": 295.5780709272532,
    "2025-04-30": 298.9773378699913,
    "2025-05-01": 302.99057747908705,
    "2025-05-02": 307.00381708818287,
    "2025-05-03": 311.01705669727863,
    "2025-05-04": 315.03029630637445,
    "2025-05-05": 319.0435359154702,
    "2025-05-06": 323.056775524566,
    "2025-05-07": 327.0700151336618,
    "2025-05-08": 331.0832547427576,
    "2025-05-09": 335.0964943518534,
    "2025-05-10": 339.10973396094914,
    "2025-05-11": 343.12297357004496,
    "2025-05-12": 347.1362131791407,
    "2025-05-13": 351.14945278823654,
    "2025-05-14": 355.1626923973323,
    "2025-05-15": 359.17593200642807,
    "2025-05-16": 363.1891716155239,
    "2025-05-17": 367.20241122461965,
    "2025-05-18": 371.2156508337155,
    "2025-05-19": 375.2288904428112,
    "2025-05-20": 379.242130051907,
    "2025-05-21": 383.2553696610028,
    "2025-05-22": 387.2686092700986,
    "2025-05-23": 391.2818488791944,
    "2025-05-24": 395.29508848829016,
    "2025-05-25": 399.3083280973859,
    "2025-05-26": 403.32156770648174,
    "2025-05-27": 407.3348073155776,
    "2025-05-28": 411.3480469246733,
    "2025-05-29": 415.3612865337691,
    "2025-05-30": 419.3745261428649,
    "2025-05-31": 423.3877657519607,
    "2025-06-01": 428.175616616913,
    "2025-06-02": 432.9634674818655,
    "2025-06-03": 437.7513183468178,
    "2025-06-04": 442.53916921177023,
    "2025-06-05": 447.3270200767226,
    "2025-06-06": 452.114870941675,
    "2025-06-07": 456.90272180662737,
    "2025-06-08": 461.6905726715797,
    "2025-06-09": 466.47842353653215,
    "2025-06-10": 471.2662744014845,
    "2025-06-11": 476.0541252664369,
    "2025-06-12": 480.8419761313893,
    "2025-06-13": 485.6298269963417,
    "2025-06-14": 490.41767786129407,
    "2025-06-15": 495.2055287262465,
    "2025-06-16": 499.9933795911989,
    "2025-06-17": 504.7812304561512,
    "2025-06-18": 509.5690813211036,
    "2025-06-19": 514.356932186056,
    "2025-06-20": 519.1447830510084,
    "2025-06-21": 523.9326339159608,
    "2025-06-22": 528.7204847809131,
    "2025-06-23": 533.5083356458656,
    "2025-06-24": 538.296186510818,
    "2025-06-25": 543.0840373757703,
    "2025-06-26": 547.8718882407227,
    "2025-06-27": 552.659739105675,
    "2025-06-28": 557.4475899706274,
    "2025-06-29": 562.2354408355799,
    "2025-06-30": 567.0232917005322,
    "2025-07-01": 572.012559037073,
    "2025-07-02": 577.0018263736137,
    "2025-07-03": 581.9910937101544,
    "2025-07-04": 586.9803610466951,
    "2025-07-05": 591.9696283832358,
    "2025-07-06": 596.9588957197765,
    "2025-07-07": 601.9481630563172,
    "2025-07-08": 606.9374303928579,
    "2025-07-09": 611.9266977293986,
    "2025-07-10": 616.9159650659393,
    "2025-07-11": 621.90523240248,
    "2025-07-12": 626.8944997390207,
    "2025-07-13": 631.8837670755614,
    "2025-07-14": 636.8730344121022,
    "2025-07-15": 641.862301748643,
    "2025-07-16": 646.8515690851837,
    "2025-07-17": 651.8408364217244,
    "2025-07-18": 656.8301037582651,
    "2025-07-19": 661.8193710948058,
    "2025-07-20": 666.8086384313465,
    "2025-07-21": 671.7979057678872,
    "2025-07-22": 676.7871731044279,
    "2025-07-23": 681.7764404409686,
    "2025-07-24": 686.7657077775093,
    "2025-07-25": 691.75497511405,
    "2025-07-26": 696.7442424505907,
    "2025-07-27": 701.7335097871314,
    "2025-07-28": 706.7227771236721,
    "2025-07-29": 711.7120444602128,
    "2025-07-30": 716.7013117967535,
    "2025-07-31": 721.6905791332942,
    "2025-08-01": 725.5762205045927,
    "2025-08-02": 729.4618618758913,
    "2025-08-03": 733.3475032471897,
    "2025-08-04": 737.2331446184883,
    "2025-08-05": 741.1187859897867,
    "2025-08-06": 745.0044273610852,
    "2025-08-07": 748.8900687323837,
    "2025-08-08": 752.7757101036822,
    "2025-08-09": 756.6613514749806,
    "2025-08-10": 760.5469928462792,
    "2025-08-11": 764.4326342175776,
    "2025-08-12": 768.3182755888762,
    "2025-08-13": 772.2039169601746,
    "2025-08-14": 776.0895583314731,
    "2025-08-15": 779.9751997027716,
    "2025-08-16": 783.8608410740701,
    "2025-08-17": 787.7464824453687,
    "2025-08-18": 791.6321238166671,
    "2025-08-19": 795.5177651879656,
    "2025-08-20": 799.4034065592641,
    "2025-08-21": 803.2890479305626,
    "2025-08-22": 807.174689301861,
    "2025-08-23": 811.0603306731596,
    "2025-08-24": 814.945972044458,
    "2025-08-25": 818.8316134157566,
    "2025-08-26": 822.717254787055,
    "2025-08-27": 826.6028961583536,
    "2025-08-28": 830.488537529652,
    "2025-08-29": 834.3741789009505,
    "2025-08-30": 838.259820272249,
    "2025-08-31": 842.1454616435475,
    "2025-09-01": 845.2168288697331,
    "2025-09-02": 848.2881960959188,
    "2025-09-03": 851.3595633221043,
    "2025-09-04": 854.43093054829,
    "2025-09-05": 857.5022977744757,
    "2025-09-06": 860.5736650006613,
    "2025-09-07": 863.645032226847,
    "2025-09-08": 866.7163994530325,
    "2025-09-09": 869.7877666792182,
    "2025-09-10": 872.8591339054038,
    "2025-09-11": 875.9305011315895,
    "2025-09-12": 879.0018683577752,
    "2025-09-13": 882.0732355839607,
    "2025-09-14": 885.1446028101464,
    "2025-09-15": 888.215970036332,
    "2025-09-16": 891.2873372625177,
    "2025-09-17": 894.3587044887033,
    "2025-09-18": 897.4300717148889,
    "2025-09-19": 900.5014389410745,
    "2025-09-20": 903.5728061672602,
    "2025-09-21": 906.6441733934458,
    "2025-09-22": 909.7155406196316,
    "2025-09-23": 912.786907845817,
    "2025-09-24": 915.8582750720028,
    "2025-09-25": 918.9296422981884,
    "2025-09-26": 922.001009524374,
    "2025-09-27": 925.0723767505596,
    "2025-09-28": 928.1437439767452,
    "2025-09-29": 931.2151112029308,
    "2025-09-30": 934.2864784291164,
  },
  Citrus: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.8557214406072415,
    "2024-10-03": 3.711442881214484,
    "2024-10-04": 5.567164321821725,
    "2024-10-05": 7.422885762428967,
    "2024-10-06": 9.27860720303621,
    "2024-10-07": 11.13432864364345,
    "2024-10-08": 12.990050084250692,
    "2024-10-09": 14.845771524857934,
    "2024-10-10": 16.701492965465174,
    "2024-10-11": 18.55721440607242,
    "2024-10-12": 20.41293584667966,
    "2024-10-13": 22.2686572872869,
    "2024-10-14": 24.124378727894143,
    "2024-10-15": 25.980100168501384,
    "2024-10-16": 27.835821609108628,
    "2024-10-17": 29.691543049715868,
    "2024-10-18": 31.54726449032311,
    "2024-10-19": 33.40298593093035,
    "2024-10-20": 35.2587073715376,
    "2024-10-21": 37.11442881214484,
    "2024-10-22": 38.97015025275208,
    "2024-10-23": 40.82587169335932,
    "2024-10-24": 42.68159313396656,
    "2024-10-25": 44.5373145745738,
    "2024-10-26": 46.393036015181046,
    "2024-10-27": 48.24875745578829,
    "2024-10-28": 50.10447889639553,
    "2024-10-29": 51.96020033700277,
    "2024-10-30": 53.81592177761001,
    "2024-10-31": 55.671643218217255,
    "2024-11-01": 56.52354139370933,
    "2024-11-02": 57.37543956920141,
    "2024-11-03": 58.227337744693486,
    "2024-11-04": 59.07923592018556,
    "2024-11-05": 59.93113409567764,
    "2024-11-06": 60.78303227116971,
    "2024-11-07": 61.63493044666178,
    "2024-11-08": 62.486828622153865,
    "2024-11-09": 63.33872679764594,
    "2024-11-10": 64.19062497313801,
    "2024-11-11": 65.0425231486301,
    "2024-11-12": 65.89442132412216,
    "2024-11-13": 66.74631949961424,
    "2024-11-14": 67.59821767510631,
    "2024-11-15": 68.4501158505984,
    "2024-11-16": 69.30201402609048,
    "2024-11-17": 70.15391220158254,
    "2024-11-18": 71.00581037707462,
    "2024-11-19": 71.85770855256669,
    "2024-11-20": 72.70960672805877,
    "2024-11-21": 73.56150490355085,
    "2024-11-22": 74.41340307904292,
    "2024-11-23": 75.265301254535,
    "2024-11-24": 76.11719943002709,
    "2024-11-25": 76.96909760551915,
    "2024-11-26": 77.82099578101123,
    "2024-11-27": 78.6728939565033,
    "2024-11-28": 79.52479213199538,
    "2024-11-29": 80.37669030748745,
    "2024-11-30": 81.22858848297953,
    "2024-12-01": 81.80455935285852,
    "2024-12-02": 82.3805302227375,
    "2024-12-03": 82.95650109261649,
    "2024-12-04": 83.53247196249548,
    "2024-12-05": 84.10844283237446,
    "2024-12-06": 84.68441370225347,
    "2024-12-07": 85.26038457213245,
    "2024-12-08": 85.83635544201144,
    "2024-12-09": 86.41232631189042,
    "2024-12-10": 86.98829718176941,
    "2024-12-11": 87.5642680516484,
    "2024-12-12": 88.14023892152738,
    "2024-12-13": 88.71620979140637,
    "2024-12-14": 89.29218066128536,
    "2024-12-15": 89.86815153116434,
    "2024-12-16": 90.44412240104332,
    "2024-12-17": 91.02009327092232,
    "2024-12-18": 91.59606414080132,
    "2024-12-19": 92.1720350106803,
    "2024-12-20": 92.74800588055928,
    "2024-12-21": 93.32397675043828,
    "2024-12-22": 93.89994762031726,
    "2024-12-23": 94.47591849019624,
    "2024-12-24": 95.05188936007524,
    "2024-12-25": 95.62786022995422,
    "2024-12-26": 96.20383109983322,
    "2024-12-27": 96.7798019697122,
    "2024-12-28": 97.3557728395912,
    "2024-12-29": 97.93174370947018,
    "2024-12-30": 98.50771457934916,
    "2024-12-31": 99.08368544922816,
    "2025-01-01": 99.7298828338499,
    "2025-01-02": 100.37608021847166,
    "2025-01-03": 101.0222776030934,
    "2025-01-04": 101.66847498771514,
    "2025-01-05": 102.31467237233689,
    "2025-01-06": 102.96086975695864,
    "2025-01-07": 103.6070671415804,
    "2025-01-08": 104.25326452620212,
    "2025-01-09": 104.89946191082387,
    "2025-01-10": 105.54565929544565,
    "2025-01-11": 106.19185668006736,
    "2025-01-12": 106.83805406468912,
    "2025-01-13": 107.48425144931086,
    "2025-01-14": 108.13044883393262,
    "2025-01-15": 108.77664621855436,
    "2025-01-16": 109.4228436031761,
    "2025-01-17": 110.06904098779783,
    "2025-01-18": 110.7152383724196,
    "2025-01-19": 111.36143575704136,
    "2025-01-20": 112.00763314166308,
    "2025-01-21": 112.65383052628484,
    "2025-01-22": 113.3000279109066,
    "2025-01-23": 113.94622529552834,
    "2025-01-24": 114.59242268015008,
    "2025-01-25": 115.23862006477182,
    "2025-01-26": 115.88481744939358,
    "2025-01-27": 116.53101483401532,
    "2025-01-28": 117.17721221863708,
    "2025-01-29": 117.82340960325882,
    "2025-01-30": 118.46960698788055,
    "2025-01-31": 119.11580437250232,
    "2025-02-01": 120.35930931017182,
    "2025-02-02": 121.60281424784132,
    "2025-02-03": 122.84631918551084,
    "2025-02-04": 124.08982412318036,
    "2025-02-05": 125.33332906084986,
    "2025-02-06": 126.57683399851936,
    "2025-02-07": 127.82033893618888,
    "2025-02-08": 129.0638438738584,
    "2025-02-09": 130.3073488115279,
    "2025-02-10": 131.55085374919742,
    "2025-02-11": 132.7943586868669,
    "2025-02-12": 134.0378636245364,
    "2025-02-13": 135.28136856220593,
    "2025-02-14": 136.52487349987544,
    "2025-02-15": 137.76837843754495,
    "2025-02-16": 139.01188337521447,
    "2025-02-17": 140.25538831288398,
    "2025-02-18": 141.49889325055346,
    "2025-02-19": 142.74239818822298,
    "2025-02-20": 143.9859031258925,
    "2025-02-21": 145.229408063562,
    "2025-02-22": 146.47291300123152,
    "2025-02-23": 147.71641793890103,
    "2025-02-24": 148.95992287657054,
    "2025-02-25": 150.20342781424006,
    "2025-02-26": 151.44693275190954,
    "2025-02-27": 152.69043768957906,
    "2025-02-28": 153.93394262724857,
    "2025-03-01": 155.5453080607724,
    "2025-03-02": 157.15667349429626,
    "2025-03-03": 158.7680389278201,
    "2025-03-04": 160.37940436134394,
    "2025-03-05": 161.9907697948678,
    "2025-03-06": 163.60213522839163,
    "2025-03-07": 165.21350066191548,
    "2025-03-08": 166.82486609543932,
    "2025-03-09": 168.43623152896316,
    "2025-03-10": 170.047596962487,
    "2025-03-11": 171.65896239601085,
    "2025-03-12": 173.2703278295347,
    "2025-03-13": 174.88169326305854,
    "2025-03-14": 176.49305869658238,
    "2025-03-15": 178.10442413010622,
    "2025-03-16": 179.71578956363007,
    "2025-03-17": 181.3271549971539,
    "2025-03-18": 182.93852043067776,
    "2025-03-19": 184.5498858642016,
    "2025-03-20": 186.16125129772544,
    "2025-03-21": 187.7726167312493,
    "2025-03-22": 189.38398216477316,
    "2025-03-23": 190.99534759829697,
    "2025-03-24": 192.6067130318208,
    "2025-03-25": 194.21807846534463,
    "2025-03-26": 195.8294438988685,
    "2025-03-27": 197.44080933239235,
    "2025-03-28": 199.0521747659162,
    "2025-03-29": 200.66354019944004,
    "2025-03-30": 202.27490563296388,
    "2025-03-31": 203.88627106648767,
    "2025-04-01": 206.2249993147191,
    "2025-04-02": 208.56372756295048,
    "2025-04-03": 210.90245581118185,
    "2025-04-04": 213.2411840594132,
    "2025-04-05": 215.57991230764455,
    "2025-04-06": 217.91864055587595,
    "2025-04-07": 220.25736880410733,
    "2025-04-08": 222.5960970523387,
    "2025-04-09": 224.93482530057008,
    "2025-04-10": 227.27355354880143,
    "2025-04-11": 229.61228179703284,
    "2025-04-12": 231.95101004526416,
    "2025-04-13": 234.2897382934956,
    "2025-04-14": 236.6284665417269,
    "2025-04-15": 238.9671947899583,
    "2025-04-16": 241.3059230381897,
    "2025-04-17": 243.64465128642104,
    "2025-04-18": 245.98337953465244,
    "2025-04-19": 248.3221077828838,
    "2025-04-20": 250.6608360311152,
    "2025-04-21": 252.99956427934652,
    "2025-04-22": 255.33829252757792,
    "2025-04-23": 257.6770207758093,
    "2025-04-24": 260.01574902404064,
    "2025-04-25": 262.35447727227205,
    "2025-04-26": 264.6932055205034,
    "2025-04-27": 267.0319337687348,
    "2025-04-28": 269.3706620169661,
    "2025-04-29": 271.7093902651975,
    "2025-04-30": 274.0481185134289,
    "2025-05-01": 276.99387968993204,
    "2025-05-02": 279.93964086643524,
    "2025-05-03": 282.8854020429384,
    "2025-05-04": 285.8311632194415,
    "2025-05-05": 288.77692439594466,
    "2025-05-06": 291.72268557244786,
    "2025-05-07": 294.668446748951,
    "2025-05-08": 297.61420792545414,
    "2025-05-09": 300.55996910195734,
    "2025-05-10": 303.5057302784605,
    "2025-05-11": 306.4514914549636,
    "2025-05-12": 309.3972526314668,
    "2025-05-13": 312.34301380796995,
    "2025-05-14": 315.2887749844731,
    "2025-05-15": 318.23453616097623,
    "2025-05-16": 321.18029733747943,
    "2025-05-17": 324.12605851398257,
    "2025-05-18": 327.0718196904857,
    "2025-05-19": 330.01758086698885,
    "2025-05-20": 332.96334204349205,
    "2025-05-21": 335.9091032199952,
    "2025-05-22": 338.8548643964984,
    "2025-05-23": 341.8006255730015,
    "2025-05-24": 344.74638674950467,
    "2025-05-25": 347.6921479260078,
    "2025-05-26": 350.637909102511,
    "2025-05-27": 353.58367027901414,
    "2025-05-28": 356.5294314555173,
    "2025-05-29": 359.4751926320205,
    "2025-05-30": 362.4209538085236,
    "2025-05-31": 365.3667149850268,
    "2025-06-01": 368.7440604158785,
    "2025-06-02": 372.12140584673017,
    "2025-06-03": 375.4987512775819,
    "2025-06-04": 378.8760967084336,
    "2025-06-05": 382.25344213928537,
    "2025-06-06": 385.630787570137,
    "2025-06-07": 389.0081330009888,
    "2025-06-08": 392.3854784318405,
    "2025-06-09": 395.7628238626922,
    "2025-06-10": 399.1401692935439,
    "2025-06-11": 402.51751472439565,
    "2025-06-12": 405.8948601552474,
    "2025-06-13": 409.2722055860991,
    "2025-06-14": 412.6495510169508,
    "2025-06-15": 416.0268964478025,
    "2025-06-16": 419.4042418786543,
    "2025-06-17": 422.781587309506,
    "2025-06-18": 426.15893274035767,
    "2025-06-19": 429.5362781712094,
    "2025-06-20": 432.91362360206114,
    "2025-06-21": 436.2909690329128,
    "2025-06-22": 439.66831446376455,
    "2025-06-23": 443.0456598946163,
    "2025-06-24": 446.423005325468,
    "2025-06-25": 449.8003507563197,
    "2025-06-26": 453.1776961871714,
    "2025-06-27": 456.5550416180232,
    "2025-06-28": 459.9323870488748,
    "2025-06-29": 463.30973247972656,
    "2025-06-30": 466.6870779105783,
    "2025-07-01": 470.20123365437377,
    "2025-07-02": 473.7153893981693,
    "2025-07-03": 477.2295451419647,
    "2025-07-04": 480.7437008857601,
    "2025-07-05": 484.2578566295556,
    "2025-07-06": 487.7720123733511,
    "2025-07-07": 491.2861681171465,
    "2025-07-08": 494.800323860942,
    "2025-07-09": 498.3144796047375,
    "2025-07-10": 501.8286353485329,
    "2025-07-11": 505.3427910923284,
    "2025-07-12": 508.8569468361238,
    "2025-07-13": 512.3711025799192,
    "2025-07-14": 515.8852583237148,
    "2025-07-15": 519.3994140675102,
    "2025-07-16": 522.9135698113057,
    "2025-07-17": 526.4277255551011,
    "2025-07-18": 529.9418812988965,
    "2025-07-19": 533.4560370426921,
    "2025-07-20": 536.9701927864875,
    "2025-07-21": 540.484348530283,
    "2025-07-22": 543.9985042740784,
    "2025-07-23": 547.5126600178739,
    "2025-07-24": 551.0268157616694,
    "2025-07-25": 554.5409715054648,
    "2025-07-26": 558.0551272492603,
    "2025-07-27": 561.5692829930557,
    "2025-07-28": 565.0834387368512,
    "2025-07-29": 568.5975944806466,
    "2025-07-30": 572.1117502244422,
    "2025-07-31": 575.6259059682376,
    "2025-08-01": 578.3908452192682,
    "2025-08-02": 581.1557844702986,
    "2025-08-03": 583.9207237213292,
    "2025-08-04": 586.6856629723596,
    "2025-08-05": 589.4506022233902,
    "2025-08-06": 592.2155414744207,
    "2025-08-07": 594.9804807254512,
    "2025-08-08": 597.7454199764817,
    "2025-08-09": 600.5103592275123,
    "2025-08-10": 603.2752984785427,
    "2025-08-11": 606.0402377295733,
    "2025-08-12": 608.8051769806037,
    "2025-08-13": 611.5701162316343,
    "2025-08-14": 614.3350554826648,
    "2025-08-15": 617.0999947336953,
    "2025-08-16": 619.8649339847258,
    "2025-08-17": 622.6298732357563,
    "2025-08-18": 625.3948124867868,
    "2025-08-19": 628.1597517378174,
    "2025-08-20": 630.9246909888478,
    "2025-08-21": 633.6896302398784,
    "2025-08-22": 636.4545694909089,
    "2025-08-23": 639.2195087419394,
    "2025-08-24": 641.9844479929699,
    "2025-08-25": 644.7493872440004,
    "2025-08-26": 647.5143264950309,
    "2025-08-27": 650.2792657460615,
    "2025-08-28": 653.044204997092,
    "2025-08-29": 655.8091442481225,
    "2025-08-30": 658.574083499153,
    "2025-08-31": 661.3390227501835,
    "2025-09-01": 663.5727717190819,
    "2025-09-02": 665.8065206879802,
    "2025-09-03": 668.0402696568785,
    "2025-09-04": 670.2740186257769,
    "2025-09-05": 672.5077675946752,
    "2025-09-06": 674.7415165635736,
    "2025-09-07": 676.9752655324719,
    "2025-09-08": 679.2090145013702,
    "2025-09-09": 681.4427634702686,
    "2025-09-10": 683.6765124391669,
    "2025-09-11": 685.9102614080653,
    "2025-09-12": 688.1440103769636,
    "2025-09-13": 690.3777593458619,
    "2025-09-14": 692.6115083147603,
    "2025-09-15": 694.8452572836586,
    "2025-09-16": 697.079006252557,
    "2025-09-17": 699.3127552214553,
    "2025-09-18": 701.5465041903536,
    "2025-09-19": 703.780253159252,
    "2025-09-20": 706.0140021281503,
    "2025-09-21": 708.2477510970486,
    "2025-09-22": 710.481500065947,
    "2025-09-23": 712.7152490348453,
    "2025-09-24": 714.9489980037437,
    "2025-09-25": 717.182746972642,
    "2025-09-26": 719.4164959415403,
    "2025-09-27": 721.6502449104387,
    "2025-09-28": 723.883993879337,
    "2025-09-29": 726.1177428482354,
    "2025-09-30": 728.3514918171337,
  },
  Grapes: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.099918030628692,
    "2024-10-03": 4.199836061257384,
    "2024-10-04": 6.299754091886076,
    "2024-10-05": 8.399672122514767,
    "2024-10-06": 10.499590153143458,
    "2024-10-07": 12.599508183772151,
    "2024-10-08": 14.699426214400845,
    "2024-10-09": 16.799344245029534,
    "2024-10-10": 18.899262275658227,
    "2024-10-11": 20.99918030628692,
    "2024-10-12": 23.09909833691561,
    "2024-10-13": 25.199016367544303,
    "2024-10-14": 27.298934398172992,
    "2024-10-15": 29.398852428801685,
    "2024-10-16": 31.49877045943037,
    "2024-10-17": 33.59868849005907,
    "2024-10-18": 35.69860652068776,
    "2024-10-19": 37.79852455131645,
    "2024-10-20": 39.89844258194514,
    "2024-10-21": 41.99836061257383,
    "2024-10-22": 44.098278643202526,
    "2024-10-23": 46.19819667383122,
    "2024-10-24": 48.29811470445991,
    "2024-10-25": 50.398032735088606,
    "2024-10-26": 52.49795076571729,
    "2024-10-27": 54.59786879634599,
    "2024-10-28": 56.69778682697468,
    "2024-10-29": 58.79770485760337,
    "2024-10-30": 60.897622888232064,
    "2024-10-31": 62.99754091886076,
    "2024-11-01": 63.72710424826767,
    "2024-11-02": 64.45666757767457,
    "2024-11-03": 65.18623090708148,
    "2024-11-04": 65.91579423648838,
    "2024-11-05": 66.64535756589528,
    "2024-11-06": 67.3749208953022,
    "2024-11-07": 68.1044842247091,
    "2024-11-08": 68.83404755411601,
    "2024-11-09": 69.56361088352291,
    "2024-11-10": 70.29317421292981,
    "2024-11-11": 71.02273754233673,
    "2024-11-12": 71.75230087174363,
    "2024-11-13": 72.48186420115053,
    "2024-11-14": 73.21142753055744,
    "2024-11-15": 73.94099085996434,
    "2024-11-16": 74.67055418937126,
    "2024-11-17": 75.40011751877816,
    "2024-11-18": 76.12968084818506,
    "2024-11-19": 76.85924417759198,
    "2024-11-20": 77.58880750699888,
    "2024-11-21": 78.31837083640579,
    "2024-11-22": 79.04793416581269,
    "2024-11-23": 79.77749749521959,
    "2024-11-24": 80.5070608246265,
    "2024-11-25": 81.23662415403341,
    "2024-11-26": 81.96618748344031,
    "2024-11-27": 82.69575081284722,
    "2024-11-28": 83.42531414225412,
    "2024-11-29": 84.15487747166102,
    "2024-11-30": 84.88444080106794,
    "2024-12-01": 85.19268203502516,
    "2024-12-02": 85.50092326898238,
    "2024-12-03": 85.8091645029396,
    "2024-12-04": 86.11740573689683,
    "2024-12-05": 86.42564697085405,
    "2024-12-06": 86.73388820481127,
    "2024-12-07": 87.04212943876848,
    "2024-12-08": 87.3503706727257,
    "2024-12-09": 87.65861190668292,
    "2024-12-10": 87.96685314064015,
    "2024-12-11": 88.27509437459737,
    "2024-12-12": 88.58333560855459,
    "2024-12-13": 88.89157684251181,
    "2024-12-14": 89.19981807646903,
    "2024-12-15": 89.50805931042625,
    "2024-12-16": 89.81630054438348,
    "2024-12-17": 90.1245417783407,
    "2024-12-18": 90.43278301229792,
    "2024-12-19": 90.74102424625514,
    "2024-12-20": 91.04926548021236,
    "2024-12-21": 91.35750671416956,
    "2024-12-22": 91.6657479481268,
    "2024-12-23": 91.97398918208404,
    "2024-12-24": 92.28223041604124,
    "2024-12-25": 92.59047164999846,
    "2024-12-26": 92.89871288395568,
    "2024-12-27": 93.2069541179129,
    "2024-12-28": 93.51519535187012,
    "2024-12-29": 93.82343658582737,
    "2024-12-30": 94.13167781978456,
    "2024-12-31": 94.4399190537418,
    "2025-01-01": 95.05730222718284,
    "2025-01-02": 95.6746854006239,
    "2025-01-03": 96.29206857406494,
    "2025-01-04": 96.909451747506,
    "2025-01-05": 97.52683492094704,
    "2025-01-06": 98.14421809438812,
    "2025-01-07": 98.76160126782916,
    "2025-01-08": 99.3789844412702,
    "2025-01-09": 99.99636761471126,
    "2025-01-10": 100.61375078815232,
    "2025-01-11": 101.23113396159336,
    "2025-01-12": 101.8485171350344,
    "2025-01-13": 102.46590030847548,
    "2025-01-14": 103.08328348191652,
    "2025-01-15": 103.70066665535758,
    "2025-01-16": 104.31804982879862,
    "2025-01-17": 104.93543300223968,
    "2025-01-18": 105.55281617568072,
    "2025-01-19": 106.1701993491218,
    "2025-01-20": 106.78758252256284,
    "2025-01-21": 107.40496569600388,
    "2025-01-22": 108.02234886944494,
    "2025-01-23": 108.639732042886,
    "2025-01-24": 109.25711521632704,
    "2025-01-25": 109.87449838976808,
    "2025-01-26": 110.49188156320916,
    "2025-01-27": 111.1092647366502,
    "2025-01-28": 111.72664791009126,
    "2025-01-29": 112.34403108353231,
    "2025-01-30": 112.96141425697336,
    "2025-01-31": 113.5787974304144,
    "2025-02-01": 115.0527455293911,
    "2025-02-02": 116.5266936283678,
    "2025-02-03": 118.00064172734449,
    "2025-02-04": 119.4745898263212,
    "2025-02-05": 120.94853792529788,
    "2025-02-06": 122.42248602427458,
    "2025-02-07": 123.89643412325128,
    "2025-02-08": 125.37038222222796,
    "2025-02-09": 126.84433032120468,
    "2025-02-10": 128.31827842018134,
    "2025-02-11": 129.79222651915805,
    "2025-02-12": 131.26617461813476,
    "2025-02-13": 132.74012271711143,
    "2025-02-14": 134.21407081608814,
    "2025-02-15": 135.68801891506482,
    "2025-02-16": 137.16196701404152,
    "2025-02-17": 138.6359151130182,
    "2025-02-18": 140.1098632119949,
    "2025-02-19": 141.5838113109716,
    "2025-02-20": 143.0577594099483,
    "2025-02-21": 144.531707508925,
    "2025-02-22": 146.0056556079017,
    "2025-02-23": 147.47960370687838,
    "2025-02-24": 148.95355180585506,
    "2025-02-25": 150.42749990483176,
    "2025-02-26": 151.90144800380847,
    "2025-02-27": 153.37539610278515,
    "2025-02-28": 154.84934420176185,
    "2025-03-01": 156.18835742722916,
    "2025-03-02": 157.52737065269648,
    "2025-03-03": 158.8663838781638,
    "2025-03-04": 160.20539710363107,
    "2025-03-05": 161.54441032909838,
    "2025-03-06": 162.8834235545657,
    "2025-03-07": 164.222436780033,
    "2025-03-08": 165.56145000550032,
    "2025-03-09": 166.9004632309676,
    "2025-03-10": 168.23947645643491,
    "2025-03-11": 169.57848968190223,
    "2025-03-12": 170.91750290736954,
    "2025-03-13": 172.25651613283685,
    "2025-03-14": 173.59552935830416,
    "2025-03-15": 174.93454258377147,
    "2025-03-16": 176.27355580923876,
    "2025-03-17": 177.61256903470607,
    "2025-03-18": 178.95158226017338,
    "2025-03-19": 180.2905954856407,
    "2025-03-20": 181.629608711108,
    "2025-03-21": 182.9686219365753,
    "2025-03-22": 184.3076351620426,
    "2025-03-23": 185.6466483875099,
    "2025-03-24": 186.9856616129772,
    "2025-03-25": 188.3246748384445,
    "2025-03-26": 189.66368806391185,
    "2025-03-27": 191.0027012893792,
    "2025-03-28": 192.34171451484644,
    "2025-03-29": 193.68072774031376,
    "2025-03-30": 195.01974096578107,
    "2025-03-31": 196.3587541912484,
    "2025-04-01": 198.92925254097025,
    "2025-04-02": 201.49975089069204,
    "2025-04-03": 204.0702492404139,
    "2025-04-04": 206.6407475901357,
    "2025-04-05": 209.21124593985755,
    "2025-04-06": 211.78174428957936,
    "2025-04-07": 214.3522426393012,
    "2025-04-08": 216.92274098902303,
    "2025-04-09": 219.49323933874487,
    "2025-04-10": 222.06373768846672,
    "2025-04-11": 224.63423603818853,
    "2025-04-12": 227.2047343879104,
    "2025-04-13": 229.7752327376322,
    "2025-04-14": 232.34573108735404,
    "2025-04-15": 234.91622943707583,
    "2025-04-16": 237.4867277867977,
    "2025-04-17": 240.05722613651955,
    "2025-04-18": 242.62772448624136,
    "2025-04-19": 245.1982228359632,
    "2025-04-20": 247.76872118568505,
    "2025-04-21": 250.33921953540687,
    "2025-04-22": 252.9097178851287,
    "2025-04-23": 255.48021623485053,
    "2025-04-24": 258.05071458457235,
    "2025-04-25": 260.6212129342942,
    "2025-04-26": 263.19171128401604,
    "2025-04-27": 265.7622096337378,
    "2025-04-28": 268.3327079834597,
    "2025-04-29": 270.9032063331815,
    "2025-04-30": 273.47370468290336,
    "2025-05-01": 277.4651909636476,
    "2025-05-02": 281.45667724439187,
    "2025-05-03": 285.4481635251361,
    "2025-05-04": 289.4396498058804,
    "2025-05-05": 293.43113608662463,
    "2025-05-06": 297.42262236736894,
    "2025-05-07": 301.4141086481132,
    "2025-05-08": 305.40559492885745,
    "2025-05-09": 309.3970812096017,
    "2025-05-10": 313.388567490346,
    "2025-05-11": 317.3800537710902,
    "2025-05-12": 321.3715400518345,
    "2025-05-13": 325.3630263325787,
    "2025-05-14": 329.354512613323,
    "2025-05-15": 333.34599889406724,
    "2025-05-16": 337.3374851748115,
    "2025-05-17": 341.3289714555558,
    "2025-05-18": 345.32045773630006,
    "2025-05-19": 349.3119440170443,
    "2025-05-20": 353.30343029778857,
    "2025-05-21": 357.2949165785328,
    "2025-05-22": 361.2864028592771,
    "2025-05-23": 365.2778891400213,
    "2025-05-24": 369.2693754207656,
    "2025-05-25": 373.2608617015098,
    "2025-05-26": 377.25234798225415,
    "2025-05-27": 381.2438342629984,
    "2025-05-28": 385.23532054374266,
    "2025-05-29": 389.2268068244869,
    "2025-05-30": 393.2182931052312,
    "2025-05-31": 397.2097793859754,
    "2025-06-01": 402.3185035725904,
    "2025-06-02": 407.4272277592054,
    "2025-06-03": 412.53595194582033,
    "2025-06-04": 417.6446761324353,
    "2025-06-05": 422.75340031905023,
    "2025-06-06": 427.8621245056653,
    "2025-06-07": 432.9708486922802,
    "2025-06-08": 438.0795728788952,
    "2025-06-09": 443.1882970655101,
    "2025-06-10": 448.2970212521251,
    "2025-06-11": 453.40574543874,
    "2025-06-12": 458.514469625355,
    "2025-06-13": 463.62319381197,
    "2025-06-14": 468.73191799858495,
    "2025-06-15": 473.8406421852,
    "2025-06-16": 478.9493663718149,
    "2025-06-17": 484.05809055842985,
    "2025-06-18": 489.1668147450448,
    "2025-06-19": 494.2755389316598,
    "2025-06-20": 499.3842631182748,
    "2025-06-21": 504.4929873048897,
    "2025-06-22": 509.6017114915047,
    "2025-06-23": 514.7104356781197,
    "2025-06-24": 519.8191598647346,
    "2025-06-25": 524.9278840513496,
    "2025-06-26": 530.0366082379645,
    "2025-06-27": 535.1453324245795,
    "2025-06-28": 540.2540566111945,
    "2025-06-29": 545.3627807978095,
    "2025-06-30": 550.4715049844244,
    "2025-07-01": 555.7979358271514,
    "2025-07-02": 561.1243666698783,
    "2025-07-03": 566.4507975126053,
    "2025-07-04": 571.7772283553323,
    "2025-07-05": 577.1036591980593,
    "2025-07-06": 582.4300900407862,
    "2025-07-07": 587.7565208835132,
    "2025-07-08": 593.0829517262401,
    "2025-07-09": 598.4093825689671,
    "2025-07-10": 603.735813411694,
    "2025-07-11": 609.062244254421,
    "2025-07-12": 614.388675097148,
    "2025-07-13": 619.715105939875,
    "2025-07-14": 625.041536782602,
    "2025-07-15": 630.3679676253289,
    "2025-07-16": 635.6943984680559,
    "2025-07-17": 641.0208293107828,
    "2025-07-18": 646.3472601535098,
    "2025-07-19": 651.6736909962367,
    "2025-07-20": 657.0001218389638,
    "2025-07-21": 662.3265526816907,
    "2025-07-22": 667.6529835244177,
    "2025-07-23": 672.9794143671446,
    "2025-07-24": 678.3058452098716,
    "2025-07-25": 683.6322760525985,
    "2025-07-26": 688.9587068953256,
    "2025-07-27": 694.2851377380525,
    "2025-07-28": 699.6115685807795,
    "2025-07-29": 704.9379994235064,
    "2025-07-30": 710.2644302662334,
    "2025-07-31": 715.5908611089603,
    "2025-08-01": 719.8952838685136,
    "2025-08-02": 724.199706628067,
    "2025-08-03": 728.5041293876203,
    "2025-08-04": 732.8085521471737,
    "2025-08-05": 737.112974906727,
    "2025-08-06": 741.4173976662803,
    "2025-08-07": 745.7218204258337,
    "2025-08-08": 750.026243185387,
    "2025-08-09": 754.3306659449404,
    "2025-08-10": 758.6350887044937,
    "2025-08-11": 762.939511464047,
    "2025-08-12": 767.2439342236004,
    "2025-08-13": 771.5483569831537,
    "2025-08-14": 775.8527797427071,
    "2025-08-15": 780.1572025022604,
    "2025-08-16": 784.4616252618137,
    "2025-08-17": 788.766048021367,
    "2025-08-18": 793.0704707809203,
    "2025-08-19": 797.3748935404736,
    "2025-08-20": 801.679316300027,
    "2025-08-21": 805.9837390595803,
    "2025-08-22": 810.2881618191337,
    "2025-08-23": 814.592584578687,
    "2025-08-24": 818.8970073382403,
    "2025-08-25": 823.2014300977937,
    "2025-08-26": 827.505852857347,
    "2025-08-27": 831.8102756169003,
    "2025-08-28": 836.1146983764537,
    "2025-08-29": 840.419121136007,
    "2025-08-30": 844.7235438955604,
    "2025-08-31": 849.0279666551137,
    "2025-09-01": 852.1893112952952,
    "2025-09-02": 855.3506559354768,
    "2025-09-03": 858.5120005756582,
    "2025-09-04": 861.6733452158397,
    "2025-09-05": 864.8346898560213,
    "2025-09-06": 867.9960344962028,
    "2025-09-07": 871.1573791363844,
    "2025-09-08": 874.3187237765659,
    "2025-09-09": 877.4800684167474,
    "2025-09-10": 880.641413056929,
    "2025-09-11": 883.8027576971105,
    "2025-09-12": 886.9641023372919,
    "2025-09-13": 890.1254469774735,
    "2025-09-14": 893.286791617655,
    "2025-09-15": 896.4481362578365,
    "2025-09-16": 899.6094808980181,
    "2025-09-17": 902.7708255381996,
    "2025-09-18": 905.9321701783812,
    "2025-09-19": 909.0935148185628,
    "2025-09-20": 912.254859458744,
    "2025-09-21": 915.4162040989256,
    "2025-09-22": 918.5775487391072,
    "2025-09-23": 921.7388933792888,
    "2025-09-24": 924.9002380194704,
    "2025-09-25": 928.0615826596518,
    "2025-09-26": 931.2229272998334,
    "2025-09-27": 934.3842719400149,
    "2025-09-28": 937.5456165801965,
    "2025-09-29": 940.706961220378,
    "2025-09-30": 943.8683058605594,
  },
  Kiwi: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.007163412544243,
    "2024-10-03": 4.014326825088486,
    "2024-10-04": 6.0214902376327295,
    "2024-10-05": 8.028653650176972,
    "2024-10-06": 10.035817062721216,
    "2024-10-07": 12.04298047526546,
    "2024-10-08": 14.050143887809702,
    "2024-10-09": 16.057307300353944,
    "2024-10-10": 18.06447071289819,
    "2024-10-11": 20.07163412544243,
    "2024-10-12": 22.078797537986677,
    "2024-10-13": 24.08596095053092,
    "2024-10-14": 26.09312436307516,
    "2024-10-15": 28.100287775619403,
    "2024-10-16": 30.107451188163644,
    "2024-10-17": 32.11461460070789,
    "2024-10-18": 34.12177801325213,
    "2024-10-19": 36.12894142579638,
    "2024-10-20": 38.13610483834061,
    "2024-10-21": 40.14326825088486,
    "2024-10-22": 42.1504316634291,
    "2024-10-23": 44.15759507597335,
    "2024-10-24": 46.16475848851759,
    "2024-10-25": 48.17192190106184,
    "2024-10-26": 50.17908531360607,
    "2024-10-27": 52.18624872615032,
    "2024-10-28": 54.19341213869456,
    "2024-10-29": 56.200575551238806,
    "2024-10-30": 58.20773896378305,
    "2024-10-31": 60.21490237632729,
    "2024-11-01": 60.99615607180392,
    "2024-11-02": 61.77740976728055,
    "2024-11-03": 62.55866346275718,
    "2024-11-04": 63.33991715823381,
    "2024-11-05": 64.12117085371044,
    "2024-11-06": 64.90242454918707,
    "2024-11-07": 65.6836782446637,
    "2024-11-08": 66.46493194014033,
    "2024-11-09": 67.24618563561697,
    "2024-11-10": 68.02743933109359,
    "2024-11-11": 68.80869302657023,
    "2024-11-12": 69.58994672204686,
    "2024-11-13": 70.37120041752348,
    "2024-11-14": 71.15245411300012,
    "2024-11-15": 71.93370780847675,
    "2024-11-16": 72.71496150395338,
    "2024-11-17": 73.49621519943001,
    "2024-11-18": 74.27746889490663,
    "2024-11-19": 75.05872259038327,
    "2024-11-20": 75.8399762858599,
    "2024-11-21": 76.62122998133653,
    "2024-11-22": 77.40248367681316,
    "2024-11-23": 78.18373737228978,
    "2024-11-24": 78.96499106776642,
    "2024-11-25": 79.74624476324306,
    "2024-11-26": 80.52749845871969,
    "2024-11-27": 81.30875215419631,
    "2024-11-28": 82.09000584967295,
    "2024-11-29": 82.87125954514957,
    "2024-11-30": 83.6525132406262,
    "2024-12-01": 83.96176899111242,
    "2024-12-02": 84.27102474159865,
    "2024-12-03": 84.58028049208487,
    "2024-12-04": 84.88953624257108,
    "2024-12-05": 85.19879199305731,
    "2024-12-06": 85.50804774354353,
    "2024-12-07": 85.81730349402974,
    "2024-12-08": 86.12655924451597,
    "2024-12-09": 86.43581499500219,
    "2024-12-10": 86.7450707454884,
    "2024-12-11": 87.05432649597464,
    "2024-12-12": 87.36358224646085,
    "2024-12-13": 87.67283799694707,
    "2024-12-14": 87.9820937474333,
    "2024-12-15": 88.29134949791951,
    "2024-12-16": 88.60060524840573,
    "2024-12-17": 88.90986099889196,
    "2024-12-18": 89.21911674937817,
    "2024-12-19": 89.52837249986439,
    "2024-12-20": 89.8376282503506,
    "2024-12-21": 90.14688400083683,
    "2024-12-22": 90.45613975132304,
    "2024-12-23": 90.76539550180928,
    "2024-12-24": 91.0746512522955,
    "2024-12-25": 91.38390700278173,
    "2024-12-26": 91.69316275326791,
    "2024-12-27": 92.00241850375416,
    "2024-12-28": 92.31167425424036,
    "2024-12-29": 92.6209300047266,
    "2024-12-30": 92.93018575521282,
    "2024-12-31": 93.23944150569903,
    "2025-01-01": 93.84000493212348,
    "2025-01-02": 94.44056835854792,
    "2025-01-03": 95.04113178497236,
    "2025-01-04": 95.6416952113968,
    "2025-01-05": 96.24225863782124,
    "2025-01-06": 96.84282206424572,
    "2025-01-07": 97.44338549067017,
    "2025-01-08": 98.0439489170946,
    "2025-01-09": 98.64451234351904,
    "2025-01-10": 99.24507576994348,
    "2025-01-11": 99.84563919636793,
    "2025-01-12": 100.44620262279236,
    "2025-01-13": 101.0467660492168,
    "2025-01-14": 101.64732947564126,
    "2025-01-15": 102.2478929020657,
    "2025-01-16": 102.84845632849016,
    "2025-01-17": 103.4490197549146,
    "2025-01-18": 104.04958318133905,
    "2025-01-19": 104.65014660776347,
    "2025-01-20": 105.25071003418792,
    "2025-01-21": 105.85127346061238,
    "2025-01-22": 106.45183688703682,
    "2025-01-23": 107.05240031346126,
    "2025-01-24": 107.6529637398857,
    "2025-01-25": 108.25352716631016,
    "2025-01-26": 108.8540905927346,
    "2025-01-27": 109.45465401915904,
    "2025-01-28": 110.05521744558348,
    "2025-01-29": 110.65578087200794,
    "2025-01-30": 111.25634429843238,
    "2025-01-31": 111.85690772485682,
    "2025-02-01": 112.77258389938318,
    "2025-02-02": 113.68826007390952,
    "2025-02-03": 114.60393624843589,
    "2025-02-04": 115.51961242296224,
    "2025-02-05": 116.4352885974886,
    "2025-02-06": 117.35096477201496,
    "2025-02-07": 118.26664094654129,
    "2025-02-08": 119.18231712106764,
    "2025-02-09": 120.097993295594,
    "2025-02-10": 121.01366947012036,
    "2025-02-11": 121.9293456446467,
    "2025-02-12": 122.84502181917306,
    "2025-02-13": 123.7606979936994,
    "2025-02-14": 124.67637416822576,
    "2025-02-15": 125.59205034275212,
    "2025-02-16": 126.50772651727848,
    "2025-02-17": 127.42340269180482,
    "2025-02-18": 128.33907886633116,
    "2025-02-19": 129.25475504085753,
    "2025-02-20": 130.17043121538387,
    "2025-02-21": 131.08610738991024,
    "2025-02-22": 132.00178356443658,
    "2025-02-23": 132.91745973896295,
    "2025-02-24": 133.8331359134893,
    "2025-02-25": 134.74881208801563,
    "2025-02-26": 135.664488262542,
    "2025-02-27": 136.58016443706833,
    "2025-02-28": 137.4958406115947,
    "2025-03-01": 138.85068519514556,
    "2025-03-02": 140.20552977869642,
    "2025-03-03": 141.56037436224727,
    "2025-03-04": 142.91521894579813,
    "2025-03-05": 144.270063529349,
    "2025-03-06": 145.62490811289985,
    "2025-03-07": 146.9797526964507,
    "2025-03-08": 148.33459728000156,
    "2025-03-09": 149.68944186355242,
    "2025-03-10": 151.04428644710327,
    "2025-03-11": 152.39913103065413,
    "2025-03-12": 153.753975614205,
    "2025-03-13": 155.10882019775585,
    "2025-03-14": 156.4636647813067,
    "2025-03-15": 157.81850936485756,
    "2025-03-16": 159.17335394840842,
    "2025-03-17": 160.52819853195928,
    "2025-03-18": 161.88304311551013,
    "2025-03-19": 163.23788769906102,
    "2025-03-20": 164.59273228261188,
    "2025-03-21": 165.94757686616273,
    "2025-03-22": 167.3024214497136,
    "2025-03-23": 168.65726603326445,
    "2025-03-24": 170.0121106168153,
    "2025-03-25": 171.36695520036616,
    "2025-03-26": 172.72179978391702,
    "2025-03-27": 174.07664436746788,
    "2025-03-28": 175.43148895101874,
    "2025-03-29": 176.7863335345696,
    "2025-03-30": 178.14117811812045,
    "2025-03-31": 179.4960227016713,
    "2025-04-01": 182.73742554338125,
    "2025-04-02": 185.9788283850912,
    "2025-04-03": 189.22023122680116,
    "2025-04-04": 192.46163406851107,
    "2025-04-05": 195.703036910221,
    "2025-04-06": 198.94443975193093,
    "2025-04-07": 202.18584259364087,
    "2025-04-08": 205.4272454353508,
    "2025-04-09": 208.66864827706075,
    "2025-04-10": 211.9100511187707,
    "2025-04-11": 215.15145396048064,
    "2025-04-12": 218.39285680219055,
    "2025-04-13": 221.6342596439005,
    "2025-04-14": 224.8756624856105,
    "2025-04-15": 228.1170653273204,
    "2025-04-16": 231.35846816903037,
    "2025-04-17": 234.5998710107403,
    "2025-04-18": 237.8412738524502,
    "2025-04-19": 241.0826766941601,
    "2025-04-20": 244.32407953587008,
    "2025-04-21": 247.56548237758005,
    "2025-04-22": 250.80688521929,
    "2025-04-23": 254.0482880609999,
    "2025-04-24": 257.2896909027098,
    "2025-04-25": 260.53109374441976,
    "2025-04-26": 263.7724965861297,
    "2025-04-27": 267.01389942783965,
    "2025-04-28": 270.2553022695496,
    "2025-04-29": 273.4967051112596,
    "2025-04-30": 276.7381079529695,
    "2025-05-01": 281.1010295984641,
    "2025-05-02": 285.4639512439587,
    "2025-05-03": 289.82687288945334,
    "2025-05-04": 294.189794534948,
    "2025-05-05": 298.55271618044253,
    "2025-05-06": 302.91563782593715,
    "2025-05-07": 307.2785594714318,
    "2025-05-08": 311.6414811169264,
    "2025-05-09": 316.004402762421,
    "2025-05-10": 320.36732440791565,
    "2025-05-11": 324.73024605341027,
    "2025-05-12": 329.0931676989049,
    "2025-05-13": 333.4560893443995,
    "2025-05-14": 337.81901098989414,
    "2025-05-15": 342.1819326353888,
    "2025-05-16": 346.5448542808833,
    "2025-05-17": 350.907775926378,
    "2025-05-18": 355.2706975718726,
    "2025-05-19": 359.6336192173672,
    "2025-05-20": 363.9965408628618,
    "2025-05-21": 368.3594625083565,
    "2025-05-22": 372.7223841538511,
    "2025-05-23": 377.0853057993457,
    "2025-05-24": 381.4482274448403,
    "2025-05-25": 385.8111490903349,
    "2025-05-26": 390.1740707358296,
    "2025-05-27": 394.5369923813241,
    "2025-05-28": 398.8999140268188,
    "2025-05-29": 403.2628356723134,
    "2025-05-30": 407.625757317808,
    "2025-05-31": 411.9886789633026,
    "2025-06-01": 417.5913872978224,
    "2025-06-02": 423.1940956323421,
    "2025-06-03": 428.7968039668618,
    "2025-06-04": 434.3995123013816,
    "2025-06-05": 440.00222063590127,
    "2025-06-06": 445.604928970421,
    "2025-06-07": 451.2076373049408,
    "2025-06-08": 456.8103456394605,
    "2025-06-09": 462.4130539739802,
    "2025-06-10": 468.0157623085,
    "2025-06-11": 473.6184706430197,
    "2025-06-12": 479.2211789775394,
    "2025-06-13": 484.8238873120591,
    "2025-06-14": 490.4265956465789,
    "2025-06-15": 496.0293039810986,
    "2025-06-16": 501.6320123156184,
    "2025-06-17": 507.2347206501381,
    "2025-06-18": 512.8374289846578,
    "2025-06-19": 518.4401373191776,
    "2025-06-20": 524.0428456536973,
    "2025-06-21": 529.645553988217,
    "2025-06-22": 535.2482623227368,
    "2025-06-23": 540.8509706572565,
    "2025-06-24": 546.4536789917762,
    "2025-06-25": 552.056387326296,
    "2025-06-26": 557.6590956608156,
    "2025-06-27": 563.2618039953354,
    "2025-06-28": 568.8645123298552,
    "2025-06-29": 574.4672206643748,
    "2025-06-30": 580.0699289988946,
    "2025-07-01": 585.5573926404685,
    "2025-07-02": 591.0448562820424,
    "2025-07-03": 596.5323199236161,
    "2025-07-04": 602.01978356519,
    "2025-07-05": 607.5072472067639,
    "2025-07-06": 612.9947108483377,
    "2025-07-07": 618.4821744899116,
    "2025-07-08": 623.9696381314855,
    "2025-07-09": 629.4571017730593,
    "2025-07-10": 634.9445654146331,
    "2025-07-11": 640.4320290562069,
    "2025-07-12": 645.9194926977808,
    "2025-07-13": 651.4069563393547,
    "2025-07-14": 656.8944199809285,
    "2025-07-15": 662.3818836225023,
    "2025-07-16": 667.8693472640762,
    "2025-07-17": 673.35681090565,
    "2025-07-18": 678.8442745472239,
    "2025-07-19": 684.3317381887978,
    "2025-07-20": 689.8192018303716,
    "2025-07-21": 695.3066654719455,
    "2025-07-22": 700.7941291135193,
    "2025-07-23": 706.2815927550931,
    "2025-07-24": 711.769056396667,
    "2025-07-25": 717.2565200382409,
    "2025-07-26": 722.7439836798147,
    "2025-07-27": 728.2314473213885,
    "2025-07-28": 733.7189109629624,
    "2025-07-29": 739.2063746045362,
    "2025-07-30": 744.6938382461101,
    "2025-07-31": 750.181301887684,
    "2025-08-01": 754.5990816690613,
    "2025-08-02": 759.0168614504388,
    "2025-08-03": 763.4346412318162,
    "2025-08-04": 767.8524210131935,
    "2025-08-05": 772.2702007945709,
    "2025-08-06": 776.6879805759484,
    "2025-08-07": 781.1057603573257,
    "2025-08-08": 785.5235401387031,
    "2025-08-09": 789.9413199200806,
    "2025-08-10": 794.3590997014579,
    "2025-08-11": 798.7768794828353,
    "2025-08-12": 803.1946592642128,
    "2025-08-13": 807.6124390455901,
    "2025-08-14": 812.0302188269675,
    "2025-08-15": 816.4479986083448,
    "2025-08-16": 820.8657783897223,
    "2025-08-17": 825.2835581710997,
    "2025-08-18": 829.701337952477,
    "2025-08-19": 834.1191177338544,
    "2025-08-20": 838.5368975152319,
    "2025-08-21": 842.9546772966092,
    "2025-08-22": 847.3724570779866,
    "2025-08-23": 851.7902368593641,
    "2025-08-24": 856.2080166407414,
    "2025-08-25": 860.6257964221188,
    "2025-08-26": 865.0435762034963,
    "2025-08-27": 869.4613559848736,
    "2025-08-28": 873.879135766251,
    "2025-08-29": 878.2969155476285,
    "2025-08-30": 882.7146953290058,
    "2025-08-31": 887.1324751103832,
    "2025-09-01": 890.4454558709854,
    "2025-09-02": 893.7584366315874,
    "2025-09-03": 897.0714173921896,
    "2025-09-04": 900.3843981527916,
    "2025-09-05": 903.6973789133938,
    "2025-09-06": 907.0103596739958,
    "2025-09-07": 910.323340434598,
    "2025-09-08": 913.6363211952,
    "2025-09-09": 916.9493019558022,
    "2025-09-10": 920.2622827164042,
    "2025-09-11": 923.5752634770064,
    "2025-09-12": 926.8882442376084,
    "2025-09-13": 930.2012249982106,
    "2025-09-14": 933.5142057588127,
    "2025-09-15": 936.8271865194148,
    "2025-09-16": 940.140167280017,
    "2025-09-17": 943.453148040619,
    "2025-09-18": 946.7661288012212,
    "2025-09-19": 950.0791095618232,
    "2025-09-20": 953.3920903224254,
    "2025-09-21": 956.7050710830274,
    "2025-09-22": 960.0180518436296,
    "2025-09-23": 963.3310326042316,
    "2025-09-24": 966.6440133648338,
    "2025-09-25": 969.9569941254358,
    "2025-09-26": 973.269974886038,
    "2025-09-27": 976.58295564664,
    "2025-09-28": 979.8959364072422,
    "2025-09-29": 983.2089171678442,
    "2025-09-30": 986.5218979284464,
  },
  "Miscellaneous Deciduous": {
    "2024-10-01": 0.0,
    "2024-10-02": 1.9250997666525296,
    "2024-10-03": 3.850199533305059,
    "2024-10-04": 5.775299299957589,
    "2024-10-05": 7.700399066610118,
    "2024-10-06": 9.625498833262649,
    "2024-10-07": 11.550598599915178,
    "2024-10-08": 13.475698366567707,
    "2024-10-09": 15.400798133220237,
    "2024-10-10": 17.325897899872768,
    "2024-10-11": 19.250997666525297,
    "2024-10-12": 21.176097433177823,
    "2024-10-13": 23.10119719983036,
    "2024-10-14": 25.026296966482885,
    "2024-10-15": 26.95139673313541,
    "2024-10-16": 28.876496499787944,
    "2024-10-17": 30.801596266440477,
    "2024-10-18": 32.726696033093006,
    "2024-10-19": 34.651795799745535,
    "2024-10-20": 36.57689556639807,
    "2024-10-21": 38.501995333050594,
    "2024-10-22": 40.42709509970312,
    "2024-10-23": 42.35219486635565,
    "2024-10-24": 44.27729463300818,
    "2024-10-25": 46.20239439966071,
    "2024-10-26": 48.12749416631324,
    "2024-10-27": 50.05259393296577,
    "2024-10-28": 51.9776936996183,
    "2024-10-29": 53.90279346627083,
    "2024-10-30": 55.82789323292336,
    "2024-10-31": 57.75299299957589,
    "2024-11-01": 58.31203456010491,
    "2024-11-02": 58.87107612063393,
    "2024-11-03": 59.43011768116296,
    "2024-11-04": 59.98915924169198,
    "2024-11-05": 60.548200802221,
    "2024-11-06": 61.10724236275002,
    "2024-11-07": 61.66628392327904,
    "2024-11-08": 62.225325483808064,
    "2024-11-09": 62.78436704433709,
    "2024-11-10": 63.343408604866106,
    "2024-11-11": 63.90245016539513,
    "2024-11-12": 64.46149172592415,
    "2024-11-13": 65.02053328645317,
    "2024-11-14": 65.5795748469822,
    "2024-11-15": 66.13861640751122,
    "2024-11-16": 66.69765796804025,
    "2024-11-17": 67.25669952856927,
    "2024-11-18": 67.81574108909828,
    "2024-11-19": 68.3747826496273,
    "2024-11-20": 68.93382421015633,
    "2024-11-21": 69.49286577068536,
    "2024-11-22": 70.05190733121438,
    "2024-11-23": 70.61094889174339,
    "2024-11-24": 71.16999045227242,
    "2024-11-25": 71.72903201280144,
    "2024-11-26": 72.28807357333046,
    "2024-11-27": 72.84711513385949,
    "2024-11-28": 73.4061566943885,
    "2024-11-29": 73.96519825491752,
    "2024-11-30": 74.52423981544655,
    "2024-12-01": 74.84154168823477,
    "2024-12-02": 75.15884356102298,
    "2024-12-03": 75.4761454338112,
    "2024-12-04": 75.79344730659942,
    "2024-12-05": 76.11074917938764,
    "2024-12-06": 76.42805105217585,
    "2024-12-07": 76.74535292496407,
    "2024-12-08": 77.06265479775229,
    "2024-12-09": 77.37995667054051,
    "2024-12-10": 77.69725854332872,
    "2024-12-11": 78.01456041611694,
    "2024-12-12": 78.33186228890516,
    "2024-12-13": 78.64916416169338,
    "2024-12-14": 78.96646603448158,
    "2024-12-15": 79.2837679072698,
    "2024-12-16": 79.60106978005803,
    "2024-12-17": 79.91837165284625,
    "2024-12-18": 80.23567352563445,
    "2024-12-19": 80.55297539842267,
    "2024-12-20": 80.8702772712109,
    "2024-12-21": 81.18757914399912,
    "2024-12-22": 81.50488101678732,
    "2024-12-23": 81.82218288957554,
    "2024-12-24": 82.13948476236376,
    "2024-12-25": 82.45678663515199,
    "2024-12-26": 82.77408850794019,
    "2024-12-27": 83.09139038072841,
    "2024-12-28": 83.40869225351663,
    "2024-12-29": 83.72599412630484,
    "2024-12-30": 84.04329599909306,
    "2024-12-31": 84.36059787188128,
    "2025-01-01": 84.9932604314057,
    "2025-01-02": 85.62592299093012,
    "2025-01-03": 86.25858555045454,
    "2025-01-04": 86.89124810997896,
    "2025-01-05": 87.52391066950338,
    "2025-01-06": 88.1565732290278,
    "2025-01-07": 88.78923578855222,
    "2025-01-08": 89.42189834807664,
    "2025-01-09": 90.05456090760107,
    "2025-01-10": 90.68722346712548,
    "2025-01-11": 91.31988602664993,
    "2025-01-12": 91.95254858617432,
    "2025-01-13": 92.58521114569876,
    "2025-01-14": 93.21787370522316,
    "2025-01-15": 93.8505362647476,
    "2025-01-16": 94.483198824272,
    "2025-01-17": 95.11586138379644,
    "2025-01-18": 95.74852394332083,
    "2025-01-19": 96.38118650284528,
    "2025-01-20": 97.01384906236969,
    "2025-01-21": 97.6465116218941,
    "2025-01-22": 98.27917418141853,
    "2025-01-23": 98.91183674094296,
    "2025-01-24": 99.54449930046738,
    "2025-01-25": 100.1771618599918,
    "2025-01-26": 100.80982441951622,
    "2025-01-27": 101.44248697904064,
    "2025-01-28": 102.07514953856506,
    "2025-01-29": 102.70781209808948,
    "2025-01-30": 103.3404746576139,
    "2025-01-31": 103.97313721713832,
    "2025-02-01": 105.10329660512788,
    "2025-02-02": 106.23345599311746,
    "2025-02-03": 107.36361538110702,
    "2025-02-04": 108.4937747690966,
    "2025-02-05": 109.62393415708615,
    "2025-02-06": 110.75409354507572,
    "2025-02-07": 111.88425293306533,
    "2025-02-08": 113.01441232105488,
    "2025-02-09": 114.14457170904446,
    "2025-02-10": 115.27473109703402,
    "2025-02-11": 116.4048904850236,
    "2025-02-12": 117.53504987301316,
    "2025-02-13": 118.66520926100272,
    "2025-02-14": 119.79536864899232,
    "2025-02-15": 120.92552803698187,
    "2025-02-16": 122.05568742497144,
    "2025-02-17": 123.18584681296102,
    "2025-02-18": 124.3160062009506,
    "2025-02-19": 125.44616558894016,
    "2025-02-20": 126.57632497692973,
    "2025-02-21": 127.7064843649193,
    "2025-02-22": 128.83664375290888,
    "2025-02-23": 129.96680314089843,
    "2025-02-24": 131.096962528888,
    "2025-02-25": 132.2271219168776,
    "2025-02-26": 133.35728130486717,
    "2025-02-27": 134.48744069285672,
    "2025-02-28": 135.6176000808463,
    "2025-03-01": 137.30292355877503,
    "2025-03-02": 138.98824703670374,
    "2025-03-03": 140.67357051463247,
    "2025-03-04": 142.35889399256118,
    "2025-03-05": 144.0442174704899,
    "2025-03-06": 145.72954094841862,
    "2025-03-07": 147.41486442634735,
    "2025-03-08": 149.10018790427608,
    "2025-03-09": 150.7855113822048,
    "2025-03-10": 152.47083486013352,
    "2025-03-11": 154.15615833806223,
    "2025-03-12": 155.84148181599096,
    "2025-03-13": 157.5268052939197,
    "2025-03-14": 159.2121287718484,
    "2025-03-15": 160.89745224977713,
    "2025-03-16": 162.58277572770584,
    "2025-03-17": 164.26809920563457,
    "2025-03-18": 165.95342268356328,
    "2025-03-19": 167.638746161492,
    "2025-03-20": 169.3240696394207,
    "2025-03-21": 171.00939311734945,
    "2025-03-22": 172.69471659527818,
    "2025-03-23": 174.38004007320689,
    "2025-03-24": 176.06536355113562,
    "2025-03-25": 177.75068702906435,
    "2025-03-26": 179.43601050699306,
    "2025-03-27": 181.12133398492176,
    "2025-03-28": 182.8066574628505,
    "2025-03-29": 184.49198094077923,
    "2025-03-30": 186.17730441870796,
    "2025-03-31": 187.86262789663667,
    "2025-04-01": 190.6941441936783,
    "2025-04-02": 193.52566049072,
    "2025-04-03": 196.35717678776163,
    "2025-04-04": 199.1886930848033,
    "2025-04-05": 202.02020938184492,
    "2025-04-06": 204.85172567888665,
    "2025-04-07": 207.68324197592827,
    "2025-04-08": 210.5147582729699,
    "2025-04-09": 213.3462745700116,
    "2025-04-10": 216.17779086705323,
    "2025-04-11": 219.0093071640949,
    "2025-04-12": 221.84082346113652,
    "2025-04-13": 224.67233975817825,
    "2025-04-14": 227.50385605521987,
    "2025-04-15": 230.33537235226152,
    "2025-04-16": 233.1668886493032,
    "2025-04-17": 235.9984049463449,
    "2025-04-18": 238.8299212433865,
    "2025-04-19": 241.66143754042812,
    "2025-04-20": 244.49295383746983,
    "2025-04-21": 247.32447013451147,
    "2025-04-22": 250.15598643155312,
    "2025-04-23": 252.9875027285948,
    "2025-04-24": 255.8190190256365,
    "2025-04-25": 258.65053532267814,
    "2025-04-26": 261.4820516197197,
    "2025-04-27": 264.31356791676143,
    "2025-04-28": 267.1450842138031,
    "2025-04-29": 269.9766005108447,
    "2025-04-30": 272.8081168078864,
    "2025-05-01": 275.98857493929216,
    "2025-05-02": 279.16903307069794,
    "2025-05-03": 282.34949120210365,
    "2025-05-04": 285.5299493335094,
    "2025-05-05": 288.7104074649152,
    "2025-05-06": 291.89086559632096,
    "2025-05-07": 295.07132372772674,
    "2025-05-08": 298.2517818591325,
    "2025-05-09": 301.4322399905383,
    "2025-05-10": 304.612698121944,
    "2025-05-11": 307.79315625334976,
    "2025-05-12": 310.97361438475554,
    "2025-05-13": 314.1540725161613,
    "2025-05-14": 317.3345306475671,
    "2025-05-15": 320.5149887789728,
    "2025-05-16": 323.69544691037856,
    "2025-05-17": 326.87590504178434,
    "2025-05-18": 330.0563631731901,
    "2025-05-19": 333.2368213045959,
    "2025-05-20": 336.41727943600165,
    "2025-05-21": 339.5977375674074,
    "2025-05-22": 342.7781956988132,
    "2025-05-23": 345.9586538302189,
    "2025-05-24": 349.1391119616247,
    "2025-05-25": 352.31957009303045,
    "2025-05-26": 355.5000282244362,
    "2025-05-27": 358.68048635584194,
    "2025-05-28": 361.8609444872477,
    "2025-05-29": 365.0414026186535,
    "2025-05-30": 368.2218607500593,
    "2025-05-31": 371.402318881465,
    "2025-06-01": 375.0151676403983,
    "2025-06-02": 378.6280163993316,
    "2025-06-03": 382.2408651582648,
    "2025-06-04": 385.8537139171981,
    "2025-06-05": 389.4665626761313,
    "2025-06-06": 393.07941143506457,
    "2025-06-07": 396.6922601939978,
    "2025-06-08": 400.3051089529311,
    "2025-06-09": 403.9179577118643,
    "2025-06-10": 407.5308064707976,
    "2025-06-11": 411.1436552297308,
    "2025-06-12": 414.75650398866406,
    "2025-06-13": 418.3693527475973,
    "2025-06-14": 421.9822015065306,
    "2025-06-15": 425.59505026546384,
    "2025-06-16": 429.2078990243971,
    "2025-06-17": 432.8207477833304,
    "2025-06-18": 436.4335965422636,
    "2025-06-19": 440.04644530119685,
    "2025-06-20": 443.6592940601301,
    "2025-06-21": 447.2721428190633,
    "2025-06-22": 450.88499157799663,
    "2025-06-23": 454.4978403369298,
    "2025-06-24": 458.1106890958631,
    "2025-06-25": 461.7235378547964,
    "2025-06-26": 465.3363866137296,
    "2025-06-27": 468.9492353726629,
    "2025-06-28": 472.5620841315962,
    "2025-06-29": 476.1749328905294,
    "2025-06-30": 479.78778164946266,
    "2025-07-01": 483.6598713013688,
    "2025-07-02": 487.53196095327496,
    "2025-07-03": 491.4040506051812,
    "2025-07-04": 495.2761402570873,
    "2025-07-05": 499.1482299089935,
    "2025-07-06": 503.0203195608996,
    "2025-07-07": 506.8924092128058,
    "2025-07-08": 510.7644988647119,
    "2025-07-09": 514.6365885166181,
    "2025-07-10": 518.5086781685243,
    "2025-07-11": 522.3807678204304,
    "2025-07-12": 526.2528574723366,
    "2025-07-13": 530.1249471242428,
    "2025-07-14": 533.9970367761489,
    "2025-07-15": 537.8691264280551,
    "2025-07-16": 541.7412160799612,
    "2025-07-17": 545.6133057318674,
    "2025-07-18": 549.4853953837735,
    "2025-07-19": 553.3574850356797,
    "2025-07-20": 557.2295746875859,
    "2025-07-21": 561.101664339492,
    "2025-07-22": 564.9737539913982,
    "2025-07-23": 568.8458436433043,
    "2025-07-24": 572.7179332952105,
    "2025-07-25": 576.5900229471167,
    "2025-07-26": 580.4621125990228,
    "2025-07-27": 584.334202250929,
    "2025-07-28": 588.2062919028351,
    "2025-07-29": 592.0783815547413,
    "2025-07-30": 595.9504712066475,
    "2025-07-31": 599.8225608585536,
    "2025-08-01": 603.1525741829329,
    "2025-08-02": 606.4825875073122,
    "2025-08-03": 609.8126008316915,
    "2025-08-04": 613.1426141560709,
    "2025-08-05": 616.4726274804501,
    "2025-08-06": 619.8026408048294,
    "2025-08-07": 623.1326541292087,
    "2025-08-08": 626.462667453588,
    "2025-08-09": 629.7926807779672,
    "2025-08-10": 633.1226941023466,
    "2025-08-11": 636.4527074267259,
    "2025-08-12": 639.7827207511052,
    "2025-08-13": 643.1127340754845,
    "2025-08-14": 646.4427473998637,
    "2025-08-15": 649.7727607242431,
    "2025-08-16": 653.1027740486223,
    "2025-08-17": 656.4327873730017,
    "2025-08-18": 659.762800697381,
    "2025-08-19": 663.0928140217602,
    "2025-08-20": 666.4228273461396,
    "2025-08-21": 669.7528406705188,
    "2025-08-22": 673.0828539948982,
    "2025-08-23": 676.4128673192774,
    "2025-08-24": 679.7428806436567,
    "2025-08-25": 683.072893968036,
    "2025-08-26": 686.4029072924153,
    "2025-08-27": 689.7329206167947,
    "2025-08-28": 693.0629339411739,
    "2025-08-29": 696.3929472655532,
    "2025-08-30": 699.7229605899325,
    "2025-08-31": 703.0529739143118,
    "2025-09-01": 705.469966217389,
    "2025-09-02": 707.8869585204661,
    "2025-09-03": 710.3039508235433,
    "2025-09-04": 712.7209431266206,
    "2025-09-05": 715.1379354296978,
    "2025-09-06": 717.5549277327749,
    "2025-09-07": 719.9719200358521,
    "2025-09-08": 722.3889123389293,
    "2025-09-09": 724.8059046420066,
    "2025-09-10": 727.2228969450837,
    "2025-09-11": 729.6398892481609,
    "2025-09-12": 732.0568815512381,
    "2025-09-13": 734.4738738543153,
    "2025-09-14": 736.8908661573925,
    "2025-09-15": 739.3078584604697,
    "2025-09-16": 741.7248507635469,
    "2025-09-17": 744.141843066624,
    "2025-09-18": 746.5588353697012,
    "2025-09-19": 748.9758276727785,
    "2025-09-20": 751.3928199758557,
    "2025-09-21": 753.8098122789328,
    "2025-09-22": 756.22680458201,
    "2025-09-23": 758.6437968850872,
    "2025-09-24": 761.0607891881644,
    "2025-09-25": 763.4777814912416,
    "2025-09-26": 765.8947737943188,
    "2025-09-27": 768.311766097396,
    "2025-09-28": 770.7287584004732,
    "2025-09-29": 773.1457507035503,
    "2025-09-30": 775.5627430066276,
  },
  "Miscellaneous Subtropical Fruits": {
    "2024-10-01": 0.0,
    "2024-10-02": 2.10660573102837,
    "2024-10-03": 4.21321146205674,
    "2024-10-04": 6.319817193085109,
    "2024-10-05": 8.42642292411348,
    "2024-10-06": 10.53302865514185,
    "2024-10-07": 12.63963438617022,
    "2024-10-08": 14.746240117198589,
    "2024-10-09": 16.85284584822696,
    "2024-10-10": 18.95945157925533,
    "2024-10-11": 21.0660573102837,
    "2024-10-12": 23.17266304131207,
    "2024-10-13": 25.27926877234044,
    "2024-10-14": 27.385874503368807,
    "2024-10-15": 29.492480234397178,
    "2024-10-16": 31.599085965425548,
    "2024-10-17": 33.70569169645392,
    "2024-10-18": 35.812297427482285,
    "2024-10-19": 37.91890315851066,
    "2024-10-20": 40.02550888953903,
    "2024-10-21": 42.1321146205674,
    "2024-10-22": 44.23872035159577,
    "2024-10-23": 46.34532608262414,
    "2024-10-24": 48.45193181365251,
    "2024-10-25": 50.55853754468088,
    "2024-10-26": 52.66514327570925,
    "2024-10-27": 54.771749006737615,
    "2024-10-28": 56.87835473776599,
    "2024-10-29": 58.98496046879436,
    "2024-10-30": 61.09156619982273,
    "2024-10-31": 63.1981719308511,
    "2024-11-01": 63.88379884000389,
    "2024-11-02": 64.56942574915666,
    "2024-11-03": 65.25505265830944,
    "2024-11-04": 65.94067956746221,
    "2024-11-05": 66.62630647661499,
    "2024-11-06": 67.31193338576777,
    "2024-11-07": 67.99756029492055,
    "2024-11-08": 68.68318720407332,
    "2024-11-09": 69.3688141132261,
    "2024-11-10": 70.05444102237888,
    "2024-11-11": 70.74006793153166,
    "2024-11-12": 71.42569484068443,
    "2024-11-13": 72.1113217498372,
    "2024-11-14": 72.79694865898999,
    "2024-11-15": 73.48257556814276,
    "2024-11-16": 74.16820247729554,
    "2024-11-17": 74.85382938644833,
    "2024-11-18": 75.5394562956011,
    "2024-11-19": 76.22508320475387,
    "2024-11-20": 76.91071011390665,
    "2024-11-21": 77.59633702305943,
    "2024-11-22": 78.28196393221221,
    "2024-11-23": 78.96759084136498,
    "2024-11-24": 79.65321775051777,
    "2024-11-25": 80.33884465967054,
    "2024-11-26": 81.02447156882332,
    "2024-11-27": 81.71009847797609,
    "2024-11-28": 82.39572538712886,
    "2024-11-29": 83.08135229628165,
    "2024-11-30": 83.76697920543442,
    "2024-12-01": 84.1825467276834,
    "2024-12-02": 84.5981142499324,
    "2024-12-03": 85.01368177218137,
    "2024-12-04": 85.42924929443035,
    "2024-12-05": 85.84481681667933,
    "2024-12-06": 86.26038433892832,
    "2024-12-07": 86.6759518611773,
    "2024-12-08": 87.09151938342627,
    "2024-12-09": 87.50708690567527,
    "2024-12-10": 87.92265442792424,
    "2024-12-11": 88.33822195017322,
    "2024-12-12": 88.7537894724222,
    "2024-12-13": 89.16935699467119,
    "2024-12-14": 89.58492451692017,
    "2024-12-15": 90.00049203916915,
    "2024-12-16": 90.41605956141814,
    "2024-12-17": 90.83162708366712,
    "2024-12-18": 91.24719460591608,
    "2024-12-19": 91.66276212816508,
    "2024-12-20": 92.07832965041406,
    "2024-12-21": 92.49389717266304,
    "2024-12-22": 92.90946469491202,
    "2024-12-23": 93.325032217161,
    "2024-12-24": 93.74059973941,
    "2024-12-25": 94.15616726165896,
    "2024-12-26": 94.57173478390794,
    "2024-12-27": 94.98730230615692,
    "2024-12-28": 95.40286982840593,
    "2024-12-29": 95.81843735065488,
    "2024-12-30": 96.23400487290388,
    "2024-12-31": 96.64957239515286,
    "2025-01-01": 97.4169661243101,
    "2025-01-02": 98.18435985346734,
    "2025-01-03": 98.95175358262458,
    "2025-01-04": 99.7191473117818,
    "2025-01-05": 100.48654104093904,
    "2025-01-06": 101.2539347700963,
    "2025-01-07": 102.02132849925351,
    "2025-01-08": 102.78872222841076,
    "2025-01-09": 103.556115957568,
    "2025-01-10": 104.32350968672525,
    "2025-01-11": 105.09090341588248,
    "2025-01-12": 105.85829714503971,
    "2025-01-13": 106.62569087419696,
    "2025-01-14": 107.3930846033542,
    "2025-01-15": 108.16047833251145,
    "2025-01-16": 108.92787206166868,
    "2025-01-17": 109.6952657908259,
    "2025-01-18": 110.46265951998316,
    "2025-01-19": 111.23005324914038,
    "2025-01-20": 111.99744697829762,
    "2025-01-21": 112.76484070745484,
    "2025-01-22": 113.5322344366121,
    "2025-01-23": 114.29962816576932,
    "2025-01-24": 115.06702189492655,
    "2025-01-25": 115.83441562408382,
    "2025-01-26": 116.60180935324104,
    "2025-01-27": 117.36920308239829,
    "2025-01-28": 118.13659681155552,
    "2025-01-29": 118.90399054071275,
    "2025-01-30": 119.67138426987,
    "2025-01-31": 120.43877799902724,
    "2025-02-01": 121.65513862393314,
    "2025-02-02": 122.87149924883904,
    "2025-02-03": 124.08785987374496,
    "2025-02-04": 125.30422049865084,
    "2025-02-05": 126.52058112355677,
    "2025-02-06": 127.73694174846266,
    "2025-02-07": 128.95330237336856,
    "2025-02-08": 130.16966299827448,
    "2025-02-09": 131.38602362318036,
    "2025-02-10": 132.60238424808628,
    "2025-02-11": 133.81874487299217,
    "2025-02-12": 135.0351054978981,
    "2025-02-13": 136.25146612280398,
    "2025-02-14": 137.4678267477099,
    "2025-02-15": 138.68418737261578,
    "2025-02-16": 139.9005479975217,
    "2025-02-17": 141.1169086224276,
    "2025-02-18": 142.3332692473335,
    "2025-02-19": 143.5496298722394,
    "2025-02-20": 144.7659904971453,
    "2025-02-21": 145.9823511220512,
    "2025-02-22": 147.19871174695712,
    "2025-02-23": 148.415072371863,
    "2025-02-24": 149.63143299676892,
    "2025-02-25": 150.8477936216748,
    "2025-02-26": 152.06415424658073,
    "2025-02-27": 153.28051487148662,
    "2025-02-28": 154.49687549639253,
    "2025-03-01": 156.1425151498165,
    "2025-03-02": 157.78815480324045,
    "2025-03-03": 159.4337944566644,
    "2025-03-04": 161.07943411008833,
    "2025-03-05": 162.72507376351228,
    "2025-03-06": 164.37071341693624,
    "2025-03-07": 166.0163530703602,
    "2025-03-08": 167.66199272378415,
    "2025-03-09": 169.3076323772081,
    "2025-03-10": 170.95327203063206,
    "2025-03-11": 172.59891168405602,
    "2025-03-12": 174.24455133747995,
    "2025-03-13": 175.8901909909039,
    "2025-03-14": 177.53583064432786,
    "2025-03-15": 179.18147029775182,
    "2025-03-16": 180.82710995117577,
    "2025-03-17": 182.47274960459973,
    "2025-03-18": 184.11838925802368,
    "2025-03-19": 185.7640289114476,
    "2025-03-20": 187.4096685648716,
    "2025-03-21": 189.05530821829552,
    "2025-03-22": 190.70094787171948,
    "2025-03-23": 192.34658752514343,
    "2025-03-24": 193.9922271785674,
    "2025-03-25": 195.63786683199132,
    "2025-03-26": 197.28350648541527,
    "2025-03-27": 198.9291461388393,
    "2025-03-28": 200.5747857922632,
    "2025-03-29": 202.22042544568717,
    "2025-03-30": 203.8660650991111,
    "2025-03-31": 205.51170475253505,
    "2025-04-01": 208.39045977885243,
    "2025-04-02": 211.26921480516975,
    "2025-04-03": 214.1479698314872,
    "2025-04-04": 217.0267248578045,
    "2025-04-05": 219.9054798841219,
    "2025-04-06": 222.78423491043924,
    "2025-04-07": 225.66298993675665,
    "2025-04-08": 228.541744963074,
    "2025-04-09": 231.42049998939132,
    "2025-04-10": 234.29925501570872,
    "2025-04-11": 237.17801004202607,
    "2025-04-12": 240.05676506834345,
    "2025-04-13": 242.9355200946608,
    "2025-04-14": 245.81427512097815,
    "2025-04-15": 248.69303014729556,
    "2025-04-16": 251.5717851736129,
    "2025-04-17": 254.4505401999303,
    "2025-04-18": 257.3292952262476,
    "2025-04-19": 260.208050252565,
    "2025-04-20": 263.0868052788824,
    "2025-04-21": 265.96556030519974,
    "2025-04-22": 268.8443153315171,
    "2025-04-23": 271.72307035783444,
    "2025-04-24": 274.6018253841518,
    "2025-04-25": 277.4805804104692,
    "2025-04-26": 280.3593354367866,
    "2025-04-27": 283.238090463104,
    "2025-04-28": 286.1168454894213,
    "2025-04-29": 288.99560051573866,
    "2025-04-30": 291.87435554205604,
    "2025-05-01": 295.0462315914118,
    "2025-05-02": 298.2181076407676,
    "2025-05-03": 301.38998369012336,
    "2025-05-04": 304.56185973947913,
    "2025-05-05": 307.7337357888349,
    "2025-05-06": 310.9056118381907,
    "2025-05-07": 314.07748788754645,
    "2025-05-08": 317.2493639369022,
    "2025-05-09": 320.421239986258,
    "2025-05-10": 323.5931160356138,
    "2025-05-11": 326.76499208496955,
    "2025-05-12": 329.9368681343253,
    "2025-05-13": 333.1087441836811,
    "2025-05-14": 336.28062023303687,
    "2025-05-15": 339.45249628239264,
    "2025-05-16": 342.6243723317484,
    "2025-05-17": 345.7962483811042,
    "2025-05-18": 348.96812443046,
    "2025-05-19": 352.1400004798158,
    "2025-05-20": 355.3118765291716,
    "2025-05-21": 358.48375257852734,
    "2025-05-22": 361.6556286278831,
    "2025-05-23": 364.8275046772389,
    "2025-05-24": 367.99938072659467,
    "2025-05-25": 371.1712567759504,
    "2025-05-26": 374.3431328253062,
    "2025-05-27": 377.515008874662,
    "2025-05-28": 380.68688492401776,
    "2025-05-29": 383.85876097337353,
    "2025-05-30": 387.0306370227293,
    "2025-05-31": 390.2025130720851,
    "2025-06-01": 393.4538345628194,
    "2025-06-02": 396.7051560535537,
    "2025-06-03": 399.956477544288,
    "2025-06-04": 403.2077990350222,
    "2025-06-05": 406.4591205257565,
    "2025-06-06": 409.7104420164908,
    "2025-06-07": 412.9617635072251,
    "2025-06-08": 416.21308499795936,
    "2025-06-09": 419.46440648869367,
    "2025-06-10": 422.7157279794279,
    "2025-06-11": 425.96704947016224,
    "2025-06-12": 429.2183709608965,
    "2025-06-13": 432.4696924516308,
    "2025-06-14": 435.72101394236506,
    "2025-06-15": 438.9723354330994,
    "2025-06-16": 442.2236569238337,
    "2025-06-17": 445.474978414568,
    "2025-06-18": 448.7262999053022,
    "2025-06-19": 451.9776213960365,
    "2025-06-20": 455.2289428867708,
    "2025-06-21": 458.4802643775051,
    "2025-06-22": 461.7315858682394,
    "2025-06-23": 464.9829073589737,
    "2025-06-24": 468.234228849708,
    "2025-06-25": 471.4855503404422,
    "2025-06-26": 474.7368718311765,
    "2025-06-27": 477.9881933219108,
    "2025-06-28": 481.2395148126451,
    "2025-06-29": 484.4908363033794,
    "2025-06-30": 487.74215779411367,
    "2025-07-01": 491.10501173755137,
    "2025-07-02": 494.4678656809891,
    "2025-07-03": 497.8307196244268,
    "2025-07-04": 501.1935735678646,
    "2025-07-05": 504.5564275113023,
    "2025-07-06": 507.91928145474,
    "2025-07-07": 511.2821353981777,
    "2025-07-08": 514.6449893416154,
    "2025-07-09": 518.0078432850531,
    "2025-07-10": 521.3706972284909,
    "2025-07-11": 524.7335511719286,
    "2025-07-12": 528.0964051153663,
    "2025-07-13": 531.459259058804,
    "2025-07-14": 534.8221130022417,
    "2025-07-15": 538.1849669456795,
    "2025-07-16": 541.5478208891172,
    "2025-07-17": 544.910674832555,
    "2025-07-18": 548.2735287759926,
    "2025-07-19": 551.6363827194305,
    "2025-07-20": 554.9992366628682,
    "2025-07-21": 558.3620906063059,
    "2025-07-22": 561.7249445497436,
    "2025-07-23": 565.0877984931813,
    "2025-07-24": 568.4506524366191,
    "2025-07-25": 571.8135063800568,
    "2025-07-26": 575.1763603234945,
    "2025-07-27": 578.5392142669322,
    "2025-07-28": 581.9020682103699,
    "2025-07-29": 585.2649221538077,
    "2025-07-30": 588.6277760972454,
    "2025-07-31": 591.9906300406831,
    "2025-08-01": 594.9509570146419,
    "2025-08-02": 597.9112839886006,
    "2025-08-03": 600.8716109625594,
    "2025-08-04": 603.8319379365182,
    "2025-08-05": 606.792264910477,
    "2025-08-06": 609.7525918844358,
    "2025-08-07": 612.7129188583946,
    "2025-08-08": 615.6732458323532,
    "2025-08-09": 618.633572806312,
    "2025-08-10": 621.5938997802708,
    "2025-08-11": 624.5542267542296,
    "2025-08-12": 627.5145537281884,
    "2025-08-13": 630.4748807021472,
    "2025-08-14": 633.435207676106,
    "2025-08-15": 636.3955346500647,
    "2025-08-16": 639.3558616240235,
    "2025-08-17": 642.3161885979823,
    "2025-08-18": 645.2765155719411,
    "2025-08-19": 648.2368425458999,
    "2025-08-20": 651.1971695198587,
    "2025-08-21": 654.1574964938175,
    "2025-08-22": 657.1178234677761,
    "2025-08-23": 660.078150441735,
    "2025-08-24": 663.0384774156937,
    "2025-08-25": 665.9988043896525,
    "2025-08-26": 668.9591313636113,
    "2025-08-27": 671.9194583375701,
    "2025-08-28": 674.8797853115288,
    "2025-08-29": 677.8401122854876,
    "2025-08-30": 680.8004392594464,
    "2025-08-31": 683.7607662334052,
    "2025-09-01": 686.0965342554701,
    "2025-09-02": 688.4323022775351,
    "2025-09-03": 690.7680702996001,
    "2025-09-04": 693.1038383216651,
    "2025-09-05": 695.43960634373,
    "2025-09-06": 697.775374365795,
    "2025-09-07": 700.1111423878599,
    "2025-09-08": 702.4469104099248,
    "2025-09-09": 704.7826784319898,
    "2025-09-10": 707.1184464540548,
    "2025-09-11": 709.4542144761198,
    "2025-09-12": 711.7899824981847,
    "2025-09-13": 714.1257505202497,
    "2025-09-14": 716.4615185423146,
    "2025-09-15": 718.7972865643796,
    "2025-09-16": 721.1330545864446,
    "2025-09-17": 723.4688226085095,
    "2025-09-18": 725.8045906305745,
    "2025-09-19": 728.1403586526394,
    "2025-09-20": 730.4761266747043,
    "2025-09-21": 732.8118946967693,
    "2025-09-22": 735.1476627188343,
    "2025-09-23": 737.4834307408993,
    "2025-09-24": 739.8191987629642,
    "2025-09-25": 742.1549667850292,
    "2025-09-26": 744.4907348070941,
    "2025-09-27": 746.8265028291592,
    "2025-09-28": 749.1622708512241,
    "2025-09-29": 751.498038873289,
    "2025-09-30": 753.833806895354,
  },
  Olives: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.878266442092544,
    "2024-10-03": 3.756532884185088,
    "2024-10-04": 5.634799326277633,
    "2024-10-05": 7.513065768370176,
    "2024-10-06": 9.39133221046272,
    "2024-10-07": 11.269598652555263,
    "2024-10-08": 13.147865094647807,
    "2024-10-09": 15.026131536740351,
    "2024-10-10": 16.904397978832897,
    "2024-10-11": 18.782664420925443,
    "2024-10-12": 20.660930863017985,
    "2024-10-13": 22.53919730511053,
    "2024-10-14": 24.417463747203072,
    "2024-10-15": 26.295730189295615,
    "2024-10-16": 28.17399663138816,
    "2024-10-17": 30.052263073480702,
    "2024-10-18": 31.93052951557325,
    "2024-10-19": 33.808795957665794,
    "2024-10-20": 35.68706239975834,
    "2024-10-21": 37.565328841850885,
    "2024-10-22": 39.443595283943424,
    "2024-10-23": 41.32186172603597,
    "2024-10-24": 43.20012816812852,
    "2024-10-25": 45.07839461022106,
    "2024-10-26": 46.956661052313606,
    "2024-10-27": 48.83492749440615,
    "2024-10-28": 50.71319393649869,
    "2024-10-29": 52.59146037859124,
    "2024-10-30": 54.46972682068378,
    "2024-10-31": 56.34799326277632,
    "2024-11-01": 57.139989325440965,
    "2024-11-02": 57.93198538810561,
    "2024-11-03": 58.72398145077025,
    "2024-11-04": 59.5159775134349,
    "2024-11-05": 60.30797357609954,
    "2024-11-06": 61.099969638764186,
    "2024-11-07": 61.89196570142883,
    "2024-11-08": 62.68396176409348,
    "2024-11-09": 63.47595782675812,
    "2024-11-10": 64.26795388942277,
    "2024-11-11": 65.05994995208741,
    "2024-11-12": 65.85194601475206,
    "2024-11-13": 66.6439420774167,
    "2024-11-14": 67.43593814008135,
    "2024-11-15": 68.22793420274598,
    "2024-11-16": 69.01993026541064,
    "2024-11-17": 69.81192632807527,
    "2024-11-18": 70.60392239073992,
    "2024-11-19": 71.39591845340456,
    "2024-11-20": 72.18791451606921,
    "2024-11-21": 72.97991057873385,
    "2024-11-22": 73.7719066413985,
    "2024-11-23": 74.56390270406314,
    "2024-11-24": 75.35589876672779,
    "2024-11-25": 76.14789482939244,
    "2024-11-26": 76.93989089205708,
    "2024-11-27": 77.73188695472172,
    "2024-11-28": 78.52388301738637,
    "2024-11-29": 79.31587908005102,
    "2024-11-30": 80.10787514271566,
    "2024-12-01": 80.61015955310457,
    "2024-12-02": 81.11244396349349,
    "2024-12-03": 81.6147283738824,
    "2024-12-04": 82.11701278427132,
    "2024-12-05": 82.61929719466023,
    "2024-12-06": 83.12158160504914,
    "2024-12-07": 83.62386601543807,
    "2024-12-08": 84.12615042582698,
    "2024-12-09": 84.62843483621589,
    "2024-12-10": 85.13071924660481,
    "2024-12-11": 85.63300365699372,
    "2024-12-12": 86.13528806738265,
    "2024-12-13": 86.63757247777156,
    "2024-12-14": 87.13985688816047,
    "2024-12-15": 87.64214129854939,
    "2024-12-16": 88.1444257089383,
    "2024-12-17": 88.64671011932722,
    "2024-12-18": 89.14899452971613,
    "2024-12-19": 89.65127894010504,
    "2024-12-20": 90.15356335049395,
    "2024-12-21": 90.65584776088288,
    "2024-12-22": 91.1581321712718,
    "2024-12-23": 91.66041658166073,
    "2024-12-24": 92.16270099204962,
    "2024-12-25": 92.66498540243856,
    "2024-12-26": 93.16726981282746,
    "2024-12-27": 93.66955422321638,
    "2024-12-28": 94.17183863360528,
    "2024-12-29": 94.6741230439942,
    "2024-12-30": 95.17640745438312,
    "2024-12-31": 95.67869186477203,
    "2025-01-01": 96.3297803977932,
    "2025-01-02": 96.98086893081438,
    "2025-01-03": 97.63195746383556,
    "2025-01-04": 98.28304599685671,
    "2025-01-05": 98.9341345298779,
    "2025-01-06": 99.58522306289906,
    "2025-01-07": 100.23631159592024,
    "2025-01-08": 100.8874001289414,
    "2025-01-09": 101.5384886619626,
    "2025-01-10": 102.18957719498376,
    "2025-01-11": 102.84066572800492,
    "2025-01-12": 103.4917542610261,
    "2025-01-13": 104.14284279404728,
    "2025-01-14": 104.79393132706844,
    "2025-01-15": 105.44501986008962,
    "2025-01-16": 106.09610839311078,
    "2025-01-17": 106.74719692613196,
    "2025-01-18": 107.39828545915312,
    "2025-01-19": 108.0493739921743,
    "2025-01-20": 108.70046252519548,
    "2025-01-21": 109.35155105821664,
    "2025-01-22": 110.00263959123782,
    "2025-01-23": 110.653728124259,
    "2025-01-24": 111.30481665728016,
    "2025-01-25": 111.95590519030134,
    "2025-01-26": 112.6069937233225,
    "2025-01-27": 113.25808225634368,
    "2025-01-28": 113.90917078936484,
    "2025-01-29": 114.56025932238602,
    "2025-01-30": 115.2113478554072,
    "2025-01-31": 115.86243638842836,
    "2025-02-01": 117.09575901671332,
    "2025-02-02": 118.3290816449983,
    "2025-02-03": 119.56240427328326,
    "2025-02-04": 120.79572690156824,
    "2025-02-05": 122.0290495298532,
    "2025-02-06": 123.26237215813816,
    "2025-02-07": 124.49569478642312,
    "2025-02-08": 125.7290174147081,
    "2025-02-09": 126.96234004299306,
    "2025-02-10": 128.19566267127803,
    "2025-02-11": 129.428985299563,
    "2025-02-12": 130.66230792784796,
    "2025-02-13": 131.89563055613291,
    "2025-02-14": 133.1289531844179,
    "2025-02-15": 134.36227581270288,
    "2025-02-16": 135.59559844098783,
    "2025-02-17": 136.82892106927278,
    "2025-02-18": 138.06224369755776,
    "2025-02-19": 139.29556632584274,
    "2025-02-20": 140.5288889541277,
    "2025-02-21": 141.76221158241265,
    "2025-02-22": 142.99553421069763,
    "2025-02-23": 144.2288568389826,
    "2025-02-24": 145.46217946726756,
    "2025-02-25": 146.6955020955525,
    "2025-02-26": 147.9288247238375,
    "2025-02-27": 149.16214735212247,
    "2025-02-28": 150.39546998040743,
    "2025-03-01": 152.08974157126974,
    "2025-03-02": 153.78401316213208,
    "2025-03-03": 155.4782847529944,
    "2025-03-04": 157.1725563438567,
    "2025-03-05": 158.86682793471903,
    "2025-03-06": 160.56109952558137,
    "2025-03-07": 162.25537111644368,
    "2025-03-08": 163.94964270730603,
    "2025-03-09": 165.64391429816834,
    "2025-03-10": 167.33818588903063,
    "2025-03-11": 169.03245747989297,
    "2025-03-12": 170.7267290707553,
    "2025-03-13": 172.42100066161763,
    "2025-03-14": 174.11527225247994,
    "2025-03-15": 175.80954384334228,
    "2025-03-16": 177.5038154342046,
    "2025-03-17": 179.1980870250669,
    "2025-03-18": 180.89235861592925,
    "2025-03-19": 182.5866302067916,
    "2025-03-20": 184.28090179765388,
    "2025-03-21": 185.97517338851625,
    "2025-03-22": 187.6694449793785,
    "2025-03-23": 189.36371657024085,
    "2025-03-24": 191.0579881611032,
    "2025-03-25": 192.7522597519655,
    "2025-03-26": 194.44653134282785,
    "2025-03-27": 196.14080293369017,
    "2025-03-28": 197.83507452455248,
    "2025-03-29": 199.5293461154148,
    "2025-03-30": 201.22361770627717,
    "2025-03-31": 202.91788929713945,
    "2025-04-01": 205.31345188385205,
    "2025-04-02": 207.7090144705646,
    "2025-04-03": 210.1045770572772,
    "2025-04-04": 212.5001396439897,
    "2025-04-05": 214.8957022307023,
    "2025-04-06": 217.29126481741488,
    "2025-04-07": 219.68682740412743,
    "2025-04-08": 222.08238999084003,
    "2025-04-09": 224.4779525775526,
    "2025-04-10": 226.8735151642652,
    "2025-04-11": 229.26907775097771,
    "2025-04-12": 231.66464033769032,
    "2025-04-13": 234.0602029244029,
    "2025-04-14": 236.45576551111543,
    "2025-04-15": 238.851328097828,
    "2025-04-16": 241.24689068454057,
    "2025-04-17": 243.64245327125315,
    "2025-04-18": 246.0380158579657,
    "2025-04-19": 248.4335784446783,
    "2025-04-20": 250.8291410313909,
    "2025-04-21": 253.22470361810343,
    "2025-04-22": 255.620266204816,
    "2025-04-23": 258.0158287915286,
    "2025-04-24": 260.41139137824115,
    "2025-04-25": 262.8069539649537,
    "2025-04-26": 265.2025165516663,
    "2025-04-27": 267.59807913837886,
    "2025-04-28": 269.99364172509144,
    "2025-04-29": 272.389204311804,
    "2025-04-30": 274.7847668985166,
    "2025-05-01": 277.61805102139766,
    "2025-05-02": 280.45133514427874,
    "2025-05-03": 283.2846192671598,
    "2025-05-04": 286.1179033900409,
    "2025-05-05": 288.951187512922,
    "2025-05-06": 291.7844716358032,
    "2025-05-07": 294.6177557586842,
    "2025-05-08": 297.4510398815653,
    "2025-05-09": 300.2843240044464,
    "2025-05-10": 303.11760812732746,
    "2025-05-11": 305.95089225020854,
    "2025-05-12": 308.7841763730896,
    "2025-05-13": 311.6174604959707,
    "2025-05-14": 314.4507446188518,
    "2025-05-15": 317.28402874173287,
    "2025-05-16": 320.11731286461395,
    "2025-05-17": 322.9505969874951,
    "2025-05-18": 325.78388111037617,
    "2025-05-19": 328.61716523325725,
    "2025-05-20": 331.45044935613834,
    "2025-05-21": 334.2837334790194,
    "2025-05-22": 337.1170176019005,
    "2025-05-23": 339.9503017247816,
    "2025-05-24": 342.78358584766266,
    "2025-05-25": 345.61686997054375,
    "2025-05-26": 348.4501540934249,
    "2025-05-27": 351.283438216306,
    "2025-05-28": 354.11672233918705,
    "2025-05-29": 356.95000646206813,
    "2025-05-30": 359.7832905849492,
    "2025-05-31": 362.6165747078303,
    "2025-06-01": 365.8537550620479,
    "2025-06-02": 369.0909354162656,
    "2025-06-03": 372.3281157704832,
    "2025-06-04": 375.5652961247008,
    "2025-06-05": 378.8024764789184,
    "2025-06-06": 382.03965683313606,
    "2025-06-07": 385.2768371873537,
    "2025-06-08": 388.5140175415713,
    "2025-06-09": 391.75119789578895,
    "2025-06-10": 394.9883782500066,
    "2025-06-11": 398.2255586042242,
    "2025-06-12": 401.4627389584418,
    "2025-06-13": 404.69991931265946,
    "2025-06-14": 407.9370996668771,
    "2025-06-15": 411.1742800210948,
    "2025-06-16": 414.41146037531234,
    "2025-06-17": 417.64864072953,
    "2025-06-18": 420.8858210837476,
    "2025-06-19": 424.1230014379653,
    "2025-06-20": 427.36018179218286,
    "2025-06-21": 430.5973621464005,
    "2025-06-22": 433.83454250061817,
    "2025-06-23": 437.0717228548358,
    "2025-06-24": 440.3089032090534,
    "2025-06-25": 443.5460835632711,
    "2025-06-26": 446.7832639174887,
    "2025-06-27": 450.0204442717063,
    "2025-06-28": 453.257624625924,
    "2025-06-29": 456.4948049801416,
    "2025-06-30": 459.7319853343592,
    "2025-07-01": 463.06606539906096,
    "2025-07-02": 466.4001454637627,
    "2025-07-03": 469.73422552846455,
    "2025-07-04": 473.0683055931663,
    "2025-07-05": 476.4023856578681,
    "2025-07-06": 479.73646572256985,
    "2025-07-07": 483.0705457872716,
    "2025-07-08": 486.4046258519734,
    "2025-07-09": 489.7387059166752,
    "2025-07-10": 493.07278598137697,
    "2025-07-11": 496.40686604607873,
    "2025-07-12": 499.7409461107805,
    "2025-07-13": 503.0750261754823,
    "2025-07-14": 506.409106240184,
    "2025-07-15": 509.74318630488585,
    "2025-07-16": 513.0772663695876,
    "2025-07-17": 516.4113464342894,
    "2025-07-18": 519.7454264989912,
    "2025-07-19": 523.0795065636929,
    "2025-07-20": 526.4135866283947,
    "2025-07-21": 529.7476666930964,
    "2025-07-22": 533.0817467577982,
    "2025-07-23": 536.4158268225,
    "2025-07-24": 539.7499068872019,
    "2025-07-25": 543.0839869519036,
    "2025-07-26": 546.4180670166054,
    "2025-07-27": 549.7521470813072,
    "2025-07-28": 553.0862271460089,
    "2025-07-29": 556.4203072107107,
    "2025-07-30": 559.7543872754125,
    "2025-07-31": 563.0884673401142,
    "2025-08-01": 566.522166613779,
    "2025-08-02": 569.9558658874437,
    "2025-08-03": 573.3895651611084,
    "2025-08-04": 576.8232644347731,
    "2025-08-05": 580.2569637084379,
    "2025-08-06": 583.6906629821026,
    "2025-08-07": 587.1243622557673,
    "2025-08-08": 590.5580615294322,
    "2025-08-09": 593.9917608030969,
    "2025-08-10": 597.4254600767616,
    "2025-08-11": 600.8591593504264,
    "2025-08-12": 604.2928586240911,
    "2025-08-13": 607.7265578977558,
    "2025-08-14": 611.1602571714205,
    "2025-08-15": 614.5939564450853,
    "2025-08-16": 618.02765571875,
    "2025-08-17": 621.4613549924147,
    "2025-08-18": 624.8950542660795,
    "2025-08-19": 628.3287535397442,
    "2025-08-20": 631.7624528134089,
    "2025-08-21": 635.1961520870736,
    "2025-08-22": 638.6298513607385,
    "2025-08-23": 642.0635506344031,
    "2025-08-24": 645.4972499080679,
    "2025-08-25": 648.9309491817327,
    "2025-08-26": 652.3646484553974,
    "2025-08-27": 655.7983477290621,
    "2025-08-28": 659.2320470027269,
    "2025-08-29": 662.6657462763916,
    "2025-08-30": 666.0994455500563,
    "2025-08-31": 669.533144823721,
    "2025-09-01": 671.6478726816667,
    "2025-09-02": 673.7626005396123,
    "2025-09-03": 675.877328397558,
    "2025-09-04": 677.9920562555037,
    "2025-09-05": 680.1067841134494,
    "2025-09-06": 682.221511971395,
    "2025-09-07": 684.3362398293407,
    "2025-09-08": 686.4509676872864,
    "2025-09-09": 688.5656955452321,
    "2025-09-10": 690.6804234031777,
    "2025-09-11": 692.7951512611234,
    "2025-09-12": 694.909879119069,
    "2025-09-13": 697.0246069770147,
    "2025-09-14": 699.1393348349603,
    "2025-09-15": 701.254062692906,
    "2025-09-16": 703.3687905508517,
    "2025-09-17": 705.4835184087974,
    "2025-09-18": 707.598246266743,
    "2025-09-19": 709.7129741246887,
    "2025-09-20": 711.8277019826344,
    "2025-09-21": 713.94242984058,
    "2025-09-22": 716.0571576985257,
    "2025-09-23": 718.1718855564714,
    "2025-09-24": 720.286613414417,
    "2025-09-25": 722.4013412723626,
    "2025-09-26": 724.5160691303083,
    "2025-09-27": 726.630796988254,
    "2025-09-28": 728.7455248461997,
    "2025-09-29": 730.8602527041453,
    "2025-09-30": 732.974980562091,
  },
  "Peaches/Nectarines": {
    "2024-10-01": 0.0,
    "2024-10-02": 2.12916258196458,
    "2024-10-03": 4.25832516392916,
    "2024-10-04": 6.38748774589374,
    "2024-10-05": 8.51665032785832,
    "2024-10-06": 10.6458129098229,
    "2024-10-07": 12.77497549178748,
    "2024-10-08": 14.90413807375206,
    "2024-10-09": 17.03330065571664,
    "2024-10-10": 19.16246323768122,
    "2024-10-11": 21.2916258196458,
    "2024-10-12": 23.42078840161038,
    "2024-10-13": 25.54995098357496,
    "2024-10-14": 27.67911356553954,
    "2024-10-15": 29.80827614750412,
    "2024-10-16": 31.937438729468703,
    "2024-10-17": 34.06660131143328,
    "2024-10-18": 36.19576389339786,
    "2024-10-19": 38.32492647536244,
    "2024-10-20": 40.45408905732703,
    "2024-10-21": 42.5832516392916,
    "2024-10-22": 44.71241422125618,
    "2024-10-23": 46.84157680322076,
    "2024-10-24": 48.97073938518534,
    "2024-10-25": 51.09990196714992,
    "2024-10-26": 53.2290645491145,
    "2024-10-27": 55.35822713107908,
    "2024-10-28": 57.48738971304366,
    "2024-10-29": 59.61655229500824,
    "2024-10-30": 61.74571487697282,
    "2024-10-31": 63.8748774589374,
    "2024-11-01": 64.51123760957357,
    "2024-11-02": 65.14759776020975,
    "2024-11-03": 65.78395791084591,
    "2024-11-04": 66.42031806148209,
    "2024-11-05": 67.05667821211826,
    "2024-11-06": 67.69303836275444,
    "2024-11-07": 68.32939851339061,
    "2024-11-08": 68.96575866402678,
    "2024-11-09": 69.60211881466296,
    "2024-11-10": 70.23847896529912,
    "2024-11-11": 70.8748391159353,
    "2024-11-12": 71.51119926657148,
    "2024-11-13": 72.14755941720765,
    "2024-11-14": 72.78391956784382,
    "2024-11-15": 73.42027971847999,
    "2024-11-16": 74.05663986911617,
    "2024-11-17": 74.69300001975233,
    "2024-11-18": 75.32936017038851,
    "2024-11-19": 75.96572032102469,
    "2024-11-20": 76.60208047166086,
    "2024-11-21": 77.23844062229703,
    "2024-11-22": 77.8748007729332,
    "2024-11-23": 78.51116092356938,
    "2024-11-24": 79.14752107420554,
    "2024-11-25": 79.78388122484172,
    "2024-11-26": 80.4202413754779,
    "2024-11-27": 81.05660152611406,
    "2024-11-28": 81.69296167675024,
    "2024-11-29": 82.32932182738642,
    "2024-11-30": 82.96568197802259,
    "2024-12-01": 83.31055399365465,
    "2024-12-02": 83.65542600928671,
    "2024-12-03": 84.00029802491878,
    "2024-12-04": 84.34517004055084,
    "2024-12-05": 84.6900420561829,
    "2024-12-06": 85.03491407181495,
    "2024-12-07": 85.37978608744702,
    "2024-12-08": 85.72465810307908,
    "2024-12-09": 86.06953011871114,
    "2024-12-10": 86.4144021343432,
    "2024-12-11": 86.75927414997527,
    "2024-12-12": 87.10414616560733,
    "2024-12-13": 87.4490181812394,
    "2024-12-14": 87.79389019687146,
    "2024-12-15": 88.13876221250352,
    "2024-12-16": 88.48363422813557,
    "2024-12-17": 88.82850624376763,
    "2024-12-18": 89.1733782593997,
    "2024-12-19": 89.51825027503176,
    "2024-12-20": 89.86312229066382,
    "2024-12-21": 90.20799430629587,
    "2024-12-22": 90.55286632192797,
    "2024-12-23": 90.89773833756,
    "2024-12-24": 91.24261035319208,
    "2024-12-25": 91.58748236882414,
    "2024-12-26": 91.9323543844562,
    "2024-12-27": 92.27722640008824,
    "2024-12-28": 92.62209841572032,
    "2024-12-29": 92.96697043135238,
    "2024-12-30": 93.31184244698444,
    "2024-12-31": 93.6567144626165,
    "2025-01-01": 94.20874740592429,
    "2025-01-02": 94.76078034923204,
    "2025-01-03": 95.3128132925398,
    "2025-01-04": 95.8648462358476,
    "2025-01-05": 96.41687917915536,
    "2025-01-06": 96.96891212246312,
    "2025-01-07": 97.5209450657709,
    "2025-01-08": 98.07297800907868,
    "2025-01-09": 98.62501095238645,
    "2025-01-10": 99.1770438956942,
    "2025-01-11": 99.72907683900198,
    "2025-01-12": 100.28110978230976,
    "2025-01-13": 100.83314272561752,
    "2025-01-14": 101.38517566892529,
    "2025-01-15": 101.93720861223306,
    "2025-01-16": 102.48924155554084,
    "2025-01-17": 103.0412744988486,
    "2025-01-18": 103.59330744215636,
    "2025-01-19": 104.14534038546414,
    "2025-01-20": 104.69737332877192,
    "2025-01-21": 105.24940627207968,
    "2025-01-22": 105.80143921538746,
    "2025-01-23": 106.35347215869524,
    "2025-01-24": 106.905505102003,
    "2025-01-25": 107.45753804531076,
    "2025-01-26": 108.00957098861852,
    "2025-01-27": 108.5616039319263,
    "2025-01-28": 109.11363687523408,
    "2025-01-29": 109.66566981854184,
    "2025-01-30": 110.21770276184962,
    "2025-01-31": 110.7697357051574,
    "2025-02-01": 111.71029995084191,
    "2025-02-02": 112.65086419652648,
    "2025-02-03": 113.591428442211,
    "2025-02-04": 114.53199268789557,
    "2025-02-05": 115.4725569335801,
    "2025-02-06": 116.41312117926464,
    "2025-02-07": 117.35368542494918,
    "2025-02-08": 118.29424967063372,
    "2025-02-09": 119.23481391631826,
    "2025-02-10": 120.1753781620028,
    "2025-02-11": 121.11594240768734,
    "2025-02-12": 122.05650665337188,
    "2025-02-13": 122.99707089905642,
    "2025-02-14": 123.93763514474097,
    "2025-02-15": 124.87819939042552,
    "2025-02-16": 125.81876363611003,
    "2025-02-17": 126.7593278817946,
    "2025-02-18": 127.69989212747912,
    "2025-02-19": 128.64045637316366,
    "2025-02-20": 129.5810206188482,
    "2025-02-21": 130.52158486453277,
    "2025-02-22": 131.4621491102173,
    "2025-02-23": 132.40271335590182,
    "2025-02-24": 133.34327760158638,
    "2025-02-25": 134.2838418472709,
    "2025-02-26": 135.22440609295546,
    "2025-02-27": 136.16497033864,
    "2025-02-28": 137.10553458432454,
    "2025-03-01": 138.74513225446464,
    "2025-03-02": 140.38472992460473,
    "2025-03-03": 142.02432759474482,
    "2025-03-04": 143.66392526488488,
    "2025-03-05": 145.30352293502497,
    "2025-03-06": 146.94312060516506,
    "2025-03-07": 148.58271827530515,
    "2025-03-08": 150.22231594544525,
    "2025-03-09": 151.86191361558534,
    "2025-03-10": 153.50151128572543,
    "2025-03-11": 155.1411089558655,
    "2025-03-12": 156.78070662600558,
    "2025-03-13": 158.42030429614567,
    "2025-03-14": 160.05990196628576,
    "2025-03-15": 161.69949963642586,
    "2025-03-16": 163.33909730656595,
    "2025-03-17": 164.97869497670604,
    "2025-03-18": 166.61829264684613,
    "2025-03-19": 168.25789031698622,
    "2025-03-20": 169.89748798712628,
    "2025-03-21": 171.53708565726637,
    "2025-03-22": 173.1766833274065,
    "2025-03-23": 174.81628099754656,
    "2025-03-24": 176.45587866768665,
    "2025-03-25": 178.09547633782674,
    "2025-03-26": 179.73507400796683,
    "2025-03-27": 181.3746716781069,
    "2025-03-28": 183.01426934824696,
    "2025-03-29": 184.65386701838707,
    "2025-03-30": 186.2934646885272,
    "2025-03-31": 187.93306235866729,
    "2025-04-01": 191.12609571239625,
    "2025-04-02": 194.31912906612524,
    "2025-04-03": 197.5121624198542,
    "2025-04-04": 200.7051957735832,
    "2025-04-05": 203.8982291273122,
    "2025-04-06": 207.0912624810412,
    "2025-04-07": 210.28429583477015,
    "2025-04-08": 213.47732918849917,
    "2025-04-09": 216.67036254222813,
    "2025-04-10": 219.86339589595715,
    "2025-04-11": 223.0564292496861,
    "2025-04-12": 226.2494626034151,
    "2025-04-13": 229.44249595714408,
    "2025-04-14": 232.63552931087307,
    "2025-04-15": 235.8285626646021,
    "2025-04-16": 239.02159601833105,
    "2025-04-17": 242.21462937206,
    "2025-04-18": 245.407662725789,
    "2025-04-19": 248.600696079518,
    "2025-04-20": 251.793729433247,
    "2025-04-21": 254.986762786976,
    "2025-04-22": 258.179796140705,
    "2025-04-23": 261.372829494434,
    "2025-04-24": 264.56586284816296,
    "2025-04-25": 267.758896201892,
    "2025-04-26": 270.9519295556209,
    "2025-04-27": 274.1449629093499,
    "2025-04-28": 277.3379962630789,
    "2025-04-29": 280.53102961680787,
    "2025-04-30": 283.72406297053686,
    "2025-05-01": 287.75476686413214,
    "2025-05-02": 291.7854707577274,
    "2025-05-03": 295.8161746513227,
    "2025-05-04": 299.846878544918,
    "2025-05-05": 303.8775824385133,
    "2025-05-06": 307.90828633210856,
    "2025-05-07": 311.93899022570383,
    "2025-05-08": 315.9696941192991,
    "2025-05-09": 320.0003980128944,
    "2025-05-10": 324.03110190648965,
    "2025-05-11": 328.061805800085,
    "2025-05-12": 332.09250969368026,
    "2025-05-13": 336.1232135872756,
    "2025-05-14": 340.1539174808708,
    "2025-05-15": 344.1846213744661,
    "2025-05-16": 348.2153252680614,
    "2025-05-17": 352.2460291616567,
    "2025-05-18": 356.27673305525195,
    "2025-05-19": 360.3074369488472,
    "2025-05-20": 364.3381408424425,
    "2025-05-21": 368.3688447360378,
    "2025-05-22": 372.39954862963305,
    "2025-05-23": 376.4302525232283,
    "2025-05-24": 380.4609564168237,
    "2025-05-25": 384.4916603104189,
    "2025-05-26": 388.5223642040142,
    "2025-05-27": 392.5530680976095,
    "2025-05-28": 396.5837719912048,
    "2025-05-29": 400.6144758848001,
    "2025-05-30": 404.64517977839535,
    "2025-05-31": 408.6758836719906,
    "2025-06-01": 413.7457031858719,
    "2025-06-02": 418.8155226997532,
    "2025-06-03": 423.8853422136344,
    "2025-06-04": 428.9551617275157,
    "2025-06-05": 434.024981241397,
    "2025-06-06": 439.09480075527824,
    "2025-06-07": 444.1646202691595,
    "2025-06-08": 449.2344397830408,
    "2025-06-09": 454.30425929692206,
    "2025-06-10": 459.3740788108033,
    "2025-06-11": 464.4438983246846,
    "2025-06-12": 469.51371783856587,
    "2025-06-13": 474.5835373524472,
    "2025-06-14": 479.6533568663284,
    "2025-06-15": 484.7231763802097,
    "2025-06-16": 489.79299589409095,
    "2025-06-17": 494.8628154079722,
    "2025-06-18": 499.9326349218535,
    "2025-06-19": 505.0024544357348,
    "2025-06-20": 510.072273949616,
    "2025-06-21": 515.1420934634973,
    "2025-06-22": 520.2119129773786,
    "2025-06-23": 525.2817324912598,
    "2025-06-24": 530.3515520051411,
    "2025-06-25": 535.4213715190224,
    "2025-06-26": 540.4911910329037,
    "2025-06-27": 545.5610105467849,
    "2025-06-28": 550.6308300606662,
    "2025-06-29": 555.7006495745475,
    "2025-06-30": 560.7704690884287,
    "2025-07-01": 566.1242716365297,
    "2025-07-02": 571.4780741846307,
    "2025-07-03": 576.8318767327316,
    "2025-07-04": 582.1856792808327,
    "2025-07-05": 587.5394818289336,
    "2025-07-06": 592.8932843770347,
    "2025-07-07": 598.2470869251356,
    "2025-07-08": 603.6008894732365,
    "2025-07-09": 608.9546920213376,
    "2025-07-10": 614.3084945694385,
    "2025-07-11": 619.6622971175395,
    "2025-07-12": 625.0160996656405,
    "2025-07-13": 630.3699022137414,
    "2025-07-14": 635.7237047618424,
    "2025-07-15": 641.0775073099434,
    "2025-07-16": 646.4313098580444,
    "2025-07-17": 651.7851124061453,
    "2025-07-18": 657.1389149542464,
    "2025-07-19": 662.4927175023473,
    "2025-07-20": 667.8465200504484,
    "2025-07-21": 673.2003225985493,
    "2025-07-22": 678.5541251466502,
    "2025-07-23": 683.9079276947513,
    "2025-07-24": 689.2617302428522,
    "2025-07-25": 694.6155327909532,
    "2025-07-26": 699.9693353390542,
    "2025-07-27": 705.3231378871551,
    "2025-07-28": 710.6769404352561,
    "2025-07-29": 716.0307429833571,
    "2025-07-30": 721.3845455314581,
    "2025-07-31": 726.738348079559,
    "2025-08-01": 731.0564815521914,
    "2025-08-02": 735.3746150248238,
    "2025-08-03": 739.6927484974561,
    "2025-08-04": 744.0108819700886,
    "2025-08-05": 748.3290154427209,
    "2025-08-06": 752.6471489153533,
    "2025-08-07": 756.9652823879857,
    "2025-08-08": 761.2834158606181,
    "2025-08-09": 765.6015493332504,
    "2025-08-10": 769.9196828058829,
    "2025-08-11": 774.2378162785152,
    "2025-08-12": 778.5559497511476,
    "2025-08-13": 782.87408322378,
    "2025-08-14": 787.1922166964124,
    "2025-08-15": 791.5103501690447,
    "2025-08-16": 795.8284836416772,
    "2025-08-17": 800.1466171143095,
    "2025-08-18": 804.4647505869419,
    "2025-08-19": 808.7828840595743,
    "2025-08-20": 813.1010175322067,
    "2025-08-21": 817.419151004839,
    "2025-08-22": 821.7372844774715,
    "2025-08-23": 826.0554179501038,
    "2025-08-24": 830.3735514227362,
    "2025-08-25": 834.6916848953686,
    "2025-08-26": 839.009818368001,
    "2025-08-27": 843.3279518406333,
    "2025-08-28": 847.6460853132658,
    "2025-08-29": 851.9642187858981,
    "2025-08-30": 856.2823522585304,
    "2025-08-31": 860.6004857311628,
    "2025-09-01": 863.8363611604873,
    "2025-09-02": 867.0722365898117,
    "2025-09-03": 870.3081120191363,
    "2025-09-04": 873.5439874484607,
    "2025-09-05": 876.7798628777851,
    "2025-09-06": 880.0157383071096,
    "2025-09-07": 883.251613736434,
    "2025-09-08": 886.4874891657586,
    "2025-09-09": 889.723364595083,
    "2025-09-10": 892.9592400244074,
    "2025-09-11": 896.1951154537319,
    "2025-09-12": 899.4309908830563,
    "2025-09-13": 902.6668663123808,
    "2025-09-14": 905.9027417417052,
    "2025-09-15": 909.1386171710298,
    "2025-09-16": 912.3744926003542,
    "2025-09-17": 915.6103680296786,
    "2025-09-18": 918.8462434590032,
    "2025-09-19": 922.0821188883276,
    "2025-09-20": 925.317994317652,
    "2025-09-21": 928.5538697469764,
    "2025-09-22": 931.7897451763008,
    "2025-09-23": 935.0256206056256,
    "2025-09-24": 938.26149603495,
    "2025-09-25": 941.4973714642744,
    "2025-09-26": 944.7332468935988,
    "2025-09-27": 947.9691223229232,
    "2025-09-28": 951.2049977522478,
    "2025-09-29": 954.4408731815722,
    "2025-09-30": 957.6767486108968,
  },
  Pears: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.249735759657168,
    "2024-10-03": 4.499471519314335,
    "2024-10-04": 6.749207278971503,
    "2024-10-05": 8.99894303862867,
    "2024-10-06": 11.248678798285836,
    "2024-10-07": 13.498414557943006,
    "2024-10-08": 15.748150317600174,
    "2024-10-09": 17.99788607725734,
    "2024-10-10": 20.247621836914508,
    "2024-10-11": 22.497357596571675,
    "2024-10-12": 24.747093356228845,
    "2024-10-13": 26.99682911588601,
    "2024-10-14": 29.24656487554318,
    "2024-10-15": 31.49630063520035,
    "2024-10-16": 33.74603639485751,
    "2024-10-17": 35.99577215451468,
    "2024-10-18": 38.24550791417185,
    "2024-10-19": 40.495243673829016,
    "2024-10-20": 42.744979433486186,
    "2024-10-21": 44.99471519314335,
    "2024-10-22": 47.24445095280052,
    "2024-10-23": 49.49418671245769,
    "2024-10-24": 51.74392247211485,
    "2024-10-25": 53.99365823177202,
    "2024-10-26": 56.2433939914292,
    "2024-10-27": 58.49312975108636,
    "2024-10-28": 60.74286551074353,
    "2024-10-29": 62.9926012704007,
    "2024-10-30": 65.24233703005787,
    "2024-10-31": 67.49207278971502,
    "2024-11-01": 68.16121117430082,
    "2024-11-02": 68.83034955888661,
    "2024-11-03": 69.4994879434724,
    "2024-11-04": 70.1686263280582,
    "2024-11-05": 70.83776471264399,
    "2024-11-06": 71.50690309722978,
    "2024-11-07": 72.17604148181559,
    "2024-11-08": 72.84517986640138,
    "2024-11-09": 73.51431825098717,
    "2024-11-10": 74.18345663557297,
    "2024-11-11": 74.85259502015876,
    "2024-11-12": 75.52173340474455,
    "2024-11-13": 76.19087178933034,
    "2024-11-14": 76.86001017391614,
    "2024-11-15": 77.52914855850193,
    "2024-11-16": 78.19828694308772,
    "2024-11-17": 78.86742532767352,
    "2024-11-18": 79.53656371225931,
    "2024-11-19": 80.2057020968451,
    "2024-11-20": 80.8748404814309,
    "2024-11-21": 81.54397886601669,
    "2024-11-22": 82.2131172506025,
    "2024-11-23": 82.88225563518829,
    "2024-11-24": 83.55139401977408,
    "2024-11-25": 84.22053240435987,
    "2024-11-26": 84.88967078894566,
    "2024-11-27": 85.55880917353146,
    "2024-11-28": 86.22794755811725,
    "2024-11-29": 86.89708594270304,
    "2024-11-30": 87.56622432728884,
    "2024-12-01": 87.92630759363051,
    "2024-12-02": 88.2863908599722,
    "2024-12-03": 88.64647412631388,
    "2024-12-04": 89.00655739265557,
    "2024-12-05": 89.36664065899724,
    "2024-12-06": 89.72672392533892,
    "2024-12-07": 90.0868071916806,
    "2024-12-08": 90.44689045802228,
    "2024-12-09": 90.80697372436396,
    "2024-12-10": 91.16705699070565,
    "2024-12-11": 91.52714025704734,
    "2024-12-12": 91.887223523389,
    "2024-12-13": 92.24730678973069,
    "2024-12-14": 92.60739005607238,
    "2024-12-15": 92.96747332241404,
    "2024-12-16": 93.32755658875574,
    "2024-12-17": 93.68763985509742,
    "2024-12-18": 94.0477231214391,
    "2024-12-19": 94.40780638778078,
    "2024-12-20": 94.76788965412246,
    "2024-12-21": 95.12797292046416,
    "2024-12-22": 95.48805618680582,
    "2024-12-23": 95.84813945314752,
    "2024-12-24": 96.2082227194892,
    "2024-12-25": 96.56830598583088,
    "2024-12-26": 96.92838925217256,
    "2024-12-27": 97.28847251851424,
    "2024-12-28": 97.64855578485592,
    "2024-12-29": 98.0086390511976,
    "2024-12-30": 98.36872231753928,
    "2024-12-31": 98.72880558388096,
    "2025-01-01": 99.2868310348264,
    "2025-01-02": 99.84485648577184,
    "2025-01-03": 100.40288193671728,
    "2025-01-04": 100.96090738766271,
    "2025-01-05": 101.51893283860817,
    "2025-01-06": 102.0769582895536,
    "2025-01-07": 102.63498374049902,
    "2025-01-08": 103.19300919144447,
    "2025-01-09": 103.75103464238993,
    "2025-01-10": 104.30906009333536,
    "2025-01-11": 104.86708554428078,
    "2025-01-12": 105.42511099522622,
    "2025-01-13": 105.98313644617168,
    "2025-01-14": 106.5411618971171,
    "2025-01-15": 107.09918734806254,
    "2025-01-16": 107.65721279900798,
    "2025-01-17": 108.21523824995342,
    "2025-01-18": 108.77326370089888,
    "2025-01-19": 109.3312891518443,
    "2025-01-20": 109.88931460278974,
    "2025-01-21": 110.44734005373518,
    "2025-01-22": 111.0053655046806,
    "2025-01-23": 111.56339095562606,
    "2025-01-24": 112.1214164065715,
    "2025-01-25": 112.67944185751692,
    "2025-01-26": 113.23746730846236,
    "2025-01-27": 113.7954927594078,
    "2025-01-28": 114.35351821035326,
    "2025-01-29": 114.9115436612987,
    "2025-01-30": 115.46956911224412,
    "2025-01-31": 116.02759456318957,
    "2025-02-01": 116.9163638859104,
    "2025-02-02": 117.80513320863125,
    "2025-02-03": 118.69390253135208,
    "2025-02-04": 119.5826718540729,
    "2025-02-05": 120.47144117679376,
    "2025-02-06": 121.36021049951458,
    "2025-02-07": 122.2489798222354,
    "2025-02-08": 123.13774914495625,
    "2025-02-09": 124.02651846767708,
    "2025-02-10": 124.91528779039793,
    "2025-02-11": 125.80405711311874,
    "2025-02-12": 126.69282643583958,
    "2025-02-13": 127.5815957585604,
    "2025-02-14": 128.47036508128124,
    "2025-02-15": 129.35913440400208,
    "2025-02-16": 130.2479037267229,
    "2025-02-17": 131.13667304944374,
    "2025-02-18": 132.0254423721646,
    "2025-02-19": 132.9142116948854,
    "2025-02-20": 133.80298101760627,
    "2025-02-21": 134.6917503403271,
    "2025-02-22": 135.58051966304794,
    "2025-02-23": 136.46928898576877,
    "2025-02-24": 137.3580583084896,
    "2025-02-25": 138.24682763121044,
    "2025-02-26": 139.13559695393127,
    "2025-02-27": 140.0243662766521,
    "2025-02-28": 140.91313559937294,
    "2025-03-01": 142.3833201774355,
    "2025-03-02": 143.85350475549808,
    "2025-03-03": 145.32368933356065,
    "2025-03-04": 146.79387391162322,
    "2025-03-05": 148.2640584896858,
    "2025-03-06": 149.73424306774837,
    "2025-03-07": 151.20442764581094,
    "2025-03-08": 152.6746122238735,
    "2025-03-09": 154.1447968019361,
    "2025-03-10": 155.61498137999868,
    "2025-03-11": 157.08516595806125,
    "2025-03-12": 158.55535053612385,
    "2025-03-13": 160.0255351141864,
    "2025-03-14": 161.49571969224897,
    "2025-03-15": 162.96590427031154,
    "2025-03-16": 164.4360888483741,
    "2025-03-17": 165.90627342643668,
    "2025-03-18": 167.37645800449926,
    "2025-03-19": 168.84664258256183,
    "2025-03-20": 170.3168271606244,
    "2025-03-21": 171.78701173868697,
    "2025-03-22": 173.25719631674957,
    "2025-03-23": 174.72738089481214,
    "2025-03-24": 176.19756547287471,
    "2025-03-25": 177.6677500509373,
    "2025-03-26": 179.13793462899986,
    "2025-03-27": 180.60811920706243,
    "2025-03-28": 182.078303785125,
    "2025-03-29": 183.5484883631876,
    "2025-03-30": 185.01867294125012,
    "2025-03-31": 186.48885751931272,
    "2025-04-01": 189.4410822831212,
    "2025-04-02": 192.3933070469297,
    "2025-04-03": 195.3455318107382,
    "2025-04-04": 198.2977565745467,
    "2025-04-05": 201.2499813383552,
    "2025-04-06": 204.20220610216367,
    "2025-04-07": 207.15443086597216,
    "2025-04-08": 210.10665562978068,
    "2025-04-09": 213.0588803935892,
    "2025-04-10": 216.01110515739765,
    "2025-04-11": 218.9633299212061,
    "2025-04-12": 221.91555468501463,
    "2025-04-13": 224.86777944882317,
    "2025-04-14": 227.82000421263163,
    "2025-04-15": 230.7722289764401,
    "2025-04-16": 233.7244537402486,
    "2025-04-17": 236.67667850405712,
    "2025-04-18": 239.6289032678656,
    "2025-04-19": 242.5811280316741,
    "2025-04-20": 245.53335279548256,
    "2025-04-21": 248.48557755929107,
    "2025-04-22": 251.4378023230996,
    "2025-04-23": 254.39002708690805,
    "2025-04-24": 257.3422518507166,
    "2025-04-25": 260.294476614525,
    "2025-04-26": 263.2467013783336,
    "2025-04-27": 266.19892614214206,
    "2025-04-28": 269.15115090595054,
    "2025-04-29": 272.10337566975903,
    "2025-04-30": 275.0556004335675,
    "2025-05-01": 278.8324347002671,
    "2025-05-02": 282.60926896696657,
    "2025-05-03": 286.3861032336661,
    "2025-05-04": 290.1629375003657,
    "2025-05-05": 293.9397717670652,
    "2025-05-06": 297.7166060337647,
    "2025-05-07": 301.4934403004643,
    "2025-05-08": 305.27027456716377,
    "2025-05-09": 309.0471088338633,
    "2025-05-10": 312.8239431005629,
    "2025-05-11": 316.6007773672624,
    "2025-05-12": 320.3776116339619,
    "2025-05-13": 324.15444590066147,
    "2025-05-14": 327.931280167361,
    "2025-05-15": 331.7081144340605,
    "2025-05-16": 335.48494870076007,
    "2025-05-17": 339.2617829674596,
    "2025-05-18": 343.0386172341591,
    "2025-05-19": 346.81545150085867,
    "2025-05-20": 350.5922857675582,
    "2025-05-21": 354.3691200342577,
    "2025-05-22": 358.14595430095727,
    "2025-05-23": 361.9227885676568,
    "2025-05-24": 365.6996228343563,
    "2025-05-25": 369.4764571010559,
    "2025-05-26": 373.2532913677554,
    "2025-05-27": 377.0301256344549,
    "2025-05-28": 380.80695990115447,
    "2025-05-29": 384.583794167854,
    "2025-05-30": 388.3606284345535,
    "2025-05-31": 392.137462701253,
    "2025-06-01": 396.7615650751996,
    "2025-06-02": 401.38566744914607,
    "2025-06-03": 406.0097698230926,
    "2025-06-04": 410.6338721970391,
    "2025-06-05": 415.2579745709856,
    "2025-06-06": 419.88207694493207,
    "2025-06-07": 424.5061793188786,
    "2025-06-08": 429.13028169282506,
    "2025-06-09": 433.7543840667716,
    "2025-06-10": 438.37848644071806,
    "2025-06-11": 443.0025888146646,
    "2025-06-12": 447.6266911886111,
    "2025-06-13": 452.2507935625576,
    "2025-06-14": 456.8748959365041,
    "2025-06-15": 461.4989983104506,
    "2025-06-16": 466.12310068439706,
    "2025-06-17": 470.7472030583436,
    "2025-06-18": 475.3713054322901,
    "2025-06-19": 479.9954078062366,
    "2025-06-20": 484.6195101801831,
    "2025-06-21": 489.2436125541296,
    "2025-06-22": 493.8677149280761,
    "2025-06-23": 498.4918173020226,
    "2025-06-24": 503.1159196759691,
    "2025-06-25": 507.7400220499156,
    "2025-06-26": 512.3641244238621,
    "2025-06-27": 516.9882267978086,
    "2025-06-28": 521.6123291717552,
    "2025-06-29": 526.2364315457016,
    "2025-06-30": 530.8605339196481,
    "2025-07-01": 535.8109630710417,
    "2025-07-02": 540.7613922224353,
    "2025-07-03": 545.7118213738289,
    "2025-07-04": 550.6622505252225,
    "2025-07-05": 555.6126796766162,
    "2025-07-06": 560.5631088280097,
    "2025-07-07": 565.5135379794033,
    "2025-07-08": 570.463967130797,
    "2025-07-09": 575.4143962821905,
    "2025-07-10": 580.3648254335841,
    "2025-07-11": 585.3152545849778,
    "2025-07-12": 590.2656837363713,
    "2025-07-13": 595.2161128877649,
    "2025-07-14": 600.1665420391585,
    "2025-07-15": 605.1169711905521,
    "2025-07-16": 610.0674003419457,
    "2025-07-17": 615.0178294933394,
    "2025-07-18": 619.9682586447329,
    "2025-07-19": 624.9186877961265,
    "2025-07-20": 629.8691169475201,
    "2025-07-21": 634.8195460989137,
    "2025-07-22": 639.7699752503073,
    "2025-07-23": 644.7204044017009,
    "2025-07-24": 649.6708335530946,
    "2025-07-25": 654.6212627044881,
    "2025-07-26": 659.5716918558817,
    "2025-07-27": 664.5221210072754,
    "2025-07-28": 669.4725501586689,
    "2025-07-29": 674.4229793100625,
    "2025-07-30": 679.3734084614562,
    "2025-07-31": 684.3238376128497,
    "2025-08-01": 688.5822868091174,
    "2025-08-02": 692.8407360053849,
    "2025-08-03": 697.0991852016525,
    "2025-08-04": 701.35763439792,
    "2025-08-05": 705.6160835941877,
    "2025-08-06": 709.8745327904553,
    "2025-08-07": 714.1329819867228,
    "2025-08-08": 718.3914311829905,
    "2025-08-09": 722.6498803792581,
    "2025-08-10": 726.9083295755256,
    "2025-08-11": 731.1667787717932,
    "2025-08-12": 735.4252279680608,
    "2025-08-13": 739.6836771643284,
    "2025-08-14": 743.9421263605959,
    "2025-08-15": 748.2005755568636,
    "2025-08-16": 752.4590247531312,
    "2025-08-17": 756.7174739493987,
    "2025-08-18": 760.9759231456663,
    "2025-08-19": 765.234372341934,
    "2025-08-20": 769.4928215382015,
    "2025-08-21": 773.7512707344691,
    "2025-08-22": 778.0097199307367,
    "2025-08-23": 782.2681691270043,
    "2025-08-24": 786.5266183232719,
    "2025-08-25": 790.7850675195394,
    "2025-08-26": 795.0435167158071,
    "2025-08-27": 799.3019659120746,
    "2025-08-28": 803.5604151083422,
    "2025-08-29": 807.8188643046099,
    "2025-08-30": 812.0773135008774,
    "2025-08-31": 816.335762697145,
    "2025-09-01": 819.470149376331,
    "2025-09-02": 822.6045360555171,
    "2025-09-03": 825.738922734703,
    "2025-09-04": 828.873309413889,
    "2025-09-05": 832.0076960930751,
    "2025-09-06": 835.1420827722611,
    "2025-09-07": 838.2764694514472,
    "2025-09-08": 841.4108561306332,
    "2025-09-09": 844.5452428098192,
    "2025-09-10": 847.6796294890052,
    "2025-09-11": 850.8140161681912,
    "2025-09-12": 853.9484028473772,
    "2025-09-13": 857.0827895265633,
    "2025-09-14": 860.2171762057493,
    "2025-09-15": 863.3515628849352,
    "2025-09-16": 866.4859495641213,
    "2025-09-17": 869.6203362433073,
    "2025-09-18": 872.7547229224933,
    "2025-09-19": 875.8891096016794,
    "2025-09-20": 879.0234962808654,
    "2025-09-21": 882.1578829600514,
    "2025-09-22": 885.2922696392374,
    "2025-09-23": 888.4266563184234,
    "2025-09-24": 891.5610429976094,
    "2025-09-25": 894.6954296767955,
    "2025-09-26": 897.8298163559815,
    "2025-09-27": 900.9642030351674,
    "2025-09-28": 904.0985897143536,
    "2025-09-29": 907.2329763935396,
    "2025-09-30": 910.3673630727257,
  },
  Pecans: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.147122160336644,
    "2024-10-03": 4.294244320673288,
    "2024-10-04": 6.441366481009932,
    "2024-10-05": 8.588488641346576,
    "2024-10-06": 10.73561080168322,
    "2024-10-07": 12.882732962019864,
    "2024-10-08": 15.029855122356508,
    "2024-10-09": 17.17697728269315,
    "2024-10-10": 19.324099443029795,
    "2024-10-11": 21.47122160336644,
    "2024-10-12": 23.618343763703084,
    "2024-10-13": 25.765465924039727,
    "2024-10-14": 27.91258808437637,
    "2024-10-15": 30.059710244713017,
    "2024-10-16": 32.20683240504966,
    "2024-10-17": 34.3539545653863,
    "2024-10-18": 36.50107672572295,
    "2024-10-19": 38.64819888605959,
    "2024-10-20": 40.79532104639623,
    "2024-10-21": 42.94244320673288,
    "2024-10-22": 45.089565367069525,
    "2024-10-23": 47.23668752740617,
    "2024-10-24": 49.38380968774281,
    "2024-10-25": 51.530931848079454,
    "2024-10-26": 53.6780540084161,
    "2024-10-27": 55.82517616875274,
    "2024-10-28": 57.97229832908938,
    "2024-10-29": 60.119420489426034,
    "2024-10-30": 62.26654264976268,
    "2024-10-31": 64.41366481009932,
    "2024-11-01": 65.25811975882593,
    "2024-11-02": 66.10257470755255,
    "2024-11-03": 66.94702965627917,
    "2024-11-04": 67.79148460500578,
    "2024-11-05": 68.63593955373238,
    "2024-11-06": 69.480394502459,
    "2024-11-07": 70.32484945118563,
    "2024-11-08": 71.16930439991224,
    "2024-11-09": 72.01375934863884,
    "2024-11-10": 72.85821429736546,
    "2024-11-11": 73.70266924609209,
    "2024-11-12": 74.5471241948187,
    "2024-11-13": 75.3915791435453,
    "2024-11-14": 76.23603409227192,
    "2024-11-15": 77.08048904099854,
    "2024-11-16": 77.92494398972515,
    "2024-11-17": 78.76939893845176,
    "2024-11-18": 79.61385388717838,
    "2024-11-19": 80.458308835905,
    "2024-11-20": 81.30276378463161,
    "2024-11-21": 82.14721873335822,
    "2024-11-22": 82.99167368208484,
    "2024-11-23": 83.83612863081146,
    "2024-11-24": 84.68058357953807,
    "2024-11-25": 85.52503852826467,
    "2024-11-26": 86.3694934769913,
    "2024-11-27": 87.21394842571792,
    "2024-11-28": 88.05840337444452,
    "2024-11-29": 88.90285832317113,
    "2024-11-30": 89.74731327189775,
    "2024-12-01": 90.13762575368796,
    "2024-12-02": 90.5279382354782,
    "2024-12-03": 90.9182507172684,
    "2024-12-04": 91.30856319905864,
    "2024-12-05": 91.69887568084884,
    "2024-12-06": 92.08918816263906,
    "2024-12-07": 92.47950064442928,
    "2024-12-08": 92.8698131262195,
    "2024-12-09": 93.26012560800972,
    "2024-12-10": 93.65043808979992,
    "2024-12-11": 94.04075057159017,
    "2024-12-12": 94.43106305338036,
    "2024-12-13": 94.8213755351706,
    "2024-12-14": 95.2116880169608,
    "2024-12-15": 95.602000498751,
    "2024-12-16": 95.99231298054124,
    "2024-12-17": 96.38262546233145,
    "2024-12-18": 96.77293794412168,
    "2024-12-19": 97.16325042591188,
    "2024-12-20": 97.5535629077021,
    "2024-12-21": 97.94387538949232,
    "2024-12-22": 98.33418787128254,
    "2024-12-23": 98.72450035307276,
    "2024-12-24": 99.11481283486296,
    "2024-12-25": 99.5051253166532,
    "2024-12-26": 99.8954377984434,
    "2024-12-27": 100.28575028023364,
    "2024-12-28": 100.67606276202385,
    "2024-12-29": 101.06637524381406,
    "2024-12-30": 101.45668772560428,
    "2024-12-31": 101.8470002073945,
    "2025-01-01": 102.39469395119366,
    "2025-01-02": 102.94238769499282,
    "2025-01-03": 103.49008143879198,
    "2025-01-04": 104.03777518259112,
    "2025-01-05": 104.58546892639028,
    "2025-01-06": 105.13316267018944,
    "2025-01-07": 105.6808564139886,
    "2025-01-08": 106.22855015778777,
    "2025-01-09": 106.77624390158692,
    "2025-01-10": 107.32393764538608,
    "2025-01-11": 107.87163138918524,
    "2025-01-12": 108.41932513298438,
    "2025-01-13": 108.96701887678354,
    "2025-01-14": 109.5147126205827,
    "2025-01-15": 110.06240636438186,
    "2025-01-16": 110.61010010818102,
    "2025-01-17": 111.15779385198016,
    "2025-01-18": 111.70548759577932,
    "2025-01-19": 112.25318133957848,
    "2025-01-20": 112.80087508337763,
    "2025-01-21": 113.3485688271768,
    "2025-01-22": 113.89626257097596,
    "2025-01-23": 114.44395631477512,
    "2025-01-24": 114.99165005857428,
    "2025-01-25": 115.53934380237342,
    "2025-01-26": 116.08703754617258,
    "2025-01-27": 116.63473128997174,
    "2025-01-28": 117.1824250337709,
    "2025-01-29": 117.73011877757006,
    "2025-01-30": 118.2778125213692,
    "2025-01-31": 118.82550626516836,
    "2025-02-01": 119.927892166389,
    "2025-02-02": 121.0302780676096,
    "2025-02-03": 122.1326639688302,
    "2025-02-04": 123.23504987005082,
    "2025-02-05": 124.33743577127144,
    "2025-02-06": 125.43982167249204,
    "2025-02-07": 126.54220757371266,
    "2025-02-08": 127.64459347493326,
    "2025-02-09": 128.7469793761539,
    "2025-02-10": 129.8493652773745,
    "2025-02-11": 130.9517511785951,
    "2025-02-12": 132.05413707981572,
    "2025-02-13": 133.15652298103632,
    "2025-02-14": 134.25890888225695,
    "2025-02-15": 135.36129478347755,
    "2025-02-16": 136.46368068469815,
    "2025-02-17": 137.56606658591878,
    "2025-02-18": 138.66845248713938,
    "2025-02-19": 139.77083838835998,
    "2025-02-20": 140.8732242895806,
    "2025-02-21": 141.9756101908012,
    "2025-02-22": 143.07799609202183,
    "2025-02-23": 144.18038199324243,
    "2025-02-24": 145.28276789446303,
    "2025-02-25": 146.38515379568366,
    "2025-02-26": 147.48753969690426,
    "2025-02-27": 148.58992559812486,
    "2025-02-28": 149.6923114993455,
    "2025-03-01": 151.4260043550889,
    "2025-03-02": 153.1596972108323,
    "2025-03-03": 154.8933900665757,
    "2025-03-04": 156.62708292231912,
    "2025-03-05": 158.3607757780625,
    "2025-03-06": 160.09446863380592,
    "2025-03-07": 161.82816148954933,
    "2025-03-08": 163.56185434529272,
    "2025-03-09": 165.29554720103613,
    "2025-03-10": 167.02924005677954,
    "2025-03-11": 168.76293291252296,
    "2025-03-12": 170.49662576826634,
    "2025-03-13": 172.23031862400975,
    "2025-03-14": 173.96401147975314,
    "2025-03-15": 175.69770433549655,
    "2025-03-16": 177.43139719123997,
    "2025-03-17": 179.16509004698338,
    "2025-03-18": 180.8987829027268,
    "2025-03-19": 182.63247575847015,
    "2025-03-20": 184.3661686142136,
    "2025-03-21": 186.09986146995695,
    "2025-03-22": 187.8335543257004,
    "2025-03-23": 189.5672471814438,
    "2025-03-24": 191.3009400371872,
    "2025-03-25": 193.0346328929306,
    "2025-03-26": 194.768325748674,
    "2025-03-27": 196.5020186044174,
    "2025-03-28": 198.2357114601608,
    "2025-03-29": 199.96940431590423,
    "2025-03-30": 201.70309717164764,
    "2025-03-31": 203.43679002739103,
    "2025-04-01": 206.48068258933688,
    "2025-04-02": 209.52457515128276,
    "2025-04-03": 212.56846771322856,
    "2025-04-04": 215.61236027517444,
    "2025-04-05": 218.6562528371203,
    "2025-04-06": 221.70014539906612,
    "2025-04-07": 224.744037961012,
    "2025-04-08": 227.78793052295785,
    "2025-04-09": 230.8318230849037,
    "2025-04-10": 233.8757156468496,
    "2025-04-11": 236.9196082087954,
    "2025-04-12": 239.96350077074123,
    "2025-04-13": 243.00739333268712,
    "2025-04-14": 246.0512858946329,
    "2025-04-15": 249.0951784565788,
    "2025-04-16": 252.13907101852465,
    "2025-04-17": 255.18296358047053,
    "2025-04-18": 258.22685614241635,
    "2025-04-19": 261.27074870436223,
    "2025-04-20": 264.31464126630806,
    "2025-04-21": 267.35853382825394,
    "2025-04-22": 270.40242639019976,
    "2025-04-23": 273.44631895214565,
    "2025-04-24": 276.49021151409147,
    "2025-04-25": 279.5341040760373,
    "2025-04-26": 282.5779966379832,
    "2025-04-27": 285.621889199929,
    "2025-04-28": 288.6657817618749,
    "2025-04-29": 291.7096743238208,
    "2025-04-30": 294.7535668857666,
    "2025-05-01": 298.50671254711165,
    "2025-05-02": 302.2598582084567,
    "2025-05-03": 306.01300386980176,
    "2025-05-04": 309.7661495311468,
    "2025-05-05": 313.5192951924919,
    "2025-05-06": 317.27244085383694,
    "2025-05-07": 321.025586515182,
    "2025-05-08": 324.77873217652706,
    "2025-05-09": 328.5318778378721,
    "2025-05-10": 332.2850234992172,
    "2025-05-11": 336.03816916056223,
    "2025-05-12": 339.7913148219073,
    "2025-05-13": 343.54446048325235,
    "2025-05-14": 347.29760614459747,
    "2025-05-15": 351.05075180594247,
    "2025-05-16": 354.8038974672876,
    "2025-05-17": 358.5570431286326,
    "2025-05-18": 362.3101887899777,
    "2025-05-19": 366.0633344513227,
    "2025-05-20": 369.8164801126678,
    "2025-05-21": 373.5696257740129,
    "2025-05-22": 377.32277143535794,
    "2025-05-23": 381.075917096703,
    "2025-05-24": 384.82906275804805,
    "2025-05-25": 388.5822084193931,
    "2025-05-26": 392.33535408073817,
    "2025-05-27": 396.0884997420832,
    "2025-05-28": 399.8416454034283,
    "2025-05-29": 403.59479106477335,
    "2025-05-30": 407.3479367261184,
    "2025-05-31": 411.10108238746346,
    "2025-06-01": 415.77836978735183,
    "2025-06-02": 420.45565718724015,
    "2025-06-03": 425.13294458712846,
    "2025-06-04": 429.8102319870168,
    "2025-06-05": 434.4875193869052,
    "2025-06-06": 439.1648067867935,
    "2025-06-07": 443.8420941866818,
    "2025-06-08": 448.5193815865702,
    "2025-06-09": 453.1966689864586,
    "2025-06-10": 457.8739563863469,
    "2025-06-11": 462.5512437862352,
    "2025-06-12": 467.2285311861236,
    "2025-06-13": 471.905818586012,
    "2025-06-14": 476.58310598590026,
    "2025-06-15": 481.2603933857886,
    "2025-06-16": 485.93768078567695,
    "2025-06-17": 490.6149681855653,
    "2025-06-18": 495.2922555854536,
    "2025-06-19": 499.969542985342,
    "2025-06-20": 504.6468303852303,
    "2025-06-21": 509.3241177851187,
    "2025-06-22": 514.001405185007,
    "2025-06-23": 518.6786925848953,
    "2025-06-24": 523.3559799847837,
    "2025-06-25": 528.0332673846721,
    "2025-06-26": 532.7105547845604,
    "2025-06-27": 537.3878421844487,
    "2025-06-28": 542.065129584337,
    "2025-06-29": 546.7424169842254,
    "2025-06-30": 551.4197043841137,
    "2025-07-01": 556.5220141497682,
    "2025-07-02": 561.6243239154226,
    "2025-07-03": 566.726633681077,
    "2025-07-04": 571.8289434467314,
    "2025-07-05": 576.9312532123859,
    "2025-07-06": 582.0335629780403,
    "2025-07-07": 587.1358727436947,
    "2025-07-08": 592.2381825093491,
    "2025-07-09": 597.3404922750035,
    "2025-07-10": 602.442802040658,
    "2025-07-11": 607.5451118063124,
    "2025-07-12": 612.6474215719668,
    "2025-07-13": 617.7497313376213,
    "2025-07-14": 622.8520411032757,
    "2025-07-15": 627.9543508689301,
    "2025-07-16": 633.0566606345845,
    "2025-07-17": 638.1589704002389,
    "2025-07-18": 643.2612801658934,
    "2025-07-19": 648.3635899315478,
    "2025-07-20": 653.4658996972022,
    "2025-07-21": 658.5682094628567,
    "2025-07-22": 663.670519228511,
    "2025-07-23": 668.7728289941655,
    "2025-07-24": 673.87513875982,
    "2025-07-25": 678.9774485254743,
    "2025-07-26": 684.0797582911288,
    "2025-07-27": 689.1820680567832,
    "2025-07-28": 694.2843778224376,
    "2025-07-29": 699.3866875880921,
    "2025-07-30": 704.4889973537464,
    "2025-07-31": 709.5913071194009,
    "2025-08-01": 713.5876572080376,
    "2025-08-02": 717.5840072966743,
    "2025-08-03": 721.580357385311,
    "2025-08-04": 725.5767074739477,
    "2025-08-05": 729.5730575625845,
    "2025-08-06": 733.5694076512211,
    "2025-08-07": 737.5657577398579,
    "2025-08-08": 741.5621078284946,
    "2025-08-09": 745.5584579171314,
    "2025-08-10": 749.554808005768,
    "2025-08-11": 753.5511580944047,
    "2025-08-12": 757.5475081830415,
    "2025-08-13": 761.5438582716782,
    "2025-08-14": 765.5402083603149,
    "2025-08-15": 769.5365584489516,
    "2025-08-16": 773.5329085375884,
    "2025-08-17": 777.5292586262251,
    "2025-08-18": 781.5256087148617,
    "2025-08-19": 785.5219588034985,
    "2025-08-20": 789.5183088921352,
    "2025-08-21": 793.514658980772,
    "2025-08-22": 797.5110090694086,
    "2025-08-23": 801.5073591580453,
    "2025-08-24": 805.5037092466821,
    "2025-08-25": 809.5000593353188,
    "2025-08-26": 813.4964094239555,
    "2025-08-27": 817.4927595125922,
    "2025-08-28": 821.489109601229,
    "2025-08-29": 825.4854596898656,
    "2025-08-30": 829.4818097785023,
    "2025-08-31": 833.4781598671391,
    "2025-09-01": 836.648785444177,
    "2025-09-02": 839.8194110212148,
    "2025-09-03": 842.9900365982526,
    "2025-09-04": 846.1606621752904,
    "2025-09-05": 849.3312877523283,
    "2025-09-06": 852.5019133293662,
    "2025-09-07": 855.6725389064039,
    "2025-09-08": 858.8431644834418,
    "2025-09-09": 862.0137900604797,
    "2025-09-10": 865.1844156375175,
    "2025-09-11": 868.3550412145553,
    "2025-09-12": 871.5256667915932,
    "2025-09-13": 874.696292368631,
    "2025-09-14": 877.8669179456689,
    "2025-09-15": 881.0375435227068,
    "2025-09-16": 884.2081690997445,
    "2025-09-17": 887.3787946767824,
    "2025-09-18": 890.5494202538202,
    "2025-09-19": 893.7200458308581,
    "2025-09-20": 896.8906714078959,
    "2025-09-21": 900.0612969849337,
    "2025-09-22": 903.2319225619716,
    "2025-09-23": 906.4025481390096,
    "2025-09-24": 909.5731737160472,
    "2025-09-25": 912.7437992930852,
    "2025-09-26": 915.914424870123,
    "2025-09-27": 919.0850504471608,
    "2025-09-28": 922.2556760241988,
    "2025-09-29": 925.4263016012364,
    "2025-09-30": 928.5969271782744,
  },
  Pistachios: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.948158403180684,
    "2024-10-03": 3.896316806361368,
    "2024-10-04": 5.844475209542052,
    "2024-10-05": 7.792633612722736,
    "2024-10-06": 9.74079201590342,
    "2024-10-07": 11.688950419084104,
    "2024-10-08": 13.637108822264787,
    "2024-10-09": 15.585267225445472,
    "2024-10-10": 17.533425628626155,
    "2024-10-11": 19.48158403180684,
    "2024-10-12": 21.429742434987524,
    "2024-10-13": 23.37790083816821,
    "2024-10-14": 25.326059241348894,
    "2024-10-15": 27.27421764452957,
    "2024-10-16": 29.22237604771026,
    "2024-10-17": 31.170534450890944,
    "2024-10-18": 33.118692854071625,
    "2024-10-19": 35.06685125725231,
    "2024-10-20": 37.015009660433,
    "2024-10-21": 38.96316806361368,
    "2024-10-22": 40.91132646679437,
    "2024-10-23": 42.85948486997505,
    "2024-10-24": 44.80764327315573,
    "2024-10-25": 46.75580167633642,
    "2024-10-26": 48.7039600795171,
    "2024-10-27": 50.65211848269779,
    "2024-10-28": 52.60027688587847,
    "2024-10-29": 54.54843528905915,
    "2024-10-30": 56.49659369223984,
    "2024-10-31": 58.44475209542052,
    "2024-11-01": 59.03273260171815,
    "2024-11-02": 59.620713108015785,
    "2024-11-03": 60.20869361431342,
    "2024-11-04": 60.79667412061105,
    "2024-11-05": 61.38465462690869,
    "2024-11-06": 61.97263513320632,
    "2024-11-07": 62.56061563950395,
    "2024-11-08": 63.148596145801584,
    "2024-11-09": 63.73657665209922,
    "2024-11-10": 64.32455715839686,
    "2024-11-11": 64.91253766469448,
    "2024-11-12": 65.50051817099212,
    "2024-11-13": 66.08849867728975,
    "2024-11-14": 66.67647918358739,
    "2024-11-15": 67.26445968988502,
    "2024-11-16": 67.85244019618266,
    "2024-11-17": 68.44042070248028,
    "2024-11-18": 69.02840120877792,
    "2024-11-19": 69.61638171507555,
    "2024-11-20": 70.20436222137319,
    "2024-11-21": 70.79234272767081,
    "2024-11-22": 71.38032323396845,
    "2024-11-23": 71.96830374026608,
    "2024-11-24": 72.55628424656372,
    "2024-11-25": 73.14426475286135,
    "2024-11-26": 73.73224525915899,
    "2024-11-27": 74.32022576545661,
    "2024-11-28": 74.90820627175425,
    "2024-11-29": 75.49618677805188,
    "2024-11-30": 76.08416728434952,
    "2024-12-01": 76.24690471924043,
    "2024-12-02": 76.40964215413135,
    "2024-12-03": 76.57237958902226,
    "2024-12-04": 76.73511702391319,
    "2024-12-05": 76.8978544588041,
    "2024-12-06": 77.06059189369502,
    "2024-12-07": 77.22332932858593,
    "2024-12-08": 77.38606676347685,
    "2024-12-09": 77.54880419836776,
    "2024-12-10": 77.71154163325868,
    "2024-12-11": 77.87427906814959,
    "2024-12-12": 78.03701650304052,
    "2024-12-13": 78.19975393793143,
    "2024-12-14": 78.36249137282235,
    "2024-12-15": 78.52522880771326,
    "2024-12-16": 78.68796624260418,
    "2024-12-17": 78.85070367749509,
    "2024-12-18": 79.013441112386,
    "2024-12-19": 79.17617854727692,
    "2024-12-20": 79.33891598216785,
    "2024-12-21": 79.50165341705876,
    "2024-12-22": 79.66439085194968,
    "2024-12-23": 79.82712828684059,
    "2024-12-24": 79.9898657217315,
    "2024-12-25": 80.15260315662242,
    "2024-12-26": 80.31534059151333,
    "2024-12-27": 80.47807802640426,
    "2024-12-28": 80.64081546129518,
    "2024-12-29": 80.80355289618609,
    "2024-12-30": 80.966290331077,
    "2024-12-31": 81.12902776596792,
    "2025-01-01": 81.64871856840197,
    "2025-01-02": 82.16840937083605,
    "2025-01-03": 82.6881001732701,
    "2025-01-04": 83.20779097570416,
    "2025-01-05": 83.72748177813821,
    "2025-01-06": 84.24717258057228,
    "2025-01-07": 84.76686338300634,
    "2025-01-08": 85.2865541854404,
    "2025-01-09": 85.80624498787445,
    "2025-01-10": 86.32593579030852,
    "2025-01-11": 86.84562659274258,
    "2025-01-12": 87.36531739517663,
    "2025-01-13": 87.88500819761069,
    "2025-01-14": 88.40469900004476,
    "2025-01-15": 88.92438980247881,
    "2025-01-16": 89.44408060491287,
    "2025-01-17": 89.96377140734693,
    "2025-01-18": 90.483462209781,
    "2025-01-19": 91.00315301221504,
    "2025-01-20": 91.52284381464912,
    "2025-01-21": 92.04253461708316,
    "2025-01-22": 92.56222541951723,
    "2025-01-23": 93.08191622195127,
    "2025-01-24": 93.60160702438534,
    "2025-01-25": 94.1212978268194,
    "2025-01-26": 94.64098862925348,
    "2025-01-27": 95.16067943168753,
    "2025-01-28": 95.68037023412158,
    "2025-01-29": 96.20006103655564,
    "2025-01-30": 96.71975183898972,
    "2025-01-31": 97.23944264142376,
    "2025-02-01": 98.32663355848992,
    "2025-02-02": 99.41382447555604,
    "2025-02-03": 100.5010153926222,
    "2025-02-04": 101.58820630968836,
    "2025-02-05": 102.6753972267545,
    "2025-02-06": 103.76258814382064,
    "2025-02-07": 104.8497790608868,
    "2025-02-08": 105.93696997795294,
    "2025-02-09": 107.02416089501908,
    "2025-02-10": 108.11135181208525,
    "2025-02-11": 109.19854272915136,
    "2025-02-12": 110.28573364621752,
    "2025-02-13": 111.37292456328368,
    "2025-02-14": 112.4601154803498,
    "2025-02-15": 113.54730639741597,
    "2025-02-16": 114.6344973144821,
    "2025-02-17": 115.72168823154826,
    "2025-02-18": 116.8088791486144,
    "2025-02-19": 117.89607006568056,
    "2025-02-20": 118.98326098274669,
    "2025-02-21": 120.07045189981284,
    "2025-02-22": 121.157642816879,
    "2025-02-23": 122.24483373394511,
    "2025-02-24": 123.33202465101128,
    "2025-02-25": 124.41921556807742,
    "2025-02-26": 125.50640648514356,
    "2025-02-27": 126.59359740220972,
    "2025-02-28": 127.68078831927586,
    "2025-03-01": 129.097225072138,
    "2025-03-02": 130.51366182500016,
    "2025-03-03": 131.93009857786228,
    "2025-03-04": 133.34653533072444,
    "2025-03-05": 134.7629720835866,
    "2025-03-06": 136.17940883644872,
    "2025-03-07": 137.59584558931087,
    "2025-03-08": 139.01228234217302,
    "2025-03-09": 140.42871909503515,
    "2025-03-10": 141.8451558478973,
    "2025-03-11": 143.26159260075943,
    "2025-03-12": 144.67802935362158,
    "2025-03-13": 146.09446610648374,
    "2025-03-14": 147.51090285934586,
    "2025-03-15": 148.92733961220802,
    "2025-03-16": 150.34377636507017,
    "2025-03-17": 151.7602131179323,
    "2025-03-18": 153.17664987079445,
    "2025-03-19": 154.59308662365655,
    "2025-03-20": 156.00952337651873,
    "2025-03-21": 157.42596012938088,
    "2025-03-22": 158.842396882243,
    "2025-03-23": 160.25883363510516,
    "2025-03-24": 161.67527038796732,
    "2025-03-25": 163.09170714082944,
    "2025-03-26": 164.5081438936916,
    "2025-03-27": 165.92458064655375,
    "2025-03-28": 167.34101739941588,
    "2025-03-29": 168.75745415227803,
    "2025-03-30": 170.17389090514018,
    "2025-03-31": 171.5903276580023,
    "2025-04-01": 174.1334539326531,
    "2025-04-02": 176.6765802073039,
    "2025-04-03": 179.2197064819547,
    "2025-04-04": 181.7628327566055,
    "2025-04-05": 184.3059590312563,
    "2025-04-06": 186.8490853059071,
    "2025-04-07": 189.3922115805579,
    "2025-04-08": 191.93533785520867,
    "2025-04-09": 194.47846412985947,
    "2025-04-10": 197.02159040451028,
    "2025-04-11": 199.56471667916108,
    "2025-04-12": 202.10784295381188,
    "2025-04-13": 204.65096922846263,
    "2025-04-14": 207.19409550311343,
    "2025-04-15": 209.73722177776423,
    "2025-04-16": 212.28034805241504,
    "2025-04-17": 214.82347432706587,
    "2025-04-18": 217.36660060171664,
    "2025-04-19": 219.90972687636744,
    "2025-04-20": 222.45285315101825,
    "2025-04-21": 224.99597942566905,
    "2025-04-22": 227.53910570031985,
    "2025-04-23": 230.08223197497065,
    "2025-04-24": 232.62535824962143,
    "2025-04-25": 235.16848452427223,
    "2025-04-26": 237.711610798923,
    "2025-04-27": 240.25473707357384,
    "2025-04-28": 242.7978633482246,
    "2025-04-29": 245.3409896228754,
    "2025-04-30": 247.8841158975262,
    "2025-05-01": 251.5579122137937,
    "2025-05-02": 255.2317085300612,
    "2025-05-03": 258.9055048463287,
    "2025-05-04": 262.5793011625962,
    "2025-05-05": 266.25309747886376,
    "2025-05-06": 269.92689379513126,
    "2025-05-07": 273.6006901113988,
    "2025-05-08": 277.27448642766626,
    "2025-05-09": 280.94828274393376,
    "2025-05-10": 284.62207906020126,
    "2025-05-11": 288.2958753764688,
    "2025-05-12": 291.96967169273626,
    "2025-05-13": 295.6434680090037,
    "2025-05-14": 299.31726432527125,
    "2025-05-15": 302.99106064153875,
    "2025-05-16": 306.66485695780625,
    "2025-05-17": 310.3386532740738,
    "2025-05-18": 314.0124495903413,
    "2025-05-19": 317.6862459066088,
    "2025-05-20": 321.3600422228763,
    "2025-05-21": 325.0338385391438,
    "2025-05-22": 328.7076348554113,
    "2025-05-23": 332.3814311716788,
    "2025-05-24": 336.0552274879463,
    "2025-05-25": 339.7290238042138,
    "2025-05-26": 343.4028201204813,
    "2025-05-27": 347.07661643674885,
    "2025-05-28": 350.75041275301635,
    "2025-05-29": 354.42420906928385,
    "2025-05-30": 358.09800538555135,
    "2025-05-31": 361.7718017018189,
    "2025-06-01": 366.4070559571305,
    "2025-06-02": 371.0423102124422,
    "2025-06-03": 375.6775644677539,
    "2025-06-04": 380.3128187230656,
    "2025-06-05": 384.9480729783773,
    "2025-06-06": 389.5833272336889,
    "2025-06-07": 394.2185814890006,
    "2025-06-08": 398.8538357443123,
    "2025-06-09": 403.489089999624,
    "2025-06-10": 408.1243442549357,
    "2025-06-11": 412.7595985102473,
    "2025-06-12": 417.394852765559,
    "2025-06-13": 422.0301070208707,
    "2025-06-14": 426.6653612761824,
    "2025-06-15": 431.300615531494,
    "2025-06-16": 435.9358697868057,
    "2025-06-17": 440.5711240421174,
    "2025-06-18": 445.206378297429,
    "2025-06-19": 449.8416325527408,
    "2025-06-20": 454.4768868080524,
    "2025-06-21": 459.1121410633641,
    "2025-06-22": 463.7473953186758,
    "2025-06-23": 468.38264957398746,
    "2025-06-24": 473.0179038292992,
    "2025-06-25": 477.6531580846108,
    "2025-06-26": 482.2884123399225,
    "2025-06-27": 486.9236665952342,
    "2025-06-28": 491.55892085054586,
    "2025-06-29": 496.1941751058576,
    "2025-06-30": 500.8294293611692,
    "2025-07-01": 506.0677617569603,
    "2025-07-02": 511.3060941527513,
    "2025-07-03": 516.5444265485423,
    "2025-07-04": 521.7827589443334,
    "2025-07-05": 527.0210913401245,
    "2025-07-06": 532.2594237359156,
    "2025-07-07": 537.4977561317065,
    "2025-07-08": 542.7360885274976,
    "2025-07-09": 547.9744209232887,
    "2025-07-10": 553.2127533190798,
    "2025-07-11": 558.4510857148707,
    "2025-07-12": 563.6894181106618,
    "2025-07-13": 568.9277505064529,
    "2025-07-14": 574.1660829022439,
    "2025-07-15": 579.404415298035,
    "2025-07-16": 584.642747693826,
    "2025-07-17": 589.8810800896171,
    "2025-07-18": 595.1194124854081,
    "2025-07-19": 600.3577448811992,
    "2025-07-20": 605.5960772769902,
    "2025-07-21": 610.8344096727812,
    "2025-07-22": 616.0727420685723,
    "2025-07-23": 621.3110744643634,
    "2025-07-24": 626.5494068601545,
    "2025-07-25": 631.7877392559454,
    "2025-07-26": 637.0260716517365,
    "2025-07-27": 642.2644040475276,
    "2025-07-28": 647.5027364433187,
    "2025-07-29": 652.7410688391096,
    "2025-07-30": 657.9794012349007,
    "2025-07-31": 663.2177336306918,
    "2025-08-01": 667.8033062590767,
    "2025-08-02": 672.3888788874617,
    "2025-08-03": 676.9744515158468,
    "2025-08-04": 681.5600241442318,
    "2025-08-05": 686.1455967726167,
    "2025-08-06": 690.7311694010017,
    "2025-08-07": 695.3167420293868,
    "2025-08-08": 699.9023146577717,
    "2025-08-09": 704.4878872861567,
    "2025-08-10": 709.0734599145417,
    "2025-08-11": 713.6590325429268,
    "2025-08-12": 718.2446051713117,
    "2025-08-13": 722.8301777996967,
    "2025-08-14": 727.4157504280817,
    "2025-08-15": 732.0013230564666,
    "2025-08-16": 736.5868956848517,
    "2025-08-17": 741.1724683132367,
    "2025-08-18": 745.7580409416216,
    "2025-08-19": 750.3436135700066,
    "2025-08-20": 754.9291861983916,
    "2025-08-21": 759.5147588267766,
    "2025-08-22": 764.1003314551616,
    "2025-08-23": 768.6859040835466,
    "2025-08-24": 773.2714767119317,
    "2025-08-25": 777.8570493403166,
    "2025-08-26": 782.4426219687016,
    "2025-08-27": 787.0281945970866,
    "2025-08-28": 791.6137672254715,
    "2025-08-29": 796.1993398538566,
    "2025-08-30": 800.7849124822416,
    "2025-08-31": 805.3704851106265,
    "2025-09-01": 808.6623739231105,
    "2025-09-02": 811.9542627355945,
    "2025-09-03": 815.2461515480785,
    "2025-09-04": 818.5380403605625,
    "2025-09-05": 821.8299291730464,
    "2025-09-06": 825.1218179855304,
    "2025-09-07": 828.4137067980143,
    "2025-09-08": 831.7055956104983,
    "2025-09-09": 834.9974844229823,
    "2025-09-10": 838.2893732354663,
    "2025-09-11": 841.5812620479503,
    "2025-09-12": 844.8731508604343,
    "2025-09-13": 848.1650396729183,
    "2025-09-14": 851.4569284854023,
    "2025-09-15": 854.7488172978863,
    "2025-09-16": 858.0407061103701,
    "2025-09-17": 861.3325949228541,
    "2025-09-18": 864.6244837353381,
    "2025-09-19": 867.9163725478221,
    "2025-09-20": 871.2082613603061,
    "2025-09-21": 874.5001501727901,
    "2025-09-22": 877.7920389852741,
    "2025-09-23": 881.0839277977581,
    "2025-09-24": 884.375816610242,
    "2025-09-25": 887.6677054227259,
    "2025-09-26": 890.9595942352099,
    "2025-09-27": 894.2514830476939,
    "2025-09-28": 897.5433718601779,
    "2025-09-29": 900.835260672662,
    "2025-09-30": 904.127149485146,
  },
  Plums: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.0546527957096,
    "2024-10-03": 4.1093055914192,
    "2024-10-04": 6.163958387128799,
    "2024-10-05": 8.2186111828384,
    "2024-10-06": 10.273263978548,
    "2024-10-07": 12.3279167742576,
    "2024-10-08": 14.3825695699672,
    "2024-10-09": 16.4372223656768,
    "2024-10-10": 18.4918751613864,
    "2024-10-11": 20.546527957096,
    "2024-10-12": 22.6011807528056,
    "2024-10-13": 24.6558335485152,
    "2024-10-14": 26.7104863442248,
    "2024-10-15": 28.7651391399344,
    "2024-10-16": 30.819791935644,
    "2024-10-17": 32.8744447313536,
    "2024-10-18": 34.9290975270632,
    "2024-10-19": 36.9837503227728,
    "2024-10-20": 39.0384031184824,
    "2024-10-21": 41.093055914192,
    "2024-10-22": 43.1477087099016,
    "2024-10-23": 45.2023615056112,
    "2024-10-24": 47.2570143013208,
    "2024-10-25": 49.3116670970304,
    "2024-10-26": 51.36631989274,
    "2024-10-27": 53.4209726884496,
    "2024-10-28": 55.4756254841592,
    "2024-10-29": 57.5302782798688,
    "2024-10-30": 59.5849310755784,
    "2024-10-31": 61.639583871288,
    "2024-11-01": 62.25760618915538,
    "2024-11-02": 62.87562850702275,
    "2024-11-03": 63.493650824890125,
    "2024-11-04": 64.1116731427575,
    "2024-11-05": 64.72969546062488,
    "2024-11-06": 65.34771777849225,
    "2024-11-07": 65.96574009635962,
    "2024-11-08": 66.58376241422701,
    "2024-11-09": 67.20178473209438,
    "2024-11-10": 67.81980704996175,
    "2024-11-11": 68.43782936782912,
    "2024-11-12": 69.0558516856965,
    "2024-11-13": 69.67387400356388,
    "2024-11-14": 70.29189632143125,
    "2024-11-15": 70.90991863929862,
    "2024-11-16": 71.52794095716601,
    "2024-11-17": 72.14596327503338,
    "2024-11-18": 72.76398559290075,
    "2024-11-19": 73.38200791076812,
    "2024-11-20": 74.0000302286355,
    "2024-11-21": 74.61805254650288,
    "2024-11-22": 75.23607486437025,
    "2024-11-23": 75.85409718223762,
    "2024-11-24": 76.47211950010501,
    "2024-11-25": 77.09014181797238,
    "2024-11-26": 77.70816413583975,
    "2024-11-27": 78.32618645370712,
    "2024-11-28": 78.9442087715745,
    "2024-11-29": 79.56223108944188,
    "2024-11-30": 80.18025340730925,
    "2024-12-01": 80.5002381075506,
    "2024-12-02": 80.82022280779195,
    "2024-12-03": 81.1402075080333,
    "2024-12-04": 81.46019220827465,
    "2024-12-05": 81.780176908516,
    "2024-12-06": 82.10016160875735,
    "2024-12-07": 82.4201463089987,
    "2024-12-08": 82.74013100924003,
    "2024-12-09": 83.06011570948138,
    "2024-12-10": 83.38010040972273,
    "2024-12-11": 83.70008510996408,
    "2024-12-12": 84.02006981020543,
    "2024-12-13": 84.34005451044678,
    "2024-12-14": 84.66003921068813,
    "2024-12-15": 84.98002391092948,
    "2024-12-16": 85.30000861117082,
    "2024-12-17": 85.61999331141217,
    "2024-12-18": 85.93997801165352,
    "2024-12-19": 86.25996271189487,
    "2024-12-20": 86.57994741213622,
    "2024-12-21": 86.89993211237757,
    "2024-12-22": 87.21991681261892,
    "2024-12-23": 87.53990151286027,
    "2024-12-24": 87.8598862131016,
    "2024-12-25": 88.17987091334295,
    "2024-12-26": 88.4998556135843,
    "2024-12-27": 88.81984031382565,
    "2024-12-28": 89.139825014067,
    "2024-12-29": 89.45980971430835,
    "2024-12-30": 89.7797944145497,
    "2024-12-31": 90.09977911479103,
    "2025-01-01": 90.64957860373217,
    "2025-01-02": 91.19937809267326,
    "2025-01-03": 91.74917758161436,
    "2025-01-04": 92.29897707055544,
    "2025-01-05": 92.84877655949656,
    "2025-01-06": 93.39857604843766,
    "2025-01-07": 93.94837553737877,
    "2025-01-08": 94.49817502631986,
    "2025-01-09": 95.04797451526096,
    "2025-01-10": 95.59777400420208,
    "2025-01-11": 96.14757349314316,
    "2025-01-12": 96.69737298208427,
    "2025-01-13": 97.24717247102537,
    "2025-01-14": 97.79697195996648,
    "2025-01-15": 98.34677144890756,
    "2025-01-16": 98.89657093784868,
    "2025-01-17": 99.44637042678978,
    "2025-01-18": 99.99616991573087,
    "2025-01-19": 100.54596940467198,
    "2025-01-20": 101.09576889361308,
    "2025-01-21": 101.6455683825542,
    "2025-01-22": 102.19536787149528,
    "2025-01-23": 102.7451673604364,
    "2025-01-24": 103.29496684937747,
    "2025-01-25": 103.8447663383186,
    "2025-01-26": 104.3945658272597,
    "2025-01-27": 104.9443653162008,
    "2025-01-28": 105.4941648051419,
    "2025-01-29": 106.043964294083,
    "2025-01-30": 106.5937637830241,
    "2025-01-31": 107.1435632719652,
    "2025-02-01": 108.0916713258681,
    "2025-02-02": 109.03977937977102,
    "2025-02-03": 109.98788743367392,
    "2025-02-04": 110.93599548757685,
    "2025-02-05": 111.88410354147972,
    "2025-02-06": 112.83221159538265,
    "2025-02-07": 113.78031964928554,
    "2025-02-08": 114.72842770318844,
    "2025-02-09": 115.67653575709136,
    "2025-02-10": 116.62464381099426,
    "2025-02-11": 117.57275186489716,
    "2025-02-12": 118.52085991880008,
    "2025-02-13": 119.46896797270298,
    "2025-02-14": 120.41707602660588,
    "2025-02-15": 121.36518408050878,
    "2025-02-16": 122.3132921344117,
    "2025-02-17": 123.2614001883146,
    "2025-02-18": 124.20950824221752,
    "2025-02-19": 125.1576162961204,
    "2025-02-20": 126.10572435002332,
    "2025-02-21": 127.05383240392622,
    "2025-02-22": 128.00194045782914,
    "2025-02-23": 128.95004851173204,
    "2025-02-24": 129.8981565656349,
    "2025-02-25": 130.84626461953783,
    "2025-02-26": 131.79437267344076,
    "2025-02-27": 132.74248072734366,
    "2025-02-28": 133.69058878124656,
    "2025-03-01": 135.39944020028165,
    "2025-03-02": 137.10829161931673,
    "2025-03-03": 138.81714303835184,
    "2025-03-04": 140.52599445738693,
    "2025-03-05": 142.234845876422,
    "2025-03-06": 143.9436972954571,
    "2025-03-07": 145.65254871449218,
    "2025-03-08": 147.36140013352727,
    "2025-03-09": 149.07025155256235,
    "2025-03-10": 150.77910297159747,
    "2025-03-11": 152.48795439063255,
    "2025-03-12": 154.19680580966764,
    "2025-03-13": 155.90565722870272,
    "2025-03-14": 157.6145086477378,
    "2025-03-15": 159.32336006677292,
    "2025-03-16": 161.032211485808,
    "2025-03-17": 162.7410629048431,
    "2025-03-18": 164.44991432387818,
    "2025-03-19": 166.15876574291326,
    "2025-03-20": 167.86761716194837,
    "2025-03-21": 169.57646858098343,
    "2025-03-22": 171.28532000001854,
    "2025-03-23": 172.99417141905363,
    "2025-03-24": 174.7030228380887,
    "2025-03-25": 176.4118742571238,
    "2025-03-26": 178.12072567615888,
    "2025-03-27": 179.829577095194,
    "2025-03-28": 181.53842851422905,
    "2025-03-29": 183.24727993326417,
    "2025-03-30": 184.95613135229925,
    "2025-03-31": 186.66498277133437,
    "2025-04-01": 189.901807341466,
    "2025-04-02": 193.13863191159763,
    "2025-04-03": 196.3754564817293,
    "2025-04-04": 199.6122810518609,
    "2025-04-05": 202.84910562199255,
    "2025-04-06": 206.0859301921242,
    "2025-04-07": 209.32275476225587,
    "2025-04-08": 212.5595793323875,
    "2025-04-09": 215.7964039025192,
    "2025-04-10": 219.0332284726508,
    "2025-04-11": 222.27005304278245,
    "2025-04-12": 225.50687761291408,
    "2025-04-13": 228.7437021830457,
    "2025-04-14": 231.9805267531774,
    "2025-04-15": 235.21735132330903,
    "2025-04-16": 238.45417589344063,
    "2025-04-17": 241.69100046357232,
    "2025-04-18": 244.927825033704,
    "2025-04-19": 248.1646496038356,
    "2025-04-20": 251.40147417396724,
    "2025-04-21": 254.6382987440989,
    "2025-04-22": 257.87512331423056,
    "2025-04-23": 261.11194788436217,
    "2025-04-24": 264.3487724544939,
    "2025-04-25": 267.5855970246255,
    "2025-04-26": 270.82242159475715,
    "2025-04-27": 274.0592461648888,
    "2025-04-28": 277.2960707350204,
    "2025-04-29": 280.53289530515207,
    "2025-04-30": 283.7697198752837,
    "2025-05-01": 287.6076213886328,
    "2025-05-02": 291.445522901982,
    "2025-05-03": 295.28342441533107,
    "2025-05-04": 299.1213259286802,
    "2025-05-05": 302.9592274420293,
    "2025-05-06": 306.79712895537847,
    "2025-05-07": 310.6350304687276,
    "2025-05-08": 314.4729319820767,
    "2025-05-09": 318.3108334954258,
    "2025-05-10": 322.14873500877496,
    "2025-05-11": 325.98663652212406,
    "2025-05-12": 329.8245380354732,
    "2025-05-13": 333.6624395488223,
    "2025-05-14": 337.50034106217146,
    "2025-05-15": 341.3382425755205,
    "2025-05-16": 345.1761440888697,
    "2025-05-17": 349.0140456022188,
    "2025-05-18": 352.85194711556795,
    "2025-05-19": 356.68984862891705,
    "2025-05-20": 360.5277501422662,
    "2025-05-21": 364.3656516556153,
    "2025-05-22": 368.2035531689645,
    "2025-05-23": 372.0414546823136,
    "2025-05-24": 375.8793561956627,
    "2025-05-25": 379.7172577090118,
    "2025-05-26": 383.5551592223609,
    "2025-05-27": 387.3930607357101,
    "2025-05-28": 391.2309622490592,
    "2025-05-29": 395.0688637624083,
    "2025-05-30": 398.9067652757574,
    "2025-05-31": 402.7446667891065,
    "2025-06-01": 407.4963430239475,
    "2025-06-02": 412.2480192587884,
    "2025-06-03": 416.99969549362936,
    "2025-06-04": 421.7513717284704,
    "2025-06-05": 426.5030479633113,
    "2025-06-06": 431.25472419815225,
    "2025-06-07": 436.0064004329932,
    "2025-06-08": 440.7580766678341,
    "2025-06-09": 445.5097529026751,
    "2025-06-10": 450.261429137516,
    "2025-06-11": 455.013105372357,
    "2025-06-12": 459.764781607198,
    "2025-06-13": 464.5164578420389,
    "2025-06-14": 469.2681340768799,
    "2025-06-15": 474.0198103117208,
    "2025-06-16": 478.7714865465617,
    "2025-06-17": 483.5231627814027,
    "2025-06-18": 488.2748390162436,
    "2025-06-19": 493.0265152510846,
    "2025-06-20": 497.7781914859256,
    "2025-06-21": 502.5298677207665,
    "2025-06-22": 507.28154395560745,
    "2025-06-23": 512.0332201904484,
    "2025-06-24": 516.7848964252894,
    "2025-06-25": 521.5365726601303,
    "2025-06-26": 526.2882488949713,
    "2025-06-27": 531.0399251298122,
    "2025-06-28": 535.7916013646532,
    "2025-06-29": 540.5432775994941,
    "2025-06-30": 545.294953834335,
    "2025-07-01": 550.2968117660537,
    "2025-07-02": 555.2986696977722,
    "2025-07-03": 560.3005276294908,
    "2025-07-04": 565.3023855612093,
    "2025-07-05": 570.304243492928,
    "2025-07-06": 575.3061014246465,
    "2025-07-07": 580.3079593563651,
    "2025-07-08": 585.3098172880837,
    "2025-07-09": 590.3116752198023,
    "2025-07-10": 595.3135331515209,
    "2025-07-11": 600.3153910832394,
    "2025-07-12": 605.3172490149581,
    "2025-07-13": 610.3191069466766,
    "2025-07-14": 615.3209648783952,
    "2025-07-15": 620.3228228101137,
    "2025-07-16": 625.3246807418324,
    "2025-07-17": 630.3265386735509,
    "2025-07-18": 635.3283966052695,
    "2025-07-19": 640.330254536988,
    "2025-07-20": 645.3321124687067,
    "2025-07-21": 650.3339704004252,
    "2025-07-22": 655.3358283321438,
    "2025-07-23": 660.3376862638625,
    "2025-07-24": 665.339544195581,
    "2025-07-25": 670.3414021272996,
    "2025-07-26": 675.3432600590181,
    "2025-07-27": 680.3451179907368,
    "2025-07-28": 685.3469759224553,
    "2025-07-29": 690.3488338541739,
    "2025-07-30": 695.3506917858924,
    "2025-07-31": 700.352549717611,
    "2025-08-01": 704.4350805216916,
    "2025-08-02": 708.517611325772,
    "2025-08-03": 712.6001421298525,
    "2025-08-04": 716.6826729339331,
    "2025-08-05": 720.7652037380136,
    "2025-08-06": 724.847734542094,
    "2025-08-07": 728.9302653461746,
    "2025-08-08": 733.0127961502551,
    "2025-08-09": 737.0953269543355,
    "2025-08-10": 741.177857758416,
    "2025-08-11": 745.2603885624966,
    "2025-08-12": 749.342919366577,
    "2025-08-13": 753.4254501706575,
    "2025-08-14": 757.5079809747381,
    "2025-08-15": 761.5905117788186,
    "2025-08-16": 765.673042582899,
    "2025-08-17": 769.7555733869796,
    "2025-08-18": 773.8381041910601,
    "2025-08-19": 777.9206349951405,
    "2025-08-20": 782.003165799221,
    "2025-08-21": 786.0856966033016,
    "2025-08-22": 790.1682274073821,
    "2025-08-23": 794.2507582114625,
    "2025-08-24": 798.3332890155431,
    "2025-08-25": 802.4158198196236,
    "2025-08-26": 806.498350623704,
    "2025-08-27": 810.5808814277846,
    "2025-08-28": 814.6634122318651,
    "2025-08-29": 818.7459430359456,
    "2025-08-30": 822.828473840026,
    "2025-08-31": 826.9110046441066,
    "2025-09-01": 829.9290132367112,
    "2025-09-02": 832.9470218293158,
    "2025-09-03": 835.9650304219205,
    "2025-09-04": 838.983039014525,
    "2025-09-05": 842.0010476071296,
    "2025-09-06": 845.0190561997342,
    "2025-09-07": 848.0370647923388,
    "2025-09-08": 851.0550733849435,
    "2025-09-09": 854.0730819775481,
    "2025-09-10": 857.0910905701527,
    "2025-09-11": 860.1090991627573,
    "2025-09-12": 863.1271077553619,
    "2025-09-13": 866.1451163479666,
    "2025-09-14": 869.1631249405712,
    "2025-09-15": 872.1811335331757,
    "2025-09-16": 875.1991421257803,
    "2025-09-17": 878.2171507183849,
    "2025-09-18": 881.2351593109896,
    "2025-09-19": 884.2531679035942,
    "2025-09-20": 887.2711764961988,
    "2025-09-21": 890.2891850888034,
    "2025-09-22": 893.307193681408,
    "2025-09-23": 896.3252022740127,
    "2025-09-24": 899.3432108666173,
    "2025-09-25": 902.3612194592218,
    "2025-09-26": 905.3792280518264,
    "2025-09-27": 908.397236644431,
    "2025-09-28": 911.4152452370356,
    "2025-09-29": 914.4332538296404,
    "2025-09-30": 917.4512624222448,
  },
  Pomegranates: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.0830234474456475,
    "2024-10-03": 4.166046894891295,
    "2024-10-04": 6.249070342336943,
    "2024-10-05": 8.33209378978259,
    "2024-10-06": 10.415117237228236,
    "2024-10-07": 12.498140684673883,
    "2024-10-08": 14.581164132119532,
    "2024-10-09": 16.66418757956518,
    "2024-10-10": 18.747211027010827,
    "2024-10-11": 20.830234474456475,
    "2024-10-12": 22.91325792190212,
    "2024-10-13": 24.99628136934777,
    "2024-10-14": 27.079304816793417,
    "2024-10-15": 29.162328264239065,
    "2024-10-16": 31.245351711684712,
    "2024-10-17": 33.32837515913036,
    "2024-10-18": 35.41139860657601,
    "2024-10-19": 37.494422054021655,
    "2024-10-20": 39.5774455014673,
    "2024-10-21": 41.66046894891295,
    "2024-10-22": 43.7434923963586,
    "2024-10-23": 45.826515843804245,
    "2024-10-24": 47.90953929124989,
    "2024-10-25": 49.99256273869554,
    "2024-10-26": 52.07558618614119,
    "2024-10-27": 54.15860963358684,
    "2024-10-28": 56.24163308103248,
    "2024-10-29": 58.32465652847813,
    "2024-10-30": 60.40767997592378,
    "2024-10-31": 62.49070342336943,
    "2024-11-01": 63.10554509984436,
    "2024-11-02": 63.7203867763193,
    "2024-11-03": 64.33522845279424,
    "2024-11-04": 64.95007012926918,
    "2024-11-05": 65.56491180574412,
    "2024-11-06": 66.17975348221904,
    "2024-11-07": 66.79459515869398,
    "2024-11-08": 67.40943683516892,
    "2024-11-09": 68.02427851164386,
    "2024-11-10": 68.6391201881188,
    "2024-11-11": 69.25396186459373,
    "2024-11-12": 69.86880354106867,
    "2024-11-13": 70.48364521754361,
    "2024-11-14": 71.09848689401855,
    "2024-11-15": 71.71332857049347,
    "2024-11-16": 72.32817024696841,
    "2024-11-17": 72.94301192344335,
    "2024-11-18": 73.55785359991829,
    "2024-11-19": 74.17269527639323,
    "2024-11-20": 74.78753695286817,
    "2024-11-21": 75.4023786293431,
    "2024-11-22": 76.01722030581804,
    "2024-11-23": 76.63206198229298,
    "2024-11-24": 77.2469036587679,
    "2024-11-25": 77.86174533524286,
    "2024-11-26": 78.47658701171778,
    "2024-11-27": 79.09142868819272,
    "2024-11-28": 79.70627036466766,
    "2024-11-29": 80.3211120411426,
    "2024-11-30": 80.93595371761754,
    "2024-12-01": 81.23533841362296,
    "2024-12-02": 81.53472310962837,
    "2024-12-03": 81.83410780563379,
    "2024-12-04": 82.13349250163921,
    "2024-12-05": 82.43287719764463,
    "2024-12-06": 82.73226189365003,
    "2024-12-07": 83.03164658965545,
    "2024-12-08": 83.33103128566087,
    "2024-12-09": 83.63041598166629,
    "2024-12-10": 83.92980067767171,
    "2024-12-11": 84.22918537367713,
    "2024-12-12": 84.52857006968254,
    "2024-12-13": 84.82795476568796,
    "2024-12-14": 85.12733946169338,
    "2024-12-15": 85.4267241576988,
    "2024-12-16": 85.7261088537042,
    "2024-12-17": 86.02549354970962,
    "2024-12-18": 86.32487824571504,
    "2024-12-19": 86.62426294172046,
    "2024-12-20": 86.92364763772588,
    "2024-12-21": 87.2230323337313,
    "2024-12-22": 87.52241702973672,
    "2024-12-23": 87.82180172574213,
    "2024-12-24": 88.12118642174755,
    "2024-12-25": 88.42057111775297,
    "2024-12-26": 88.71995581375838,
    "2024-12-27": 89.0193405097638,
    "2024-12-28": 89.31872520576921,
    "2024-12-29": 89.61810990177463,
    "2024-12-30": 89.91749459778005,
    "2024-12-31": 90.21687929378548,
    "2025-01-01": 90.82541526840444,
    "2025-01-02": 91.4339512430234,
    "2025-01-03": 92.04248721764236,
    "2025-01-04": 92.65102319226128,
    "2025-01-05": 93.25955916688024,
    "2025-01-06": 93.8680951414992,
    "2025-01-07": 94.47663111611816,
    "2025-01-08": 95.08516709073712,
    "2025-01-09": 95.69370306535608,
    "2025-01-10": 96.30223903997503,
    "2025-01-11": 96.910775014594,
    "2025-01-12": 97.51931098921295,
    "2025-01-13": 98.12784696383191,
    "2025-01-14": 98.73638293845087,
    "2025-01-15": 99.34491891306983,
    "2025-01-16": 99.9534548876888,
    "2025-01-17": 100.56199086230777,
    "2025-01-18": 101.17052683692673,
    "2025-01-19": 101.77906281154566,
    "2025-01-20": 102.38759878616462,
    "2025-01-21": 102.99613476078358,
    "2025-01-22": 103.60467073540254,
    "2025-01-23": 104.2132067100215,
    "2025-01-24": 104.82174268464044,
    "2025-01-25": 105.4302786592594,
    "2025-01-26": 106.03881463387836,
    "2025-01-27": 106.64735060849732,
    "2025-01-28": 107.25588658311628,
    "2025-01-29": 107.86442255773524,
    "2025-01-30": 108.4729585323542,
    "2025-01-31": 109.08149450697316,
    "2025-02-01": 110.1199356388414,
    "2025-02-02": 111.15837677070964,
    "2025-02-03": 112.19681790257786,
    "2025-02-04": 113.2352590344461,
    "2025-02-05": 114.27370016631434,
    "2025-02-06": 115.31214129818258,
    "2025-02-07": 116.35058243005082,
    "2025-02-08": 117.38902356191906,
    "2025-02-09": 118.4274646937873,
    "2025-02-10": 119.46590582565553,
    "2025-02-11": 120.50434695752377,
    "2025-02-12": 121.542788089392,
    "2025-02-13": 122.58122922126024,
    "2025-02-14": 123.61967035312848,
    "2025-02-15": 124.65811148499672,
    "2025-02-16": 125.69655261686496,
    "2025-02-17": 126.7349937487332,
    "2025-02-18": 127.77343488060144,
    "2025-02-19": 128.81187601246967,
    "2025-02-20": 129.8503171443379,
    "2025-02-21": 130.88875827620615,
    "2025-02-22": 131.9271994080744,
    "2025-02-23": 132.96564053994263,
    "2025-02-24": 134.00408167181087,
    "2025-02-25": 135.04252280367908,
    "2025-02-26": 136.08096393554732,
    "2025-02-27": 137.11940506741556,
    "2025-02-28": 138.1578461992838,
    "2025-03-01": 139.8527646454181,
    "2025-03-02": 141.5476830915524,
    "2025-03-03": 143.24260153768668,
    "2025-03-04": 144.93751998382098,
    "2025-03-05": 146.63243842995524,
    "2025-03-06": 148.32735687608954,
    "2025-03-07": 150.02227532222383,
    "2025-03-08": 151.71719376835813,
    "2025-03-09": 153.41211221449242,
    "2025-03-10": 155.10703066062672,
    "2025-03-11": 156.801949106761,
    "2025-03-12": 158.4968675528953,
    "2025-03-13": 160.1917859990296,
    "2025-03-14": 161.8867044451639,
    "2025-03-15": 163.5816228912982,
    "2025-03-16": 165.2765413374325,
    "2025-03-17": 166.97145978356676,
    "2025-03-18": 168.66637822970105,
    "2025-03-19": 170.36129667583535,
    "2025-03-20": 172.05621512196964,
    "2025-03-21": 173.75113356810394,
    "2025-03-22": 175.44605201423823,
    "2025-03-23": 177.14097046037253,
    "2025-03-24": 178.83588890650682,
    "2025-03-25": 180.53080735264112,
    "2025-03-26": 182.2257257987754,
    "2025-03-27": 183.92064424490968,
    "2025-03-28": 185.615562691044,
    "2025-03-29": 187.31048113717827,
    "2025-03-30": 189.00539958331257,
    "2025-03-31": 190.7003180294469,
    "2025-04-01": 193.69181653685175,
    "2025-04-02": 196.6833150442567,
    "2025-04-03": 199.6748135516616,
    "2025-04-04": 202.66631205906648,
    "2025-04-05": 205.6578105664714,
    "2025-04-06": 208.6493090738763,
    "2025-04-07": 211.6408075812812,
    "2025-04-08": 214.6323060886861,
    "2025-04-09": 217.62380459609105,
    "2025-04-10": 220.61530310349596,
    "2025-04-11": 223.60680161090085,
    "2025-04-12": 226.59830011830576,
    "2025-04-13": 229.58979862571064,
    "2025-04-14": 232.5812971331156,
    "2025-04-15": 235.57279564052047,
    "2025-04-16": 238.56429414792535,
    "2025-04-17": 241.5557926553303,
    "2025-04-18": 244.5472911627352,
    "2025-04-19": 247.5387896701401,
    "2025-04-20": 250.530288177545,
    "2025-04-21": 253.52178668494992,
    "2025-04-22": 256.51328519235483,
    "2025-04-23": 259.50478369975974,
    "2025-04-24": 262.49628220716465,
    "2025-04-25": 265.4877807145696,
    "2025-04-26": 268.4792792219744,
    "2025-04-27": 271.47077772937934,
    "2025-04-28": 274.46227623678425,
    "2025-04-29": 277.4537747441892,
    "2025-04-30": 280.4452732515941,
    "2025-05-01": 283.692647612578,
    "2025-05-02": 286.9400219735619,
    "2025-05-03": 290.1873963345458,
    "2025-05-04": 293.43477069552966,
    "2025-05-05": 296.6821450565136,
    "2025-05-06": 299.9295194174975,
    "2025-05-07": 303.17689377848137,
    "2025-05-08": 306.4242681394653,
    "2025-05-09": 309.6716425004492,
    "2025-05-10": 312.9190168614331,
    "2025-05-11": 316.166391222417,
    "2025-05-12": 319.4137655834009,
    "2025-05-13": 322.66113994438484,
    "2025-05-14": 325.9085143053687,
    "2025-05-15": 329.1558886663526,
    "2025-05-16": 332.4032630273365,
    "2025-05-17": 335.65063738832043,
    "2025-05-18": 338.8980117493043,
    "2025-05-19": 342.14538611028826,
    "2025-05-20": 345.39276047127214,
    "2025-05-21": 348.6401348322561,
    "2025-05-22": 351.88750919324,
    "2025-05-23": 355.13488355422385,
    "2025-05-24": 358.3822579152078,
    "2025-05-25": 361.62963227619167,
    "2025-05-26": 364.8770066371756,
    "2025-05-27": 368.1243809981595,
    "2025-05-28": 371.3717553591434,
    "2025-05-29": 374.61912972012726,
    "2025-05-30": 377.8665040811112,
    "2025-05-31": 381.1138784420951,
    "2025-06-01": 384.583667451073,
    "2025-06-02": 388.053456460051,
    "2025-06-03": 391.52324546902895,
    "2025-06-04": 394.9930344780069,
    "2025-06-05": 398.4628234869848,
    "2025-06-06": 401.9326124959628,
    "2025-06-07": 405.4024015049407,
    "2025-06-08": 408.87219051391867,
    "2025-06-09": 412.3419795228966,
    "2025-06-10": 415.8117685318746,
    "2025-06-11": 419.2815575408525,
    "2025-06-12": 422.7513465498304,
    "2025-06-13": 426.2211355588084,
    "2025-06-14": 429.6909245677864,
    "2025-06-15": 433.1607135767643,
    "2025-06-16": 436.6305025857423,
    "2025-06-17": 440.1002915947202,
    "2025-06-18": 443.57008060369816,
    "2025-06-19": 447.03986961267606,
    "2025-06-20": 450.509658621654,
    "2025-06-21": 453.979447630632,
    "2025-06-22": 457.4492366396099,
    "2025-06-23": 460.9190256485879,
    "2025-06-24": 464.3888146575658,
    "2025-06-25": 467.8586036665438,
    "2025-06-26": 471.32839267552174,
    "2025-06-27": 474.7981816844997,
    "2025-06-28": 478.2679706934776,
    "2025-06-29": 481.7377597024556,
    "2025-06-30": 485.2075487114335,
    "2025-07-01": 488.9511140305492,
    "2025-07-02": 492.6946793496649,
    "2025-07-03": 496.4382446687806,
    "2025-07-04": 500.1818099878963,
    "2025-07-05": 503.925375307012,
    "2025-07-06": 507.6689406261277,
    "2025-07-07": 511.4125059452434,
    "2025-07-08": 515.1560712643591,
    "2025-07-09": 518.8996365834748,
    "2025-07-10": 522.6432019025906,
    "2025-07-11": 526.3867672217062,
    "2025-07-12": 530.1303325408219,
    "2025-07-13": 533.8738978599376,
    "2025-07-14": 537.6174631790534,
    "2025-07-15": 541.361028498169,
    "2025-07-16": 545.1045938172847,
    "2025-07-17": 548.8481591364005,
    "2025-07-18": 552.5917244555162,
    "2025-07-19": 556.3352897746319,
    "2025-07-20": 560.0788550937475,
    "2025-07-21": 563.8224204128633,
    "2025-07-22": 567.565985731979,
    "2025-07-23": 571.3095510510947,
    "2025-07-24": 575.0531163702103,
    "2025-07-25": 578.7966816893261,
    "2025-07-26": 582.5402470084418,
    "2025-07-27": 586.2838123275575,
    "2025-07-28": 590.0273776466731,
    "2025-07-29": 593.7709429657889,
    "2025-07-30": 597.5145082849047,
    "2025-07-31": 601.2580736040203,
    "2025-08-01": 604.7516923977768,
    "2025-08-02": 608.2453111915331,
    "2025-08-03": 611.7389299852896,
    "2025-08-04": 615.232548779046,
    "2025-08-05": 618.7261675728025,
    "2025-08-06": 622.2197863665589,
    "2025-08-07": 625.7134051603153,
    "2025-08-08": 629.2070239540718,
    "2025-08-09": 632.7006427478282,
    "2025-08-10": 636.1942615415846,
    "2025-08-11": 639.6878803353411,
    "2025-08-12": 643.1814991290976,
    "2025-08-13": 646.6751179228539,
    "2025-08-14": 650.1687367166104,
    "2025-08-15": 653.6623555103669,
    "2025-08-16": 657.1559743041232,
    "2025-08-17": 660.6495930978797,
    "2025-08-18": 664.1432118916362,
    "2025-08-19": 667.6368306853926,
    "2025-08-20": 671.130449479149,
    "2025-08-21": 674.6240682729054,
    "2025-08-22": 678.1176870666619,
    "2025-08-23": 681.6113058604183,
    "2025-08-24": 685.1049246541747,
    "2025-08-25": 688.5985434479312,
    "2025-08-26": 692.0921622416877,
    "2025-08-27": 695.585781035444,
    "2025-08-28": 699.0793998292005,
    "2025-08-29": 702.573018622957,
    "2025-08-30": 706.0666374167133,
    "2025-08-31": 709.5602562104698,
    "2025-09-01": 712.2430275235225,
    "2025-09-02": 714.9257988365752,
    "2025-09-03": 717.6085701496279,
    "2025-09-04": 720.2913414626806,
    "2025-09-05": 722.9741127757333,
    "2025-09-06": 725.656884088786,
    "2025-09-07": 728.3396554018387,
    "2025-09-08": 731.0224267148914,
    "2025-09-09": 733.7051980279441,
    "2025-09-10": 736.3879693409968,
    "2025-09-11": 739.0707406540495,
    "2025-09-12": 741.7535119671022,
    "2025-09-13": 744.436283280155,
    "2025-09-14": 747.1190545932076,
    "2025-09-15": 749.8018259062603,
    "2025-09-16": 752.4845972193131,
    "2025-09-17": 755.1673685323657,
    "2025-09-18": 757.8501398454184,
    "2025-09-19": 760.5329111584712,
    "2025-09-20": 763.2156824715238,
    "2025-09-21": 765.8984537845765,
    "2025-09-22": 768.5812250976293,
    "2025-09-23": 771.2639964106819,
    "2025-09-24": 773.9467677237346,
    "2025-09-25": 776.6295390367874,
    "2025-09-26": 779.31231034984,
    "2025-09-27": 781.9950816628927,
    "2025-09-28": 784.6778529759455,
    "2025-09-29": 787.3606242889981,
    "2025-09-30": 790.0433956020509,
  },
  Prunes: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.1388582127208293,
    "2024-10-03": 4.277716425441659,
    "2024-10-04": 6.416574638162488,
    "2024-10-05": 8.555432850883317,
    "2024-10-06": 10.694291063604147,
    "2024-10-07": 12.833149276324976,
    "2024-10-08": 14.972007489045804,
    "2024-10-09": 17.110865701766635,
    "2024-10-10": 19.249723914487465,
    "2024-10-11": 21.38858212720829,
    "2024-10-12": 23.52744033992912,
    "2024-10-13": 25.666298552649952,
    "2024-10-14": 27.805156765370786,
    "2024-10-15": 29.94401497809161,
    "2024-10-16": 32.08287319081244,
    "2024-10-17": 34.22173140353327,
    "2024-10-18": 36.360589616254096,
    "2024-10-19": 38.49944782897493,
    "2024-10-20": 40.63830604169576,
    "2024-10-21": 42.77716425441659,
    "2024-10-22": 44.91602246713742,
    "2024-10-23": 47.05488067985824,
    "2024-10-24": 49.19373889257908,
    "2024-10-25": 51.332597105299904,
    "2024-10-26": 53.47145531802073,
    "2024-10-27": 55.61031353074157,
    "2024-10-28": 57.74917174346239,
    "2024-10-29": 59.88802995618322,
    "2024-10-30": 62.02688816890405,
    "2024-10-31": 64.16574638162488,
    "2024-11-01": 64.82665195407313,
    "2024-11-02": 65.48755752652137,
    "2024-11-03": 66.14846309896961,
    "2024-11-04": 66.80936867141786,
    "2024-11-05": 67.4702742438661,
    "2024-11-06": 68.13117981631434,
    "2024-11-07": 68.79208538876259,
    "2024-11-08": 69.45299096121084,
    "2024-11-09": 70.11389653365909,
    "2024-11-10": 70.77480210610733,
    "2024-11-11": 71.43570767855557,
    "2024-11-12": 72.09661325100382,
    "2024-11-13": 72.75751882345206,
    "2024-11-14": 73.4184243959003,
    "2024-11-15": 74.07932996834855,
    "2024-11-16": 74.74023554079679,
    "2024-11-17": 75.40114111324503,
    "2024-11-18": 76.06204668569328,
    "2024-11-19": 76.72295225814152,
    "2024-11-20": 77.38385783058976,
    "2024-11-21": 78.04476340303802,
    "2024-11-22": 78.70566897548625,
    "2024-11-23": 79.3665745479345,
    "2024-11-24": 80.02748012038275,
    "2024-11-25": 80.68838569283099,
    "2024-11-26": 81.34929126527923,
    "2024-11-27": 82.01019683772748,
    "2024-11-28": 82.67110241017572,
    "2024-11-29": 83.33200798262396,
    "2024-11-30": 83.9929135550722,
    "2024-12-01": 84.3336863970951,
    "2024-12-02": 84.67445923911798,
    "2024-12-03": 85.01523208114087,
    "2024-12-04": 85.35600492316375,
    "2024-12-05": 85.69677776518664,
    "2024-12-06": 86.03755060720952,
    "2024-12-07": 86.37832344923241,
    "2024-12-08": 86.7190962912553,
    "2024-12-09": 87.05986913327818,
    "2024-12-10": 87.40064197530107,
    "2024-12-11": 87.74141481732396,
    "2024-12-12": 88.08218765934684,
    "2024-12-13": 88.42296050136973,
    "2024-12-14": 88.76373334339262,
    "2024-12-15": 89.10450618541552,
    "2024-12-16": 89.4452790274384,
    "2024-12-17": 89.78605186946129,
    "2024-12-18": 90.12682471148418,
    "2024-12-19": 90.46759755350706,
    "2024-12-20": 90.80837039552996,
    "2024-12-21": 91.14914323755283,
    "2024-12-22": 91.48991607957572,
    "2024-12-23": 91.8306889215986,
    "2024-12-24": 92.1714617636215,
    "2024-12-25": 92.51223460564438,
    "2024-12-26": 92.85300744766728,
    "2024-12-27": 93.19378028969015,
    "2024-12-28": 93.53455313171304,
    "2024-12-29": 93.87532597373593,
    "2024-12-30": 94.2160988157588,
    "2024-12-31": 94.5568716577817,
    "2025-01-01": 95.15728782273368,
    "2025-01-02": 95.75770398768564,
    "2025-01-03": 96.35812015263762,
    "2025-01-04": 96.9585363175896,
    "2025-01-05": 97.5589524825416,
    "2025-01-06": 98.15936864749357,
    "2025-01-07": 98.75978481244552,
    "2025-01-08": 99.36020097739753,
    "2025-01-09": 99.96061714234948,
    "2025-01-10": 100.56103330730146,
    "2025-01-11": 101.16144947225344,
    "2025-01-12": 101.76186563720542,
    "2025-01-13": 102.3622818021574,
    "2025-01-14": 102.96269796710936,
    "2025-01-15": 103.56311413206134,
    "2025-01-16": 104.16353029701332,
    "2025-01-17": 104.7639464619653,
    "2025-01-18": 105.36436262691728,
    "2025-01-19": 105.96477879186924,
    "2025-01-20": 106.56519495682124,
    "2025-01-21": 107.1656111217732,
    "2025-01-22": 107.76602728672518,
    "2025-01-23": 108.36644345167716,
    "2025-01-24": 108.96685961662914,
    "2025-01-25": 109.56727578158112,
    "2025-01-26": 110.16769194653308,
    "2025-01-27": 110.76810811148506,
    "2025-01-28": 111.36852427643704,
    "2025-01-29": 111.968940441389,
    "2025-01-30": 112.569356606341,
    "2025-01-31": 113.16977277129295,
    "2025-02-01": 114.38497777174454,
    "2025-02-02": 115.60018277219612,
    "2025-02-03": 116.81538777264768,
    "2025-02-04": 118.03059277309926,
    "2025-02-05": 119.24579777355083,
    "2025-02-06": 120.4610027740024,
    "2025-02-07": 121.676207774454,
    "2025-02-08": 122.89141277490556,
    "2025-02-09": 124.10661777535712,
    "2025-02-10": 125.3218227758087,
    "2025-02-11": 126.53702777626027,
    "2025-02-12": 127.75223277671184,
    "2025-02-13": 128.9674377771634,
    "2025-02-14": 130.182642777615,
    "2025-02-15": 131.39784777806656,
    "2025-02-16": 132.61305277851812,
    "2025-02-17": 133.82825777896971,
    "2025-02-18": 135.04346277942128,
    "2025-02-19": 136.25866777987284,
    "2025-02-20": 137.47387278032443,
    "2025-02-21": 138.689077780776,
    "2025-02-22": 139.90428278122758,
    "2025-02-23": 141.11948778167914,
    "2025-02-24": 142.3346927821307,
    "2025-02-25": 143.5498977825823,
    "2025-02-26": 144.76510278303385,
    "2025-02-27": 145.98030778348544,
    "2025-02-28": 147.195512783937,
    "2025-03-01": 148.9927348470213,
    "2025-03-02": 150.78995691010556,
    "2025-03-03": 152.58717897318985,
    "2025-03-04": 154.3844010362741,
    "2025-03-05": 156.1816230993584,
    "2025-03-06": 157.97884516244267,
    "2025-03-07": 159.77606722552696,
    "2025-03-08": 161.57328928861122,
    "2025-03-09": 163.3705113516955,
    "2025-03-10": 165.16773341477978,
    "2025-03-11": 166.96495547786407,
    "2025-03-12": 168.76217754094833,
    "2025-03-13": 170.55939960403262,
    "2025-03-14": 172.35662166711688,
    "2025-03-15": 174.15384373020115,
    "2025-03-16": 175.95106579328544,
    "2025-03-17": 177.74828785636973,
    "2025-03-18": 179.545509919454,
    "2025-03-19": 181.34273198253828,
    "2025-03-20": 183.13995404562252,
    "2025-03-21": 184.93717610870684,
    "2025-03-22": 186.7343981717911,
    "2025-03-23": 188.5316202348754,
    "2025-03-24": 190.32884229795968,
    "2025-03-25": 192.12606436104397,
    "2025-03-26": 193.9232864241282,
    "2025-03-27": 195.7205084872125,
    "2025-03-28": 197.5177305502968,
    "2025-03-29": 199.31495261338105,
    "2025-03-30": 201.1121746764653,
    "2025-03-31": 202.9093967395496,
    "2025-04-01": 206.17186775792987,
    "2025-04-02": 209.4343387763101,
    "2025-04-03": 212.6968097946904,
    "2025-04-04": 215.95928081307065,
    "2025-04-05": 219.2217518314509,
    "2025-04-06": 222.4842228498312,
    "2025-04-07": 225.74669386821145,
    "2025-04-08": 229.0091648865917,
    "2025-04-09": 232.271635904972,
    "2025-04-10": 235.53410692335223,
    "2025-04-11": 238.7965779417325,
    "2025-04-12": 242.0590489601128,
    "2025-04-13": 245.321519978493,
    "2025-04-14": 248.58399099687327,
    "2025-04-15": 251.84646201525356,
    "2025-04-16": 255.1089330336338,
    "2025-04-17": 258.37140405201404,
    "2025-04-18": 261.6338750703943,
    "2025-04-19": 264.8963460887746,
    "2025-04-20": 268.15881710715485,
    "2025-04-21": 271.4212881255351,
    "2025-04-22": 274.6837591439154,
    "2025-04-23": 277.94623016229565,
    "2025-04-24": 281.2087011806759,
    "2025-04-25": 284.4711721990561,
    "2025-04-26": 287.7336432174364,
    "2025-04-27": 290.99611423581666,
    "2025-04-28": 294.25858525419693,
    "2025-04-29": 297.5210562725772,
    "2025-04-30": 300.78352729095747,
    "2025-05-01": 304.52985993753794,
    "2025-05-02": 308.27619258411835,
    "2025-05-03": 312.0225252306988,
    "2025-05-04": 315.7688578772793,
    "2025-05-05": 319.51519052385976,
    "2025-05-06": 323.26152317044017,
    "2025-05-07": 327.00785581702064,
    "2025-05-08": 330.7541884636011,
    "2025-05-09": 334.5005211101815,
    "2025-05-10": 338.246853756762,
    "2025-05-11": 341.99318640334246,
    "2025-05-12": 345.73951904992293,
    "2025-05-13": 349.48585169650335,
    "2025-05-14": 353.2321843430838,
    "2025-05-15": 356.9785169896643,
    "2025-05-16": 360.7248496362447,
    "2025-05-17": 364.4711822828252,
    "2025-05-18": 368.2175149294056,
    "2025-05-19": 371.9638475759861,
    "2025-05-20": 375.7101802225665,
    "2025-05-21": 379.456512869147,
    "2025-05-22": 383.20284551572746,
    "2025-05-23": 386.9491781623079,
    "2025-05-24": 390.69551080888834,
    "2025-05-25": 394.4418434554688,
    "2025-05-26": 398.1881761020493,
    "2025-05-27": 401.9345087486297,
    "2025-05-28": 405.68084139521017,
    "2025-05-29": 409.4271740417906,
    "2025-05-30": 413.1735066883711,
    "2025-05-31": 416.9198393349515,
    "2025-06-01": 421.3619231278393,
    "2025-06-02": 425.8040069207272,
    "2025-06-03": 430.246090713615,
    "2025-06-04": 434.6881745065028,
    "2025-06-05": 439.13025829939056,
    "2025-06-06": 443.5723420922784,
    "2025-06-07": 448.0144258851663,
    "2025-06-08": 452.456509678054,
    "2025-06-09": 456.8985934709418,
    "2025-06-10": 461.34067726382966,
    "2025-06-11": 465.7827610567175,
    "2025-06-12": 470.2248448496053,
    "2025-06-13": 474.6669286424931,
    "2025-06-14": 479.1090124353809,
    "2025-06-15": 483.5510962282688,
    "2025-06-16": 487.99318002115655,
    "2025-06-17": 492.43526381404433,
    "2025-06-18": 496.8773476069322,
    "2025-06-19": 501.31943139982,
    "2025-06-20": 505.7615151927078,
    "2025-06-21": 510.2035989855956,
    "2025-06-22": 514.6456827784834,
    "2025-06-23": 519.0877665713713,
    "2025-06-24": 523.5298503642591,
    "2025-06-25": 527.9719341571468,
    "2025-06-26": 532.4140179500347,
    "2025-06-27": 536.8561017429225,
    "2025-06-28": 541.2981855358103,
    "2025-06-29": 545.7402693286981,
    "2025-06-30": 550.182353121586,
    "2025-07-01": 555.1325540356978,
    "2025-07-02": 560.0827549498096,
    "2025-07-03": 565.0329558639214,
    "2025-07-04": 569.9831567780333,
    "2025-07-05": 574.9333576921451,
    "2025-07-06": 579.8835586062569,
    "2025-07-07": 584.8337595203687,
    "2025-07-08": 589.7839604344806,
    "2025-07-09": 594.7341613485924,
    "2025-07-10": 599.6843622627042,
    "2025-07-11": 604.6345631768161,
    "2025-07-12": 609.5847640909278,
    "2025-07-13": 614.5349650050397,
    "2025-07-14": 619.4851659191515,
    "2025-07-15": 624.4353668332634,
    "2025-07-16": 629.3855677473751,
    "2025-07-17": 634.335768661487,
    "2025-07-18": 639.2859695755989,
    "2025-07-19": 644.2361704897107,
    "2025-07-20": 649.1863714038225,
    "2025-07-21": 654.1365723179343,
    "2025-07-22": 659.0867732320462,
    "2025-07-23": 664.036974146158,
    "2025-07-24": 668.9871750602698,
    "2025-07-25": 673.9373759743817,
    "2025-07-26": 678.8875768884934,
    "2025-07-27": 683.8377778026053,
    "2025-07-28": 688.7879787167171,
    "2025-07-29": 693.7381796308289,
    "2025-07-30": 698.6883805449407,
    "2025-07-31": 703.6385814590526,
    "2025-08-01": 707.5519192576966,
    "2025-08-02": 711.4652570563405,
    "2025-08-03": 715.3785948549845,
    "2025-08-04": 719.2919326536285,
    "2025-08-05": 723.2052704522723,
    "2025-08-06": 727.1186082509163,
    "2025-08-07": 731.0319460495602,
    "2025-08-08": 734.9452838482042,
    "2025-08-09": 738.8586216468482,
    "2025-08-10": 742.7719594454921,
    "2025-08-11": 746.6852972441361,
    "2025-08-12": 750.5986350427801,
    "2025-08-13": 754.511972841424,
    "2025-08-14": 758.425310640068,
    "2025-08-15": 762.338648438712,
    "2025-08-16": 766.2519862373558,
    "2025-08-17": 770.1653240359998,
    "2025-08-18": 774.0786618346438,
    "2025-08-19": 777.9919996332877,
    "2025-08-20": 781.9053374319317,
    "2025-08-21": 785.8186752305756,
    "2025-08-22": 789.7320130292196,
    "2025-08-23": 793.6453508278636,
    "2025-08-24": 797.5586886265075,
    "2025-08-25": 801.4720264251514,
    "2025-08-26": 805.3853642237955,
    "2025-08-27": 809.2987020224393,
    "2025-08-28": 813.2120398210833,
    "2025-08-29": 817.1253776197273,
    "2025-08-30": 821.0387154183712,
    "2025-08-31": 824.9520532170152,
    "2025-09-01": 827.8408850313077,
    "2025-09-02": 830.7297168456003,
    "2025-09-03": 833.6185486598928,
    "2025-09-04": 836.5073804741853,
    "2025-09-05": 839.396212288478,
    "2025-09-06": 842.2850441027705,
    "2025-09-07": 845.173875917063,
    "2025-09-08": 848.0627077313555,
    "2025-09-09": 850.9515395456481,
    "2025-09-10": 853.8403713599406,
    "2025-09-11": 856.7292031742331,
    "2025-09-12": 859.6180349885257,
    "2025-09-13": 862.5068668028182,
    "2025-09-14": 865.3956986171107,
    "2025-09-15": 868.2845304314033,
    "2025-09-16": 871.1733622456959,
    "2025-09-17": 874.0621940599884,
    "2025-09-18": 876.951025874281,
    "2025-09-19": 879.8398576885735,
    "2025-09-20": 882.728689502866,
    "2025-09-21": 885.6175213171585,
    "2025-09-22": 888.5063531314511,
    "2025-09-23": 891.3951849457436,
    "2025-09-24": 894.2840167600361,
    "2025-09-25": 897.1728485743288,
    "2025-09-26": 900.0616803886213,
    "2025-09-27": 902.9505122029138,
    "2025-09-28": 905.8393440172064,
    "2025-09-29": 908.7281758314988,
    "2025-09-30": 911.6170076457914,
  },
  Walnuts: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.257305492447427,
    "2024-10-03": 4.514610984894854,
    "2024-10-04": 6.77191647734228,
    "2024-10-05": 9.029221969789708,
    "2024-10-06": 11.286527462237135,
    "2024-10-07": 13.54383295468456,
    "2024-10-08": 15.801138447131988,
    "2024-10-09": 18.058443939579416,
    "2024-10-10": 20.31574943202684,
    "2024-10-11": 22.57305492447427,
    "2024-10-12": 24.830360416921696,
    "2024-10-13": 27.08766590936912,
    "2024-10-14": 29.34497140181655,
    "2024-10-15": 31.602276894263976,
    "2024-10-16": 33.8595823867114,
    "2024-10-17": 36.11688787915883,
    "2024-10-18": 38.37419337160626,
    "2024-10-19": 40.63149886405368,
    "2024-10-20": 42.88880435650111,
    "2024-10-21": 45.14610984894854,
    "2024-10-22": 47.40341534139596,
    "2024-10-23": 49.66072083384339,
    "2024-10-24": 51.91802632629082,
    "2024-10-25": 54.17533181873824,
    "2024-10-26": 56.43263731118567,
    "2024-10-27": 58.6899428036331,
    "2024-10-28": 60.94724829608053,
    "2024-10-29": 63.20455378852795,
    "2024-10-30": 65.46185928097537,
    "2024-10-31": 67.7191647734228,
    "2024-11-01": 68.55410972040319,
    "2024-11-02": 69.38905466738359,
    "2024-11-03": 70.22399961436398,
    "2024-11-04": 71.05894456134438,
    "2024-11-05": 71.89388950832476,
    "2024-11-06": 72.72883445530516,
    "2024-11-07": 73.56377940228555,
    "2024-11-08": 74.39872434926593,
    "2024-11-09": 75.23366929624633,
    "2024-11-10": 76.06861424322672,
    "2024-11-11": 76.90355919020712,
    "2024-11-12": 77.7385041371875,
    "2024-11-13": 78.5734490841679,
    "2024-11-14": 79.40839403114829,
    "2024-11-15": 80.24333897812869,
    "2024-11-16": 81.07828392510908,
    "2024-11-17": 81.91322887208946,
    "2024-11-18": 82.74817381906986,
    "2024-11-19": 83.58311876605025,
    "2024-11-20": 84.41806371303065,
    "2024-11-21": 85.25300866001103,
    "2024-11-22": 86.08795360699142,
    "2024-11-23": 86.92289855397182,
    "2024-11-24": 87.7578435009522,
    "2024-11-25": 88.5927884479326,
    "2024-11-26": 89.42773339491299,
    "2024-11-27": 90.26267834189338,
    "2024-11-28": 91.09762328887378,
    "2024-11-29": 91.93256823585418,
    "2024-11-30": 92.76751318283456,
    "2024-12-01": 93.10622929750436,
    "2024-12-02": 93.44494541217414,
    "2024-12-03": 93.78366152684391,
    "2024-12-04": 94.12237764151372,
    "2024-12-05": 94.4610937561835,
    "2024-12-06": 94.7998098708533,
    "2024-12-07": 95.13852598552307,
    "2024-12-08": 95.47724210019288,
    "2024-12-09": 95.81595821486266,
    "2024-12-10": 96.15467432953244,
    "2024-12-11": 96.49339044420223,
    "2024-12-12": 96.832106558872,
    "2024-12-13": 97.1708226735418,
    "2024-12-14": 97.5095387882116,
    "2024-12-15": 97.84825490288138,
    "2024-12-16": 98.18697101755116,
    "2024-12-17": 98.52568713222097,
    "2024-12-18": 98.86440324689076,
    "2024-12-19": 99.20311936156054,
    "2024-12-20": 99.54183547623032,
    "2024-12-21": 99.88055159090013,
    "2024-12-22": 100.2192677055699,
    "2024-12-23": 100.55798382023968,
    "2024-12-24": 100.89669993490948,
    "2024-12-25": 101.23541604957926,
    "2024-12-26": 101.57413216424904,
    "2024-12-27": 101.91284827891884,
    "2024-12-28": 102.25156439358862,
    "2024-12-29": 102.59028050825842,
    "2024-12-30": 102.9289966229282,
    "2024-12-31": 103.267712737598,
    "2025-01-01": 103.82467928684298,
    "2025-01-02": 104.38164583608796,
    "2025-01-03": 104.93861238533296,
    "2025-01-04": 105.49557893457794,
    "2025-01-05": 106.05254548382293,
    "2025-01-06": 106.60951203306792,
    "2025-01-07": 107.16647858231288,
    "2025-01-08": 107.72344513155788,
    "2025-01-09": 108.28041168080289,
    "2025-01-10": 108.83737823004786,
    "2025-01-11": 109.39434477929284,
    "2025-01-12": 109.95131132853784,
    "2025-01-13": 110.50827787778282,
    "2025-01-14": 111.0652444270278,
    "2025-01-15": 111.6222109762728,
    "2025-01-16": 112.17917752551776,
    "2025-01-17": 112.73614407476276,
    "2025-01-18": 113.29311062400777,
    "2025-01-19": 113.85007717325274,
    "2025-01-20": 114.40704372249772,
    "2025-01-21": 114.96401027174272,
    "2025-01-22": 115.5209768209877,
    "2025-01-23": 116.07794337023267,
    "2025-01-24": 116.63490991947768,
    "2025-01-25": 117.19187646872264,
    "2025-01-26": 117.74884301796764,
    "2025-01-27": 118.30580956721263,
    "2025-01-28": 118.86277611645762,
    "2025-01-29": 119.4197426657026,
    "2025-01-30": 119.9767092149476,
    "2025-01-31": 120.53367576419258,
    "2025-02-01": 121.6077904156148,
    "2025-02-02": 122.681905067037,
    "2025-02-03": 123.7560197184592,
    "2025-02-04": 124.8301343698814,
    "2025-02-05": 125.9042490213036,
    "2025-02-06": 126.9783636727258,
    "2025-02-07": 128.052478324148,
    "2025-02-08": 129.12659297557022,
    "2025-02-09": 130.20070762699245,
    "2025-02-10": 131.27482227841463,
    "2025-02-11": 132.34893692983684,
    "2025-02-12": 133.42305158125905,
    "2025-02-13": 134.49716623268125,
    "2025-02-14": 135.57128088410346,
    "2025-02-15": 136.6453955355257,
    "2025-02-16": 137.71951018694787,
    "2025-02-17": 138.79362483837008,
    "2025-02-18": 139.86773948979226,
    "2025-02-19": 140.9418541412145,
    "2025-02-20": 142.01596879263667,
    "2025-02-21": 143.09008344405888,
    "2025-02-22": 144.16419809548108,
    "2025-02-23": 145.2383127469033,
    "2025-02-24": 146.3124273983255,
    "2025-02-25": 147.3865420497477,
    "2025-02-26": 148.4606567011699,
    "2025-02-27": 149.53477135259212,
    "2025-02-28": 150.60888600401432,
    "2025-03-01": 152.25972652253006,
    "2025-03-02": 153.91056704104577,
    "2025-03-03": 155.5614075595615,
    "2025-03-04": 157.21224807807724,
    "2025-03-05": 158.86308859659297,
    "2025-03-06": 160.51392911510868,
    "2025-03-07": 162.16476963362442,
    "2025-03-08": 163.81561015214012,
    "2025-03-09": 165.46645067065586,
    "2025-03-10": 167.1172911891716,
    "2025-03-11": 168.7681317076873,
    "2025-03-12": 170.41897222620304,
    "2025-03-13": 172.06981274471875,
    "2025-03-14": 173.7206532632345,
    "2025-03-15": 175.37149378175022,
    "2025-03-16": 177.02233430026595,
    "2025-03-17": 178.67317481878166,
    "2025-03-18": 180.3240153372974,
    "2025-03-19": 181.97485585581316,
    "2025-03-20": 183.62569637432887,
    "2025-03-21": 185.27653689284455,
    "2025-03-22": 186.9273774113603,
    "2025-03-23": 188.57821792987605,
    "2025-03-24": 190.22905844839173,
    "2025-03-25": 191.8798989669075,
    "2025-03-26": 193.53073948542325,
    "2025-03-27": 195.18158000393893,
    "2025-03-28": 196.83242052245467,
    "2025-03-29": 198.4832610409704,
    "2025-03-30": 200.1341015594861,
    "2025-03-31": 201.78494207800185,
    "2025-04-01": 204.75194867928727,
    "2025-04-02": 207.71895528057283,
    "2025-04-03": 210.6859618818583,
    "2025-04-04": 213.65296848314375,
    "2025-04-05": 216.61997508442929,
    "2025-04-06": 219.5869816857148,
    "2025-04-07": 222.55398828700024,
    "2025-04-08": 225.5209948882857,
    "2025-04-09": 228.4880014895712,
    "2025-04-10": 231.4550080908567,
    "2025-04-11": 234.42201469214217,
    "2025-04-12": 237.38902129342765,
    "2025-04-13": 240.35602789471312,
    "2025-04-14": 243.32303449599863,
    "2025-04-15": 246.2900410972841,
    "2025-04-16": 249.2570476985696,
    "2025-04-17": 252.22405429985508,
    "2025-04-18": 255.19106090114056,
    "2025-04-19": 258.15806750242604,
    "2025-04-20": 261.12507410371154,
    "2025-04-21": 264.092080704997,
    "2025-04-22": 267.0590873062825,
    "2025-04-23": 270.026093907568,
    "2025-04-24": 272.99310050885344,
    "2025-04-25": 275.9601071101389,
    "2025-04-26": 278.92711371142445,
    "2025-04-27": 281.8941203127099,
    "2025-04-28": 284.8611269139954,
    "2025-04-29": 287.82813351528085,
    "2025-04-30": 290.7951401165664,
    "2025-05-01": 294.9993072312743,
    "2025-05-02": 299.2034743459823,
    "2025-05-03": 303.4076414606903,
    "2025-05-04": 307.61180857539824,
    "2025-05-05": 311.8159756901062,
    "2025-05-06": 316.02014280481416,
    "2025-05-07": 320.22430991952217,
    "2025-05-08": 324.4284770342301,
    "2025-05-09": 328.6326441489381,
    "2025-05-10": 332.83681126364604,
    "2025-05-11": 337.040978378354,
    "2025-05-12": 341.245145493062,
    "2025-05-13": 345.44931260777,
    "2025-05-14": 349.6534797224779,
    "2025-05-15": 353.8576468371859,
    "2025-05-16": 358.0618139518939,
    "2025-05-17": 362.26598106660185,
    "2025-05-18": 366.4701481813098,
    "2025-05-19": 370.67431529601777,
    "2025-05-20": 374.8784824107257,
    "2025-05-21": 379.0826495254337,
    "2025-05-22": 383.2868166401417,
    "2025-05-23": 387.4909837548497,
    "2025-05-24": 391.6951508695576,
    "2025-05-25": 395.8993179842656,
    "2025-05-26": 400.1034850989736,
    "2025-05-27": 404.3076522136816,
    "2025-05-28": 408.5118193283895,
    "2025-05-29": 412.7159864430975,
    "2025-05-30": 416.9201535578054,
    "2025-05-31": 421.1243206725134,
    "2025-06-01": 426.30475427574,
    "2025-06-02": 431.48518787896666,
    "2025-06-03": 436.6656214821932,
    "2025-06-04": 441.84605508541983,
    "2025-06-05": 447.02648868864645,
    "2025-06-06": 452.206922291873,
    "2025-06-07": 457.3873558950996,
    "2025-06-08": 462.5677894983263,
    "2025-06-09": 467.74822310155287,
    "2025-06-10": 472.9286567047795,
    "2025-06-11": 478.1090903080061,
    "2025-06-12": 483.2895239112327,
    "2025-06-13": 488.4699575144593,
    "2025-06-14": 493.6503911176859,
    "2025-06-15": 498.83082472091246,
    "2025-06-16": 504.0112583241391,
    "2025-06-17": 509.1916919273657,
    "2025-06-18": 514.3721255305923,
    "2025-06-19": 519.5525591338189,
    "2025-06-20": 524.7329927370455,
    "2025-06-21": 529.913426340272,
    "2025-06-22": 535.0938599434987,
    "2025-06-23": 540.2742935467253,
    "2025-06-24": 545.454727149952,
    "2025-06-25": 550.6351607531785,
    "2025-06-26": 555.8155943564052,
    "2025-06-27": 560.9960279596318,
    "2025-06-28": 566.1764615628583,
    "2025-06-29": 571.356895166085,
    "2025-06-30": 576.5373287693116,
    "2025-07-01": 581.9309429095543,
    "2025-07-02": 587.3245570497971,
    "2025-07-03": 592.71817119004,
    "2025-07-04": 598.1117853302828,
    "2025-07-05": 603.5053994705256,
    "2025-07-06": 608.8990136107684,
    "2025-07-07": 614.2926277510113,
    "2025-07-08": 619.6862418912541,
    "2025-07-09": 625.0798560314969,
    "2025-07-10": 630.4734701717397,
    "2025-07-11": 635.8670843119826,
    "2025-07-12": 641.2606984522254,
    "2025-07-13": 646.6543125924682,
    "2025-07-14": 652.047926732711,
    "2025-07-15": 657.4415408729537,
    "2025-07-16": 662.8351550131966,
    "2025-07-17": 668.2287691534394,
    "2025-07-18": 673.6223832936822,
    "2025-07-19": 679.015997433925,
    "2025-07-20": 684.4096115741679,
    "2025-07-21": 689.8032257144107,
    "2025-07-22": 695.1968398546535,
    "2025-07-23": 700.5904539948963,
    "2025-07-24": 705.9840681351391,
    "2025-07-25": 711.377682275382,
    "2025-07-26": 716.7712964156248,
    "2025-07-27": 722.1649105558676,
    "2025-07-28": 727.5585246961103,
    "2025-07-29": 732.9521388363532,
    "2025-07-30": 738.345752976596,
    "2025-07-31": 743.7393671168388,
    "2025-08-01": 748.148590823054,
    "2025-08-02": 752.5578145292691,
    "2025-08-03": 756.9670382354842,
    "2025-08-04": 761.3762619416993,
    "2025-08-05": 765.7854856479145,
    "2025-08-06": 770.1947093541296,
    "2025-08-07": 774.6039330603447,
    "2025-08-08": 779.0131567665599,
    "2025-08-09": 783.422380472775,
    "2025-08-10": 787.8316041789901,
    "2025-08-11": 792.2408278852052,
    "2025-08-12": 796.6500515914204,
    "2025-08-13": 801.0592752976355,
    "2025-08-14": 805.4684990038506,
    "2025-08-15": 809.8777227100658,
    "2025-08-16": 814.2869464162809,
    "2025-08-17": 818.696170122496,
    "2025-08-18": 823.1053938287112,
    "2025-08-19": 827.5146175349263,
    "2025-08-20": 831.9238412411414,
    "2025-08-21": 836.3330649473565,
    "2025-08-22": 840.7422886535717,
    "2025-08-23": 845.1515123597868,
    "2025-08-24": 849.5607360660019,
    "2025-08-25": 853.9699597722171,
    "2025-08-26": 858.3791834784322,
    "2025-08-27": 862.7884071846473,
    "2025-08-28": 867.1976308908625,
    "2025-08-29": 871.6068545970776,
    "2025-08-30": 876.0160783032927,
    "2025-08-31": 880.4253020095078,
    "2025-09-01": 883.6360323698876,
    "2025-09-02": 886.8467627302674,
    "2025-09-03": 890.0574930906472,
    "2025-09-04": 893.268223451027,
    "2025-09-05": 896.4789538114068,
    "2025-09-06": 899.6896841717866,
    "2025-09-07": 902.9004145321665,
    "2025-09-08": 906.111144892546,
    "2025-09-09": 909.3218752529258,
    "2025-09-10": 912.5326056133056,
    "2025-09-11": 915.7433359736854,
    "2025-09-12": 918.9540663340651,
    "2025-09-13": 922.1647966944448,
    "2025-09-14": 925.3755270548248,
    "2025-09-15": 928.5862574152044,
    "2025-09-16": 931.7969877755844,
    "2025-09-17": 935.007718135964,
    "2025-09-18": 938.218448496344,
    "2025-09-19": 941.4291788567236,
    "2025-09-20": 944.6399092171034,
    "2025-09-21": 947.8506395774832,
    "2025-09-22": 951.061369937863,
    "2025-09-23": 954.2721002982428,
    "2025-09-24": 957.4828306586224,
    "2025-09-25": 960.6935610190022,
    "2025-09-26": 963.904291379382,
    "2025-09-27": 967.1150217397618,
    "2025-09-28": 970.3257521001416,
    "2025-09-29": 973.5364824605214,
    "2025-09-30": 976.7472128209012,
  },
};

export const perennialTreeQ85: Record<string, Record<string, number>> = {
  Almonds: {
    "2024-10-01": 0.0,
    "2024-10-02": 1.983989687671944,
    "2024-10-03": 3.967979375343888,
    "2024-10-04": 5.951969063015832,
    "2024-10-05": 7.935958750687775,
    "2024-10-06": 9.91994843835972,
    "2024-10-07": 11.903938126031663,
    "2024-10-08": 13.887927813703609,
    "2024-10-09": 15.87191750137555,
    "2024-10-10": 17.855907189047496,
    "2024-10-11": 19.83989687671944,
    "2024-10-12": 21.823886564391383,
    "2024-10-13": 23.807876252063327,
    "2024-10-14": 25.79186593973527,
    "2024-10-15": 27.77585562740721,
    "2024-10-16": 29.75984531507916,
    "2024-10-17": 31.7438350027511,
    "2024-10-18": 33.72782469042305,
    "2024-10-19": 35.71181437809499,
    "2024-10-20": 37.695804065766936,
    "2024-10-21": 39.67979375343888,
    "2024-10-22": 41.66378344111082,
    "2024-10-23": 43.64777312878277,
    "2024-10-24": 45.63176281645471,
    "2024-10-25": 47.615752504126654,
    "2024-10-26": 49.5997421917986,
    "2024-10-27": 51.58373187947054,
    "2024-10-28": 53.567721567142485,
    "2024-10-29": 55.55171125481443,
    "2024-10-30": 57.53570094248637,
    "2024-10-31": 59.51969063015832,
    "2024-11-01": 60.40479306027432,
    "2024-11-02": 61.28989549039032,
    "2024-11-03": 62.17499792050632,
    "2024-11-04": 63.06010035062232,
    "2024-11-05": 63.94520278073833,
    "2024-11-06": 64.83030521085433,
    "2024-11-07": 65.71540764097033,
    "2024-11-08": 66.60051007108633,
    "2024-11-09": 67.48561250120234,
    "2024-11-10": 68.37071493131833,
    "2024-11-11": 69.25581736143434,
    "2024-11-12": 70.14091979155035,
    "2024-11-13": 71.02602222166634,
    "2024-11-14": 71.91112465178234,
    "2024-11-15": 72.79622708189835,
    "2024-11-16": 73.68132951201434,
    "2024-11-17": 74.56643194213035,
    "2024-11-18": 75.45153437224636,
    "2024-11-19": 76.33663680236236,
    "2024-11-20": 77.22173923247836,
    "2024-11-21": 78.10684166259436,
    "2024-11-22": 78.99194409271036,
    "2024-11-23": 79.87704652282636,
    "2024-11-24": 80.76214895294237,
    "2024-11-25": 81.64725138305838,
    "2024-11-26": 82.53235381317437,
    "2024-11-27": 83.41745624329037,
    "2024-11-28": 84.30255867340637,
    "2024-11-29": 85.18766110352237,
    "2024-11-30": 86.07276353363838,
    "2024-12-01": 86.47975312574839,
    "2024-12-02": 86.88674271785841,
    "2024-12-03": 87.29373230996842,
    "2024-12-04": 87.70072190207844,
    "2024-12-05": 88.10771149418845,
    "2024-12-06": 88.51470108629846,
    "2024-12-07": 88.92169067840848,
    "2024-12-08": 89.32868027051849,
    "2024-12-09": 89.73566986262851,
    "2024-12-10": 90.14265945473852,
    "2024-12-11": 90.54964904684854,
    "2024-12-12": 90.95663863895857,
    "2024-12-13": 91.36362823106856,
    "2024-12-14": 91.77061782317858,
    "2024-12-15": 92.1776074152886,
    "2024-12-16": 92.5845970073986,
    "2024-12-17": 92.99158659950862,
    "2024-12-18": 93.39857619161864,
    "2024-12-19": 93.80556578372864,
    "2024-12-20": 94.21255537583866,
    "2024-12-21": 94.61954496794868,
    "2024-12-22": 95.02653456005868,
    "2024-12-23": 95.43352415216872,
    "2024-12-24": 95.84051374427872,
    "2024-12-25": 96.24750333638876,
    "2024-12-26": 96.65449292849875,
    "2024-12-27": 97.06148252060876,
    "2024-12-28": 97.4684721127188,
    "2024-12-29": 97.8754617048288,
    "2024-12-30": 98.2824512969388,
    "2024-12-31": 98.68944088904884,
    "2025-01-01": 99.37436105115928,
    "2025-01-02": 100.05928121326971,
    "2025-01-03": 100.7442013753802,
    "2025-01-04": 101.42912153749064,
    "2025-01-05": 102.11404169960107,
    "2025-01-06": 102.79896186171156,
    "2025-01-07": 103.483882023822,
    "2025-01-08": 104.16880218593244,
    "2025-01-09": 104.8537223480429,
    "2025-01-10": 105.53864251015337,
    "2025-01-11": 106.2235626722638,
    "2025-01-12": 106.90848283437424,
    "2025-01-13": 107.59340299648473,
    "2025-01-14": 108.27832315859516,
    "2025-01-15": 108.96324332070562,
    "2025-01-16": 109.64816348281606,
    "2025-01-17": 110.33308364492652,
    "2025-01-18": 111.01800380703696,
    "2025-01-19": 111.70292396914742,
    "2025-01-20": 112.38784413125788,
    "2025-01-21": 113.07276429336832,
    "2025-01-22": 113.75768445547878,
    "2025-01-23": 114.44260461758924,
    "2025-01-24": 115.12752477969968,
    "2025-01-25": 115.81244494181011,
    "2025-01-26": 116.4973651039206,
    "2025-01-27": 117.18228526603104,
    "2025-01-28": 117.86720542814147,
    "2025-01-29": 118.55212559025196,
    "2025-01-30": 119.2370457523624,
    "2025-01-31": 119.92196591447284,
    "2025-02-01": 121.18399546714434,
    "2025-02-02": 122.44602501981582,
    "2025-02-03": 123.70805457248731,
    "2025-02-04": 124.9700841251588,
    "2025-02-05": 126.23211367783028,
    "2025-02-06": 127.49414323050178,
    "2025-02-07": 128.75617278317327,
    "2025-02-08": 130.01820233584476,
    "2025-02-09": 131.28023188851623,
    "2025-02-10": 132.54226144118772,
    "2025-02-11": 133.8042909938592,
    "2025-02-12": 135.0663205465307,
    "2025-02-13": 136.3283500992022,
    "2025-02-14": 137.59037965187366,
    "2025-02-15": 138.85240920454515,
    "2025-02-16": 140.11443875721665,
    "2025-02-17": 141.37646830988814,
    "2025-02-18": 142.63849786255963,
    "2025-02-19": 143.90052741523112,
    "2025-02-20": 145.1625569679026,
    "2025-02-21": 146.42458652057408,
    "2025-02-22": 147.68661607324557,
    "2025-02-23": 148.94864562591707,
    "2025-02-24": 150.21067517858856,
    "2025-02-25": 151.47270473126002,
    "2025-02-26": 152.73473428393152,
    "2025-02-27": 153.996763836603,
    "2025-02-28": 155.2587933892745,
    "2025-03-01": 157.6701001443594,
    "2025-03-02": 160.08140689944426,
    "2025-03-03": 162.49271365452915,
    "2025-03-04": 164.90402040961405,
    "2025-03-05": 167.3153271646989,
    "2025-03-06": 169.7266339197838,
    "2025-03-07": 172.13794067486867,
    "2025-03-08": 174.54924742995357,
    "2025-03-09": 176.96055418503846,
    "2025-03-10": 179.37186094012333,
    "2025-03-11": 181.78316769520825,
    "2025-03-12": 184.19447445029311,
    "2025-03-13": 186.605781205378,
    "2025-03-14": 189.01708796046287,
    "2025-03-15": 191.42839471554777,
    "2025-03-16": 193.83970147063263,
    "2025-03-17": 196.25100822571756,
    "2025-03-18": 198.6623149808024,
    "2025-03-19": 201.0736217358873,
    "2025-03-20": 203.48492849097215,
    "2025-03-21": 205.89623524605707,
    "2025-03-22": 208.30754200114197,
    "2025-03-23": 210.71884875622683,
    "2025-03-24": 213.13015551131173,
    "2025-03-25": 215.5414622663966,
    "2025-03-26": 217.9527690214815,
    "2025-03-27": 220.3640757765664,
    "2025-03-28": 222.77538253165125,
    "2025-03-29": 225.1866892867361,
    "2025-03-30": 227.597996041821,
    "2025-03-31": 230.0093027969059,
    "2025-04-01": 234.267245305118,
    "2025-04-02": 238.5251878133301,
    "2025-04-03": 242.7831303215422,
    "2025-04-04": 247.04107282975428,
    "2025-04-05": 251.2990153379664,
    "2025-04-06": 255.55695784617848,
    "2025-04-07": 259.8149003543906,
    "2025-04-08": 264.07284286260267,
    "2025-04-09": 268.3307853708148,
    "2025-04-10": 272.58872787902686,
    "2025-04-11": 276.846670387239,
    "2025-04-12": 281.10461289545106,
    "2025-04-13": 285.3625554036632,
    "2025-04-14": 289.6204979118753,
    "2025-04-15": 293.8784404200874,
    "2025-04-16": 298.13638292829944,
    "2025-04-17": 302.3943254365116,
    "2025-04-18": 306.6522679447237,
    "2025-04-19": 310.91021045293576,
    "2025-04-20": 315.1681529611478,
    "2025-04-21": 319.42609546935995,
    "2025-04-22": 323.6840379775721,
    "2025-04-23": 327.94198048578414,
    "2025-04-24": 332.19992299399627,
    "2025-04-25": 336.45786550220834,
    "2025-04-26": 340.71580801042046,
    "2025-04-27": 344.9737505186325,
    "2025-04-28": 349.23169302684465,
    "2025-04-29": 353.4896355350568,
    "2025-04-30": 357.74757804326885,
    "2025-05-01": 363.5453896697308,
    "2025-05-02": 369.3432012961928,
    "2025-05-03": 375.1410129226547,
    "2025-05-04": 380.9388245491167,
    "2025-05-05": 386.7366361755786,
    "2025-05-06": 392.5344478020406,
    "2025-05-07": 398.33225942850254,
    "2025-05-08": 404.1300710549645,
    "2025-05-09": 409.9278826814264,
    "2025-05-10": 415.7256943078884,
    "2025-05-11": 421.5235059343504,
    "2025-05-12": 427.3213175608123,
    "2025-05-13": 433.1191291872742,
    "2025-05-14": 438.9169408137362,
    "2025-05-15": 444.7147524401981,
    "2025-05-16": 450.5125640666601,
    "2025-05-17": 456.310375693122,
    "2025-05-18": 462.108187319584,
    "2025-05-19": 467.90599894604594,
    "2025-05-20": 473.7038105725079,
    "2025-05-21": 479.5016221989698,
    "2025-05-22": 485.2994338254318,
    "2025-05-23": 491.09724545189374,
    "2025-05-24": 496.8950570783557,
    "2025-05-25": 502.69286870481767,
    "2025-05-26": 508.4906803312796,
    "2025-05-27": 514.2884919577416,
    "2025-05-28": 520.0863035842035,
    "2025-05-29": 525.8841152106654,
    "2025-05-30": 531.6819268371274,
    "2025-05-31": 537.4797384635893,
    "2025-06-01": 544.4245542594954,
    "2025-06-02": 551.3693700554014,
    "2025-06-03": 558.3141858513073,
    "2025-06-04": 565.2590016472134,
    "2025-06-05": 572.2038174431194,
    "2025-06-06": 579.1486332390255,
    "2025-06-07": 586.0934490349315,
    "2025-06-08": 593.0382648308374,
    "2025-06-09": 599.9830806267435,
    "2025-06-10": 606.9278964226495,
    "2025-06-11": 613.8727122185555,
    "2025-06-12": 620.8175280144615,
    "2025-06-13": 627.7623438103675,
    "2025-06-14": 634.7071596062735,
    "2025-06-15": 641.6519754021796,
    "2025-06-16": 648.5967911980856,
    "2025-06-17": 655.5416069939915,
    "2025-06-18": 662.4864227898976,
    "2025-06-19": 669.4312385858036,
    "2025-06-20": 676.3760543817097,
    "2025-06-21": 683.3208701776157,
    "2025-06-22": 690.2656859735216,
    "2025-06-23": 697.2105017694277,
    "2025-06-24": 704.1553175653337,
    "2025-06-25": 711.1001333612397,
    "2025-06-26": 718.0449491571458,
    "2025-06-27": 724.9897649530517,
    "2025-06-28": 731.9345807489577,
    "2025-06-29": 738.8793965448638,
    "2025-06-30": 745.8242123407698,
    "2025-07-01": 752.5843049664653,
    "2025-07-02": 759.3443975921608,
    "2025-07-03": 766.1044902178562,
    "2025-07-04": 772.8645828435517,
    "2025-07-05": 779.6246754692472,
    "2025-07-06": 786.3847680949427,
    "2025-07-07": 793.1448607206382,
    "2025-07-08": 799.9049533463337,
    "2025-07-09": 806.6650459720292,
    "2025-07-10": 813.4251385977246,
    "2025-07-11": 820.1852312234201,
    "2025-07-12": 826.9453238491157,
    "2025-07-13": 833.7054164748112,
    "2025-07-14": 840.4655091005067,
    "2025-07-15": 847.2256017262021,
    "2025-07-16": 853.9856943518976,
    "2025-07-17": 860.7457869775931,
    "2025-07-18": 867.5058796032886,
    "2025-07-19": 874.2659722289841,
    "2025-07-20": 881.0260648546796,
    "2025-07-21": 887.7861574803751,
    "2025-07-22": 894.5462501060706,
    "2025-07-23": 901.306342731766,
    "2025-07-24": 908.0664353574616,
    "2025-07-25": 914.826527983157,
    "2025-07-26": 921.5866206088524,
    "2025-07-27": 928.346713234548,
    "2025-07-28": 935.1068058602434,
    "2025-07-29": 941.8668984859388,
    "2025-07-30": 948.6269911116344,
    "2025-07-31": 955.38708373733,
    "2025-08-01": 960.1355392512404,
    "2025-08-02": 964.8839947651512,
    "2025-08-03": 969.6324502790618,
    "2025-08-04": 974.3809057929724,
    "2025-08-05": 979.1293613068832,
    "2025-08-06": 983.8778168207936,
    "2025-08-07": 988.6262723347044,
    "2025-08-08": 993.374727848615,
    "2025-08-09": 998.1231833625257,
    "2025-08-10": 1002.871638876436,
    "2025-08-11": 1007.6200943903468,
    "2025-08-12": 1012.3685499042574,
    "2025-08-13": 1017.117005418168,
    "2025-08-14": 1021.8654609320786,
    "2025-08-15": 1026.6139164459892,
    "2025-08-16": 1031.3623719599,
    "2025-08-17": 1036.1108274738106,
    "2025-08-18": 1040.8592829877211,
    "2025-08-19": 1045.6077385016315,
    "2025-08-20": 1050.3561940155423,
    "2025-08-21": 1055.104649529453,
    "2025-08-22": 1059.8531050433637,
    "2025-08-23": 1064.6015605572743,
    "2025-08-24": 1069.3500160711849,
    "2025-08-25": 1074.0984715850957,
    "2025-08-26": 1078.846927099006,
    "2025-08-27": 1083.5953826129166,
    "2025-08-28": 1088.3438381268274,
    "2025-08-29": 1093.092293640738,
    "2025-08-30": 1097.8407491546486,
    "2025-08-31": 1102.5892046685592,
    "2025-09-01": 1105.953720924765,
    "2025-09-02": 1109.3182371809717,
    "2025-09-03": 1112.6827534371778,
    "2025-09-04": 1116.047269693384,
    "2025-09-05": 1119.4117859495902,
    "2025-09-06": 1122.7763022057966,
    "2025-09-07": 1126.1408184620027,
    "2025-09-08": 1129.505334718209,
    "2025-09-09": 1132.8698509744152,
    "2025-09-10": 1136.2343672306215,
    "2025-09-11": 1139.5988834868276,
    "2025-09-12": 1142.963399743034,
    "2025-09-13": 1146.32791599924,
    "2025-09-14": 1149.6924322554464,
    "2025-09-15": 1153.0569485116523,
    "2025-09-16": 1156.4214647678589,
    "2025-09-17": 1159.785981024065,
    "2025-09-18": 1163.150497280271,
    "2025-09-19": 1166.5150135364777,
    "2025-09-20": 1169.8795297926836,
    "2025-09-21": 1173.24404604889,
    "2025-09-22": 1176.608562305096,
    "2025-09-23": 1179.9730785613024,
    "2025-09-24": 1183.3375948175085,
    "2025-09-25": 1186.7021110737148,
    "2025-09-26": 1190.066627329921,
    "2025-09-27": 1193.4311435861273,
    "2025-09-28": 1196.7956598423334,
    "2025-09-29": 1200.1601760985398,
    "2025-09-30": 1203.524692354746,
  },
  Apples: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.492144600299873,
    "2024-10-03": 4.984289200599747,
    "2024-10-04": 7.47643380089962,
    "2024-10-05": 9.968578401199494,
    "2024-10-06": 12.460723001499368,
    "2024-10-07": 14.95286760179924,
    "2024-10-08": 17.445012202099115,
    "2024-10-09": 19.937156802398988,
    "2024-10-10": 22.42930140269886,
    "2024-10-11": 24.92144600299873,
    "2024-10-12": 27.41359060329861,
    "2024-10-13": 29.90573520359848,
    "2024-10-14": 32.39787980389836,
    "2024-10-15": 34.89002440419823,
    "2024-10-16": 37.3821690044981,
    "2024-10-17": 39.874313604797976,
    "2024-10-18": 42.36645820509785,
    "2024-10-19": 44.85860280539772,
    "2024-10-20": 47.3507474056976,
    "2024-10-21": 49.84289200599747,
    "2024-10-22": 52.335036606297344,
    "2024-10-23": 54.82718120659722,
    "2024-10-24": 57.31932580689709,
    "2024-10-25": 59.81147040719696,
    "2024-10-26": 62.30361500749684,
    "2024-10-27": 64.79575960779671,
    "2024-10-28": 67.28790420809659,
    "2024-10-29": 69.78004880839646,
    "2024-10-30": 72.27219340869632,
    "2024-10-31": 74.7643380089962,
    "2024-11-01": 75.65527115622585,
    "2024-11-02": 76.5462043034555,
    "2024-11-03": 77.43713745068514,
    "2024-11-04": 78.32807059791479,
    "2024-11-05": 79.21900374514443,
    "2024-11-06": 80.10993689237408,
    "2024-11-07": 81.00087003960373,
    "2024-11-08": 81.89180318683337,
    "2024-11-09": 82.78273633406302,
    "2024-11-10": 83.67366948129266,
    "2024-11-11": 84.56460262852231,
    "2024-11-12": 85.45553577575195,
    "2024-11-13": 86.3464689229816,
    "2024-11-14": 87.23740207021126,
    "2024-11-15": 88.1283352174409,
    "2024-11-16": 89.01926836467055,
    "2024-11-17": 89.9102015119002,
    "2024-11-18": 90.80113465912984,
    "2024-11-19": 91.69206780635947,
    "2024-11-20": 92.58300095358912,
    "2024-11-21": 93.47393410081878,
    "2024-11-22": 94.36486724804844,
    "2024-11-23": 95.25580039527809,
    "2024-11-24": 96.14673354250772,
    "2024-11-25": 97.03766668973736,
    "2024-11-26": 97.928599836967,
    "2024-11-27": 98.81953298419666,
    "2024-11-28": 99.7104661314263,
    "2024-11-29": 100.60139927865596,
    "2024-11-30": 101.4923324258856,
    "2024-12-01": 102.02632264268732,
    "2024-12-02": 102.56031285948906,
    "2024-12-03": 103.0943030762908,
    "2024-12-04": 103.62829329309253,
    "2024-12-05": 104.16228350989428,
    "2024-12-06": 104.696273726696,
    "2024-12-07": 105.23026394349772,
    "2024-12-08": 105.76425416029949,
    "2024-12-09": 106.2982443771012,
    "2024-12-10": 106.83223459390294,
    "2024-12-11": 107.36622481070468,
    "2024-12-12": 107.9002150275064,
    "2024-12-13": 108.43420524430816,
    "2024-12-14": 108.96819546110989,
    "2024-12-15": 109.5021856779116,
    "2024-12-16": 110.03617589471334,
    "2024-12-17": 110.57016611151508,
    "2024-12-18": 111.1041563283168,
    "2024-12-19": 111.63814654511854,
    "2024-12-20": 112.17213676192029,
    "2024-12-21": 112.706126978722,
    "2024-12-22": 113.24011719552377,
    "2024-12-23": 113.77410741232548,
    "2024-12-24": 114.30809762912722,
    "2024-12-25": 114.84208784592894,
    "2024-12-26": 115.37607806273068,
    "2024-12-27": 115.91006827953242,
    "2024-12-28": 116.44405849633416,
    "2024-12-29": 116.97804871313588,
    "2024-12-30": 117.51203892993762,
    "2024-12-31": 118.04602914673936,
    "2025-01-01": 119.0008176470022,
    "2025-01-02": 119.95560614726504,
    "2025-01-03": 120.9103946475279,
    "2025-01-04": 121.86518314779072,
    "2025-01-05": 122.81997164805358,
    "2025-01-06": 123.77476014831645,
    "2025-01-07": 124.72954864857928,
    "2025-01-08": 125.68433714884212,
    "2025-01-09": 126.63912564910495,
    "2025-01-10": 127.5939141493678,
    "2025-01-11": 128.54870264963066,
    "2025-01-12": 129.5034911498935,
    "2025-01-13": 130.45827965015633,
    "2025-01-14": 131.41306815041918,
    "2025-01-15": 132.36785665068203,
    "2025-01-16": 133.32264515094488,
    "2025-01-17": 134.27743365120773,
    "2025-01-18": 135.23222215147058,
    "2025-01-19": 136.1870106517334,
    "2025-01-20": 137.14179915199625,
    "2025-01-21": 138.0965876522591,
    "2025-01-22": 139.05137615252195,
    "2025-01-23": 140.00616465278478,
    "2025-01-24": 140.96095315304763,
    "2025-01-25": 141.91574165331048,
    "2025-01-26": 142.87053015357333,
    "2025-01-27": 143.82531865383618,
    "2025-01-28": 144.78010715409903,
    "2025-01-29": 145.73489565436185,
    "2025-01-30": 146.6896841546247,
    "2025-01-31": 147.64447265488755,
    "2025-02-01": 149.10467519733345,
    "2025-02-02": 150.56487773977932,
    "2025-02-03": 152.02508028222522,
    "2025-02-04": 153.48528282467112,
    "2025-02-05": 154.945485367117,
    "2025-02-06": 156.4056879095629,
    "2025-02-07": 157.86589045200878,
    "2025-02-08": 159.32609299445463,
    "2025-02-09": 160.78629553690055,
    "2025-02-10": 162.24649807934645,
    "2025-02-11": 163.70670062179232,
    "2025-02-12": 165.16690316423822,
    "2025-02-13": 166.62710570668412,
    "2025-02-14": 168.08730824913,
    "2025-02-15": 169.5475107915759,
    "2025-02-16": 171.0077133340218,
    "2025-02-17": 172.46791587646766,
    "2025-02-18": 173.92811841891356,
    "2025-02-19": 175.38832096135943,
    "2025-02-20": 176.84852350380535,
    "2025-02-21": 178.30872604625122,
    "2025-02-22": 179.76892858869712,
    "2025-02-23": 181.22913113114305,
    "2025-02-24": 182.6893336735889,
    "2025-02-25": 184.1495362160348,
    "2025-02-26": 185.6097387584807,
    "2025-02-27": 187.06994130092656,
    "2025-02-28": 188.53014384337249,
    "2025-03-01": 190.6483952873254,
    "2025-03-02": 192.76664673127837,
    "2025-03-03": 194.88489817523129,
    "2025-03-04": 197.00314961918423,
    "2025-03-05": 199.12140106313717,
    "2025-03-06": 201.23965250709009,
    "2025-03-07": 203.35790395104303,
    "2025-03-08": 205.476155394996,
    "2025-03-09": 207.5944068389489,
    "2025-03-10": 209.71265828290183,
    "2025-03-11": 211.8309097268548,
    "2025-03-12": 213.9491611708077,
    "2025-03-13": 216.06741261476063,
    "2025-03-14": 218.1856640587136,
    "2025-03-15": 220.3039155026665,
    "2025-03-16": 222.42216694661948,
    "2025-03-17": 224.54041839057243,
    "2025-03-18": 226.65866983452537,
    "2025-03-19": 228.7769212784783,
    "2025-03-20": 230.89517272243123,
    "2025-03-21": 233.0134241663842,
    "2025-03-22": 235.1316756103371,
    "2025-03-23": 237.24992705429003,
    "2025-03-24": 239.368178498243,
    "2025-03-25": 241.48642994219597,
    "2025-03-26": 243.60468138614888,
    "2025-03-27": 245.7229328301018,
    "2025-03-28": 247.84118427405477,
    "2025-03-29": 249.95943571800768,
    "2025-03-30": 252.07768716196065,
    "2025-03-31": 254.1959386059136,
    "2025-04-01": 257.7730817188993,
    "2025-04-02": 261.350224831885,
    "2025-04-03": 264.9273679448707,
    "2025-04-04": 268.5045110578564,
    "2025-04-05": 272.0816541708421,
    "2025-04-06": 275.6587972838278,
    "2025-04-07": 279.23594039681353,
    "2025-04-08": 282.81308350979924,
    "2025-04-09": 286.3902266227849,
    "2025-04-10": 289.96736973577066,
    "2025-04-11": 293.5445128487564,
    "2025-04-12": 297.1216559617421,
    "2025-04-13": 300.6987990747278,
    "2025-04-14": 304.27594218771355,
    "2025-04-15": 307.85308530069926,
    "2025-04-16": 311.430228413685,
    "2025-04-17": 315.0073715266707,
    "2025-04-18": 318.5845146396564,
    "2025-04-19": 322.1616577526421,
    "2025-04-20": 325.7388008656278,
    "2025-04-21": 329.3159439786135,
    "2025-04-22": 332.8930870915992,
    "2025-04-23": 336.47023020458494,
    "2025-04-24": 340.04737331757065,
    "2025-04-25": 343.62451643055635,
    "2025-04-26": 347.20165954354206,
    "2025-04-27": 350.7788026565278,
    "2025-04-28": 354.3559457695135,
    "2025-04-29": 357.9330888824992,
    "2025-04-30": 361.5102319954849,
    "2025-05-01": 365.8571356123164,
    "2025-05-02": 370.20403922914784,
    "2025-05-03": 374.5509428459793,
    "2025-05-04": 378.8978464628108,
    "2025-05-05": 383.2447500796423,
    "2025-05-06": 387.59165369647377,
    "2025-05-07": 391.9385573133053,
    "2025-05-08": 396.2854609301367,
    "2025-05-09": 400.6323645469682,
    "2025-05-10": 404.9792681637997,
    "2025-05-11": 409.3261717806311,
    "2025-05-12": 413.6730753974626,
    "2025-05-13": 418.0199790142941,
    "2025-05-14": 422.3668826311256,
    "2025-05-15": 426.71378624795705,
    "2025-05-16": 431.0606898647885,
    "2025-05-17": 435.40759348162,
    "2025-05-18": 439.75449709845145,
    "2025-05-19": 444.1014007152829,
    "2025-05-20": 448.4483043321144,
    "2025-05-21": 452.79520794894586,
    "2025-05-22": 457.1421115657774,
    "2025-05-23": 461.48901518260885,
    "2025-05-24": 465.8359187994403,
    "2025-05-25": 470.1828224162718,
    "2025-05-26": 474.52972603310326,
    "2025-05-27": 478.8766296499348,
    "2025-05-28": 483.2235332667663,
    "2025-05-29": 487.5704368835977,
    "2025-05-30": 491.9173405004292,
    "2025-05-31": 496.2642441172607,
    "2025-06-01": 501.5600588009629,
    "2025-06-02": 506.8558734846652,
    "2025-06-03": 512.1516881683674,
    "2025-06-04": 517.4475028520696,
    "2025-06-05": 522.7433175357719,
    "2025-06-06": 528.0391322194741,
    "2025-06-07": 533.3349469031764,
    "2025-06-08": 538.6307615868787,
    "2025-06-09": 543.926576270581,
    "2025-06-10": 549.2223909542832,
    "2025-06-11": 554.5182056379855,
    "2025-06-12": 559.8140203216877,
    "2025-06-13": 565.10983500539,
    "2025-06-14": 570.4056496890922,
    "2025-06-15": 575.7014643727945,
    "2025-06-16": 580.9972790564967,
    "2025-06-17": 586.293093740199,
    "2025-06-18": 591.5889084239012,
    "2025-06-19": 596.8847231076035,
    "2025-06-20": 602.1805377913057,
    "2025-06-21": 607.4763524750081,
    "2025-06-22": 612.7721671587103,
    "2025-06-23": 618.0679818424126,
    "2025-06-24": 623.3637965261148,
    "2025-06-25": 628.6596112098171,
    "2025-06-26": 633.9554258935193,
    "2025-06-27": 639.2512405772216,
    "2025-06-28": 644.5470552609238,
    "2025-06-29": 649.842869944626,
    "2025-06-30": 655.1386846283283,
    "2025-07-01": 660.9277380853154,
    "2025-07-02": 666.7167915423024,
    "2025-07-03": 672.5058449992894,
    "2025-07-04": 678.2948984562764,
    "2025-07-05": 684.0839519132635,
    "2025-07-06": 689.8730053702506,
    "2025-07-07": 695.6620588272375,
    "2025-07-08": 701.4511122842246,
    "2025-07-09": 707.2401657412116,
    "2025-07-10": 713.0292191981987,
    "2025-07-11": 718.8182726551856,
    "2025-07-12": 724.6073261121727,
    "2025-07-13": 730.3963795691598,
    "2025-07-14": 736.1854330261468,
    "2025-07-15": 741.9744864831339,
    "2025-07-16": 747.7635399401208,
    "2025-07-17": 753.5525933971079,
    "2025-07-18": 759.341646854095,
    "2025-07-19": 765.130700311082,
    "2025-07-20": 770.9197537680691,
    "2025-07-21": 776.708807225056,
    "2025-07-22": 782.4978606820431,
    "2025-07-23": 788.2869141390302,
    "2025-07-24": 794.0759675960171,
    "2025-07-25": 799.8650210530042,
    "2025-07-26": 805.6540745099912,
    "2025-07-27": 811.4431279669783,
    "2025-07-28": 817.2321814239654,
    "2025-07-29": 823.0212348809523,
    "2025-07-30": 828.8102883379394,
    "2025-07-31": 834.5993417949264,
    "2025-08-01": 839.2541204609054,
    "2025-08-02": 843.9088991268843,
    "2025-08-03": 848.5636777928632,
    "2025-08-04": 853.2184564588422,
    "2025-08-05": 857.8732351248211,
    "2025-08-06": 862.5280137908001,
    "2025-08-07": 867.182792456779,
    "2025-08-08": 871.8375711227579,
    "2025-08-09": 876.4923497887369,
    "2025-08-10": 881.1471284547158,
    "2025-08-11": 885.8019071206948,
    "2025-08-12": 890.4566857866737,
    "2025-08-13": 895.1114644526526,
    "2025-08-14": 899.7662431186316,
    "2025-08-15": 904.4210217846104,
    "2025-08-16": 909.0758004505894,
    "2025-08-17": 913.7305791165684,
    "2025-08-18": 918.3853577825472,
    "2025-08-19": 923.040136448526,
    "2025-08-20": 927.6949151145052,
    "2025-08-21": 932.349693780484,
    "2025-08-22": 937.004472446463,
    "2025-08-23": 941.659251112442,
    "2025-08-24": 946.3140297784208,
    "2025-08-25": 950.9688084443998,
    "2025-08-26": 955.6235871103788,
    "2025-08-27": 960.2783657763576,
    "2025-08-28": 964.9331444423366,
    "2025-08-29": 969.5879231083156,
    "2025-08-30": 974.2427017742943,
    "2025-08-31": 978.8974804402734,
    "2025-09-01": 982.3299124877994,
    "2025-09-02": 985.7623445353256,
    "2025-09-03": 989.1947765828515,
    "2025-09-04": 992.6272086303776,
    "2025-09-05": 996.0596406779036,
    "2025-09-06": 999.4920727254296,
    "2025-09-07": 1002.9245047729556,
    "2025-09-08": 1006.3569368204816,
    "2025-09-09": 1009.7893688680076,
    "2025-09-10": 1013.2218009155338,
    "2025-09-11": 1016.6542329630598,
    "2025-09-12": 1020.086665010586,
    "2025-09-13": 1023.519097058112,
    "2025-09-14": 1026.951529105638,
    "2025-09-15": 1030.383961153164,
    "2025-09-16": 1033.81639320069,
    "2025-09-17": 1037.248825248216,
    "2025-09-18": 1040.6812572957422,
    "2025-09-19": 1044.113689343268,
    "2025-09-20": 1047.5461213907945,
    "2025-09-21": 1050.9785534383202,
    "2025-09-22": 1054.410985485846,
    "2025-09-23": 1057.8434175333723,
    "2025-09-24": 1061.2758495808982,
    "2025-09-25": 1064.7082816284244,
    "2025-09-26": 1068.1407136759503,
    "2025-09-27": 1071.5731457234765,
    "2025-09-28": 1075.0055777710024,
    "2025-09-29": 1078.4380098185284,
    "2025-09-30": 1081.8704418660543,
  },
  Apricots: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.295345600886839,
    "2024-10-03": 4.590691201773678,
    "2024-10-04": 6.886036802660517,
    "2024-10-05": 9.181382403547357,
    "2024-10-06": 11.476728004434197,
    "2024-10-07": 13.772073605321037,
    "2024-10-08": 16.067419206207873,
    "2024-10-09": 18.362764807094717,
    "2024-10-10": 20.658110407981557,
    "2024-10-11": 22.953456008868397,
    "2024-10-12": 25.24880160975523,
    "2024-10-13": 27.54414721064207,
    "2024-10-14": 29.83949281152891,
    "2024-10-15": 32.134838412415746,
    "2024-10-16": 34.430184013302586,
    "2024-10-17": 36.72552961418943,
    "2024-10-18": 39.020875215076266,
    "2024-10-19": 41.31622081596311,
    "2024-10-20": 43.611566416849946,
    "2024-10-21": 45.90691201773679,
    "2024-10-22": 48.20225761862362,
    "2024-10-23": 50.49760321951046,
    "2024-10-24": 52.7929488203973,
    "2024-10-25": 55.08829442128414,
    "2024-10-26": 57.38364002217098,
    "2024-10-27": 59.67898562305782,
    "2024-10-28": 61.97433122394466,
    "2024-10-29": 64.26967682483149,
    "2024-10-30": 66.56502242571834,
    "2024-10-31": 68.86036802660517,
    "2024-11-01": 69.59532564822499,
    "2024-11-02": 70.3302832698448,
    "2024-11-03": 71.06524089146461,
    "2024-11-04": 71.80019851308444,
    "2024-11-05": 72.53515613470425,
    "2024-11-06": 73.27011375632406,
    "2024-11-07": 74.00507137794388,
    "2024-11-08": 74.74002899956369,
    "2024-11-09": 75.4749866211835,
    "2024-11-10": 76.20994424280332,
    "2024-11-11": 76.94490186442314,
    "2024-11-12": 77.67985948604296,
    "2024-11-13": 78.41481710766277,
    "2024-11-14": 79.14977472928258,
    "2024-11-15": 79.8847323509024,
    "2024-11-16": 80.61968997252221,
    "2024-11-17": 81.35464759414202,
    "2024-11-18": 82.08960521576184,
    "2024-11-19": 82.82456283738165,
    "2024-11-20": 83.55952045900148,
    "2024-11-21": 84.29447808062129,
    "2024-11-22": 85.0294357022411,
    "2024-11-23": 85.76439332386092,
    "2024-11-24": 86.49935094548073,
    "2024-11-25": 87.23430856710054,
    "2024-11-26": 87.96926618872035,
    "2024-11-27": 88.70422381034018,
    "2024-11-28": 89.43918143196,
    "2024-11-29": 90.1741390535798,
    "2024-11-30": 90.90909667519962,
    "2024-12-01": 91.25938316798828,
    "2024-12-02": 91.60966966077694,
    "2024-12-03": 91.9599561535656,
    "2024-12-04": 92.31024264635428,
    "2024-12-05": 92.66052913914294,
    "2024-12-06": 93.0108156319316,
    "2024-12-07": 93.36110212472026,
    "2024-12-08": 93.71138861750892,
    "2024-12-09": 94.0616751102976,
    "2024-12-10": 94.41196160308624,
    "2024-12-11": 94.76224809587492,
    "2024-12-12": 95.11253458866358,
    "2024-12-13": 95.46282108145223,
    "2024-12-14": 95.81310757424092,
    "2024-12-15": 96.16339406702956,
    "2024-12-16": 96.51368055981824,
    "2024-12-17": 96.8639670526069,
    "2024-12-18": 97.21425354539556,
    "2024-12-19": 97.56454003818423,
    "2024-12-20": 97.91482653097287,
    "2024-12-21": 98.26511302376156,
    "2024-12-22": 98.6153995165502,
    "2024-12-23": 98.96568600933888,
    "2024-12-24": 99.31597250212756,
    "2024-12-25": 99.6662589949162,
    "2024-12-26": 100.01654548770487,
    "2024-12-27": 100.36683198049354,
    "2024-12-28": 100.7171184732822,
    "2024-12-29": 101.06740496607088,
    "2024-12-30": 101.41769145885952,
    "2024-12-31": 101.7679779516482,
    "2025-01-01": 102.3730224625416,
    "2025-01-02": 102.97806697343503,
    "2025-01-03": 103.58311148432846,
    "2025-01-04": 104.18815599522188,
    "2025-01-05": 104.7932005061153,
    "2025-01-06": 105.39824501700872,
    "2025-01-07": 106.00328952790214,
    "2025-01-08": 106.60833403879556,
    "2025-01-09": 107.21337854968898,
    "2025-01-10": 107.8184230605824,
    "2025-01-11": 108.42346757147584,
    "2025-01-12": 109.02851208236925,
    "2025-01-13": 109.63355659326268,
    "2025-01-14": 110.23860110415607,
    "2025-01-15": 110.84364561504952,
    "2025-01-16": 111.44869012594292,
    "2025-01-17": 112.05373463683635,
    "2025-01-18": 112.65877914772976,
    "2025-01-19": 113.2638236586232,
    "2025-01-20": 113.86886816951665,
    "2025-01-21": 114.47391268041004,
    "2025-01-22": 115.07895719130347,
    "2025-01-23": 115.6840017021969,
    "2025-01-24": 116.28904621309032,
    "2025-01-25": 116.89409072398374,
    "2025-01-26": 117.49913523487716,
    "2025-01-27": 118.10417974577058,
    "2025-01-28": 118.709224256664,
    "2025-01-29": 119.31426876755742,
    "2025-01-30": 119.91931327845084,
    "2025-01-31": 120.52435778934426,
    "2025-02-01": 121.6238266485432,
    "2025-02-02": 122.72329550774217,
    "2025-02-03": 123.82276436694112,
    "2025-02-04": 124.92223322614008,
    "2025-02-05": 126.02170208533904,
    "2025-02-06": 127.12117094453798,
    "2025-02-07": 128.22063980373693,
    "2025-02-08": 129.3201086629359,
    "2025-02-09": 130.41957752213483,
    "2025-02-10": 131.5190463813338,
    "2025-02-11": 132.61851524053276,
    "2025-02-12": 133.7179840997317,
    "2025-02-13": 134.81745295893066,
    "2025-02-14": 135.9169218181296,
    "2025-02-15": 137.01639067732856,
    "2025-02-16": 138.11585953652752,
    "2025-02-17": 139.21532839572646,
    "2025-02-18": 140.31479725492542,
    "2025-02-19": 141.4142661141244,
    "2025-02-20": 142.51373497332332,
    "2025-02-21": 143.6132038325223,
    "2025-02-22": 144.71267269172122,
    "2025-02-23": 145.8121415509202,
    "2025-02-24": 146.91161041011915,
    "2025-02-25": 148.0110792693181,
    "2025-02-26": 149.11054812851705,
    "2025-02-27": 150.21001698771602,
    "2025-02-28": 151.30948584691495,
    "2025-03-01": 153.34099154295248,
    "2025-03-02": 155.37249723899,
    "2025-03-03": 157.40400293502756,
    "2025-03-04": 159.4355086310651,
    "2025-03-05": 161.46701432710262,
    "2025-03-06": 163.49852002314014,
    "2025-03-07": 165.53002571917767,
    "2025-03-08": 167.56153141521523,
    "2025-03-09": 169.59303711125276,
    "2025-03-10": 171.62454280729028,
    "2025-03-11": 173.6560485033278,
    "2025-03-12": 175.68755419936537,
    "2025-03-13": 177.7190598954029,
    "2025-03-14": 179.75056559144042,
    "2025-03-15": 181.78207128747795,
    "2025-03-16": 183.81357698351547,
    "2025-03-17": 185.84508267955303,
    "2025-03-18": 187.87658837559056,
    "2025-03-19": 189.90809407162808,
    "2025-03-20": 191.93959976766564,
    "2025-03-21": 193.9711054637032,
    "2025-03-22": 196.0026111597407,
    "2025-03-23": 198.03411685577825,
    "2025-03-24": 200.06562255181572,
    "2025-03-25": 202.09712824785328,
    "2025-03-26": 204.12863394389083,
    "2025-03-27": 206.1601396399284,
    "2025-03-28": 208.1916453359659,
    "2025-03-29": 210.2231510320034,
    "2025-03-30": 212.25465672804097,
    "2025-03-31": 214.2861624240785,
    "2025-04-01": 218.0992005507061,
    "2025-04-02": 221.9122386773337,
    "2025-04-03": 225.7252768039613,
    "2025-04-04": 229.5383149305889,
    "2025-04-05": 233.35135305721653,
    "2025-04-06": 237.1643911838441,
    "2025-04-07": 240.9774293104717,
    "2025-04-08": 244.79046743709927,
    "2025-04-09": 248.6035055637269,
    "2025-04-10": 252.41654369035453,
    "2025-04-11": 256.22958181698215,
    "2025-04-12": 260.04261994360974,
    "2025-04-13": 263.8556580702374,
    "2025-04-14": 267.66869619686497,
    "2025-04-15": 271.48173432349256,
    "2025-04-16": 275.2947724501201,
    "2025-04-17": 279.10781057674774,
    "2025-04-18": 282.9208487033754,
    "2025-04-19": 286.733886830003,
    "2025-04-20": 290.54692495663056,
    "2025-04-21": 294.3599630832582,
    "2025-04-22": 298.1730012098858,
    "2025-04-23": 301.9860393365134,
    "2025-04-24": 305.799077463141,
    "2025-04-25": 309.6121155897686,
    "2025-04-26": 313.4251537163962,
    "2025-04-27": 317.2381918430238,
    "2025-04-28": 321.05122996965144,
    "2025-04-29": 324.86426809627903,
    "2025-04-30": 328.6773062229066,
    "2025-05-01": 333.674540998901,
    "2025-05-02": 338.6717757748954,
    "2025-05-03": 343.6690105508899,
    "2025-05-04": 348.6662453268843,
    "2025-05-05": 353.6634801028787,
    "2025-05-06": 358.6607148788731,
    "2025-05-07": 363.6579496548675,
    "2025-05-08": 368.65518443086194,
    "2025-05-09": 373.65241920685634,
    "2025-05-10": 378.64965398285074,
    "2025-05-11": 383.64688875884514,
    "2025-05-12": 388.6441235348396,
    "2025-05-13": 393.641358310834,
    "2025-05-14": 398.6385930868284,
    "2025-05-15": 403.6358278628228,
    "2025-05-16": 408.6330626388173,
    "2025-05-17": 413.6302974148117,
    "2025-05-18": 418.6275321908061,
    "2025-05-19": 423.6247669668005,
    "2025-05-20": 428.6220017427949,
    "2025-05-21": 433.6192365187893,
    "2025-05-22": 438.6164712947837,
    "2025-05-23": 443.6137060707781,
    "2025-05-24": 448.6109408467725,
    "2025-05-25": 453.6081756227669,
    "2025-05-26": 458.60541039876136,
    "2025-05-27": 463.60264517475576,
    "2025-05-28": 468.59987995075016,
    "2025-05-29": 473.5971147267446,
    "2025-05-30": 478.59434950273896,
    "2025-05-31": 483.5915842787334,
    "2025-06-01": 489.6198382150736,
    "2025-06-02": 495.6480921514137,
    "2025-06-03": 501.6763460877539,
    "2025-06-04": 507.7046000240941,
    "2025-06-05": 513.7328539604342,
    "2025-06-06": 519.7611078967744,
    "2025-06-07": 525.7893618331145,
    "2025-06-08": 531.8176157694547,
    "2025-06-09": 537.8458697057948,
    "2025-06-10": 543.874123642135,
    "2025-06-11": 549.9023775784752,
    "2025-06-12": 555.9306315148153,
    "2025-06-13": 561.9588854511555,
    "2025-06-14": 567.9871393874956,
    "2025-06-15": 574.0153933238358,
    "2025-06-16": 580.043647260176,
    "2025-06-17": 586.0719011965161,
    "2025-06-18": 592.1001551328563,
    "2025-06-19": 598.1284090691964,
    "2025-06-20": 604.1566630055366,
    "2025-06-21": 610.1849169418768,
    "2025-06-22": 616.2131708782169,
    "2025-06-23": 622.2414248145571,
    "2025-06-24": 628.2696787508974,
    "2025-06-25": 634.2979326872374,
    "2025-06-26": 640.3261866235777,
    "2025-06-27": 646.3544405599177,
    "2025-06-28": 652.382694496258,
    "2025-06-29": 658.4109484325982,
    "2025-06-30": 664.4392023689383,
    "2025-07-01": 670.5381033008094,
    "2025-07-02": 676.6370042326806,
    "2025-07-03": 682.7359051645518,
    "2025-07-04": 688.834806096423,
    "2025-07-05": 694.9337070282942,
    "2025-07-06": 701.0326079601654,
    "2025-07-07": 707.1315088920365,
    "2025-07-08": 713.2304098239076,
    "2025-07-09": 719.3293107557788,
    "2025-07-10": 725.42821168765,
    "2025-07-11": 731.5271126195212,
    "2025-07-12": 737.6260135513924,
    "2025-07-13": 743.7249144832635,
    "2025-07-14": 749.8238154151347,
    "2025-07-15": 755.9227163470059,
    "2025-07-16": 762.0216172788771,
    "2025-07-17": 768.1205182107483,
    "2025-07-18": 774.2194191426195,
    "2025-07-19": 780.3183200744907,
    "2025-07-20": 786.4172210063618,
    "2025-07-21": 792.516121938233,
    "2025-07-22": 798.6150228701042,
    "2025-07-23": 804.7139238019754,
    "2025-07-24": 810.8128247338466,
    "2025-07-25": 816.9117256657178,
    "2025-07-26": 823.010626597589,
    "2025-07-27": 829.10952752946,
    "2025-07-28": 835.2084284613312,
    "2025-07-29": 841.3073293932024,
    "2025-07-30": 847.4062303250736,
    "2025-07-31": 853.5051312569448,
    "2025-08-01": 858.4562138762324,
    "2025-08-02": 863.4072964955201,
    "2025-08-03": 868.3583791148077,
    "2025-08-04": 873.3094617340953,
    "2025-08-05": 878.2605443533829,
    "2025-08-06": 883.2116269726706,
    "2025-08-07": 888.1627095919582,
    "2025-08-08": 893.1137922112458,
    "2025-08-09": 898.0648748305334,
    "2025-08-10": 903.0159574498211,
    "2025-08-11": 907.9670400691087,
    "2025-08-12": 912.9181226883964,
    "2025-08-13": 917.869205307684,
    "2025-08-14": 922.8202879269716,
    "2025-08-15": 927.7713705462592,
    "2025-08-16": 932.7224531655468,
    "2025-08-17": 937.6735357848344,
    "2025-08-18": 942.6246184041222,
    "2025-08-19": 947.5757010234098,
    "2025-08-20": 952.5267836426974,
    "2025-08-21": 957.477866261985,
    "2025-08-22": 962.4289488812728,
    "2025-08-23": 967.3800315005604,
    "2025-08-24": 972.331114119848,
    "2025-08-25": 977.2821967391357,
    "2025-08-26": 982.2332793584231,
    "2025-08-27": 987.1843619777108,
    "2025-08-28": 992.1354445969984,
    "2025-08-29": 997.0865272162862,
    "2025-08-30": 1002.0376098355738,
    "2025-08-31": 1006.9886924548614,
    "2025-09-01": 1010.6297755124062,
    "2025-09-02": 1014.2708585699512,
    "2025-09-03": 1017.911941627496,
    "2025-09-04": 1021.5530246850408,
    "2025-09-05": 1025.1941077425856,
    "2025-09-06": 1028.8351908001305,
    "2025-09-07": 1032.476273857675,
    "2025-09-08": 1036.1173569152202,
    "2025-09-09": 1039.758439972765,
    "2025-09-10": 1043.39952303031,
    "2025-09-11": 1047.0406060878547,
    "2025-09-12": 1050.6816891453996,
    "2025-09-13": 1054.3227722029444,
    "2025-09-14": 1057.9638552604893,
    "2025-09-15": 1061.604938318034,
    "2025-09-16": 1065.246021375579,
    "2025-09-17": 1068.8871044331238,
    "2025-09-18": 1072.5281874906686,
    "2025-09-19": 1076.1692705482135,
    "2025-09-20": 1079.8103536057583,
    "2025-09-21": 1083.4514366633032,
    "2025-09-22": 1087.092519720848,
    "2025-09-23": 1090.7336027783929,
    "2025-09-24": 1094.3746858359375,
    "2025-09-25": 1098.0157688934826,
    "2025-09-26": 1101.6568519510274,
    "2025-09-27": 1105.2979350085725,
    "2025-09-28": 1108.9390180661171,
    "2025-09-29": 1112.580101123662,
    "2025-09-30": 1116.2211841812068,
  },
  Cherries: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.4959755629208757,
    "2024-10-03": 4.991951125841751,
    "2024-10-04": 7.4879266887626255,
    "2024-10-05": 9.9839022516835,
    "2024-10-06": 12.479877814604375,
    "2024-10-07": 14.975853377525253,
    "2024-10-08": 17.471828940446127,
    "2024-10-09": 19.967804503367,
    "2024-10-10": 22.46378006628788,
    "2024-10-11": 24.959755629208757,
    "2024-10-12": 27.45573119212963,
    "2024-10-13": 29.951706755050505,
    "2024-10-14": 32.44768231797138,
    "2024-10-15": 34.94365788089225,
    "2024-10-16": 37.43963344381313,
    "2024-10-17": 39.935609006734005,
    "2024-10-18": 42.43158456965488,
    "2024-10-19": 44.92756013257576,
    "2024-10-20": 47.42353569549663,
    "2024-10-21": 49.91951125841751,
    "2024-10-22": 52.41548682133838,
    "2024-10-23": 54.91146238425926,
    "2024-10-24": 57.407437947180135,
    "2024-10-25": 59.90341351010101,
    "2024-10-26": 62.39938907302188,
    "2024-10-27": 64.89536463594276,
    "2024-10-28": 67.39134019886363,
    "2024-10-29": 69.8873157617845,
    "2024-10-30": 72.38329132470538,
    "2024-10-31": 74.87926688762626,
    "2024-11-01": 75.78058678024648,
    "2024-11-02": 76.68190667286669,
    "2024-11-03": 77.58322656548691,
    "2024-11-04": 78.48454645810713,
    "2024-11-05": 79.38586635072735,
    "2024-11-06": 80.28718624334756,
    "2024-11-07": 81.18850613596778,
    "2024-11-08": 82.089826028588,
    "2024-11-09": 82.99114592120821,
    "2024-11-10": 83.89246581382844,
    "2024-11-11": 84.79378570644866,
    "2024-11-12": 85.69510559906888,
    "2024-11-13": 86.59642549168909,
    "2024-11-14": 87.49774538430931,
    "2024-11-15": 88.39906527692952,
    "2024-11-16": 89.30038516954974,
    "2024-11-17": 90.20170506216996,
    "2024-11-18": 91.1030249547902,
    "2024-11-19": 92.0043448474104,
    "2024-11-20": 92.90566474003062,
    "2024-11-21": 93.80698463265084,
    "2024-11-22": 94.70830452527105,
    "2024-11-23": 95.60962441789128,
    "2024-11-24": 96.51094431051148,
    "2024-11-25": 97.41226420313173,
    "2024-11-26": 98.31358409575192,
    "2024-11-27": 99.21490398837214,
    "2024-11-28": 100.11622388099237,
    "2024-11-29": 101.01754377361256,
    "2024-11-30": 101.9188636662328,
    "2024-12-01": 102.37253498767572,
    "2024-12-02": 102.82620630911867,
    "2024-12-03": 103.2798776305616,
    "2024-12-04": 103.73354895200454,
    "2024-12-05": 104.18722027344748,
    "2024-12-06": 104.64089159489042,
    "2024-12-07": 105.09456291633336,
    "2024-12-08": 105.5482342377763,
    "2024-12-09": 106.00190555921924,
    "2024-12-10": 106.45557688066218,
    "2024-12-11": 106.90924820210512,
    "2024-12-12": 107.36291952354804,
    "2024-12-13": 107.81659084499098,
    "2024-12-14": 108.27026216643392,
    "2024-12-15": 108.72393348787686,
    "2024-12-16": 109.1776048093198,
    "2024-12-17": 109.63127613076274,
    "2024-12-18": 110.08494745220568,
    "2024-12-19": 110.5386187736486,
    "2024-12-20": 110.99229009509156,
    "2024-12-21": 111.44596141653447,
    "2024-12-22": 111.89963273797744,
    "2024-12-23": 112.35330405942037,
    "2024-12-24": 112.8069753808633,
    "2024-12-25": 113.26064670230625,
    "2024-12-26": 113.7143180237492,
    "2024-12-27": 114.16798934519213,
    "2024-12-28": 114.62166066663504,
    "2024-12-29": 115.075331988078,
    "2024-12-30": 115.52900330952092,
    "2024-12-31": 115.98267463096388,
    "2025-01-01": 116.7826305345001,
    "2025-01-02": 117.58258643803632,
    "2025-01-03": 118.38254234157256,
    "2025-01-04": 119.1824982451088,
    "2025-01-05": 119.98245414864502,
    "2025-01-06": 120.78241005218123,
    "2025-01-07": 121.58236595571748,
    "2025-01-08": 122.38232185925372,
    "2025-01-09": 123.18227776278994,
    "2025-01-10": 123.98223366632617,
    "2025-01-11": 124.7821895698624,
    "2025-01-12": 125.58214547339864,
    "2025-01-13": 126.38210137693486,
    "2025-01-14": 127.18205728047108,
    "2025-01-15": 127.98201318400731,
    "2025-01-16": 128.78196908754353,
    "2025-01-17": 129.58192499107977,
    "2025-01-18": 130.38188089461602,
    "2025-01-19": 131.18183679815223,
    "2025-01-20": 131.98179270168845,
    "2025-01-21": 132.7817486052247,
    "2025-01-22": 133.58170450876094,
    "2025-01-23": 134.38166041229715,
    "2025-01-24": 135.18161631583337,
    "2025-01-25": 135.9815722193696,
    "2025-01-26": 136.78152812290585,
    "2025-01-27": 137.58148402644207,
    "2025-01-28": 138.38143992997828,
    "2025-01-29": 139.18139583351453,
    "2025-01-30": 139.98135173705077,
    "2025-01-31": 140.781307640587,
    "2025-02-01": 142.0070351730754,
    "2025-02-02": 143.23276270556383,
    "2025-02-03": 144.45849023805224,
    "2025-02-04": 145.68421777054067,
    "2025-02-05": 146.90994530302908,
    "2025-02-06": 148.1356728355175,
    "2025-02-07": 149.36140036800592,
    "2025-02-08": 150.58712790049432,
    "2025-02-09": 151.81285543298276,
    "2025-02-10": 153.03858296547116,
    "2025-02-11": 154.2643104979596,
    "2025-02-12": 155.490038030448,
    "2025-02-13": 156.71576556293644,
    "2025-02-14": 157.94149309542485,
    "2025-02-15": 159.16722062791325,
    "2025-02-16": 160.3929481604017,
    "2025-02-17": 161.6186756928901,
    "2025-02-18": 162.84440322537853,
    "2025-02-19": 164.0701307578669,
    "2025-02-20": 165.29585829035537,
    "2025-02-21": 166.52158582284378,
    "2025-02-22": 167.7473133553322,
    "2025-02-23": 168.97304088782062,
    "2025-02-24": 170.19876842030902,
    "2025-02-25": 171.42449595279746,
    "2025-02-26": 172.65022348528586,
    "2025-02-27": 173.8759510177743,
    "2025-02-28": 175.1016785502627,
    "2025-03-01": 177.10449398782572,
    "2025-03-02": 179.1073094253887,
    "2025-03-03": 181.1101248629517,
    "2025-03-04": 183.1129403005147,
    "2025-03-05": 185.11575573807767,
    "2025-03-06": 187.11857117564077,
    "2025-03-07": 189.12138661320373,
    "2025-03-08": 191.12420205076677,
    "2025-03-09": 193.12701748832973,
    "2025-03-10": 195.12983292589277,
    "2025-03-11": 197.13264836345576,
    "2025-03-12": 199.13546380101877,
    "2025-03-13": 201.13827923858176,
    "2025-03-14": 203.14109467614475,
    "2025-03-15": 205.14391011370776,
    "2025-03-16": 207.1467255512708,
    "2025-03-17": 209.14954098883376,
    "2025-03-18": 211.1523564263968,
    "2025-03-19": 213.15517186395977,
    "2025-03-20": 215.1579873015228,
    "2025-03-21": 217.1608027390858,
    "2025-03-22": 219.1636181766488,
    "2025-03-23": 221.1664336142118,
    "2025-03-24": 223.1692490517748,
    "2025-03-25": 225.1720644893378,
    "2025-03-26": 227.1748799269008,
    "2025-03-27": 229.17769536446383,
    "2025-03-28": 231.1805108020268,
    "2025-03-29": 233.18332623958983,
    "2025-03-30": 235.1861416771528,
    "2025-03-31": 237.18895711471583,
    "2025-04-01": 241.18099174873524,
    "2025-04-02": 245.1730263827546,
    "2025-04-03": 249.165061016774,
    "2025-04-04": 253.1570956507934,
    "2025-04-05": 257.1491302848128,
    "2025-04-06": 261.1411649188322,
    "2025-04-07": 265.1331995528516,
    "2025-04-08": 269.1252341868709,
    "2025-04-09": 273.1172688208904,
    "2025-04-10": 277.10930345490976,
    "2025-04-11": 281.10133808892914,
    "2025-04-12": 285.0933727229485,
    "2025-04-13": 289.08540735696795,
    "2025-04-14": 293.0774419909873,
    "2025-04-15": 297.0694766250067,
    "2025-04-16": 301.06151125902613,
    "2025-04-17": 305.0535458930455,
    "2025-04-18": 309.0455805270649,
    "2025-04-19": 313.0376151610843,
    "2025-04-20": 317.0296497951037,
    "2025-04-21": 321.02168442912307,
    "2025-04-22": 325.0137190631425,
    "2025-04-23": 329.0057536971619,
    "2025-04-24": 332.99778833118125,
    "2025-04-25": 336.9898229652007,
    "2025-04-26": 340.98185759922006,
    "2025-04-27": 344.97389223323944,
    "2025-04-28": 348.9659268672588,
    "2025-04-29": 352.9579615012782,
    "2025-04-30": 356.9499961352976,
    "2025-05-01": 361.8671003377061,
    "2025-05-02": 366.7842045401147,
    "2025-05-03": 371.7013087425232,
    "2025-05-04": 376.61841294493166,
    "2025-05-05": 381.5355171473402,
    "2025-05-06": 386.4526213497487,
    "2025-05-07": 391.3697255521572,
    "2025-05-08": 396.2868297545657,
    "2025-05-09": 401.2039339569743,
    "2025-05-10": 406.1210381593828,
    "2025-05-11": 411.0381423617912,
    "2025-05-12": 415.9552465641998,
    "2025-05-13": 420.8723507666083,
    "2025-05-14": 425.7894549690168,
    "2025-05-15": 430.7065591714253,
    "2025-05-16": 435.6236633738338,
    "2025-05-17": 440.54076757624233,
    "2025-05-18": 445.4578717786508,
    "2025-05-19": 450.3749759810594,
    "2025-05-20": 455.2920801834679,
    "2025-05-21": 460.2091843858764,
    "2025-05-22": 465.12628858828486,
    "2025-05-23": 470.0433927906934,
    "2025-05-24": 474.9604969931019,
    "2025-05-25": 479.87760119551047,
    "2025-05-26": 484.79470539791896,
    "2025-05-27": 489.71180960032746,
    "2025-05-28": 494.628913802736,
    "2025-05-29": 499.5460180051445,
    "2025-05-30": 504.463122207553,
    "2025-05-31": 509.3802264099615,
    "2025-06-01": 515.4145331389632,
    "2025-06-02": 521.4488398679649,
    "2025-06-03": 527.4831465969665,
    "2025-06-04": 533.5174533259683,
    "2025-06-05": 539.55176005497,
    "2025-06-06": 545.5860667839717,
    "2025-06-07": 551.6203735129734,
    "2025-06-08": 557.654680241975,
    "2025-06-09": 563.6889869709768,
    "2025-06-10": 569.7232936999785,
    "2025-06-11": 575.7576004289801,
    "2025-06-12": 581.7919071579819,
    "2025-06-13": 587.8262138869836,
    "2025-06-14": 593.8605206159853,
    "2025-06-15": 599.894827344987,
    "2025-06-16": 605.9291340739886,
    "2025-06-17": 611.9634408029904,
    "2025-06-18": 617.9977475319921,
    "2025-06-19": 624.0320542609937,
    "2025-06-20": 630.0663609899955,
    "2025-06-21": 636.1006677189971,
    "2025-06-22": 642.1349744479988,
    "2025-06-23": 648.1692811770006,
    "2025-06-24": 654.2035879060022,
    "2025-06-25": 660.237894635004,
    "2025-06-26": 666.2722013640057,
    "2025-06-27": 672.3065080930073,
    "2025-06-28": 678.3408148220091,
    "2025-06-29": 684.3751215510108,
    "2025-06-30": 690.4094282800124,
    "2025-07-01": 696.6317324199774,
    "2025-07-02": 702.8540365599423,
    "2025-07-03": 709.0763406999073,
    "2025-07-04": 715.2986448398723,
    "2025-07-05": 721.5209489798373,
    "2025-07-06": 727.7432531198021,
    "2025-07-07": 733.9655572597671,
    "2025-07-08": 740.1878613997321,
    "2025-07-09": 746.410165539697,
    "2025-07-10": 752.632469679662,
    "2025-07-11": 758.854773819627,
    "2025-07-12": 765.0770779595919,
    "2025-07-13": 771.2993820995569,
    "2025-07-14": 777.5216862395218,
    "2025-07-15": 783.7439903794868,
    "2025-07-16": 789.9662945194517,
    "2025-07-17": 796.1885986594167,
    "2025-07-18": 802.4109027993817,
    "2025-07-19": 808.6332069393466,
    "2025-07-20": 814.8555110793116,
    "2025-07-21": 821.0778152192765,
    "2025-07-22": 827.3001193592415,
    "2025-07-23": 833.5224234992064,
    "2025-07-24": 839.7447276391714,
    "2025-07-25": 845.9670317791364,
    "2025-07-26": 852.1893359191013,
    "2025-07-27": 858.4116400590663,
    "2025-07-28": 864.6339441990312,
    "2025-07-29": 870.8562483389962,
    "2025-07-30": 877.0785524789611,
    "2025-07-31": 883.3008566189261,
    "2025-08-01": 888.198766788677,
    "2025-08-02": 893.0966769584278,
    "2025-08-03": 897.9945871281788,
    "2025-08-04": 902.8924972979296,
    "2025-08-05": 907.7904074676804,
    "2025-08-06": 912.6883176374312,
    "2025-08-07": 917.586227807182,
    "2025-08-08": 922.4841379769332,
    "2025-08-09": 927.382048146684,
    "2025-08-10": 932.2799583164348,
    "2025-08-11": 937.1778684861856,
    "2025-08-12": 942.0757786559363,
    "2025-08-13": 946.9736888256874,
    "2025-08-14": 951.8715989954384,
    "2025-08-15": 956.7695091651892,
    "2025-08-16": 961.66741933494,
    "2025-08-17": 966.5653295046908,
    "2025-08-18": 971.4632396744416,
    "2025-08-19": 976.3611498441926,
    "2025-08-20": 981.2590600139434,
    "2025-08-21": 986.1569701836944,
    "2025-08-22": 991.0548803534452,
    "2025-08-23": 995.952790523196,
    "2025-08-24": 1000.8507006929468,
    "2025-08-25": 1005.7486108626978,
    "2025-08-26": 1010.6465210324486,
    "2025-08-27": 1015.5444312021996,
    "2025-08-28": 1020.4423413719504,
    "2025-08-29": 1025.3402515417013,
    "2025-08-30": 1030.238161711452,
    "2025-08-31": 1035.136071881203,
    "2025-09-01": 1038.9864189812058,
    "2025-09-02": 1042.836766081209,
    "2025-09-03": 1046.6871131812115,
    "2025-09-04": 1050.5374602812144,
    "2025-09-05": 1054.3878073812173,
    "2025-09-06": 1058.23815448122,
    "2025-09-07": 1062.088501581223,
    "2025-09-08": 1065.938848681226,
    "2025-09-09": 1069.7891957812287,
    "2025-09-10": 1073.6395428812316,
    "2025-09-11": 1077.4898899812345,
    "2025-09-12": 1081.340237081237,
    "2025-09-13": 1085.1905841812402,
    "2025-09-14": 1089.040931281243,
    "2025-09-15": 1092.891278381246,
    "2025-09-16": 1096.7416254812488,
    "2025-09-17": 1100.5919725812516,
    "2025-09-18": 1104.4423196812545,
    "2025-09-19": 1108.2926667812574,
    "2025-09-20": 1112.1430138812602,
    "2025-09-21": 1115.993360981263,
    "2025-09-22": 1119.843708081266,
    "2025-09-23": 1123.6940551812688,
    "2025-09-24": 1127.5444022812717,
    "2025-09-25": 1131.3947493812746,
    "2025-09-26": 1135.2450964812774,
    "2025-09-27": 1139.0954435812805,
    "2025-09-28": 1142.9457906812831,
    "2025-09-29": 1146.796137781286,
    "2025-09-30": 1150.6464848812889,
  },
  Citrus: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.141252947033848,
    "2024-10-03": 4.282505894067696,
    "2024-10-04": 6.423758841101543,
    "2024-10-05": 8.565011788135392,
    "2024-10-06": 10.70626473516924,
    "2024-10-07": 12.847517682203089,
    "2024-10-08": 14.988770629236935,
    "2024-10-09": 17.130023576270784,
    "2024-10-10": 19.271276523304632,
    "2024-10-11": 21.41252947033848,
    "2024-10-12": 23.55378241737233,
    "2024-10-13": 25.695035364406174,
    "2024-10-14": 27.836288311440025,
    "2024-10-15": 29.97754125847387,
    "2024-10-16": 32.11879420550772,
    "2024-10-17": 34.26004715254157,
    "2024-10-18": 36.401300099575415,
    "2024-10-19": 38.542553046609264,
    "2024-10-20": 40.68380599364311,
    "2024-10-21": 42.82505894067696,
    "2024-10-22": 44.96631188771081,
    "2024-10-23": 47.10756483474466,
    "2024-10-24": 49.248817781778506,
    "2024-10-25": 51.39007072881235,
    "2024-10-26": 53.5313236758462,
    "2024-10-27": 55.67257662288005,
    "2024-10-28": 57.81382956991389,
    "2024-10-29": 59.95508251694774,
    "2024-10-30": 62.09633546398159,
    "2024-10-31": 64.23758841101544,
    "2024-11-01": 65.25501152872296,
    "2024-11-02": 66.27243464643048,
    "2024-11-03": 67.28985776413802,
    "2024-11-04": 68.30728088184554,
    "2024-11-05": 69.32470399955307,
    "2024-11-06": 70.34212711726059,
    "2024-11-07": 71.35955023496811,
    "2024-11-08": 72.37697335267563,
    "2024-11-09": 73.39439647038316,
    "2024-11-10": 74.4118195880907,
    "2024-11-11": 75.42924270579822,
    "2024-11-12": 76.44666582350574,
    "2024-11-13": 77.46408894121326,
    "2024-11-14": 78.48151205892079,
    "2024-11-15": 79.49893517662832,
    "2024-11-16": 80.51635829433584,
    "2024-11-17": 81.53378141204337,
    "2024-11-18": 82.55120452975089,
    "2024-11-19": 83.56862764745841,
    "2024-11-20": 84.58605076516594,
    "2024-11-21": 85.60347388287346,
    "2024-11-22": 86.620897000581,
    "2024-11-23": 87.63832011828852,
    "2024-11-24": 88.65574323599604,
    "2024-11-25": 89.67316635370356,
    "2024-11-26": 90.6905894714111,
    "2024-11-27": 91.70801258911862,
    "2024-11-28": 92.72543570682616,
    "2024-11-29": 93.74285882453368,
    "2024-11-30": 94.7602819422412,
    "2024-12-01": 95.45594576198296,
    "2024-12-02": 96.15160958172474,
    "2024-12-03": 96.84727340146652,
    "2024-12-04": 97.5429372212083,
    "2024-12-05": 98.23860104095009,
    "2024-12-06": 98.93426486069184,
    "2024-12-07": 99.62992868043364,
    "2024-12-08": 100.3255925001754,
    "2024-12-09": 101.0212563199172,
    "2024-12-10": 101.71692013965897,
    "2024-12-11": 102.41258395940072,
    "2024-12-12": 103.10824777914252,
    "2024-12-13": 103.8039115988843,
    "2024-12-14": 104.49957541862608,
    "2024-12-15": 105.19523923836783,
    "2024-12-16": 105.89090305810964,
    "2024-12-17": 106.5865668778514,
    "2024-12-18": 107.28223069759318,
    "2024-12-19": 107.97789451733496,
    "2024-12-20": 108.67355833707674,
    "2024-12-21": 109.36922215681852,
    "2024-12-22": 110.06488597656028,
    "2024-12-23": 110.76054979630209,
    "2024-12-24": 111.45621361604384,
    "2024-12-25": 112.15187743578562,
    "2024-12-26": 112.8475412555274,
    "2024-12-27": 113.54320507526916,
    "2024-12-28": 114.23886889501097,
    "2024-12-29": 114.93453271475272,
    "2024-12-30": 115.6301965344945,
    "2024-12-31": 116.32586035423628,
    "2025-01-01": 117.07128032169112,
    "2025-01-02": 117.81670028914596,
    "2025-01-03": 118.5621202566008,
    "2025-01-04": 119.30754022405564,
    "2025-01-05": 120.05296019151048,
    "2025-01-06": 120.79838015896532,
    "2025-01-07": 121.54380012642017,
    "2025-01-08": 122.289220093875,
    "2025-01-09": 123.03464006132984,
    "2025-01-10": 123.78006002878467,
    "2025-01-11": 124.52547999623953,
    "2025-01-12": 125.27089996369436,
    "2025-01-13": 126.0163199311492,
    "2025-01-14": 126.76173989860403,
    "2025-01-15": 127.50715986605888,
    "2025-01-16": 128.25257983351372,
    "2025-01-17": 128.99799980096856,
    "2025-01-18": 129.7434197684234,
    "2025-01-19": 130.48883973587823,
    "2025-01-20": 131.2342597033331,
    "2025-01-21": 131.97967967078793,
    "2025-01-22": 132.72509963824277,
    "2025-01-23": 133.4705196056976,
    "2025-01-24": 134.21593957315244,
    "2025-01-25": 134.96135954060728,
    "2025-01-26": 135.7067795080621,
    "2025-01-27": 136.45219947551698,
    "2025-01-28": 137.1976194429718,
    "2025-01-29": 137.94303941042665,
    "2025-01-30": 138.6884593778815,
    "2025-01-31": 139.43387934533632,
    "2025-02-01": 140.90750003526674,
    "2025-02-02": 142.38112072519715,
    "2025-02-03": 143.85474141512756,
    "2025-02-04": 145.32836210505798,
    "2025-02-05": 146.80198279498842,
    "2025-02-06": 148.27560348491883,
    "2025-02-07": 149.74922417484925,
    "2025-02-08": 151.22284486477966,
    "2025-02-09": 152.69646555471007,
    "2025-02-10": 154.1700862446405,
    "2025-02-11": 155.6437069345709,
    "2025-02-12": 157.1173276245013,
    "2025-02-13": 158.59094831443173,
    "2025-02-14": 160.06456900436217,
    "2025-02-15": 161.53818969429258,
    "2025-02-16": 163.011810384223,
    "2025-02-17": 164.4854310741534,
    "2025-02-18": 165.95905176408382,
    "2025-02-19": 167.43267245401424,
    "2025-02-20": 168.90629314394465,
    "2025-02-21": 170.3799138338751,
    "2025-02-22": 171.85353452380548,
    "2025-02-23": 173.32715521373592,
    "2025-02-24": 174.8007759036663,
    "2025-02-25": 176.27439659359675,
    "2025-02-26": 177.74801728352716,
    "2025-02-27": 179.22163797345758,
    "2025-02-28": 180.695258663388,
    "2025-03-01": 182.4494819648832,
    "2025-03-02": 184.20370526637845,
    "2025-03-03": 185.9579285678737,
    "2025-03-04": 187.7121518693689,
    "2025-03-05": 189.46637517086413,
    "2025-03-06": 191.2205984723593,
    "2025-03-07": 192.9748217738546,
    "2025-03-08": 194.7290450753498,
    "2025-03-09": 196.48326837684505,
    "2025-03-10": 198.23749167834023,
    "2025-03-11": 199.99171497983548,
    "2025-03-12": 201.74593828133072,
    "2025-03-13": 203.50016158282597,
    "2025-03-14": 205.25438488432115,
    "2025-03-15": 207.0086081858164,
    "2025-03-16": 208.7628314873116,
    "2025-03-17": 210.5170547888069,
    "2025-03-18": 212.27127809030208,
    "2025-03-19": 214.0255013917973,
    "2025-03-20": 215.7797246932925,
    "2025-03-21": 217.53394799478772,
    "2025-03-22": 219.288171296283,
    "2025-03-23": 221.0423945977782,
    "2025-03-24": 222.79661789927343,
    "2025-03-25": 224.55084120076867,
    "2025-03-26": 226.3050645022639,
    "2025-03-27": 228.0592878037591,
    "2025-03-28": 229.81351110525435,
    "2025-03-29": 231.5677344067496,
    "2025-03-30": 233.3219577082448,
    "2025-03-31": 235.07618100974005,
    "2025-04-01": 237.61651157916037,
    "2025-04-02": 240.1568421485807,
    "2025-04-03": 242.697172718001,
    "2025-04-04": 245.23750328742136,
    "2025-04-05": 247.77783385684168,
    "2025-04-06": 250.318164426262,
    "2025-04-07": 252.85849499568235,
    "2025-04-08": 255.39882556510267,
    "2025-04-09": 257.939156134523,
    "2025-04-10": 260.47948670394334,
    "2025-04-11": 263.0198172733637,
    "2025-04-12": 265.560147842784,
    "2025-04-13": 268.1004784122043,
    "2025-04-14": 270.6408089816247,
    "2025-04-15": 273.181139551045,
    "2025-04-16": 275.7214701204653,
    "2025-04-17": 278.26180068988566,
    "2025-04-18": 280.802131259306,
    "2025-04-19": 283.3424618287263,
    "2025-04-20": 285.88279239814665,
    "2025-04-21": 288.423122967567,
    "2025-04-22": 290.96345353698734,
    "2025-04-23": 293.50378410640764,
    "2025-04-24": 296.044114675828,
    "2025-04-25": 298.58444524524833,
    "2025-04-26": 301.1247758146686,
    "2025-04-27": 303.665106384089,
    "2025-04-28": 306.2054369535093,
    "2025-04-29": 308.74576752292967,
    "2025-04-30": 311.28609809235,
    "2025-05-01": 314.77354184913503,
    "2025-05-02": 318.26098560592004,
    "2025-05-03": 321.7484293627051,
    "2025-05-04": 325.2358731194902,
    "2025-05-05": 328.7233168762752,
    "2025-05-06": 332.21076063306026,
    "2025-05-07": 335.69820438984533,
    "2025-05-08": 339.18564814663034,
    "2025-05-09": 342.6730919034154,
    "2025-05-10": 346.1605356602005,
    "2025-05-11": 349.6479794169855,
    "2025-05-12": 353.13542317377056,
    "2025-05-13": 356.6228669305556,
    "2025-05-14": 360.11031068734064,
    "2025-05-15": 363.5977544441257,
    "2025-05-16": 367.0851982009107,
    "2025-05-17": 370.5726419576958,
    "2025-05-18": 374.06008571448086,
    "2025-05-19": 377.5475294712659,
    "2025-05-20": 381.0349732280509,
    "2025-05-21": 384.522416984836,
    "2025-05-22": 388.009860741621,
    "2025-05-23": 391.4973044984061,
    "2025-05-24": 394.9847482551911,
    "2025-05-25": 398.4721920119762,
    "2025-05-26": 401.9596357687613,
    "2025-05-27": 405.4470795255463,
    "2025-05-28": 408.9345232823313,
    "2025-05-29": 412.4219670391164,
    "2025-05-30": 415.9094107959014,
    "2025-05-31": 419.3968545526865,
    "2025-06-01": 423.46893562817,
    "2025-06-02": 427.54101670365344,
    "2025-06-03": 431.6130977791369,
    "2025-06-04": 435.6851788546204,
    "2025-06-05": 439.7572599301039,
    "2025-06-06": 443.82934100558737,
    "2025-06-07": 447.9014220810709,
    "2025-06-08": 451.97350315655433,
    "2025-06-09": 456.04558423203787,
    "2025-06-10": 460.11766530752135,
    "2025-06-11": 464.1897463830048,
    "2025-06-12": 468.2618274584883,
    "2025-06-13": 472.3339085339718,
    "2025-06-14": 476.4059896094553,
    "2025-06-15": 480.4780706849388,
    "2025-06-16": 484.55015176042224,
    "2025-06-17": 488.6222328359057,
    "2025-06-18": 492.6943139113892,
    "2025-06-19": 496.7663949868727,
    "2025-06-20": 500.83847606235616,
    "2025-06-21": 504.9105571378397,
    "2025-06-22": 508.9826382133232,
    "2025-06-23": 513.0547192888066,
    "2025-06-24": 517.1268003642901,
    "2025-06-25": 521.1988814397736,
    "2025-06-26": 525.2709625152571,
    "2025-06-27": 529.3430435907405,
    "2025-06-28": 533.4151246662241,
    "2025-06-29": 537.4872057417075,
    "2025-06-30": 541.559286817191,
    "2025-07-01": 545.7176951196082,
    "2025-07-02": 549.8761034220252,
    "2025-07-03": 554.0345117244423,
    "2025-07-04": 558.1929200268593,
    "2025-07-05": 562.3513283292764,
    "2025-07-06": 566.5097366316935,
    "2025-07-07": 570.6681449341105,
    "2025-07-08": 574.8265532365276,
    "2025-07-09": 578.9849615389446,
    "2025-07-10": 583.1433698413617,
    "2025-07-11": 587.3017781437788,
    "2025-07-12": 591.4601864461958,
    "2025-07-13": 595.618594748613,
    "2025-07-14": 599.7770030510301,
    "2025-07-15": 603.9354113534471,
    "2025-07-16": 608.0938196558642,
    "2025-07-17": 612.2522279582812,
    "2025-07-18": 616.4106362606983,
    "2025-07-19": 620.5690445631154,
    "2025-07-20": 624.7274528655324,
    "2025-07-21": 628.8858611679495,
    "2025-07-22": 633.0442694703665,
    "2025-07-23": 637.2026777727837,
    "2025-07-24": 641.3610860752008,
    "2025-07-25": 645.5194943776178,
    "2025-07-26": 649.6779026800349,
    "2025-07-27": 653.836310982452,
    "2025-07-28": 657.994719284869,
    "2025-07-29": 662.1531275872861,
    "2025-07-30": 666.3115358897031,
    "2025-07-31": 670.4699441921202,
    "2025-08-01": 673.8287616893894,
    "2025-08-02": 677.1875791866585,
    "2025-08-03": 680.5463966839276,
    "2025-08-04": 683.9052141811968,
    "2025-08-05": 687.2640316784659,
    "2025-08-06": 690.622849175735,
    "2025-08-07": 693.9816666730042,
    "2025-08-08": 697.3404841702733,
    "2025-08-09": 700.6993016675424,
    "2025-08-10": 704.0581191648116,
    "2025-08-11": 707.4169366620807,
    "2025-08-12": 710.7757541593498,
    "2025-08-13": 714.134571656619,
    "2025-08-14": 717.4933891538881,
    "2025-08-15": 720.8522066511572,
    "2025-08-16": 724.2110241484264,
    "2025-08-17": 727.5698416456955,
    "2025-08-18": 730.9286591429646,
    "2025-08-19": 734.2874766402338,
    "2025-08-20": 737.6462941375029,
    "2025-08-21": 741.005111634772,
    "2025-08-22": 744.3639291320412,
    "2025-08-23": 747.7227466293103,
    "2025-08-24": 751.0815641265795,
    "2025-08-25": 754.4403816238486,
    "2025-08-26": 757.7991991211177,
    "2025-08-27": 761.1580166183868,
    "2025-08-28": 764.5168341156559,
    "2025-08-29": 767.8756516129251,
    "2025-08-30": 771.2344691101943,
    "2025-08-31": 774.5932866074634,
    "2025-09-01": 777.5392844432864,
    "2025-09-02": 780.4852822791095,
    "2025-09-03": 783.4312801149324,
    "2025-09-04": 786.3772779507555,
    "2025-09-05": 789.3232757865785,
    "2025-09-06": 792.2692736224016,
    "2025-09-07": 795.2152714582246,
    "2025-09-08": 798.1612692940477,
    "2025-09-09": 801.1072671298707,
    "2025-09-10": 804.0532649656936,
    "2025-09-11": 806.9992628015167,
    "2025-09-12": 809.9452606373397,
    "2025-09-13": 812.8912584731628,
    "2025-09-14": 815.8372563089858,
    "2025-09-15": 818.7832541448088,
    "2025-09-16": 821.7292519806318,
    "2025-09-17": 824.6752498164549,
    "2025-09-18": 827.6212476522779,
    "2025-09-19": 830.567245488101,
    "2025-09-20": 833.513243323924,
    "2025-09-21": 836.4592411597471,
    "2025-09-22": 839.40523899557,
    "2025-09-23": 842.3512368313931,
    "2025-09-24": 845.2972346672161,
    "2025-09-25": 848.2432325030392,
    "2025-09-26": 851.1892303388622,
    "2025-09-27": 854.1352281746852,
    "2025-09-28": 857.0812260105082,
    "2025-09-29": 860.0272238463313,
    "2025-09-30": 862.9732216821543,
  },
  Grapes: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.540876308633048,
    "2024-10-03": 5.081752617266096,
    "2024-10-04": 7.622628925899144,
    "2024-10-05": 10.163505234532192,
    "2024-10-06": 12.70438154316524,
    "2024-10-07": 15.245257851798288,
    "2024-10-08": 17.786134160431335,
    "2024-10-09": 20.327010469064383,
    "2024-10-10": 22.867886777697432,
    "2024-10-11": 25.40876308633048,
    "2024-10-12": 27.949639394963526,
    "2024-10-13": 30.49051570359657,
    "2024-10-14": 33.031392012229624,
    "2024-10-15": 35.57226832086267,
    "2024-10-16": 38.11314462949572,
    "2024-10-17": 40.65402093812877,
    "2024-10-18": 43.19489724676181,
    "2024-10-19": 45.735773555394864,
    "2024-10-20": 48.27664986402791,
    "2024-10-21": 50.81752617266096,
    "2024-10-22": 53.35840248129401,
    "2024-10-23": 55.89927878992705,
    "2024-10-24": 58.440155098560105,
    "2024-10-25": 60.98103140719315,
    "2024-10-26": 63.5219077158262,
    "2024-10-27": 66.06278402445925,
    "2024-10-28": 68.6036603330923,
    "2024-10-29": 71.14453664172534,
    "2024-10-30": 73.68541295035838,
    "2024-10-31": 76.22628925899144,
    "2024-11-01": 77.24203219209387,
    "2024-11-02": 78.2577751251963,
    "2024-11-03": 79.27351805829873,
    "2024-11-04": 80.28926099140116,
    "2024-11-05": 81.3050039245036,
    "2024-11-06": 82.32074685760603,
    "2024-11-07": 83.33648979070846,
    "2024-11-08": 84.35223272381089,
    "2024-11-09": 85.3679756569133,
    "2024-11-10": 86.38371859001573,
    "2024-11-11": 87.39946152311816,
    "2024-11-12": 88.4152044562206,
    "2024-11-13": 89.43094738932302,
    "2024-11-14": 90.44669032242544,
    "2024-11-15": 91.46243325552788,
    "2024-11-16": 92.47817618863031,
    "2024-11-17": 93.49391912173274,
    "2024-11-18": 94.50966205483518,
    "2024-11-19": 95.5254049879376,
    "2024-11-20": 96.54114792104004,
    "2024-11-21": 97.55689085414248,
    "2024-11-22": 98.57263378724488,
    "2024-11-23": 99.58837672034733,
    "2024-11-24": 100.60411965344974,
    "2024-11-25": 101.6198625865522,
    "2024-11-26": 102.6356055196546,
    "2024-11-27": 103.65134845275703,
    "2024-11-28": 104.66709138585946,
    "2024-11-29": 105.6828343189619,
    "2024-11-30": 106.69857725206433,
    "2024-12-01": 107.0855832156383,
    "2024-12-02": 107.47258917921228,
    "2024-12-03": 107.85959514278623,
    "2024-12-04": 108.24660110636025,
    "2024-12-05": 108.6336070699342,
    "2024-12-06": 109.02061303350818,
    "2024-12-07": 109.40761899708215,
    "2024-12-08": 109.79462496065614,
    "2024-12-09": 110.1816309242301,
    "2024-12-10": 110.56863688780408,
    "2024-12-11": 110.95564285137806,
    "2024-12-12": 111.34264881495204,
    "2024-12-13": 111.729654778526,
    "2024-12-14": 112.1166607421,
    "2024-12-15": 112.50366670567396,
    "2024-12-16": 112.89067266924796,
    "2024-12-17": 113.27767863282192,
    "2024-12-18": 113.6646845963959,
    "2024-12-19": 114.05169055996988,
    "2024-12-20": 114.43869652354384,
    "2024-12-21": 114.82570248711782,
    "2024-12-22": 115.2127084506918,
    "2024-12-23": 115.59971441426578,
    "2024-12-24": 115.98672037783976,
    "2024-12-25": 116.37372634141371,
    "2024-12-26": 116.76073230498773,
    "2024-12-27": 117.14773826856168,
    "2024-12-28": 117.53474423213568,
    "2024-12-29": 117.92175019570963,
    "2024-12-30": 118.3087561592836,
    "2024-12-31": 118.6957621228576,
    "2025-01-01": 119.50299493217967,
    "2025-01-02": 120.31022774150176,
    "2025-01-03": 121.11746055082384,
    "2025-01-04": 121.92469336014592,
    "2025-01-05": 122.731926169468,
    "2025-01-06": 123.5391589787901,
    "2025-01-07": 124.34639178811216,
    "2025-01-08": 125.15362459743426,
    "2025-01-09": 125.96085740675636,
    "2025-01-10": 126.76809021607843,
    "2025-01-11": 127.57532302540052,
    "2025-01-12": 128.3825558347226,
    "2025-01-13": 129.18978864404468,
    "2025-01-14": 129.99702145336676,
    "2025-01-15": 130.80425426268886,
    "2025-01-16": 131.61148707201093,
    "2025-01-17": 132.41871988133303,
    "2025-01-18": 133.2259526906551,
    "2025-01-19": 134.03318549997718,
    "2025-01-20": 134.84041830929928,
    "2025-01-21": 135.64765111862135,
    "2025-01-22": 136.45488392794346,
    "2025-01-23": 137.26211673726553,
    "2025-01-24": 138.0693495465876,
    "2025-01-25": 138.8765823559097,
    "2025-01-26": 139.68381516523178,
    "2025-01-27": 140.49104797455385,
    "2025-01-28": 141.29828078387595,
    "2025-01-29": 142.10551359319803,
    "2025-01-30": 142.91274640252013,
    "2025-01-31": 143.7199792118422,
    "2025-02-01": 145.40147259287247,
    "2025-02-02": 147.0829659739027,
    "2025-02-03": 148.76445935493297,
    "2025-02-04": 150.44595273596323,
    "2025-02-05": 152.12744611699347,
    "2025-02-06": 153.80893949802373,
    "2025-02-07": 155.49043287905397,
    "2025-02-08": 157.17192626008423,
    "2025-02-09": 158.8534196411145,
    "2025-02-10": 160.53491302214474,
    "2025-02-11": 162.216406403175,
    "2025-02-12": 163.89789978420526,
    "2025-02-13": 165.5793931652355,
    "2025-02-14": 167.26088654626577,
    "2025-02-15": 168.94237992729603,
    "2025-02-16": 170.62387330832627,
    "2025-02-17": 172.30536668935653,
    "2025-02-18": 173.9868600703868,
    "2025-02-19": 175.66835345141703,
    "2025-02-20": 177.3498468324473,
    "2025-02-21": 179.03134021347756,
    "2025-02-22": 180.7128335945078,
    "2025-02-23": 182.3943269755381,
    "2025-02-24": 184.07582035656836,
    "2025-02-25": 185.75731373759857,
    "2025-02-26": 187.43880711862883,
    "2025-02-27": 189.12030049965907,
    "2025-02-28": 190.80179388068933,
    "2025-03-01": 192.55942702201855,
    "2025-03-02": 194.31706016334783,
    "2025-03-03": 196.0746933046771,
    "2025-03-04": 197.8323264460064,
    "2025-03-05": 199.58995958733564,
    "2025-03-06": 201.3475927286649,
    "2025-03-07": 203.10522586999417,
    "2025-03-08": 204.86285901132345,
    "2025-03-09": 206.6204921526527,
    "2025-03-10": 208.378125293982,
    "2025-03-11": 210.13575843531123,
    "2025-03-12": 211.8933915766405,
    "2025-03-13": 213.65102471796976,
    "2025-03-14": 215.40865785929904,
    "2025-03-15": 217.1662910006283,
    "2025-03-16": 218.9239241419576,
    "2025-03-17": 220.6815572832868,
    "2025-03-18": 222.4391904246161,
    "2025-03-19": 224.19682356594532,
    "2025-03-20": 225.95445670727463,
    "2025-03-21": 227.71208984860388,
    "2025-03-22": 229.4697229899332,
    "2025-03-23": 231.2273561312624,
    "2025-03-24": 232.9849892725917,
    "2025-03-25": 234.7426224139209,
    "2025-03-26": 236.5002555552502,
    "2025-03-27": 238.25788869657947,
    "2025-03-28": 240.01552183790875,
    "2025-03-29": 241.773154979238,
    "2025-03-30": 243.53078812056725,
    "2025-03-31": 245.28842126189653,
    "2025-04-01": 248.50598627067248,
    "2025-04-02": 251.72355127944843,
    "2025-04-03": 254.9411162882244,
    "2025-04-04": 258.1586812970003,
    "2025-04-05": 261.37624630577625,
    "2025-04-06": 264.5938113145522,
    "2025-04-07": 267.81137632332815,
    "2025-04-08": 271.02894133210407,
    "2025-04-09": 274.24650634088005,
    "2025-04-10": 277.464071349656,
    "2025-04-11": 280.68163635843194,
    "2025-04-12": 283.89920136720787,
    "2025-04-13": 287.11676637598384,
    "2025-04-14": 290.33433138475976,
    "2025-04-15": 293.5518963935357,
    "2025-04-16": 296.76946140231166,
    "2025-04-17": 299.9870264110876,
    "2025-04-18": 303.2045914198636,
    "2025-04-19": 306.4221564286395,
    "2025-04-20": 309.63972143741546,
    "2025-04-21": 312.8572864461914,
    "2025-04-22": 316.0748514549673,
    "2025-04-23": 319.2924164637433,
    "2025-04-24": 322.5099814725192,
    "2025-04-25": 325.7275464812952,
    "2025-04-26": 328.9451114900711,
    "2025-04-27": 332.1626764988471,
    "2025-04-28": 335.380241507623,
    "2025-04-29": 338.5978065163989,
    "2025-04-30": 341.8153715251749,
    "2025-05-01": 346.8342567580245,
    "2025-05-02": 351.8531419908741,
    "2025-05-03": 356.8720272237237,
    "2025-05-04": 361.89091245657335,
    "2025-05-05": 366.9097976894229,
    "2025-05-06": 371.9286829222725,
    "2025-05-07": 376.94756815512216,
    "2025-05-08": 381.9664533879717,
    "2025-05-09": 386.9853386208214,
    "2025-05-10": 392.00422385367096,
    "2025-05-11": 397.02310908652055,
    "2025-05-12": 402.0419943193702,
    "2025-05-13": 407.0608795522198,
    "2025-05-14": 412.0797647850694,
    "2025-05-15": 417.098650017919,
    "2025-05-16": 422.1175352507686,
    "2025-05-17": 427.1364204836182,
    "2025-05-18": 432.1553057164678,
    "2025-05-19": 437.1741909493175,
    "2025-05-20": 442.19307618216703,
    "2025-05-21": 447.2119614150166,
    "2025-05-22": 452.2308466478662,
    "2025-05-23": 457.24973188071584,
    "2025-05-24": 462.2686171135655,
    "2025-05-25": 467.2875023464151,
    "2025-05-26": 472.3063875792647,
    "2025-05-27": 477.32527281211424,
    "2025-05-28": 482.3441580449639,
    "2025-05-29": 487.3630432778135,
    "2025-05-30": 492.3819285106631,
    "2025-05-31": 497.4008137435127,
    "2025-06-01": 503.9156419697782,
    "2025-06-02": 510.43047019604376,
    "2025-06-03": 516.9452984223093,
    "2025-06-04": 523.4601266485748,
    "2025-06-05": 529.9749548748405,
    "2025-06-06": 536.489783101106,
    "2025-06-07": 543.0046113273715,
    "2025-06-08": 549.5194395536371,
    "2025-06-09": 556.0342677799026,
    "2025-06-10": 562.5490960061682,
    "2025-06-11": 569.0639242324337,
    "2025-06-12": 575.5787524586992,
    "2025-06-13": 582.0935806849648,
    "2025-06-14": 588.6084089112303,
    "2025-06-15": 595.1232371374958,
    "2025-06-16": 601.6380653637615,
    "2025-06-17": 608.152893590027,
    "2025-06-18": 614.6677218162926,
    "2025-06-19": 621.1825500425581,
    "2025-06-20": 627.6973782688236,
    "2025-06-21": 634.2122064950892,
    "2025-06-22": 640.7270347213547,
    "2025-06-23": 647.2418629476202,
    "2025-06-24": 653.7566911738859,
    "2025-06-25": 660.2715194001514,
    "2025-06-26": 666.786347626417,
    "2025-06-27": 673.3011758526825,
    "2025-06-28": 679.816004078948,
    "2025-06-29": 686.3308323052136,
    "2025-06-30": 692.8456605314791,
    "2025-07-01": 699.5544273011899,
    "2025-07-02": 706.2631940709007,
    "2025-07-03": 712.9719608406114,
    "2025-07-04": 719.6807276103222,
    "2025-07-05": 726.3894943800329,
    "2025-07-06": 733.0982611497437,
    "2025-07-07": 739.8070279194544,
    "2025-07-08": 746.5157946891652,
    "2025-07-09": 753.224561458876,
    "2025-07-10": 759.9333282285868,
    "2025-07-11": 766.6420949982976,
    "2025-07-12": 773.3508617680083,
    "2025-07-13": 780.059628537719,
    "2025-07-14": 786.7683953074298,
    "2025-07-15": 793.4771620771406,
    "2025-07-16": 800.1859288468513,
    "2025-07-17": 806.8946956165621,
    "2025-07-18": 813.6034623862729,
    "2025-07-19": 820.3122291559837,
    "2025-07-20": 827.0209959256945,
    "2025-07-21": 833.7297626954052,
    "2025-07-22": 840.438529465116,
    "2025-07-23": 847.1472962348267,
    "2025-07-24": 853.8560630045374,
    "2025-07-25": 860.5648297742482,
    "2025-07-26": 867.273596543959,
    "2025-07-27": 873.9823633136698,
    "2025-07-28": 880.6911300833806,
    "2025-07-29": 887.3998968530914,
    "2025-07-30": 894.108663622802,
    "2025-07-31": 900.8174303925128,
    "2025-08-01": 906.3297159559244,
    "2025-08-02": 911.842001519336,
    "2025-08-03": 917.3542870827474,
    "2025-08-04": 922.8665726461588,
    "2025-08-05": 928.3788582095704,
    "2025-08-06": 933.891143772982,
    "2025-08-07": 939.4034293363936,
    "2025-08-08": 944.915714899805,
    "2025-08-09": 950.4280004632166,
    "2025-08-10": 955.940286026628,
    "2025-08-11": 961.4525715900396,
    "2025-08-12": 966.9648571534512,
    "2025-08-13": 972.4771427168628,
    "2025-08-14": 977.989428280274,
    "2025-08-15": 983.5017138436856,
    "2025-08-16": 989.0139994070972,
    "2025-08-17": 994.5262849705086,
    "2025-08-18": 1000.0385705339202,
    "2025-08-19": 1005.5508560973316,
    "2025-08-20": 1011.0631416607432,
    "2025-08-21": 1016.5754272241549,
    "2025-08-22": 1022.0877127875664,
    "2025-08-23": 1027.5999983509778,
    "2025-08-24": 1033.1122839143893,
    "2025-08-25": 1038.6245694778008,
    "2025-08-26": 1044.1368550412124,
    "2025-08-27": 1049.649140604624,
    "2025-08-28": 1055.1614261680354,
    "2025-08-29": 1060.673711731447,
    "2025-08-30": 1066.1859972948585,
    "2025-08-31": 1071.69828285827,
    "2025-09-01": 1075.7592419105397,
    "2025-09-02": 1079.820200962809,
    "2025-09-03": 1083.8811600150784,
    "2025-09-04": 1087.942119067348,
    "2025-09-05": 1092.0030781196174,
    "2025-09-06": 1096.064037171887,
    "2025-09-07": 1100.1249962241566,
    "2025-09-08": 1104.185955276426,
    "2025-09-09": 1108.2469143286955,
    "2025-09-10": 1112.307873380965,
    "2025-09-11": 1116.3688324332345,
    "2025-09-12": 1120.429791485504,
    "2025-09-13": 1124.4907505377737,
    "2025-09-14": 1128.551709590043,
    "2025-09-15": 1132.6126686423129,
    "2025-09-16": 1136.673627694582,
    "2025-09-17": 1140.7345867468516,
    "2025-09-18": 1144.795545799121,
    "2025-09-19": 1148.8565048513906,
    "2025-09-20": 1152.91746390366,
    "2025-09-21": 1156.9784229559295,
    "2025-09-22": 1161.039382008199,
    "2025-09-23": 1165.1003410604685,
    "2025-09-24": 1169.161300112738,
    "2025-09-25": 1173.2222591650077,
    "2025-09-26": 1177.2832182172772,
    "2025-09-27": 1181.344177269547,
    "2025-09-28": 1185.405136321816,
    "2025-09-29": 1189.4660953740856,
    "2025-09-30": 1193.527054426355,
  },
  Kiwi: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.2582127909757648,
    "2024-10-03": 4.5164255819515295,
    "2024-10-04": 6.774638372927294,
    "2024-10-05": 9.03285116390306,
    "2024-10-06": 11.291063954878824,
    "2024-10-07": 13.549276745854588,
    "2024-10-08": 15.807489536830351,
    "2024-10-09": 18.06570232780612,
    "2024-10-10": 20.323915118781883,
    "2024-10-11": 22.58212790975765,
    "2024-10-12": 24.84034070073341,
    "2024-10-13": 27.098553491709172,
    "2024-10-14": 29.35676628268494,
    "2024-10-15": 31.614979073660702,
    "2024-10-16": 33.873191864636475,
    "2024-10-17": 36.13140465561224,
    "2024-10-18": 38.389617446588,
    "2024-10-19": 40.64783023756377,
    "2024-10-20": 42.90604302853953,
    "2024-10-21": 45.1642558195153,
    "2024-10-22": 47.42246861049106,
    "2024-10-23": 49.68068140146683,
    "2024-10-24": 51.93889419244259,
    "2024-10-25": 54.19710698341835,
    "2024-10-26": 56.45531977439412,
    "2024-10-27": 58.71353256536988,
    "2024-10-28": 60.97174535634565,
    "2024-10-29": 63.22995814732141,
    "2024-10-30": 65.48817093829717,
    "2024-10-31": 67.74638372927295,
    "2024-11-01": 68.71510176063545,
    "2024-11-02": 69.68381979199793,
    "2024-11-03": 70.65253782336043,
    "2024-11-04": 71.62125585472293,
    "2024-11-05": 72.58997388608543,
    "2024-11-06": 73.55869191744792,
    "2024-11-07": 74.52740994881042,
    "2024-11-08": 75.49612798017291,
    "2024-11-09": 76.4648460115354,
    "2024-11-10": 77.4335640428979,
    "2024-11-11": 78.4022820742604,
    "2024-11-12": 79.3710001056229,
    "2024-11-13": 80.33971813698538,
    "2024-11-14": 81.30843616834788,
    "2024-11-15": 82.27715419971037,
    "2024-11-16": 83.24587223107287,
    "2024-11-17": 84.21459026243537,
    "2024-11-18": 85.18330829379786,
    "2024-11-19": 86.15202632516035,
    "2024-11-20": 87.12074435652285,
    "2024-11-21": 88.08946238788535,
    "2024-11-22": 89.05818041924783,
    "2024-11-23": 90.02689845061033,
    "2024-11-24": 90.99561648197285,
    "2024-11-25": 91.96433451333532,
    "2024-11-26": 92.93305254469782,
    "2024-11-27": 93.90177057606031,
    "2024-11-28": 94.8704886074228,
    "2024-11-29": 95.8392066387853,
    "2024-11-30": 96.8079246701478,
    "2024-12-01": 97.18017953487175,
    "2024-12-02": 97.55243439959573,
    "2024-12-03": 97.9246892643197,
    "2024-12-04": 98.29694412904364,
    "2024-12-05": 98.66919899376762,
    "2024-12-06": 99.04145385849158,
    "2024-12-07": 99.41370872321556,
    "2024-12-08": 99.7859635879395,
    "2024-12-09": 100.15821845266348,
    "2024-12-10": 100.53047331738745,
    "2024-12-11": 100.9027281821114,
    "2024-12-12": 101.27498304683536,
    "2024-12-13": 101.64723791155932,
    "2024-12-14": 102.01949277628329,
    "2024-12-15": 102.39174764100726,
    "2024-12-16": 102.7640025057312,
    "2024-12-17": 103.13625737045518,
    "2024-12-18": 103.50851223517914,
    "2024-12-19": 103.88076709990312,
    "2024-12-20": 104.25302196462708,
    "2024-12-21": 104.62527682935104,
    "2024-12-22": 104.997531694075,
    "2024-12-23": 105.36978655879896,
    "2024-12-24": 105.74204142352292,
    "2024-12-25": 106.11429628824688,
    "2024-12-26": 106.48655115297085,
    "2024-12-27": 106.85880601769482,
    "2024-12-28": 107.23106088241876,
    "2024-12-29": 107.60331574714274,
    "2024-12-30": 107.97557061186671,
    "2024-12-31": 108.34782547659069,
    "2025-01-01": 108.98490312996914,
    "2025-01-02": 109.6219807833476,
    "2025-01-03": 110.25905843672608,
    "2025-01-04": 110.89613609010456,
    "2025-01-05": 111.53321374348302,
    "2025-01-06": 112.17029139686149,
    "2025-01-07": 112.80736905023996,
    "2025-01-08": 113.44444670361842,
    "2025-01-09": 114.0815243569969,
    "2025-01-10": 114.71860201037536,
    "2025-01-11": 115.35567966375385,
    "2025-01-12": 115.9927573171323,
    "2025-01-13": 116.62983497051076,
    "2025-01-14": 117.26691262388924,
    "2025-01-15": 117.90399027726772,
    "2025-01-16": 118.5410679306462,
    "2025-01-17": 119.17814558402466,
    "2025-01-18": 119.81522323740312,
    "2025-01-19": 120.4523008907816,
    "2025-01-20": 121.08937854416008,
    "2025-01-21": 121.72645619753854,
    "2025-01-22": 122.363533850917,
    "2025-01-23": 123.00061150429548,
    "2025-01-24": 123.63768915767396,
    "2025-01-25": 124.27476681105242,
    "2025-01-26": 124.91184446443089,
    "2025-01-27": 125.54892211780935,
    "2025-01-28": 126.18599977118782,
    "2025-01-29": 126.82307742456628,
    "2025-01-30": 127.46015507794476,
    "2025-01-31": 128.09723273132323,
    "2025-02-01": 129.21092108737244,
    "2025-02-02": 130.32460944342165,
    "2025-02-03": 131.43829779947086,
    "2025-02-04": 132.55198615552007,
    "2025-02-05": 133.66567451156925,
    "2025-02-06": 134.77936286761846,
    "2025-02-07": 135.89305122366767,
    "2025-02-08": 137.00673957971688,
    "2025-02-09": 138.1204279357661,
    "2025-02-10": 139.2341162918153,
    "2025-02-11": 140.3478046478645,
    "2025-02-12": 141.46149300391372,
    "2025-02-13": 142.57518135996293,
    "2025-02-14": 143.6888697160121,
    "2025-02-15": 144.80255807206132,
    "2025-02-16": 145.91624642811053,
    "2025-02-17": 147.02993478415974,
    "2025-02-18": 148.14362314020894,
    "2025-02-19": 149.25731149625815,
    "2025-02-20": 150.37099985230736,
    "2025-02-21": 151.48468820835657,
    "2025-02-22": 152.59837656440578,
    "2025-02-23": 153.71206492045496,
    "2025-02-24": 154.82575327650417,
    "2025-02-25": 155.93944163255338,
    "2025-02-26": 157.0531299886026,
    "2025-02-27": 158.1668183446518,
    "2025-02-28": 159.280506700701,
    "2025-03-01": 160.90508488461387,
    "2025-03-02": 162.52966306852673,
    "2025-03-03": 164.1542412524396,
    "2025-03-04": 165.77881943635245,
    "2025-03-05": 167.4033976202653,
    "2025-03-06": 169.02797580417817,
    "2025-03-07": 170.65255398809103,
    "2025-03-08": 172.27713217200392,
    "2025-03-09": 173.90171035591678,
    "2025-03-10": 175.52628853982964,
    "2025-03-11": 177.1508667237425,
    "2025-03-12": 178.77544490765536,
    "2025-03-13": 180.40002309156824,
    "2025-03-14": 182.02460127548107,
    "2025-03-15": 183.64917945939396,
    "2025-03-16": 185.2737576433068,
    "2025-03-17": 186.89833582721965,
    "2025-03-18": 188.5229140111325,
    "2025-03-19": 190.14749219504537,
    "2025-03-20": 191.77207037895823,
    "2025-03-21": 193.3966485628711,
    "2025-03-22": 195.02122674678395,
    "2025-03-23": 196.64580493069684,
    "2025-03-24": 198.27038311460967,
    "2025-03-25": 199.89496129852256,
    "2025-03-26": 201.5195394824354,
    "2025-03-27": 203.14411766634828,
    "2025-03-28": 204.76869585026117,
    "2025-03-29": 206.393274034174,
    "2025-03-30": 208.0178522180869,
    "2025-03-31": 209.6424304019997,
    "2025-04-01": 213.4074455486834,
    "2025-04-02": 217.17246069536705,
    "2025-04-03": 220.93747584205076,
    "2025-04-04": 224.7024909887344,
    "2025-04-05": 228.4675061354181,
    "2025-04-06": 232.23252128210171,
    "2025-04-07": 235.99753642878545,
    "2025-04-08": 239.7625515754691,
    "2025-04-09": 243.5275667221528,
    "2025-04-10": 247.29258186883644,
    "2025-04-11": 251.0575970155201,
    "2025-04-12": 254.8226121622038,
    "2025-04-13": 258.5876273088875,
    "2025-04-14": 262.3526424555712,
    "2025-04-15": 266.1176576022548,
    "2025-04-16": 269.8826727489385,
    "2025-04-17": 273.64768789562214,
    "2025-04-18": 277.4127030423058,
    "2025-04-19": 281.1777181889895,
    "2025-04-20": 284.94273333567315,
    "2025-04-21": 288.70774848235686,
    "2025-04-22": 292.4727636290405,
    "2025-04-23": 296.2377787757242,
    "2025-04-24": 300.0027939224079,
    "2025-04-25": 303.7678090690915,
    "2025-04-26": 307.53282421577524,
    "2025-04-27": 311.2978393624589,
    "2025-04-28": 315.06285450914254,
    "2025-04-29": 318.82786965582625,
    "2025-04-30": 322.5928848025099,
    "2025-05-01": 327.66027609983,
    "2025-05-02": 332.7276673971501,
    "2025-05-03": 337.79505869447024,
    "2025-05-04": 342.8624499917903,
    "2025-05-05": 347.9298412891104,
    "2025-05-06": 352.9972325864305,
    "2025-05-07": 358.06462388375064,
    "2025-05-08": 363.1320151810708,
    "2025-05-09": 368.19940647839087,
    "2025-05-10": 373.266797775711,
    "2025-05-11": 378.33418907303104,
    "2025-05-12": 383.4015803703512,
    "2025-05-13": 388.46897166767127,
    "2025-05-14": 393.5363629649914,
    "2025-05-15": 398.6037542623115,
    "2025-05-16": 403.6711455596316,
    "2025-05-17": 408.73853685695167,
    "2025-05-18": 413.8059281542718,
    "2025-05-19": 418.8733194515919,
    "2025-05-20": 423.940710748912,
    "2025-05-21": 429.0081020462321,
    "2025-05-22": 434.0754933435522,
    "2025-05-23": 439.1428846408724,
    "2025-05-24": 444.2102759381924,
    "2025-05-25": 449.2776672355125,
    "2025-05-26": 454.34505853283264,
    "2025-05-27": 459.4124498301528,
    "2025-05-28": 464.4798411274728,
    "2025-05-29": 469.5472324247929,
    "2025-05-30": 474.614623722113,
    "2025-05-31": 479.6820150194332,
    "2025-06-01": 486.2235975371597,
    "2025-06-02": 492.7651800548863,
    "2025-06-03": 499.3067625726129,
    "2025-06-04": 505.8483450903395,
    "2025-06-05": 512.389927608066,
    "2025-06-06": 518.9315101257927,
    "2025-06-07": 525.4730926435192,
    "2025-06-08": 532.0146751612458,
    "2025-06-09": 538.5562576789723,
    "2025-06-10": 545.0978401966989,
    "2025-06-11": 551.6394227144256,
    "2025-06-12": 558.1810052321521,
    "2025-06-13": 564.7225877498787,
    "2025-06-14": 571.2641702676052,
    "2025-06-15": 577.8057527853318,
    "2025-06-16": 584.3473353030585,
    "2025-06-17": 590.888917820785,
    "2025-06-18": 597.4305003385116,
    "2025-06-19": 603.9720828562381,
    "2025-06-20": 610.5136653739647,
    "2025-06-21": 617.0552478916914,
    "2025-06-22": 623.5968304094179,
    "2025-06-23": 630.1384129271445,
    "2025-06-24": 636.6799954448711,
    "2025-06-25": 643.2215779625976,
    "2025-06-26": 649.7631604803242,
    "2025-06-27": 656.3047429980508,
    "2025-06-28": 662.8463255157774,
    "2025-06-29": 669.3879080335039,
    "2025-06-30": 675.9294905512305,
    "2025-07-01": 682.6581064288006,
    "2025-07-02": 689.3867223063705,
    "2025-07-03": 696.1153381839406,
    "2025-07-04": 702.8439540615105,
    "2025-07-05": 709.5725699390806,
    "2025-07-06": 716.3011858166506,
    "2025-07-07": 723.0298016942206,
    "2025-07-08": 729.7584175717906,
    "2025-07-09": 736.4870334493606,
    "2025-07-10": 743.2156493269306,
    "2025-07-11": 749.9442652045007,
    "2025-07-12": 756.6728810820706,
    "2025-07-13": 763.4014969596407,
    "2025-07-14": 770.1301128372106,
    "2025-07-15": 776.8587287147807,
    "2025-07-16": 783.5873445923506,
    "2025-07-17": 790.3159604699207,
    "2025-07-18": 797.0445763474906,
    "2025-07-19": 803.7731922250607,
    "2025-07-20": 810.5018081026307,
    "2025-07-21": 817.2304239802007,
    "2025-07-22": 823.9590398577707,
    "2025-07-23": 830.6876557353407,
    "2025-07-24": 837.4162716129108,
    "2025-07-25": 844.1448874904808,
    "2025-07-26": 850.8735033680507,
    "2025-07-27": 857.6021192456208,
    "2025-07-28": 864.3307351231908,
    "2025-07-29": 871.0593510007608,
    "2025-07-30": 877.7879668783307,
    "2025-07-31": 884.5165827559008,
    "2025-08-01": 889.75499069509,
    "2025-08-02": 894.9933986342792,
    "2025-08-03": 900.2318065734684,
    "2025-08-04": 905.4702145126575,
    "2025-08-05": 910.7086224518468,
    "2025-08-06": 915.947030391036,
    "2025-08-07": 921.1854383302252,
    "2025-08-08": 926.4238462694144,
    "2025-08-09": 931.6622542086036,
    "2025-08-10": 936.9006621477928,
    "2025-08-11": 942.139070086982,
    "2025-08-12": 947.377478026171,
    "2025-08-13": 952.6158859653602,
    "2025-08-14": 957.8542939045494,
    "2025-08-15": 963.0927018437388,
    "2025-08-16": 968.3311097829278,
    "2025-08-17": 973.5695177221172,
    "2025-08-18": 978.8079256613062,
    "2025-08-19": 984.0463336004956,
    "2025-08-20": 989.2847415396848,
    "2025-08-21": 994.5231494788738,
    "2025-08-22": 999.761557418063,
    "2025-08-23": 1004.9999653572522,
    "2025-08-24": 1010.2383732964414,
    "2025-08-25": 1015.4767812356306,
    "2025-08-26": 1020.7151891748198,
    "2025-08-27": 1025.953597114009,
    "2025-08-28": 1031.192005053198,
    "2025-08-29": 1036.4304129923871,
    "2025-08-30": 1041.6688209315766,
    "2025-08-31": 1046.9072288707655,
    "2025-09-01": 1050.8427602174152,
    "2025-09-02": 1054.7782915640646,
    "2025-09-03": 1058.7138229107145,
    "2025-09-04": 1062.6493542573637,
    "2025-09-05": 1066.5848856040132,
    "2025-09-06": 1070.5204169506626,
    "2025-09-07": 1074.455948297312,
    "2025-09-08": 1078.3914796439617,
    "2025-09-09": 1082.3270109906111,
    "2025-09-10": 1086.2625423372606,
    "2025-09-11": 1090.19807368391,
    "2025-09-12": 1094.1336050305597,
    "2025-09-13": 1098.0691363772091,
    "2025-09-14": 1102.0046677238586,
    "2025-09-15": 1105.940199070508,
    "2025-09-16": 1109.8757304171577,
    "2025-09-17": 1113.811261763807,
    "2025-09-18": 1117.7467931104566,
    "2025-09-19": 1121.682324457106,
    "2025-09-20": 1125.6178558037554,
    "2025-09-21": 1129.553387150405,
    "2025-09-22": 1133.4889184970543,
    "2025-09-23": 1137.424449843704,
    "2025-09-24": 1141.3599811903534,
    "2025-09-25": 1145.2955125370029,
    "2025-09-26": 1149.2310438836523,
    "2025-09-27": 1153.1665752303018,
    "2025-09-28": 1157.1021065769514,
    "2025-09-29": 1161.0376379236009,
    "2025-09-30": 1164.9731692702503,
  },
  "Miscellaneous Deciduous": {
    "2024-10-01": 0.0,
    "2024-10-02": 2.280687851678757,
    "2024-10-03": 4.561375703357514,
    "2024-10-04": 6.842063555036272,
    "2024-10-05": 9.122751406715029,
    "2024-10-06": 11.403439258393783,
    "2024-10-07": 13.684127110072543,
    "2024-10-08": 15.9648149617513,
    "2024-10-09": 18.245502813430058,
    "2024-10-10": 20.52619066510881,
    "2024-10-11": 22.80687851678757,
    "2024-10-12": 25.08756636846633,
    "2024-10-13": 27.368254220145086,
    "2024-10-14": 29.648942071823843,
    "2024-10-15": 31.929629923502603,
    "2024-10-16": 34.21031777518136,
    "2024-10-17": 36.49100562686012,
    "2024-10-18": 38.77169347853887,
    "2024-10-19": 41.05238133021763,
    "2024-10-20": 43.333069181896384,
    "2024-10-21": 45.61375703357514,
    "2024-10-22": 47.894444885253904,
    "2024-10-23": 50.17513273693266,
    "2024-10-24": 52.45582058861142,
    "2024-10-25": 54.73650844029017,
    "2024-10-26": 57.01719629196893,
    "2024-10-27": 59.297884143647686,
    "2024-10-28": 61.57857199532644,
    "2024-10-29": 63.859259847005205,
    "2024-10-30": 66.13994769868395,
    "2024-10-31": 68.42063555036272,
    "2024-11-01": 69.14645521860274,
    "2024-11-02": 69.87227488684275,
    "2024-11-03": 70.59809455508277,
    "2024-11-04": 71.32391422332279,
    "2024-11-05": 72.04973389156281,
    "2024-11-06": 72.77555355980282,
    "2024-11-07": 73.50137322804284,
    "2024-11-08": 74.22719289628286,
    "2024-11-09": 74.95301256452288,
    "2024-11-10": 75.67883223276289,
    "2024-11-11": 76.40465190100291,
    "2024-11-12": 77.13047156924293,
    "2024-11-13": 77.85629123748294,
    "2024-11-14": 78.58211090572296,
    "2024-11-15": 79.30793057396298,
    "2024-11-16": 80.033750242203,
    "2024-11-17": 80.75956991044302,
    "2024-11-18": 81.48538957868303,
    "2024-11-19": 82.21120924692305,
    "2024-11-20": 82.93702891516307,
    "2024-11-21": 83.66284858340308,
    "2024-11-22": 84.3886682516431,
    "2024-11-23": 85.11448791988312,
    "2024-11-24": 85.84030758812312,
    "2024-11-25": 86.56612725636315,
    "2024-11-26": 87.29194692460317,
    "2024-11-27": 88.01776659284319,
    "2024-11-28": 88.74358626108321,
    "2024-11-29": 89.46940592932322,
    "2024-11-30": 90.19522559756324,
    "2024-12-01": 90.58144091146148,
    "2024-12-02": 90.96765622535976,
    "2024-12-03": 91.353871539258,
    "2024-12-04": 91.74008685315626,
    "2024-12-05": 92.1263021670545,
    "2024-12-06": 92.51251748095277,
    "2024-12-07": 92.898732794851,
    "2024-12-08": 93.28494810874926,
    "2024-12-09": 93.67116342264752,
    "2024-12-10": 94.05737873654576,
    "2024-12-11": 94.44359405044403,
    "2024-12-12": 94.82980936434228,
    "2024-12-13": 95.21602467824052,
    "2024-12-14": 95.6022399921388,
    "2024-12-15": 95.98845530603704,
    "2024-12-16": 96.3746706199353,
    "2024-12-17": 96.76088593383356,
    "2024-12-18": 97.1471012477318,
    "2024-12-19": 97.53331656163006,
    "2024-12-20": 97.9195318755283,
    "2024-12-21": 98.30574718942655,
    "2024-12-22": 98.69196250332482,
    "2024-12-23": 99.07817781722308,
    "2024-12-24": 99.46439313112133,
    "2024-12-25": 99.8506084450196,
    "2024-12-26": 100.23682375891784,
    "2024-12-27": 100.62303907281608,
    "2024-12-28": 101.00925438671436,
    "2024-12-29": 101.3954697006126,
    "2024-12-30": 101.78168501451086,
    "2024-12-31": 102.1679003284091,
    "2025-01-01": 102.859036426856,
    "2025-01-02": 103.55017252530293,
    "2025-01-03": 104.24130862374984,
    "2025-01-04": 104.93244472219672,
    "2025-01-05": 105.62358082064364,
    "2025-01-06": 106.31471691909054,
    "2025-01-07": 107.00585301753746,
    "2025-01-08": 107.69698911598437,
    "2025-01-09": 108.38812521443128,
    "2025-01-10": 109.07926131287816,
    "2025-01-11": 109.77039741132508,
    "2025-01-12": 110.461533509772,
    "2025-01-13": 111.1526696082189,
    "2025-01-14": 111.8438057066658,
    "2025-01-15": 112.53494180511272,
    "2025-01-16": 113.22607790355964,
    "2025-01-17": 113.91721400200652,
    "2025-01-18": 114.60835010045344,
    "2025-01-19": 115.29948619890034,
    "2025-01-20": 115.99062229734724,
    "2025-01-21": 116.68175839579416,
    "2025-01-22": 117.37289449424108,
    "2025-01-23": 118.06403059268796,
    "2025-01-24": 118.75516669113487,
    "2025-01-25": 119.4463027895818,
    "2025-01-26": 120.1374388880287,
    "2025-01-27": 120.8285749864756,
    "2025-01-28": 121.5197110849225,
    "2025-01-29": 122.21084718336942,
    "2025-01-30": 122.90198328181631,
    "2025-01-31": 123.59311938026325,
    "2025-02-01": 125.01544819195064,
    "2025-02-02": 126.43777700363808,
    "2025-02-03": 127.86010581532553,
    "2025-02-04": 129.28243462701295,
    "2025-02-05": 130.70476343870038,
    "2025-02-06": 132.1270922503878,
    "2025-02-07": 133.54942106207525,
    "2025-02-08": 134.97174987376266,
    "2025-02-09": 136.39407868545007,
    "2025-02-10": 137.8164074971375,
    "2025-02-11": 139.23873630882494,
    "2025-02-12": 140.66106512051238,
    "2025-02-13": 142.08339393219978,
    "2025-02-14": 143.50572274388722,
    "2025-02-15": 144.92805155557463,
    "2025-02-16": 146.35038036726206,
    "2025-02-17": 147.7727091789495,
    "2025-02-18": 149.19503799063693,
    "2025-02-19": 150.61736680232434,
    "2025-02-20": 152.03969561401178,
    "2025-02-21": 153.4620244256992,
    "2025-02-22": 154.88435323738665,
    "2025-02-23": 156.30668204907406,
    "2025-02-24": 157.7290108607615,
    "2025-02-25": 159.15133967244893,
    "2025-02-26": 160.57366848413636,
    "2025-02-27": 161.99599729582377,
    "2025-02-28": 163.4183261075112,
    "2025-03-01": 165.58782733111582,
    "2025-03-02": 167.75732855472046,
    "2025-03-03": 169.92682977832507,
    "2025-03-04": 172.0963310019297,
    "2025-03-05": 174.26583222553433,
    "2025-03-06": 176.43533344913897,
    "2025-03-07": 178.60483467274358,
    "2025-03-08": 180.77433589634825,
    "2025-03-09": 182.94383711995283,
    "2025-03-10": 185.11333834355747,
    "2025-03-11": 187.28283956716209,
    "2025-03-12": 189.45234079076675,
    "2025-03-13": 191.6218420143713,
    "2025-03-14": 193.791343237976,
    "2025-03-15": 195.9608444615806,
    "2025-03-16": 198.13034568518523,
    "2025-03-17": 200.29984690878985,
    "2025-03-18": 202.4693481323945,
    "2025-03-19": 204.6388493559991,
    "2025-03-20": 206.8083505796037,
    "2025-03-21": 208.97785180320835,
    "2025-03-22": 211.147353026813,
    "2025-03-23": 213.3168542504176,
    "2025-03-24": 215.48635547402225,
    "2025-03-25": 217.6558566976269,
    "2025-03-26": 219.8253579212315,
    "2025-03-27": 221.9948591448361,
    "2025-03-28": 224.16436036844075,
    "2025-03-29": 226.33386159204537,
    "2025-03-30": 228.50336281565,
    "2025-03-31": 230.67286403925465,
    "2025-04-01": 234.0608426988446,
    "2025-04-02": 237.4488213584346,
    "2025-04-03": 240.83680001802455,
    "2025-04-04": 244.22477867761455,
    "2025-04-05": 247.61275733720456,
    "2025-04-06": 251.00073599679456,
    "2025-04-07": 254.3887146563845,
    "2025-04-08": 257.7766933159745,
    "2025-04-09": 261.1646719755645,
    "2025-04-10": 264.5526506351545,
    "2025-04-11": 267.9406292947445,
    "2025-04-12": 271.3286079543345,
    "2025-04-13": 274.71658661392445,
    "2025-04-14": 278.1045652735145,
    "2025-04-15": 281.49254393310446,
    "2025-04-16": 284.88052259269443,
    "2025-04-17": 288.2685012522844,
    "2025-04-18": 291.6564799118744,
    "2025-04-19": 295.0444585714644,
    "2025-04-20": 298.4324372310544,
    "2025-04-21": 301.8204158906444,
    "2025-04-22": 305.20839455023435,
    "2025-04-23": 308.5963732098244,
    "2025-04-24": 311.98435186941435,
    "2025-04-25": 315.3723305290044,
    "2025-04-26": 318.7603091885943,
    "2025-04-27": 322.1482878481843,
    "2025-04-28": 325.53626650777426,
    "2025-04-29": 328.9242451673643,
    "2025-04-30": 332.31222382695427,
    "2025-05-01": 336.38142402548124,
    "2025-05-02": 340.45062422400827,
    "2025-05-03": 344.51982442253524,
    "2025-05-04": 348.5890246210622,
    "2025-05-05": 352.65822481958924,
    "2025-05-06": 356.7274250181162,
    "2025-05-07": 360.7966252166432,
    "2025-05-08": 364.8658254151702,
    "2025-05-09": 368.9350256136972,
    "2025-05-10": 373.0042258122242,
    "2025-05-11": 377.0734260107512,
    "2025-05-12": 381.14262620927815,
    "2025-05-13": 385.2118264078052,
    "2025-05-14": 389.28102660633215,
    "2025-05-15": 393.3502268048591,
    "2025-05-16": 397.41942700338615,
    "2025-05-17": 401.4886272019131,
    "2025-05-18": 405.55782740044015,
    "2025-05-19": 409.6270275989671,
    "2025-05-20": 413.6962277974941,
    "2025-05-21": 417.7654279960211,
    "2025-05-22": 421.8346281945481,
    "2025-05-23": 425.9038283930751,
    "2025-05-24": 429.9730285916021,
    "2025-05-25": 434.04222879012906,
    "2025-05-26": 438.111428988656,
    "2025-05-27": 442.1806291871831,
    "2025-05-28": 446.24982938571,
    "2025-05-29": 450.319029584237,
    "2025-05-30": 454.388229782764,
    "2025-05-31": 458.457429981291,
    "2025-06-01": 463.5386042407311,
    "2025-06-02": 468.6197785001712,
    "2025-06-03": 473.7009527596113,
    "2025-06-04": 478.7821270190514,
    "2025-06-05": 483.8633012784915,
    "2025-06-06": 488.9444755379316,
    "2025-06-07": 494.0256497973717,
    "2025-06-08": 499.10682405681183,
    "2025-06-09": 504.187998316252,
    "2025-06-10": 509.269172575692,
    "2025-06-11": 514.3503468351321,
    "2025-06-12": 519.4315210945722,
    "2025-06-13": 524.5126953540123,
    "2025-06-14": 529.5938696134524,
    "2025-06-15": 534.6750438728925,
    "2025-06-16": 539.7562181323326,
    "2025-06-17": 544.8373923917727,
    "2025-06-18": 549.9185666512128,
    "2025-06-19": 554.9997409106529,
    "2025-06-20": 560.080915170093,
    "2025-06-21": 565.1620894295331,
    "2025-06-22": 570.2432636889732,
    "2025-06-23": 575.3244379484133,
    "2025-06-24": 580.4056122078534,
    "2025-06-25": 585.4867864672935,
    "2025-06-26": 590.5679607267336,
    "2025-06-27": 595.6491349861737,
    "2025-06-28": 600.7303092456139,
    "2025-06-29": 605.811483505054,
    "2025-06-30": 610.8926577644941,
    "2025-07-01": 616.4127955070596,
    "2025-07-02": 621.9329332496251,
    "2025-07-03": 627.4530709921906,
    "2025-07-04": 632.9732087347561,
    "2025-07-05": 638.4933464773217,
    "2025-07-06": 644.0134842198872,
    "2025-07-07": 649.5336219624527,
    "2025-07-08": 655.0537597050183,
    "2025-07-09": 660.5738974475837,
    "2025-07-10": 666.0940351901493,
    "2025-07-11": 671.6141729327148,
    "2025-07-12": 677.1343106752803,
    "2025-07-13": 682.6544484178459,
    "2025-07-14": 688.1745861604113,
    "2025-07-15": 693.6947239029769,
    "2025-07-16": 699.2148616455424,
    "2025-07-17": 704.7349993881079,
    "2025-07-18": 710.2551371306735,
    "2025-07-19": 715.775274873239,
    "2025-07-20": 721.2954126158045,
    "2025-07-21": 726.81555035837,
    "2025-07-22": 732.3356881009355,
    "2025-07-23": 737.8558258435011,
    "2025-07-24": 743.3759635860665,
    "2025-07-25": 748.8961013286321,
    "2025-07-26": 754.4162390711977,
    "2025-07-27": 759.9363768137632,
    "2025-07-28": 765.4565145563287,
    "2025-07-29": 770.9766522988942,
    "2025-07-30": 776.4967900414597,
    "2025-07-31": 782.0169277840253,
    "2025-08-01": 786.825384359325,
    "2025-08-02": 791.6338409346248,
    "2025-08-03": 796.4422975099245,
    "2025-08-04": 801.2507540852243,
    "2025-08-05": 806.0592106605241,
    "2025-08-06": 810.8676672358239,
    "2025-08-07": 815.6761238111236,
    "2025-08-08": 820.4845803864234,
    "2025-08-09": 825.2930369617231,
    "2025-08-10": 830.1014935370229,
    "2025-08-11": 834.9099501123227,
    "2025-08-12": 839.7184066876224,
    "2025-08-13": 844.5268632629222,
    "2025-08-14": 849.335319838222,
    "2025-08-15": 854.1437764135218,
    "2025-08-16": 858.9522329888215,
    "2025-08-17": 863.7606895641213,
    "2025-08-18": 868.569146139421,
    "2025-08-19": 873.3776027147209,
    "2025-08-20": 878.1860592900206,
    "2025-08-21": 882.9945158653204,
    "2025-08-22": 887.8029724406201,
    "2025-08-23": 892.6114290159198,
    "2025-08-24": 897.4198855912197,
    "2025-08-25": 902.2283421665194,
    "2025-08-26": 907.0367987418192,
    "2025-08-27": 911.8452553171188,
    "2025-08-28": 916.6537118924188,
    "2025-08-29": 921.4621684677184,
    "2025-08-30": 926.2706250430184,
    "2025-08-31": 931.079081618318,
    "2025-09-01": 934.5097203173198,
    "2025-09-02": 937.9403590163216,
    "2025-09-03": 941.3709977153233,
    "2025-09-04": 944.801636414325,
    "2025-09-05": 948.2322751133268,
    "2025-09-06": 951.6629138123284,
    "2025-09-07": 955.0935525113302,
    "2025-09-08": 958.524191210332,
    "2025-09-09": 961.9548299093336,
    "2025-09-10": 965.3854686083354,
    "2025-09-11": 968.8161073073372,
    "2025-09-12": 972.2467460063388,
    "2025-09-13": 975.6773847053406,
    "2025-09-14": 979.1080234043424,
    "2025-09-15": 982.538662103344,
    "2025-09-16": 985.969300802346,
    "2025-09-17": 989.3999395013476,
    "2025-09-18": 992.8305782003494,
    "2025-09-19": 996.2612168993512,
    "2025-09-20": 999.6918555983528,
    "2025-09-21": 1003.1224942973546,
    "2025-09-22": 1006.5531329963562,
    "2025-09-23": 1009.983771695358,
    "2025-09-24": 1013.4144103943596,
    "2025-09-25": 1016.8450490933616,
    "2025-09-26": 1020.2756877923632,
    "2025-09-27": 1023.706326491365,
    "2025-09-28": 1027.1369651903667,
    "2025-09-29": 1030.5676038893685,
    "2025-09-30": 1033.9982425883702,
  },
  "Miscellaneous Subtropical Fruits": {
    "2024-10-01": 0.0,
    "2024-10-02": 2.915650713015826,
    "2024-10-03": 5.831301426031652,
    "2024-10-04": 8.746952139047478,
    "2024-10-05": 11.662602852063303,
    "2024-10-06": 14.578253565079129,
    "2024-10-07": 17.493904278094956,
    "2024-10-08": 20.40955499111078,
    "2024-10-09": 23.325205704126606,
    "2024-10-10": 26.24085641714243,
    "2024-10-11": 29.156507130158257,
    "2024-10-12": 32.07215784317408,
    "2024-10-13": 34.98780855618991,
    "2024-10-14": 37.90345926920573,
    "2024-10-15": 40.81910998222156,
    "2024-10-16": 43.73476069523738,
    "2024-10-17": 46.65041140825321,
    "2024-10-18": 49.56606212126904,
    "2024-10-19": 52.48171283428486,
    "2024-10-20": 55.39736354730069,
    "2024-10-21": 58.313014260316514,
    "2024-10-22": 61.22866497333234,
    "2024-10-23": 64.14431568634816,
    "2024-10-24": 67.05996639936399,
    "2024-10-25": 69.97561711237982,
    "2024-10-26": 72.89126782539564,
    "2024-10-27": 75.80691853841147,
    "2024-10-28": 78.7225692514273,
    "2024-10-29": 81.63821996444312,
    "2024-10-30": 84.55387067745895,
    "2024-10-31": 87.46952139047477,
    "2024-11-01": 88.31662848089496,
    "2024-11-02": 89.16373557131516,
    "2024-11-03": 90.01084266173535,
    "2024-11-04": 90.85794975215552,
    "2024-11-05": 91.70505684257571,
    "2024-11-06": 92.55216393299592,
    "2024-11-07": 93.39927102341612,
    "2024-11-08": 94.24637811383631,
    "2024-11-09": 95.09348520425652,
    "2024-11-10": 95.9405922946767,
    "2024-11-11": 96.78769938509689,
    "2024-11-12": 97.63480647551708,
    "2024-11-13": 98.48191356593728,
    "2024-11-14": 99.32902065635749,
    "2024-11-15": 100.17612774677768,
    "2024-11-16": 101.02323483719786,
    "2024-11-17": 101.87034192761806,
    "2024-11-18": 102.71744901803824,
    "2024-11-19": 103.56455610845843,
    "2024-11-20": 104.41166319887864,
    "2024-11-21": 105.25877028929882,
    "2024-11-22": 106.10587737971902,
    "2024-11-23": 106.9529844701392,
    "2024-11-24": 107.8000915605594,
    "2024-11-25": 108.6471986509796,
    "2024-11-26": 109.49430574139978,
    "2024-11-27": 110.34141283181998,
    "2024-11-28": 111.18851992224018,
    "2024-11-29": 112.03562701266036,
    "2024-11-30": 112.88273410308057,
    "2024-12-01": 113.46212773714956,
    "2024-12-02": 114.04152137121856,
    "2024-12-03": 114.62091500528756,
    "2024-12-04": 115.20030863935656,
    "2024-12-05": 115.77970227342556,
    "2024-12-06": 116.35909590749456,
    "2024-12-07": 116.93848954156356,
    "2024-12-08": 117.51788317563258,
    "2024-12-09": 118.09727680970155,
    "2024-12-10": 118.67667044377058,
    "2024-12-11": 119.25606407783955,
    "2024-12-12": 119.83545771190856,
    "2024-12-13": 120.41485134597758,
    "2024-12-14": 120.99424498004656,
    "2024-12-15": 121.57363861411558,
    "2024-12-16": 122.15303224818456,
    "2024-12-17": 122.73242588225358,
    "2024-12-18": 123.31181951632256,
    "2024-12-19": 123.89121315039158,
    "2024-12-20": 124.4706067844606,
    "2024-12-21": 125.05000041852958,
    "2024-12-22": 125.62939405259858,
    "2024-12-23": 126.20878768666758,
    "2024-12-24": 126.78818132073658,
    "2024-12-25": 127.36757495480558,
    "2024-12-26": 127.94696858887458,
    "2024-12-27": 128.5263622229436,
    "2024-12-28": 129.10575585701258,
    "2024-12-29": 129.68514949108155,
    "2024-12-30": 130.2645431251506,
    "2024-12-31": 130.8439367592196,
    "2025-01-01": 131.73054750919235,
    "2025-01-02": 132.6171582591651,
    "2025-01-03": 133.50376900913787,
    "2025-01-04": 134.39037975911066,
    "2025-01-05": 135.27699050908342,
    "2025-01-06": 136.16360125905618,
    "2025-01-07": 137.05021200902894,
    "2025-01-08": 137.9368227590017,
    "2025-01-09": 138.82343350897446,
    "2025-01-10": 139.71004425894722,
    "2025-01-11": 140.59665500891998,
    "2025-01-12": 141.48326575889277,
    "2025-01-13": 142.36987650886553,
    "2025-01-14": 143.2564872588383,
    "2025-01-15": 144.14309800881105,
    "2025-01-16": 145.0297087587838,
    "2025-01-17": 145.91631950875657,
    "2025-01-18": 146.80293025872933,
    "2025-01-19": 147.68954100870212,
    "2025-01-20": 148.57615175867488,
    "2025-01-21": 149.46276250864764,
    "2025-01-22": 150.3493732586204,
    "2025-01-23": 151.23598400859316,
    "2025-01-24": 152.12259475856592,
    "2025-01-25": 153.00920550853868,
    "2025-01-26": 153.89581625851145,
    "2025-01-27": 154.7824270084842,
    "2025-01-28": 155.669037758457,
    "2025-01-29": 156.55564850842975,
    "2025-01-30": 157.44225925840252,
    "2025-01-31": 158.32887000837528,
    "2025-02-01": 159.75299962161583,
    "2025-02-02": 161.1771292348564,
    "2025-02-03": 162.60125884809696,
    "2025-02-04": 164.0253884613375,
    "2025-02-05": 165.44951807457807,
    "2025-02-06": 166.87364768781862,
    "2025-02-07": 168.2977773010592,
    "2025-02-08": 169.72190691429975,
    "2025-02-09": 171.1460365275403,
    "2025-02-10": 172.57016614078088,
    "2025-02-11": 173.99429575402144,
    "2025-02-12": 175.418425367262,
    "2025-02-13": 176.84255498050254,
    "2025-02-14": 178.2666845937431,
    "2025-02-15": 179.69081420698367,
    "2025-02-16": 181.11494382022423,
    "2025-02-17": 182.5390734334648,
    "2025-02-18": 183.96320304670536,
    "2025-02-19": 185.3873326599459,
    "2025-02-20": 186.8114622731865,
    "2025-02-21": 188.23559188642704,
    "2025-02-22": 189.6597214996676,
    "2025-02-23": 191.08385111290812,
    "2025-02-24": 192.5079807261487,
    "2025-02-25": 193.93211033938923,
    "2025-02-26": 195.35623995262983,
    "2025-02-27": 196.7803695658704,
    "2025-02-28": 198.2044991791109,
    "2025-03-01": 200.3426214830932,
    "2025-03-02": 202.4807437870755,
    "2025-03-03": 204.61886609105775,
    "2025-03-04": 206.75698839504008,
    "2025-03-05": 208.89511069902235,
    "2025-03-06": 211.03323300300465,
    "2025-03-07": 213.17135530698687,
    "2025-03-08": 215.3094776109692,
    "2025-03-09": 217.4475999149515,
    "2025-03-10": 219.5857222189338,
    "2025-03-11": 221.72384452291607,
    "2025-03-12": 223.8619668268984,
    "2025-03-13": 226.00008913088064,
    "2025-03-14": 228.1382114348629,
    "2025-03-15": 230.2763337388452,
    "2025-03-16": 232.4144560428275,
    "2025-03-17": 234.55257834680975,
    "2025-03-18": 236.69070065079208,
    "2025-03-19": 238.82882295477435,
    "2025-03-20": 240.96694525875665,
    "2025-03-21": 243.10506756273887,
    "2025-03-22": 245.2431898667212,
    "2025-03-23": 247.3813121707035,
    "2025-03-24": 249.5194344746858,
    "2025-03-25": 251.65755677866807,
    "2025-03-26": 253.79567908265037,
    "2025-03-27": 255.93380138663264,
    "2025-03-28": 258.07192369061494,
    "2025-03-29": 260.2100459945972,
    "2025-03-30": 262.3481682985795,
    "2025-03-31": 264.4862906025618,
    "2025-04-01": 267.8985573745141,
    "2025-04-02": 271.3108241464664,
    "2025-04-03": 274.72309091841873,
    "2025-04-04": 278.135357690371,
    "2025-04-05": 281.5476244623233,
    "2025-04-06": 284.95989123427563,
    "2025-04-07": 288.37215800622795,
    "2025-04-08": 291.78442477818027,
    "2025-04-09": 295.1966915501326,
    "2025-04-10": 298.6089583220849,
    "2025-04-11": 302.0212250940372,
    "2025-04-12": 305.4334918659895,
    "2025-04-13": 308.8457586379418,
    "2025-04-14": 312.2580254098941,
    "2025-04-15": 315.67029218184643,
    "2025-04-16": 319.08255895379875,
    "2025-04-17": 322.49482572575107,
    "2025-04-18": 325.9070924977034,
    "2025-04-19": 329.3193592696557,
    "2025-04-20": 332.731626041608,
    "2025-04-21": 336.1438928135603,
    "2025-04-22": 339.5561595855126,
    "2025-04-23": 342.9684263574649,
    "2025-04-24": 346.38069312941724,
    "2025-04-25": 349.7929599013696,
    "2025-04-26": 353.2052266733218,
    "2025-04-27": 356.61749344527414,
    "2025-04-28": 360.02976021722645,
    "2025-04-29": 363.4420269891788,
    "2025-04-30": 366.8542937611311,
    "2025-05-01": 371.23283666222335,
    "2025-05-02": 375.6113795633156,
    "2025-05-03": 379.9899224644079,
    "2025-05-04": 384.3684653655001,
    "2025-05-05": 388.7470082665924,
    "2025-05-06": 393.1255511676847,
    "2025-05-07": 397.5040940687769,
    "2025-05-08": 401.8826369698692,
    "2025-05-09": 406.2611798709614,
    "2025-05-10": 410.6397227720537,
    "2025-05-11": 415.018265673146,
    "2025-05-12": 419.3968085742382,
    "2025-05-13": 423.77535147533047,
    "2025-05-14": 428.1538943764227,
    "2025-05-15": 432.532437277515,
    "2025-05-16": 436.9109801786073,
    "2025-05-17": 441.2895230796995,
    "2025-05-18": 445.66806598079177,
    "2025-05-19": 450.046608881884,
    "2025-05-20": 454.4251517829763,
    "2025-05-21": 458.80369468406855,
    "2025-05-22": 463.1822375851608,
    "2025-05-23": 467.56078048625307,
    "2025-05-24": 471.9393233873453,
    "2025-05-25": 476.3178662884376,
    "2025-05-26": 480.69640918952985,
    "2025-05-27": 485.0749520906221,
    "2025-05-28": 489.4534949917144,
    "2025-05-29": 493.8320378928066,
    "2025-05-30": 498.2105807938989,
    "2025-05-31": 502.5891236949912,
    "2025-06-01": 507.5495286713909,
    "2025-06-02": 512.5099336477906,
    "2025-06-03": 517.4703386241904,
    "2025-06-04": 522.4307436005901,
    "2025-06-05": 527.3911485769898,
    "2025-06-06": 532.3515535533895,
    "2025-06-07": 537.3119585297893,
    "2025-06-08": 542.2723635061891,
    "2025-06-09": 547.2327684825888,
    "2025-06-10": 552.1931734589886,
    "2025-06-11": 557.1535784353882,
    "2025-06-12": 562.113983411788,
    "2025-06-13": 567.0743883881877,
    "2025-06-14": 572.0347933645875,
    "2025-06-15": 576.9951983409871,
    "2025-06-16": 581.9556033173869,
    "2025-06-17": 586.9160082937867,
    "2025-06-18": 591.8764132701864,
    "2025-06-19": 596.8368182465862,
    "2025-06-20": 601.7972232229858,
    "2025-06-21": 606.7576281993856,
    "2025-06-22": 611.7180331757854,
    "2025-06-23": 616.6784381521851,
    "2025-06-24": 621.6388431285849,
    "2025-06-25": 626.5992481049846,
    "2025-06-26": 631.5596530813843,
    "2025-06-27": 636.5200580577841,
    "2025-06-28": 641.4804630341838,
    "2025-06-29": 646.4408680105835,
    "2025-06-30": 651.4012729869833,
    "2025-07-01": 656.16787092347,
    "2025-07-02": 660.9344688599566,
    "2025-07-03": 665.7010667964433,
    "2025-07-04": 670.46766473293,
    "2025-07-05": 675.2342626694167,
    "2025-07-06": 680.0008606059033,
    "2025-07-07": 684.76745854239,
    "2025-07-08": 689.5340564788768,
    "2025-07-09": 694.3006544153634,
    "2025-07-10": 699.0672523518501,
    "2025-07-11": 703.8338502883367,
    "2025-07-12": 708.6004482248235,
    "2025-07-13": 713.3670461613101,
    "2025-07-14": 718.1336440977968,
    "2025-07-15": 722.9002420342836,
    "2025-07-16": 727.6668399707702,
    "2025-07-17": 732.4334379072569,
    "2025-07-18": 737.2000358437435,
    "2025-07-19": 741.9666337802303,
    "2025-07-20": 746.733231716717,
    "2025-07-21": 751.4998296532036,
    "2025-07-22": 756.2664275896904,
    "2025-07-23": 761.033025526177,
    "2025-07-24": 765.7996234626637,
    "2025-07-25": 770.5662213991504,
    "2025-07-26": 775.332819335637,
    "2025-07-27": 780.0994172721237,
    "2025-07-28": 784.8660152086104,
    "2025-07-29": 789.6326131450971,
    "2025-07-30": 794.3992110815838,
    "2025-07-31": 799.1658090180705,
    "2025-08-01": 803.456875375452,
    "2025-08-02": 807.7479417328335,
    "2025-08-03": 812.0390080902149,
    "2025-08-04": 816.3300744475964,
    "2025-08-05": 820.6211408049779,
    "2025-08-06": 824.9122071623594,
    "2025-08-07": 829.203273519741,
    "2025-08-08": 833.4943398771223,
    "2025-08-09": 837.7854062345039,
    "2025-08-10": 842.0764725918854,
    "2025-08-11": 846.3675389492669,
    "2025-08-12": 850.6586053066484,
    "2025-08-13": 854.9496716640298,
    "2025-08-14": 859.2407380214113,
    "2025-08-15": 863.5318043787928,
    "2025-08-16": 867.8228707361743,
    "2025-08-17": 872.1139370935558,
    "2025-08-18": 876.4050034509373,
    "2025-08-19": 880.6960698083187,
    "2025-08-20": 884.9871361657002,
    "2025-08-21": 889.2782025230817,
    "2025-08-22": 893.5692688804633,
    "2025-08-23": 897.8603352378448,
    "2025-08-24": 902.1514015952262,
    "2025-08-25": 906.4424679526076,
    "2025-08-26": 910.7335343099892,
    "2025-08-27": 915.0246006673708,
    "2025-08-28": 919.3156670247522,
    "2025-08-29": 923.6067333821336,
    "2025-08-30": 927.8977997395152,
    "2025-08-31": 932.1888660968966,
    "2025-09-01": 935.5030342154602,
    "2025-09-02": 938.8172023340236,
    "2025-09-03": 942.1313704525874,
    "2025-09-04": 945.4455385711508,
    "2025-09-05": 948.7597066897144,
    "2025-09-06": 952.073874808278,
    "2025-09-07": 955.3880429268416,
    "2025-09-08": 958.7022110454052,
    "2025-09-09": 962.0163791639688,
    "2025-09-10": 965.3305472825324,
    "2025-09-11": 968.6447154010958,
    "2025-09-12": 971.9588835196594,
    "2025-09-13": 975.273051638223,
    "2025-09-14": 978.5872197567866,
    "2025-09-15": 981.90138787535,
    "2025-09-16": 985.2155559939137,
    "2025-09-17": 988.5297241124772,
    "2025-09-18": 991.8438922310409,
    "2025-09-19": 995.1580603496044,
    "2025-09-20": 998.472228468168,
    "2025-09-21": 1001.7863965867316,
    "2025-09-22": 1005.100564705295,
    "2025-09-23": 1008.4147328238588,
    "2025-09-24": 1011.7289009424222,
    "2025-09-25": 1015.0430690609858,
    "2025-09-26": 1018.3572371795492,
    "2025-09-27": 1021.6714052981127,
    "2025-09-28": 1024.9855734166763,
    "2025-09-29": 1028.29974153524,
    "2025-09-30": 1031.6139096538036,
  },
  Olives: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.122644116132687,
    "2024-10-03": 4.245288232265374,
    "2024-10-04": 6.367932348398062,
    "2024-10-05": 8.490576464530749,
    "2024-10-06": 10.613220580663436,
    "2024-10-07": 12.735864696796124,
    "2024-10-08": 14.858508812928813,
    "2024-10-09": 16.981152929061498,
    "2024-10-10": 19.103797045194185,
    "2024-10-11": 21.22644116132687,
    "2024-10-12": 23.34908527745956,
    "2024-10-13": 25.47172939359225,
    "2024-10-14": 27.59437350972493,
    "2024-10-15": 29.717017625857626,
    "2024-10-16": 31.83966174199031,
    "2024-10-17": 33.962305858123,
    "2024-10-18": 36.084949974255686,
    "2024-10-19": 38.20759409038837,
    "2024-10-20": 40.33023820652106,
    "2024-10-21": 42.45288232265374,
    "2024-10-22": 44.57552643878643,
    "2024-10-23": 46.69817055491912,
    "2024-10-24": 48.82081467105181,
    "2024-10-25": 50.9434587871845,
    "2024-10-26": 53.06610290331718,
    "2024-10-27": 55.18874701944987,
    "2024-10-28": 57.31139113558256,
    "2024-10-29": 59.43403525171525,
    "2024-10-30": 61.55667936784793,
    "2024-10-31": 63.67932348398062,
    "2024-11-01": 64.6336577091054,
    "2024-11-02": 65.58799193423019,
    "2024-11-03": 66.54232615935497,
    "2024-11-04": 67.49666038447975,
    "2024-11-05": 68.45099460960454,
    "2024-11-06": 69.40532883472932,
    "2024-11-07": 70.3596630598541,
    "2024-11-08": 71.31399728497888,
    "2024-11-09": 72.26833151010366,
    "2024-11-10": 73.22266573522845,
    "2024-11-11": 74.17699996035323,
    "2024-11-12": 75.13133418547801,
    "2024-11-13": 76.08566841060279,
    "2024-11-14": 77.04000263572757,
    "2024-11-15": 77.99433686085236,
    "2024-11-16": 78.94867108597714,
    "2024-11-17": 79.90300531110192,
    "2024-11-18": 80.8573395362267,
    "2024-11-19": 81.8116737613515,
    "2024-11-20": 82.76600798647627,
    "2024-11-21": 83.72034221160106,
    "2024-11-22": 84.67467643672583,
    "2024-11-23": 85.62901066185063,
    "2024-11-24": 86.5833448869754,
    "2024-11-25": 87.5376791121002,
    "2024-11-26": 88.49201333722498,
    "2024-11-27": 89.44634756234976,
    "2024-11-28": 90.40068178747454,
    "2024-11-29": 91.35501601259932,
    "2024-11-30": 92.3093502377241,
    "2024-12-01": 92.92783925181148,
    "2024-12-02": 93.54632826589888,
    "2024-12-03": 94.16481727998628,
    "2024-12-04": 94.78330629407364,
    "2024-12-05": 95.40179530816104,
    "2024-12-06": 96.02028432224844,
    "2024-12-07": 96.63877333633582,
    "2024-12-08": 97.2572623504232,
    "2024-12-09": 97.8757513645106,
    "2024-12-10": 98.49424037859798,
    "2024-12-11": 99.11272939268537,
    "2024-12-12": 99.73121840677275,
    "2024-12-13": 100.34970742086014,
    "2024-12-14": 100.96819643494752,
    "2024-12-15": 101.58668544903492,
    "2024-12-16": 102.2051744631223,
    "2024-12-17": 102.82366347720968,
    "2024-12-18": 103.44215249129708,
    "2024-12-19": 104.06064150538448,
    "2024-12-20": 104.67913051947184,
    "2024-12-21": 105.29761953355924,
    "2024-12-22": 105.91610854764664,
    "2024-12-23": 106.53459756173402,
    "2024-12-24": 107.1530865758214,
    "2024-12-25": 107.7715755899088,
    "2024-12-26": 108.39006460399618,
    "2024-12-27": 109.00855361808355,
    "2024-12-28": 109.62704263217096,
    "2024-12-29": 110.24553164625834,
    "2024-12-30": 110.86402066034572,
    "2024-12-31": 111.48250967443312,
    "2025-01-01": 112.20104587163236,
    "2025-01-02": 112.91958206883164,
    "2025-01-03": 113.63811826603089,
    "2025-01-04": 114.35665446323011,
    "2025-01-05": 115.0751906604294,
    "2025-01-06": 115.79372685762864,
    "2025-01-07": 116.5122630548279,
    "2025-01-08": 117.23079925202715,
    "2025-01-09": 117.9493354492264,
    "2025-01-10": 118.66787164642568,
    "2025-01-11": 119.38640784362492,
    "2025-01-12": 120.10494404082417,
    "2025-01-13": 120.82348023802342,
    "2025-01-14": 121.54201643522268,
    "2025-01-15": 122.26055263242192,
    "2025-01-16": 122.9790888296212,
    "2025-01-17": 123.69762502682045,
    "2025-01-18": 124.4161612240197,
    "2025-01-19": 125.13469742121896,
    "2025-01-20": 125.8532336184182,
    "2025-01-21": 126.57176981561746,
    "2025-01-22": 127.29030601281671,
    "2025-01-23": 128.00884221001598,
    "2025-01-24": 128.7273784072152,
    "2025-01-25": 129.44591460441447,
    "2025-01-26": 130.16445080161373,
    "2025-01-27": 130.88298699881298,
    "2025-01-28": 131.60152319601224,
    "2025-01-29": 132.3200593932115,
    "2025-01-30": 133.03859559041075,
    "2025-01-31": 133.75713178761,
    "2025-02-01": 135.162940713588,
    "2025-02-02": 136.568749639566,
    "2025-02-03": 137.974558565544,
    "2025-02-04": 139.38036749152198,
    "2025-02-05": 140.78617641749997,
    "2025-02-06": 142.19198534347797,
    "2025-02-07": 143.59779426945596,
    "2025-02-08": 145.00360319543395,
    "2025-02-09": 146.40941212141195,
    "2025-02-10": 147.81522104738994,
    "2025-02-11": 149.22102997336793,
    "2025-02-12": 150.62683889934593,
    "2025-02-13": 152.03264782532392,
    "2025-02-14": 153.4384567513019,
    "2025-02-15": 154.8442656772799,
    "2025-02-16": 156.2500746032579,
    "2025-02-17": 157.6558835292359,
    "2025-02-18": 159.0616924552139,
    "2025-02-19": 160.46750138119188,
    "2025-02-20": 161.87331030716987,
    "2025-02-21": 163.27911923314787,
    "2025-02-22": 164.68492815912586,
    "2025-02-23": 166.09073708510385,
    "2025-02-24": 167.49654601108185,
    "2025-02-25": 168.90235493705984,
    "2025-02-26": 170.30816386303783,
    "2025-02-27": 171.71397278901583,
    "2025-02-28": 173.11978171499382,
    "2025-03-01": 174.96489655442687,
    "2025-03-02": 176.81001139385992,
    "2025-03-03": 178.655126233293,
    "2025-03-04": 180.50024107272608,
    "2025-03-05": 182.3453559121591,
    "2025-03-06": 184.19047075159216,
    "2025-03-07": 186.0355855910252,
    "2025-03-08": 187.8807004304583,
    "2025-03-09": 189.7258152698913,
    "2025-03-10": 191.5709301093244,
    "2025-03-11": 193.41604494875745,
    "2025-03-12": 195.2611597881905,
    "2025-03-13": 197.1062746276236,
    "2025-03-14": 198.95138946705663,
    "2025-03-15": 200.79650430648968,
    "2025-03-16": 202.64161914592276,
    "2025-03-17": 204.48673398535576,
    "2025-03-18": 206.33184882478884,
    "2025-03-19": 208.17696366422192,
    "2025-03-20": 210.02207850365497,
    "2025-03-21": 211.867193343088,
    "2025-03-22": 213.71230818252107,
    "2025-03-23": 215.55742302195412,
    "2025-03-24": 217.4025378613872,
    "2025-03-25": 219.24765270082025,
    "2025-03-26": 221.0927675402533,
    "2025-03-27": 222.9378823796864,
    "2025-03-28": 224.7829972191194,
    "2025-03-29": 226.6281120585525,
    "2025-03-30": 228.47322689798557,
    "2025-03-31": 230.3183417374186,
    "2025-04-01": 232.9448014658412,
    "2025-04-02": 235.57126119426383,
    "2025-04-03": 238.19772092268644,
    "2025-04-04": 240.82418065110903,
    "2025-04-05": 243.4506403795317,
    "2025-04-06": 246.07710010795432,
    "2025-04-07": 248.7035598363769,
    "2025-04-08": 251.3300195647996,
    "2025-04-09": 253.95647929322217,
    "2025-04-10": 256.5829390216448,
    "2025-04-11": 259.2093987500674,
    "2025-04-12": 261.83585847849,
    "2025-04-13": 264.46231820691264,
    "2025-04-14": 267.08877793533526,
    "2025-04-15": 269.7152376637579,
    "2025-04-16": 272.3416973921805,
    "2025-04-17": 274.9681571206031,
    "2025-04-18": 277.5946168490257,
    "2025-04-19": 280.22107657744834,
    "2025-04-20": 282.847536305871,
    "2025-04-21": 285.4739960342936,
    "2025-04-22": 288.10045576271625,
    "2025-04-23": 290.72691549113887,
    "2025-04-24": 293.3533752195615,
    "2025-04-25": 295.9798349479841,
    "2025-04-26": 298.6062946764067,
    "2025-04-27": 301.23275440482934,
    "2025-04-28": 303.85921413325195,
    "2025-04-29": 306.48567386167457,
    "2025-04-30": 309.1121335900972,
    "2025-05-01": 312.3881959378231,
    "2025-05-02": 315.6642582855491,
    "2025-05-03": 318.94032063327506,
    "2025-05-04": 322.21638298100106,
    "2025-05-05": 325.492445328727,
    "2025-05-06": 328.76850767645294,
    "2025-05-07": 332.04457002417894,
    "2025-05-08": 335.3206323719049,
    "2025-05-09": 338.5966947196308,
    "2025-05-10": 341.8727570673568,
    "2025-05-11": 345.1488194150828,
    "2025-05-12": 348.42488176280875,
    "2025-05-13": 351.7009441105347,
    "2025-05-14": 354.9770064582607,
    "2025-05-15": 358.25306880598663,
    "2025-05-16": 361.52913115371257,
    "2025-05-17": 364.80519350143857,
    "2025-05-18": 368.0812558491645,
    "2025-05-19": 371.3573181968905,
    "2025-05-20": 374.6333805446165,
    "2025-05-21": 377.9094428923424,
    "2025-05-22": 381.1855052400683,
    "2025-05-23": 384.4615675877943,
    "2025-05-24": 387.7376299355203,
    "2025-05-25": 391.0136922832463,
    "2025-05-26": 394.2897546309722,
    "2025-05-27": 397.5658169786982,
    "2025-05-28": 400.8418793264241,
    "2025-05-29": 404.1179416741501,
    "2025-05-30": 407.39400402187607,
    "2025-05-31": 410.670066369602,
    "2025-06-01": 414.6239873087296,
    "2025-06-02": 418.5779082478573,
    "2025-06-03": 422.5318291869849,
    "2025-06-04": 426.4857501261124,
    "2025-06-05": 430.43967106524,
    "2025-06-06": 434.3935920043676,
    "2025-06-07": 438.3475129434953,
    "2025-06-08": 442.30143388262286,
    "2025-06-09": 446.2553548217504,
    "2025-06-10": 450.209275760878,
    "2025-06-11": 454.1631967000056,
    "2025-06-12": 458.11711763913326,
    "2025-06-13": 462.07103857826087,
    "2025-06-14": 466.0249595173885,
    "2025-06-15": 469.9788804565161,
    "2025-06-16": 473.9328013956437,
    "2025-06-17": 477.88672233477126,
    "2025-06-18": 481.8406432738989,
    "2025-06-19": 485.7945642130265,
    "2025-06-20": 489.7484851521541,
    "2025-06-21": 493.70240609128166,
    "2025-06-22": 497.6563270304093,
    "2025-06-23": 501.6102479695369,
    "2025-06-24": 505.5641689086645,
    "2025-06-25": 509.5180898477921,
    "2025-06-26": 513.4720107869197,
    "2025-06-27": 517.4259317260473,
    "2025-06-28": 521.3798526651749,
    "2025-06-29": 525.3337736043026,
    "2025-06-30": 529.2876945434301,
    "2025-07-01": 533.2929843206498,
    "2025-07-02": 537.2982740978696,
    "2025-07-03": 541.3035638750893,
    "2025-07-04": 545.308853652309,
    "2025-07-05": 549.3141434295287,
    "2025-07-06": 553.3194332067485,
    "2025-07-07": 557.3247229839682,
    "2025-07-08": 561.330012761188,
    "2025-07-09": 565.3353025384076,
    "2025-07-10": 569.3405923156274,
    "2025-07-11": 573.3458820928471,
    "2025-07-12": 577.3511718700669,
    "2025-07-13": 581.3564616472866,
    "2025-07-14": 585.3617514245063,
    "2025-07-15": 589.367041201726,
    "2025-07-16": 593.3723309789458,
    "2025-07-17": 597.3776207561655,
    "2025-07-18": 601.3829105333853,
    "2025-07-19": 605.3882003106049,
    "2025-07-20": 609.3934900878247,
    "2025-07-21": 613.3987798650444,
    "2025-07-22": 617.4040696422642,
    "2025-07-23": 621.4093594194838,
    "2025-07-24": 625.4146491967036,
    "2025-07-25": 629.4199389739233,
    "2025-07-26": 633.4252287511431,
    "2025-07-27": 637.4305185283628,
    "2025-07-28": 641.4358083055824,
    "2025-07-29": 645.4410980828022,
    "2025-07-30": 649.446387860022,
    "2025-07-31": 653.4516776372417,
    "2025-08-01": 658.0135857509234,
    "2025-08-02": 662.5754938646053,
    "2025-08-03": 667.137401978287,
    "2025-08-04": 671.6993100919688,
    "2025-08-05": 676.2612182056506,
    "2025-08-06": 680.8231263193323,
    "2025-08-07": 685.3850344330141,
    "2025-08-08": 689.9469425466959,
    "2025-08-09": 694.5088506603777,
    "2025-08-10": 699.0707587740594,
    "2025-08-11": 703.6326668877412,
    "2025-08-12": 708.194575001423,
    "2025-08-13": 712.7564831151047,
    "2025-08-14": 717.3183912287866,
    "2025-08-15": 721.8802993424683,
    "2025-08-16": 726.4422074561501,
    "2025-08-17": 731.0041155698318,
    "2025-08-18": 735.5660236835137,
    "2025-08-19": 740.1279317971954,
    "2025-08-20": 744.6898399108771,
    "2025-08-21": 749.251748024559,
    "2025-08-22": 753.8136561382407,
    "2025-08-23": 758.3755642519225,
    "2025-08-24": 762.9374723656043,
    "2025-08-25": 767.4993804792861,
    "2025-08-26": 772.0612885929678,
    "2025-08-27": 776.6231967066497,
    "2025-08-28": 781.1851048203314,
    "2025-08-29": 785.7470129340131,
    "2025-08-30": 790.3089210476949,
    "2025-08-31": 794.8708291613767,
    "2025-09-01": 797.6861987394203,
    "2025-09-02": 800.5015683174639,
    "2025-09-03": 803.3169378955076,
    "2025-09-04": 806.1323074735512,
    "2025-09-05": 808.9476770515948,
    "2025-09-06": 811.7630466296384,
    "2025-09-07": 814.578416207682,
    "2025-09-08": 817.3937857857256,
    "2025-09-09": 820.2091553637692,
    "2025-09-10": 823.024524941813,
    "2025-09-11": 825.8398945198566,
    "2025-09-12": 828.6552640979002,
    "2025-09-13": 831.4706336759438,
    "2025-09-14": 834.2860032539874,
    "2025-09-15": 837.1013728320311,
    "2025-09-16": 839.9167424100747,
    "2025-09-17": 842.7321119881183,
    "2025-09-18": 845.5474815661619,
    "2025-09-19": 848.3628511442055,
    "2025-09-20": 851.1782207222491,
    "2025-09-21": 853.9935903002927,
    "2025-09-22": 856.8089598783364,
    "2025-09-23": 859.62432945638,
    "2025-09-24": 862.4396990344236,
    "2025-09-25": 865.2550686124672,
    "2025-09-26": 868.0704381905108,
    "2025-09-27": 870.8858077685545,
    "2025-09-28": 873.7011773465981,
    "2025-09-29": 876.5165469246417,
    "2025-09-30": 879.3319165026853,
  },
  "Peaches/Nectarines": {
    "2024-10-01": 0.0,
    "2024-10-02": 2.3067463342113057,
    "2024-10-03": 4.613492668422611,
    "2024-10-04": 6.920239002633917,
    "2024-10-05": 9.226985336845225,
    "2024-10-06": 11.533731671056527,
    "2024-10-07": 13.840478005267832,
    "2024-10-08": 16.14722433947914,
    "2024-10-09": 18.45397067369045,
    "2024-10-10": 20.76071700790175,
    "2024-10-11": 23.067463342113054,
    "2024-10-12": 25.37420967632436,
    "2024-10-13": 27.680956010535667,
    "2024-10-14": 29.98770234474697,
    "2024-10-15": 32.29444867895828,
    "2024-10-16": 34.60119501316959,
    "2024-10-17": 36.90794134738089,
    "2024-10-18": 39.2146876815922,
    "2024-10-19": 41.5214340158035,
    "2024-10-20": 43.82818035001481,
    "2024-10-21": 46.13492668422612,
    "2024-10-22": 48.44167301843742,
    "2024-10-23": 50.748419352648725,
    "2024-10-24": 53.05516568686003,
    "2024-10-25": 55.36191202107133,
    "2024-10-26": 57.668658355282645,
    "2024-10-27": 59.97540468949395,
    "2024-10-28": 62.28215102370525,
    "2024-10-29": 64.58889735791657,
    "2024-10-30": 66.89564369212786,
    "2024-10-31": 69.20239002633917,
    "2024-11-01": 69.95460304755102,
    "2024-11-02": 70.70681606876286,
    "2024-11-03": 71.4590290899747,
    "2024-11-04": 72.21124211118656,
    "2024-11-05": 72.96345513239841,
    "2024-11-06": 73.71566815361025,
    "2024-11-07": 74.4678811748221,
    "2024-11-08": 75.22009419603394,
    "2024-11-09": 75.97230721724578,
    "2024-11-10": 76.72452023845763,
    "2024-11-11": 77.47673325966949,
    "2024-11-12": 78.22894628088133,
    "2024-11-13": 78.98115930209318,
    "2024-11-14": 79.73337232330502,
    "2024-11-15": 80.48558534451686,
    "2024-11-16": 81.23779836572871,
    "2024-11-17": 81.99001138694055,
    "2024-11-18": 82.7422244081524,
    "2024-11-19": 83.49443742936424,
    "2024-11-20": 84.2466504505761,
    "2024-11-21": 84.99886347178794,
    "2024-11-22": 85.75107649299979,
    "2024-11-23": 86.50328951421163,
    "2024-11-24": 87.25550253542347,
    "2024-11-25": 88.00771555663532,
    "2024-11-26": 88.75992857784718,
    "2024-11-27": 89.51214159905902,
    "2024-11-28": 90.26435462027086,
    "2024-11-29": 91.01656764148272,
    "2024-11-30": 91.76878066269455,
    "2024-12-01": 92.16410391770712,
    "2024-12-02": 92.5594271727197,
    "2024-12-03": 92.95475042773226,
    "2024-12-04": 93.35007368274483,
    "2024-12-05": 93.7453969377574,
    "2024-12-06": 94.14072019276998,
    "2024-12-07": 94.53604344778256,
    "2024-12-08": 94.93136670279512,
    "2024-12-09": 95.32668995780767,
    "2024-12-10": 95.72201321282026,
    "2024-12-11": 96.11733646783284,
    "2024-12-12": 96.5126597228454,
    "2024-12-13": 96.90798297785796,
    "2024-12-14": 97.30330623287054,
    "2024-12-15": 97.6986294878831,
    "2024-12-16": 98.09395274289568,
    "2024-12-17": 98.48927599790824,
    "2024-12-18": 98.8845992529208,
    "2024-12-19": 99.27992250793338,
    "2024-12-20": 99.67524576294596,
    "2024-12-21": 100.07056901795852,
    "2024-12-22": 100.46589227297108,
    "2024-12-23": 100.86121552798366,
    "2024-12-24": 101.25653878299624,
    "2024-12-25": 101.6518620380088,
    "2024-12-26": 102.04718529302136,
    "2024-12-27": 102.44250854803394,
    "2024-12-28": 102.83783180304653,
    "2024-12-29": 103.23315505805908,
    "2024-12-30": 103.62847831307164,
    "2024-12-31": 104.02380156808422,
    "2025-01-01": 104.63036658267322,
    "2025-01-02": 105.23693159726224,
    "2025-01-03": 105.84349661185122,
    "2025-01-04": 106.45006162644022,
    "2025-01-05": 107.05662664102924,
    "2025-01-06": 107.66319165561822,
    "2025-01-07": 108.26975667020722,
    "2025-01-08": 108.87632168479622,
    "2025-01-09": 109.48288669938522,
    "2025-01-10": 110.08945171397424,
    "2025-01-11": 110.69601672856322,
    "2025-01-12": 111.30258174315222,
    "2025-01-13": 111.90914675774124,
    "2025-01-14": 112.51571177233022,
    "2025-01-15": 113.12227678691922,
    "2025-01-16": 113.72884180150822,
    "2025-01-17": 114.33540681609722,
    "2025-01-18": 114.9419718306862,
    "2025-01-19": 115.54853684527522,
    "2025-01-20": 116.15510185986422,
    "2025-01-21": 116.7616668744532,
    "2025-01-22": 117.36823188904222,
    "2025-01-23": 117.97479690363122,
    "2025-01-24": 118.5813619182202,
    "2025-01-25": 119.18792693280922,
    "2025-01-26": 119.7944919473982,
    "2025-01-27": 120.40105696198722,
    "2025-01-28": 121.00762197657622,
    "2025-01-29": 121.6141869911652,
    "2025-01-30": 122.2207520057542,
    "2025-01-31": 122.82731702034322,
    "2025-02-01": 123.9938722433348,
    "2025-02-02": 125.16042746632638,
    "2025-02-03": 126.32698268931796,
    "2025-02-04": 127.49353791230952,
    "2025-02-05": 128.6600931353011,
    "2025-02-06": 129.8266483582927,
    "2025-02-07": 130.9932035812843,
    "2025-02-08": 132.15975880427587,
    "2025-02-09": 133.32631402726744,
    "2025-02-10": 134.49286925025902,
    "2025-02-11": 135.6594244732506,
    "2025-02-12": 136.8259796962422,
    "2025-02-13": 137.99253491923378,
    "2025-02-14": 139.15909014222535,
    "2025-02-15": 140.32564536521693,
    "2025-02-16": 141.4922005882085,
    "2025-02-17": 142.65875581120008,
    "2025-02-18": 143.82531103419166,
    "2025-02-19": 144.99186625718326,
    "2025-02-20": 146.15842148017484,
    "2025-02-21": 147.3249767031664,
    "2025-02-22": 148.491531926158,
    "2025-02-23": 149.65808714914957,
    "2025-02-24": 150.82464237214117,
    "2025-02-25": 151.99119759513275,
    "2025-02-26": 153.15775281812432,
    "2025-02-27": 154.3243080411159,
    "2025-02-28": 155.49086326410747,
    "2025-03-01": 157.39880858253608,
    "2025-03-02": 159.30675390096468,
    "2025-03-03": 161.2146992193933,
    "2025-03-04": 163.1226445378219,
    "2025-03-05": 165.03058985625051,
    "2025-03-06": 166.93853517467912,
    "2025-03-07": 168.84648049310775,
    "2025-03-08": 170.75442581153635,
    "2025-03-09": 172.66237112996495,
    "2025-03-10": 174.57031644839356,
    "2025-03-11": 176.4782617668222,
    "2025-03-12": 178.3862070852508,
    "2025-03-13": 180.2941524036794,
    "2025-03-14": 182.202097722108,
    "2025-03-15": 184.1100430405366,
    "2025-03-16": 186.01798835896523,
    "2025-03-17": 187.92593367739383,
    "2025-03-18": 189.83387899582243,
    "2025-03-19": 191.74182431425103,
    "2025-03-20": 193.64976963267964,
    "2025-03-21": 195.55771495110827,
    "2025-03-22": 197.46566026953687,
    "2025-03-23": 199.37360558796547,
    "2025-03-24": 201.2815509063941,
    "2025-03-25": 203.1894962248227,
    "2025-03-26": 205.0974415432513,
    "2025-03-27": 207.0053868616799,
    "2025-03-28": 208.9133321801085,
    "2025-03-29": 210.82127749853717,
    "2025-03-30": 212.72922281696572,
    "2025-03-31": 214.63716813539435,
    "2025-04-01": 218.34170019241475,
    "2025-04-02": 222.04623224943515,
    "2025-04-03": 225.75076430645555,
    "2025-04-04": 229.45529636347595,
    "2025-04-05": 233.15982842049635,
    "2025-04-06": 236.86436047751675,
    "2025-04-07": 240.5688925345372,
    "2025-04-08": 244.2734245915576,
    "2025-04-09": 247.977956648578,
    "2025-04-10": 251.6824887055984,
    "2025-04-11": 255.38702076261876,
    "2025-04-12": 259.0915528196392,
    "2025-04-13": 262.7960848766596,
    "2025-04-14": 266.5006169336799,
    "2025-04-15": 270.2051489907003,
    "2025-04-16": 273.9096810477207,
    "2025-04-17": 277.6142131047411,
    "2025-04-18": 281.3187451617615,
    "2025-04-19": 285.0232772187819,
    "2025-04-20": 288.7278092758023,
    "2025-04-21": 292.4323413328227,
    "2025-04-22": 296.1368733898431,
    "2025-04-23": 299.8414054468635,
    "2025-04-24": 303.5459375038839,
    "2025-04-25": 307.2504695609043,
    "2025-04-26": 310.9550016179247,
    "2025-04-27": 314.6595336749451,
    "2025-04-28": 318.3640657319655,
    "2025-04-29": 322.0685977889859,
    "2025-04-30": 325.7731298460063,
    "2025-05-01": 330.50716799090424,
    "2025-05-02": 335.2412061358022,
    "2025-05-03": 339.9752442807001,
    "2025-05-04": 344.709282425598,
    "2025-05-05": 349.443320570496,
    "2025-05-06": 354.1773587153939,
    "2025-05-07": 358.9113968602918,
    "2025-05-08": 363.64543500518977,
    "2025-05-09": 368.3794731500877,
    "2025-05-10": 373.1135112949856,
    "2025-05-11": 377.8475494398836,
    "2025-05-12": 382.5815875847815,
    "2025-05-13": 387.31562572967937,
    "2025-05-14": 392.0496638745773,
    "2025-05-15": 396.7837020194752,
    "2025-05-16": 401.5177401643732,
    "2025-05-17": 406.2517783092711,
    "2025-05-18": 410.985816454169,
    "2025-05-19": 415.7198545990669,
    "2025-05-20": 420.4538927439648,
    "2025-05-21": 425.1879308888628,
    "2025-05-22": 429.9219690337607,
    "2025-05-23": 434.6560071786587,
    "2025-05-24": 439.3900453235566,
    "2025-05-25": 444.1240834684545,
    "2025-05-26": 448.8581216133524,
    "2025-05-27": 453.5921597582504,
    "2025-05-28": 458.3261979031483,
    "2025-05-29": 463.0602360480463,
    "2025-05-30": 467.79427419294416,
    "2025-05-31": 472.52831233784207,
    "2025-06-01": 478.6066182634838,
    "2025-06-02": 484.6849241891255,
    "2025-06-03": 490.7632301147673,
    "2025-06-04": 496.841536040409,
    "2025-06-05": 502.9198419660508,
    "2025-06-06": 508.9981478916925,
    "2025-06-07": 515.0764538173343,
    "2025-06-08": 521.154759742976,
    "2025-06-09": 527.2330656686178,
    "2025-06-10": 533.3113715942595,
    "2025-06-11": 539.3896775199012,
    "2025-06-12": 545.4679834455429,
    "2025-06-13": 551.5462893711847,
    "2025-06-14": 557.6245952968264,
    "2025-06-15": 563.7029012224682,
    "2025-06-16": 569.78120714811,
    "2025-06-17": 575.8595130737517,
    "2025-06-18": 581.9378189993935,
    "2025-06-19": 588.0161249250352,
    "2025-06-20": 594.0944308506769,
    "2025-06-21": 600.1727367763186,
    "2025-06-22": 606.2510427019604,
    "2025-06-23": 612.3293486276021,
    "2025-06-24": 618.4076545532439,
    "2025-06-25": 624.4859604788857,
    "2025-06-26": 630.5642664045274,
    "2025-06-27": 636.6425723301691,
    "2025-06-28": 642.7208782558108,
    "2025-06-29": 648.7991841814526,
    "2025-06-30": 654.8774901070943,
    "2025-07-01": 661.0770568606166,
    "2025-07-02": 667.2766236141388,
    "2025-07-03": 673.476190367661,
    "2025-07-04": 679.6757571211832,
    "2025-07-05": 685.8753238747055,
    "2025-07-06": 692.0748906282276,
    "2025-07-07": 698.2744573817499,
    "2025-07-08": 704.4740241352721,
    "2025-07-09": 710.6735908887944,
    "2025-07-10": 716.8731576423165,
    "2025-07-11": 723.0727243958388,
    "2025-07-12": 729.2722911493611,
    "2025-07-13": 735.4718579028832,
    "2025-07-14": 741.6714246564055,
    "2025-07-15": 747.8709914099277,
    "2025-07-16": 754.07055816345,
    "2025-07-17": 760.2701249169721,
    "2025-07-18": 766.4696916704944,
    "2025-07-19": 772.6692584240166,
    "2025-07-20": 778.8688251775388,
    "2025-07-21": 785.0683919310611,
    "2025-07-22": 791.2679586845833,
    "2025-07-23": 797.4675254381054,
    "2025-07-24": 803.6670921916277,
    "2025-07-25": 809.86665894515,
    "2025-07-26": 816.0662256986722,
    "2025-07-27": 822.2657924521944,
    "2025-07-28": 828.4653592057166,
    "2025-07-29": 834.6649259592389,
    "2025-07-30": 840.8644927127611,
    "2025-07-31": 847.0640594662833,
    "2025-08-01": 852.0633434020729,
    "2025-08-02": 857.0626273378624,
    "2025-08-03": 862.061911273652,
    "2025-08-04": 867.0611952094415,
    "2025-08-05": 872.060479145231,
    "2025-08-06": 877.0597630810205,
    "2025-08-07": 882.05904701681,
    "2025-08-08": 887.0583309525996,
    "2025-08-09": 892.0576148883891,
    "2025-08-10": 897.0568988241787,
    "2025-08-11": 902.0561827599682,
    "2025-08-12": 907.0554666957578,
    "2025-08-13": 912.0547506315472,
    "2025-08-14": 917.0540345673368,
    "2025-08-15": 922.0533185031264,
    "2025-08-16": 927.052602438916,
    "2025-08-17": 932.0518863747054,
    "2025-08-18": 937.051170310495,
    "2025-08-19": 942.0504542462844,
    "2025-08-20": 947.049738182074,
    "2025-08-21": 952.0490221178636,
    "2025-08-22": 957.0483060536532,
    "2025-08-23": 962.0475899894428,
    "2025-08-24": 967.0468739252324,
    "2025-08-25": 972.0461578610218,
    "2025-08-26": 977.0454417968112,
    "2025-08-27": 982.0447257326008,
    "2025-08-28": 987.0440096683903,
    "2025-08-29": 992.04329360418,
    "2025-08-30": 997.0425775399694,
    "2025-08-31": 1002.041861475759,
    "2025-09-01": 1005.8294961081816,
    "2025-09-02": 1009.617130740604,
    "2025-09-03": 1013.4047653730264,
    "2025-09-04": 1017.1924000054488,
    "2025-09-05": 1020.9800346378714,
    "2025-09-06": 1024.767669270294,
    "2025-09-07": 1028.5553039027163,
    "2025-09-08": 1032.342938535139,
    "2025-09-09": 1036.1305731675614,
    "2025-09-10": 1039.918207799984,
    "2025-09-11": 1043.7058424324064,
    "2025-09-12": 1047.4934770648288,
    "2025-09-13": 1051.2811116972514,
    "2025-09-14": 1055.0687463296738,
    "2025-09-15": 1058.8563809620964,
    "2025-09-16": 1062.6440155945188,
    "2025-09-17": 1066.4316502269414,
    "2025-09-18": 1070.2192848593638,
    "2025-09-19": 1074.0069194917862,
    "2025-09-20": 1077.7945541242088,
    "2025-09-21": 1081.5821887566312,
    "2025-09-22": 1085.369823389054,
    "2025-09-23": 1089.1574580214765,
    "2025-09-24": 1092.9450926538989,
    "2025-09-25": 1096.7327272863213,
    "2025-09-26": 1100.5203619187437,
    "2025-09-27": 1104.3079965511663,
    "2025-09-28": 1108.0956311835887,
    "2025-09-29": 1111.883265816011,
    "2025-09-30": 1115.6709004484337,
  },
  Pears: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.5055841012286324,
    "2024-10-03": 5.011168202457265,
    "2024-10-04": 7.516752303685897,
    "2024-10-05": 10.02233640491453,
    "2024-10-06": 12.52792050614316,
    "2024-10-07": 15.033504607371794,
    "2024-10-08": 17.539088708600428,
    "2024-10-09": 20.04467280982906,
    "2024-10-10": 22.55025691105769,
    "2024-10-11": 25.05584101228632,
    "2024-10-12": 27.56142511351496,
    "2024-10-13": 30.06700921474359,
    "2024-10-14": 32.57259331597222,
    "2024-10-15": 35.078177417200855,
    "2024-10-16": 37.58376151842948,
    "2024-10-17": 40.08934561965812,
    "2024-10-18": 42.59492972088675,
    "2024-10-19": 45.10051382211538,
    "2024-10-20": 47.60609792334402,
    "2024-10-21": 50.11168202457264,
    "2024-10-22": 52.61726612580128,
    "2024-10-23": 55.12285022702992,
    "2024-10-24": 57.62843432825854,
    "2024-10-25": 60.13401842948718,
    "2024-10-26": 62.63960253071581,
    "2024-10-27": 65.14518663194444,
    "2024-10-28": 67.65077073317308,
    "2024-10-29": 70.15635483440171,
    "2024-10-30": 72.66193893563035,
    "2024-10-31": 75.16752303685897,
    "2024-11-01": 75.90270213473633,
    "2024-11-02": 76.63788123261368,
    "2024-11-03": 77.37306033049104,
    "2024-11-04": 78.1082394283684,
    "2024-11-05": 78.84341852624576,
    "2024-11-06": 79.57859762412312,
    "2024-11-07": 80.31377672200047,
    "2024-11-08": 81.04895581987783,
    "2024-11-09": 81.7841349177552,
    "2024-11-10": 82.51931401563255,
    "2024-11-11": 83.25449311350991,
    "2024-11-12": 83.98967221138727,
    "2024-11-13": 84.72485130926462,
    "2024-11-14": 85.46003040714199,
    "2024-11-15": 86.19520950501933,
    "2024-11-16": 86.9303886028967,
    "2024-11-17": 87.66556770077406,
    "2024-11-18": 88.40074679865141,
    "2024-11-19": 89.13592589652878,
    "2024-11-20": 89.87110499440614,
    "2024-11-21": 90.60628409228347,
    "2024-11-22": 91.34146319016084,
    "2024-11-23": 92.07664228803822,
    "2024-11-24": 92.81182138591556,
    "2024-11-25": 93.54700048379291,
    "2024-11-26": 94.28217958167028,
    "2024-11-27": 95.01735867954764,
    "2024-11-28": 95.752537777425,
    "2024-11-29": 96.48771687530235,
    "2024-11-30": 97.22289597317972,
    "2024-12-01": 97.6294540038312,
    "2024-12-02": 98.03601203448264,
    "2024-12-03": 98.4425700651341,
    "2024-12-04": 98.84912809578556,
    "2024-12-05": 99.25568612643704,
    "2024-12-06": 99.66224415708848,
    "2024-12-07": 100.06880218773996,
    "2024-12-08": 100.47536021839142,
    "2024-12-09": 100.88191824904288,
    "2024-12-10": 101.28847627969434,
    "2024-12-11": 101.6950343103458,
    "2024-12-12": 102.10159234099726,
    "2024-12-13": 102.50815037164872,
    "2024-12-14": 102.91470840230018,
    "2024-12-15": 103.32126643295165,
    "2024-12-16": 103.7278244636031,
    "2024-12-17": 104.13438249425457,
    "2024-12-18": 104.54094052490603,
    "2024-12-19": 104.94749855555747,
    "2024-12-20": 105.35405658620896,
    "2024-12-21": 105.7606146168604,
    "2024-12-22": 106.16717264751188,
    "2024-12-23": 106.57373067816332,
    "2024-12-24": 106.9802887088148,
    "2024-12-25": 107.38684673946624,
    "2024-12-26": 107.79340477011772,
    "2024-12-27": 108.1999628007692,
    "2024-12-28": 108.60652083142064,
    "2024-12-29": 109.0130788620721,
    "2024-12-30": 109.41963689272356,
    "2024-12-31": 109.82619492337504,
    "2025-01-01": 110.42212057618266,
    "2025-01-02": 111.0180462289903,
    "2025-01-03": 111.61397188179792,
    "2025-01-04": 112.20989753460556,
    "2025-01-05": 112.8058231874132,
    "2025-01-06": 113.40174884022083,
    "2025-01-07": 113.99767449302848,
    "2025-01-08": 114.59360014583608,
    "2025-01-09": 115.18952579864371,
    "2025-01-10": 115.78545145145137,
    "2025-01-11": 116.381377104259,
    "2025-01-12": 116.97730275706664,
    "2025-01-13": 117.57322840987426,
    "2025-01-14": 118.1691540626819,
    "2025-01-15": 118.76507971548952,
    "2025-01-16": 119.36100536829716,
    "2025-01-17": 119.9569310211048,
    "2025-01-18": 120.55285667391244,
    "2025-01-19": 121.14878232672008,
    "2025-01-20": 121.7447079795277,
    "2025-01-21": 122.34063363233534,
    "2025-01-22": 122.93655928514298,
    "2025-01-23": 123.5324849379506,
    "2025-01-24": 124.12841059075824,
    "2025-01-25": 124.72433624356589,
    "2025-01-26": 125.32026189637352,
    "2025-01-27": 125.91618754918116,
    "2025-01-28": 126.51211320198875,
    "2025-01-29": 127.1080388547964,
    "2025-01-30": 127.70396450760404,
    "2025-01-31": 128.29989016041168,
    "2025-02-01": 129.31716537637544,
    "2025-02-02": 130.33444059233923,
    "2025-02-03": 131.351715808303,
    "2025-02-04": 132.36899102426676,
    "2025-02-05": 133.38626624023053,
    "2025-02-06": 134.40354145619432,
    "2025-02-07": 135.42081667215808,
    "2025-02-08": 136.43809188812185,
    "2025-02-09": 137.45536710408564,
    "2025-02-10": 138.4726423200494,
    "2025-02-11": 139.48991753601317,
    "2025-02-12": 140.50719275197696,
    "2025-02-13": 141.52446796794072,
    "2025-02-14": 142.5417431839045,
    "2025-02-15": 143.55901839986825,
    "2025-02-16": 144.57629361583204,
    "2025-02-17": 145.5935688317958,
    "2025-02-18": 146.61084404775957,
    "2025-02-19": 147.62811926372336,
    "2025-02-20": 148.64539447968713,
    "2025-02-21": 149.6626696956509,
    "2025-02-22": 150.67994491161463,
    "2025-02-23": 151.69722012757845,
    "2025-02-24": 152.7144953435422,
    "2025-02-25": 153.73177055950595,
    "2025-02-26": 154.74904577546977,
    "2025-02-27": 155.76632099143353,
    "2025-02-28": 156.7835962073973,
    "2025-03-01": 158.45756236575065,
    "2025-03-02": 160.13152852410403,
    "2025-03-03": 161.80549468245738,
    "2025-03-04": 163.47946084081076,
    "2025-03-05": 165.1534269991641,
    "2025-03-06": 166.8273931575175,
    "2025-03-07": 168.50135931587084,
    "2025-03-08": 170.17532547422422,
    "2025-03-09": 171.84929163257758,
    "2025-03-10": 173.52325779093096,
    "2025-03-11": 175.1972239492843,
    "2025-03-12": 176.8711901076377,
    "2025-03-13": 178.54515626599104,
    "2025-03-14": 180.2191224243444,
    "2025-03-15": 181.89308858269777,
    "2025-03-16": 183.56705474105115,
    "2025-03-17": 185.2410208994045,
    "2025-03-18": 186.91498705775788,
    "2025-03-19": 188.58895321611124,
    "2025-03-20": 190.26291937446464,
    "2025-03-21": 191.936885532818,
    "2025-03-22": 193.61085169117132,
    "2025-03-23": 195.2848178495247,
    "2025-03-24": 196.95878400787808,
    "2025-03-25": 198.63275016623143,
    "2025-03-26": 200.3067163245848,
    "2025-03-27": 201.98068248293816,
    "2025-03-28": 203.65464864129157,
    "2025-03-29": 205.3286147996449,
    "2025-03-30": 207.00258095799825,
    "2025-03-31": 208.67654711635163,
    "2025-04-01": 212.11554210416543,
    "2025-04-02": 215.5545370919793,
    "2025-04-03": 218.99353207979317,
    "2025-04-04": 222.43252706760697,
    "2025-04-05": 225.8715220554208,
    "2025-04-06": 229.31051704323465,
    "2025-04-07": 232.74951203104848,
    "2025-04-08": 236.1885070188623,
    "2025-04-09": 239.6275020066761,
    "2025-04-10": 243.06649699449,
    "2025-04-11": 246.50549198230385,
    "2025-04-12": 249.94448697011765,
    "2025-04-13": 253.3834819579315,
    "2025-04-14": 256.82247694574534,
    "2025-04-15": 260.2614719335592,
    "2025-04-16": 263.700466921373,
    "2025-04-17": 267.1394619091868,
    "2025-04-18": 270.57845689700065,
    "2025-04-19": 274.0174518848145,
    "2025-04-20": 277.4564468726284,
    "2025-04-21": 280.8954418604422,
    "2025-04-22": 284.334436848256,
    "2025-04-23": 287.77343183606985,
    "2025-04-24": 291.2124268238837,
    "2025-04-25": 294.6514218116975,
    "2025-04-26": 298.09041679951133,
    "2025-04-27": 301.5294117873252,
    "2025-04-28": 304.96840677513904,
    "2025-04-29": 308.4074017629529,
    "2025-04-30": 311.8463967507667,
    "2025-05-01": 316.630701128065,
    "2025-05-02": 321.4150055053633,
    "2025-05-03": 326.1993098826617,
    "2025-05-04": 330.98361425996,
    "2025-05-05": 335.76791863725833,
    "2025-05-06": 340.55222301455666,
    "2025-05-07": 345.336527391855,
    "2025-05-08": 350.1208317691533,
    "2025-05-09": 354.90513614645164,
    "2025-05-10": 359.68944052375,
    "2025-05-11": 364.4737449010483,
    "2025-05-12": 369.2580492783466,
    "2025-05-13": 374.04235365564494,
    "2025-05-14": 378.8266580329433,
    "2025-05-15": 383.61096241024165,
    "2025-05-16": 388.39526678754,
    "2025-05-17": 393.1795711648383,
    "2025-05-18": 397.96387554213663,
    "2025-05-19": 402.74817991943496,
    "2025-05-20": 407.5324842967333,
    "2025-05-21": 412.3167886740316,
    "2025-05-22": 417.10109305132994,
    "2025-05-23": 421.88539742862827,
    "2025-05-24": 426.6697018059266,
    "2025-05-25": 431.4540061832249,
    "2025-05-26": 436.2383105605233,
    "2025-05-27": 441.0226149378216,
    "2025-05-28": 445.8069193151199,
    "2025-05-29": 450.5912236924182,
    "2025-05-30": 455.37552806971655,
    "2025-05-31": 460.1598324470149,
    "2025-06-01": 466.3295200632723,
    "2025-06-02": 472.4992076795298,
    "2025-06-03": 478.6688952957872,
    "2025-06-04": 484.8385829120446,
    "2025-06-05": 491.0082705283021,
    "2025-06-06": 497.1779581445595,
    "2025-06-07": 503.3476457608169,
    "2025-06-08": 509.5173333770744,
    "2025-06-09": 515.6870209933318,
    "2025-06-10": 521.8567086095893,
    "2025-06-11": 528.0263962258467,
    "2025-06-12": 534.1960838421041,
    "2025-06-13": 540.3657714583616,
    "2025-06-14": 546.535459074619,
    "2025-06-15": 552.7051466908765,
    "2025-06-16": 558.8748343071339,
    "2025-06-17": 565.0445219233914,
    "2025-06-18": 571.2142095396488,
    "2025-06-19": 577.3838971559062,
    "2025-06-20": 583.5535847721636,
    "2025-06-21": 589.723272388421,
    "2025-06-22": 595.8929600046786,
    "2025-06-23": 602.062647620936,
    "2025-06-24": 608.2323352371934,
    "2025-06-25": 614.4020228534508,
    "2025-06-26": 620.5717104697083,
    "2025-06-27": 626.7413980859658,
    "2025-06-28": 632.9110857022231,
    "2025-06-29": 639.0807733184806,
    "2025-06-30": 645.250460934738,
    "2025-07-01": 651.5411213915527,
    "2025-07-02": 657.8317818483674,
    "2025-07-03": 664.1224423051821,
    "2025-07-04": 670.4131027619968,
    "2025-07-05": 676.7037632188114,
    "2025-07-06": 682.9944236756262,
    "2025-07-07": 689.2850841324408,
    "2025-07-08": 695.5757445892556,
    "2025-07-09": 701.8664050460702,
    "2025-07-10": 708.157065502885,
    "2025-07-11": 714.4477259596996,
    "2025-07-12": 720.7383864165143,
    "2025-07-13": 727.029046873329,
    "2025-07-14": 733.3197073301437,
    "2025-07-15": 739.6103677869584,
    "2025-07-16": 745.9010282437731,
    "2025-07-17": 752.1916887005877,
    "2025-07-18": 758.4823491574025,
    "2025-07-19": 764.7730096142171,
    "2025-07-20": 771.0636700710319,
    "2025-07-21": 777.3543305278465,
    "2025-07-22": 783.6449909846613,
    "2025-07-23": 789.9356514414759,
    "2025-07-24": 796.2263118982905,
    "2025-07-25": 802.5169723551053,
    "2025-07-26": 808.80763281192,
    "2025-07-27": 815.0982932687347,
    "2025-07-28": 821.3889537255493,
    "2025-07-29": 827.679614182364,
    "2025-07-30": 833.9702746391788,
    "2025-07-31": 840.2609350959934,
    "2025-08-01": 845.2979316078475,
    "2025-08-02": 850.3349281197018,
    "2025-08-03": 855.3719246315559,
    "2025-08-04": 860.40892114341,
    "2025-08-05": 865.4459176552642,
    "2025-08-06": 870.4829141671183,
    "2025-08-07": 875.5199106789725,
    "2025-08-08": 880.5569071908267,
    "2025-08-09": 885.5939037026808,
    "2025-08-10": 890.6309002145349,
    "2025-08-11": 895.6678967263891,
    "2025-08-12": 900.7048932382432,
    "2025-08-13": 905.7418897500976,
    "2025-08-14": 910.7788862619516,
    "2025-08-15": 915.8158827738056,
    "2025-08-16": 920.85287928566,
    "2025-08-17": 925.889875797514,
    "2025-08-18": 930.9268723093682,
    "2025-08-19": 935.9638688212224,
    "2025-08-20": 941.0008653330764,
    "2025-08-21": 946.0378618449306,
    "2025-08-22": 951.0748583567848,
    "2025-08-23": 956.1118548686388,
    "2025-08-24": 961.1488513804932,
    "2025-08-25": 966.1858478923472,
    "2025-08-26": 971.2228444042014,
    "2025-08-27": 976.2598409160556,
    "2025-08-28": 981.2968374279096,
    "2025-08-29": 986.3338339397638,
    "2025-08-30": 991.370830451618,
    "2025-08-31": 996.4078269634722,
    "2025-09-01": 1000.377622184765,
    "2025-09-02": 1004.3474174060576,
    "2025-09-03": 1008.3172126273504,
    "2025-09-04": 1012.2870078486432,
    "2025-09-05": 1016.256803069936,
    "2025-09-06": 1020.2265982912288,
    "2025-09-07": 1024.1963935125214,
    "2025-09-08": 1028.166188733814,
    "2025-09-09": 1032.135983955107,
    "2025-09-10": 1036.1057791763997,
    "2025-09-11": 1040.0755743976924,
    "2025-09-12": 1044.0453696189852,
    "2025-09-13": 1048.015164840278,
    "2025-09-14": 1051.9849600615707,
    "2025-09-15": 1055.9547552828635,
    "2025-09-16": 1059.924550504156,
    "2025-09-17": 1063.8943457254488,
    "2025-09-18": 1067.8641409467416,
    "2025-09-19": 1071.8339361680344,
    "2025-09-20": 1075.8037313893271,
    "2025-09-21": 1079.77352661062,
    "2025-09-22": 1083.743321831913,
    "2025-09-23": 1087.7131170532057,
    "2025-09-24": 1091.6829122744982,
    "2025-09-25": 1095.6527074957908,
    "2025-09-26": 1099.6225027170835,
    "2025-09-27": 1103.5922979383763,
    "2025-09-28": 1107.562093159669,
    "2025-09-29": 1111.5318883809618,
    "2025-09-30": 1115.5016836022546,
  },
  Pecans: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.4181680971683845,
    "2024-10-03": 4.836336194336769,
    "2024-10-04": 7.254504291505153,
    "2024-10-05": 9.672672388673538,
    "2024-10-06": 12.090840485841923,
    "2024-10-07": 14.509008583010306,
    "2024-10-08": 16.927176680178693,
    "2024-10-09": 19.34534477734708,
    "2024-10-10": 21.76351287451546,
    "2024-10-11": 24.181680971683846,
    "2024-10-12": 26.59984906885223,
    "2024-10-13": 29.018017166020613,
    "2024-10-14": 31.436185263189,
    "2024-10-15": 33.854353360357386,
    "2024-10-16": 36.27252145752577,
    "2024-10-17": 38.69068955469415,
    "2024-10-18": 41.108857651862536,
    "2024-10-19": 43.52702574903092,
    "2024-10-20": 45.94519384619931,
    "2024-10-21": 48.36336194336769,
    "2024-10-22": 50.78153004053608,
    "2024-10-23": 53.19969813770446,
    "2024-10-24": 55.61786623487284,
    "2024-10-25": 58.036034332041226,
    "2024-10-26": 60.454202429209616,
    "2024-10-27": 62.872370526378,
    "2024-10-28": 65.29053862354638,
    "2024-10-29": 67.70870672071477,
    "2024-10-30": 70.12687481788315,
    "2024-10-31": 72.54504291505154,
    "2024-11-01": 73.59742238907319,
    "2024-11-02": 74.64980186309482,
    "2024-11-03": 75.70218133711647,
    "2024-11-04": 76.7545608111381,
    "2024-11-05": 77.80694028515975,
    "2024-11-06": 78.85931975918139,
    "2024-11-07": 79.91169923320304,
    "2024-11-08": 80.96407870722467,
    "2024-11-09": 82.01645818124632,
    "2024-11-10": 83.06883765526796,
    "2024-11-11": 84.1212171292896,
    "2024-11-12": 85.17359660331124,
    "2024-11-13": 86.22597607733289,
    "2024-11-14": 87.27835555135454,
    "2024-11-15": 88.33073502537617,
    "2024-11-16": 89.3831144993978,
    "2024-11-17": 90.43549397341944,
    "2024-11-18": 91.4878734474411,
    "2024-11-19": 92.54025292146274,
    "2024-11-20": 93.59263239548436,
    "2024-11-21": 94.64501186950602,
    "2024-11-22": 95.69739134352768,
    "2024-11-23": 96.7497708175493,
    "2024-11-24": 97.80215029157095,
    "2024-11-25": 98.8545297655926,
    "2024-11-26": 99.90690923961424,
    "2024-11-27": 100.95928871363589,
    "2024-11-28": 102.01166818765752,
    "2024-11-29": 103.06404766167915,
    "2024-11-30": 104.1164271357008,
    "2024-12-01": 104.58805411420138,
    "2024-12-02": 105.05968109270196,
    "2024-12-03": 105.53130807120256,
    "2024-12-04": 106.00293504970313,
    "2024-12-05": 106.4745620282037,
    "2024-12-06": 106.94618900670427,
    "2024-12-07": 107.41781598520488,
    "2024-12-08": 107.88944296370543,
    "2024-12-09": 108.36106994220604,
    "2024-12-10": 108.8326969207066,
    "2024-12-11": 109.3043238992072,
    "2024-12-12": 109.77595087770776,
    "2024-12-13": 110.24757785620837,
    "2024-12-14": 110.71920483470892,
    "2024-12-15": 111.19083181320951,
    "2024-12-16": 111.6624587917101,
    "2024-12-17": 112.13408577021067,
    "2024-12-18": 112.60571274871126,
    "2024-12-19": 113.07733972721182,
    "2024-12-20": 113.5489667057124,
    "2024-12-21": 114.02059368421298,
    "2024-12-22": 114.49222066271356,
    "2024-12-23": 114.96384764121414,
    "2024-12-24": 115.43547461971473,
    "2024-12-25": 115.9071015982153,
    "2024-12-26": 116.37872857671589,
    "2024-12-27": 116.85035555521648,
    "2024-12-28": 117.32198253371703,
    "2024-12-29": 117.79360951221764,
    "2024-12-30": 118.2652364907182,
    "2024-12-31": 118.7368634692188,
    "2025-01-01": 119.35005235119384,
    "2025-01-02": 119.96324123316889,
    "2025-01-03": 120.57643011514392,
    "2025-01-04": 121.18961899711896,
    "2025-01-05": 121.80280787909402,
    "2025-01-06": 122.41599676106904,
    "2025-01-07": 123.0291856430441,
    "2025-01-08": 123.64237452501916,
    "2025-01-09": 124.25556340699418,
    "2025-01-10": 124.86875228896923,
    "2025-01-11": 125.48194117094428,
    "2025-01-12": 126.09513005291932,
    "2025-01-13": 126.70831893489436,
    "2025-01-14": 127.3215078168694,
    "2025-01-15": 127.93469669884446,
    "2025-01-16": 128.5478855808195,
    "2025-01-17": 129.16107446279457,
    "2025-01-18": 129.7742633447696,
    "2025-01-19": 130.38745222674464,
    "2025-01-20": 131.0006411087197,
    "2025-01-21": 131.6138299906947,
    "2025-01-22": 132.22701887266976,
    "2025-01-23": 132.8402077546448,
    "2025-01-24": 133.45339663661986,
    "2025-01-25": 134.0665855185949,
    "2025-01-26": 134.67977440056995,
    "2025-01-27": 135.292963282545,
    "2025-01-28": 135.90615216452005,
    "2025-01-29": 136.51934104649507,
    "2025-01-30": 137.13252992847012,
    "2025-01-31": 137.74571881044517,
    "2025-02-01": 139.06918319497828,
    "2025-02-02": 140.3926475795114,
    "2025-02-03": 141.7161119640445,
    "2025-02-04": 143.0395763485776,
    "2025-02-05": 144.36304073311072,
    "2025-02-06": 145.68650511764383,
    "2025-02-07": 147.00996950217694,
    "2025-02-08": 148.33343388671005,
    "2025-02-09": 149.65689827124316,
    "2025-02-10": 150.98036265577628,
    "2025-02-11": 152.3038270403094,
    "2025-02-12": 153.6272914248425,
    "2025-02-13": 154.9507558093756,
    "2025-02-14": 156.27422019390872,
    "2025-02-15": 157.59768457844183,
    "2025-02-16": 158.92114896297494,
    "2025-02-17": 160.24461334750805,
    "2025-02-18": 161.56807773204116,
    "2025-02-19": 162.89154211657427,
    "2025-02-20": 164.21500650110738,
    "2025-02-21": 165.5384708856405,
    "2025-02-22": 166.8619352701736,
    "2025-02-23": 168.1853996547067,
    "2025-02-24": 169.50886403923982,
    "2025-02-25": 170.83232842377294,
    "2025-02-26": 172.15579280830605,
    "2025-02-27": 173.47925719283916,
    "2025-02-28": 174.80272157737227,
    "2025-03-01": 176.9512578768406,
    "2025-03-02": 179.09979417630893,
    "2025-03-03": 181.24833047577724,
    "2025-03-04": 183.3968667752456,
    "2025-03-05": 185.5454030747139,
    "2025-03-06": 187.69393937418224,
    "2025-03-07": 189.84247567365057,
    "2025-03-08": 191.99101197311887,
    "2025-03-09": 194.1395482725872,
    "2025-03-10": 196.28808457205557,
    "2025-03-11": 198.43662087152387,
    "2025-03-12": 200.5851571709922,
    "2025-03-13": 202.7336934704605,
    "2025-03-14": 204.88222976992884,
    "2025-03-15": 207.0307660693972,
    "2025-03-16": 209.1793023688655,
    "2025-03-17": 211.32783866833384,
    "2025-03-18": 213.47637496780212,
    "2025-03-19": 215.62491126727048,
    "2025-03-20": 217.7734475667388,
    "2025-03-21": 219.92198386620717,
    "2025-03-22": 222.07052016567548,
    "2025-03-23": 224.2190564651438,
    "2025-03-24": 226.3675927646121,
    "2025-03-25": 228.51612906408045,
    "2025-03-26": 230.6646653635488,
    "2025-03-27": 232.8132016630171,
    "2025-03-28": 234.96173796248544,
    "2025-03-29": 237.11027426195372,
    "2025-03-30": 239.25881056142208,
    "2025-03-31": 241.4073468608904,
    "2025-04-01": 245.01870891192533,
    "2025-04-02": 248.63007096296025,
    "2025-04-03": 252.24143301399516,
    "2025-04-04": 255.85279506503,
    "2025-04-05": 259.46415711606494,
    "2025-04-06": 263.07551916709986,
    "2025-04-07": 266.6868812181347,
    "2025-04-08": 270.29824326916963,
    "2025-04-09": 273.90960532020455,
    "2025-04-10": 277.52096737123946,
    "2025-04-11": 281.1323294222743,
    "2025-04-12": 284.74369147330924,
    "2025-04-13": 288.35505352434416,
    "2025-04-14": 291.9664155753791,
    "2025-04-15": 295.577777626414,
    "2025-04-16": 299.18913967744885,
    "2025-04-17": 302.80050172848377,
    "2025-04-18": 306.4118637795187,
    "2025-04-19": 310.02322583055354,
    "2025-04-20": 313.63458788158846,
    "2025-04-21": 317.2459499326234,
    "2025-04-22": 320.8573119836583,
    "2025-04-23": 324.4686740346932,
    "2025-04-24": 328.0800360857281,
    "2025-04-25": 331.691398136763,
    "2025-04-26": 335.3027601877979,
    "2025-04-27": 338.9141222388328,
    "2025-04-28": 342.5254842898677,
    "2025-04-29": 346.1368463409026,
    "2025-04-30": 349.7482083919375,
    "2025-05-01": 354.3261609079579,
    "2025-05-02": 358.90411342397823,
    "2025-05-03": 363.4820659399986,
    "2025-05-04": 368.06001845601895,
    "2025-05-05": 372.63797097203934,
    "2025-05-06": 377.2159234880597,
    "2025-05-07": 381.79387600408006,
    "2025-05-08": 386.3718285201004,
    "2025-05-09": 390.9497810361208,
    "2025-05-10": 395.5277335521411,
    "2025-05-11": 400.1056860681615,
    "2025-05-12": 404.6836385841818,
    "2025-05-13": 409.2615911002022,
    "2025-05-14": 413.83954361622256,
    "2025-05-15": 418.41749613224295,
    "2025-05-16": 422.9954486482633,
    "2025-05-17": 427.57340116428367,
    "2025-05-18": 432.151353680304,
    "2025-05-19": 436.7293061963244,
    "2025-05-20": 441.3072587123447,
    "2025-05-21": 445.8852112283651,
    "2025-05-22": 450.46316374438544,
    "2025-05-23": 455.0411162604058,
    "2025-05-24": 459.61906877642616,
    "2025-05-25": 464.19702129244655,
    "2025-05-26": 468.7749738084669,
    "2025-05-27": 473.35292632448727,
    "2025-05-28": 477.9308788405076,
    "2025-05-29": 482.508831356528,
    "2025-05-30": 487.0867838725484,
    "2025-05-31": 491.6647363885687,
    "2025-06-01": 497.72298186695633,
    "2025-06-02": 503.7812273453439,
    "2025-06-03": 509.8394728237315,
    "2025-06-04": 515.8977183021191,
    "2025-06-05": 521.9559637805067,
    "2025-06-06": 528.0142092588943,
    "2025-06-07": 534.0724547372819,
    "2025-06-08": 540.1307002156695,
    "2025-06-09": 546.1889456940571,
    "2025-06-10": 552.2471911724447,
    "2025-06-11": 558.3054366508323,
    "2025-06-12": 564.3636821292199,
    "2025-06-13": 570.4219276076075,
    "2025-06-14": 576.4801730859951,
    "2025-06-15": 582.5384185643827,
    "2025-06-16": 588.5966640427703,
    "2025-06-17": 594.654909521158,
    "2025-06-18": 600.7131549995455,
    "2025-06-19": 606.7714004779331,
    "2025-06-20": 612.8296459563207,
    "2025-06-21": 618.8878914347083,
    "2025-06-22": 624.9461369130959,
    "2025-06-23": 631.0043823914835,
    "2025-06-24": 637.0626278698711,
    "2025-06-25": 643.1208733482588,
    "2025-06-26": 649.1791188266463,
    "2025-06-27": 655.2373643050339,
    "2025-06-28": 661.2956097834215,
    "2025-06-29": 667.3538552618091,
    "2025-06-30": 673.4121007401967,
    "2025-07-01": 679.9917506332444,
    "2025-07-02": 686.5714005262921,
    "2025-07-03": 693.1510504193398,
    "2025-07-04": 699.7307003123875,
    "2025-07-05": 706.3103502054352,
    "2025-07-06": 712.8900000984829,
    "2025-07-07": 719.4696499915306,
    "2025-07-08": 726.0492998845783,
    "2025-07-09": 732.628949777626,
    "2025-07-10": 739.2085996706737,
    "2025-07-11": 745.7882495637214,
    "2025-07-12": 752.3678994567691,
    "2025-07-13": 758.9475493498168,
    "2025-07-14": 765.5271992428645,
    "2025-07-15": 772.1068491359122,
    "2025-07-16": 778.6864990289599,
    "2025-07-17": 785.2661489220076,
    "2025-07-18": 791.8457988150553,
    "2025-07-19": 798.425448708103,
    "2025-07-20": 805.0050986011507,
    "2025-07-21": 811.5847484941984,
    "2025-07-22": 818.1643983872461,
    "2025-07-23": 824.7440482802938,
    "2025-07-24": 831.3236981733414,
    "2025-07-25": 837.9033480663892,
    "2025-07-26": 844.482997959437,
    "2025-07-27": 851.0626478524846,
    "2025-07-28": 857.6422977455322,
    "2025-07-29": 864.22194763858,
    "2025-07-30": 870.8015975316277,
    "2025-07-31": 877.3812474246754,
    "2025-08-01": 882.5390853211758,
    "2025-08-02": 887.6969232176763,
    "2025-08-03": 892.8547611141767,
    "2025-08-04": 898.0125990106771,
    "2025-08-05": 903.1704369071776,
    "2025-08-06": 908.328274803678,
    "2025-08-07": 913.4861127001784,
    "2025-08-08": 918.6439505966788,
    "2025-08-09": 923.8017884931792,
    "2025-08-10": 928.9596263896796,
    "2025-08-11": 934.1174642861802,
    "2025-08-12": 939.2753021826804,
    "2025-08-13": 944.4331400791808,
    "2025-08-14": 949.5909779756814,
    "2025-08-15": 954.7488158721818,
    "2025-08-16": 959.9066537686824,
    "2025-08-17": 965.0644916651828,
    "2025-08-18": 970.2223295616832,
    "2025-08-19": 975.3801674581836,
    "2025-08-20": 980.538005354684,
    "2025-08-21": 985.6958432511844,
    "2025-08-22": 990.8536811476848,
    "2025-08-23": 996.0115190441852,
    "2025-08-24": 1001.1693569406856,
    "2025-08-25": 1006.3271948371862,
    "2025-08-26": 1011.4850327336866,
    "2025-08-27": 1016.642870630187,
    "2025-08-28": 1021.8007085266876,
    "2025-08-29": 1026.958546423188,
    "2025-08-30": 1032.1163843196882,
    "2025-08-31": 1037.2742222161887,
    "2025-09-01": 1041.4277349715835,
    "2025-09-02": 1045.5812477269783,
    "2025-09-03": 1049.7347604823733,
    "2025-09-04": 1053.888273237768,
    "2025-09-05": 1058.041785993163,
    "2025-09-06": 1062.195298748558,
    "2025-09-07": 1066.348811503953,
    "2025-09-08": 1070.5023242593477,
    "2025-09-09": 1074.6558370147425,
    "2025-09-10": 1078.8093497701373,
    "2025-09-11": 1082.9628625255325,
    "2025-09-12": 1087.116375280927,
    "2025-09-13": 1091.2698880363218,
    "2025-09-14": 1095.4234007917169,
    "2025-09-15": 1099.5769135471116,
    "2025-09-16": 1103.7304263025064,
    "2025-09-17": 1107.8839390579014,
    "2025-09-18": 1112.0374518132962,
    "2025-09-19": 1116.190964568691,
    "2025-09-20": 1120.344477324086,
    "2025-09-21": 1124.4979900794808,
    "2025-09-22": 1128.6515028348756,
    "2025-09-23": 1132.8050155902706,
    "2025-09-24": 1136.9585283456654,
    "2025-09-25": 1141.1120411010602,
    "2025-09-26": 1145.2655538564552,
    "2025-09-27": 1149.41906661185,
    "2025-09-28": 1153.5725793672448,
    "2025-09-29": 1157.7260921226398,
    "2025-09-30": 1161.8796048780346,
  },
  Pistachios: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.4728533819571044,
    "2024-10-03": 4.945706763914209,
    "2024-10-04": 7.418560145871313,
    "2024-10-05": 9.891413527828416,
    "2024-10-06": 12.364266909785522,
    "2024-10-07": 14.837120291742623,
    "2024-10-08": 17.30997367369973,
    "2024-10-09": 19.782827055656835,
    "2024-10-10": 22.25568043761394,
    "2024-10-11": 24.728533819571044,
    "2024-10-12": 27.20138720152815,
    "2024-10-13": 29.67424058348525,
    "2024-10-14": 32.14709396544236,
    "2024-10-15": 34.61994734739946,
    "2024-10-16": 37.09280072935657,
    "2024-10-17": 39.56565411131367,
    "2024-10-18": 42.03850749327077,
    "2024-10-19": 44.51136087522788,
    "2024-10-20": 46.98421425718498,
    "2024-10-21": 49.45706763914209,
    "2024-10-22": 51.92992102109919,
    "2024-10-23": 54.4027744030563,
    "2024-10-24": 56.8756277850134,
    "2024-10-25": 59.3484811669705,
    "2024-10-26": 61.82133454892761,
    "2024-10-27": 64.29418793088472,
    "2024-10-28": 66.76704131284181,
    "2024-10-29": 69.23989469479892,
    "2024-10-30": 71.71274807675603,
    "2024-10-31": 74.18560145871314,
    "2024-11-01": 74.96554221571078,
    "2024-11-02": 75.74548297270843,
    "2024-11-03": 76.52542372970608,
    "2024-11-04": 77.30536448670372,
    "2024-11-05": 78.08530524370137,
    "2024-11-06": 78.86524600069902,
    "2024-11-07": 79.64518675769666,
    "2024-11-08": 80.42512751469431,
    "2024-11-09": 81.20506827169196,
    "2024-11-10": 81.9850090286896,
    "2024-11-11": 82.76494978568725,
    "2024-11-12": 83.5448905426849,
    "2024-11-13": 84.32483129968254,
    "2024-11-14": 85.10477205668019,
    "2024-11-15": 85.88471281367784,
    "2024-11-16": 86.66465357067548,
    "2024-11-17": 87.44459432767313,
    "2024-11-18": 88.22453508467078,
    "2024-11-19": 89.00447584166842,
    "2024-11-20": 89.78441659866607,
    "2024-11-21": 90.56435735566372,
    "2024-11-22": 91.34429811266136,
    "2024-11-23": 92.124238869659,
    "2024-11-24": 92.90417962665666,
    "2024-11-25": 93.6841203836543,
    "2024-11-26": 94.46406114065196,
    "2024-11-27": 95.2440018976496,
    "2024-11-28": 96.02394265464724,
    "2024-11-29": 96.80388341164488,
    "2024-11-30": 97.58382416864254,
    "2024-12-01": 97.84136353659731,
    "2024-12-02": 98.09890290455208,
    "2024-12-03": 98.35644227250684,
    "2024-12-04": 98.61398164046162,
    "2024-12-05": 98.8715210084164,
    "2024-12-06": 99.12906037637116,
    "2024-12-07": 99.38659974432592,
    "2024-12-08": 99.64413911228073,
    "2024-12-09": 99.90167848023547,
    "2024-12-10": 100.15921784819024,
    "2024-12-11": 100.41675721614504,
    "2024-12-12": 100.6742965840998,
    "2024-12-13": 100.93183595205456,
    "2024-12-14": 101.18937532000936,
    "2024-12-15": 101.44691468796412,
    "2024-12-16": 101.70445405591887,
    "2024-12-17": 101.96199342387364,
    "2024-12-18": 102.21953279182844,
    "2024-12-19": 102.4770721597832,
    "2024-12-20": 102.73461152773795,
    "2024-12-21": 102.99215089569276,
    "2024-12-22": 103.24969026364752,
    "2024-12-23": 103.50722963160229,
    "2024-12-24": 103.76476899955706,
    "2024-12-25": 104.02230836751184,
    "2024-12-26": 104.2798477354666,
    "2024-12-27": 104.53738710342138,
    "2024-12-28": 104.79492647137614,
    "2024-12-29": 105.05246583933092,
    "2024-12-30": 105.31000520728568,
    "2024-12-31": 105.56754457524046,
    "2025-01-01": 106.18824737037929,
    "2025-01-02": 106.80895016551813,
    "2025-01-03": 107.42965296065697,
    "2025-01-04": 108.0503557557958,
    "2025-01-05": 108.67105855093462,
    "2025-01-06": 109.29176134607346,
    "2025-01-07": 109.91246414121228,
    "2025-01-08": 110.53316693635112,
    "2025-01-09": 111.15386973148996,
    "2025-01-10": 111.7745725266288,
    "2025-01-11": 112.3952753217676,
    "2025-01-12": 113.01597811690644,
    "2025-01-13": 113.63668091204528,
    "2025-01-14": 114.25738370718412,
    "2025-01-15": 114.87808650232294,
    "2025-01-16": 115.49878929746178,
    "2025-01-17": 116.1194920926006,
    "2025-01-18": 116.74019488773943,
    "2025-01-19": 117.36089768287827,
    "2025-01-20": 117.98160047801711,
    "2025-01-21": 118.60230327315594,
    "2025-01-22": 119.22300606829478,
    "2025-01-23": 119.8437088634336,
    "2025-01-24": 120.46441165857244,
    "2025-01-25": 121.08511445371128,
    "2025-01-26": 121.70581724885012,
    "2025-01-27": 122.32652004398894,
    "2025-01-28": 122.94722283912776,
    "2025-01-29": 123.5679256342666,
    "2025-01-30": 124.18862842940544,
    "2025-01-31": 124.80933122454428,
    "2025-02-01": 126.02738940208071,
    "2025-02-02": 127.24544757961718,
    "2025-02-03": 128.46350575715363,
    "2025-02-04": 129.6815639346901,
    "2025-02-05": 130.89962211222655,
    "2025-02-06": 132.11768028976303,
    "2025-02-07": 133.33573846729948,
    "2025-02-08": 134.55379664483593,
    "2025-02-09": 135.7718548223724,
    "2025-02-10": 136.98991299990885,
    "2025-02-11": 138.20797117744533,
    "2025-02-12": 139.42602935498178,
    "2025-02-13": 140.64408753251823,
    "2025-02-14": 141.8621457100547,
    "2025-02-15": 143.08020388759115,
    "2025-02-16": 144.29826206512763,
    "2025-02-17": 145.51632024266408,
    "2025-02-18": 146.73437842020053,
    "2025-02-19": 147.952436597737,
    "2025-02-20": 149.17049477527345,
    "2025-02-21": 150.3885529528099,
    "2025-02-22": 151.60661113034638,
    "2025-02-23": 152.82466930788283,
    "2025-02-24": 154.04272748541928,
    "2025-02-25": 155.26078566295575,
    "2025-02-26": 156.4788438404922,
    "2025-02-27": 157.69690201802865,
    "2025-02-28": 158.91496019556513,
    "2025-03-01": 160.7133387201492,
    "2025-03-02": 162.5117172447333,
    "2025-03-03": 164.31009576931737,
    "2025-03-04": 166.10847429390145,
    "2025-03-05": 167.90685281848553,
    "2025-03-06": 169.7052313430696,
    "2025-03-07": 171.5036098676537,
    "2025-03-08": 173.30198839223775,
    "2025-03-09": 175.10036691682183,
    "2025-03-10": 176.8987454414059,
    "2025-03-11": 178.69712396599,
    "2025-03-12": 180.49550249057407,
    "2025-03-13": 182.29388101515812,
    "2025-03-14": 184.09225953974223,
    "2025-03-15": 185.8906380643263,
    "2025-03-16": 187.6890165889104,
    "2025-03-17": 189.48739511349447,
    "2025-03-18": 191.28577363807852,
    "2025-03-19": 193.08415216266263,
    "2025-03-20": 194.8825306872467,
    "2025-03-21": 196.6809092118308,
    "2025-03-22": 198.47928773641485,
    "2025-03-23": 200.27766626099896,
    "2025-03-24": 202.076044785583,
    "2025-03-25": 203.87442331016712,
    "2025-03-26": 205.6728018347512,
    "2025-03-27": 207.47118035933525,
    "2025-03-28": 209.26955888391933,
    "2025-03-29": 211.0679374085034,
    "2025-03-30": 212.8663159330875,
    "2025-03-31": 214.6646944576716,
    "2025-04-01": 217.82395078896567,
    "2025-04-02": 220.98320712025972,
    "2025-04-03": 224.14246345155385,
    "2025-04-04": 227.30171978284795,
    "2025-04-05": 230.46097611414203,
    "2025-04-06": 233.62023244543613,
    "2025-04-07": 236.7794887767302,
    "2025-04-08": 239.9387451080243,
    "2025-04-09": 243.0980014393184,
    "2025-04-10": 246.25725777061248,
    "2025-04-11": 249.41651410190656,
    "2025-04-12": 252.5757704332007,
    "2025-04-13": 255.7350267644948,
    "2025-04-14": 258.89428309578886,
    "2025-04-15": 262.05353942708297,
    "2025-04-16": 265.21279575837707,
    "2025-04-17": 268.3720520896711,
    "2025-04-18": 271.5313084209652,
    "2025-04-19": 274.6905647522593,
    "2025-04-20": 277.8498210835534,
    "2025-04-21": 281.0090774148475,
    "2025-04-22": 284.1683337461416,
    "2025-04-23": 287.3275900774357,
    "2025-04-24": 290.4868464087298,
    "2025-04-25": 293.6461027400239,
    "2025-04-26": 296.805359071318,
    "2025-04-27": 299.9646154026121,
    "2025-04-28": 303.1238717339062,
    "2025-04-29": 306.28312806520023,
    "2025-04-30": 309.44238439649433,
    "2025-05-01": 314.5135048198841,
    "2025-05-02": 319.58462524327376,
    "2025-05-03": 324.6557456666635,
    "2025-05-04": 329.72686609005325,
    "2025-05-05": 334.797986513443,
    "2025-05-06": 339.8691069368327,
    "2025-05-07": 344.9402273602224,
    "2025-05-08": 350.01134778361217,
    "2025-05-09": 355.0824682070019,
    "2025-05-10": 360.1535886303916,
    "2025-05-11": 365.2247090537813,
    "2025-05-12": 370.2958294771711,
    "2025-05-13": 375.3669499005608,
    "2025-05-14": 380.4380703239505,
    "2025-05-15": 385.50919074734026,
    "2025-05-16": 390.58031117073,
    "2025-05-17": 395.6514315941197,
    "2025-05-18": 400.72255201750943,
    "2025-05-19": 405.7936724408992,
    "2025-05-20": 410.8647928642889,
    "2025-05-21": 415.93591328767866,
    "2025-05-22": 421.0070337110684,
    "2025-05-23": 426.0781541344581,
    "2025-05-24": 431.1492745578478,
    "2025-05-25": 436.2203949812375,
    "2025-05-26": 441.29151540462726,
    "2025-05-27": 446.362635828017,
    "2025-05-28": 451.4337562514068,
    "2025-05-29": 456.5048766747965,
    "2025-05-30": 461.5759970981862,
    "2025-05-31": 466.6471175215759,
    "2025-06-01": 473.3894003810799,
    "2025-06-02": 480.1316832405839,
    "2025-06-03": 486.87396610008784,
    "2025-06-04": 493.6162489595919,
    "2025-06-05": 500.35853181909584,
    "2025-06-06": 507.1008146785998,
    "2025-06-07": 513.8430975381038,
    "2025-06-08": 520.5853803976078,
    "2025-06-09": 527.3276632571118,
    "2025-06-10": 534.0699461166157,
    "2025-06-11": 540.8122289761197,
    "2025-06-12": 547.5545118356238,
    "2025-06-13": 554.2967946951277,
    "2025-06-14": 561.0390775546317,
    "2025-06-15": 567.7813604141356,
    "2025-06-16": 574.5236432736397,
    "2025-06-17": 581.2659261331437,
    "2025-06-18": 588.0082089926476,
    "2025-06-19": 594.7504918521516,
    "2025-06-20": 601.4927747116556,
    "2025-06-21": 608.2350575711596,
    "2025-06-22": 614.9773404306636,
    "2025-06-23": 621.7196232901675,
    "2025-06-24": 628.4619061496714,
    "2025-06-25": 635.2041890091755,
    "2025-06-26": 641.9464718686795,
    "2025-06-27": 648.6887547281834,
    "2025-06-28": 655.4310375876875,
    "2025-06-29": 662.1733204471914,
    "2025-06-30": 668.9156033066954,
    "2025-07-01": 676.0915957597874,
    "2025-07-02": 683.2675882128796,
    "2025-07-03": 690.4435806659716,
    "2025-07-04": 697.6195731190636,
    "2025-07-05": 704.7955655721557,
    "2025-07-06": 711.9715580252478,
    "2025-07-07": 719.1475504783398,
    "2025-07-08": 726.3235429314319,
    "2025-07-09": 733.4995353845239,
    "2025-07-10": 740.675527837616,
    "2025-07-11": 747.8515202907081,
    "2025-07-12": 755.0275127438001,
    "2025-07-13": 762.2035051968921,
    "2025-07-14": 769.3794976499842,
    "2025-07-15": 776.5554901030763,
    "2025-07-16": 783.7314825561683,
    "2025-07-17": 790.9074750092605,
    "2025-07-18": 798.0834674623525,
    "2025-07-19": 805.2594599154445,
    "2025-07-20": 812.4354523685365,
    "2025-07-21": 819.6114448216287,
    "2025-07-22": 826.7874372747207,
    "2025-07-23": 833.9634297278127,
    "2025-07-24": 841.1394221809048,
    "2025-07-25": 848.3154146339969,
    "2025-07-26": 855.4914070870889,
    "2025-07-27": 862.667399540181,
    "2025-07-28": 869.843391993273,
    "2025-07-29": 877.019384446365,
    "2025-07-30": 884.1953768994572,
    "2025-07-31": 891.3713693525492,
    "2025-08-01": 897.4821603265416,
    "2025-08-02": 903.592951300534,
    "2025-08-03": 909.7037422745263,
    "2025-08-04": 915.8145332485188,
    "2025-08-05": 921.9253242225112,
    "2025-08-06": 928.0361151965036,
    "2025-08-07": 934.146906170496,
    "2025-08-08": 940.2576971444882,
    "2025-08-09": 946.3684881184806,
    "2025-08-10": 952.479279092473,
    "2025-08-11": 958.5900700664654,
    "2025-08-12": 964.7008610404578,
    "2025-08-13": 970.81165201445,
    "2025-08-14": 976.9224429884424,
    "2025-08-15": 983.0332339624348,
    "2025-08-16": 989.1440249364272,
    "2025-08-17": 995.2548159104196,
    "2025-08-18": 1001.365606884412,
    "2025-08-19": 1007.4763978584044,
    "2025-08-20": 1013.5871888323968,
    "2025-08-21": 1019.6979798063892,
    "2025-08-22": 1025.8087707803816,
    "2025-08-23": 1031.919561754374,
    "2025-08-24": 1038.0303527283663,
    "2025-08-25": 1044.1411437023587,
    "2025-08-26": 1050.251934676351,
    "2025-08-27": 1056.3627256503437,
    "2025-08-28": 1062.4735166243358,
    "2025-08-29": 1068.5843075983282,
    "2025-08-30": 1074.6950985723206,
    "2025-08-31": 1080.805889546313,
    "2025-09-01": 1085.135576072461,
    "2025-09-02": 1089.465262598609,
    "2025-09-03": 1093.7949491247564,
    "2025-09-04": 1098.1246356509043,
    "2025-09-05": 1102.4543221770523,
    "2025-09-06": 1106.7840087032,
    "2025-09-07": 1111.1136952293475,
    "2025-09-08": 1115.4433817554957,
    "2025-09-09": 1119.7730682816436,
    "2025-09-10": 1124.1027548077914,
    "2025-09-11": 1128.432441333939,
    "2025-09-12": 1132.762127860087,
    "2025-09-13": 1137.091814386235,
    "2025-09-14": 1141.4215009123827,
    "2025-09-15": 1145.7511874385305,
    "2025-09-16": 1150.0808739646784,
    "2025-09-17": 1154.4105604908264,
    "2025-09-18": 1158.740247016974,
    "2025-09-19": 1163.0699335431218,
    "2025-09-20": 1167.3996200692698,
    "2025-09-21": 1171.7293065954177,
    "2025-09-22": 1176.0589931215654,
    "2025-09-23": 1180.3886796477132,
    "2025-09-24": 1184.718366173861,
    "2025-09-25": 1189.048052700009,
    "2025-09-26": 1193.3777392261568,
    "2025-09-27": 1197.7074257523043,
    "2025-09-28": 1202.0371122784525,
    "2025-09-29": 1206.3667988046004,
    "2025-09-30": 1210.696485330748,
  },
  Plums: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.264107944681187,
    "2024-10-03": 4.528215889362374,
    "2024-10-04": 6.792323834043561,
    "2024-10-05": 9.056431778724749,
    "2024-10-06": 11.320539723405936,
    "2024-10-07": 13.584647668087122,
    "2024-10-08": 15.84875561276831,
    "2024-10-09": 18.112863557449497,
    "2024-10-10": 20.376971502130683,
    "2024-10-11": 22.641079446811872,
    "2024-10-12": 24.905187391493055,
    "2024-10-13": 27.169295336174244,
    "2024-10-14": 29.433403280855437,
    "2024-10-15": 31.69751122553662,
    "2024-10-16": 33.96161917021781,
    "2024-10-17": 36.225727114898994,
    "2024-10-18": 38.48983505958018,
    "2024-10-19": 40.753943004261366,
    "2024-10-20": 43.01805094894256,
    "2024-10-21": 45.28215889362375,
    "2024-10-22": 47.54626683830493,
    "2024-10-23": 49.81037478298612,
    "2024-10-24": 52.0744827276673,
    "2024-10-25": 54.33859067234849,
    "2024-10-26": 56.60269861702968,
    "2024-10-27": 58.86680656171087,
    "2024-10-28": 61.13091450639205,
    "2024-10-29": 63.39502245107324,
    "2024-10-30": 65.65913039575443,
    "2024-10-31": 67.92323834043562,
    "2024-11-01": 68.65272823686226,
    "2024-11-02": 69.38221813328892,
    "2024-11-03": 70.11170802971556,
    "2024-11-04": 70.8411979261422,
    "2024-11-05": 71.57068782256886,
    "2024-11-06": 72.3001777189955,
    "2024-11-07": 73.02966761542214,
    "2024-11-08": 73.7591575118488,
    "2024-11-09": 74.48864740827544,
    "2024-11-10": 75.21813730470208,
    "2024-11-11": 75.94762720112874,
    "2024-11-12": 76.67711709755538,
    "2024-11-13": 77.40660699398202,
    "2024-11-14": 78.13609689040868,
    "2024-11-15": 78.86558678683532,
    "2024-11-16": 79.59507668326196,
    "2024-11-17": 80.32456657968862,
    "2024-11-18": 81.05405647611526,
    "2024-11-19": 81.7835463725419,
    "2024-11-20": 82.51303626896856,
    "2024-11-21": 83.2425261653952,
    "2024-11-22": 83.97201606182185,
    "2024-11-23": 84.7015059582485,
    "2024-11-24": 85.43099585467515,
    "2024-11-25": 86.16048575110179,
    "2024-11-26": 86.88997564752844,
    "2024-11-27": 87.61946554395509,
    "2024-11-28": 88.34895544038173,
    "2024-11-29": 89.07844533680839,
    "2024-11-30": 89.80793523323503,
    "2024-12-01": 90.17415771824518,
    "2024-12-02": 90.54038020325532,
    "2024-12-03": 90.90660268826548,
    "2024-12-04": 91.27282517327563,
    "2024-12-05": 91.6390476582858,
    "2024-12-06": 92.00527014329592,
    "2024-12-07": 92.37149262830609,
    "2024-12-08": 92.73771511331624,
    "2024-12-09": 93.10393759832638,
    "2024-12-10": 93.47016008333654,
    "2024-12-11": 93.83638256834668,
    "2024-12-12": 94.20260505335683,
    "2024-12-13": 94.568827538367,
    "2024-12-14": 94.93505002337714,
    "2024-12-15": 95.3012725083873,
    "2024-12-16": 95.66749499339744,
    "2024-12-17": 96.0337174784076,
    "2024-12-18": 96.39993996341776,
    "2024-12-19": 96.7661624484279,
    "2024-12-20": 97.13238493343805,
    "2024-12-21": 97.4986074184482,
    "2024-12-22": 97.86482990345836,
    "2024-12-23": 98.2310523884685,
    "2024-12-24": 98.59727487347864,
    "2024-12-25": 98.9634973584888,
    "2024-12-26": 99.32971984349896,
    "2024-12-27": 99.6959423285091,
    "2024-12-28": 100.06216481351926,
    "2024-12-29": 100.42838729852942,
    "2024-12-30": 100.79460978353956,
    "2024-12-31": 101.16083226854973,
    "2025-01-01": 101.7568324265371,
    "2025-01-02": 102.35283258452448,
    "2025-01-03": 102.94883274251188,
    "2025-01-04": 103.54483290049924,
    "2025-01-05": 104.14083305848663,
    "2025-01-06": 104.736833216474,
    "2025-01-07": 105.3328333744614,
    "2025-01-08": 105.92883353244878,
    "2025-01-09": 106.52483369043615,
    "2025-01-10": 107.12083384842356,
    "2025-01-11": 107.71683400641092,
    "2025-01-12": 108.31283416439832,
    "2025-01-13": 108.9088343223857,
    "2025-01-14": 109.50483448037308,
    "2025-01-15": 110.10083463836048,
    "2025-01-16": 110.69683479634786,
    "2025-01-17": 111.29283495433523,
    "2025-01-18": 111.88883511232262,
    "2025-01-19": 112.48483527031,
    "2025-01-20": 113.0808354282974,
    "2025-01-21": 113.67683558628477,
    "2025-01-22": 114.27283574427216,
    "2025-01-23": 114.86883590225956,
    "2025-01-24": 115.46483606024692,
    "2025-01-25": 116.06083621823431,
    "2025-01-26": 116.65683637622168,
    "2025-01-27": 117.25283653420908,
    "2025-01-28": 117.84883669219646,
    "2025-01-29": 118.44483685018383,
    "2025-01-30": 119.04083700817122,
    "2025-01-31": 119.6368371661586,
    "2025-02-01": 120.79240086288364,
    "2025-02-02": 121.94796455960866,
    "2025-02-03": 123.1035282563337,
    "2025-02-04": 124.25909195305871,
    "2025-02-05": 125.41465564978375,
    "2025-02-06": 126.57021934650878,
    "2025-02-07": 127.7257830432338,
    "2025-02-08": 128.88134673995884,
    "2025-02-09": 130.03691043668385,
    "2025-02-10": 131.1924741334089,
    "2025-02-11": 132.34803783013393,
    "2025-02-12": 133.50360152685894,
    "2025-02-13": 134.65916522358398,
    "2025-02-14": 135.814728920309,
    "2025-02-15": 136.97029261703403,
    "2025-02-16": 138.12585631375907,
    "2025-02-17": 139.28142001048408,
    "2025-02-18": 140.43698370720912,
    "2025-02-19": 141.59254740393416,
    "2025-02-20": 142.74811110065917,
    "2025-02-21": 143.9036747973842,
    "2025-02-22": 145.05923849410922,
    "2025-02-23": 146.21480219083426,
    "2025-02-24": 147.3703658875593,
    "2025-02-25": 148.5259295842843,
    "2025-02-26": 149.68149328100935,
    "2025-02-27": 150.8370569777344,
    "2025-02-28": 151.9926206744594,
    "2025-03-01": 154.01126763422846,
    "2025-03-02": 156.02991459399752,
    "2025-03-03": 158.04856155376658,
    "2025-03-04": 160.06720851353566,
    "2025-03-05": 162.08585547330472,
    "2025-03-06": 164.10450243307378,
    "2025-03-07": 166.12314939284283,
    "2025-03-08": 168.1417963526119,
    "2025-03-09": 170.16044331238095,
    "2025-03-10": 172.17909027215,
    "2025-03-11": 174.1977372319191,
    "2025-03-12": 176.21638419168815,
    "2025-03-13": 178.2350311514572,
    "2025-03-14": 180.25367811122624,
    "2025-03-15": 182.2723250709953,
    "2025-03-16": 184.2909720307644,
    "2025-03-17": 186.3096189905335,
    "2025-03-18": 188.32826595030247,
    "2025-03-19": 190.3469129100716,
    "2025-03-20": 192.36555986984064,
    "2025-03-21": 194.3842068296097,
    "2025-03-22": 196.40285378937875,
    "2025-03-23": 198.4215007491478,
    "2025-03-24": 200.4401477089169,
    "2025-03-25": 202.45879466868595,
    "2025-03-26": 204.477441628455,
    "2025-03-27": 206.49608858822407,
    "2025-03-28": 208.51473554799315,
    "2025-03-29": 210.5333825077622,
    "2025-03-30": 212.55202946753127,
    "2025-03-31": 214.57067642730036,
    "2025-04-01": 218.379588854798,
    "2025-04-02": 222.1885012822956,
    "2025-04-03": 225.9974137097932,
    "2025-04-04": 229.80632613729085,
    "2025-04-05": 233.61523856478848,
    "2025-04-06": 237.4241509922861,
    "2025-04-07": 241.23306341978375,
    "2025-04-08": 245.04197584728135,
    "2025-04-09": 248.85088827477904,
    "2025-04-10": 252.65980070227664,
    "2025-04-11": 256.4687131297743,
    "2025-04-12": 260.2776255572719,
    "2025-04-13": 264.0865379847696,
    "2025-04-14": 267.8954504122672,
    "2025-04-15": 271.7043628397648,
    "2025-04-16": 275.51327526726243,
    "2025-04-17": 279.3221876947601,
    "2025-04-18": 283.1311001222577,
    "2025-04-19": 286.9400125497553,
    "2025-04-20": 290.7489249772529,
    "2025-04-21": 294.5578374047506,
    "2025-04-22": 298.3667498322483,
    "2025-04-23": 302.1756622597459,
    "2025-04-24": 305.98457468724354,
    "2025-04-25": 309.79348711474114,
    "2025-04-26": 313.6023995422388,
    "2025-04-27": 317.4113119697364,
    "2025-04-28": 321.22022439723406,
    "2025-04-29": 325.0291368247317,
    "2025-04-30": 328.8380492522293,
    "2025-05-01": 333.6116682825973,
    "2025-05-02": 338.3852873129652,
    "2025-05-03": 343.1589063433332,
    "2025-05-04": 347.9325253737011,
    "2025-05-05": 352.70614440406905,
    "2025-05-06": 357.479763434437,
    "2025-05-07": 362.2533824648049,
    "2025-05-08": 367.0270014951729,
    "2025-05-09": 371.8006205255408,
    "2025-05-10": 376.5742395559088,
    "2025-05-11": 381.3478585862767,
    "2025-05-12": 386.1214776166447,
    "2025-05-13": 390.89509664701256,
    "2025-05-14": 395.6687156773805,
    "2025-05-15": 400.4423347077485,
    "2025-05-16": 405.2159537381164,
    "2025-05-17": 409.9895727684844,
    "2025-05-18": 414.7631917988523,
    "2025-05-19": 419.53681082922026,
    "2025-05-20": 424.3104298595882,
    "2025-05-21": 429.08404888995614,
    "2025-05-22": 433.8576679203241,
    "2025-05-23": 438.631286950692,
    "2025-05-24": 443.40490598106,
    "2025-05-25": 448.178525011428,
    "2025-05-26": 452.9521440417959,
    "2025-05-27": 457.7257630721638,
    "2025-05-28": 462.4993821025317,
    "2025-05-29": 467.2730011328997,
    "2025-05-30": 472.0466201632677,
    "2025-05-31": 476.8202391936356,
    "2025-06-01": 482.91591253235686,
    "2025-06-02": 489.0115858710781,
    "2025-06-03": 495.1072592097994,
    "2025-06-04": 501.2029325485207,
    "2025-06-05": 507.29860588724193,
    "2025-06-06": 513.3942792259631,
    "2025-06-07": 519.4899525646845,
    "2025-06-08": 525.5856259034057,
    "2025-06-09": 531.681299242127,
    "2025-06-10": 537.7769725808482,
    "2025-06-11": 543.8726459195695,
    "2025-06-12": 549.9683192582908,
    "2025-06-13": 556.063992597012,
    "2025-06-14": 562.1596659357333,
    "2025-06-15": 568.2553392744545,
    "2025-06-16": 574.3510126131758,
    "2025-06-17": 580.446685951897,
    "2025-06-18": 586.5423592906184,
    "2025-06-19": 592.6380326293396,
    "2025-06-20": 598.7337059680608,
    "2025-06-21": 604.8293793067821,
    "2025-06-22": 610.9250526455035,
    "2025-06-23": 617.0207259842247,
    "2025-06-24": 623.1163993229459,
    "2025-06-25": 629.2120726616672,
    "2025-06-26": 635.3077460003884,
    "2025-06-27": 641.4034193391097,
    "2025-06-28": 647.499092677831,
    "2025-06-29": 653.5947660165523,
    "2025-06-30": 659.6904393552735,
    "2025-07-01": 665.8393908039557,
    "2025-07-02": 671.9883422526378,
    "2025-07-03": 678.1372937013201,
    "2025-07-04": 684.2862451500023,
    "2025-07-05": 690.4351965986845,
    "2025-07-06": 696.5841480473666,
    "2025-07-07": 702.7330994960488,
    "2025-07-08": 708.8820509447311,
    "2025-07-09": 715.0310023934132,
    "2025-07-10": 721.1799538420954,
    "2025-07-11": 727.3289052907776,
    "2025-07-12": 733.4778567394598,
    "2025-07-13": 739.6268081881419,
    "2025-07-14": 745.7757596368242,
    "2025-07-15": 751.9247110855064,
    "2025-07-16": 758.0736625341885,
    "2025-07-17": 764.2226139828707,
    "2025-07-18": 770.3715654315529,
    "2025-07-19": 776.5205168802352,
    "2025-07-20": 782.6694683289173,
    "2025-07-21": 788.8184197775995,
    "2025-07-22": 794.9673712262817,
    "2025-07-23": 801.1163226749638,
    "2025-07-24": 807.2652741236461,
    "2025-07-25": 813.4142255723283,
    "2025-07-26": 819.5631770210105,
    "2025-07-27": 825.7121284696926,
    "2025-07-28": 831.8610799183748,
    "2025-07-29": 838.0100313670571,
    "2025-07-30": 844.1589828157393,
    "2025-07-31": 850.3079342644214,
    "2025-08-01": 855.2835742749276,
    "2025-08-02": 860.2592142854337,
    "2025-08-03": 865.2348542959398,
    "2025-08-04": 870.2104943064459,
    "2025-08-05": 875.186134316952,
    "2025-08-06": 880.1617743274581,
    "2025-08-07": 885.1374143379643,
    "2025-08-08": 890.1130543484704,
    "2025-08-09": 895.0886943589766,
    "2025-08-10": 900.0643343694827,
    "2025-08-11": 905.0399743799888,
    "2025-08-12": 910.0156143904948,
    "2025-08-13": 914.991254401001,
    "2025-08-14": 919.9668944115072,
    "2025-08-15": 924.9425344220132,
    "2025-08-16": 929.9181744325194,
    "2025-08-17": 934.8938144430256,
    "2025-08-18": 939.8694544535316,
    "2025-08-19": 944.845094464038,
    "2025-08-20": 949.820734474544,
    "2025-08-21": 954.79637448505,
    "2025-08-22": 959.7720144955562,
    "2025-08-23": 964.7476545060624,
    "2025-08-24": 969.7232945165684,
    "2025-08-25": 974.6989345270746,
    "2025-08-26": 979.6745745375806,
    "2025-08-27": 984.6502145480868,
    "2025-08-28": 989.6258545585928,
    "2025-08-29": 994.601494569099,
    "2025-08-30": 999.5771345796052,
    "2025-08-31": 1004.5527745901112,
    "2025-09-01": 1008.2576814902092,
    "2025-09-02": 1011.962588390307,
    "2025-09-03": 1015.667495290405,
    "2025-09-04": 1019.3724021905028,
    "2025-09-05": 1023.0773090906008,
    "2025-09-06": 1026.782215990699,
    "2025-09-07": 1030.4871228907964,
    "2025-09-08": 1034.1920297908944,
    "2025-09-09": 1037.896936690992,
    "2025-09-10": 1041.60184359109,
    "2025-09-11": 1045.306750491188,
    "2025-09-12": 1049.0116573912858,
    "2025-09-13": 1052.7165642913835,
    "2025-09-14": 1056.4214711914815,
    "2025-09-15": 1060.1263780915797,
    "2025-09-16": 1063.8312849916774,
    "2025-09-17": 1067.5361918917752,
    "2025-09-18": 1071.2410987918731,
    "2025-09-19": 1074.9460056919709,
    "2025-09-20": 1078.6509125920688,
    "2025-09-21": 1082.3558194921668,
    "2025-09-22": 1086.0607263922643,
    "2025-09-23": 1089.7656332923625,
    "2025-09-24": 1093.4705401924602,
    "2025-09-25": 1097.1754470925582,
    "2025-09-26": 1100.8803539926562,
    "2025-09-27": 1104.585260892754,
    "2025-09-28": 1108.290167792852,
    "2025-09-29": 1111.9950746929496,
    "2025-09-30": 1115.6999815930476,
  },
  Pomegranates: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.457889652103275,
    "2024-10-03": 4.91577930420655,
    "2024-10-04": 7.373668956309825,
    "2024-10-05": 9.8315586084131,
    "2024-10-06": 12.289448260516377,
    "2024-10-07": 14.74733791261965,
    "2024-10-08": 17.205227564722925,
    "2024-10-09": 19.6631172168262,
    "2024-10-10": 22.12100686892948,
    "2024-10-11": 24.578896521032757,
    "2024-10-12": 27.036786173136026,
    "2024-10-13": 29.4946758252393,
    "2024-10-14": 31.952565477342574,
    "2024-10-15": 34.41045512944585,
    "2024-10-16": 36.868344781549126,
    "2024-10-17": 39.3262344336524,
    "2024-10-18": 41.78412408575568,
    "2024-10-19": 44.24201373785896,
    "2024-10-20": 46.69990338996223,
    "2024-10-21": 49.15779304206551,
    "2024-10-22": 51.615682694168775,
    "2024-10-23": 54.07357234627205,
    "2024-10-24": 56.53146199837533,
    "2024-10-25": 58.9893516504786,
    "2024-10-26": 61.44724130258188,
    "2024-10-27": 63.90513095468516,
    "2024-10-28": 66.36302060678842,
    "2024-10-29": 68.8209102588917,
    "2024-10-30": 71.27879991099498,
    "2024-10-31": 73.73668956309825,
    "2024-11-01": 74.5842849739304,
    "2024-11-02": 75.43188038476254,
    "2024-11-03": 76.27947579559468,
    "2024-11-04": 77.12707120642682,
    "2024-11-05": 77.97466661725896,
    "2024-11-06": 78.8222620280911,
    "2024-11-07": 79.66985743892324,
    "2024-11-08": 80.51745284975539,
    "2024-11-09": 81.36504826058753,
    "2024-11-10": 82.21264367141967,
    "2024-11-11": 83.06023908225181,
    "2024-11-12": 83.90783449308395,
    "2024-11-13": 84.7554299039161,
    "2024-11-14": 85.60302531474824,
    "2024-11-15": 86.45062072558038,
    "2024-11-16": 87.29821613641252,
    "2024-11-17": 88.14581154724466,
    "2024-11-18": 88.9934069580768,
    "2024-11-19": 89.84100236890895,
    "2024-11-20": 90.68859777974107,
    "2024-11-21": 91.53619319057324,
    "2024-11-22": 92.38378860140536,
    "2024-11-23": 93.23138401223753,
    "2024-11-24": 94.07897942306964,
    "2024-11-25": 94.9265748339018,
    "2024-11-26": 95.77417024473394,
    "2024-11-27": 96.62176565556608,
    "2024-11-28": 97.46936106639822,
    "2024-11-29": 98.31695647723036,
    "2024-11-30": 99.1645518880625,
    "2024-12-01": 99.52651243179508,
    "2024-12-02": 99.88847297552766,
    "2024-12-03": 100.25043351926024,
    "2024-12-04": 100.61239406299283,
    "2024-12-05": 100.9743546067254,
    "2024-12-06": 101.336315150458,
    "2024-12-07": 101.69827569419056,
    "2024-12-08": 102.06023623792316,
    "2024-12-09": 102.42219678165571,
    "2024-12-10": 102.7841573253883,
    "2024-12-11": 103.14611786912089,
    "2024-12-12": 103.50807841285348,
    "2024-12-13": 103.87003895658606,
    "2024-12-14": 104.23199950031864,
    "2024-12-15": 104.59396004405122,
    "2024-12-16": 104.9559205877838,
    "2024-12-17": 105.31788113151636,
    "2024-12-18": 105.67984167524897,
    "2024-12-19": 106.04180221898152,
    "2024-12-20": 106.40376276271412,
    "2024-12-21": 106.7657233064467,
    "2024-12-22": 107.12768385017928,
    "2024-12-23": 107.48964439391186,
    "2024-12-24": 107.85160493764444,
    "2024-12-25": 108.21356548137702,
    "2024-12-26": 108.5755260251096,
    "2024-12-27": 108.9374865688422,
    "2024-12-28": 109.29944711257475,
    "2024-12-29": 109.66140765630736,
    "2024-12-30": 110.02336820003993,
    "2024-12-31": 110.3853287437725,
    "2025-01-01": 111.0738638739135,
    "2025-01-02": 111.76239900405449,
    "2025-01-03": 112.45093413419548,
    "2025-01-04": 113.13946926433648,
    "2025-01-05": 113.82800439447746,
    "2025-01-06": 114.51653952461844,
    "2025-01-07": 115.20507465475944,
    "2025-01-08": 115.89360978490043,
    "2025-01-09": 116.58214491504144,
    "2025-01-10": 117.27068004518244,
    "2025-01-11": 117.95921517532342,
    "2025-01-12": 118.6477503054644,
    "2025-01-13": 119.3362854356054,
    "2025-01-14": 120.0248205657464,
    "2025-01-15": 120.7133556958874,
    "2025-01-16": 121.40189082602838,
    "2025-01-17": 122.09042595616936,
    "2025-01-18": 122.77896108631036,
    "2025-01-19": 123.46749621645137,
    "2025-01-20": 124.15603134659234,
    "2025-01-21": 124.84456647673332,
    "2025-01-22": 125.53310160687433,
    "2025-01-23": 126.22163673701532,
    "2025-01-24": 126.91017186715632,
    "2025-01-25": 127.59870699729731,
    "2025-01-26": 128.2872421274383,
    "2025-01-27": 128.9757772575793,
    "2025-01-28": 129.6643123877203,
    "2025-01-29": 130.35284751786128,
    "2025-01-30": 131.04138264800227,
    "2025-01-31": 131.72991777814326,
    "2025-02-01": 133.01149866965514,
    "2025-02-02": 134.29307956116702,
    "2025-02-03": 135.5746604526789,
    "2025-02-04": 136.85624134419078,
    "2025-02-05": 138.13782223570266,
    "2025-02-06": 139.41940312721454,
    "2025-02-07": 140.70098401872642,
    "2025-02-08": 141.9825649102383,
    "2025-02-09": 143.26414580175015,
    "2025-02-10": 144.54572669326205,
    "2025-02-11": 145.82730758477393,
    "2025-02-12": 147.1088884762858,
    "2025-02-13": 148.39046936779766,
    "2025-02-14": 149.67205025930957,
    "2025-02-15": 150.95363115082142,
    "2025-02-16": 152.2352120423333,
    "2025-02-17": 153.51679293384518,
    "2025-02-18": 154.79837382535706,
    "2025-02-19": 156.07995471686894,
    "2025-02-20": 157.36153560838082,
    "2025-02-21": 158.6431164998927,
    "2025-02-22": 159.92469739140458,
    "2025-02-23": 161.20627828291646,
    "2025-02-24": 162.48785917442834,
    "2025-02-25": 163.76944006594022,
    "2025-02-26": 165.0510209574521,
    "2025-02-27": 166.33260184896398,
    "2025-02-28": 167.61418274047583,
    "2025-03-01": 169.70077127193355,
    "2025-03-02": 171.7873598033912,
    "2025-03-03": 173.8739483348489,
    "2025-03-04": 175.96053686630657,
    "2025-03-05": 178.04712539776426,
    "2025-03-06": 180.13371392922193,
    "2025-03-07": 182.2203024606796,
    "2025-03-08": 184.30689099213728,
    "2025-03-09": 186.39347952359495,
    "2025-03-10": 188.48006805505264,
    "2025-03-11": 190.56665658651036,
    "2025-03-12": 192.65324511796803,
    "2025-03-13": 194.7398336494257,
    "2025-03-14": 196.82642218088336,
    "2025-03-15": 198.91301071234105,
    "2025-03-16": 200.99959924379877,
    "2025-03-17": 203.0861877752564,
    "2025-03-18": 205.1727763067141,
    "2025-03-19": 207.2593648381718,
    "2025-03-20": 209.34595336962943,
    "2025-03-21": 211.43254190108712,
    "2025-03-22": 213.5191304325448,
    "2025-03-23": 215.6057189640025,
    "2025-03-24": 217.69230749546017,
    "2025-03-25": 219.77889602691783,
    "2025-03-26": 221.86548455837556,
    "2025-03-27": 223.9520730898332,
    "2025-03-28": 226.03866162129088,
    "2025-03-29": 228.12525015274855,
    "2025-03-30": 230.21183868420627,
    "2025-03-31": 232.29842721566396,
    "2025-04-01": 235.95149163262,
    "2025-04-02": 239.604556049576,
    "2025-04-03": 243.257620466532,
    "2025-04-04": 246.910684883488,
    "2025-04-05": 250.563749300444,
    "2025-04-06": 254.21681371740004,
    "2025-04-07": 257.86987813435604,
    "2025-04-08": 261.5229425513121,
    "2025-04-09": 265.1760069682681,
    "2025-04-10": 268.8290713852241,
    "2025-04-11": 272.4821358021801,
    "2025-04-12": 276.1352002191361,
    "2025-04-13": 279.7882646360921,
    "2025-04-14": 283.4413290530482,
    "2025-04-15": 287.0943934700042,
    "2025-04-16": 290.7474578869602,
    "2025-04-17": 294.40052230391626,
    "2025-04-18": 298.05358672087226,
    "2025-04-19": 301.7066511378283,
    "2025-04-20": 305.3597155547843,
    "2025-04-21": 309.0127799717403,
    "2025-04-22": 312.6658443886963,
    "2025-04-23": 316.3189088056524,
    "2025-04-24": 319.9719732226084,
    "2025-04-25": 323.6250376395644,
    "2025-04-26": 327.2781020565204,
    "2025-04-27": 330.9311664734764,
    "2025-04-28": 334.5842308904324,
    "2025-04-29": 338.2372953073885,
    "2025-04-30": 341.8903597243445,
    "2025-05-01": 346.1119004191254,
    "2025-05-02": 350.3334411139064,
    "2025-05-03": 354.5549818086873,
    "2025-05-04": 358.77652250346824,
    "2025-05-05": 362.9980631982492,
    "2025-05-06": 367.2196038930301,
    "2025-05-07": 371.44114458781104,
    "2025-05-08": 375.662685282592,
    "2025-05-09": 379.8842259773729,
    "2025-05-10": 384.1057666721538,
    "2025-05-11": 388.3273073669348,
    "2025-05-12": 392.5488480617157,
    "2025-05-13": 396.7703887564967,
    "2025-05-14": 400.9919294512776,
    "2025-05-15": 405.2134701460585,
    "2025-05-16": 409.4350108408395,
    "2025-05-17": 413.6565515356204,
    "2025-05-18": 417.8780922304013,
    "2025-05-19": 422.0996329251823,
    "2025-05-20": 426.3211736199633,
    "2025-05-21": 430.54271431474416,
    "2025-05-22": 434.7642550095251,
    "2025-05-23": 438.9857957043061,
    "2025-05-24": 443.20733639908696,
    "2025-05-25": 447.4288770938679,
    "2025-05-26": 451.6504177886488,
    "2025-05-27": 455.8719584834298,
    "2025-05-28": 460.0934991782107,
    "2025-05-29": 464.3150398729916,
    "2025-05-30": 468.5365805677726,
    "2025-05-31": 472.7581212625535,
    "2025-06-01": 477.5258280729144,
    "2025-06-02": 482.2935348832752,
    "2025-06-03": 487.0612416936361,
    "2025-06-04": 491.82894850399697,
    "2025-06-05": 496.5966553143578,
    "2025-06-06": 501.3643621247187,
    "2025-06-07": 506.1320689350796,
    "2025-06-08": 510.8997757454404,
    "2025-06-09": 515.6674825558013,
    "2025-06-10": 520.4351893661621,
    "2025-06-11": 525.202896176523,
    "2025-06-12": 529.9706029868839,
    "2025-06-13": 534.7383097972447,
    "2025-06-14": 539.5060166076056,
    "2025-06-15": 544.2737234179665,
    "2025-06-16": 549.0414302283273,
    "2025-06-17": 553.8091370386882,
    "2025-06-18": 558.576843849049,
    "2025-06-19": 563.34455065941,
    "2025-06-20": 568.1122574697708,
    "2025-06-21": 572.8799642801316,
    "2025-06-22": 577.6476710904925,
    "2025-06-23": 582.4153779008534,
    "2025-06-24": 587.1830847112142,
    "2025-06-25": 591.9507915215751,
    "2025-06-26": 596.718498331936,
    "2025-06-27": 601.4862051422969,
    "2025-06-28": 606.2539119526577,
    "2025-06-29": 611.0216187630185,
    "2025-06-30": 615.7893255733794,
    "2025-07-01": 621.0714187523741,
    "2025-07-02": 626.3535119313689,
    "2025-07-03": 631.6356051103637,
    "2025-07-04": 636.9176982893584,
    "2025-07-05": 642.1997914683532,
    "2025-07-06": 647.4818846473479,
    "2025-07-07": 652.7639778263426,
    "2025-07-08": 658.0460710053374,
    "2025-07-09": 663.3281641843321,
    "2025-07-10": 668.6102573633269,
    "2025-07-11": 673.8923505423217,
    "2025-07-12": 679.1744437213164,
    "2025-07-13": 684.4565369003111,
    "2025-07-14": 689.7386300793058,
    "2025-07-15": 695.0207232583007,
    "2025-07-16": 700.3028164372954,
    "2025-07-17": 705.5849096162901,
    "2025-07-18": 710.8670027952849,
    "2025-07-19": 716.1490959742796,
    "2025-07-20": 721.4311891532743,
    "2025-07-21": 726.713282332269,
    "2025-07-22": 731.9953755112639,
    "2025-07-23": 737.2774686902586,
    "2025-07-24": 742.5595618692533,
    "2025-07-25": 747.8416550482481,
    "2025-07-26": 753.1237482272428,
    "2025-07-27": 758.4058414062376,
    "2025-07-28": 763.6879345852324,
    "2025-07-29": 768.9700277642271,
    "2025-07-30": 774.2521209432218,
    "2025-07-31": 779.5342141222166,
    "2025-08-01": 784.4682388385484,
    "2025-08-02": 789.4022635548803,
    "2025-08-03": 794.3362882712121,
    "2025-08-04": 799.2703129875439,
    "2025-08-05": 804.2043377038758,
    "2025-08-06": 809.1383624202076,
    "2025-08-07": 814.0723871365394,
    "2025-08-08": 819.0064118528713,
    "2025-08-09": 823.9404365692031,
    "2025-08-10": 828.8744612855351,
    "2025-08-11": 833.8084860018669,
    "2025-08-12": 838.7425107181987,
    "2025-08-13": 843.6765354345306,
    "2025-08-14": 848.6105601508624,
    "2025-08-15": 853.5445848671942,
    "2025-08-16": 858.4786095835261,
    "2025-08-17": 863.4126342998579,
    "2025-08-18": 868.3466590161897,
    "2025-08-19": 873.2806837325217,
    "2025-08-20": 878.2147084488535,
    "2025-08-21": 883.1487331651853,
    "2025-08-22": 888.0827578815172,
    "2025-08-23": 893.016782597849,
    "2025-08-24": 897.9508073141808,
    "2025-08-25": 902.8848320305128,
    "2025-08-26": 907.8188567468444,
    "2025-08-27": 912.7528814631764,
    "2025-08-28": 917.6869061795082,
    "2025-08-29": 922.62093089584,
    "2025-08-30": 927.554955612172,
    "2025-08-31": 932.4889803285038,
    "2025-09-01": 936.1091087261892,
    "2025-09-02": 939.7292371238748,
    "2025-09-03": 943.3493655215603,
    "2025-09-04": 946.969493919246,
    "2025-09-05": 950.5896223169316,
    "2025-09-06": 954.209750714617,
    "2025-09-07": 957.8298791123024,
    "2025-09-08": 961.450007509988,
    "2025-09-09": 965.0701359076736,
    "2025-09-10": 968.6902643053592,
    "2025-09-11": 972.3103927030446,
    "2025-09-12": 975.9305211007302,
    "2025-09-13": 979.5506494984156,
    "2025-09-14": 983.1707778961012,
    "2025-09-15": 986.7909062937867,
    "2025-09-16": 990.4110346914724,
    "2025-09-17": 994.031163089158,
    "2025-09-18": 997.6512914868434,
    "2025-09-19": 1001.271419884529,
    "2025-09-20": 1004.8915482822144,
    "2025-09-21": 1008.5116766799,
    "2025-09-22": 1012.1318050775856,
    "2025-09-23": 1015.7519334752712,
    "2025-09-24": 1019.3720618729566,
    "2025-09-25": 1022.992190270642,
    "2025-09-26": 1026.6123186683276,
    "2025-09-27": 1030.2324470660133,
    "2025-09-28": 1033.8525754636987,
    "2025-09-29": 1037.4727038613844,
    "2025-09-30": 1041.0928322590698,
  },
  Prunes: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.3406226866014403,
    "2024-10-03": 4.681245373202881,
    "2024-10-04": 7.021868059804321,
    "2024-10-05": 9.36249074640576,
    "2024-10-06": 11.703113433007202,
    "2024-10-07": 14.043736119608642,
    "2024-10-08": 16.38435880621008,
    "2024-10-09": 18.724981492811523,
    "2024-10-10": 21.065604179412965,
    "2024-10-11": 23.406226866014403,
    "2024-10-12": 25.74684955261584,
    "2024-10-13": 28.087472239217284,
    "2024-10-14": 30.428094925818726,
    "2024-10-15": 32.76871761242016,
    "2024-10-16": 35.1093402990216,
    "2024-10-17": 37.449962985623046,
    "2024-10-18": 39.79058567222449,
    "2024-10-19": 42.13120835882593,
    "2024-10-20": 44.471831045427365,
    "2024-10-21": 46.81245373202881,
    "2024-10-22": 49.15307641863025,
    "2024-10-23": 51.49369910523168,
    "2024-10-24": 53.834321791833126,
    "2024-10-25": 56.17494447843457,
    "2024-10-26": 58.51556716503601,
    "2024-10-27": 60.85618985163745,
    "2024-10-28": 63.19681253823889,
    "2024-10-29": 65.53743522484032,
    "2024-10-30": 67.87805791144177,
    "2024-10-31": 70.2186805980432,
    "2024-11-01": 71.01697433973831,
    "2024-11-02": 71.81526808143342,
    "2024-11-03": 72.61356182312852,
    "2024-11-04": 73.41185556482361,
    "2024-11-05": 74.21014930651872,
    "2024-11-06": 75.00844304821382,
    "2024-11-07": 75.80673678990892,
    "2024-11-08": 76.60503053160403,
    "2024-11-09": 77.40332427329912,
    "2024-11-10": 78.20161801499422,
    "2024-11-11": 78.99991175668933,
    "2024-11-12": 79.79820549838443,
    "2024-11-13": 80.59649924007954,
    "2024-11-14": 81.39479298177464,
    "2024-11-15": 82.19308672346975,
    "2024-11-16": 82.99138046516484,
    "2024-11-17": 83.78967420685994,
    "2024-11-18": 84.58796794855505,
    "2024-11-19": 85.38626169025015,
    "2024-11-20": 86.18455543194526,
    "2024-11-21": 86.98284917364035,
    "2024-11-22": 87.78114291533547,
    "2024-11-23": 88.57943665703056,
    "2024-11-24": 89.37773039872566,
    "2024-11-25": 90.17602414042076,
    "2024-11-26": 90.97431788211588,
    "2024-11-27": 91.77261162381096,
    "2024-11-28": 92.57090536550606,
    "2024-11-29": 93.36919910720115,
    "2024-11-30": 94.16749284889627,
    "2024-12-01": 94.56066670116869,
    "2024-12-02": 94.9538405534411,
    "2024-12-03": 95.34701440571352,
    "2024-12-04": 95.74018825798592,
    "2024-12-05": 96.13336211025836,
    "2024-12-06": 96.52653596253076,
    "2024-12-07": 96.91970981480316,
    "2024-12-08": 97.3128836670756,
    "2024-12-09": 97.706057519348,
    "2024-12-10": 98.09923137162042,
    "2024-12-11": 98.49240522389285,
    "2024-12-12": 98.88557907616524,
    "2024-12-13": 99.27875292843768,
    "2024-12-14": 99.67192678071008,
    "2024-12-15": 100.06510063298248,
    "2024-12-16": 100.4582744852549,
    "2024-12-17": 100.85144833752732,
    "2024-12-18": 101.24462218979974,
    "2024-12-19": 101.63779604207215,
    "2024-12-20": 102.03096989434457,
    "2024-12-21": 102.42414374661698,
    "2024-12-22": 102.8173175988894,
    "2024-12-23": 103.2104914511618,
    "2024-12-24": 103.60366530343424,
    "2024-12-25": 103.99683915570664,
    "2024-12-26": 104.39001300797904,
    "2024-12-27": 104.78318686025146,
    "2024-12-28": 105.17636071252387,
    "2024-12-29": 105.5695345647963,
    "2024-12-30": 105.96270841706873,
    "2024-12-31": 106.35588226934112,
    "2025-01-01": 107.02378188403482,
    "2025-01-02": 107.69168149872851,
    "2025-01-03": 108.3595811134222,
    "2025-01-04": 109.0274807281159,
    "2025-01-05": 109.6953803428096,
    "2025-01-06": 110.3632799575033,
    "2025-01-07": 111.031179572197,
    "2025-01-08": 111.69907918689069,
    "2025-01-09": 112.36697880158438,
    "2025-01-10": 113.03487841627808,
    "2025-01-11": 113.70277803097176,
    "2025-01-12": 114.37067764566548,
    "2025-01-13": 115.03857726035916,
    "2025-01-14": 115.70647687505286,
    "2025-01-15": 116.37437648974657,
    "2025-01-16": 117.04227610444023,
    "2025-01-17": 117.71017571913396,
    "2025-01-18": 118.37807533382764,
    "2025-01-19": 119.04597494852136,
    "2025-01-20": 119.71387456321504,
    "2025-01-21": 120.38177417790874,
    "2025-01-22": 121.04967379260243,
    "2025-01-23": 121.71757340729611,
    "2025-01-24": 122.38547302198982,
    "2025-01-25": 123.05337263668352,
    "2025-01-26": 123.7212722513772,
    "2025-01-27": 124.38917186607092,
    "2025-01-28": 125.0570714807646,
    "2025-01-29": 125.7249710954583,
    "2025-01-30": 126.392870710152,
    "2025-01-31": 127.06077032484568,
    "2025-02-01": 128.6109225208597,
    "2025-02-02": 130.1610747168737,
    "2025-02-03": 131.71122691288775,
    "2025-02-04": 133.26137910890176,
    "2025-02-05": 134.81153130491575,
    "2025-02-06": 136.3616835009298,
    "2025-02-07": 137.9118356969438,
    "2025-02-08": 139.46198789295784,
    "2025-02-09": 141.01214008897185,
    "2025-02-10": 142.56229228498586,
    "2025-02-11": 144.11244448099987,
    "2025-02-12": 145.66259667701388,
    "2025-02-13": 147.21274887302792,
    "2025-02-14": 148.76290106904193,
    "2025-02-15": 150.31305326505594,
    "2025-02-16": 151.86320546106995,
    "2025-02-17": 153.413357657084,
    "2025-02-18": 154.963509853098,
    "2025-02-19": 156.513662049112,
    "2025-02-20": 158.06381424512605,
    "2025-02-21": 159.61396644114006,
    "2025-02-22": 161.16411863715408,
    "2025-02-23": 162.7142708331681,
    "2025-02-24": 164.2644230291821,
    "2025-02-25": 165.8145752251961,
    "2025-02-26": 167.36472742121015,
    "2025-02-27": 168.91487961722416,
    "2025-02-28": 170.46503181323817,
    "2025-03-01": 172.49966239482265,
    "2025-03-02": 174.53429297640716,
    "2025-03-03": 176.56892355799164,
    "2025-03-04": 178.60355413957615,
    "2025-03-05": 180.63818472116063,
    "2025-03-06": 182.67281530274516,
    "2025-03-07": 184.7074458843296,
    "2025-03-08": 186.74207646591407,
    "2025-03-09": 188.7767070474986,
    "2025-03-10": 190.8113376290831,
    "2025-03-11": 192.8459682106676,
    "2025-03-12": 194.8805987922521,
    "2025-03-13": 196.91522937383655,
    "2025-03-14": 198.9498599554211,
    "2025-03-15": 200.9844905370056,
    "2025-03-16": 203.01912111859008,
    "2025-03-17": 205.05375170017456,
    "2025-03-18": 207.08838228175907,
    "2025-03-19": 209.12301286334355,
    "2025-03-20": 211.15764344492808,
    "2025-03-21": 213.1922740265125,
    "2025-03-22": 215.22690460809704,
    "2025-03-23": 217.26153518968152,
    "2025-03-24": 219.29616577126603,
    "2025-03-25": 221.3307963528505,
    "2025-03-26": 223.365426934435,
    "2025-03-27": 225.4000575160195,
    "2025-03-28": 227.434688097604,
    "2025-03-29": 229.4693186791885,
    "2025-03-30": 231.50394926077297,
    "2025-03-31": 233.53857984235748,
    "2025-04-01": 237.28581651556408,
    "2025-04-02": 241.0330531887707,
    "2025-04-03": 244.7802898619773,
    "2025-04-04": 248.5275265351839,
    "2025-04-05": 252.2747632083905,
    "2025-04-06": 256.02199988159714,
    "2025-04-07": 259.76923655480374,
    "2025-04-08": 263.51647322801034,
    "2025-04-09": 267.26370990121694,
    "2025-04-10": 271.01094657442354,
    "2025-04-11": 274.7581832476302,
    "2025-04-12": 278.5054199208368,
    "2025-04-13": 282.2526565940434,
    "2025-04-14": 285.99989326725,
    "2025-04-15": 289.7471299404566,
    "2025-04-16": 293.4943666136632,
    "2025-04-17": 297.2416032868698,
    "2025-04-18": 300.98883996007646,
    "2025-04-19": 304.736076633283,
    "2025-04-20": 308.48331330648966,
    "2025-04-21": 312.23054997969626,
    "2025-04-22": 315.97778665290286,
    "2025-04-23": 319.72502332610946,
    "2025-04-24": 323.47225999931607,
    "2025-04-25": 327.21949667252267,
    "2025-04-26": 330.96673334572927,
    "2025-04-27": 334.7139700189359,
    "2025-04-28": 338.4612066921425,
    "2025-04-29": 342.2084433653491,
    "2025-04-30": 345.9556800385557,
    "2025-05-01": 350.3436148086813,
    "2025-05-02": 354.73154957880695,
    "2025-05-03": 359.11948434893253,
    "2025-05-04": 363.5074191190581,
    "2025-05-05": 367.89535388918375,
    "2025-05-06": 372.2832886593093,
    "2025-05-07": 376.6712234294349,
    "2025-05-08": 381.05915819956056,
    "2025-05-09": 385.4470929696861,
    "2025-05-10": 389.8350277398118,
    "2025-05-11": 394.22296250993736,
    "2025-05-12": 398.6108972800629,
    "2025-05-13": 402.9988320501886,
    "2025-05-14": 407.38676682031416,
    "2025-05-15": 411.7747015904398,
    "2025-05-16": 416.1626363605654,
    "2025-05-17": 420.55057113069097,
    "2025-05-18": 424.9385059008166,
    "2025-05-19": 429.3264406709422,
    "2025-05-20": 433.7143754410678,
    "2025-05-21": 438.1023102111934,
    "2025-05-22": 442.490244981319,
    "2025-05-23": 446.8781797514446,
    "2025-05-24": 451.2661145215702,
    "2025-05-25": 455.6540492916958,
    "2025-05-26": 460.0419840618214,
    "2025-05-27": 464.429918831947,
    "2025-05-28": 468.8178536020726,
    "2025-05-29": 473.2057883721982,
    "2025-05-30": 477.5937231423238,
    "2025-05-31": 481.9816579124494,
    "2025-06-01": 487.3268611555208,
    "2025-06-02": 492.67206439859217,
    "2025-06-03": 498.0172676416636,
    "2025-06-04": 503.362470884735,
    "2025-06-05": 508.7076741278064,
    "2025-06-06": 514.0528773708777,
    "2025-06-07": 519.3980806139491,
    "2025-06-08": 524.7432838570205,
    "2025-06-09": 530.0884871000919,
    "2025-06-10": 535.4336903431633,
    "2025-06-11": 540.7788935862347,
    "2025-06-12": 546.124096829306,
    "2025-06-13": 551.4693000723775,
    "2025-06-14": 556.8145033154489,
    "2025-06-15": 562.1597065585203,
    "2025-06-16": 567.5049098015917,
    "2025-06-17": 572.850113044663,
    "2025-06-18": 578.1953162877344,
    "2025-06-19": 583.5405195308058,
    "2025-06-20": 588.8857227738772,
    "2025-06-21": 594.2309260169486,
    "2025-06-22": 599.57612926002,
    "2025-06-23": 604.9213325030913,
    "2025-06-24": 610.2665357461627,
    "2025-06-25": 615.6117389892341,
    "2025-06-26": 620.9569422323056,
    "2025-06-27": 626.302145475377,
    "2025-06-28": 631.6473487184483,
    "2025-06-29": 636.9925519615197,
    "2025-06-30": 642.3377552045911,
    "2025-07-01": 648.1942464025859,
    "2025-07-02": 654.0507376005806,
    "2025-07-03": 659.9072287985755,
    "2025-07-04": 665.7637199965703,
    "2025-07-05": 671.6202111945652,
    "2025-07-06": 677.4767023925599,
    "2025-07-07": 683.3331935905547,
    "2025-07-08": 689.1896847885496,
    "2025-07-09": 695.0461759865444,
    "2025-07-10": 700.9026671845392,
    "2025-07-11": 706.759158382534,
    "2025-07-12": 712.6156495805288,
    "2025-07-13": 718.4721407785237,
    "2025-07-14": 724.3286319765184,
    "2025-07-15": 730.1851231745133,
    "2025-07-16": 736.0416143725081,
    "2025-07-17": 741.8981055705029,
    "2025-07-18": 747.7545967684977,
    "2025-07-19": 753.6110879664925,
    "2025-07-20": 759.4675791644873,
    "2025-07-21": 765.3240703624822,
    "2025-07-22": 771.1805615604769,
    "2025-07-23": 777.0370527584718,
    "2025-07-24": 782.8935439564666,
    "2025-07-25": 788.7500351544613,
    "2025-07-26": 794.6065263524562,
    "2025-07-27": 800.463017550451,
    "2025-07-28": 806.3195087484459,
    "2025-07-29": 812.1759999464407,
    "2025-07-30": 818.0324911444354,
    "2025-07-31": 823.8889823424303,
    "2025-08-01": 828.5873275929093,
    "2025-08-02": 833.2856728433883,
    "2025-08-03": 837.9840180938673,
    "2025-08-04": 842.6823633443463,
    "2025-08-05": 847.3807085948254,
    "2025-08-06": 852.0790538453043,
    "2025-08-07": 856.7773990957834,
    "2025-08-08": 861.4757443462623,
    "2025-08-09": 866.1740895967414,
    "2025-08-10": 870.8724348472203,
    "2025-08-11": 875.5707800976994,
    "2025-08-12": 880.2691253481784,
    "2025-08-13": 884.9674705986574,
    "2025-08-14": 889.6658158491364,
    "2025-08-15": 894.3641610996154,
    "2025-08-16": 899.0625063500944,
    "2025-08-17": 903.7608516005736,
    "2025-08-18": 908.4591968510524,
    "2025-08-19": 913.1575421015316,
    "2025-08-20": 917.8558873520104,
    "2025-08-21": 922.5542326024896,
    "2025-08-22": 927.2525778529684,
    "2025-08-23": 931.9509231034476,
    "2025-08-24": 936.6492683539263,
    "2025-08-25": 941.3476136044056,
    "2025-08-26": 946.0459588548844,
    "2025-08-27": 950.7443041053637,
    "2025-08-28": 955.4426493558426,
    "2025-08-29": 960.1409946063216,
    "2025-08-30": 964.8393398568004,
    "2025-08-31": 969.5376851072796,
    "2025-09-01": 973.0308073044748,
    "2025-09-02": 976.52392950167,
    "2025-09-03": 980.0170516988652,
    "2025-09-04": 983.5101738960605,
    "2025-09-05": 987.0032960932556,
    "2025-09-06": 990.4964182904508,
    "2025-09-07": 993.989540487646,
    "2025-09-08": 997.4826626848412,
    "2025-09-09": 1000.9757848820364,
    "2025-09-10": 1004.4689070792316,
    "2025-09-11": 1007.962029276427,
    "2025-09-12": 1011.455151473622,
    "2025-09-13": 1014.9482736708172,
    "2025-09-14": 1018.4413958680126,
    "2025-09-15": 1021.9345180652078,
    "2025-09-16": 1025.427640262403,
    "2025-09-17": 1028.920762459598,
    "2025-09-18": 1032.4138846567937,
    "2025-09-19": 1035.9070068539886,
    "2025-09-20": 1039.4001290511835,
    "2025-09-21": 1042.893251248379,
    "2025-09-22": 1046.3863734455742,
    "2025-09-23": 1049.8794956427696,
    "2025-09-24": 1053.3726178399647,
    "2025-09-25": 1056.86574003716,
    "2025-09-26": 1060.3588622343552,
    "2025-09-27": 1063.8519844315504,
    "2025-09-28": 1067.3451066287455,
    "2025-09-29": 1070.8382288259409,
    "2025-09-30": 1074.331351023136,
  },
  Walnuts: {
    "2024-10-01": 0.0,
    "2024-10-02": 2.4399967069965105,
    "2024-10-03": 4.879993413993021,
    "2024-10-04": 7.319990120989532,
    "2024-10-05": 9.759986827986042,
    "2024-10-06": 12.199983534982552,
    "2024-10-07": 14.639980241979064,
    "2024-10-08": 17.079976948975574,
    "2024-10-09": 19.519973655972084,
    "2024-10-10": 21.959970362968598,
    "2024-10-11": 24.399967069965104,
    "2024-10-12": 26.83996377696161,
    "2024-10-13": 29.279960483958128,
    "2024-10-14": 31.71995719095464,
    "2024-10-15": 34.15995389795115,
    "2024-10-16": 36.59995060494766,
    "2024-10-17": 39.03994731194417,
    "2024-10-18": 41.47994401894068,
    "2024-10-19": 43.91994072593719,
    "2024-10-20": 46.3599374329337,
    "2024-10-21": 48.79993413993021,
    "2024-10-22": 51.23993084692672,
    "2024-10-23": 53.67992755392323,
    "2024-10-24": 56.11992426091974,
    "2024-10-25": 58.559920967916256,
    "2024-10-26": 60.999917674912766,
    "2024-10-27": 63.43991438190928,
    "2024-10-28": 65.87991108890579,
    "2024-10-29": 68.3199077959023,
    "2024-10-30": 70.7599045028988,
    "2024-10-31": 73.19990120989532,
    "2024-11-01": 74.17423920254525,
    "2024-11-02": 75.1485771951952,
    "2024-11-03": 76.12291518784514,
    "2024-11-04": 77.09725318049509,
    "2024-11-05": 78.07159117314502,
    "2024-11-06": 79.04592916579497,
    "2024-11-07": 80.02026715844491,
    "2024-11-08": 80.99460515109485,
    "2024-11-09": 81.9689431437448,
    "2024-11-10": 82.94328113639473,
    "2024-11-11": 83.91761912904468,
    "2024-11-12": 84.89195712169462,
    "2024-11-13": 85.86629511434457,
    "2024-11-14": 86.8406331069945,
    "2024-11-15": 87.81497109964445,
    "2024-11-16": 88.78930909229439,
    "2024-11-17": 89.76364708494432,
    "2024-11-18": 90.73798507759427,
    "2024-11-19": 91.7123230702442,
    "2024-11-20": 92.68666106289416,
    "2024-11-21": 93.6609990555441,
    "2024-11-22": 94.63533704819405,
    "2024-11-23": 95.60967504084398,
    "2024-11-24": 96.58401303349392,
    "2024-11-25": 97.55835102614388,
    "2024-11-26": 98.5326890187938,
    "2024-11-27": 99.50702701144374,
    "2024-11-28": 100.48136500409367,
    "2024-11-29": 101.45570299674364,
    "2024-11-30": 102.43004098939358,
    "2024-12-01": 102.8164636241922,
    "2024-12-02": 103.20288625899084,
    "2024-12-03": 103.58930889378944,
    "2024-12-04": 103.97573152858808,
    "2024-12-05": 104.3621541633867,
    "2024-12-06": 104.74857679818534,
    "2024-12-07": 105.13499943298396,
    "2024-12-08": 105.5214220677826,
    "2024-12-09": 105.90784470258122,
    "2024-12-10": 106.29426733737984,
    "2024-12-11": 106.68068997217848,
    "2024-12-12": 107.0671126069771,
    "2024-12-13": 107.45353524177573,
    "2024-12-14": 107.83995787657436,
    "2024-12-15": 108.22638051137298,
    "2024-12-16": 108.6128031461716,
    "2024-12-17": 108.99922578097024,
    "2024-12-18": 109.38564841576888,
    "2024-12-19": 109.77207105056748,
    "2024-12-20": 110.15849368536612,
    "2024-12-21": 110.54491632016476,
    "2024-12-22": 110.93133895496338,
    "2024-12-23": 111.317761589762,
    "2024-12-24": 111.70418422456063,
    "2024-12-25": 112.09060685935926,
    "2024-12-26": 112.47702949415788,
    "2024-12-27": 112.86345212895652,
    "2024-12-28": 113.24987476375514,
    "2024-12-29": 113.63629739855376,
    "2024-12-30": 114.0227200333524,
    "2024-12-31": 114.40914266815102,
    "2025-01-01": 115.01275834362453,
    "2025-01-02": 115.616374019098,
    "2025-01-03": 116.21998969457152,
    "2025-01-04": 116.823605370045,
    "2025-01-05": 117.4272210455185,
    "2025-01-06": 118.030836720992,
    "2025-01-07": 118.63445239646548,
    "2025-01-08": 119.23806807193898,
    "2025-01-09": 119.84168374741247,
    "2025-01-10": 120.44529942288597,
    "2025-01-11": 121.04891509835946,
    "2025-01-12": 121.65253077383296,
    "2025-01-13": 122.25614644930646,
    "2025-01-14": 122.85976212477996,
    "2025-01-15": 123.46337780025344,
    "2025-01-16": 124.06699347572692,
    "2025-01-17": 124.67060915120042,
    "2025-01-18": 125.27422482667392,
    "2025-01-19": 125.87784050214742,
    "2025-01-20": 126.48145617762091,
    "2025-01-21": 127.0850718530944,
    "2025-01-22": 127.6886875285679,
    "2025-01-23": 128.2923032040414,
    "2025-01-24": 128.89591887951488,
    "2025-01-25": 129.49953455498837,
    "2025-01-26": 130.1031502304619,
    "2025-01-27": 130.70676590593538,
    "2025-01-28": 131.31038158140888,
    "2025-01-29": 131.91399725688237,
    "2025-01-30": 132.51761293235586,
    "2025-01-31": 133.12122860782935,
    "2025-02-01": 134.4218649665682,
    "2025-02-02": 135.722501325307,
    "2025-02-03": 137.02313768404585,
    "2025-02-04": 138.32377404278466,
    "2025-02-05": 139.6244104015235,
    "2025-02-06": 140.92504676026235,
    "2025-02-07": 142.22568311900116,
    "2025-02-08": 143.52631947774,
    "2025-02-09": 144.82695583647882,
    "2025-02-10": 146.12759219521766,
    "2025-02-11": 147.4282285539565,
    "2025-02-12": 148.72886491269531,
    "2025-02-13": 150.02950127143416,
    "2025-02-14": 151.330137630173,
    "2025-02-15": 152.6307739889118,
    "2025-02-16": 153.93141034765063,
    "2025-02-17": 155.23204670638947,
    "2025-02-18": 156.5326830651283,
    "2025-02-19": 157.83331942386715,
    "2025-02-20": 159.13395578260597,
    "2025-02-21": 160.4345921413448,
    "2025-02-22": 161.73522850008362,
    "2025-02-23": 163.03586485882246,
    "2025-02-24": 164.3365012175613,
    "2025-02-25": 165.63713757630012,
    "2025-02-26": 166.93777393503896,
    "2025-02-27": 168.2384102937778,
    "2025-02-28": 169.53904665251662,
    "2025-03-01": 171.48785485420348,
    "2025-03-02": 173.43666305589034,
    "2025-03-03": 175.38547125757722,
    "2025-03-04": 177.33427945926408,
    "2025-03-05": 179.28308766095094,
    "2025-03-06": 181.2318958626378,
    "2025-03-07": 183.18070406432463,
    "2025-03-08": 185.12951226601157,
    "2025-03-09": 187.0783204676984,
    "2025-03-10": 189.0271286693853,
    "2025-03-11": 190.9759368710721,
    "2025-03-12": 192.92474507275895,
    "2025-03-13": 194.87355327444584,
    "2025-03-14": 196.82236147613276,
    "2025-03-15": 198.7711696778196,
    "2025-03-16": 200.71997787950644,
    "2025-03-17": 202.6687860811933,
    "2025-03-18": 204.6175942828802,
    "2025-03-19": 206.56640248456705,
    "2025-03-20": 208.5152106862539,
    "2025-03-21": 210.4640188879408,
    "2025-03-22": 212.41282708962763,
    "2025-03-23": 214.36163529131449,
    "2025-03-24": 216.31044349300137,
    "2025-03-25": 218.25925169468823,
    "2025-03-26": 220.2080598963751,
    "2025-03-27": 222.15686809806195,
    "2025-03-28": 224.10567629974884,
    "2025-03-29": 226.0544845014357,
    "2025-03-30": 228.00329270312253,
    "2025-03-31": 229.9521009048094,
    "2025-04-01": 233.4736861691736,
    "2025-04-02": 236.9952714335377,
    "2025-04-03": 240.5168566979019,
    "2025-04-04": 244.0384419622661,
    "2025-04-05": 247.5600272266302,
    "2025-04-06": 251.0816124909944,
    "2025-04-07": 254.6031977553585,
    "2025-04-08": 258.1247830197227,
    "2025-04-09": 261.64636828408686,
    "2025-04-10": 265.167953548451,
    "2025-04-11": 268.6895388128152,
    "2025-04-12": 272.2111240771793,
    "2025-04-13": 275.7327093415435,
    "2025-04-14": 279.25429460590766,
    "2025-04-15": 282.7758798702718,
    "2025-04-16": 286.297465134636,
    "2025-04-17": 289.81905039900016,
    "2025-04-18": 293.3406356633643,
    "2025-04-19": 296.86222092772846,
    "2025-04-20": 300.3838061920926,
    "2025-04-21": 303.90539145645675,
    "2025-04-22": 307.4269767208209,
    "2025-04-23": 310.9485619851851,
    "2025-04-24": 314.47014724954926,
    "2025-04-25": 317.9917325139134,
    "2025-04-26": 321.51331777827755,
    "2025-04-27": 325.03490304264176,
    "2025-04-28": 328.5564883070059,
    "2025-04-29": 332.07807357137006,
    "2025-04-30": 335.5996588357342,
    "2025-05-01": 340.7829002537587,
    "2025-05-02": 345.96614167178325,
    "2025-05-03": 351.14938308980777,
    "2025-05-04": 356.3326245078323,
    "2025-05-05": 361.5158659258568,
    "2025-05-06": 366.6991073438813,
    "2025-05-07": 371.88234876190586,
    "2025-05-08": 377.0655901799304,
    "2025-05-09": 382.2488315979549,
    "2025-05-10": 387.4320730159794,
    "2025-05-11": 392.615314434004,
    "2025-05-12": 397.79855585202847,
    "2025-05-13": 402.981797270053,
    "2025-05-14": 408.1650386880775,
    "2025-05-15": 413.3482801061021,
    "2025-05-16": 418.53152152412656,
    "2025-05-17": 423.7147629421511,
    "2025-05-18": 428.8980043601756,
    "2025-05-19": 434.0812457782001,
    "2025-05-20": 439.2644871962247,
    "2025-05-21": 444.4477286142492,
    "2025-05-22": 449.63097003227375,
    "2025-05-23": 454.8142114502983,
    "2025-05-24": 459.9974528683228,
    "2025-05-25": 465.1806942863473,
    "2025-05-26": 470.36393570437184,
    "2025-05-27": 475.5471771223964,
    "2025-05-28": 480.7304185404209,
    "2025-05-29": 485.9136599584454,
    "2025-05-30": 491.09690137646993,
    "2025-05-31": 496.28014279449445,
    "2025-06-01": 502.9028261562274,
    "2025-06-02": 509.5255095179603,
    "2025-06-03": 516.1481928796932,
    "2025-06-04": 522.7708762414261,
    "2025-06-05": 529.393559603159,
    "2025-06-06": 536.016242964892,
    "2025-06-07": 542.6389263266249,
    "2025-06-08": 549.2616096883578,
    "2025-06-09": 555.8842930500907,
    "2025-06-10": 562.5069764118236,
    "2025-06-11": 569.1296597735566,
    "2025-06-12": 575.7523431352895,
    "2025-06-13": 582.3750264970224,
    "2025-06-14": 588.9977098587553,
    "2025-06-15": 595.6203932204883,
    "2025-06-16": 602.2430765822212,
    "2025-06-17": 608.8657599439541,
    "2025-06-18": 615.488443305687,
    "2025-06-19": 622.11112666742,
    "2025-06-20": 628.7338100291529,
    "2025-06-21": 635.3564933908858,
    "2025-06-22": 641.9791767526187,
    "2025-06-23": 648.6018601143517,
    "2025-06-24": 655.2245434760846,
    "2025-06-25": 661.8472268378174,
    "2025-06-26": 668.4699101995503,
    "2025-06-27": 675.0925935612833,
    "2025-06-28": 681.7152769230162,
    "2025-06-29": 688.3379602847491,
    "2025-06-30": 694.960643646482,
    "2025-07-01": 701.5409677571748,
    "2025-07-02": 708.1212918678676,
    "2025-07-03": 714.7016159785603,
    "2025-07-04": 721.2819400892531,
    "2025-07-05": 727.8622641999459,
    "2025-07-06": 734.4425883106387,
    "2025-07-07": 741.0229124213314,
    "2025-07-08": 747.6032365320242,
    "2025-07-09": 754.183560642717,
    "2025-07-10": 760.7638847534098,
    "2025-07-11": 767.3442088641025,
    "2025-07-12": 773.9245329747953,
    "2025-07-13": 780.5048570854881,
    "2025-07-14": 787.0851811961809,
    "2025-07-15": 793.6655053068737,
    "2025-07-16": 800.2458294175664,
    "2025-07-17": 806.8261535282592,
    "2025-07-18": 813.406477638952,
    "2025-07-19": 819.9868017496448,
    "2025-07-20": 826.5671258603375,
    "2025-07-21": 833.1474499710303,
    "2025-07-22": 839.727774081723,
    "2025-07-23": 846.3080981924159,
    "2025-07-24": 852.8884223031087,
    "2025-07-25": 859.4687464138013,
    "2025-07-26": 866.0490705244941,
    "2025-07-27": 872.6293946351869,
    "2025-07-28": 879.2097187458797,
    "2025-07-29": 885.7900428565724,
    "2025-07-30": 892.3703669672652,
    "2025-07-31": 898.950691077958,
    "2025-08-01": 904.4496356569738,
    "2025-08-02": 909.9485802359897,
    "2025-08-03": 915.4475248150054,
    "2025-08-04": 920.9464693940212,
    "2025-08-05": 926.4454139730368,
    "2025-08-06": 931.9443585520528,
    "2025-08-07": 937.4433031310684,
    "2025-08-08": 942.9422477100844,
    "2025-08-09": 948.4411922891,
    "2025-08-10": 953.9401368681158,
    "2025-08-11": 959.4390814471316,
    "2025-08-12": 964.9380260261474,
    "2025-08-13": 970.4369706051632,
    "2025-08-14": 975.935915184179,
    "2025-08-15": 981.4348597631948,
    "2025-08-16": 986.9338043422106,
    "2025-08-17": 992.4327489212264,
    "2025-08-18": 997.931693500242,
    "2025-08-19": 1003.4306380792578,
    "2025-08-20": 1008.9295826582736,
    "2025-08-21": 1014.4285272372896,
    "2025-08-22": 1019.9274718163052,
    "2025-08-23": 1025.426416395321,
    "2025-08-24": 1030.9253609743369,
    "2025-08-25": 1036.4243055533525,
    "2025-08-26": 1041.9232501323684,
    "2025-08-27": 1047.4221947113842,
    "2025-08-28": 1052.9211392904,
    "2025-08-29": 1058.4200838694155,
    "2025-08-30": 1063.9190284484314,
    "2025-08-31": 1069.4179730274473,
    "2025-09-01": 1073.37177431388,
    "2025-09-02": 1077.3255756003127,
    "2025-09-03": 1081.2793768867457,
    "2025-09-04": 1085.2331781731782,
    "2025-09-05": 1089.186979459611,
    "2025-09-06": 1093.140780746044,
    "2025-09-07": 1097.0945820324766,
    "2025-09-08": 1101.0483833189094,
    "2025-09-09": 1105.002184605342,
    "2025-09-10": 1108.9559858917748,
    "2025-09-11": 1112.9097871782076,
    "2025-09-12": 1116.8635884646403,
    "2025-09-13": 1120.817389751073,
    "2025-09-14": 1124.7711910375058,
    "2025-09-15": 1128.7249923239387,
    "2025-09-16": 1132.6787936103717,
    "2025-09-17": 1136.6325948968042,
    "2025-09-18": 1140.586396183237,
    "2025-09-19": 1144.5401974696697,
    "2025-09-20": 1148.4939987561024,
    "2025-09-21": 1152.4478000425352,
    "2025-09-22": 1156.401601328968,
    "2025-09-23": 1160.3554026154006,
    "2025-09-24": 1164.3092039018334,
    "2025-09-25": 1168.263005188266,
    "2025-09-26": 1172.216806474699,
    "2025-09-27": 1176.1706077611318,
    "2025-09-28": 1180.1244090475643,
    "2025-09-29": 1184.0782103339973,
    "2025-09-30": 1188.03201162043,
  },
};
